/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: string; output: string; }
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: any; }
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: { input: string; output: string; }
  date: { input: string; output: string; }
  datetime: { input: string; output: string; }
  datetime2: { input: string; output: string; }
  image: { input: any; output: any; }
  json: { input: any; output: any; }
  numeric: { input: number; output: number; }
  smalldatetime: { input: any; output: any; }
  time: { input: string; output: string; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uniqueidentifier: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

export type AceitarPacoteServicosError = ValidationError;

export type AceitarPacoteServicosInput = {
  codUsuarioPacoteServicos: Scalars['Int']['input'];
};

export type AceitarPacoteServicosOutput = {
  __typename?: 'AceitarPacoteServicosOutput';
  codPacoteServicos: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
};

export type AceitarPacoteServicosPayload = {
  __typename?: 'AceitarPacoteServicosPayload';
  aceitarPacoteServicosOutput?: Maybe<AceitarPacoteServicosOutput>;
  errors?: Maybe<Array<AceitarPacoteServicosError>>;
};

export type AdiantarOuAtrasarError = RepeatedPatientError | ValidationError;

export type AdiantarOuAtrasarInput = {
  codAgendamentoOrigem: Scalars['Int']['input'];
  enviaEmailPaciente?: Scalars['Boolean']['input'];
  remarcarNovoAgendamento: RemarcarNovoAgendamentoInput;
};

export type AdiantarOuAtrasarPayload = {
  __typename?: 'AdiantarOuAtrasarPayload';
  agendamentoApiOutput?: Maybe<AgendamentoApiOutput>;
  errors?: Maybe<Array<AdiantarOuAtrasarError>>;
};

export type AgendamentoApiOutput = {
  __typename?: 'AgendamentoApiOutput';
  codAgendamento: Scalars['Int']['output'];
};

export type AgendamentoAtendidoError = ValidationError;

export type AgendamentoAtendidoInput = {
  codAgendamento: Scalars['Int']['input'];
};

export type AgendamentoAtendidoPayload = {
  __typename?: 'AgendamentoAtendidoPayload';
  errors?: Maybe<Array<AgendamentoAtendidoError>>;
  sucesso?: Maybe<Scalars['Boolean']['output']>;
};

export type AgendamentoNaoAtendidoError = ValidationError;

export type AgendamentoNaoAtendidoInput = {
  codAgendamento: Scalars['Int']['input'];
};

export type AgendamentoNaoAtendidoPayload = {
  __typename?: 'AgendamentoNaoAtendidoPayload';
  errors?: Maybe<Array<AgendamentoNaoAtendidoError>>;
  sucesso?: Maybe<Scalars['Boolean']['output']>;
};

export type AgendamentoOutput = {
  __typename?: 'AgendamentoOutput';
  agendamentoComPaciente?: Maybe<Scalars['Boolean']['output']>;
  cancelado?: Maybe<Scalars['Boolean']['output']>;
  cobrancaStatus?: Maybe<Scalars['String']['output']>;
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codControlPay?: Maybe<Scalars['Int']['output']>;
  codPaciente?: Maybe<Scalars['Int']['output']>;
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Int']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Int']['output']>;
  confirmaCancelamento?: Maybe<Scalars['Boolean']['output']>;
  confirmado?: Maybe<Scalars['Boolean']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  cpfProprio?: Maybe<Scalars['Boolean']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  dataCadastro?: Maybe<Scalars['String']['output']>;
  dataCancelamento?: Maybe<Scalars['String']['output']>;
  dataCienciaCancelamento?: Maybe<Scalars['String']['output']>;
  dataNascimento?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  eventual?: Maybe<Scalars['Boolean']['output']>;
  fechaCancelamento?: Maybe<Scalars['Boolean']['output']>;
  horaFim?: Maybe<Scalars['String']['output']>;
  horaInicio?: Maybe<Scalars['String']['output']>;
  meioPagamento?: Maybe<Scalars['String']['output']>;
  motivoCancelamento?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  nomeConvenio?: Maybe<Scalars['String']['output']>;
  nomePlano?: Maybe<Scalars['String']['output']>;
  nomePreferencialUsuario?: Maybe<Scalars['String']['output']>;
  nomeTratado?: Maybe<Scalars['String']['output']>;
  nomeUsuario?: Maybe<Scalars['String']['output']>;
  numeroCarteirinha?: Maybe<Scalars['String']['output']>;
  pagar?: Maybe<Scalars['Boolean']['output']>;
  pago?: Maybe<Scalars['Boolean']['output']>;
  receberWhatsAppConfirmacao?: Maybe<Scalars['Boolean']['output']>;
  telefone?: Maybe<Scalars['String']['output']>;
  telefoneProprio?: Maybe<Scalars['Boolean']['output']>;
  validadeCarteirinha?: Maybe<Scalars['String']['output']>;
  valor?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas = {
  __typename?: 'AgendamentosAlocacoesAtivas';
  /** An object relationship */
  Agendamento: Agendamentos;
  /** An object relationship */
  UnidadeSala: UnidadesSalas;
  codAgendamento: Scalars['Int']['output'];
  codUnidadeSala: Scalars['Int']['output'];
  horaInicio: Scalars['time']['output'];
};

/** order by aggregate values of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Aggregate_Order_By = {
  avg?: InputMaybe<AgendamentosAlocacoesAtivas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AgendamentosAlocacoesAtivas_Max_Order_By>;
  min?: InputMaybe<AgendamentosAlocacoesAtivas_Min_Order_By>;
  stddev?: InputMaybe<AgendamentosAlocacoesAtivas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AgendamentosAlocacoesAtivas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AgendamentosAlocacoesAtivas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AgendamentosAlocacoesAtivas_Sum_Order_By>;
  var_pop?: InputMaybe<AgendamentosAlocacoesAtivas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AgendamentosAlocacoesAtivas_Var_Samp_Order_By>;
  variance?: InputMaybe<AgendamentosAlocacoesAtivas_Variance_Order_By>;
};

/** order by avg() on columns of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Avg_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbAgendamentosAlocacoesAtivas". All fields are combined with a logical 'AND'. */
export type AgendamentosAlocacoesAtivas_Bool_Exp = {
  Agendamento?: InputMaybe<Agendamentos_Bool_Exp>;
  UnidadeSala?: InputMaybe<UnidadesSalas_Bool_Exp>;
  _and?: InputMaybe<Array<AgendamentosAlocacoesAtivas_Bool_Exp>>;
  _not?: InputMaybe<AgendamentosAlocacoesAtivas_Bool_Exp>;
  _or?: InputMaybe<Array<AgendamentosAlocacoesAtivas_Bool_Exp>>;
  codAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadeSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  horaInicio?: InputMaybe<Time_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Max_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Min_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbAgendamentosAlocacoesAtivas". */
export type AgendamentosAlocacoesAtivas_Order_By = {
  Agendamento?: InputMaybe<Agendamentos_Order_By>;
  UnidadeSala?: InputMaybe<UnidadesSalas_Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Stddev_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Stddev_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Stddev_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Sum_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Var_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Var_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbAgendamentosAlocacoesAtivas" */
export type AgendamentosAlocacoesAtivas_Variance_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

export type AlocacaoAtiva = {
  __typename?: 'AlocacaoAtiva';
  atrasado: Scalars['Boolean']['output'];
  codAgendamento: Scalars['Int']['output'];
  codFinalidadeAgendamento: Scalars['Int']['output'];
  codTipoSala: Scalars['Int']['output'];
  codUnidade: Scalars['Int']['output'];
  codUnidadeSala: Scalars['Int']['output'];
  dataAgendamento: Scalars['DateTime']['output'];
  horaFimAgendamento: Scalars['TimeSpan']['output'];
  horaFimAlocacao: Scalars['TimeSpan']['output'];
  horaInicioAgendamento: Scalars['TimeSpan']['output'];
  horaInicioAlocacao: Scalars['TimeSpan']['output'];
  nomePaciente?: Maybe<Scalars['String']['output']>;
  nomeUnidade?: Maybe<Scalars['String']['output']>;
  nomeUnidadeSala?: Maybe<Scalars['String']['output']>;
  nomeUsuarioCompromisso?: Maybe<Scalars['String']['output']>;
  pacienteRegistroVirtual: Scalars['Boolean']['output'];
  progresso: Scalars['Float']['output'];
  siglaSala?: Maybe<Scalars['String']['output']>;
  tempoAlocado: Scalars['TimeSpan']['output'];
  tempoAtrasado: Scalars['TimeSpan']['output'];
  tempoRestante: Scalars['TimeSpan']['output'];
};

export type AlocacaoDetalhada = {
  __typename?: 'AlocacaoDetalhada';
  codAgendamento: Scalars['Int']['output'];
  horaFimCobrado: Scalars['TimeSpan']['output'];
  horaFimDevolvido: Scalars['TimeSpan']['output'];
  horaInicio: Scalars['TimeSpan']['output'];
  partes: Array<AlocacaoParcial>;
};

export type AlocacaoParcial = {
  __typename?: 'AlocacaoParcial';
  horaFim: Scalars['TimeSpan']['output'];
  horaInicio: Scalars['TimeSpan']['output'];
  taxaCobranca: Scalars['Decimal']['output'];
  tipoAlocacao: TipoAlocacao;
};

export type AlterarPacienteError = ValidationError;

export type AlterarPacienteInput = {
  paciente?: InputMaybe<PacienteGraphQlInput>;
};

export type AlterarPacientePayload = {
  __typename?: 'AlterarPacientePayload';
  errors?: Maybe<Array<AlterarPacienteError>>;
  pacienteGraphQL?: Maybe<PacienteGraphQl>;
};

export type AnalyticsMembroDadosDeUsuarioLinkRastreamento = {
  __typename?: 'AnalyticsMembroDadosDeUsuarioLinkRastreamento';
  data: Array<Maybe<DataItemUsuarioLinkRastreavelPipe>>;
  meta: Array<Maybe<ApiQueryJsonResponseMetaItem>>;
  rows: Scalars['Float']['output'];
  rowsBeforeLimitAtLeast?: Maybe<Scalars['Float']['output']>;
  statistics: ApiQueryJsonResponseStatistics;
};

export type AnalyticsMembroRelatorioIndependente = {
  __typename?: 'AnalyticsMembroRelatorioIndependente';
  data: Array<Maybe<DataItemRelatorioIndependente>>;
  meta: Array<Maybe<ApiQueryJsonResponseMetaItem>>;
  rows: Scalars['Float']['output'];
  rowsBeforeLimitAtLeast?: Maybe<Scalars['Float']['output']>;
  statistics: ApiQueryJsonResponseStatistics;
};

export type AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo = {
  __typename?: 'AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo';
  data: Array<Maybe<DataItemAnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo>>;
  meta: Array<Maybe<ApiQueryJsonResponseMetaItem>>;
  rows: Scalars['Float']['output'];
  rowsBeforeLimitAtLeast?: Maybe<Scalars['Float']['output']>;
  statistics: ApiQueryJsonResponseStatistics;
};

export type AnimusCancelSalesVisitInput = {
  sellerEmail?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  visitType?: InputMaybe<Scalars['String']['input']>;
};

export type AnimusCancelSalesVisitOutput = {
  __typename?: 'AnimusCancelSalesVisitOutput';
  message: Scalars['String']['output'];
};

export type AnimusCancelVisitOutput = {
  __typename?: 'AnimusCancelVisitOutput';
  message: Scalars['String']['output'];
};

export type AnimusDeleteVirtualSalesVisitInput = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type AnimusDeleteVirtualSalesVisitOutput = {
  __typename?: 'AnimusDeleteVirtualSalesVisitOutput';
  message?: Maybe<Scalars['String']['output']>;
};

export type AnimusOnboardingTimeAvailabilityInput = {
  endDate: Scalars['String']['input'];
  selectedLocationCode: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export type AnimusScheduleSalesVisitInput = {
  date: Scalars['String']['input'];
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  durationLabel?: InputMaybe<Scalars['String']['input']>;
  groupVisitScheduleId?: InputMaybe<Scalars['Int']['input']>;
  origin: Scalars['String']['input'];
  roomType?: InputMaybe<Scalars['Int']['input']>;
  selectedLocationCode: Scalars['Int']['input'];
  sellerEmail?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
  visitType?: InputMaybe<Scalars['String']['input']>;
};

export type AnimusScheduleSalesVisitOutput = {
  __typename?: 'AnimusScheduleSalesVisitOutput';
  blocking: Scalars['Int']['output'];
  schedule: Scalars['Int']['output'];
};

export type AnimusUpdateLivanceNicknameInput = {
  animusId: Scalars['Int']['input'];
  nickname: Scalars['String']['input'];
};

export type AnimusUpdateLivanceNicknameOutput = {
  __typename?: 'AnimusUpdateLivanceNicknameOutput';
  animusId?: Maybe<Scalars['Int']['output']>;
  livanceId?: Maybe<Scalars['Int']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
};

export type AnimusUploadProfessionalIdPictureInput = {
  base64string: Scalars['String']['input'];
  documentSide: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  type: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type AnimusUploadProfessionalIdPictureOutput = {
  __typename?: 'AnimusUploadProfessionalIdPictureOutput';
  filepath: Scalars['String']['output'];
};

export type ApiQueryJsonResponseMetaItem = {
  __typename?: 'ApiQueryJSONResponseMetaItem';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ApiQueryJsonResponseStatistics = {
  __typename?: 'ApiQueryJSONResponseStatistics';
  bytesRead?: Maybe<Scalars['Float']['output']>;
  elapsed?: Maybe<Scalars['Float']['output']>;
  rowsRead?: Maybe<Scalars['Float']['output']>;
};

export type AppointmentAgeRangeInput = {
  idadeMaximaPaciente: Scalars['Int']['input'];
  idadeMinimaPaciente: Scalars['Int']['input'];
};

export type AppointmentAgeRangeOutput = {
  __typename?: 'AppointmentAgeRangeOutput';
  message: Scalars['String']['output'];
};

export type AppointmentRequirementsInput = {
  codTipoPoliticaRetorno: Scalars['Int']['input'];
  confirmarConsulta: Scalars['Boolean']['input'];
  emailPaciente: Scalars['String']['input'];
  emailPacienteInformar: Scalars['Boolean']['input'];
  horasAntecedenciaBusca: Scalars['Int']['input'];
  idadeMaximaPaciente: Scalars['Int']['input'];
  idadeMinimaPaciente: Scalars['Int']['input'];
  minutosAntecedenciaAlocacao: Scalars['Int']['input'];
  orientacoes: Scalars['String']['input'];
  telefonePacienteInformar: Scalars['Boolean']['input'];
};

export type AppointmentRequirementsOutput = {
  __typename?: 'AppointmentRequirementsOutput';
  message: Scalars['String']['output'];
};

export type AppointmentType = {
  __typename?: 'AppointmentType';
  appointmentTypeId?: Maybe<Scalars['Int']['output']>;
  durationInMinutes?: Maybe<Scalars['Int']['output']>;
  hostId?: Maybe<Scalars['Int']['output']>;
  paymentTypeId?: Maybe<Scalars['Int']['output']>;
};

export type AtualizarTelefonePublicoError = ValidationError;

export type AtualizarTelefonePublicoInput = {
  telefone?: InputMaybe<Scalars['String']['input']>;
};

export type AtualizarTelefonePublicoPayload = {
  __typename?: 'AtualizarTelefonePublicoPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<AtualizarTelefonePublicoError>>;
};

export type AvailableTimesInput = {
  codUnidade: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
  comHorarioExtra?: InputMaybe<Scalars['Boolean']['input']>;
  comHorariosMenores?: InputMaybe<Scalars['Boolean']['input']>;
  data: Scalars['String']['input'];
};

export type BasicProfileEspecialidades = {
  id: Scalars['Int']['input'];
  prioridade: Scalars['Int']['input'];
  rqe?: InputMaybe<Scalars['String']['input']>;
  subespecialidades?: InputMaybe<Array<BasicProfileSubespecialidade>>;
};

export type BasicProfileSubespecialidade = {
  id: Scalars['Int']['input'];
  rqe?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BuscaDataFimTrialAssistProOutput = {
  __typename?: 'BuscaDataFimTrialAssistProOutput';
  dataFimTrialAssistPro: Scalars['String']['output'];
  temTrialDisponivel: Scalars['Boolean']['output'];
};

export type BuscaHorariosUnidadeAlternativaOutput = {
  __typename?: 'BuscaHorariosUnidadeAlternativaOutput';
  unidadesComAgendaAberta: HorariosUnidadesAlternativas;
  unidadesProximas: HorariosUnidadesAlternativas;
};

export type CancelOnboardingOutput = {
  __typename?: 'CancelOnboardingOutput';
  message: Scalars['String']['output'];
};

export type CancelarPacoteServicosAssistProError = ValidationError;

export type CancelarPacoteServicosAssistProInput = {
  telefone?: InputMaybe<Scalars['String']['input']>;
};

export type CancelarPacoteServicosAssistProPayload = {
  __typename?: 'CancelarPacoteServicosAssistProPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<CancelarPacoteServicosAssistProError>>;
};

export type CancelarPacoteServicosError = ValidationError;

export type CancelarPacoteServicosInput = {
  codPacoteServico: Scalars['Int']['input'];
};

export type CancelarPacoteServicosPayload = {
  __typename?: 'CancelarPacoteServicosPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<CancelarPacoteServicosError>>;
};

export type CobrancaExibicao = {
  __typename?: 'CobrancaExibicao';
  boletoUrl?: Maybe<Scalars['String']['output']>;
  codCobranca: Scalars['Int']['output'];
  codStatus: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  dataExpiracaoBoleto?: Maybe<Scalars['DateTime']['output']>;
  dataFim: Scalars['DateTime']['output'];
  dataInicio: Scalars['DateTime']['output'];
  dataVencimento?: Maybe<Scalars['DateTime']['output']>;
  descricaoStatus: Scalars['String']['output'];
  estaAtrasada?: Maybe<Scalars['Boolean']['output']>;
  movimentacoes: Array<MovimentacaoExibicao>;
  observacao?: Maybe<Scalars['String']['output']>;
  podeCobrar?: Maybe<Scalars['Boolean']['output']>;
  temBoletoValido?: Maybe<Scalars['Boolean']['output']>;
  valor: Scalars['Decimal']['output'];
};

/** A connection to a list of items. */
export type CobrancasAbertasConnection = {
  __typename?: 'CobrancasAbertasConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CobrancasAbertasEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<CobrancaExibicao>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CobrancasAbertasEdge = {
  __typename?: 'CobrancasAbertasEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CobrancaExibicao>;
};

/** A connection to a list of items. */
export type CobrancasFechadasConnection = {
  __typename?: 'CobrancasFechadasConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CobrancasFechadasEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<CobrancaExibicao>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CobrancasFechadasEdge = {
  __typename?: 'CobrancasFechadasEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CobrancaExibicao>;
};

export enum CodUsuarioAcao {
  Agendamento = 'AGENDAMENTO'
}

export type ContratarPacoteServicosError = ValidationError;

export type ContratarPacoteServicosInput = {
  codPacoteServico: Scalars['Int']['input'];
  fluxo?: InputMaybe<Scalars['String']['input']>;
};

export type ContratarPacoteServicosOutput = {
  __typename?: 'ContratarPacoteServicosOutput';
  codPacoteServico: Scalars['Int']['output'];
};

export type ContratarPacoteServicosPayload = {
  __typename?: 'ContratarPacoteServicosPayload';
  contratarPacoteServicosOutput?: Maybe<ContratarPacoteServicosOutput>;
  errors?: Maybe<Array<ContratarPacoteServicosError>>;
};

export type CreateNewVirtualSalesVisitInput = {
  appointmentTypeId?: InputMaybe<Scalars['Int']['input']>;
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  groupVisitScheduleId?: InputMaybe<Scalars['Int']['input']>;
  selectedDatetime: Scalars['String']['input'];
  sellerEmail?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type CreateNewVirtualSalesVisitResponse = {
  __typename?: 'CreateNewVirtualSalesVisitResponse';
  blocking?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Scalars['Int']['output']>;
};

export type CreateUserAppointmentTypeInput = {
  active: Scalars['Boolean']['input'];
  billingTypes: Scalars['Int']['input'];
  category: Scalars['String']['input'];
  duration: Scalars['String']['input'];
  livanceUserId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  online: Scalars['Boolean']['input'];
  price: Scalars['Float']['input'];
  roomTypeId: Scalars['Int']['input'];
};

export type CreateUserAppointmentTypeOutput = {
  __typename?: 'CreateUserAppointmentTypeOutput';
  codUsuario?: Maybe<Scalars['Int']['output']>;
};

export type CreateVirtualSalesVisitInput = {
  appointmentTypeId: Scalars['Int']['input'];
  selectedDatetime: Scalars['String']['input'];
  sellerEmail?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type CreateVirtualSalesVisitResponse = {
  __typename?: 'CreateVirtualSalesVisitResponse';
  appointmentTypeId?: Maybe<Scalars['Int']['output']>;
  hostId?: Maybe<Scalars['Int']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  schedulingDatetime?: Maybe<Scalars['String']['output']>;
  schedulingId?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CriarAgendamentoError = RepeatedPatientError | ValidationError;

export type CriarAgendamentoInput = {
  cancelado?: InputMaybe<Scalars['Boolean']['input']>;
  cobraCancelamento?: InputMaybe<Scalars['Boolean']['input']>;
  codFinalidadeAgendamento?: InputMaybe<Scalars['Int']['input']>;
  codPaciente?: InputMaybe<Scalars['Int']['input']>;
  codTipoConvenio?: InputMaybe<Scalars['Int']['input']>;
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  codUsuarioAgenda?: InputMaybe<Scalars['Int']['input']>;
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
  confirmado?: InputMaybe<Scalars['Boolean']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['Date']['input'];
  dataNascimento?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  eventual?: InputMaybe<Scalars['Boolean']['input']>;
  horaFim: Scalars['String']['input'];
  horaInicio: Scalars['String']['input'];
  ignorarEnvioEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ignorarEnvioWhatsApp?: InputMaybe<Scalars['Boolean']['input']>;
  nome: Scalars['String']['input'];
  nomePlano?: InputMaybe<Scalars['String']['input']>;
  numeroCarteirinha?: InputMaybe<Scalars['String']['input']>;
  receberWhatsAppConfirmacao?: InputMaybe<Scalars['Boolean']['input']>;
  telefone: Scalars['String']['input'];
  telefoneInternacionalNormalizado?: InputMaybe<Scalars['String']['input']>;
};

export type CriarAgendamentoPayload = {
  __typename?: 'CriarAgendamentoPayload';
  agendamentoApiOutput?: Maybe<AgendamentoApiOutput>;
  errors?: Maybe<Array<CriarAgendamentoError>>;
};

export type CriarMultiplosFechamentosError = ValidationError;

export type CriarMultiplosFechamentosInput = {
  codUnidades?: InputMaybe<Array<Scalars['Int']['input']>>;
  codUsuario: Scalars['Int']['input'];
  dataFim: Scalars['DateTime']['input'];
  dataInicio: Scalars['DateTime']['input'];
  horaFim: Scalars['TimeSpan']['input'];
  horaInicio: Scalars['TimeSpan']['input'];
  motivo?: InputMaybe<Scalars['String']['input']>;
};

export type CriarMultiplosFechamentosPayload = {
  __typename?: 'CriarMultiplosFechamentosPayload';
  errors?: Maybe<Array<CriarMultiplosFechamentosError>>;
  fechamentoApiOutput?: Maybe<Array<Maybe<FechamentoApiOutput>>>;
};

export type CriarUsuarioLinkRastreamentoError = ValidationError;

export type CriarUsuarioLinkRastreamentoInput = {
  codLinkDestino?: InputMaybe<Scalars['Int']['input']>;
  descricao?: Scalars['String']['input'];
  nome: Scalars['String']['input'];
};

export type CriarUsuarioLinkRastreamentoOutput = {
  __typename?: 'CriarUsuarioLinkRastreamentoOutput';
  codUsuarioLinkRastreamento: Scalars['Int']['output'];
  link: Scalars['String']['output'];
};

export type CriarUsuarioLinkRastreamentoPayload = {
  __typename?: 'CriarUsuarioLinkRastreamentoPayload';
  criarUsuarioLinkRastreamentoOutput?: Maybe<CriarUsuarioLinkRastreamentoOutput>;
  errors?: Maybe<Array<CriarUsuarioLinkRastreamentoError>>;
};

export type DataItemAnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo = {
  __typename?: 'DataItemAnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo';
  agendamentosRecuperados?: Maybe<Scalars['BigInt']['output']>;
  fluxo?: Maybe<Scalars['String']['output']>;
  mes?: Maybe<Scalars['String']['output']>;
  totalMensagens?: Maybe<Scalars['BigInt']['output']>;
};

export type DataItemRelatorioIndependente = {
  __typename?: 'DataItemRelatorioIndependente';
  agendamentosConveniosParaOMes?: Maybe<Scalars['BigInt']['output']>;
  agendamentosMarcados?: Maybe<Scalars['BigInt']['output']>;
  agendamentosMarcadosParaOMes?: Maybe<Scalars['BigInt']['output']>;
  agendamentosNovos?: Maybe<Scalars['BigInt']['output']>;
  agendamentosPacienteAtrasado?: Maybe<Scalars['BigInt']['output']>;
  agendamentosPacientePontual?: Maybe<Scalars['BigInt']['output']>;
  agendamentosPacienteSemCheckin?: Maybe<Scalars['BigInt']['output']>;
  agendamentosParticularesParaOMes?: Maybe<Scalars['BigInt']['output']>;
  cancelamentos?: Maybe<Scalars['BigInt']['output']>;
  cancelamentosDefinitivos?: Maybe<Scalars['BigInt']['output']>;
  codUsuario?: Maybe<Scalars['BigInt']['output']>;
  consultasNoShow?: Maybe<Scalars['BigInt']['output']>;
  consultasPresenciais?: Maybe<Scalars['BigInt']['output']>;
  consultasRealizadas?: Maybe<Scalars['BigInt']['output']>;
  consultasVirtuais?: Maybe<Scalars['BigInt']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  mes?: Maybe<Scalars['String']['output']>;
  reagendamentos?: Maybe<Scalars['BigInt']['output']>;
};

export type DataItemUsuarioLinkRastreavelPipe = {
  __typename?: 'DataItemUsuarioLinkRastreavelPipe';
  totalAcesso?: Maybe<Scalars['BigInt']['output']>;
  totalAgendamento?: Maybe<Scalars['BigInt']['output']>;
  totalBuscasRealizadas?: Maybe<Scalars['BigInt']['output']>;
  totalRecebido?: Maybe<Scalars['String']['output']>;
  totalUso?: Maybe<Scalars['BigInt']['output']>;
};

export type Error = {
  message: Scalars['String']['output'];
};

export type Especialidade = {
  __typename?: 'Especialidade';
  nome?: Maybe<Scalars['String']['output']>;
};

export type EspecialidadeTipoSala = {
  __typename?: 'EspecialidadeTipoSala';
  codEspecialidade?: Maybe<Scalars['Int']['output']>;
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};

export type EstenderAgendamentoError = ValidationError;

export type EstenderAgendamentoInput = {
  codAgendamentoAlocacaoAtiva: Scalars['Int']['input'];
  duracao: Scalars['String']['input'];
};

export type EstenderAgendamentoPayload = {
  __typename?: 'EstenderAgendamentoPayload';
  agendamentoApiOutput?: Maybe<AgendamentoApiOutput>;
  errors?: Maybe<Array<EstenderAgendamentoError>>;
};

export type ExpensumAutomaticAnticipationSettingsByRecipientOutput = {
  __typename?: 'ExpensumAutomaticAnticipationSettingsByRecipientOutput';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ExpensumBankAccount = {
  __typename?: 'ExpensumBankAccount';
  accountCheckDigit?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  bank?: Maybe<Scalars['String']['output']>;
  branchCheckDigit?: Maybe<Scalars['String']['output']>;
  branchNumber?: Maybe<Scalars['String']['output']>;
  holderName?: Maybe<Scalars['String']['output']>;
  holderType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pagarmeId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExpensumCancelTotemPaymentInput = {
  codAgendamento: Scalars['Int']['input'];
};

export type ExpensumCancelTotemPaymentOutput = {
  __typename?: 'ExpensumCancelTotemPaymentOutput';
  codAgendamento: Scalars['Int']['output'];
};

export type ExpensumCard = {
  __typename?: 'ExpensumCard';
  brand?: Maybe<Scalars['String']['output']>;
  firstSixDigits?: Maybe<Scalars['String']['output']>;
  holderName?: Maybe<Scalars['String']['output']>;
  lastFourDigits?: Maybe<Scalars['String']['output']>;
};

export type ExpensumCharge = {
  __typename?: 'ExpensumCharge';
  canceledAmount?: Maybe<Scalars['Int']['output']>;
  canceledAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastTransaction?: Maybe<ExpensumLastTransaction>;
  paidAmount?: Maybe<Scalars['Int']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExpensumChargeCancelInput = {
  acquirerTransactionKey: Scalars['String']['input'];
  amount?: InputMaybe<Scalars['Int']['input']>;
  canceledBy?: InputMaybe<Scalars['String']['input']>;
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
  onlinePaymentGuid?: InputMaybe<Scalars['String']['input']>;
};

export type ExpensumChargeCancelOutput = {
  __typename?: 'ExpensumChargeCancelOutput';
  charge: ExpensumCharge;
};

export type ExpensumCreateOnlinePaymentInput = {
  amount: Scalars['Int']['input'];
  automaticSending?: InputMaybe<Scalars['Boolean']['input']>;
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  codPaciente?: InputMaybe<Scalars['Int']['input']>;
  codUsuarioCompromisso?: InputMaybe<Scalars['Int']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  installments: Scalars['Int']['input'];
  originPaymentType: Scalars['String']['input'];
  payerEmail?: InputMaybe<Scalars['String']['input']>;
  payerName?: InputMaybe<Scalars['String']['input']>;
  payerPhone?: InputMaybe<Scalars['String']['input']>;
  paymentTypes: Array<Scalars['Int']['input']>;
  productDescription: Scalars['String']['input'];
};

export type ExpensumCreateOnlinePaymentOutput = {
  __typename?: 'ExpensumCreateOnlinePaymentOutput';
  guid: Scalars['String']['output'];
};

export type ExpensumGetAutomaticAnticipationSettingsByRecipientInput = {
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  codUsuario: Scalars['Int']['input'];
};

export type ExpensumGetAutomaticAnticipationSettingsByRecipientOutput = {
  __typename?: 'ExpensumGetAutomaticAnticipationSettingsByRecipientOutput';
  automaticAnticipationSettings: ExpensumAutomaticAnticipationSettingsByRecipientOutput;
};

export type ExpensumGetBankAccountByRecipientInput = {
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  codUsuario: Scalars['Int']['input'];
};

export type ExpensumGetBankAccountByRecipientOutput = {
  __typename?: 'ExpensumGetBankAccountByRecipientOutput';
  bankAccount: ExpensumBankAccount;
};

export type ExpensumGetPayablesChartsInfoByStatus = {
  __typename?: 'ExpensumGetPayablesChartsInfoByStatus';
  totalAmount: Scalars['Int']['output'];
};

export type ExpensumGetPayablesChartsInfoInput = {
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  intervalEnd: Scalars['String']['input'];
  intervalStart: Scalars['String']['input'];
  periodicity: Scalars['String']['input'];
};

export type ExpensumGetPayablesChartsInfoIntervalData = {
  __typename?: 'ExpensumGetPayablesChartsInfoIntervalData';
  intervalEnd: Scalars['String']['output'];
  intervalStart: Scalars['String']['output'];
  paid: ExpensumGetPayablesChartsInfoByStatus;
  waitingFunds: ExpensumGetPayablesChartsInfoByStatus;
};

export type ExpensumGetPayablesChartsInfoOutput = {
  __typename?: 'ExpensumGetPayablesChartsInfoOutput';
  periods: Array<ExpensumGetPayablesChartsInfoIntervalData>;
};

export type ExpensumGetPayablesInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  bulkAnticipationId?: InputMaybe<Scalars['String']['input']>;
  chargeId?: InputMaybe<Scalars['String']['input']>;
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  codUsuario: Scalars['Int']['input'];
  createdSince?: InputMaybe<Scalars['String']['input']>;
  createdUntil?: InputMaybe<Scalars['String']['input']>;
  gatewayId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  installment?: InputMaybe<Scalars['String']['input']>;
  liquidationArrangementId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  paymentDateSince?: InputMaybe<Scalars['String']['input']>;
  paymentDateUntil?: InputMaybe<Scalars['String']['input']>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  splitId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedSince?: InputMaybe<Scalars['String']['input']>;
  updatedUntil?: InputMaybe<Scalars['String']['input']>;
};

export type ExpensumGetPayablesOutput = {
  __typename?: 'ExpensumGetPayablesOutput';
  data: Array<Maybe<ExpensumPayables>>;
};

export type ExpensumGetPayablesV2Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  bulkAnticipationId?: InputMaybe<Scalars['String']['input']>;
  chargeId?: InputMaybe<Scalars['String']['input']>;
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  codUsuario: Scalars['Int']['input'];
  createdSince?: InputMaybe<Scalars['String']['input']>;
  createdUntil?: InputMaybe<Scalars['String']['input']>;
  gatewayId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  installment?: InputMaybe<Scalars['String']['input']>;
  liquidationArrangementId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  paymentDateSince?: InputMaybe<Scalars['String']['input']>;
  paymentDateUntil?: InputMaybe<Scalars['String']['input']>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  splitId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedSince?: InputMaybe<Scalars['String']['input']>;
  updatedUntil?: InputMaybe<Scalars['String']['input']>;
};

export type ExpensumGetPayablesV2Output = {
  __typename?: 'ExpensumGetPayablesV2Output';
  data: Array<Maybe<ExpensumPayablesV2>>;
};

export type ExpensumGetPaymentInfo = {
  __typename?: 'ExpensumGetPaymentInfo';
  acquirerTransactionKey?: Maybe<Scalars['String']['output']>;
  agendamento?: Maybe<ExpensumGetPaymentInfoAppointment>;
  checkout?: Maybe<ExpensumGetPaymentInfoCheckout>;
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  criadoEm?: Maybe<Scalars['String']['output']>;
  hasAutomaticAnticipation: Scalars['Boolean']['output'];
  meioPagamentoSelecionado?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  origem: Scalars['String']['output'];
  pagoEm?: Maybe<Scalars['String']['output']>;
  parcelas?: Maybe<Scalars['Int']['output']>;
  payableInfo?: Maybe<ExpensumGetPaymentPayableInfo>;
  status: Scalars['String']['output'];
  tipoAtividade?: Maybe<Scalars['String']['output']>;
  valor: Scalars['Int']['output'];
};

export type ExpensumGetPaymentInfoAppointment = {
  __typename?: 'ExpensumGetPaymentInfoAppointment';
  data: Scalars['String']['output'];
  horaInicio: Scalars['String']['output'];
  paciente: LivanceApiPaciente;
  unidade: Scalars['String']['output'];
};

export type ExpensumGetPaymentInfoCheckout = {
  __typename?: 'ExpensumGetPaymentInfoCheckout';
  emailDoPagador: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  nomeDoPagador: Scalars['String']['output'];
  telefoneDoPagador: Scalars['String']['output'];
};

export type ExpensumGetPaymentPayableInfo = {
  __typename?: 'ExpensumGetPaymentPayableInfo';
  installment?: Maybe<Scalars['Int']['output']>;
  nextPaymentDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExpensumGetPaymentsChartsInfoInput = {
  intervalEnd: Scalars['String']['input'];
  intervalStart: Scalars['String']['input'];
  periodicity: Scalars['String']['input'];
};

export type ExpensumGetPaymentsChartsInfoIntervalData = {
  __typename?: 'ExpensumGetPaymentsChartsInfoIntervalData';
  intervalEnd: Scalars['String']['output'];
  intervalStart: Scalars['String']['output'];
  onlinePayments: ExpensumGetPaymentsChartsInfoPaymentsBySource;
  totalAmount: Scalars['Int']['output'];
  totemPayments: ExpensumGetPaymentsChartsInfoPaymentsBySource;
};

export type ExpensumGetPaymentsChartsInfoOutput = {
  __typename?: 'ExpensumGetPaymentsChartsInfoOutput';
  periods: Array<ExpensumGetPaymentsChartsInfoIntervalData>;
};

export type ExpensumGetPaymentsChartsInfoPaymentDetail = {
  __typename?: 'ExpensumGetPaymentsChartsInfoPaymentDetail';
  amount: Scalars['Int']['output'];
  paymentType?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ExpensumGetPaymentsChartsInfoPaymentsBySource = {
  __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsBySource';
  created: ExpensumGetPaymentsChartsInfoPaymentsByStatus;
  paid: ExpensumGetPaymentsChartsInfoPaymentsByStatus;
  totalAmount: Scalars['Int']['output'];
};

export type ExpensumGetPaymentsChartsInfoPaymentsByStatus = {
  __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus';
  payments: Array<ExpensumGetPaymentsChartsInfoPaymentDetail>;
  totalAmount: Scalars['Int']['output'];
};

export type ExpensumGetPaymentsInput = {
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  intervalEnd: Scalars['String']['input'];
  intervalStart: Scalars['String']['input'];
  origin?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentMethod?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExpensumGetPaymentsOutput = {
  __typename?: 'ExpensumGetPaymentsOutput';
  payments: Array<Maybe<ExpensumGetPaymentInfo>>;
  totalAmount: Scalars['Int']['output'];
};

export type ExpensumGetRecipientBankAccount = {
  __typename?: 'ExpensumGetRecipientBankAccount';
  bankName?: Maybe<Scalars['String']['output']>;
};

export type ExpensumGetRecipientCard = {
  __typename?: 'ExpensumGetRecipientCard';
  brand?: Maybe<Scalars['String']['output']>;
  lastFourDigits?: Maybe<Scalars['String']['output']>;
};

export type ExpensumGetRecipientInput = {
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  codUsuario: Scalars['Int']['input'];
};

export type ExpensumGetRecipientOutput = {
  __typename?: 'ExpensumGetRecipientOutput';
  recipient?: Maybe<ExpensumRecipient>;
};

export type ExpensumGetRefundReceiptInput = {
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
  onlinePaymentGuid?: InputMaybe<Scalars['String']['input']>;
};

export type ExpensumGetRefundReceiptOutput = {
  __typename?: 'ExpensumGetRefundReceiptOutput';
  receipt?: Maybe<ExpensumRefundReceipt>;
};

export type ExpensumLastTransaction = {
  __typename?: 'ExpensumLastTransaction';
  acquirerAuthCode?: Maybe<Scalars['String']['output']>;
  acquirerTid?: Maybe<Scalars['String']['output']>;
  card?: Maybe<ExpensumCard>;
};

export type ExpensumPayables = {
  __typename?: 'ExpensumPayables';
  date: Scalars['String']['output'];
  payables: Array<Maybe<PagarmePayable>>;
};

export type ExpensumPayablesV2 = {
  __typename?: 'ExpensumPayablesV2';
  date: Scalars['String']['output'];
  payables: Array<Maybe<PagarmePayableV2>>;
  totalAmount: Scalars['Int']['output'];
};

export type ExpensumPaymentDetailsAppointmentInfo = {
  __typename?: 'ExpensumPaymentDetailsAppointmentInfo';
  codAgendamento: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  startHour: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type ExpensumPaymentDetailsInput = {
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
  onlinePaymentGuid?: InputMaybe<Scalars['String']['input']>;
};

export type ExpensumPaymentDetailsOnlinePaymentInfo = {
  __typename?: 'ExpensumPaymentDetailsOnlinePaymentInfo';
  guid: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ExpensumPaymentDetailsOutput = {
  __typename?: 'ExpensumPaymentDetailsOutput';
  acquirerTransactionKey?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Int']['output'];
  appointment?: Maybe<ExpensumPaymentDetailsAppointmentInfo>;
  brand?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  installments?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  onlinePaymentInfo?: Maybe<ExpensumPaymentDetailsOnlinePaymentInfo>;
  origin: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['String']['output']>;
  patient: ExpensumPaymentDetailsPatientInfo;
  payablesInfo: ExpensumPaymentDetailsPayablesInfo;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  refundedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ExpensumPaymentDetailsPatientInfo = {
  __typename?: 'ExpensumPaymentDetailsPatientInfo';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type ExpensumPaymentDetailsPayableInfo = {
  __typename?: 'ExpensumPaymentDetailsPayableInfo';
  anticipationFee?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  fee?: Maybe<Scalars['Int']['output']>;
  grossValue: Scalars['Int']['output'];
  installment?: Maybe<Scalars['Int']['output']>;
  netValue: Scalars['Int']['output'];
  paymentDate: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ExpensumPaymentDetailsPayablesInfo = {
  __typename?: 'ExpensumPaymentDetailsPayablesInfo';
  isRefund: Scalars['Boolean']['output'];
  payables: Array<ExpensumPaymentDetailsPayableInfo>;
};

export type ExpensumRecipient = {
  __typename?: 'ExpensumRecipient';
  bankAccounts?: Maybe<Array<Maybe<ExpensumBankAccount>>>;
  codClinica?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pagarmeId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExpensumRefundReceipt = {
  __typename?: 'ExpensumRefundReceipt';
  authorizationId?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<ExpensumGetRecipientBankAccount>;
  canceledAmount?: Maybe<Scalars['Int']['output']>;
  canceledAt?: Maybe<Scalars['String']['output']>;
  card?: Maybe<ExpensumGetRecipientCard>;
  installments?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paidAmount?: Maybe<Scalars['Int']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type FechamentoApiOutput = {
  __typename?: 'FechamentoApiOutput';
  codFechamento: Scalars['Int']['output'];
};

export type FileInput = {
  base64string: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type FinalizaAlocacaoPayload = {
  __typename?: 'FinalizaAlocacaoPayload';
  sucesso?: Maybe<Scalars['Boolean']['output']>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FuncionalidadeContratadaOutput = {
  __typename?: 'FuncionalidadeContratadaOutput';
  ativo: Scalars['Boolean']['output'];
  codFuncionalidade: Scalars['Int']['output'];
  contratada: Scalars['Boolean']['output'];
};

export type GetAllBanksOutput = {
  __typename?: 'GetAllBanksOutput';
  code?: Maybe<Scalars['Int']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  ispb?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GetSalesVisitAvailabilityInput = {
  date: Scalars['String']['input'];
  durationInMinutes: Scalars['Int']['input'];
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  selectedLocationCode: Scalars['Int']['input'];
  specialty: Scalars['String']['input'];
  startDatetime?: InputMaybe<Scalars['String']['input']>;
  stepSizeInMinutes?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  visitType?: InputMaybe<Scalars['String']['input']>;
};

export type GetSalesVisitAvailabilityOutput = {
  __typename?: 'GetSalesVisitAvailabilityOutput';
  end?: Maybe<Scalars['String']['output']>;
  groupVisitScheduleId?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type HorarioUnidadeAlternativa = {
  __typename?: 'HorarioUnidadeAlternativa';
  codUnidade: Scalars['Int']['output'];
  dataHoraFim: Scalars['DateTime']['output'];
  dataHoraInicio: Scalars['DateTime']['output'];
  distancia: Scalars['Float']['output'];
  nomeLimpoUnidade: Scalars['String']['output'];
  siglaUnidade: Scalars['String']['output'];
  tipoHorarioSugestao: Scalars['Int']['output'];
};

export type HorariosUnidadesAlternativas = {
  __typename?: 'HorariosUnidadesAlternativas';
  horarios: Array<HorarioUnidadeAlternativa>;
  totalUnidadesBuscadas: Scalars['Int']['output'];
};

export enum HttpStatusCode {
  Accepted = 'ACCEPTED',
  AlreadyReported = 'ALREADY_REPORTED',
  Ambiguous = 'AMBIGUOUS',
  BadGateway = 'BAD_GATEWAY',
  BadRequest = 'BAD_REQUEST',
  Conflict = 'CONFLICT',
  Continue = 'CONTINUE',
  Created = 'CREATED',
  EarlyHints = 'EARLY_HINTS',
  ExpectationFailed = 'EXPECTATION_FAILED',
  FailedDependency = 'FAILED_DEPENDENCY',
  Forbidden = 'FORBIDDEN',
  GatewayTimeout = 'GATEWAY_TIMEOUT',
  Gone = 'GONE',
  HttpVersionNotSupported = 'HTTP_VERSION_NOT_SUPPORTED',
  ImUsed = 'IM_USED',
  InsufficientStorage = 'INSUFFICIENT_STORAGE',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  LengthRequired = 'LENGTH_REQUIRED',
  Locked = 'LOCKED',
  LoopDetected = 'LOOP_DETECTED',
  MethodNotAllowed = 'METHOD_NOT_ALLOWED',
  MisdirectedRequest = 'MISDIRECTED_REQUEST',
  Moved = 'MOVED',
  MultiStatus = 'MULTI_STATUS',
  NetworkAuthenticationRequired = 'NETWORK_AUTHENTICATION_REQUIRED',
  NonAuthoritativeInformation = 'NON_AUTHORITATIVE_INFORMATION',
  NotAcceptable = 'NOT_ACCEPTABLE',
  NotExtended = 'NOT_EXTENDED',
  NotFound = 'NOT_FOUND',
  NotImplemented = 'NOT_IMPLEMENTED',
  NotModified = 'NOT_MODIFIED',
  NoContent = 'NO_CONTENT',
  Ok = 'OK',
  PartialContent = 'PARTIAL_CONTENT',
  PaymentRequired = 'PAYMENT_REQUIRED',
  PermanentRedirect = 'PERMANENT_REDIRECT',
  PreconditionFailed = 'PRECONDITION_FAILED',
  PreconditionRequired = 'PRECONDITION_REQUIRED',
  Processing = 'PROCESSING',
  ProxyAuthenticationRequired = 'PROXY_AUTHENTICATION_REQUIRED',
  Redirect = 'REDIRECT',
  RedirectMethod = 'REDIRECT_METHOD',
  RequestedRangeNotSatisfiable = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  RequestEntityTooLarge = 'REQUEST_ENTITY_TOO_LARGE',
  RequestHeaderFieldsTooLarge = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  RequestTimeout = 'REQUEST_TIMEOUT',
  RequestUriTooLong = 'REQUEST_URI_TOO_LONG',
  ResetContent = 'RESET_CONTENT',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  SwitchingProtocols = 'SWITCHING_PROTOCOLS',
  TemporaryRedirect = 'TEMPORARY_REDIRECT',
  TooManyRequests = 'TOO_MANY_REQUESTS',
  Unauthorized = 'UNAUTHORIZED',
  UnavailableForLegalReasons = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  UnprocessableEntity = 'UNPROCESSABLE_ENTITY',
  UnsupportedMediaType = 'UNSUPPORTED_MEDIA_TYPE',
  Unused = 'UNUSED',
  UpgradeRequired = 'UPGRADE_REQUIRED',
  UseProxy = 'USE_PROXY',
  VariantAlsoNegotiates = 'VARIANT_ALSO_NEGOTIATES'
}

export type IndicarProfissionalError = ValidationError;

export type IndicarProfissionalInput = {
  codPaciente: Scalars['Int']['input'];
  codUsuarioIndicado: Scalars['Int']['input'];
  mensagem?: InputMaybe<Scalars['String']['input']>;
  telefonePaciente: Scalars['String']['input'];
};

export type IndicarProfissionalPayload = {
  __typename?: 'IndicarProfissionalPayload';
  errors?: Maybe<Array<IndicarProfissionalError>>;
  sucesso?: Maybe<Scalars['Boolean']['output']>;
};

export type InitiumUploadCheckInFileInput = {
  codAgendamento: Scalars['Int']['input'];
  file: Scalars['String']['input'];
};

export type InitiumUploadCheckInFileOutput = {
  __typename?: 'InitiumUploadCheckInFileOutput';
  filePath: Scalars['String']['output'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type JsonPatchDocument = {
  op: Scalars['String']['input'];
  path: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LivanceApiAgendamentoInput = {
  cancelado: Scalars['Boolean']['input'];
  cobraCancelamento?: InputMaybe<Scalars['Boolean']['input']>;
  codAgendamento: Scalars['Int']['input'];
  codFinalidadeAgendamento?: InputMaybe<Scalars['Int']['input']>;
  codPaciente?: InputMaybe<Scalars['Int']['input']>;
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  codUsuarioAgenda?: InputMaybe<Scalars['Int']['input']>;
  codUsuarioAuditoria?: InputMaybe<Scalars['Int']['input']>;
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
  confirmado: Scalars['Boolean']['input'];
  cpf?: InputMaybe<Scalars['String']['input']>;
  cpfProprio: Scalars['Boolean']['input'];
  data: Scalars['String']['input'];
  dataNascimento?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  eventual: Scalars['Boolean']['input'];
  horaFim: Scalars['String']['input'];
  horaInicio: Scalars['String']['input'];
  ignorarEnvioEmail: Scalars['Boolean']['input'];
  ignorarEnvioWhatsApp: Scalars['Boolean']['input'];
  nome: Scalars['String']['input'];
  nomeConvenio?: InputMaybe<Scalars['String']['input']>;
  nomePlano?: InputMaybe<Scalars['String']['input']>;
  numeroCarteirinha?: InputMaybe<Scalars['String']['input']>;
  receberWhatsAppConfirmacao: Scalars['Boolean']['input'];
  telefone: Scalars['String']['input'];
  telefoneProprio: Scalars['Boolean']['input'];
  validadeCarteirinha?: InputMaybe<Scalars['String']['input']>;
};

export type LivanceApiAlteraUsuarioCompromissoFormaRecebimento = {
  __typename?: 'LivanceApiAlteraUsuarioCompromissoFormaRecebimento';
  ativo: Scalars['Int']['output'];
  codUsuarioFormaRecebimento: Scalars['Int']['output'];
};

export type LivanceApiAlteraUsuarioCompromissoInput = {
  codUsuarioCompromisso: Scalars['Int']['input'];
  jsonPatchDocument: Array<InputMaybe<Scalars['json']['input']>>;
};

export type LivanceApiAlteraUsuarioCompromissoOutput = {
  __typename?: 'LivanceApiAlteraUsuarioCompromissoOutput';
  ativo: Scalars['Boolean']['output'];
  categoria: Scalars['Int']['output'];
  codParceiroIntegracao?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  codUsuarioCompromisso: Scalars['Int']['output'];
  codUsuarioCompromissoModalidade: Scalars['Int']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  duracao: Scalars['String']['output'];
  informacoesPaciente?: Maybe<Scalars['String']['output']>;
  nome: Scalars['String']['output'];
  online: Scalars['Boolean']['output'];
  usuariosCompromissosFormasRecebimentos: Array<Maybe<LivanceApiAlteraUsuarioCompromissoFormaRecebimento>>;
  usuariosCompromissosTiposSalas: Array<Maybe<LivanceApiAlteraUsuarioCompromissoTiposSalas>>;
  valor: Scalars['Float']['output'];
};

export type LivanceApiAlteraUsuarioCompromissoTiposSalas = {
  __typename?: 'LivanceApiAlteraUsuarioCompromissoTiposSalas';
  codTipoSala: Scalars['Int']['output'];
  prioridade: Scalars['Int']['output'];
};

export type LivanceApiBuscaHorarioLivreInput = {
  codAgendamentoOrigem?: InputMaybe<Scalars['Int']['input']>;
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
  comHorariosMenores?: InputMaybe<Scalars['Boolean']['input']>;
  data: Scalars['date']['input'];
  horarioInicio: Scalars['String']['input'];
};

export type LivanceApiBuscaHorarioLivreOutput = {
  __typename?: 'LivanceApiBuscaHorarioLivreOutput';
  autorizado: Scalars['Boolean']['output'];
  codUnidade: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioAgenda: Scalars['Int']['output'];
  fim: Scalars['date']['output'];
  inicio: Scalars['date']['output'];
  motivo?: Maybe<Scalars['String']['output']>;
  podeExceder: Scalars['Boolean']['output'];
  prioridade: Scalars['Float']['output'];
  tipoHorarioSugestao: Scalars['Int']['output'];
};

export type LivanceApiBuscaHorarioLivreReagendamentoOutput = {
  __typename?: 'LivanceApiBuscaHorarioLivreReagendamentoOutput';
  autorizado?: Maybe<Scalars['Boolean']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Int']['output']>;
  fim?: Maybe<Scalars['String']['output']>;
  inicio?: Maybe<Scalars['String']['output']>;
  motivo?: Maybe<Scalars['String']['output']>;
  podeExceder?: Maybe<Scalars['Boolean']['output']>;
  prioridade?: Maybe<Scalars['Float']['output']>;
  tipoHorarioSugestao?: Maybe<Scalars['Int']['output']>;
};

export type LivanceApiBuscaHorariosDisponiveisDiaDaSemanaInput = {
  codModalidadePeriodoGarantido: Scalars['Int']['input'];
  codPeriodoGarantidoRecorrenteFrequencia: Scalars['Int']['input'];
  codTipoSala: Scalars['Int']['input'];
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  diaDaSemana: Scalars['Int']['input'];
  duracao: Scalars['String']['input'];
};

export type LivanceApiBuscaHorariosDisponiveisDiaDaSemanaOutput = {
  __typename?: 'LivanceApiBuscaHorariosDisponiveisDiaDaSemanaOutput';
  sugestoesHorarios?: Maybe<Array<Maybe<LivanceApiSugestaoDeHorariosPeriodoGarantido>>>;
};

export type LivanceApiBuscaHorariosParaEstenderInput = {
  codAgendamento: Scalars['Int']['input'];
};

export type LivanceApiBuscaSelecionaFaixasLivresAgendaInput = {
  codUnidade?: InputMaybe<Scalars['Int']['input']>;
  codUsuario: Scalars['Int']['input'];
  dataFim?: InputMaybe<Scalars['date']['input']>;
  dataInicio?: InputMaybe<Scalars['date']['input']>;
};

export type LivanceApiBuscaSelecionaFaixasLivresAgendaOutput = {
  __typename?: 'LivanceApiBuscaSelecionaFaixasLivresAgendaOutput';
  autorizado: Scalars['Boolean']['output'];
  codUsuarioAgenda: Scalars['Int']['output'];
  fim: Scalars['date']['output'];
  inicio: Scalars['date']['output'];
  podeExceder: Scalars['Boolean']['output'];
  prioridade: Scalars['Float']['output'];
};

export type LivanceApiBuscaTipoSalaSugestoesOutput = {
  __typename?: 'LivanceApiBuscaTipoSalaSugestoesOutput';
  codEspecialidade?: Maybe<Scalars['Int']['output']>;
  codEspecialidadeTipoSala?: Maybe<Scalars['Int']['output']>;
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  especialidade?: Maybe<EspecialidadeTipoSala>;
  prioridade?: Maybe<Scalars['Int']['output']>;
  tipoSala?: Maybe<TipoSala>;
};

export type LivanceApiBuscaUsuarioCompromissoSugestaoDuracaoOutput = {
  __typename?: 'LivanceApiBuscaUsuarioCompromissoSugestaoDuracaoOutput';
  deveSugerir?: Maybe<Scalars['Boolean']['output']>;
  novaDuracao?: Maybe<Scalars['time']['output']>;
};

export type LivanceApiCadastraNovoCartaoInput = {
  cardHash: Scalars['String']['input'];
  codUsuario: Scalars['Int']['input'];
};

export type LivanceApiCadastraNovoCartaoOutput = {
  __typename?: 'LivanceApiCadastraNovoCartaoOutput';
  ativo: Scalars['Boolean']['output'];
  bandeira?: Maybe<Scalars['String']['output']>;
  cardHash?: Maybe<Scalars['String']['output']>;
  codControlPay?: Maybe<Scalars['Int']['output']>;
  codStatus?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  codUsuarioCartao?: Maybe<Scalars['Int']['output']>;
  dataCadastro: Scalars['String']['output'];
  descricaoStatus?: Maybe<Scalars['String']['output']>;
  numero?: Maybe<Scalars['String']['output']>;
  provedor?: Maybe<Scalars['String']['output']>;
  tokenCartao?: Maybe<Scalars['String']['output']>;
  tokenControlPay?: Maybe<Scalars['String']['output']>;
  tokenUrl?: Maybe<Scalars['String']['output']>;
  validade?: Maybe<Scalars['String']['output']>;
};

export type LivanceApiCancelaPeriodoGarantidoInput = {
  codPeriodoGarantido?: InputMaybe<Scalars['Int']['input']>;
};

export type LivanceApiCancelaPeriodoGarantidoOutput = {
  __typename?: 'LivanceApiCancelaPeriodoGarantidoOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LivanceApiCancelaPeriodoGarantidoRecorrenteInput = {
  codPeriodoGarantidoRecorrente: Scalars['Int']['input'];
};

export type LivanceApiCancelaPeriodoGarantidoRecorrenteOutput = {
  __typename?: 'LivanceApiCancelaPeriodoGarantidoRecorrenteOutput';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LivanceApiCreateAgendamentoInput = {
  cobraCancelamento?: InputMaybe<Scalars['Boolean']['input']>;
  codFinalidadeAgendamento?: InputMaybe<Scalars['Int']['input']>;
  codPaciente?: InputMaybe<Scalars['Int']['input']>;
  codTipoConvenio?: InputMaybe<Scalars['Int']['input']>;
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  codUsuarioAgenda?: InputMaybe<Scalars['Int']['input']>;
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
  cpf?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['String']['input'];
  dataNascimento?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  horaFim: Scalars['String']['input'];
  horaInicio: Scalars['String']['input'];
  ignorarEnvioEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ignorarEnvioWhatsApp?: InputMaybe<Scalars['Boolean']['input']>;
  nome: Scalars['String']['input'];
  nomePlano?: InputMaybe<Scalars['String']['input']>;
  numeroCarteirinha?: InputMaybe<Scalars['String']['input']>;
  receberWhatsAppConfirmacao?: InputMaybe<Scalars['Boolean']['input']>;
  telefone: Scalars['String']['input'];
};

export type LivanceApiCreateAppointmentInput = {
  cobraCancelamento?: InputMaybe<Scalars['Boolean']['input']>;
  codTipoConvenio?: InputMaybe<Scalars['Int']['input']>;
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  codUsuarioAgenda?: InputMaybe<Scalars['Int']['input']>;
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
  cpf?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['String']['input'];
  dataNascimento?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  horaFim: Scalars['String']['input'];
  horaInicio: Scalars['String']['input'];
  ignorarEnvioEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ignorarEnvioWhatsApp?: InputMaybe<Scalars['Boolean']['input']>;
  nome: Scalars['String']['input'];
  nomePlano?: InputMaybe<Scalars['String']['input']>;
  numeroCarteirinha?: InputMaybe<Scalars['String']['input']>;
  receberWhatsAppConfirmacao?: InputMaybe<Scalars['Boolean']['input']>;
  telefone: Scalars['String']['input'];
};

export type LivanceApiCreateUsuarioAgendaInput = {
  codTipoAgendaRepeticao: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  dataFim?: InputMaybe<Scalars['String']['input']>;
  dataInicio: Scalars['String']['input'];
  fim: Scalars['String']['input'];
  inicio: Scalars['String']['input'];
  usuariosAgendasCompromissos: Array<UsuarioAgendaCompromisso>;
  usuariosAgendasDiasSemanas?: InputMaybe<Array<UsuarioAgendaDiaSemana>>;
  usuariosAgendasUnidades: Array<UsuarioAgendaUnidade>;
};

export type LivanceApiCriaFechamentoInput = {
  codTipoFechamento: Scalars['Int']['input'];
  codUnidade?: InputMaybe<Scalars['Int']['input']>;
  codUsuario: Scalars['Int']['input'];
  data: Scalars['date']['input'];
  horaFim: Scalars['String']['input'];
  horaInicio: Scalars['String']['input'];
  motivo?: InputMaybe<Scalars['String']['input']>;
};

export type LivanceApiCriaPeriodoGarantidoRecorrenteInput = {
  codModalidadePeriodoGarantido: Scalars['Int']['input'];
  codPeriodoGarantidoRecorrenteFrequencia: Scalars['Int']['input'];
  codTipoSala: Scalars['Int']['input'];
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  dataInicio: Scalars['String']['input'];
  horaFim: Scalars['String']['input'];
  horaInicio: Scalars['String']['input'];
  margemInicial: Scalars['String']['input'];
};

export type LivanceApiCriaPeriodoGarantidoRecorrenteOutput = {
  __typename?: 'LivanceApiCriaPeriodoGarantidoRecorrenteOutput';
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LivanceApiCriaUsuarioCompromissoInput = {
  ativo: Scalars['Boolean']['input'];
  categoria: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  codUsuarioCompromissoModalidade: Scalars['Int']['input'];
  codUsuarioResponsavelPagamento?: InputMaybe<Scalars['Int']['input']>;
  dataCadastro: Scalars['String']['input'];
  descricao: Scalars['String']['input'];
  duracao: Scalars['String']['input'];
  envioAutomaticoValorTotem: Scalars['Boolean']['input'];
  informacoesPaciente?: InputMaybe<Scalars['String']['input']>;
  nome: Scalars['String']['input'];
  online: Scalars['Boolean']['input'];
  salaFlexHabilitada?: InputMaybe<Scalars['Boolean']['input']>;
  usuariosCompromissosCanaisAgendamentos?: InputMaybe<Array<InputMaybe<UsuarioCompromissoCanalAgendamentoInput>>>;
  usuariosCompromissosFormasRecebimentos: Array<InputMaybe<UsuarioCompromissoFormaDeRecebimentoCriacaoInput>>;
  usuariosCompromissosTiposSalas: Array<InputMaybe<UsuarioCompromissoTipoSalaCriacaoInput>>;
  valor: Scalars['Float']['input'];
};

export type LivanceApiCriaUsuarioCompromissoOutput = {
  __typename?: 'LivanceApiCriaUsuarioCompromissoOutput';
  response?: Maybe<Scalars['json']['output']>;
};

export type LivanceApiDeleteUsuarioAgendaInput = {
  codUsuarioAgenda: Scalars['Int']['input'];
};

export type LivanceApiDeleteUsuarioCompromissoInput = {
  codUsuarioCompromisso: Scalars['Int']['input'];
};

export type LivanceApiFeriado = {
  __typename?: 'LivanceApiFeriado';
  ano?: Maybe<Scalars['Int']['output']>;
  codCidade?: Maybe<Scalars['Int']['output']>;
  codFeriado: Scalars['Int']['output'];
  codUnidade?: Maybe<Scalars['Int']['output']>;
  dia: Scalars['Int']['output'];
  horaFim: Scalars['String']['output'];
  horaInicio: Scalars['String']['output'];
  mes: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
};

export type LivanceApiFeriadosPorPeriodoInput = {
  dataFim: Scalars['String']['input'];
  dataInicio: Scalars['String']['input'];
};

export type LivanceApiPaciente = {
  __typename?: 'LivanceApiPaciente';
  nome: Scalars['String']['output'];
};

export type LivanceApiPatchDadosBancariosInput = {
  codDadosBancarios: Scalars['Int']['input'];
  jsonPatchDocument: Array<JsonPatchDocument>;
};

export type LivanceApiPatchDadosBancariosOutput = {
  __typename?: 'LivanceApiPatchDadosBancariosOutput';
  codDadosBancarios: Scalars['Int']['output'];
};

export type LivanceApiPatchUsuarioAgendaInput = {
  codUsuarioAgenda: Scalars['Int']['input'];
  jsonPatchDocument: Array<Scalars['json']['input']>;
};

export type LivanceApiPatchUsuarioFormaRecebimentoInput = {
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
  jsonPatchDocument: Array<Scalars['json']['input']>;
};

export type LivanceApiRemarcaAgendamentoInput = {
  enviaEmailPaciente?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  newAppointment: LivanceApiAgendamentoInput;
  origem?: InputMaybe<Scalars['String']['input']>;
  tipoRemarcacao?: InputMaybe<Scalars['Int']['input']>;
};

export type LivanceApiSelecionaFotoDePerfilInput = {
  codUsuario: Scalars['Int']['input'];
};

export type LivanceApiSelecionaFotoDePerfilOutput = {
  __typename?: 'LivanceApiSelecionaFotoDePerfilOutput';
  arquivo?: Maybe<Scalars['String']['output']>;
  codTipoArquivo?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioArquivo?: Maybe<Scalars['Int']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
};

export type LivanceApiSelecionaHorariosProximosInput = {
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
  dataDisponibilidade: Scalars['date']['input'];
};

export type LivanceApiSelecionaHorariosProximosOutput = {
  __typename?: 'LivanceApiSelecionaHorariosProximosOutput';
  horariosDisponiveis: Array<Maybe<Scalars['String']['output']>>;
};

export type LivanceApiSimulaCobrancaDeCancelamentoInput = {
  codPeriodoGarantido: Scalars['Int']['input'];
  dataReferencia?: InputMaybe<Scalars['String']['input']>;
};

export type LivanceApiSimulaCobrancaDeCancelamentoOutput = {
  __typename?: 'LivanceApiSimulaCobrancaDeCancelamentoOutput';
  taxa?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

export type LivanceApiSimulaCobrancaPeriodoGarantidoInput = {
  codModalidadePeriodoGarantido: Scalars['Int']['input'];
  codTipoSala: Scalars['Int']['input'];
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  duracao: Scalars['String']['input'];
};

export type LivanceApiSimulaCobrancaPeriodoGarantidoOutput = {
  __typename?: 'LivanceApiSimulaCobrancaPeriodoGarantidoOutput';
  valor: Scalars['Float']['output'];
};

export type LivanceApiSugestaoDeHorariosPeriodoGarantido = {
  __typename?: 'LivanceApiSugestaoDeHorariosPeriodoGarantido';
  data: Scalars['String']['output'];
  horaFim: Scalars['String']['output'];
  horaInicio: Scalars['String']['output'];
};

export type LivanceApiUpsertUsuarioEnderecoInput = {
  bairro?: InputMaybe<Scalars['String']['input']>;
  cep: Scalars['String']['input'];
  cidade: Scalars['String']['input'];
  codUsuario: Scalars['Int']['input'];
  codigoIBGE?: InputMaybe<Scalars['String']['input']>;
  complemento?: InputMaybe<Scalars['String']['input']>;
  logradouro?: InputMaybe<Scalars['String']['input']>;
  numero?: InputMaybe<Scalars['String']['input']>;
  uf: Scalars['String']['input'];
};

export type LivanceApiUpsertUsuarioEnderecoOutput = {
  __typename?: 'LivanceApiUpsertUsuarioEnderecoOutput';
  bairro?: Maybe<Scalars['String']['output']>;
  cep: Scalars['String']['output'];
  cidade: Scalars['String']['output'];
  codUsuario: Scalars['Int']['output'];
  codigoIBGE?: Maybe<Scalars['String']['output']>;
  complemento?: Maybe<Scalars['String']['output']>;
  logradouro?: Maybe<Scalars['String']['output']>;
  numero?: Maybe<Scalars['String']['output']>;
  uf: Scalars['String']['output'];
};

export type LivanceApiUsuarioAgendaAtivosPorUsuarioInput = {
  codUsuario: Scalars['Int']['input'];
};

export type LivanceApiUsuarioAgendaAtivosPorUsuarioOutput = {
  __typename?: 'LivanceApiUsuarioAgendaAtivosPorUsuarioOutput';
  ativo: Scalars['Boolean']['output'];
  codTipoAgendaRepeticao: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioAgenda: Scalars['Int']['output'];
  dataFim?: Maybe<Scalars['String']['output']>;
  dataInicio: Scalars['String']['output'];
  fim: Scalars['String']['output'];
  inicio: Scalars['String']['output'];
  reserva?: Maybe<Scalars['Boolean']['output']>;
  usuariosAgendasCompromissos?: Maybe<Array<LivanceApiUsuarioAgendaCompromisso>>;
  usuariosAgendasDiasSemanas?: Maybe<Array<LivanceApiUsuarioAgendaDiaSemana>>;
  usuariosAgendasUnidades?: Maybe<Array<LivanceApiUsuarioAgendaUnidade>>;
};

export type LivanceApiUsuarioAgendaCompromisso = {
  __typename?: 'LivanceApiUsuarioAgendaCompromisso';
  ativo: Scalars['Boolean']['output'];
  categoria: Scalars['Int']['output'];
  codUsuarioAgenda: Scalars['Int']['output'];
  codUsuarioCompromisso: Scalars['Int']['output'];
  dataCadastro: Scalars['String']['output'];
  modalidade: Scalars['Int']['output'];
  usuarioCompromisso?: Maybe<LivanceApiUsuarioCompromissoOutput>;
};

export type LivanceApiUsuarioAgendaDiaSemana = {
  __typename?: 'LivanceApiUsuarioAgendaDiaSemana';
  ativo: Scalars['Boolean']['output'];
  codUsuarioAgenda: Scalars['Int']['output'];
  dataCadastro: Scalars['String']['output'];
  diaSemana: Scalars['Int']['output'];
  diaSemanaNome: Scalars['String']['output'];
};

export type LivanceApiUsuarioAgendaUnidade = {
  __typename?: 'LivanceApiUsuarioAgendaUnidade';
  ativo: Scalars['Boolean']['output'];
  codUnidade: Scalars['Int']['output'];
  codUsuarioAgenda: Scalars['Int']['output'];
  dataCadastro: Scalars['String']['output'];
};

export type LivanceApiUsuarioCompromissoOutput = {
  __typename?: 'LivanceApiUsuarioCompromissoOutput';
  ativo: Scalars['Boolean']['output'];
  categoria: Scalars['Int']['output'];
  codParceiroIntegracao?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  codUsuarioCompromisso: Scalars['Int']['output'];
  codUsuarioCompromissoModalidade: Scalars['Int']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  duracao: Scalars['String']['output'];
  nome: Scalars['String']['output'];
  usuariosCompromissosFormasRecebimentos: Array<LivanceApiusuarioCompromissoFormaRecebimento>;
};

export type LivanceApiUsuarioPlanoMigracaoInput = {
  codPlano: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
};

export type LivanceApiUsuarioPlanoMigracaoOutput = {
  __typename?: 'LivanceApiUsuarioPlanoMigracaoOutput';
  codPlano: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioProfissionalPlano: Scalars['Int']['output'];
  dataCadastro: Scalars['String']['output'];
  dataFim?: Maybe<Scalars['String']['output']>;
  dataInicio: Scalars['String']['output'];
};

export type LivanceApiusuarioCompromissoFormaRecebimento = {
  __typename?: 'LivanceApiusuarioCompromissoFormaRecebimento';
  ativo: Scalars['Int']['output'];
  codUsuarioFormaRecebimento: Scalars['Int']['output'];
};

export type LocusGetProfileCompletionPercentageOutput = {
  __typename?: 'LocusGetProfileCompletionPercentageOutput';
  codUsuario?: Maybe<Scalars['Int']['output']>;
  membro?: Maybe<Locus_Membro>;
  pendente?: Maybe<LocusGetProfileCompletionPercentagePending>;
  porcentagemPerfil: Scalars['Int']['output'];
};

export type LocusGetProfileCompletionPercentagePending = {
  __typename?: 'LocusGetProfileCompletionPercentagePending';
  experiencias?: Maybe<Scalars['String']['output']>;
  faqs?: Maybe<Scalars['String']['output']>;
  focosTratamentos?: Maybe<Scalars['String']['output']>;
  membroFormacoes?: Maybe<Scalars['String']['output']>;
  sobre?: Maybe<Scalars['String']['output']>;
};

export type LocusUpdateMemberSocialMediaInput = {
  socialMedia: Array<SocialMediaInput>;
};

export type LocusUpsertBasicProfileInput = {
  ativo: Scalars['Boolean']['input'];
  duracaoConsulta: Scalars['String']['input'];
  especialidades: Array<BasicProfileEspecialidades>;
  formasPagamento: Scalars['String']['input'];
  fotoPerfil?: InputMaybe<FileInput>;
  idConselhoProfissional: Scalars['Int']['input'];
  nomeExibido: Scalars['String']['input'];
  numeroConselhoProfissional: Scalars['String']['input'];
  pronome?: InputMaybe<Scalars['String']['input']>;
  resumo: Scalars['String']['input'];
  ufConselhoProfissional: Scalars['String']['input'];
  valorConsulta: Scalars['Float']['input'];
};

export type LocusUpsertBasicProfileOutput = {
  __typename?: 'LocusUpsertBasicProfileOutput';
  id: Scalars['Int']['output'];
};

/** Essa classe inclui informações adicionais ao usuário */
export type Membro = {
  __typename?: 'Membro';
  /** Calcula se o usuário possui alta taxa de cancelamento nos últimos 30 dias */
  altaTaxaCancelamento: Scalars['Boolean']['output'];
  codUsuario: Scalars['Int']['output'];
  /** Busca funcionalidades contratadas do membro */
  funcionalidadesContratadas?: Maybe<Array<Maybe<FuncionalidadeContratadaOutput>>>;
  /** Busca os pacotes e serviços do membro */
  pacotesServicos?: Maybe<Array<Maybe<PacoteServicoOutput>>>;
  /** Esse método busca a possivel data de final do trial para o assist pro */
  possivelDataFimTrialAssistPro?: Maybe<BuscaDataFimTrialAssistProOutput>;
};

export type MembroPerfilComunidade = {
  __typename?: 'MembroPerfilComunidade';
  codUsuario: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailComunidadeInformar?: Maybe<Scalars['Boolean']['output']>;
  especialidades?: Maybe<Array<Especialidade>>;
  follow: Array<Nexus_Follow>;
  nome?: Maybe<Scalars['String']['output']>;
  ramal?: Maybe<Scalars['String']['output']>;
  ramalTroncoComunidadeInformar?: Maybe<Scalars['Boolean']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  telefone?: Maybe<Scalars['String']['output']>;
  telefoneComunidadeInformar?: Maybe<Scalars['Boolean']['output']>;
  unidades?: Maybe<Array<Unidade>>;
  urlFoto?: Maybe<Scalars['String']['output']>;
  websiteComunidadeInformar?: Maybe<Scalars['Boolean']['output']>;
};


export type MembroPerfilComunidadeFollowArgs = {
  distinct_on?: InputMaybe<Array<Nexus_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nexus_Follow_Order_By>>;
  where?: InputMaybe<Nexus_Follow_Bool_Exp>;
};

export type MembroPerfilPublico = {
  __typename?: 'MembroPerfilPublico';
  codUsuario: Scalars['Int']['output'];
  especialidades?: Maybe<Array<Especialidade>>;
  nome?: Maybe<Scalars['String']['output']>;
};

export type MovimentacaoExibicao = {
  __typename?: 'MovimentacaoExibicao';
  cobrado: Scalars['Boolean']['output'];
  codCobranca?: Maybe<Scalars['Int']['output']>;
  codModalidadeFiscal: Scalars['Int']['output'];
  codMovimentacao: Scalars['Int']['output'];
  codOrigem?: Maybe<Scalars['Int']['output']>;
  codTipoMovimentacao: Scalars['Int']['output'];
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  dataCadastro: Scalars['DateTime']['output'];
  dataVencimento: Scalars['DateTime']['output'];
  identificacaoTipoMovimentacao?: Maybe<Scalars['String']['output']>;
  movimentacoesAcrescimos: Array<MovimentacaoExibicao>;
  movimentacoesDesconto: Array<MovimentacaoExibicao>;
  nomeTipoMovimentacao: Scalars['String']['output'];
  nomeUnidade?: Maybe<Scalars['String']['output']>;
  possuiExtensao: Scalars['Boolean']['output'];
  quantidade: Scalars['Decimal']['output'];
  tempoUnitario: Scalars['TimeSpan']['output'];
  tipoOrigem?: Maybe<Scalars['String']['output']>;
  valor: Scalars['Decimal']['output'];
  valorAcrescimo: Scalars['Decimal']['output'];
  valorDesconto: Scalars['Decimal']['output'];
  valorUnitario: Scalars['Decimal']['output'];
};

export type NuntiusAssistContactBatchDetails = {
  __typename?: 'NuntiusAssistContactBatchDetails';
  billingDate: Scalars['String']['output'];
  channel: Scalars['String']['output'];
  contactId: Scalars['String']['output'];
  contactReason: Scalars['String']['output'];
  contactType: Scalars['String']['output'];
  direction: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  price: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type NuntiusGetAssistContactBatchDetailsInput = {
  contactBatchId: Scalars['Int']['input'];
};

export type NuntiusGetAssistContactBatchDetailsOutput = {
  __typename?: 'NuntiusGetAssistContactBatchDetailsOutput';
  assistContactBatchDetails: Array<Maybe<NuntiusAssistContactBatchDetails>>;
};

export type NuntiusGetCustomerContactManyPeriodSummaryInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type NuntiusGetCustomerContactManyPeriodSummaryOccurrenceData = {
  __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOccurrenceData';
  key: Scalars['Int']['output'];
  percent: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type NuntiusGetCustomerContactManyPeriodSummaryOutput = {
  __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput';
  mainReasonsOccurrences: Array<NuntiusGetCustomerContactManyPeriodSummaryOccurrenceData>;
  mostFrequentNotScheduledAppointmentReasons: Array<NuntiusGetCustomerContactManyPeriodSummaryOccurrenceData>;
  percentCustomerContactsAppointmentsScheduled: Scalars['Int']['output'];
  percentCustomerContactsChat: Scalars['Int']['output'];
  percentCustomerContactsVoice: Scalars['Int']['output'];
  percentDigitalCustomerContacts: Scalars['Int']['output'];
  percentGrowthTotalCustomerContacts: Scalars['Int']['output'];
  percentGrowthTotalHumanCustomerContacts: Scalars['Int']['output'];
  percentHumanCustomerContacts: Scalars['Int']['output'];
  percentHumanCustomerContactsChat: Scalars['Int']['output'];
  percentHumanCustomerContactsVoice: Scalars['Int']['output'];
  percentNewCustomerContacts: Scalars['Int']['output'];
  percentOldCustomerContacts: Scalars['Int']['output'];
  percentTotalFilteredCustomerContacts: Scalars['Int']['output'];
  period: Scalars['String']['output'];
  removedFilters: Array<Maybe<NuntiusGetCustomerContactManyPeriodSummaryOccurrenceData>>;
  totalBeforeFiltering: Scalars['Int']['output'];
  totalCustomerContacts: Scalars['Int']['output'];
  totalCustomerContactsAppointmentsScheduled: Scalars['Int']['output'];
  totalCustomerContactsChat: Scalars['Int']['output'];
  totalCustomerContactsNewAppointmentMainReason: Scalars['Int']['output'];
  totalCustomerContactsVoice: Scalars['Int']['output'];
  totalDigitalCustomerContacts: Scalars['Int']['output'];
  totalFiltered: Scalars['Int']['output'];
  totalHumanCustomerContacts: Scalars['Int']['output'];
  totalHumanCustomerContactsChat: Scalars['Int']['output'];
  totalHumanCustomerContactsVoice: Scalars['Int']['output'];
  totalNewCustomerContacts: Scalars['Int']['output'];
  totalNotScheduledAppointments: Scalars['Int']['output'];
  totalOldCustomerContacts: Scalars['Int']['output'];
};

export type NuntiusGetCustomerContactPeriodSummaryInput = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type NuntiusGetCustomerContactPeriodSummaryOutput = {
  __typename?: 'NuntiusGetCustomerContactPeriodSummaryOutput';
  mostFrequentMainReasonId?: Maybe<Scalars['Int']['output']>;
  mostFrequentNotScheduledAppointmentReasonsIds: Array<Scalars['Int']['output']>;
  percentCustomerContactsAppointmentsScheduled: Scalars['Int']['output'];
  percentMostFrequentMainReason: Scalars['Int']['output'];
  percentNewCustomers: Scalars['Int']['output'];
  percentOldCustomers: Scalars['Int']['output'];
  totalAllocatedRooms: Scalars['Int']['output'];
  totalAllocatedRoomsOnPeriod: Scalars['Int']['output'];
  totalCustomerContacts: Scalars['Int']['output'];
  totalCustomerContactsAppointmentsScheduled: Scalars['Int']['output'];
  totalCustomerContactsNewAppointmentMainReason: Scalars['Int']['output'];
  totalCustomers: Scalars['Int']['output'];
  totalMostFrequentMainReason: Scalars['Int']['output'];
  totalNewCustomers: Scalars['Int']['output'];
  totalOldCustomers: Scalars['Int']['output'];
};

export type NuntiusGetFutureAppointmentByPhoneNumberInput = {
  codUsuario: Scalars['Int']['input'];
  patientPhoneNumber: Scalars['String']['input'];
};

export type NuntiusGetFutureAppointmentByPhoneNumberOutput = {
  __typename?: 'NuntiusGetFutureAppointmentByPhoneNumberOutput';
  appointmentDay?: Maybe<Scalars['Int']['output']>;
  appointmentId?: Maybe<Scalars['Int']['output']>;
  appointmentMonth?: Maybe<Scalars['String']['output']>;
  appointmentTime?: Maybe<Scalars['String']['output']>;
  hasFutureAppointment: Scalars['Boolean']['output'];
  isEligible?: Maybe<Scalars['Boolean']['output']>;
  isNotEligibleReason?: Maybe<Scalars['String']['output']>;
  rescheduleLink?: Maybe<Scalars['String']['output']>;
  rescheduleLinkPath?: Maybe<Scalars['String']['output']>;
};

export type OnboardingSchedulingInfos = {
  codUnidade: Scalars['Int']['input'];
  data: Scalars['String']['input'];
};

export type OnboardingSchedulingOutput = {
  __typename?: 'OnboardingSchedulingOutput';
  blocking: Scalars['Int']['output'];
};

export type PacienteGraphQl = {
  __typename?: 'PacienteGraphQL';
  ativo?: Maybe<Scalars['Boolean']['output']>;
  codPaciente: Scalars['Int']['output'];
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  cpfProprio?: Maybe<Scalars['Boolean']['output']>;
  dataNascimento?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  nome: Scalars['String']['output'];
  nomeConvenio?: Maybe<Scalars['String']['output']>;
  nomePlano?: Maybe<Scalars['String']['output']>;
  numeroCarteirinha?: Maybe<Scalars['String']['output']>;
  receberWhatsAppConfirmacao?: Maybe<Scalars['Boolean']['output']>;
  telefone?: Maybe<Scalars['String']['output']>;
  telefoneInternacionalNormalizado?: Maybe<Scalars['String']['output']>;
  telefoneProprio?: Maybe<Scalars['Boolean']['output']>;
  validadeCarteirinha?: Maybe<Scalars['DateTime']['output']>;
};

export type PacienteGraphQlInput = {
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  codPaciente: Scalars['Int']['input'];
  codTipoConvenio?: InputMaybe<Scalars['Int']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  cpfProprio?: InputMaybe<Scalars['Boolean']['input']>;
  dataNascimento?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  nome: Scalars['String']['input'];
  nomeConvenio?: InputMaybe<Scalars['String']['input']>;
  nomePlano?: InputMaybe<Scalars['String']['input']>;
  numeroCarteirinha?: InputMaybe<Scalars['String']['input']>;
  receberWhatsAppConfirmacao?: InputMaybe<Scalars['Boolean']['input']>;
  telefone?: InputMaybe<Scalars['String']['input']>;
  telefoneInternacionalNormalizado?: InputMaybe<Scalars['String']['input']>;
  telefoneProprio?: InputMaybe<Scalars['Boolean']['input']>;
  validadeCarteirinha?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PacoteServicoOutput = {
  __typename?: 'PacoteServicoOutput';
  cancelado: Scalars['Boolean']['output'];
  codPacoteServicos: Scalars['Int']['output'];
  codUsuarioPacoteServicos: Scalars['Int']['output'];
  dataContratacao: Scalars['DateTime']['output'];
  dataDesativacao?: Maybe<Scalars['DateTime']['output']>;
  dataFimTrial?: Maybe<Scalars['DateTime']['output']>;
  grupoUpgrade: Scalars['String']['output'];
  pacoteServicoPreco?: Maybe<PacoteServicoPrecoOutput>;
  trialAtivo: Scalars['Boolean']['output'];
  trialFinalizado: Scalars['Boolean']['output'];
};

export type PacoteServicoPrecoOutput = {
  __typename?: 'PacoteServicoPrecoOutput';
  valorUnitarioFixo: Scalars['Decimal']['output'];
  valorUnitarioVariavel: Scalars['Decimal']['output'];
};

export type PagarmeAutomaticAnticipationSettingsUpdateInput = {
  days?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  delay?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  recipientId: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  volumePercentage?: InputMaybe<Scalars['String']['input']>;
};

export type PagarmePagination = {
  __typename?: 'PagarmePagination';
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type PagarmePayable = {
  __typename?: 'PagarmePayable';
  accrualAt?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  anticipationFee?: Maybe<Scalars['Int']['output']>;
  chargeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  fraudCoverageFee?: Maybe<Scalars['Int']['output']>;
  gatewayId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  installment?: Maybe<Scalars['Int']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  recipientId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PagarmePayableV2 = {
  __typename?: 'PagarmePayableV2';
  accrualAt?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Int']['output']>;
  anticipationFee?: Maybe<Scalars['Int']['output']>;
  appointmentDate?: Maybe<Scalars['String']['output']>;
  appointmentStart?: Maybe<Scalars['String']['output']>;
  chargeId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  fraudCoverageFee?: Maybe<Scalars['Int']['output']>;
  gatewayId?: Maybe<Scalars['Int']['output']>;
  installment?: Maybe<Scalars['Int']['output']>;
  installments?: Maybe<Scalars['Int']['output']>;
  originPaymentType?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  paymentCreatedAt?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  recipientId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PagarmePayablesListInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  bulkAnticipationId?: InputMaybe<Scalars['String']['input']>;
  chargeId?: InputMaybe<Scalars['String']['input']>;
  createdSince?: InputMaybe<Scalars['String']['input']>;
  createdUntil?: InputMaybe<Scalars['String']['input']>;
  gatewayId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  installment?: InputMaybe<Scalars['String']['input']>;
  liquidationArrangementId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  paymentDateSince?: InputMaybe<Scalars['String']['input']>;
  paymentDateUntil?: InputMaybe<Scalars['String']['input']>;
  recipientId: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  splitId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedSince?: InputMaybe<Scalars['String']['input']>;
  updatedUntil?: InputMaybe<Scalars['String']['input']>;
};

export type PagarmePayablesListOutput = {
  __typename?: 'PagarmePayablesListOutput';
  data: Array<Maybe<PagarmePayable>>;
  paging?: Maybe<PagarmePagination>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type PerfisComunidadeConnection = {
  __typename?: 'PerfisComunidadeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PerfisComunidadeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<MembroPerfilComunidade>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PerfisComunidadeEdge = {
  __typename?: 'PerfisComunidadeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MembroPerfilComunidade>;
};

/** A connection to a list of items. */
export type PerfisPublicosConnection = {
  __typename?: 'PerfisPublicosConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PerfisPublicosEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<MembroPerfilPublico>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PerfisPublicosEdge = {
  __typename?: 'PerfisPublicosEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MembroPerfilPublico>;
};

/** columns and relationships of "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas = {
  __typename?: 'PrecificacoesTiposSalas';
  /** An object relationship */
  TipoMovimentacao: TiposMovimentacoes;
  ativo: Scalars['Boolean']['output'];
  codPrecificacao: Scalars['Int']['output'];
  codTipoMovimentacao: Scalars['Int']['output'];
  codTipoSala: Scalars['Int']['output'];
  codUnidade: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  /** An object relationship */
  tiposSala: TiposSalas;
  /** An object relationship */
  unidade: Unidades;
};

/** order by aggregate values of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Aggregate_Order_By = {
  avg?: InputMaybe<PrecificacoesTiposSalas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<PrecificacoesTiposSalas_Max_Order_By>;
  min?: InputMaybe<PrecificacoesTiposSalas_Min_Order_By>;
  stddev?: InputMaybe<PrecificacoesTiposSalas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<PrecificacoesTiposSalas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<PrecificacoesTiposSalas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<PrecificacoesTiposSalas_Sum_Order_By>;
  var_pop?: InputMaybe<PrecificacoesTiposSalas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<PrecificacoesTiposSalas_Var_Samp_Order_By>;
  variance?: InputMaybe<PrecificacoesTiposSalas_Variance_Order_By>;
};

/** order by avg() on columns of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Avg_Order_By = {
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbPrecificacoesTiposSalas". All fields are combined with a logical 'AND'. */
export type PrecificacoesTiposSalas_Bool_Exp = {
  TipoMovimentacao?: InputMaybe<TiposMovimentacoes_Bool_Exp>;
  _and?: InputMaybe<Array<PrecificacoesTiposSalas_Bool_Exp>>;
  _not?: InputMaybe<PrecificacoesTiposSalas_Bool_Exp>;
  _or?: InputMaybe<Array<PrecificacoesTiposSalas_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codPrecificacao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoMovimentacao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  tiposSala?: InputMaybe<TiposSalas_Bool_Exp>;
  unidade?: InputMaybe<Unidades_Bool_Exp>;
};

/** order by max() on columns of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Max_Order_By = {
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Min_Order_By = {
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbPrecificacoesTiposSalas". */
export type PrecificacoesTiposSalas_Order_By = {
  TipoMovimentacao?: InputMaybe<TiposMovimentacoes_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  tiposSala?: InputMaybe<TiposSalas_Order_By>;
  unidade?: InputMaybe<Unidades_Order_By>;
};

/** order by stddev() on columns of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Stddev_Order_By = {
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Stddev_Pop_Order_By = {
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Stddev_Samp_Order_By = {
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Sum_Order_By = {
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Var_Pop_Order_By = {
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Var_Samp_Order_By = {
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbPrecificacoesTiposSalas" */
export type PrecificacoesTiposSalas_Variance_Order_By = {
  codPrecificacao?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
};

export type ReceberSalaAgoraError = RepeatedPatientError | ValidationError;

export type ReceberSalaAgoraInput = {
  codAgendamento: Scalars['Int']['input'];
  enviaEmailPaciente?: Scalars['Boolean']['input'];
};

export type ReceberSalaAgoraPayload = {
  __typename?: 'ReceberSalaAgoraPayload';
  agendamentoApiOutput?: Maybe<AgendamentoApiOutput>;
  errors?: Maybe<Array<ReceberSalaAgoraError>>;
};

export type RemarcarAgendamentoError = RepeatedPatientError | ValidationError;

export type RemarcarAgendamentoInput = {
  codAgendamentoOrigem: Scalars['Int']['input'];
  enviaEmailPaciente?: Scalars['Boolean']['input'];
  remarcarNovoAgendamento: RemarcarNovoAgendamentoInput;
};

export type RemarcarAgendamentoPayload = {
  __typename?: 'RemarcarAgendamentoPayload';
  agendamentoApiOutput?: Maybe<AgendamentoApiOutput>;
  errors?: Maybe<Array<RemarcarAgendamentoError>>;
};

export type RemarcarNovoAgendamentoInput = {
  cancelado?: InputMaybe<Scalars['Boolean']['input']>;
  cobraCancelamento?: InputMaybe<Scalars['Boolean']['input']>;
  codFinalidadeAgendamento?: InputMaybe<Scalars['Int']['input']>;
  codPaciente?: InputMaybe<Scalars['Int']['input']>;
  codTipoConvenio?: InputMaybe<Scalars['Int']['input']>;
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  codUsuarioAgenda?: InputMaybe<Scalars['Int']['input']>;
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
  confirmado: Scalars['Boolean']['input'];
  cpf?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['Date']['input'];
  dataNascimento?: InputMaybe<Scalars['Date']['input']>;
  email: Scalars['String']['input'];
  eventual?: Scalars['Boolean']['input'];
  horaFim: Scalars['String']['input'];
  horaInicio: Scalars['String']['input'];
  ignorarEnvioEmail: Scalars['Boolean']['input'];
  ignorarEnvioWhatsApp: Scalars['Boolean']['input'];
  nome: Scalars['String']['input'];
  nomePlano?: InputMaybe<Scalars['String']['input']>;
  numeroCarteirinha?: InputMaybe<Scalars['String']['input']>;
  receberWhatsAppConfirmacao: Scalars['Boolean']['input'];
  telefone: Scalars['String']['input'];
  telefoneInternacionalNormalizado?: InputMaybe<Scalars['String']['input']>;
};

export type RepeatedPatientError = Error & {
  __typename?: 'RepeatedPatientError';
  message: Scalars['String']['output'];
  statusCode: HttpStatusCode;
};

export type SetupReturnSettingsInput = {
  returnDuration: Scalars['String']['input'];
  returnSettings: Scalars['Int']['input'];
};

export type SetupReturnSettingsOutput = {
  __typename?: 'SetupReturnSettingsOutput';
  message: Scalars['String']['output'];
};

export type Slot = {
  __typename?: 'Slot';
  appointmentTypes?: Maybe<Array<Maybe<AppointmentType>>>;
  end?: Maybe<Scalars['String']['output']>;
  hostIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  start?: Maybe<Scalars['String']['output']>;
};

export type SocialMediaInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type TimeSuggestion = {
  __typename?: 'TimeSuggestion';
  codUsuarioAgenda?: Maybe<Scalars['Int']['output']>;
  dataHora: Scalars['String']['output'];
  dataHoraFim: Scalars['String']['output'];
  diaNome: Scalars['String']['output'];
  diaSemanaNome: Scalars['String']['output'];
  duracao: Scalars['String']['output'];
  periodo: Scalars['String']['output'];
  tipoHorarioSugestao?: Maybe<Scalars['Int']['output']>;
};

export enum TipoAlocacao {
  AlocacaoPadrao = 'ALOCACAO_PADRAO',
  Atraso = 'ATRASO',
  Extensao = 'EXTENSAO',
  PeriodoGarantido = 'PERIODO_GARANTIDO'
}

export type TipoSala = {
  __typename?: 'TipoSala';
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  nomeAbreviado?: Maybe<Scalars['String']['output']>;
};

export type TrocarPacienteError = RepeatedPatientError | ValidationError;

export type TrocarPacienteInput = {
  codAgendamentoOrigem: Scalars['Int']['input'];
  enviaEmailPaciente?: Scalars['Boolean']['input'];
  remarcarNovoAgendamento: RemarcarNovoAgendamentoInput;
};

export type TrocarPacientePayload = {
  __typename?: 'TrocarPacientePayload';
  agendamentoApiOutput?: Maybe<AgendamentoApiOutput>;
  errors?: Maybe<Array<TrocarPacienteError>>;
};

export type Unidade = {
  __typename?: 'Unidade';
  nome?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis = {
  __typename?: 'UnidadesPrecosFlexiveis';
  /** An object relationship */
  TiposSala: TiposSalas;
  /** An object relationship */
  Unidade: Unidades;
  /** An array relationship */
  UnidadesPrecosFlexiveisParceirosIntegracoes: Array<UnidadesPrecosFlexiveisParceirosIntegracoes>;
  /** An aggregate relationship */
  UnidadesPrecosFlexiveisParceirosIntegracoes_aggregate: UnidadesPrecosFlexiveisParceirosIntegracoes_Aggregate;
  ativo: Scalars['Boolean']['output'];
  codTipoSala: Scalars['Int']['output'];
  codUnidade: Scalars['Int']['output'];
  codUnidadePrecoFlexivel: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  taxaCancelamento: Scalars['Float']['output'];
  taxaDesconto: Scalars['Float']['output'];
};


/** columns and relationships of "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveisUnidadesPrecosFlexiveisParceirosIntegracoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveisParceirosIntegracoes_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp>;
};


/** columns and relationships of "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveisUnidadesPrecosFlexiveisParceirosIntegracoes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveisParceirosIntegracoes_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp>;
};

/** columns and relationships of "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes';
  /** An object relationship */
  UnidadesPrecosFlexivei: UnidadesPrecosFlexiveis;
  codParceiroIntegracao: Scalars['Int']['output'];
  codUnidadePrecoFlexivel: Scalars['Int']['output'];
};

/** aggregated selection of "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Aggregate = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_aggregate';
  aggregate?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Aggregate_Fields>;
  nodes: Array<UnidadesPrecosFlexiveisParceirosIntegracoes>;
};

/** aggregate fields of "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Aggregate_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_aggregate_fields';
  avg?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Max_Fields>;
  min?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Min_Fields>;
  stddev?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Fields>;
  stddev_pop?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Samp_Fields>;
  sum?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Sum_Fields>;
  var_pop?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Var_Pop_Fields>;
  var_samp?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Var_Samp_Fields>;
  variance?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Variance_Fields>;
};


/** aggregate fields of "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Aggregate_Order_By = {
  avg?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Max_Order_By>;
  min?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Min_Order_By>;
  stddev?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Sum_Order_By>;
  var_pop?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Var_Samp_Order_By>;
  variance?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Variance_Order_By>;
};

/** aggregate avg on columns */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Avg_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_avg_fields';
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Avg_Order_By = {
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUnidadesPrecosFlexiveisParceirosIntegracoes". All fields are combined with a logical 'AND'. */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp = {
  UnidadesPrecosFlexivei?: InputMaybe<UnidadesPrecosFlexiveis_Bool_Exp>;
  _and?: InputMaybe<Array<UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp>>;
  _not?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp>;
  _or?: InputMaybe<Array<UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp>>;
  codParceiroIntegracao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadePrecoFlexivel?: InputMaybe<Int_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Max_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_max_fields';
  codParceiroIntegracao?: Maybe<Scalars['Int']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Max_Order_By = {
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Min_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_min_fields';
  codParceiroIntegracao?: Maybe<Scalars['Int']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Min_Order_By = {
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUnidadesPrecosFlexiveisParceirosIntegracoes". */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Order_By = {
  UnidadesPrecosFlexivei?: InputMaybe<UnidadesPrecosFlexiveis_Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** select columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export enum UnidadesPrecosFlexiveisParceirosIntegracoes_Select_Column {
  /** column name */
  CodParceiroIntegracao = 'codParceiroIntegracao',
  /** column name */
  CodUnidadePrecoFlexivel = 'codUnidadePrecoFlexivel'
}

/** aggregate stddev on columns */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_stddev_fields';
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Order_By = {
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Pop_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_stddev_pop_fields';
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Pop_Order_By = {
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Samp_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_stddev_samp_fields';
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Stddev_Samp_Order_By = {
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Sum_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_sum_fields';
  codParceiroIntegracao?: Maybe<Scalars['Int']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Sum_Order_By = {
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Var_Pop_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_var_pop_fields';
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Var_Pop_Order_By = {
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Var_Samp_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_var_samp_fields';
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Var_Samp_Order_By = {
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Variance_Fields = {
  __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes_variance_fields';
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbUnidadesPrecosFlexiveisParceirosIntegracoes" */
export type UnidadesPrecosFlexiveisParceirosIntegracoes_Variance_Order_By = {
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
};

/** aggregated selection of "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Aggregate = {
  __typename?: 'UnidadesPrecosFlexiveis_aggregate';
  aggregate?: Maybe<UnidadesPrecosFlexiveis_Aggregate_Fields>;
  nodes: Array<UnidadesPrecosFlexiveis>;
};

/** aggregate fields of "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Aggregate_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_aggregate_fields';
  avg?: Maybe<UnidadesPrecosFlexiveis_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UnidadesPrecosFlexiveis_Max_Fields>;
  min?: Maybe<UnidadesPrecosFlexiveis_Min_Fields>;
  stddev?: Maybe<UnidadesPrecosFlexiveis_Stddev_Fields>;
  stddev_pop?: Maybe<UnidadesPrecosFlexiveis_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UnidadesPrecosFlexiveis_Stddev_Samp_Fields>;
  sum?: Maybe<UnidadesPrecosFlexiveis_Sum_Fields>;
  var_pop?: Maybe<UnidadesPrecosFlexiveis_Var_Pop_Fields>;
  var_samp?: Maybe<UnidadesPrecosFlexiveis_Var_Samp_Fields>;
  variance?: Maybe<UnidadesPrecosFlexiveis_Variance_Fields>;
};


/** aggregate fields of "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<UnidadesPrecosFlexiveis_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Aggregate_Order_By = {
  avg?: InputMaybe<UnidadesPrecosFlexiveis_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UnidadesPrecosFlexiveis_Max_Order_By>;
  min?: InputMaybe<UnidadesPrecosFlexiveis_Min_Order_By>;
  stddev?: InputMaybe<UnidadesPrecosFlexiveis_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UnidadesPrecosFlexiveis_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UnidadesPrecosFlexiveis_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UnidadesPrecosFlexiveis_Sum_Order_By>;
  var_pop?: InputMaybe<UnidadesPrecosFlexiveis_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UnidadesPrecosFlexiveis_Var_Samp_Order_By>;
  variance?: InputMaybe<UnidadesPrecosFlexiveis_Variance_Order_By>;
};

/** aggregate avg on columns */
export type UnidadesPrecosFlexiveis_Avg_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_avg_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
  taxaCancelamento?: Maybe<Scalars['Float']['output']>;
  taxaDesconto?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Avg_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUnidadesPrecosFlexiveis". All fields are combined with a logical 'AND'. */
export type UnidadesPrecosFlexiveis_Bool_Exp = {
  TiposSala?: InputMaybe<TiposSalas_Bool_Exp>;
  Unidade?: InputMaybe<Unidades_Bool_Exp>;
  UnidadesPrecosFlexiveisParceirosIntegracoes?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp>;
  _and?: InputMaybe<Array<UnidadesPrecosFlexiveis_Bool_Exp>>;
  _not?: InputMaybe<UnidadesPrecosFlexiveis_Bool_Exp>;
  _or?: InputMaybe<Array<UnidadesPrecosFlexiveis_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codTipoSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadePrecoFlexivel?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  taxaCancelamento?: InputMaybe<Float_Mssql_Comparison_Exp>;
  taxaDesconto?: InputMaybe<Float_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type UnidadesPrecosFlexiveis_Max_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_max_fields';
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['datetime2']['output']>;
  taxaCancelamento?: Maybe<Scalars['Float']['output']>;
  taxaDesconto?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Max_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UnidadesPrecosFlexiveis_Min_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_min_fields';
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['datetime2']['output']>;
  taxaCancelamento?: Maybe<Scalars['Float']['output']>;
  taxaDesconto?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Min_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUnidadesPrecosFlexiveis". */
export type UnidadesPrecosFlexiveis_Order_By = {
  TiposSala?: InputMaybe<TiposSalas_Order_By>;
  Unidade?: InputMaybe<Unidades_Order_By>;
  UnidadesPrecosFlexiveisParceirosIntegracoes_aggregate?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Aggregate_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** select columns of table "tbUnidadesPrecosFlexiveis" */
export enum UnidadesPrecosFlexiveis_Select_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  CodTipoSala = 'codTipoSala',
  /** column name */
  CodUnidade = 'codUnidade',
  /** column name */
  CodUnidadePrecoFlexivel = 'codUnidadePrecoFlexivel',
  /** column name */
  DataCadastro = 'dataCadastro',
  /** column name */
  TaxaCancelamento = 'taxaCancelamento',
  /** column name */
  TaxaDesconto = 'taxaDesconto'
}

/** aggregate stddev on columns */
export type UnidadesPrecosFlexiveis_Stddev_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_stddev_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
  taxaCancelamento?: Maybe<Scalars['Float']['output']>;
  taxaDesconto?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Stddev_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UnidadesPrecosFlexiveis_Stddev_Pop_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_stddev_pop_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
  taxaCancelamento?: Maybe<Scalars['Float']['output']>;
  taxaDesconto?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Stddev_Pop_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UnidadesPrecosFlexiveis_Stddev_Samp_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_stddev_samp_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
  taxaCancelamento?: Maybe<Scalars['Float']['output']>;
  taxaDesconto?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Stddev_Samp_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type UnidadesPrecosFlexiveis_Sum_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_sum_fields';
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Int']['output']>;
  taxaCancelamento?: Maybe<Scalars['Float']['output']>;
  taxaDesconto?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Sum_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type UnidadesPrecosFlexiveis_Var_Pop_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_var_pop_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
  taxaCancelamento?: Maybe<Scalars['Float']['output']>;
  taxaDesconto?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Var_Pop_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UnidadesPrecosFlexiveis_Var_Samp_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_var_samp_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
  taxaCancelamento?: Maybe<Scalars['Float']['output']>;
  taxaDesconto?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Var_Samp_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UnidadesPrecosFlexiveis_Variance_Fields = {
  __typename?: 'UnidadesPrecosFlexiveis_variance_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadePrecoFlexivel?: Maybe<Scalars['Float']['output']>;
  taxaCancelamento?: Maybe<Scalars['Float']['output']>;
  taxaDesconto?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbUnidadesPrecosFlexiveis" */
export type UnidadesPrecosFlexiveis_Variance_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePrecoFlexivel?: InputMaybe<Order_By>;
  taxaCancelamento?: InputMaybe<Order_By>;
  taxaDesconto?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUnidadesSalasMotivosBloqueios" */
export type UnidadesSalasMotivosBloqueios = {
  __typename?: 'UnidadesSalasMotivosBloqueios';
  ativo: Scalars['Boolean']['output'];
  codUnidadeSalaMotivoBloqueio: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  nome: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "tbUnidadesSalasMotivosBloqueios". All fields are combined with a logical 'AND'. */
export type UnidadesSalasMotivosBloqueios_Bool_Exp = {
  _and?: InputMaybe<Array<UnidadesSalasMotivosBloqueios_Bool_Exp>>;
  _not?: InputMaybe<UnidadesSalasMotivosBloqueios_Bool_Exp>;
  _or?: InputMaybe<Array<UnidadesSalasMotivosBloqueios_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codUnidadeSalaMotivoBloqueio?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  descricao?: InputMaybe<String_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbUnidadesSalasMotivosBloqueios". */
export type UnidadesSalasMotivosBloqueios_Order_By = {
  ativo?: InputMaybe<Order_By>;
  codUnidadeSalaMotivoBloqueio?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

export type UpdateProfessionalInfoInput = {
  councilInitials: Scalars['String']['input'];
  councilState: Scalars['String']['input'];
  profession: Scalars['String']['input'];
  professionalIdNumber: Scalars['String']['input'];
  specialty: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type UpdateReturnPoliciesInput = {
  op: Scalars['String']['input'];
  path: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
  value: Scalars['Int']['input'];
};

export type UploadProfessionalCardInput = {
  base64string: Scalars['String']['input'];
  documentSide: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UploadProfessionalCardOutput = {
  __typename?: 'UploadProfessionalCardOutput';
  filePath: Scalars['String']['output'];
};

export type UsuarioAcaoBloqueadaViewModel = {
  __typename?: 'UsuarioAcaoBloqueadaViewModel';
  ativo: Scalars['Boolean']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioAcao: CodUsuarioAcao;
  codUsuarioAcaoBloqueada: Scalars['Int']['output'];
  razao?: Maybe<Scalars['String']['output']>;
};

export type UsuarioAgendaCompromisso = {
  ativo: Scalars['Boolean']['input'];
  codUsuarioAgenda: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
};

export type UsuarioAgendaDiaSemana = {
  ativo: Scalars['Boolean']['input'];
  codUsuarioAgenda: Scalars['Int']['input'];
  diaSemana: Scalars['Int']['input'];
};

export type UsuarioAgendaUnidade = {
  ativo: Scalars['Boolean']['input'];
  codUnidade: Scalars['Int']['input'];
  codUsuarioAgenda: Scalars['Int']['input'];
};

export type UsuarioCompromissoCanalAgendamentoInput = {
  codCanalAgendamento: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
};

export type UsuarioCompromissoFormaDeRecebimentoCriacaoInput = {
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
};

export type UsuarioCompromissoTipoSalaCriacaoInput = {
  codTipoSala: Scalars['Int']['input'];
  prioridade: Scalars['Int']['input'];
};

export type UsuarioFormaRecebimentoInput = {
  categoria?: InputMaybe<Scalars['Int']['input']>;
  codParceiroIntegracao?: InputMaybe<Scalars['Int']['input']>;
  codTipoConvenio?: InputMaybe<Scalars['Int']['input']>;
  codTipoFormaRecebimento: Scalars['Int']['input'];
  codTipoPlano?: InputMaybe<Scalars['Int']['input']>;
  codUsuario: Scalars['Int']['input'];
  nomeConvenio?: InputMaybe<Scalars['String']['input']>;
  sistema?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "tbUsuariosArquivos" */
export type UsuariosArquivos = {
  __typename?: 'UsuariosArquivos';
  /** An object relationship */
  Usuario: Usuarios;
  arquivoUrl?: Maybe<Scalars['String']['output']>;
  codTipoArquivo: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioArquivo: Scalars['Int']['output'];
  dataCadastro: Scalars['smalldatetime']['output'];
  mimetype: Scalars['String']['output'];
};

/** order by aggregate values of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosArquivos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosArquivos_Max_Order_By>;
  min?: InputMaybe<UsuariosArquivos_Min_Order_By>;
  stddev?: InputMaybe<UsuariosArquivos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosArquivos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosArquivos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosArquivos_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosArquivos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosArquivos_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosArquivos_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Avg_Order_By = {
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosArquivos". All fields are combined with a logical 'AND'. */
export type UsuariosArquivos_Bool_Exp = {
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosArquivos_Bool_Exp>>;
  _not?: InputMaybe<UsuariosArquivos_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosArquivos_Bool_Exp>>;
  arquivoUrl?: InputMaybe<String_Mssql_Comparison_Exp>;
  codTipoArquivo?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioArquivo?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Smalldatetime_Mssql_Comparison_Exp>;
  mimetype?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Max_Order_By = {
  arquivoUrl?: InputMaybe<Order_By>;
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  mimetype?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Min_Order_By = {
  arquivoUrl?: InputMaybe<Order_By>;
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  mimetype?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosArquivos". */
export type UsuariosArquivos_Order_By = {
  Usuario?: InputMaybe<Usuarios_Order_By>;
  arquivoUrl?: InputMaybe<Order_By>;
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  mimetype?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Stddev_Order_By = {
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Stddev_Pop_Order_By = {
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Stddev_Samp_Order_By = {
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Sum_Order_By = {
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Var_Pop_Order_By = {
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Var_Samp_Order_By = {
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosArquivos" */
export type UsuariosArquivos_Variance_Order_By = {
  codTipoArquivo?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioArquivo?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosCompromissosStatusSugestoesDuracoes" */
export type UsuariosCompromissosStatusSugestoesDuracoes = {
  __typename?: 'UsuariosCompromissosStatusSugestoesDuracoes';
  /** An object relationship */
  UsuariosCompromisso: UsuariosCompromissos;
  codUsuarioCompromisso: Scalars['Int']['output'];
  codUsuarioCompromissoTiposStatusSugestaoDuracao: Scalars['Int']['output'];
  dataUltimaAtualizacao: Scalars['datetime2']['output'];
};

/** Boolean expression to filter rows from the table "tbUsuariosCompromissosStatusSugestoesDuracoes". All fields are combined with a logical 'AND'. */
export type UsuariosCompromissosStatusSugestoesDuracoes_Bool_Exp = {
  UsuariosCompromisso?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosCompromissosStatusSugestoesDuracoes_Bool_Exp>>;
  _not?: InputMaybe<UsuariosCompromissosStatusSugestoesDuracoes_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosCompromissosStatusSugestoesDuracoes_Bool_Exp>>;
  codUsuarioCompromisso?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioCompromissoTiposStatusSugestaoDuracao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataUltimaAtualizacao?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
};

/** upsert condition type for table "tbUsuariosCompromissosStatusSugestoesDuracoes" */
export type UsuariosCompromissosStatusSugestoesDuracoes_If_Matched = {
  match_columns?: Array<UsuariosCompromissosStatusSugestoesDuracoes_Insert_Match_Column>;
  update_columns?: Array<UsuariosCompromissosStatusSugestoesDuracoes_Update_Column>;
  where?: InputMaybe<UsuariosCompromissosStatusSugestoesDuracoes_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "tbUsuariosCompromissosStatusSugestoesDuracoes" */
export type UsuariosCompromissosStatusSugestoesDuracoes_Inc_Input = {
  codUsuarioCompromissoTiposStatusSugestaoDuracao?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "tbUsuariosCompromissosStatusSugestoesDuracoes" */
export type UsuariosCompromissosStatusSugestoesDuracoes_Insert_Input = {
  codUsuarioCompromisso?: InputMaybe<Scalars['Int']['input']>;
  codUsuarioCompromissoTiposStatusSugestaoDuracao?: InputMaybe<Scalars['Int']['input']>;
  dataUltimaAtualizacao?: InputMaybe<Scalars['datetime2']['input']>;
};

/** select match_columns of table "tbUsuariosCompromissosStatusSugestoesDuracoes" */
export enum UsuariosCompromissosStatusSugestoesDuracoes_Insert_Match_Column {
  /** column name */
  CodUsuarioCompromisso = 'codUsuarioCompromisso',
  /** column name */
  CodUsuarioCompromissoTiposStatusSugestaoDuracao = 'codUsuarioCompromissoTiposStatusSugestaoDuracao',
  /** column name */
  DataUltimaAtualizacao = 'dataUltimaAtualizacao'
}

/** response of any mutation on the table "tbUsuariosCompromissosStatusSugestoesDuracoes" */
export type UsuariosCompromissosStatusSugestoesDuracoes_Mutation_Response = {
  __typename?: 'UsuariosCompromissosStatusSugestoesDuracoes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UsuariosCompromissosStatusSugestoesDuracoes>;
};

/** Ordering options when selecting data from "tbUsuariosCompromissosStatusSugestoesDuracoes". */
export type UsuariosCompromissosStatusSugestoesDuracoes_Order_By = {
  UsuariosCompromisso?: InputMaybe<UsuariosCompromissos_Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoTiposStatusSugestaoDuracao?: InputMaybe<Order_By>;
  dataUltimaAtualizacao?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tbUsuariosCompromissosStatusSugestoesDuracoes */
export type UsuariosCompromissosStatusSugestoesDuracoes_Pk_Columns_Input = {
  codUsuarioCompromisso: Scalars['Int']['input'];
};

/** input type for updating data in table "tbUsuariosCompromissosStatusSugestoesDuracoes" */
export type UsuariosCompromissosStatusSugestoesDuracoes_Set_Input = {
  codUsuarioCompromissoTiposStatusSugestaoDuracao?: InputMaybe<Scalars['Int']['input']>;
  dataUltimaAtualizacao?: InputMaybe<Scalars['datetime2']['input']>;
};

/** update columns of table "tbUsuariosCompromissosStatusSugestoesDuracoes" */
export enum UsuariosCompromissosStatusSugestoesDuracoes_Update_Column {
  /** column name */
  CodUsuarioCompromissoTiposStatusSugestaoDuracao = 'codUsuarioCompromissoTiposStatusSugestaoDuracao',
  /** column name */
  DataUltimaAtualizacao = 'dataUltimaAtualizacao'
}

export type ValidateCepInput = {
  cep: Scalars['String']['input'];
};

export type ValidateCepOutput = {
  __typename?: 'ValidateCEPOutput';
  cep?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['json']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type ValidateCnpjInput = {
  cnpj: Scalars['String']['input'];
};

export type ValidateCnpjOutput = {
  __typename?: 'ValidateCNPJOutput';
  razao_social: Scalars['String']['output'];
};

export type ValidationError = Error & {
  __typename?: 'ValidationError';
  message: Scalars['String']['output'];
  statusCode: HttpStatusCode;
};

export type VirtualNewSalesVisitAvailability = {
  __typename?: 'VirtualNewSalesVisitAvailability';
  appointmentTypeId?: Maybe<Scalars['Int']['output']>;
  end?: Maybe<Scalars['String']['output']>;
  groupVisitScheduleId?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['String']['output']>;
};

export type VirtualNewSalesVisitAvailabilityInput = {
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  startingDate: Scalars['String']['input'];
  stepSizeInMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type VirtualSalesVisitAvailability = {
  __typename?: 'VirtualSalesVisitAvailability';
  date?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Array<Maybe<Slot>>>;
};

export type VirtualSalesVisitAvailabilityInput = {
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  endingDate: Scalars['String']['input'];
  startingDate: Scalars['String']['input'];
  stepSizeInMinutes?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "tbAgendamentos" */
export type Agendamentos = {
  __typename?: 'agendamentos';
  /** An array relationship */
  AgendamentoAlocacao: Array<AgendamentosAlocacoes>;
  /** An aggregate relationship */
  AgendamentoAlocacao_aggregate: AgendamentosAlocacoes_Aggregate;
  /** An array relationship */
  AgendamentoPreAlocacao: Array<AgendamentosPreAlocacao>;
  /** An aggregate relationship */
  AgendamentoPreAlocacao_aggregate: AgendamentosPreAlocacao_Aggregate;
  /** An array relationship */
  Agendamentos: Array<Agendamentos>;
  /** An array relationship */
  AgendamentosAlocacoesAtivas: Array<AgendamentosAlocacoesAtivas>;
  /** An object relationship */
  AgendamentosCheckin?: Maybe<TbAgendamentosCheckins>;
  /** An array relationship */
  AgendamentosVinculados: Array<TbAgendamentosVinculados>;
  /** An aggregate relationship */
  Agendamentos_aggregate: Agendamentos_Aggregate;
  /** An array relationship */
  Fechamentos: Array<TbFechamentos>;
  /** An object relationship */
  FinalidadesAgendamento: FinalidadesAgendamentos;
  /** An object relationship */
  Paciente?: Maybe<Pacientes>;
  /** An object relationship */
  Unidade: Unidades;
  /** An object relationship */
  Usuario?: Maybe<Usuarios>;
  /** An object relationship */
  UsuarioAuditoria?: Maybe<Usuarios>;
  /** An object relationship */
  UsuarioCompromisso?: Maybe<UsuariosCompromissos>;
  /** An object relationship */
  UsuarioProfissional: UsuariosProfissionais;
  /** An object relationship */
  UsuariosAgenda?: Maybe<UsuariosAgendas>;
  /** An object relationship */
  UsuariosFormasRecebimento: UsuariosFormasRecebimentos;
  cancelado: Scalars['Boolean']['output'];
  cobraCancelamento: Scalars['Boolean']['output'];
  cobrancaStatus?: Maybe<Scalars['String']['output']>;
  cobrancaTotemId?: Maybe<Scalars['uniqueidentifier']['output']>;
  codAgendamento: Scalars['Int']['output'];
  codAgendamentoGuid: Scalars['uniqueidentifier']['output'];
  codAgendamentoOrigem?: Maybe<Scalars['Int']['output']>;
  codFinalidadeAgendamento: Scalars['Int']['output'];
  codPaciente?: Maybe<Scalars['Int']['output']>;
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  codUnidade: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioAgenda?: Maybe<Scalars['Int']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso: Scalars['Int']['output'];
  codUsuarioFormaRecebimento: Scalars['Int']['output'];
  confirmaCancelamento: Scalars['Boolean']['output'];
  confirmado: Scalars['Boolean']['output'];
  data: Scalars['date']['output'];
  dataCadastro: Scalars['datetime']['output'];
  dataCancelamento?: Maybe<Scalars['datetime']['output']>;
  dataCienciaCancelamento?: Maybe<Scalars['datetime']['output']>;
  dataNascimento?: Maybe<Scalars['date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmaCancelamentoEnviado?: Maybe<Scalars['Boolean']['output']>;
  eventual: Scalars['Boolean']['output'];
  fechaCancelamento: Scalars['Boolean']['output'];
  horaFim: Scalars['time']['output'];
  horaInicio: Scalars['time']['output'];
  ignorarEnvioEmail: Scalars['Boolean']['output'];
  ignorarEnvioWhatsApp: Scalars['Boolean']['output'];
  /** An array relationship */
  lembretes: Array<Lembretes>;
  /** An aggregate relationship */
  lembretes_aggregate: Lembretes_Aggregate;
  meioPagamento?: Maybe<Scalars['String']['output']>;
  motivoCancelamento?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  nomeConvenio?: Maybe<Scalars['String']['output']>;
  nomePlano?: Maybe<Scalars['String']['output']>;
  notaAtendimento?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  notificacoesPacientesAtrasados: Array<NotificacoesPacientesAtrasados>;
  numeroCarteirinha?: Maybe<Scalars['String']['output']>;
  onlinePayments: Array<Expensum_Online_Payment>;
  onlinePayments_aggregate: Expensum_Online_Payment_Aggregate;
  pagamento?: Maybe<Expensum_Appointment_Paid>;
  pagar: Scalars['Boolean']['output'];
  pago: Scalars['Boolean']['output'];
  /** An array relationship */
  tags: Array<AgendamentosTags>;
  /** An array relationship */
  tbPeriodosGarantidos: Array<TbPeriodosGarantidos>;
  /** An aggregate relationship */
  tbPeriodosGarantidos_aggregate: TbPeriodosGarantidos_Aggregate;
  telefone: Scalars['String']['output'];
  telefoneProprio: Scalars['Boolean']['output'];
  validadeCarteirinha?: Maybe<Scalars['date']['output']>;
  valor: Scalars['Float']['output'];
  whatsAppConfirmacaoEnviado: Scalars['Boolean']['output'];
  whatsAppSegundaConfirmacaoEnviada: Scalars['Boolean']['output'];
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosAgendamentoAlocacaoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosAlocacoes_Order_By>>;
  where?: InputMaybe<AgendamentosAlocacoes_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosAgendamentoAlocacao_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosAlocacoes_Order_By>>;
  where?: InputMaybe<AgendamentosAlocacoes_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosAgendamentoPreAlocacaoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosPreAlocacao_Order_By>>;
  where?: InputMaybe<AgendamentosPreAlocacao_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosAgendamentoPreAlocacao_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosPreAlocacao_Order_By>>;
  where?: InputMaybe<AgendamentosPreAlocacao_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosAgendamentosAlocacoesAtivasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosAlocacoesAtivas_Order_By>>;
  where?: InputMaybe<AgendamentosAlocacoesAtivas_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosAgendamentosVinculadosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbAgendamentosVinculados_Order_By>>;
  where?: InputMaybe<TbAgendamentosVinculados_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosAgendamentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosFechamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbFechamentos_Order_By>>;
  where?: InputMaybe<TbFechamentos_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosLembretesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lembretes_Order_By>>;
  where?: InputMaybe<Lembretes_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosLembretes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lembretes_Order_By>>;
  where?: InputMaybe<Lembretes_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosNotificacoesPacientesAtrasadosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificacoesPacientesAtrasados_Order_By>>;
  where?: InputMaybe<NotificacoesPacientesAtrasados_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosOnlinePaymentsArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosOnlinePayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosTags_Order_By>>;
  where?: InputMaybe<AgendamentosTags_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosTbPeriodosGarantidosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidos_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentos" */
export type AgendamentosTbPeriodosGarantidos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidos_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
};

/** columns and relationships of "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes = {
  __typename?: 'agendamentosAlocacoes';
  /** An object relationship */
  Agendamento: Agendamentos;
  /** An object relationship */
  UnidadeSala: UnidadesSalas;
  codAgendamento: Scalars['Int']['output'];
  codUnidadeSala: Scalars['Int']['output'];
  data: Scalars['date']['output'];
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
  horaFim?: Maybe<Scalars['time']['output']>;
  horaInicio: Scalars['time']['output'];
};

/** aggregated selection of "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Aggregate = {
  __typename?: 'agendamentosAlocacoes_aggregate';
  aggregate?: Maybe<AgendamentosAlocacoes_Aggregate_Fields>;
  nodes: Array<AgendamentosAlocacoes>;
};

/** aggregate fields of "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Aggregate_Fields = {
  __typename?: 'agendamentosAlocacoes_aggregate_fields';
  avg?: Maybe<AgendamentosAlocacoes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AgendamentosAlocacoes_Max_Fields>;
  min?: Maybe<AgendamentosAlocacoes_Min_Fields>;
  stddev?: Maybe<AgendamentosAlocacoes_Stddev_Fields>;
  stddev_pop?: Maybe<AgendamentosAlocacoes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AgendamentosAlocacoes_Stddev_Samp_Fields>;
  sum?: Maybe<AgendamentosAlocacoes_Sum_Fields>;
  var_pop?: Maybe<AgendamentosAlocacoes_Var_Pop_Fields>;
  var_samp?: Maybe<AgendamentosAlocacoes_Var_Samp_Fields>;
  variance?: Maybe<AgendamentosAlocacoes_Variance_Fields>;
};


/** aggregate fields of "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<AgendamentosAlocacoes_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Aggregate_Order_By = {
  avg?: InputMaybe<AgendamentosAlocacoes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AgendamentosAlocacoes_Max_Order_By>;
  min?: InputMaybe<AgendamentosAlocacoes_Min_Order_By>;
  stddev?: InputMaybe<AgendamentosAlocacoes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AgendamentosAlocacoes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AgendamentosAlocacoes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AgendamentosAlocacoes_Sum_Order_By>;
  var_pop?: InputMaybe<AgendamentosAlocacoes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AgendamentosAlocacoes_Var_Samp_Order_By>;
  variance?: InputMaybe<AgendamentosAlocacoes_Variance_Order_By>;
};

/** aggregate avg on columns */
export type AgendamentosAlocacoes_Avg_Fields = {
  __typename?: 'agendamentosAlocacoes_avg_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Avg_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbAgendamentosAlocacoes". All fields are combined with a logical 'AND'. */
export type AgendamentosAlocacoes_Bool_Exp = {
  Agendamento?: InputMaybe<Agendamentos_Bool_Exp>;
  UnidadeSala?: InputMaybe<UnidadesSalas_Bool_Exp>;
  _and?: InputMaybe<Array<AgendamentosAlocacoes_Bool_Exp>>;
  _not?: InputMaybe<AgendamentosAlocacoes_Bool_Exp>;
  _or?: InputMaybe<Array<AgendamentosAlocacoes_Bool_Exp>>;
  codAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadeSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  data?: InputMaybe<Date_Mssql_Comparison_Exp>;
  duracaoEmMinutos?: InputMaybe<Float_Mssql_Comparison_Exp>;
  horaFim?: InputMaybe<Time_Mssql_Comparison_Exp>;
  horaInicio?: InputMaybe<Time_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type AgendamentosAlocacoes_Max_Fields = {
  __typename?: 'agendamentosAlocacoes_max_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['date']['output']>;
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
  horaFim?: Maybe<Scalars['time']['output']>;
  horaInicio?: Maybe<Scalars['time']['output']>;
};

/** order by max() on columns of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Max_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AgendamentosAlocacoes_Min_Fields = {
  __typename?: 'agendamentosAlocacoes_min_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['date']['output']>;
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
  horaFim?: Maybe<Scalars['time']['output']>;
  horaInicio?: Maybe<Scalars['time']['output']>;
};

/** order by min() on columns of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Min_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbAgendamentosAlocacoes". */
export type AgendamentosAlocacoes_Order_By = {
  Agendamento?: InputMaybe<Agendamentos_Order_By>;
  UnidadeSala?: InputMaybe<UnidadesSalas_Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
};

/** select columns of table "tbAgendamentosAlocacoes" */
export enum AgendamentosAlocacoes_Select_Column {
  /** column name */
  CodAgendamento = 'codAgendamento',
  /** column name */
  CodUnidadeSala = 'codUnidadeSala',
  /** column name */
  Data = 'data',
  /** column name */
  DuracaoEmMinutos = 'duracaoEmMinutos',
  /** column name */
  HoraFim = 'horaFim',
  /** column name */
  HoraInicio = 'horaInicio'
}

/** aggregate stddev on columns */
export type AgendamentosAlocacoes_Stddev_Fields = {
  __typename?: 'agendamentosAlocacoes_stddev_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Stddev_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AgendamentosAlocacoes_Stddev_Pop_Fields = {
  __typename?: 'agendamentosAlocacoes_stddev_pop_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Stddev_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AgendamentosAlocacoes_Stddev_Samp_Fields = {
  __typename?: 'agendamentosAlocacoes_stddev_samp_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Stddev_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type AgendamentosAlocacoes_Sum_Fields = {
  __typename?: 'agendamentosAlocacoes_sum_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Sum_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type AgendamentosAlocacoes_Var_Pop_Fields = {
  __typename?: 'agendamentosAlocacoes_var_pop_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Var_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AgendamentosAlocacoes_Var_Samp_Fields = {
  __typename?: 'agendamentosAlocacoes_var_samp_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Var_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AgendamentosAlocacoes_Variance_Fields = {
  __typename?: 'agendamentosAlocacoes_variance_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  duracaoEmMinutos?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbAgendamentosAlocacoes" */
export type AgendamentosAlocacoes_Variance_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  duracaoEmMinutos?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao = {
  __typename?: 'agendamentosPreAlocacao';
  /** An object relationship */
  Agendamento: Agendamentos;
  /** An object relationship */
  UnidadeSala?: Maybe<UnidadesSalas>;
  codAgendamento: Scalars['Int']['output'];
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  data: Scalars['datetime2']['output'];
  horaFimPrevisto: Scalars['time']['output'];
  horaFimTeorico: Scalars['time']['output'];
  horaInicio: Scalars['time']['output'];
};

/** aggregated selection of "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Aggregate = {
  __typename?: 'agendamentosPreAlocacao_aggregate';
  aggregate?: Maybe<AgendamentosPreAlocacao_Aggregate_Fields>;
  nodes: Array<AgendamentosPreAlocacao>;
};

/** aggregate fields of "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Aggregate_Fields = {
  __typename?: 'agendamentosPreAlocacao_aggregate_fields';
  avg?: Maybe<AgendamentosPreAlocacao_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AgendamentosPreAlocacao_Max_Fields>;
  min?: Maybe<AgendamentosPreAlocacao_Min_Fields>;
  stddev?: Maybe<AgendamentosPreAlocacao_Stddev_Fields>;
  stddev_pop?: Maybe<AgendamentosPreAlocacao_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AgendamentosPreAlocacao_Stddev_Samp_Fields>;
  sum?: Maybe<AgendamentosPreAlocacao_Sum_Fields>;
  var_pop?: Maybe<AgendamentosPreAlocacao_Var_Pop_Fields>;
  var_samp?: Maybe<AgendamentosPreAlocacao_Var_Samp_Fields>;
  variance?: Maybe<AgendamentosPreAlocacao_Variance_Fields>;
};


/** aggregate fields of "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<AgendamentosPreAlocacao_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Aggregate_Order_By = {
  avg?: InputMaybe<AgendamentosPreAlocacao_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AgendamentosPreAlocacao_Max_Order_By>;
  min?: InputMaybe<AgendamentosPreAlocacao_Min_Order_By>;
  stddev?: InputMaybe<AgendamentosPreAlocacao_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AgendamentosPreAlocacao_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AgendamentosPreAlocacao_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AgendamentosPreAlocacao_Sum_Order_By>;
  var_pop?: InputMaybe<AgendamentosPreAlocacao_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AgendamentosPreAlocacao_Var_Samp_Order_By>;
  variance?: InputMaybe<AgendamentosPreAlocacao_Variance_Order_By>;
};

/** aggregate avg on columns */
export type AgendamentosPreAlocacao_Avg_Fields = {
  __typename?: 'agendamentosPreAlocacao_avg_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Avg_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbAgendamentosPreAlocacao". All fields are combined with a logical 'AND'. */
export type AgendamentosPreAlocacao_Bool_Exp = {
  Agendamento?: InputMaybe<Agendamentos_Bool_Exp>;
  UnidadeSala?: InputMaybe<UnidadesSalas_Bool_Exp>;
  _and?: InputMaybe<Array<AgendamentosPreAlocacao_Bool_Exp>>;
  _not?: InputMaybe<AgendamentosPreAlocacao_Bool_Exp>;
  _or?: InputMaybe<Array<AgendamentosPreAlocacao_Bool_Exp>>;
  codAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadeSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  data?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  horaFimPrevisto?: InputMaybe<Time_Mssql_Comparison_Exp>;
  horaFimTeorico?: InputMaybe<Time_Mssql_Comparison_Exp>;
  horaInicio?: InputMaybe<Time_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type AgendamentosPreAlocacao_Max_Fields = {
  __typename?: 'agendamentosPreAlocacao_max_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['datetime2']['output']>;
  horaFimPrevisto?: Maybe<Scalars['time']['output']>;
  horaFimTeorico?: Maybe<Scalars['time']['output']>;
  horaInicio?: Maybe<Scalars['time']['output']>;
};

/** order by max() on columns of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Max_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  horaFimPrevisto?: InputMaybe<Order_By>;
  horaFimTeorico?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AgendamentosPreAlocacao_Min_Fields = {
  __typename?: 'agendamentosPreAlocacao_min_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['datetime2']['output']>;
  horaFimPrevisto?: Maybe<Scalars['time']['output']>;
  horaFimTeorico?: Maybe<Scalars['time']['output']>;
  horaInicio?: Maybe<Scalars['time']['output']>;
};

/** order by min() on columns of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Min_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  horaFimPrevisto?: InputMaybe<Order_By>;
  horaFimTeorico?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbAgendamentosPreAlocacao". */
export type AgendamentosPreAlocacao_Order_By = {
  Agendamento?: InputMaybe<Agendamentos_Order_By>;
  UnidadeSala?: InputMaybe<UnidadesSalas_Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  horaFimPrevisto?: InputMaybe<Order_By>;
  horaFimTeorico?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
};

/** select columns of table "tbAgendamentosPreAlocacao" */
export enum AgendamentosPreAlocacao_Select_Column {
  /** column name */
  CodAgendamento = 'codAgendamento',
  /** column name */
  CodUnidadeSala = 'codUnidadeSala',
  /** column name */
  Data = 'data',
  /** column name */
  HoraFimPrevisto = 'horaFimPrevisto',
  /** column name */
  HoraFimTeorico = 'horaFimTeorico',
  /** column name */
  HoraInicio = 'horaInicio'
}

/** aggregate stddev on columns */
export type AgendamentosPreAlocacao_Stddev_Fields = {
  __typename?: 'agendamentosPreAlocacao_stddev_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Stddev_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AgendamentosPreAlocacao_Stddev_Pop_Fields = {
  __typename?: 'agendamentosPreAlocacao_stddev_pop_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Stddev_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AgendamentosPreAlocacao_Stddev_Samp_Fields = {
  __typename?: 'agendamentosPreAlocacao_stddev_samp_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Stddev_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type AgendamentosPreAlocacao_Sum_Fields = {
  __typename?: 'agendamentosPreAlocacao_sum_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Sum_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type AgendamentosPreAlocacao_Var_Pop_Fields = {
  __typename?: 'agendamentosPreAlocacao_var_pop_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Var_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AgendamentosPreAlocacao_Var_Samp_Fields = {
  __typename?: 'agendamentosPreAlocacao_var_samp_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Var_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AgendamentosPreAlocacao_Variance_Fields = {
  __typename?: 'agendamentosPreAlocacao_variance_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbAgendamentosPreAlocacao" */
export type AgendamentosPreAlocacao_Variance_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbAgendamentosTags" */
export type AgendamentosTags = {
  __typename?: 'agendamentosTags';
  /** An object relationship */
  agendamento: Agendamentos;
  /** An object relationship */
  agendamentosTiposTag: AgendamentosTiposTags;
  codAgendamento: Scalars['Int']['output'];
  codAgendamentoTipoTag: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
};

/** order by aggregate values of table "tbAgendamentosTags" */
export type AgendamentosTags_Aggregate_Order_By = {
  avg?: InputMaybe<AgendamentosTags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AgendamentosTags_Max_Order_By>;
  min?: InputMaybe<AgendamentosTags_Min_Order_By>;
  stddev?: InputMaybe<AgendamentosTags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AgendamentosTags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AgendamentosTags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AgendamentosTags_Sum_Order_By>;
  var_pop?: InputMaybe<AgendamentosTags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AgendamentosTags_Var_Samp_Order_By>;
  variance?: InputMaybe<AgendamentosTags_Variance_Order_By>;
};

/** order by avg() on columns of table "tbAgendamentosTags" */
export type AgendamentosTags_Avg_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbAgendamentosTags". All fields are combined with a logical 'AND'. */
export type AgendamentosTags_Bool_Exp = {
  _and?: InputMaybe<Array<AgendamentosTags_Bool_Exp>>;
  _not?: InputMaybe<AgendamentosTags_Bool_Exp>;
  _or?: InputMaybe<Array<AgendamentosTags_Bool_Exp>>;
  agendamento?: InputMaybe<Agendamentos_Bool_Exp>;
  agendamentosTiposTag?: InputMaybe<AgendamentosTiposTags_Bool_Exp>;
  codAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codAgendamentoTipoTag?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbAgendamentosTags" */
export type AgendamentosTags_Max_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbAgendamentosTags" */
export type AgendamentosTags_Min_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbAgendamentosTags". */
export type AgendamentosTags_Order_By = {
  agendamento?: InputMaybe<Agendamentos_Order_By>;
  agendamentosTiposTag?: InputMaybe<AgendamentosTiposTags_Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbAgendamentosTags" */
export type AgendamentosTags_Stddev_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbAgendamentosTags" */
export type AgendamentosTags_Stddev_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbAgendamentosTags" */
export type AgendamentosTags_Stddev_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbAgendamentosTags" */
export type AgendamentosTags_Sum_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbAgendamentosTags" */
export type AgendamentosTags_Var_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbAgendamentosTags" */
export type AgendamentosTags_Var_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbAgendamentosTags" */
export type AgendamentosTags_Variance_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbAgendamentosTiposTags" */
export type AgendamentosTiposTags = {
  __typename?: 'agendamentosTiposTags';
  /** An array relationship */
  agendamentosTags: Array<AgendamentosTags>;
  codAgendamentoTipoTag: Scalars['Int']['output'];
  nome?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "tbAgendamentosTiposTags" */
export type AgendamentosTiposTagsAgendamentosTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosTags_Order_By>>;
  where?: InputMaybe<AgendamentosTags_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tbAgendamentosTiposTags". All fields are combined with a logical 'AND'. */
export type AgendamentosTiposTags_Bool_Exp = {
  _and?: InputMaybe<Array<AgendamentosTiposTags_Bool_Exp>>;
  _not?: InputMaybe<AgendamentosTiposTags_Bool_Exp>;
  _or?: InputMaybe<Array<AgendamentosTiposTags_Bool_Exp>>;
  agendamentosTags?: InputMaybe<AgendamentosTags_Bool_Exp>;
  codAgendamentoTipoTag?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbAgendamentosTiposTags". */
export type AgendamentosTiposTags_Order_By = {
  agendamentosTags_aggregate?: InputMaybe<AgendamentosTags_Aggregate_Order_By>;
  codAgendamentoTipoTag?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** aggregated selection of "tbAgendamentos" */
export type Agendamentos_Aggregate = {
  __typename?: 'agendamentos_aggregate';
  aggregate?: Maybe<Agendamentos_Aggregate_Fields>;
  nodes: Array<Agendamentos>;
};

/** aggregate fields of "tbAgendamentos" */
export type Agendamentos_Aggregate_Fields = {
  __typename?: 'agendamentos_aggregate_fields';
  avg?: Maybe<Agendamentos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Agendamentos_Max_Fields>;
  min?: Maybe<Agendamentos_Min_Fields>;
  stddev?: Maybe<Agendamentos_Stddev_Fields>;
  stddev_pop?: Maybe<Agendamentos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agendamentos_Stddev_Samp_Fields>;
  sum?: Maybe<Agendamentos_Sum_Fields>;
  var_pop?: Maybe<Agendamentos_Var_Pop_Fields>;
  var_samp?: Maybe<Agendamentos_Var_Samp_Fields>;
  variance?: Maybe<Agendamentos_Variance_Fields>;
};


/** aggregate fields of "tbAgendamentos" */
export type Agendamentos_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Agendamentos_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbAgendamentos" */
export type Agendamentos_Aggregate_Order_By = {
  avg?: InputMaybe<Agendamentos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agendamentos_Max_Order_By>;
  min?: InputMaybe<Agendamentos_Min_Order_By>;
  stddev?: InputMaybe<Agendamentos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agendamentos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agendamentos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agendamentos_Sum_Order_By>;
  var_pop?: InputMaybe<Agendamentos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agendamentos_Var_Samp_Order_By>;
  variance?: InputMaybe<Agendamentos_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Agendamentos_Avg_Fields = {
  __typename?: 'agendamentos_avg_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOrigem?: Maybe<Scalars['Float']['output']>;
  codFinalidadeAgendamento?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Float']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  notaAtendimento?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbAgendamentos" */
export type Agendamentos_Avg_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbAgendamentos". All fields are combined with a logical 'AND'. */
export type Agendamentos_Bool_Exp = {
  AgendamentoAlocacao?: InputMaybe<AgendamentosAlocacoes_Bool_Exp>;
  AgendamentoPreAlocacao?: InputMaybe<AgendamentosPreAlocacao_Bool_Exp>;
  Agendamentos?: InputMaybe<Agendamentos_Bool_Exp>;
  AgendamentosAlocacoesAtivas?: InputMaybe<AgendamentosAlocacoesAtivas_Bool_Exp>;
  AgendamentosCheckin?: InputMaybe<TbAgendamentosCheckins_Bool_Exp>;
  AgendamentosVinculados?: InputMaybe<TbAgendamentosVinculados_Bool_Exp>;
  Fechamentos?: InputMaybe<TbFechamentos_Bool_Exp>;
  FinalidadesAgendamento?: InputMaybe<FinalidadesAgendamentos_Bool_Exp>;
  Paciente?: InputMaybe<Pacientes_Bool_Exp>;
  Unidade?: InputMaybe<Unidades_Bool_Exp>;
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  UsuarioAuditoria?: InputMaybe<Usuarios_Bool_Exp>;
  UsuarioCompromisso?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
  UsuarioProfissional?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
  UsuariosAgenda?: InputMaybe<UsuariosAgendas_Bool_Exp>;
  UsuariosFormasRecebimento?: InputMaybe<UsuariosFormasRecebimentos_Bool_Exp>;
  _and?: InputMaybe<Array<Agendamentos_Bool_Exp>>;
  _not?: InputMaybe<Agendamentos_Bool_Exp>;
  _or?: InputMaybe<Array<Agendamentos_Bool_Exp>>;
  cancelado?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  cobraCancelamento?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  cobrancaStatus?: InputMaybe<String_Mssql_Comparison_Exp>;
  cobrancaTotemId?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  codAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codAgendamentoGuid?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  codAgendamentoOrigem?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codFinalidadeAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPaciente?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoConvenio?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioAgenda?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioAuditoria?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioCompromisso?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioFormaRecebimento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  confirmaCancelamento?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  confirmado?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  data?: InputMaybe<Date_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  dataCancelamento?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  dataCienciaCancelamento?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
  dataNascimento?: InputMaybe<Date_Mssql_Comparison_Exp>;
  email?: InputMaybe<String_Mssql_Comparison_Exp>;
  emailConfirmaCancelamentoEnviado?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  eventual?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  fechaCancelamento?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  horaFim?: InputMaybe<Time_Mssql_Comparison_Exp>;
  horaInicio?: InputMaybe<Time_Mssql_Comparison_Exp>;
  ignorarEnvioEmail?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  ignorarEnvioWhatsApp?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  lembretes?: InputMaybe<Lembretes_Bool_Exp>;
  meioPagamento?: InputMaybe<String_Mssql_Comparison_Exp>;
  motivoCancelamento?: InputMaybe<String_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  nomeConvenio?: InputMaybe<String_Mssql_Comparison_Exp>;
  nomePlano?: InputMaybe<String_Mssql_Comparison_Exp>;
  notaAtendimento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  notificacoesPacientesAtrasados?: InputMaybe<NotificacoesPacientesAtrasados_Bool_Exp>;
  numeroCarteirinha?: InputMaybe<String_Mssql_Comparison_Exp>;
  pagar?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  pago?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  tags?: InputMaybe<AgendamentosTags_Bool_Exp>;
  tbPeriodosGarantidos?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
  telefone?: InputMaybe<String_Mssql_Comparison_Exp>;
  telefoneProprio?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  validadeCarteirinha?: InputMaybe<Date_Mssql_Comparison_Exp>;
  valor?: InputMaybe<Float_Mssql_Comparison_Exp>;
  whatsAppConfirmacaoEnviado?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  whatsAppSegundaConfirmacaoEnviada?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type Agendamentos_Max_Fields = {
  __typename?: 'agendamentos_max_fields';
  cobrancaStatus?: Maybe<Scalars['String']['output']>;
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codAgendamentoOrigem?: Maybe<Scalars['Int']['output']>;
  codFinalidadeAgendamento?: Maybe<Scalars['Int']['output']>;
  codPaciente?: Maybe<Scalars['Int']['output']>;
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Int']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['date']['output']>;
  dataCadastro?: Maybe<Scalars['datetime']['output']>;
  dataCancelamento?: Maybe<Scalars['datetime']['output']>;
  dataCienciaCancelamento?: Maybe<Scalars['datetime']['output']>;
  dataNascimento?: Maybe<Scalars['date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  horaFim?: Maybe<Scalars['time']['output']>;
  horaInicio?: Maybe<Scalars['time']['output']>;
  meioPagamento?: Maybe<Scalars['String']['output']>;
  motivoCancelamento?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  nomeConvenio?: Maybe<Scalars['String']['output']>;
  nomePlano?: Maybe<Scalars['String']['output']>;
  notaAtendimento?: Maybe<Scalars['Int']['output']>;
  numeroCarteirinha?: Maybe<Scalars['String']['output']>;
  telefone?: Maybe<Scalars['String']['output']>;
  validadeCarteirinha?: Maybe<Scalars['date']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "tbAgendamentos" */
export type Agendamentos_Max_Order_By = {
  cobrancaStatus?: InputMaybe<Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataCancelamento?: InputMaybe<Order_By>;
  dataCienciaCancelamento?: InputMaybe<Order_By>;
  dataNascimento?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
  meioPagamento?: InputMaybe<Order_By>;
  motivoCancelamento?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  nomeConvenio?: InputMaybe<Order_By>;
  nomePlano?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  numeroCarteirinha?: InputMaybe<Order_By>;
  telefone?: InputMaybe<Order_By>;
  validadeCarteirinha?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agendamentos_Min_Fields = {
  __typename?: 'agendamentos_min_fields';
  cobrancaStatus?: Maybe<Scalars['String']['output']>;
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codAgendamentoOrigem?: Maybe<Scalars['Int']['output']>;
  codFinalidadeAgendamento?: Maybe<Scalars['Int']['output']>;
  codPaciente?: Maybe<Scalars['Int']['output']>;
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Int']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['date']['output']>;
  dataCadastro?: Maybe<Scalars['datetime']['output']>;
  dataCancelamento?: Maybe<Scalars['datetime']['output']>;
  dataCienciaCancelamento?: Maybe<Scalars['datetime']['output']>;
  dataNascimento?: Maybe<Scalars['date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  horaFim?: Maybe<Scalars['time']['output']>;
  horaInicio?: Maybe<Scalars['time']['output']>;
  meioPagamento?: Maybe<Scalars['String']['output']>;
  motivoCancelamento?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  nomeConvenio?: Maybe<Scalars['String']['output']>;
  nomePlano?: Maybe<Scalars['String']['output']>;
  notaAtendimento?: Maybe<Scalars['Int']['output']>;
  numeroCarteirinha?: Maybe<Scalars['String']['output']>;
  telefone?: Maybe<Scalars['String']['output']>;
  validadeCarteirinha?: Maybe<Scalars['date']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "tbAgendamentos" */
export type Agendamentos_Min_Order_By = {
  cobrancaStatus?: InputMaybe<Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataCancelamento?: InputMaybe<Order_By>;
  dataCienciaCancelamento?: InputMaybe<Order_By>;
  dataNascimento?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
  meioPagamento?: InputMaybe<Order_By>;
  motivoCancelamento?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  nomeConvenio?: InputMaybe<Order_By>;
  nomePlano?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  numeroCarteirinha?: InputMaybe<Order_By>;
  telefone?: InputMaybe<Order_By>;
  validadeCarteirinha?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbAgendamentos". */
export type Agendamentos_Order_By = {
  AgendamentoAlocacao_aggregate?: InputMaybe<AgendamentosAlocacoes_Aggregate_Order_By>;
  AgendamentoPreAlocacao_aggregate?: InputMaybe<AgendamentosPreAlocacao_Aggregate_Order_By>;
  AgendamentosAlocacoesAtivas_aggregate?: InputMaybe<AgendamentosAlocacoesAtivas_Aggregate_Order_By>;
  AgendamentosCheckin?: InputMaybe<TbAgendamentosCheckins_Order_By>;
  AgendamentosVinculados_aggregate?: InputMaybe<TbAgendamentosVinculados_Aggregate_Order_By>;
  Agendamentos_aggregate?: InputMaybe<Agendamentos_Aggregate_Order_By>;
  Fechamentos_aggregate?: InputMaybe<TbFechamentos_Aggregate_Order_By>;
  FinalidadesAgendamento?: InputMaybe<FinalidadesAgendamentos_Order_By>;
  Paciente?: InputMaybe<Pacientes_Order_By>;
  Unidade?: InputMaybe<Unidades_Order_By>;
  Usuario?: InputMaybe<Usuarios_Order_By>;
  UsuarioAuditoria?: InputMaybe<Usuarios_Order_By>;
  UsuarioCompromisso?: InputMaybe<UsuariosCompromissos_Order_By>;
  UsuarioProfissional?: InputMaybe<UsuariosProfissionais_Order_By>;
  UsuariosAgenda?: InputMaybe<UsuariosAgendas_Order_By>;
  UsuariosFormasRecebimento?: InputMaybe<UsuariosFormasRecebimentos_Order_By>;
  cancelado?: InputMaybe<Order_By>;
  cobraCancelamento?: InputMaybe<Order_By>;
  cobrancaStatus?: InputMaybe<Order_By>;
  cobrancaTotemId?: InputMaybe<Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoGuid?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  confirmaCancelamento?: InputMaybe<Order_By>;
  confirmado?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataCancelamento?: InputMaybe<Order_By>;
  dataCienciaCancelamento?: InputMaybe<Order_By>;
  dataNascimento?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  emailConfirmaCancelamentoEnviado?: InputMaybe<Order_By>;
  eventual?: InputMaybe<Order_By>;
  fechaCancelamento?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
  ignorarEnvioEmail?: InputMaybe<Order_By>;
  ignorarEnvioWhatsApp?: InputMaybe<Order_By>;
  lembretes_aggregate?: InputMaybe<Lembretes_Aggregate_Order_By>;
  meioPagamento?: InputMaybe<Order_By>;
  motivoCancelamento?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  nomeConvenio?: InputMaybe<Order_By>;
  nomePlano?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  notificacoesPacientesAtrasados_aggregate?: InputMaybe<NotificacoesPacientesAtrasados_Aggregate_Order_By>;
  numeroCarteirinha?: InputMaybe<Order_By>;
  pagar?: InputMaybe<Order_By>;
  pago?: InputMaybe<Order_By>;
  tags_aggregate?: InputMaybe<AgendamentosTags_Aggregate_Order_By>;
  tbPeriodosGarantidos_aggregate?: InputMaybe<TbPeriodosGarantidos_Aggregate_Order_By>;
  telefone?: InputMaybe<Order_By>;
  telefoneProprio?: InputMaybe<Order_By>;
  validadeCarteirinha?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
  whatsAppConfirmacaoEnviado?: InputMaybe<Order_By>;
  whatsAppSegundaConfirmacaoEnviada?: InputMaybe<Order_By>;
};

/** select columns of table "tbAgendamentos" */
export enum Agendamentos_Select_Column {
  /** column name */
  Cancelado = 'cancelado',
  /** column name */
  CobraCancelamento = 'cobraCancelamento',
  /** column name */
  CobrancaStatus = 'cobrancaStatus',
  /** column name */
  CobrancaTotemId = 'cobrancaTotemId',
  /** column name */
  CodAgendamento = 'codAgendamento',
  /** column name */
  CodAgendamentoGuid = 'codAgendamentoGuid',
  /** column name */
  CodAgendamentoOrigem = 'codAgendamentoOrigem',
  /** column name */
  CodFinalidadeAgendamento = 'codFinalidadeAgendamento',
  /** column name */
  CodPaciente = 'codPaciente',
  /** column name */
  CodTipoConvenio = 'codTipoConvenio',
  /** column name */
  CodUnidade = 'codUnidade',
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  CodUsuarioAgenda = 'codUsuarioAgenda',
  /** column name */
  CodUsuarioAuditoria = 'codUsuarioAuditoria',
  /** column name */
  CodUsuarioCompromisso = 'codUsuarioCompromisso',
  /** column name */
  CodUsuarioFormaRecebimento = 'codUsuarioFormaRecebimento',
  /** column name */
  ConfirmaCancelamento = 'confirmaCancelamento',
  /** column name */
  Confirmado = 'confirmado',
  /** column name */
  Data = 'data',
  /** column name */
  DataCadastro = 'dataCadastro',
  /** column name */
  DataCancelamento = 'dataCancelamento',
  /** column name */
  DataCienciaCancelamento = 'dataCienciaCancelamento',
  /** column name */
  DataNascimento = 'dataNascimento',
  /** column name */
  Email = 'email',
  /** column name */
  EmailConfirmaCancelamentoEnviado = 'emailConfirmaCancelamentoEnviado',
  /** column name */
  Eventual = 'eventual',
  /** column name */
  FechaCancelamento = 'fechaCancelamento',
  /** column name */
  HoraFim = 'horaFim',
  /** column name */
  HoraInicio = 'horaInicio',
  /** column name */
  IgnorarEnvioEmail = 'ignorarEnvioEmail',
  /** column name */
  IgnorarEnvioWhatsApp = 'ignorarEnvioWhatsApp',
  /** column name */
  MeioPagamento = 'meioPagamento',
  /** column name */
  MotivoCancelamento = 'motivoCancelamento',
  /** column name */
  Nome = 'nome',
  /** column name */
  NomeConvenio = 'nomeConvenio',
  /** column name */
  NomePlano = 'nomePlano',
  /** column name */
  NotaAtendimento = 'notaAtendimento',
  /** column name */
  NumeroCarteirinha = 'numeroCarteirinha',
  /** column name */
  Pagar = 'pagar',
  /** column name */
  Pago = 'pago',
  /** column name */
  Telefone = 'telefone',
  /** column name */
  TelefoneProprio = 'telefoneProprio',
  /** column name */
  ValidadeCarteirinha = 'validadeCarteirinha',
  /** column name */
  Valor = 'valor',
  /** column name */
  WhatsAppConfirmacaoEnviado = 'whatsAppConfirmacaoEnviado',
  /** column name */
  WhatsAppSegundaConfirmacaoEnviada = 'whatsAppSegundaConfirmacaoEnviada'
}

/** aggregate stddev on columns */
export type Agendamentos_Stddev_Fields = {
  __typename?: 'agendamentos_stddev_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOrigem?: Maybe<Scalars['Float']['output']>;
  codFinalidadeAgendamento?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Float']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  notaAtendimento?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbAgendamentos" */
export type Agendamentos_Stddev_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agendamentos_Stddev_Pop_Fields = {
  __typename?: 'agendamentos_stddev_pop_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOrigem?: Maybe<Scalars['Float']['output']>;
  codFinalidadeAgendamento?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Float']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  notaAtendimento?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbAgendamentos" */
export type Agendamentos_Stddev_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agendamentos_Stddev_Samp_Fields = {
  __typename?: 'agendamentos_stddev_samp_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOrigem?: Maybe<Scalars['Float']['output']>;
  codFinalidadeAgendamento?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Float']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  notaAtendimento?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbAgendamentos" */
export type Agendamentos_Stddev_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Agendamentos_Sum_Fields = {
  __typename?: 'agendamentos_sum_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codAgendamentoOrigem?: Maybe<Scalars['Int']['output']>;
  codFinalidadeAgendamento?: Maybe<Scalars['Int']['output']>;
  codPaciente?: Maybe<Scalars['Int']['output']>;
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Int']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Int']['output']>;
  notaAtendimento?: Maybe<Scalars['Int']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "tbAgendamentos" */
export type Agendamentos_Sum_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Agendamentos_Var_Pop_Fields = {
  __typename?: 'agendamentos_var_pop_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOrigem?: Maybe<Scalars['Float']['output']>;
  codFinalidadeAgendamento?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Float']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  notaAtendimento?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbAgendamentos" */
export type Agendamentos_Var_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agendamentos_Var_Samp_Fields = {
  __typename?: 'agendamentos_var_samp_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOrigem?: Maybe<Scalars['Float']['output']>;
  codFinalidadeAgendamento?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Float']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  notaAtendimento?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbAgendamentos" */
export type Agendamentos_Var_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agendamentos_Variance_Fields = {
  __typename?: 'agendamentos_variance_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOrigem?: Maybe<Scalars['Float']['output']>;
  codFinalidadeAgendamento?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioAgenda?: Maybe<Scalars['Float']['output']>;
  codUsuarioAuditoria?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  notaAtendimento?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbAgendamentos" */
export type Agendamentos_Variance_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOrigem?: InputMaybe<Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  notaAtendimento?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

export type AnalyticsMembroDadosDeUsuarioLinkRastreamentoInput = {
  codLinkRastreamento: Scalars['String']['input'];
  dataAcesso?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsMembroRelatorioIndependenteInput = {
  dataFim: Scalars['String']['input'];
  dataInicio: Scalars['String']['input'];
};

export type AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxoInput = {
  dataFim: Scalars['String']['input'];
  dataInicio: Scalars['String']['input'];
};

/** columns and relationships of "tbCanaisAgendamentos" */
export type CanaisAgendamentos = {
  __typename?: 'canaisAgendamentos';
  codCanalAgendamento: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "tbCanaisAgendamentos". All fields are combined with a logical 'AND'. */
export type CanaisAgendamentos_Bool_Exp = {
  _and?: InputMaybe<Array<CanaisAgendamentos_Bool_Exp>>;
  _not?: InputMaybe<CanaisAgendamentos_Bool_Exp>;
  _or?: InputMaybe<Array<CanaisAgendamentos_Bool_Exp>>;
  codCanalAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbCanaisAgendamentos". */
export type CanaisAgendamentos_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbCobrancas" */
export type Cobrancas = {
  __typename?: 'cobrancas';
  /** An array relationship */
  Movimentacoes: Array<TbMovimentacoes>;
  /** An object relationship */
  Usuario?: Maybe<Usuarios>;
  /** An object relationship */
  UsuarioProfissional: UsuariosProfissionais;
  codStatus: Scalars['Int']['output'];
  descricaoStatus: Scalars['String']['output'];
  valor: Scalars['Float']['output'];
};


/** columns and relationships of "tbCobrancas" */
export type CobrancasMovimentacoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbMovimentacoes_Order_By>>;
  where?: InputMaybe<TbMovimentacoes_Bool_Exp>;
};

/** order by aggregate values of table "tbCobrancas" */
export type Cobrancas_Aggregate_Order_By = {
  avg?: InputMaybe<Cobrancas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cobrancas_Max_Order_By>;
  min?: InputMaybe<Cobrancas_Min_Order_By>;
  stddev?: InputMaybe<Cobrancas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cobrancas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cobrancas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cobrancas_Sum_Order_By>;
  var_pop?: InputMaybe<Cobrancas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cobrancas_Var_Samp_Order_By>;
  variance?: InputMaybe<Cobrancas_Variance_Order_By>;
};

/** order by avg() on columns of table "tbCobrancas" */
export type Cobrancas_Avg_Order_By = {
  codStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbCobrancas". All fields are combined with a logical 'AND'. */
export type Cobrancas_Bool_Exp = {
  Movimentacoes?: InputMaybe<TbMovimentacoes_Bool_Exp>;
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  UsuarioProfissional?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
  _and?: InputMaybe<Array<Cobrancas_Bool_Exp>>;
  _not?: InputMaybe<Cobrancas_Bool_Exp>;
  _or?: InputMaybe<Array<Cobrancas_Bool_Exp>>;
  codStatus?: InputMaybe<Int_Mssql_Comparison_Exp>;
  descricaoStatus?: InputMaybe<String_Mssql_Comparison_Exp>;
  valor?: InputMaybe<Float_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbCobrancas" */
export type Cobrancas_Max_Order_By = {
  codStatus?: InputMaybe<Order_By>;
  descricaoStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbCobrancas" */
export type Cobrancas_Min_Order_By = {
  codStatus?: InputMaybe<Order_By>;
  descricaoStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbCobrancas". */
export type Cobrancas_Order_By = {
  Movimentacoes_aggregate?: InputMaybe<TbMovimentacoes_Aggregate_Order_By>;
  Usuario?: InputMaybe<Usuarios_Order_By>;
  UsuarioProfissional?: InputMaybe<UsuariosProfissionais_Order_By>;
  codStatus?: InputMaybe<Order_By>;
  descricaoStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbCobrancas" */
export type Cobrancas_Stddev_Order_By = {
  codStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbCobrancas" */
export type Cobrancas_Stddev_Pop_Order_By = {
  codStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbCobrancas" */
export type Cobrancas_Stddev_Samp_Order_By = {
  codStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbCobrancas" */
export type Cobrancas_Sum_Order_By = {
  codStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbCobrancas" */
export type Cobrancas_Var_Pop_Order_By = {
  codStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbCobrancas" */
export type Cobrancas_Var_Samp_Order_By = {
  codStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbCobrancas" */
export type Cobrancas_Variance_Order_By = {
  codStatus?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbCsatCategorias" */
export type CsatCategorias = {
  __typename?: 'csatCategorias';
  codCsatCategoria: Scalars['Int']['output'];
  /** An array relationship */
  csatCategoriasNotas: Array<CsatCategoriasNotas>;
  nome: Scalars['String']['output'];
};


/** columns and relationships of "tbCsatCategorias" */
export type CsatCategoriasCsatCategoriasNotasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CsatCategoriasNotas_Order_By>>;
  where?: InputMaybe<CsatCategoriasNotas_Bool_Exp>;
};

/** columns and relationships of "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas = {
  __typename?: 'csatCategoriasNotas';
  codCsatCategoria: Scalars['Int']['output'];
  /** An object relationship */
  csatCategoria: CsatCategorias;
  nota: Scalars['Int']['output'];
  ordem: Scalars['Int']['output'];
};

/** order by aggregate values of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Aggregate_Order_By = {
  avg?: InputMaybe<CsatCategoriasNotas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CsatCategoriasNotas_Max_Order_By>;
  min?: InputMaybe<CsatCategoriasNotas_Min_Order_By>;
  stddev?: InputMaybe<CsatCategoriasNotas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CsatCategoriasNotas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CsatCategoriasNotas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CsatCategoriasNotas_Sum_Order_By>;
  var_pop?: InputMaybe<CsatCategoriasNotas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CsatCategoriasNotas_Var_Samp_Order_By>;
  variance?: InputMaybe<CsatCategoriasNotas_Variance_Order_By>;
};

/** order by avg() on columns of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Avg_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbCsatCategoriasNotas". All fields are combined with a logical 'AND'. */
export type CsatCategoriasNotas_Bool_Exp = {
  _and?: InputMaybe<Array<CsatCategoriasNotas_Bool_Exp>>;
  _not?: InputMaybe<CsatCategoriasNotas_Bool_Exp>;
  _or?: InputMaybe<Array<CsatCategoriasNotas_Bool_Exp>>;
  codCsatCategoria?: InputMaybe<Int_Mssql_Comparison_Exp>;
  csatCategoria?: InputMaybe<CsatCategorias_Bool_Exp>;
  nota?: InputMaybe<Int_Mssql_Comparison_Exp>;
  ordem?: InputMaybe<Int_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Max_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Min_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbCsatCategoriasNotas". */
export type CsatCategoriasNotas_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  csatCategoria?: InputMaybe<CsatCategorias_Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Stddev_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Stddev_Pop_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Stddev_Samp_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Sum_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Var_Pop_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Var_Samp_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbCsatCategoriasNotas" */
export type CsatCategoriasNotas_Variance_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  nota?: InputMaybe<Order_By>;
  ordem?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbCsatCategorias". All fields are combined with a logical 'AND'. */
export type CsatCategorias_Bool_Exp = {
  _and?: InputMaybe<Array<CsatCategorias_Bool_Exp>>;
  _not?: InputMaybe<CsatCategorias_Bool_Exp>;
  _or?: InputMaybe<Array<CsatCategorias_Bool_Exp>>;
  codCsatCategoria?: InputMaybe<Int_Mssql_Comparison_Exp>;
  csatCategoriasNotas?: InputMaybe<CsatCategoriasNotas_Bool_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbCsatCategorias". */
export type CsatCategorias_Order_By = {
  codCsatCategoria?: InputMaybe<Order_By>;
  csatCategoriasNotas_aggregate?: InputMaybe<CsatCategoriasNotas_Aggregate_Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** Boolean expression to compare columns of type "datetime2". All fields are combined with logical 'AND'. */
export type Datetime2_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['datetime2']['input']>;
  _gt?: InputMaybe<Scalars['datetime2']['input']>;
  _gte?: InputMaybe<Scalars['datetime2']['input']>;
  _in?: InputMaybe<Array<Scalars['datetime2']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['datetime2']['input']>;
  _lte?: InputMaybe<Scalars['datetime2']['input']>;
  _neq?: InputMaybe<Scalars['datetime2']['input']>;
  _nin?: InputMaybe<Array<Scalars['datetime2']['input']>>;
};

/** Boolean expression to compare columns of type "datetime". All fields are combined with logical 'AND'. */
export type Datetime_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['datetime']['input']>;
  _gt?: InputMaybe<Scalars['datetime']['input']>;
  _gte?: InputMaybe<Scalars['datetime']['input']>;
  _in?: InputMaybe<Array<Scalars['datetime']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['datetime']['input']>;
  _lte?: InputMaybe<Scalars['datetime']['input']>;
  _neq?: InputMaybe<Scalars['datetime']['input']>;
  _nin?: InputMaybe<Array<Scalars['datetime']['input']>>;
};

/** Boolean expression to filter rows from the table "deliverus.read_app_notifications". All fields are combined with a logical 'AND'. */
export type Deliverus_Read_App_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Deliverus_Read_App_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Deliverus_Read_App_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Deliverus_Read_App_Notifications_Bool_Exp>>;
};

/** unique or primary key constraints on table "deliverus.read_app_notifications" */
export enum Deliverus_Read_App_Notifications_Constraint {
  /** unique or primary key constraint on columns "message_id" */
  ReadAppNotificationsMessageIdKey = 'read_app_notifications_message_id_key',
  /** unique or primary key constraint on columns "id" */
  ReadAppNotificationsPkey = 'read_app_notifications_pkey'
}

/** input type for inserting data into table "deliverus.read_app_notifications" */
export type Deliverus_Read_App_Notifications_Insert_Input = {
  actionId?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "deliverus.read_app_notifications" */
export type Deliverus_Read_App_Notifications_Mutation_Response = {
  __typename?: 'deliverus_read_app_notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
};

/** on_conflict condition type for table "deliverus.read_app_notifications" */
export type Deliverus_Read_App_Notifications_On_Conflict = {
  constraint: Deliverus_Read_App_Notifications_Constraint;
  update_columns?: Array<Deliverus_Read_App_Notifications_Update_Column>;
  where?: InputMaybe<Deliverus_Read_App_Notifications_Bool_Exp>;
};

/** placeholder for update columns of table "deliverus.read_app_notifications" (current role has no relevant permissions) */
export enum Deliverus_Read_App_Notifications_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "tbEspecialidades" */
export type Especialidades = {
  __typename?: 'especialidades';
  /** An array relationship */
  UsuariosEspecialidades: Array<UsuariosEspecialidades>;
  codEspecialidade: Scalars['Int']['output'];
  codTipoSala: Scalars['Int']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "tbEspecialidades" */
export type EspecialidadesUsuariosEspecialidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosEspecialidades_Order_By>>;
  where?: InputMaybe<UsuariosEspecialidades_Bool_Exp>;
};

/** order by aggregate values of table "tbEspecialidades" */
export type Especialidades_Aggregate_Order_By = {
  avg?: InputMaybe<Especialidades_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Especialidades_Max_Order_By>;
  min?: InputMaybe<Especialidades_Min_Order_By>;
  stddev?: InputMaybe<Especialidades_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Especialidades_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Especialidades_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Especialidades_Sum_Order_By>;
  var_pop?: InputMaybe<Especialidades_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Especialidades_Var_Samp_Order_By>;
  variance?: InputMaybe<Especialidades_Variance_Order_By>;
};

/** order by avg() on columns of table "tbEspecialidades" */
export type Especialidades_Avg_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbEspecialidades". All fields are combined with a logical 'AND'. */
export type Especialidades_Bool_Exp = {
  UsuariosEspecialidades?: InputMaybe<UsuariosEspecialidades_Bool_Exp>;
  _and?: InputMaybe<Array<Especialidades_Bool_Exp>>;
  _not?: InputMaybe<Especialidades_Bool_Exp>;
  _or?: InputMaybe<Array<Especialidades_Bool_Exp>>;
  codEspecialidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  descricao?: InputMaybe<String_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbEspecialidades" */
export type Especialidades_Max_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbEspecialidades" */
export type Especialidades_Min_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbEspecialidades". */
export type Especialidades_Order_By = {
  UsuariosEspecialidades_aggregate?: InputMaybe<UsuariosEspecialidades_Aggregate_Order_By>;
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbEspecialidades" */
export type Especialidades_Stddev_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbEspecialidades" */
export type Especialidades_Stddev_Pop_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbEspecialidades" */
export type Especialidades_Stddev_Samp_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbEspecialidades" */
export type Especialidades_Sum_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbEspecialidades" */
export type Especialidades_Var_Pop_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbEspecialidades" */
export type Especialidades_Var_Samp_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbEspecialidades" */
export type Especialidades_Variance_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
};

/** columns and relationships of "expensum.appointment_paid" */
export type Expensum_Appointment_Paid = {
  __typename?: 'expensum_appointment_paid';
  agendamento?: Maybe<Agendamentos>;
  clinica?: Maybe<TbClinicas>;
  codUsuario: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  usuario?: Maybe<Usuarios>;
};

/** aggregated selection of "expensum.appointment_paid" */
export type Expensum_Appointment_Paid_Aggregate = {
  __typename?: 'expensum_appointment_paid_aggregate';
  aggregate?: Maybe<Expensum_Appointment_Paid_Aggregate_Fields>;
  nodes: Array<Expensum_Appointment_Paid>;
};

/** aggregate fields of "expensum.appointment_paid" */
export type Expensum_Appointment_Paid_Aggregate_Fields = {
  __typename?: 'expensum_appointment_paid_aggregate_fields';
  avg?: Maybe<Expensum_Appointment_Paid_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Expensum_Appointment_Paid_Max_Fields>;
  min?: Maybe<Expensum_Appointment_Paid_Min_Fields>;
  stddev?: Maybe<Expensum_Appointment_Paid_Stddev_Fields>;
  stddev_pop?: Maybe<Expensum_Appointment_Paid_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Expensum_Appointment_Paid_Stddev_Samp_Fields>;
  sum?: Maybe<Expensum_Appointment_Paid_Sum_Fields>;
  var_pop?: Maybe<Expensum_Appointment_Paid_Var_Pop_Fields>;
  var_samp?: Maybe<Expensum_Appointment_Paid_Var_Samp_Fields>;
  variance?: Maybe<Expensum_Appointment_Paid_Variance_Fields>;
};


/** aggregate fields of "expensum.appointment_paid" */
export type Expensum_Appointment_Paid_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Expensum_Appointment_Paid_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Expensum_Appointment_Paid_Avg_Fields = {
  __typename?: 'expensum_appointment_paid_avg_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "expensum.appointment_paid". All fields are combined with a logical 'AND'. */
export type Expensum_Appointment_Paid_Bool_Exp = {
  _and?: InputMaybe<Array<Expensum_Appointment_Paid_Bool_Exp>>;
  _not?: InputMaybe<Expensum_Appointment_Paid_Bool_Exp>;
  _or?: InputMaybe<Array<Expensum_Appointment_Paid_Bool_Exp>>;
  codUsuario?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Expensum_Appointment_Paid_Max_Fields = {
  __typename?: 'expensum_appointment_paid_max_fields';
  codUsuario?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Expensum_Appointment_Paid_Min_Fields = {
  __typename?: 'expensum_appointment_paid_min_fields';
  codUsuario?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "expensum.appointment_paid". */
export type Expensum_Appointment_Paid_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
};

/** select columns of table "expensum.appointment_paid" */
export enum Expensum_Appointment_Paid_Select_Column {
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  CreatedAt = 'createdAt'
}

/** aggregate stddev on columns */
export type Expensum_Appointment_Paid_Stddev_Fields = {
  __typename?: 'expensum_appointment_paid_stddev_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Expensum_Appointment_Paid_Stddev_Pop_Fields = {
  __typename?: 'expensum_appointment_paid_stddev_pop_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Expensum_Appointment_Paid_Stddev_Samp_Fields = {
  __typename?: 'expensum_appointment_paid_stddev_samp_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "expensum_appointment_paid" */
export type Expensum_Appointment_Paid_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expensum_Appointment_Paid_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expensum_Appointment_Paid_Stream_Cursor_Value_Input = {
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Expensum_Appointment_Paid_Sum_Fields = {
  __typename?: 'expensum_appointment_paid_sum_fields';
  codUsuario?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Expensum_Appointment_Paid_Var_Pop_Fields = {
  __typename?: 'expensum_appointment_paid_var_pop_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Expensum_Appointment_Paid_Var_Samp_Fields = {
  __typename?: 'expensum_appointment_paid_var_samp_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Expensum_Appointment_Paid_Variance_Fields = {
  __typename?: 'expensum_appointment_paid_variance_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
};

/** Tabela de eventos de atualização das configurações de antecipação do recipiente */
export type Expensum_Event_Automatic_Anticipation_Settings_Update = {
  __typename?: 'expensum_event_automatic_anticipation_settings_update';
  id: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "expensum.event_automatic_anticipation_settings_update". All fields are combined with a logical 'AND'. */
export type Expensum_Event_Automatic_Anticipation_Settings_Update_Bool_Exp = {
  _and?: InputMaybe<Array<Expensum_Event_Automatic_Anticipation_Settings_Update_Bool_Exp>>;
  _not?: InputMaybe<Expensum_Event_Automatic_Anticipation_Settings_Update_Bool_Exp>;
  _or?: InputMaybe<Array<Expensum_Event_Automatic_Anticipation_Settings_Update_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "expensum.event_automatic_anticipation_settings_update" */
export enum Expensum_Event_Automatic_Anticipation_Settings_Update_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventAutomaticAnticipationSettingsUpdatePkey = 'event_automatic_anticipation_settings_update_pkey'
}

/** input type for inserting data into table "expensum.event_automatic_anticipation_settings_update" */
export type Expensum_Event_Automatic_Anticipation_Settings_Update_Insert_Input = {
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  days?: InputMaybe<Array<Scalars['String']['input']>>;
  delay?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  volumePercentage?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "expensum.event_automatic_anticipation_settings_update" */
export type Expensum_Event_Automatic_Anticipation_Settings_Update_Mutation_Response = {
  __typename?: 'expensum_event_automatic_anticipation_settings_update_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Expensum_Event_Automatic_Anticipation_Settings_Update>;
};

/** on_conflict condition type for table "expensum.event_automatic_anticipation_settings_update" */
export type Expensum_Event_Automatic_Anticipation_Settings_Update_On_Conflict = {
  constraint: Expensum_Event_Automatic_Anticipation_Settings_Update_Constraint;
  update_columns?: Array<Expensum_Event_Automatic_Anticipation_Settings_Update_Update_Column>;
  where?: InputMaybe<Expensum_Event_Automatic_Anticipation_Settings_Update_Bool_Exp>;
};

/** Ordering options when selecting data from "expensum.event_automatic_anticipation_settings_update". */
export type Expensum_Event_Automatic_Anticipation_Settings_Update_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** select columns of table "expensum.event_automatic_anticipation_settings_update" */
export enum Expensum_Event_Automatic_Anticipation_Settings_Update_Select_Column {
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "expensum_event_automatic_anticipation_settings_update" */
export type Expensum_Event_Automatic_Anticipation_Settings_Update_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expensum_Event_Automatic_Anticipation_Settings_Update_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expensum_Event_Automatic_Anticipation_Settings_Update_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** placeholder for update columns of table "expensum.event_automatic_anticipation_settings_update" (current role has no relevant permissions) */
export enum Expensum_Event_Automatic_Anticipation_Settings_Update_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** Tabela de evento de atualização de dados bancários. */
export type Expensum_Event_Bank_Account_Update = {
  __typename?: 'expensum_event_bank_account_update';
  id: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "expensum.event_bank_account_update". All fields are combined with a logical 'AND'. */
export type Expensum_Event_Bank_Account_Update_Bool_Exp = {
  _and?: InputMaybe<Array<Expensum_Event_Bank_Account_Update_Bool_Exp>>;
  _not?: InputMaybe<Expensum_Event_Bank_Account_Update_Bool_Exp>;
  _or?: InputMaybe<Array<Expensum_Event_Bank_Account_Update_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "expensum.event_bank_account_update" */
export enum Expensum_Event_Bank_Account_Update_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventBankAccountUpdatePkey = 'event_bank_account_update_pkey'
}

/** input type for inserting data into table "expensum.event_bank_account_update" */
export type Expensum_Event_Bank_Account_Update_Insert_Input = {
  accountCheckDigit?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bank?: InputMaybe<Scalars['String']['input']>;
  branchCheckDigit?: InputMaybe<Scalars['String']['input']>;
  branchNumber?: InputMaybe<Scalars['String']['input']>;
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  holderDocument?: InputMaybe<Scalars['String']['input']>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  holderType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "expensum.event_bank_account_update" */
export type Expensum_Event_Bank_Account_Update_Mutation_Response = {
  __typename?: 'expensum_event_bank_account_update_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Expensum_Event_Bank_Account_Update>;
};

/** on_conflict condition type for table "expensum.event_bank_account_update" */
export type Expensum_Event_Bank_Account_Update_On_Conflict = {
  constraint: Expensum_Event_Bank_Account_Update_Constraint;
  update_columns?: Array<Expensum_Event_Bank_Account_Update_Update_Column>;
  where?: InputMaybe<Expensum_Event_Bank_Account_Update_Bool_Exp>;
};

/** Ordering options when selecting data from "expensum.event_bank_account_update". */
export type Expensum_Event_Bank_Account_Update_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** select columns of table "expensum.event_bank_account_update" */
export enum Expensum_Event_Bank_Account_Update_Select_Column {
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "expensum_event_bank_account_update" */
export type Expensum_Event_Bank_Account_Update_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expensum_Event_Bank_Account_Update_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expensum_Event_Bank_Account_Update_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** placeholder for update columns of table "expensum.event_bank_account_update" (current role has no relevant permissions) */
export enum Expensum_Event_Bank_Account_Update_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "expensum.event_totem_payment_sent" */
export type Expensum_Event_Totem_Payment_Sent = {
  __typename?: 'expensum_event_totem_payment_sent';
  codUsuario?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
};

/** aggregated selection of "expensum.event_totem_payment_sent" */
export type Expensum_Event_Totem_Payment_Sent_Aggregate = {
  __typename?: 'expensum_event_totem_payment_sent_aggregate';
  aggregate?: Maybe<Expensum_Event_Totem_Payment_Sent_Aggregate_Fields>;
  nodes: Array<Expensum_Event_Totem_Payment_Sent>;
};

/** aggregate fields of "expensum.event_totem_payment_sent" */
export type Expensum_Event_Totem_Payment_Sent_Aggregate_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_aggregate_fields';
  avg?: Maybe<Expensum_Event_Totem_Payment_Sent_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Expensum_Event_Totem_Payment_Sent_Max_Fields>;
  min?: Maybe<Expensum_Event_Totem_Payment_Sent_Min_Fields>;
  stddev?: Maybe<Expensum_Event_Totem_Payment_Sent_Stddev_Fields>;
  stddev_pop?: Maybe<Expensum_Event_Totem_Payment_Sent_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Expensum_Event_Totem_Payment_Sent_Stddev_Samp_Fields>;
  sum?: Maybe<Expensum_Event_Totem_Payment_Sent_Sum_Fields>;
  var_pop?: Maybe<Expensum_Event_Totem_Payment_Sent_Var_Pop_Fields>;
  var_samp?: Maybe<Expensum_Event_Totem_Payment_Sent_Var_Samp_Fields>;
  variance?: Maybe<Expensum_Event_Totem_Payment_Sent_Variance_Fields>;
};


/** aggregate fields of "expensum.event_totem_payment_sent" */
export type Expensum_Event_Totem_Payment_Sent_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Expensum_Event_Totem_Payment_Sent_Avg_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_avg_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "expensum.event_totem_payment_sent". All fields are combined with a logical 'AND'. */
export type Expensum_Event_Totem_Payment_Sent_Bool_Exp = {
  _and?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Bool_Exp>>;
  _not?: InputMaybe<Expensum_Event_Totem_Payment_Sent_Bool_Exp>;
  _or?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Bool_Exp>>;
  codUsuario?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "expensum.event_totem_payment_sent" */
export enum Expensum_Event_Totem_Payment_Sent_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventTotemPaymentSentPkey = 'event_totem_payment_sent_pkey'
}

/** input type for inserting data into table "expensum.event_totem_payment_sent" */
export type Expensum_Event_Totem_Payment_Sent_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']['input']>;
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
  codAgendamentoOriginal?: InputMaybe<Scalars['Int']['input']>;
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  credit?: InputMaybe<Scalars['Boolean']['input']>;
  debit?: InputMaybe<Scalars['Boolean']['input']>;
  installments?: InputMaybe<Scalars['Int']['input']>;
  pix?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Expensum_Event_Totem_Payment_Sent_Max_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_max_fields';
  codUsuario?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Expensum_Event_Totem_Payment_Sent_Min_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_min_fields';
  codUsuario?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "expensum.event_totem_payment_sent" */
export type Expensum_Event_Totem_Payment_Sent_Mutation_Response = {
  __typename?: 'expensum_event_totem_payment_sent_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Expensum_Event_Totem_Payment_Sent>;
};

/** on_conflict condition type for table "expensum.event_totem_payment_sent" */
export type Expensum_Event_Totem_Payment_Sent_On_Conflict = {
  constraint: Expensum_Event_Totem_Payment_Sent_Constraint;
  update_columns?: Array<Expensum_Event_Totem_Payment_Sent_Update_Column>;
  where?: InputMaybe<Expensum_Event_Totem_Payment_Sent_Bool_Exp>;
};

/** Ordering options when selecting data from "expensum.event_totem_payment_sent". */
export type Expensum_Event_Totem_Payment_Sent_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "expensum.event_totem_payment_sent" */
export enum Expensum_Event_Totem_Payment_Sent_Select_Column {
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Expensum_Event_Totem_Payment_Sent_Stddev_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_stddev_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Expensum_Event_Totem_Payment_Sent_Stddev_Pop_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_stddev_pop_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Expensum_Event_Totem_Payment_Sent_Stddev_Samp_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_stddev_samp_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "expensum_event_totem_payment_sent" */
export type Expensum_Event_Totem_Payment_Sent_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expensum_Event_Totem_Payment_Sent_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expensum_Event_Totem_Payment_Sent_Stream_Cursor_Value_Input = {
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Expensum_Event_Totem_Payment_Sent_Sum_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_sum_fields';
  codUsuario?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

/** placeholder for update columns of table "expensum.event_totem_payment_sent" (current role has no relevant permissions) */
export enum Expensum_Event_Totem_Payment_Sent_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type Expensum_Event_Totem_Payment_Sent_Var_Pop_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_var_pop_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Expensum_Event_Totem_Payment_Sent_Var_Samp_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_var_samp_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Expensum_Event_Totem_Payment_Sent_Variance_Fields = {
  __typename?: 'expensum_event_totem_payment_sent_variance_fields';
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "expensum.online_payment" */
export type Expensum_Online_Payment = {
  __typename?: 'expensum_online_payment';
  /** An array relationship */
  activities: Array<Expensum_Online_Payment_Activity>;
  agendamento?: Maybe<Agendamentos>;
  agendamentoOriginal: Array<TbAgendamentosVinculados>;
  amount: Scalars['Int']['output'];
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  createdAt: Scalars['timestamptz']['output'];
  guid: Scalars['uuid']['output'];
  id: Scalars['Int']['output'];
  livanceUser?: Maybe<UsuariosProfissionais>;
  originPaymentType?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};


/** columns and relationships of "expensum.online_payment" */
export type Expensum_Online_PaymentActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Activity_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Activity_Bool_Exp>;
};


/** columns and relationships of "expensum.online_payment" */
export type Expensum_Online_PaymentAgendamentoOriginalArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbAgendamentosVinculados_Order_By>>;
  where?: InputMaybe<TbAgendamentosVinculados_Bool_Exp>;
};

/** columns and relationships of "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity = {
  __typename?: 'expensum_online_payment_activity';
  chosenPaymentType?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  onlinePayment: Expensum_Online_Payment;
  onlinePaymentId: Scalars['Int']['output'];
};

/** order by aggregate values of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Aggregate_Order_By = {
  avg?: InputMaybe<Expensum_Online_Payment_Activity_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Expensum_Online_Payment_Activity_Max_Order_By>;
  min?: InputMaybe<Expensum_Online_Payment_Activity_Min_Order_By>;
  stddev?: InputMaybe<Expensum_Online_Payment_Activity_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Expensum_Online_Payment_Activity_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Expensum_Online_Payment_Activity_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Expensum_Online_Payment_Activity_Sum_Order_By>;
  var_pop?: InputMaybe<Expensum_Online_Payment_Activity_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Expensum_Online_Payment_Activity_Var_Samp_Order_By>;
  variance?: InputMaybe<Expensum_Online_Payment_Activity_Variance_Order_By>;
};

/** order by avg() on columns of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Avg_Order_By = {
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "expensum.online_payment_activity". All fields are combined with a logical 'AND'. */
export type Expensum_Online_Payment_Activity_Bool_Exp = {
  _and?: InputMaybe<Array<Expensum_Online_Payment_Activity_Bool_Exp>>;
  _not?: InputMaybe<Expensum_Online_Payment_Activity_Bool_Exp>;
  _or?: InputMaybe<Array<Expensum_Online_Payment_Activity_Bool_Exp>>;
  chosenPaymentType?: InputMaybe<String_Comparison_Exp>;
  onlinePayment?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
  onlinePaymentId?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "expensum.online_payment_activity" */
export enum Expensum_Online_Payment_Activity_Constraint {
  /** unique or primary key constraint on columns "id" */
  OnlinePaymentActivityPkey = 'online_payment_activity_pkey'
}

/** input type for inserting data into table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Insert_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  onlinePaymentId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Max_Order_By = {
  chosenPaymentType?: InputMaybe<Order_By>;
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Min_Order_By = {
  chosenPaymentType?: InputMaybe<Order_By>;
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Mutation_Response = {
  __typename?: 'expensum_online_payment_activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Expensum_Online_Payment_Activity>;
};

/** on_conflict condition type for table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_On_Conflict = {
  constraint: Expensum_Online_Payment_Activity_Constraint;
  update_columns?: Array<Expensum_Online_Payment_Activity_Update_Column>;
  where?: InputMaybe<Expensum_Online_Payment_Activity_Bool_Exp>;
};

/** Ordering options when selecting data from "expensum.online_payment_activity". */
export type Expensum_Online_Payment_Activity_Order_By = {
  chosenPaymentType?: InputMaybe<Order_By>;
  onlinePayment?: InputMaybe<Expensum_Online_Payment_Order_By>;
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** select columns of table "expensum.online_payment_activity" */
export enum Expensum_Online_Payment_Activity_Select_Column {
  /** column name */
  ChosenPaymentType = 'chosenPaymentType',
  /** column name */
  OnlinePaymentId = 'onlinePaymentId'
}

/** order by stddev() on columns of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Stddev_Order_By = {
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Stddev_Pop_Order_By = {
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Stddev_Samp_Order_By = {
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "expensum_online_payment_activity" */
export type Expensum_Online_Payment_Activity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expensum_Online_Payment_Activity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expensum_Online_Payment_Activity_Stream_Cursor_Value_Input = {
  chosenPaymentType?: InputMaybe<Scalars['String']['input']>;
  onlinePaymentId?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Sum_Order_By = {
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "expensum.online_payment_activity" (current role has no relevant permissions) */
export enum Expensum_Online_Payment_Activity_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Var_Pop_Order_By = {
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Var_Samp_Order_By = {
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "expensum.online_payment_activity" */
export type Expensum_Online_Payment_Activity_Variance_Order_By = {
  onlinePaymentId?: InputMaybe<Order_By>;
};

/** aggregated selection of "expensum.online_payment" */
export type Expensum_Online_Payment_Aggregate = {
  __typename?: 'expensum_online_payment_aggregate';
  aggregate?: Maybe<Expensum_Online_Payment_Aggregate_Fields>;
  nodes: Array<Expensum_Online_Payment>;
};

/** aggregate fields of "expensum.online_payment" */
export type Expensum_Online_Payment_Aggregate_Fields = {
  __typename?: 'expensum_online_payment_aggregate_fields';
  avg?: Maybe<Expensum_Online_Payment_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Expensum_Online_Payment_Max_Fields>;
  min?: Maybe<Expensum_Online_Payment_Min_Fields>;
  stddev?: Maybe<Expensum_Online_Payment_Stddev_Fields>;
  stddev_pop?: Maybe<Expensum_Online_Payment_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Expensum_Online_Payment_Stddev_Samp_Fields>;
  sum?: Maybe<Expensum_Online_Payment_Sum_Fields>;
  var_pop?: Maybe<Expensum_Online_Payment_Var_Pop_Fields>;
  var_samp?: Maybe<Expensum_Online_Payment_Var_Samp_Fields>;
  variance?: Maybe<Expensum_Online_Payment_Variance_Fields>;
};


/** aggregate fields of "expensum.online_payment" */
export type Expensum_Online_Payment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Expensum_Online_Payment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Expensum_Online_Payment_Avg_Fields = {
  __typename?: 'expensum_online_payment_avg_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "expensum.online_payment". All fields are combined with a logical 'AND'. */
export type Expensum_Online_Payment_Bool_Exp = {
  _and?: InputMaybe<Array<Expensum_Online_Payment_Bool_Exp>>;
  _not?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
  _or?: InputMaybe<Array<Expensum_Online_Payment_Bool_Exp>>;
  activities?: InputMaybe<Expensum_Online_Payment_Activity_Bool_Exp>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  codAgendamento?: InputMaybe<Int_Comparison_Exp>;
  codAgendamentoOriginal?: InputMaybe<Int_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  guid?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  originPaymentType?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Expensum_Online_Payment_Max_Fields = {
  __typename?: 'expensum_online_payment_max_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  guid?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  originPaymentType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Expensum_Online_Payment_Min_Fields = {
  __typename?: 'expensum_online_payment_min_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  guid?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  originPaymentType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "expensum.online_payment" */
export type Expensum_Online_Payment_Mutation_Response = {
  __typename?: 'expensum_online_payment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Expensum_Online_Payment>;
};

/** Ordering options when selecting data from "expensum.online_payment". */
export type Expensum_Online_Payment_Order_By = {
  activities_aggregate?: InputMaybe<Expensum_Online_Payment_Activity_Aggregate_Order_By>;
  amount?: InputMaybe<Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  codAgendamentoOriginal?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  guid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  originPaymentType?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: expensum.online_payment */
export type Expensum_Online_Payment_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "expensum.online_payment" */
export enum Expensum_Online_Payment_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CodAgendamento = 'codAgendamento',
  /** column name */
  CodAgendamentoOriginal = 'codAgendamentoOriginal',
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Guid = 'guid',
  /** column name */
  Id = 'id',
  /** column name */
  OriginPaymentType = 'originPaymentType',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "expensum.online_payment" */
export type Expensum_Online_Payment_Set_Input = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Expensum_Online_Payment_Stddev_Fields = {
  __typename?: 'expensum_online_payment_stddev_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Expensum_Online_Payment_Stddev_Pop_Fields = {
  __typename?: 'expensum_online_payment_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Expensum_Online_Payment_Stddev_Samp_Fields = {
  __typename?: 'expensum_online_payment_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "expensum_online_payment" */
export type Expensum_Online_Payment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expensum_Online_Payment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expensum_Online_Payment_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
  codAgendamentoOriginal?: InputMaybe<Scalars['Int']['input']>;
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  guid?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  originPaymentType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Expensum_Online_Payment_Sum_Fields = {
  __typename?: 'expensum_online_payment_sum_fields';
  amount?: Maybe<Scalars['Int']['output']>;
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type Expensum_Online_Payment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Expensum_Online_Payment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Expensum_Online_Payment_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Expensum_Online_Payment_Var_Pop_Fields = {
  __typename?: 'expensum_online_payment_var_pop_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Expensum_Online_Payment_Var_Samp_Fields = {
  __typename?: 'expensum_online_payment_var_samp_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Expensum_Online_Payment_Variance_Fields = {
  __typename?: 'expensum_online_payment_variance_fields';
  amount?: Maybe<Scalars['Float']['output']>;
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codAgendamentoOriginal?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "expensum.payment_type" */
export type Expensum_Payment_Type = {
  __typename?: 'expensum_payment_type';
  active: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "expensum.payment_type". All fields are combined with a logical 'AND'. */
export type Expensum_Payment_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Expensum_Payment_Type_Bool_Exp>>;
  _not?: InputMaybe<Expensum_Payment_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Expensum_Payment_Type_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "expensum.payment_type". */
export type Expensum_Payment_Type_Order_By = {
  active?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "expensum.payment_type" */
export enum Expensum_Payment_Type_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "expensum_payment_type" */
export type Expensum_Payment_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expensum_Payment_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expensum_Payment_Type_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed = {
  __typename?: 'expensum_recipient_terms_of_use_agreed';
  codUsuario: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** An object relationship */
  termsOfUse: Expensum_Terms_Of_Use;
};

/** order by aggregate values of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Aggregate_Order_By = {
  avg?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Max_Order_By>;
  min?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Min_Order_By>;
  stddev?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Sum_Order_By>;
  var_pop?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Var_Samp_Order_By>;
  variance?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Variance_Order_By>;
};

/** order by avg() on columns of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Avg_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "expensum.recipient_terms_of_use_agreed". All fields are combined with a logical 'AND'. */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Bool_Exp = {
  _and?: InputMaybe<Array<Expensum_Recipient_Terms_Of_Use_Agreed_Bool_Exp>>;
  _not?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Bool_Exp>;
  _or?: InputMaybe<Array<Expensum_Recipient_Terms_Of_Use_Agreed_Bool_Exp>>;
  codUsuario?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  termsOfUse?: InputMaybe<Expensum_Terms_Of_Use_Bool_Exp>;
};

/** unique or primary key constraints on table "expensum.recipient_terms_of_use_agreed" */
export enum Expensum_Recipient_Terms_Of_Use_Agreed_Constraint {
  /** unique or primary key constraint on columns "cod_usuario", "terms_of_use_id" */
  RecipientTermsOfUseAgreedCodUsuarioTermsOfUseIdKey = 'recipient_terms_of_use_agreed_cod_usuario_terms_of_use_id_key',
  /** unique or primary key constraint on columns "id" */
  RecipientTermsOfUseAgreedPkey = 'recipient_terms_of_use_agreed_pkey'
}

/** input type for inserting data into table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Insert_Input = {
  agreedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  agreedFromIp?: InputMaybe<Scalars['String']['input']>;
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  recipientId?: InputMaybe<Scalars['Int']['input']>;
  termsOfUseId?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Max_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Min_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Mutation_Response = {
  __typename?: 'expensum_recipient_terms_of_use_agreed_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Expensum_Recipient_Terms_Of_Use_Agreed>;
};

/** on_conflict condition type for table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_On_Conflict = {
  constraint: Expensum_Recipient_Terms_Of_Use_Agreed_Constraint;
  update_columns?: Array<Expensum_Recipient_Terms_Of_Use_Agreed_Update_Column>;
  where?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Bool_Exp>;
};

/** Ordering options when selecting data from "expensum.recipient_terms_of_use_agreed". */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  termsOfUse?: InputMaybe<Expensum_Terms_Of_Use_Order_By>;
};

/** select columns of table "expensum.recipient_terms_of_use_agreed" */
export enum Expensum_Recipient_Terms_Of_Use_Agreed_Select_Column {
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  Id = 'id'
}

/** order by stddev() on columns of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Stddev_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Stddev_Pop_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Stddev_Samp_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "expensum_recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expensum_Recipient_Terms_Of_Use_Agreed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Stream_Cursor_Value_Input = {
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Sum_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "expensum.recipient_terms_of_use_agreed" (current role has no relevant permissions) */
export enum Expensum_Recipient_Terms_Of_Use_Agreed_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Var_Pop_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Var_Samp_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "expensum.recipient_terms_of_use_agreed" */
export type Expensum_Recipient_Terms_Of_Use_Agreed_Variance_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "expensum.terms_of_use" */
export type Expensum_Terms_Of_Use = {
  __typename?: 'expensum_terms_of_use';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  recipientTermsAgreed: Array<Expensum_Recipient_Terms_Of_Use_Agreed>;
  releaseDate: Scalars['timestamptz']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  urlTerms?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "expensum.terms_of_use" */
export type Expensum_Terms_Of_UseRecipientTermsAgreedArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Recipient_Terms_Of_Use_Agreed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Recipient_Terms_Of_Use_Agreed_Order_By>>;
  where?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "expensum.terms_of_use". All fields are combined with a logical 'AND'. */
export type Expensum_Terms_Of_Use_Bool_Exp = {
  _and?: InputMaybe<Array<Expensum_Terms_Of_Use_Bool_Exp>>;
  _not?: InputMaybe<Expensum_Terms_Of_Use_Bool_Exp>;
  _or?: InputMaybe<Array<Expensum_Terms_Of_Use_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  recipientTermsAgreed?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Bool_Exp>;
  releaseDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  urlTerms?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "expensum.terms_of_use". */
export type Expensum_Terms_Of_Use_Order_By = {
  active?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipientTermsAgreed_aggregate?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Aggregate_Order_By>;
  releaseDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  urlTerms?: InputMaybe<Order_By>;
};

/** select columns of table "expensum.terms_of_use" */
export enum Expensum_Terms_Of_Use_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ReleaseDate = 'releaseDate',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UrlTerms = 'urlTerms'
}

/** Streaming cursor of the table "expensum_terms_of_use" */
export type Expensum_Terms_Of_Use_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expensum_Terms_Of_Use_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expensum_Terms_Of_Use_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  releaseDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  urlTerms?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "tbFinalidadesAgendamentos" */
export type FinalidadesAgendamentos = {
  __typename?: 'finalidadesAgendamentos';
  /** An array relationship */
  Agendamentos: Array<Agendamentos>;
  /** An aggregate relationship */
  Agendamentos_aggregate: Agendamentos_Aggregate;
  codFinalidadeAgendamento: Scalars['Int']['output'];
  taxaCobrancaAtraso: Scalars['Float']['output'];
};


/** columns and relationships of "tbFinalidadesAgendamentos" */
export type FinalidadesAgendamentosAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbFinalidadesAgendamentos" */
export type FinalidadesAgendamentosAgendamentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tbFinalidadesAgendamentos". All fields are combined with a logical 'AND'. */
export type FinalidadesAgendamentos_Bool_Exp = {
  Agendamentos?: InputMaybe<Agendamentos_Bool_Exp>;
  _and?: InputMaybe<Array<FinalidadesAgendamentos_Bool_Exp>>;
  _not?: InputMaybe<FinalidadesAgendamentos_Bool_Exp>;
  _or?: InputMaybe<Array<FinalidadesAgendamentos_Bool_Exp>>;
  codFinalidadeAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  taxaCobrancaAtraso?: InputMaybe<Float_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbFinalidadesAgendamentos". */
export type FinalidadesAgendamentos_Order_By = {
  Agendamentos_aggregate?: InputMaybe<Agendamentos_Aggregate_Order_By>;
  codFinalidadeAgendamento?: InputMaybe<Order_By>;
  taxaCobrancaAtraso?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas = {
  __typename?: 'funcionalidadesDesativadas';
  codFuncionalidade: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  /** An object relationship */
  usuarioProfissional: UsuariosProfissionais;
};

/** order by aggregate values of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Aggregate_Order_By = {
  avg?: InputMaybe<FuncionalidadesDesativadas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<FuncionalidadesDesativadas_Max_Order_By>;
  min?: InputMaybe<FuncionalidadesDesativadas_Min_Order_By>;
  stddev?: InputMaybe<FuncionalidadesDesativadas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<FuncionalidadesDesativadas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<FuncionalidadesDesativadas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<FuncionalidadesDesativadas_Sum_Order_By>;
  var_pop?: InputMaybe<FuncionalidadesDesativadas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<FuncionalidadesDesativadas_Var_Samp_Order_By>;
  variance?: InputMaybe<FuncionalidadesDesativadas_Variance_Order_By>;
};

/** order by avg() on columns of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Avg_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbFuncionalidadesDesativadas". All fields are combined with a logical 'AND'. */
export type FuncionalidadesDesativadas_Bool_Exp = {
  _and?: InputMaybe<Array<FuncionalidadesDesativadas_Bool_Exp>>;
  _not?: InputMaybe<FuncionalidadesDesativadas_Bool_Exp>;
  _or?: InputMaybe<Array<FuncionalidadesDesativadas_Bool_Exp>>;
  codFuncionalidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  usuarioProfissional?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};

/** upsert condition type for table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_If_Matched = {
  match_columns?: Array<FuncionalidadesDesativadas_Insert_Match_Column>;
  update_columns?: Array<FuncionalidadesDesativadas_Update_Column>;
  where?: InputMaybe<FuncionalidadesDesativadas_Bool_Exp>;
};

/** input type for inserting data into table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Insert_Input = {
  codFuncionalidade?: InputMaybe<Scalars['Int']['input']>;
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  dataCadastro?: InputMaybe<Scalars['datetime2']['input']>;
};

/** select match_columns of table "tbFuncionalidadesDesativadas" */
export enum FuncionalidadesDesativadas_Insert_Match_Column {
  /** column name */
  CodFuncionalidade = 'codFuncionalidade',
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  DataCadastro = 'dataCadastro'
}

/** order by max() on columns of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Max_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Min_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Mutation_Response = {
  __typename?: 'funcionalidadesDesativadas_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FuncionalidadesDesativadas>;
};

/** Ordering options when selecting data from "tbFuncionalidadesDesativadas". */
export type FuncionalidadesDesativadas_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  usuarioProfissional?: InputMaybe<UsuariosProfissionais_Order_By>;
};

/** primary key columns input for table: tbFuncionalidadesDesativadas */
export type FuncionalidadesDesativadas_Pk_Columns_Input = {
  codFuncionalidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
};

/** input type for updating data in table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Set_Input = {
  dataCadastro?: InputMaybe<Scalars['datetime2']['input']>;
};

/** order by stddev() on columns of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Stddev_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Stddev_Pop_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Stddev_Samp_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Sum_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** update columns of table "tbFuncionalidadesDesativadas" */
export enum FuncionalidadesDesativadas_Update_Column {
  /** column name */
  DataCadastro = 'dataCadastro'
}

/** order by var_pop() on columns of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Var_Pop_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Var_Samp_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbFuncionalidadesDesativadas" */
export type FuncionalidadesDesativadas_Variance_Order_By = {
  codFuncionalidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "image". All fields are combined with logical 'AND'. */
export type Image_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['image']['input']>;
  _gt?: InputMaybe<Scalars['image']['input']>;
  _gte?: InputMaybe<Scalars['image']['input']>;
  _in?: InputMaybe<Array<Scalars['image']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['image']['input']>;
  _lte?: InputMaybe<Scalars['image']['input']>;
  _neq?: InputMaybe<Scalars['image']['input']>;
  _nin?: InputMaybe<Array<Scalars['image']['input']>>;
};

/** columns and relationships of "tbLembretes" */
export type Lembretes = {
  __typename?: 'lembretes';
  /** An object relationship */
  agendamento: Agendamentos;
  ativo: Scalars['Boolean']['output'];
  codAgendamento: Scalars['Int']['output'];
  codLembrete: Scalars['Int']['output'];
  codPaciente: Scalars['Int']['output'];
  codTipoLembrete: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  dataCadastro: Scalars['datetime2']['output'];
  dataEnviado?: Maybe<Scalars['datetime2']['output']>;
  dataParaEnvio: Scalars['datetime2']['output'];
  /** An object relationship */
  paciente: Pacientes;
  /** An object relationship */
  usuarioCompromisso?: Maybe<UsuariosCompromissos>;
  /** An object relationship */
  usuarioProfissional: UsuariosProfissionais;
};

/** aggregated selection of "tbLembretes" */
export type Lembretes_Aggregate = {
  __typename?: 'lembretes_aggregate';
  aggregate?: Maybe<Lembretes_Aggregate_Fields>;
  nodes: Array<Lembretes>;
};

/** aggregate fields of "tbLembretes" */
export type Lembretes_Aggregate_Fields = {
  __typename?: 'lembretes_aggregate_fields';
  avg?: Maybe<Lembretes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lembretes_Max_Fields>;
  min?: Maybe<Lembretes_Min_Fields>;
  stddev?: Maybe<Lembretes_Stddev_Fields>;
  stddev_pop?: Maybe<Lembretes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lembretes_Stddev_Samp_Fields>;
  sum?: Maybe<Lembretes_Sum_Fields>;
  var_pop?: Maybe<Lembretes_Var_Pop_Fields>;
  var_samp?: Maybe<Lembretes_Var_Samp_Fields>;
  variance?: Maybe<Lembretes_Variance_Fields>;
};


/** aggregate fields of "tbLembretes" */
export type Lembretes_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<Lembretes_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbLembretes" */
export type Lembretes_Aggregate_Order_By = {
  avg?: InputMaybe<Lembretes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lembretes_Max_Order_By>;
  min?: InputMaybe<Lembretes_Min_Order_By>;
  stddev?: InputMaybe<Lembretes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lembretes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lembretes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lembretes_Sum_Order_By>;
  var_pop?: InputMaybe<Lembretes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lembretes_Var_Samp_Order_By>;
  variance?: InputMaybe<Lembretes_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Lembretes_Avg_Fields = {
  __typename?: 'lembretes_avg_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codLembrete?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoLembrete?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbLembretes" */
export type Lembretes_Avg_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbLembretes". All fields are combined with a logical 'AND'. */
export type Lembretes_Bool_Exp = {
  _and?: InputMaybe<Array<Lembretes_Bool_Exp>>;
  _not?: InputMaybe<Lembretes_Bool_Exp>;
  _or?: InputMaybe<Array<Lembretes_Bool_Exp>>;
  agendamento?: InputMaybe<Agendamentos_Bool_Exp>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codLembrete?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPaciente?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoLembrete?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioCompromisso?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataEnviado?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataParaEnvio?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  paciente?: InputMaybe<Pacientes_Bool_Exp>;
  usuarioCompromisso?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
  usuarioProfissional?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};

/** upsert condition type for table "tbLembretes" */
export type Lembretes_If_Matched = {
  match_columns?: Array<Lembretes_Insert_Match_Column>;
  update_columns?: Array<Lembretes_Update_Column>;
  where?: InputMaybe<Lembretes_Bool_Exp>;
};

/** input type for inserting data into table "tbLembretes" */
export type Lembretes_Insert_Input = {
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
  codPaciente?: InputMaybe<Scalars['Int']['input']>;
  codTipoLembrete?: InputMaybe<Scalars['Int']['input']>;
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  codUsuarioCompromisso?: InputMaybe<Scalars['Int']['input']>;
  dataCadastro?: InputMaybe<Scalars['datetime2']['input']>;
  dataEnviado?: InputMaybe<Scalars['datetime2']['input']>;
  dataParaEnvio?: InputMaybe<Scalars['datetime2']['input']>;
};

/** select match_columns of table "tbLembretes" */
export enum Lembretes_Insert_Match_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  CodAgendamento = 'codAgendamento',
  /** column name */
  CodLembrete = 'codLembrete',
  /** column name */
  CodPaciente = 'codPaciente',
  /** column name */
  CodTipoLembrete = 'codTipoLembrete',
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  CodUsuarioCompromisso = 'codUsuarioCompromisso',
  /** column name */
  DataCadastro = 'dataCadastro',
  /** column name */
  DataEnviado = 'dataEnviado',
  /** column name */
  DataParaEnvio = 'dataParaEnvio'
}

/** aggregate max on columns */
export type Lembretes_Max_Fields = {
  __typename?: 'lembretes_max_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codLembrete?: Maybe<Scalars['Int']['output']>;
  codPaciente?: Maybe<Scalars['Int']['output']>;
  codTipoLembrete?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['datetime2']['output']>;
  dataEnviado?: Maybe<Scalars['datetime2']['output']>;
  dataParaEnvio?: Maybe<Scalars['datetime2']['output']>;
};

/** order by max() on columns of table "tbLembretes" */
export type Lembretes_Max_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataEnviado?: InputMaybe<Order_By>;
  dataParaEnvio?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lembretes_Min_Fields = {
  __typename?: 'lembretes_min_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codLembrete?: Maybe<Scalars['Int']['output']>;
  codPaciente?: Maybe<Scalars['Int']['output']>;
  codTipoLembrete?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['datetime2']['output']>;
  dataEnviado?: Maybe<Scalars['datetime2']['output']>;
  dataParaEnvio?: Maybe<Scalars['datetime2']['output']>;
};

/** order by min() on columns of table "tbLembretes" */
export type Lembretes_Min_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataEnviado?: InputMaybe<Order_By>;
  dataParaEnvio?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tbLembretes" */
export type Lembretes_Mutation_Response = {
  __typename?: 'lembretes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lembretes>;
};

/** Ordering options when selecting data from "tbLembretes". */
export type Lembretes_Order_By = {
  agendamento?: InputMaybe<Agendamentos_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataEnviado?: InputMaybe<Order_By>;
  dataParaEnvio?: InputMaybe<Order_By>;
  paciente?: InputMaybe<Pacientes_Order_By>;
  usuarioCompromisso?: InputMaybe<UsuariosCompromissos_Order_By>;
  usuarioProfissional?: InputMaybe<UsuariosProfissionais_Order_By>;
};

/** primary key columns input for table: tbLembretes */
export type Lembretes_Pk_Columns_Input = {
  codLembrete: Scalars['Int']['input'];
};

/** select columns of table "tbLembretes" */
export enum Lembretes_Select_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  CodAgendamento = 'codAgendamento',
  /** column name */
  CodLembrete = 'codLembrete',
  /** column name */
  CodPaciente = 'codPaciente',
  /** column name */
  CodTipoLembrete = 'codTipoLembrete',
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  CodUsuarioCompromisso = 'codUsuarioCompromisso',
  /** column name */
  DataCadastro = 'dataCadastro',
  /** column name */
  DataEnviado = 'dataEnviado',
  /** column name */
  DataParaEnvio = 'dataParaEnvio'
}

/** input type for updating data in table "tbLembretes" */
export type Lembretes_Set_Input = {
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Lembretes_Stddev_Fields = {
  __typename?: 'lembretes_stddev_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codLembrete?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoLembrete?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbLembretes" */
export type Lembretes_Stddev_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lembretes_Stddev_Pop_Fields = {
  __typename?: 'lembretes_stddev_pop_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codLembrete?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoLembrete?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbLembretes" */
export type Lembretes_Stddev_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lembretes_Stddev_Samp_Fields = {
  __typename?: 'lembretes_stddev_samp_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codLembrete?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoLembrete?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbLembretes" */
export type Lembretes_Stddev_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Lembretes_Sum_Fields = {
  __typename?: 'lembretes_sum_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  codLembrete?: Maybe<Scalars['Int']['output']>;
  codPaciente?: Maybe<Scalars['Int']['output']>;
  codTipoLembrete?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tbLembretes" */
export type Lembretes_Sum_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** update columns of table "tbLembretes" */
export enum Lembretes_Update_Column {
  /** column name */
  Ativo = 'ativo'
}

/** aggregate var_pop on columns */
export type Lembretes_Var_Pop_Fields = {
  __typename?: 'lembretes_var_pop_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codLembrete?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoLembrete?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbLembretes" */
export type Lembretes_Var_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lembretes_Var_Samp_Fields = {
  __typename?: 'lembretes_var_samp_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codLembrete?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoLembrete?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbLembretes" */
export type Lembretes_Var_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lembretes_Variance_Fields = {
  __typename?: 'lembretes_variance_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
  codLembrete?: Maybe<Scalars['Float']['output']>;
  codPaciente?: Maybe<Scalars['Float']['output']>;
  codTipoLembrete?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbLembretes" */
export type Lembretes_Variance_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codLembrete?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoLembrete?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbLinksDestinos" */
export type LinksDestinos = {
  __typename?: 'linksDestinos';
  codLinkDestino: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "tbLinksDestinos". All fields are combined with a logical 'AND'. */
export type LinksDestinos_Bool_Exp = {
  _and?: InputMaybe<Array<LinksDestinos_Bool_Exp>>;
  _not?: InputMaybe<LinksDestinos_Bool_Exp>;
  _or?: InputMaybe<Array<LinksDestinos_Bool_Exp>>;
  codLinkDestino?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbLinksDestinos". */
export type LinksDestinos_Order_By = {
  codLinkDestino?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** columns and relationships of "locus.conselho_profissional" */
export type Locus_Conselho_Profissional = {
  __typename?: 'locus_conselho_profissional';
  ativo: Scalars['Boolean']['output'];
  /** An array relationship */
  conselhoProfissionalEspecialidades: Array<Locus_Conselho_Profissional_Especialidade>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  membros: Array<Locus_Membro>;
  nome: Scalars['String']['output'];
  sigla: Scalars['String']['output'];
};


/** columns and relationships of "locus.conselho_profissional" */
export type Locus_Conselho_ProfissionalConselhoProfissionalEspecialidadesArgs = {
  distinct_on?: InputMaybe<Array<Locus_Conselho_Profissional_Especialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Conselho_Profissional_Especialidade_Order_By>>;
  where?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Bool_Exp>;
};


/** columns and relationships of "locus.conselho_profissional" */
export type Locus_Conselho_ProfissionalMembrosArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Order_By>>;
  where?: InputMaybe<Locus_Membro_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "locus.conselho_profissional". All fields are combined with a logical 'AND'. */
export type Locus_Conselho_Profissional_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Conselho_Profissional_Bool_Exp>>;
  _not?: InputMaybe<Locus_Conselho_Profissional_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Conselho_Profissional_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Comparison_Exp>;
  conselhoProfissionalEspecialidades?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  membros?: InputMaybe<Locus_Membro_Bool_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  sigla?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade = {
  __typename?: 'locus_conselho_profissional_especialidade';
  /** An object relationship */
  conselhoProfissional: Locus_Conselho_Profissional;
  /** An object relationship */
  especialidade: Locus_Especialidade;
  idConselhoProfissional: Scalars['Int']['output'];
  idEspecialidade: Scalars['Int']['output'];
};

/** order by aggregate values of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Max_Order_By>;
  min?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Min_Order_By>;
  stddev?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Avg_Order_By = {
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.conselho_profissional_especialidade". All fields are combined with a logical 'AND'. */
export type Locus_Conselho_Profissional_Especialidade_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Conselho_Profissional_Especialidade_Bool_Exp>>;
  _not?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Conselho_Profissional_Especialidade_Bool_Exp>>;
  conselhoProfissional?: InputMaybe<Locus_Conselho_Profissional_Bool_Exp>;
  especialidade?: InputMaybe<Locus_Especialidade_Bool_Exp>;
  idConselhoProfissional?: InputMaybe<Int_Comparison_Exp>;
  idEspecialidade?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Max_Order_By = {
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Min_Order_By = {
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "locus.conselho_profissional_especialidade". */
export type Locus_Conselho_Profissional_Especialidade_Order_By = {
  conselhoProfissional?: InputMaybe<Locus_Conselho_Profissional_Order_By>;
  especialidade?: InputMaybe<Locus_Especialidade_Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** select columns of table "locus.conselho_profissional_especialidade" */
export enum Locus_Conselho_Profissional_Especialidade_Select_Column {
  /** column name */
  IdConselhoProfissional = 'idConselhoProfissional',
  /** column name */
  IdEspecialidade = 'idEspecialidade'
}

/** order by stddev() on columns of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Stddev_Order_By = {
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Stddev_Pop_Order_By = {
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Stddev_Samp_Order_By = {
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Conselho_Profissional_Especialidade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Conselho_Profissional_Especialidade_Stream_Cursor_Value_Input = {
  idConselhoProfissional?: InputMaybe<Scalars['Int']['input']>;
  idEspecialidade?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Sum_Order_By = {
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Var_Pop_Order_By = {
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Var_Samp_Order_By = {
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.conselho_profissional_especialidade" */
export type Locus_Conselho_Profissional_Especialidade_Variance_Order_By = {
  idConselhoProfissional?: InputMaybe<Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "locus.conselho_profissional". */
export type Locus_Conselho_Profissional_Order_By = {
  ativo?: InputMaybe<Order_By>;
  conselhoProfissionalEspecialidades_aggregate?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  membros_aggregate?: InputMaybe<Locus_Membro_Aggregate_Order_By>;
  nome?: InputMaybe<Order_By>;
  sigla?: InputMaybe<Order_By>;
};

/** select columns of table "locus.conselho_profissional" */
export enum Locus_Conselho_Profissional_Select_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  Id = 'id',
  /** column name */
  Nome = 'nome',
  /** column name */
  Sigla = 'sigla'
}

/** Streaming cursor of the table "locus_conselho_profissional" */
export type Locus_Conselho_Profissional_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Conselho_Profissional_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Conselho_Profissional_Stream_Cursor_Value_Input = {
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  sigla?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "locus.curso_formacao" */
export type Locus_Curso_Formacao = {
  __typename?: 'locus_curso_formacao';
  atualizadoEm: Scalars['timestamptz']['output'];
  criadoEm: Scalars['timestamptz']['output'];
  deletado: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** An array relationship */
  membroFormacoesCursoFormacao: Array<Locus_Membro_Formacao>;
  nome: Scalars['String']['output'];
};


/** columns and relationships of "locus.curso_formacao" */
export type Locus_Curso_FormacaoMembroFormacoesCursoFormacaoArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Formacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Formacao_Order_By>>;
  where?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "locus.curso_formacao". All fields are combined with a logical 'AND'. */
export type Locus_Curso_Formacao_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Curso_Formacao_Bool_Exp>>;
  _not?: InputMaybe<Locus_Curso_Formacao_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Curso_Formacao_Bool_Exp>>;
  atualizadoEm?: InputMaybe<Timestamptz_Comparison_Exp>;
  criadoEm?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletado?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  membroFormacoesCursoFormacao?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "locus.curso_formacao". */
export type Locus_Curso_Formacao_Order_By = {
  atualizadoEm?: InputMaybe<Order_By>;
  criadoEm?: InputMaybe<Order_By>;
  deletado?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  membroFormacoesCursoFormacao_aggregate?: InputMaybe<Locus_Membro_Formacao_Aggregate_Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** select columns of table "locus.curso_formacao" */
export enum Locus_Curso_Formacao_Select_Column {
  /** column name */
  AtualizadoEm = 'atualizadoEm',
  /** column name */
  CriadoEm = 'criadoEm',
  /** column name */
  Deletado = 'deletado',
  /** column name */
  Id = 'id',
  /** column name */
  Nome = 'nome'
}

/** Streaming cursor of the table "locus_curso_formacao" */
export type Locus_Curso_Formacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Curso_Formacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Curso_Formacao_Stream_Cursor_Value_Input = {
  atualizadoEm?: InputMaybe<Scalars['timestamptz']['input']>;
  criadoEm?: InputMaybe<Scalars['timestamptz']['input']>;
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "locus.especialidade" */
export type Locus_Especialidade = {
  __typename?: 'locus_especialidade';
  codEspecialidade?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  conselhoProfissionalEspecialidades: Array<Locus_Conselho_Profissional_Especialidade>;
  /** An array relationship */
  especialidadeSubespecialidades: Array<Locus_Especialidade_Subespecialidade>;
  especialista?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  membro_especialidades: Array<Locus_Membro_Especialidade>;
  nome: Scalars['String']['output'];
};


/** columns and relationships of "locus.especialidade" */
export type Locus_EspecialidadeConselhoProfissionalEspecialidadesArgs = {
  distinct_on?: InputMaybe<Array<Locus_Conselho_Profissional_Especialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Conselho_Profissional_Especialidade_Order_By>>;
  where?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Bool_Exp>;
};


/** columns and relationships of "locus.especialidade" */
export type Locus_EspecialidadeEspecialidadeSubespecialidadesArgs = {
  distinct_on?: InputMaybe<Array<Locus_Especialidade_Subespecialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Especialidade_Subespecialidade_Order_By>>;
  where?: InputMaybe<Locus_Especialidade_Subespecialidade_Bool_Exp>;
};


/** columns and relationships of "locus.especialidade" */
export type Locus_EspecialidadeMembro_EspecialidadesArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Especialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Especialidade_Order_By>>;
  where?: InputMaybe<Locus_Membro_Especialidade_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "locus.especialidade". All fields are combined with a logical 'AND'. */
export type Locus_Especialidade_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Especialidade_Bool_Exp>>;
  _not?: InputMaybe<Locus_Especialidade_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Especialidade_Bool_Exp>>;
  codEspecialidade?: InputMaybe<Int_Comparison_Exp>;
  conselhoProfissionalEspecialidades?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Bool_Exp>;
  especialidadeSubespecialidades?: InputMaybe<Locus_Especialidade_Subespecialidade_Bool_Exp>;
  especialista?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  membro_especialidades?: InputMaybe<Locus_Membro_Especialidade_Bool_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "locus.especialidade". */
export type Locus_Especialidade_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  conselhoProfissionalEspecialidades_aggregate?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Aggregate_Order_By>;
  especialidadeSubespecialidades_aggregate?: InputMaybe<Locus_Especialidade_Subespecialidade_Aggregate_Order_By>;
  especialista?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  membro_especialidades_aggregate?: InputMaybe<Locus_Membro_Especialidade_Aggregate_Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** select columns of table "locus.especialidade" */
export enum Locus_Especialidade_Select_Column {
  /** column name */
  CodEspecialidade = 'codEspecialidade',
  /** column name */
  Especialista = 'especialista',
  /** column name */
  Id = 'id',
  /** column name */
  Nome = 'nome'
}

/** Streaming cursor of the table "locus_especialidade" */
export type Locus_Especialidade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Especialidade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Especialidade_Stream_Cursor_Value_Input = {
  codEspecialidade?: InputMaybe<Scalars['Int']['input']>;
  especialista?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade = {
  __typename?: 'locus_especialidade_subespecialidade';
  idEspecialidade: Scalars['Int']['output'];
  idSubespecialidade: Scalars['Int']['output'];
  /** An array relationship */
  membro_especialidade_subespecialidades: Array<Locus_Membro_Especialidade_Subespecialidade>;
  /** An object relationship */
  subespecialidade: Locus_Subespecialidade;
};


/** columns and relationships of "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_SubespecialidadeMembro_Especialidade_SubespecialidadesArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Especialidade_Subespecialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Especialidade_Subespecialidade_Order_By>>;
  where?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Bool_Exp>;
};

/** order by aggregate values of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Especialidade_Subespecialidade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Especialidade_Subespecialidade_Max_Order_By>;
  min?: InputMaybe<Locus_Especialidade_Subespecialidade_Min_Order_By>;
  stddev?: InputMaybe<Locus_Especialidade_Subespecialidade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Especialidade_Subespecialidade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Especialidade_Subespecialidade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Especialidade_Subespecialidade_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Especialidade_Subespecialidade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Especialidade_Subespecialidade_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Especialidade_Subespecialidade_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Avg_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.especialidade_subespecialidade". All fields are combined with a logical 'AND'. */
export type Locus_Especialidade_Subespecialidade_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Especialidade_Subespecialidade_Bool_Exp>>;
  _not?: InputMaybe<Locus_Especialidade_Subespecialidade_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Especialidade_Subespecialidade_Bool_Exp>>;
  idEspecialidade?: InputMaybe<Int_Comparison_Exp>;
  idSubespecialidade?: InputMaybe<Int_Comparison_Exp>;
  membro_especialidade_subespecialidades?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Bool_Exp>;
  subespecialidade?: InputMaybe<Locus_Subespecialidade_Bool_Exp>;
};

/** order by max() on columns of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Max_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Min_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "locus.especialidade_subespecialidade". */
export type Locus_Especialidade_Subespecialidade_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
  membro_especialidade_subespecialidades_aggregate?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Aggregate_Order_By>;
  subespecialidade?: InputMaybe<Locus_Subespecialidade_Order_By>;
};

/** select columns of table "locus.especialidade_subespecialidade" */
export enum Locus_Especialidade_Subespecialidade_Select_Column {
  /** column name */
  IdEspecialidade = 'idEspecialidade',
  /** column name */
  IdSubespecialidade = 'idSubespecialidade'
}

/** order by stddev() on columns of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Stddev_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Stddev_Pop_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Stddev_Samp_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Especialidade_Subespecialidade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Especialidade_Subespecialidade_Stream_Cursor_Value_Input = {
  idEspecialidade?: InputMaybe<Scalars['Int']['input']>;
  idSubespecialidade?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Sum_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Var_Pop_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Var_Samp_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.especialidade_subespecialidade" */
export type Locus_Especialidade_Subespecialidade_Variance_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** columns and relationships of "locus.experiencia_membro" */
export type Locus_Experiencia_Membro = {
  __typename?: 'locus_experiencia_membro';
  deletado: Scalars['Boolean']['output'];
  experiencia: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  idMembro: Scalars['Int']['output'];
  /** An object relationship */
  membro: Locus_Membro;
};

/** order by aggregate values of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Experiencia_Membro_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Experiencia_Membro_Max_Order_By>;
  min?: InputMaybe<Locus_Experiencia_Membro_Min_Order_By>;
  stddev?: InputMaybe<Locus_Experiencia_Membro_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Experiencia_Membro_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Experiencia_Membro_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Experiencia_Membro_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Experiencia_Membro_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Experiencia_Membro_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Experiencia_Membro_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.experiencia_membro". All fields are combined with a logical 'AND'. */
export type Locus_Experiencia_Membro_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Experiencia_Membro_Bool_Exp>>;
  _not?: InputMaybe<Locus_Experiencia_Membro_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Experiencia_Membro_Bool_Exp>>;
  deletado?: InputMaybe<Boolean_Comparison_Exp>;
  experiencia?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  idMembro?: InputMaybe<Int_Comparison_Exp>;
  membro?: InputMaybe<Locus_Membro_Bool_Exp>;
};

/** unique or primary key constraints on table "locus.experiencia_membro" */
export enum Locus_Experiencia_Membro_Constraint {
  /** unique or primary key constraint on columns "id" */
  ExperienciaMembroPkey = 'experiencia_membro_pkey'
}

/** input type for inserting data into table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Insert_Input = {
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  experiencia?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Max_Order_By = {
  experiencia?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Min_Order_By = {
  experiencia?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Mutation_Response = {
  __typename?: 'locus_experiencia_membro_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Locus_Experiencia_Membro>;
};

/** on_conflict condition type for table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_On_Conflict = {
  constraint: Locus_Experiencia_Membro_Constraint;
  update_columns?: Array<Locus_Experiencia_Membro_Update_Column>;
  where?: InputMaybe<Locus_Experiencia_Membro_Bool_Exp>;
};

/** Ordering options when selecting data from "locus.experiencia_membro". */
export type Locus_Experiencia_Membro_Order_By = {
  deletado?: InputMaybe<Order_By>;
  experiencia?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  membro?: InputMaybe<Locus_Membro_Order_By>;
};

/** primary key columns input for table: locus.experiencia_membro */
export type Locus_Experiencia_Membro_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "locus.experiencia_membro" */
export enum Locus_Experiencia_Membro_Select_Column {
  /** column name */
  Deletado = 'deletado',
  /** column name */
  Experiencia = 'experiencia',
  /** column name */
  Id = 'id',
  /** column name */
  IdMembro = 'idMembro'
}

/** input type for updating data in table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Set_Input = {
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  experiencia?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_experiencia_membro" */
export type Locus_Experiencia_Membro_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Experiencia_Membro_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Experiencia_Membro_Stream_Cursor_Value_Input = {
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  experiencia?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** update columns of table "locus.experiencia_membro" */
export enum Locus_Experiencia_Membro_Update_Column {
  /** column name */
  Deletado = 'deletado',
  /** column name */
  Experiencia = 'experiencia'
}

export type Locus_Experiencia_Membro_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Locus_Experiencia_Membro_Set_Input>;
  /** filter the rows which have to be updated */
  where: Locus_Experiencia_Membro_Bool_Exp;
};

/** order by var_pop() on columns of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.experiencia_membro" */
export type Locus_Experiencia_Membro_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** columns and relationships of "locus.faq_membro" */
export type Locus_Faq_Membro = {
  __typename?: 'locus_faq_membro';
  deletado: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  idMembro: Scalars['Int']['output'];
  /** An object relationship */
  membro: Locus_Membro;
  pergunta: Scalars['String']['output'];
  resposta: Scalars['String']['output'];
};

/** order by aggregate values of table "locus.faq_membro" */
export type Locus_Faq_Membro_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Faq_Membro_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Faq_Membro_Max_Order_By>;
  min?: InputMaybe<Locus_Faq_Membro_Min_Order_By>;
  stddev?: InputMaybe<Locus_Faq_Membro_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Faq_Membro_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Faq_Membro_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Faq_Membro_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Faq_Membro_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Faq_Membro_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Faq_Membro_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.faq_membro" */
export type Locus_Faq_Membro_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.faq_membro". All fields are combined with a logical 'AND'. */
export type Locus_Faq_Membro_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Faq_Membro_Bool_Exp>>;
  _not?: InputMaybe<Locus_Faq_Membro_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Faq_Membro_Bool_Exp>>;
  deletado?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  idMembro?: InputMaybe<Int_Comparison_Exp>;
  membro?: InputMaybe<Locus_Membro_Bool_Exp>;
  pergunta?: InputMaybe<String_Comparison_Exp>;
  resposta?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "locus.faq_membro" */
export enum Locus_Faq_Membro_Constraint {
  /** unique or primary key constraint on columns "id" */
  FaqMembroPkey = 'faq_membro_pkey'
}

/** input type for incrementing numeric columns in table "locus.faq_membro" */
export type Locus_Faq_Membro_Inc_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "locus.faq_membro" */
export type Locus_Faq_Membro_Insert_Input = {
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
  pergunta?: InputMaybe<Scalars['String']['input']>;
  resposta?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "locus.faq_membro" */
export type Locus_Faq_Membro_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  pergunta?: InputMaybe<Order_By>;
  resposta?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.faq_membro" */
export type Locus_Faq_Membro_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  pergunta?: InputMaybe<Order_By>;
  resposta?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "locus.faq_membro" */
export type Locus_Faq_Membro_Mutation_Response = {
  __typename?: 'locus_faq_membro_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Locus_Faq_Membro>;
};

/** on_conflict condition type for table "locus.faq_membro" */
export type Locus_Faq_Membro_On_Conflict = {
  constraint: Locus_Faq_Membro_Constraint;
  update_columns?: Array<Locus_Faq_Membro_Update_Column>;
  where?: InputMaybe<Locus_Faq_Membro_Bool_Exp>;
};

/** Ordering options when selecting data from "locus.faq_membro". */
export type Locus_Faq_Membro_Order_By = {
  deletado?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  membro?: InputMaybe<Locus_Membro_Order_By>;
  pergunta?: InputMaybe<Order_By>;
  resposta?: InputMaybe<Order_By>;
};

/** primary key columns input for table: locus.faq_membro */
export type Locus_Faq_Membro_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "locus.faq_membro" */
export enum Locus_Faq_Membro_Select_Column {
  /** column name */
  Deletado = 'deletado',
  /** column name */
  Id = 'id',
  /** column name */
  IdMembro = 'idMembro',
  /** column name */
  Pergunta = 'pergunta',
  /** column name */
  Resposta = 'resposta'
}

/** input type for updating data in table "locus.faq_membro" */
export type Locus_Faq_Membro_Set_Input = {
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
  pergunta?: InputMaybe<Scalars['String']['input']>;
  resposta?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "locus.faq_membro" */
export type Locus_Faq_Membro_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.faq_membro" */
export type Locus_Faq_Membro_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.faq_membro" */
export type Locus_Faq_Membro_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_faq_membro" */
export type Locus_Faq_Membro_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Faq_Membro_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Faq_Membro_Stream_Cursor_Value_Input = {
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
  pergunta?: InputMaybe<Scalars['String']['input']>;
  resposta?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "locus.faq_membro" */
export type Locus_Faq_Membro_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** update columns of table "locus.faq_membro" */
export enum Locus_Faq_Membro_Update_Column {
  /** column name */
  Deletado = 'deletado',
  /** column name */
  Id = 'id',
  /** column name */
  IdMembro = 'idMembro',
  /** column name */
  Pergunta = 'pergunta',
  /** column name */
  Resposta = 'resposta'
}

export type Locus_Faq_Membro_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Locus_Faq_Membro_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Locus_Faq_Membro_Set_Input>;
  /** filter the rows which have to be updated */
  where: Locus_Faq_Membro_Bool_Exp;
};

/** order by var_pop() on columns of table "locus.faq_membro" */
export type Locus_Faq_Membro_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.faq_membro" */
export type Locus_Faq_Membro_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.faq_membro" */
export type Locus_Faq_Membro_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** columns and relationships of "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro = {
  __typename?: 'locus_foco_tratamento_membro';
  deletado: Scalars['Boolean']['output'];
  focoTratamento: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  idMembro: Scalars['Int']['output'];
  /** An object relationship */
  membro: Locus_Membro;
};

/** order by aggregate values of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Foco_Tratamento_Membro_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Foco_Tratamento_Membro_Max_Order_By>;
  min?: InputMaybe<Locus_Foco_Tratamento_Membro_Min_Order_By>;
  stddev?: InputMaybe<Locus_Foco_Tratamento_Membro_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Foco_Tratamento_Membro_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Foco_Tratamento_Membro_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Foco_Tratamento_Membro_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Foco_Tratamento_Membro_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Foco_Tratamento_Membro_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Foco_Tratamento_Membro_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.foco_tratamento_membro". All fields are combined with a logical 'AND'. */
export type Locus_Foco_Tratamento_Membro_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Foco_Tratamento_Membro_Bool_Exp>>;
  _not?: InputMaybe<Locus_Foco_Tratamento_Membro_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Foco_Tratamento_Membro_Bool_Exp>>;
  deletado?: InputMaybe<Boolean_Comparison_Exp>;
  focoTratamento?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  idMembro?: InputMaybe<Int_Comparison_Exp>;
  membro?: InputMaybe<Locus_Membro_Bool_Exp>;
};

/** unique or primary key constraints on table "locus.foco_tratamento_membro" */
export enum Locus_Foco_Tratamento_Membro_Constraint {
  /** unique or primary key constraint on columns "id" */
  FocoTratamentoMembroPkey = 'foco_tratamento_membro_pkey'
}

/** input type for inserting data into table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Insert_Input = {
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  focoTratamento?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Max_Order_By = {
  focoTratamento?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Min_Order_By = {
  focoTratamento?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Mutation_Response = {
  __typename?: 'locus_foco_tratamento_membro_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Locus_Foco_Tratamento_Membro>;
};

/** on_conflict condition type for table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_On_Conflict = {
  constraint: Locus_Foco_Tratamento_Membro_Constraint;
  update_columns?: Array<Locus_Foco_Tratamento_Membro_Update_Column>;
  where?: InputMaybe<Locus_Foco_Tratamento_Membro_Bool_Exp>;
};

/** Ordering options when selecting data from "locus.foco_tratamento_membro". */
export type Locus_Foco_Tratamento_Membro_Order_By = {
  deletado?: InputMaybe<Order_By>;
  focoTratamento?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  membro?: InputMaybe<Locus_Membro_Order_By>;
};

/** primary key columns input for table: locus.foco_tratamento_membro */
export type Locus_Foco_Tratamento_Membro_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "locus.foco_tratamento_membro" */
export enum Locus_Foco_Tratamento_Membro_Select_Column {
  /** column name */
  Deletado = 'deletado',
  /** column name */
  FocoTratamento = 'focoTratamento',
  /** column name */
  Id = 'id',
  /** column name */
  IdMembro = 'idMembro'
}

/** input type for updating data in table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Set_Input = {
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  focoTratamento?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Foco_Tratamento_Membro_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Foco_Tratamento_Membro_Stream_Cursor_Value_Input = {
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  focoTratamento?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** update columns of table "locus.foco_tratamento_membro" */
export enum Locus_Foco_Tratamento_Membro_Update_Column {
  /** column name */
  Deletado = 'deletado',
  /** column name */
  FocoTratamento = 'focoTratamento'
}

export type Locus_Foco_Tratamento_Membro_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Locus_Foco_Tratamento_Membro_Set_Input>;
  /** filter the rows which have to be updated */
  where: Locus_Foco_Tratamento_Membro_Bool_Exp;
};

/** order by var_pop() on columns of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.foco_tratamento_membro" */
export type Locus_Foco_Tratamento_Membro_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** columns and relationships of "locus.instituicao_ensino" */
export type Locus_Instituicao_Ensino = {
  __typename?: 'locus_instituicao_ensino';
  atualizadoEm: Scalars['timestamptz']['output'];
  criadoEm: Scalars['timestamptz']['output'];
  deletado: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  membroFormacoesInstituicaoEnsino: Array<Locus_Membro_Formacao>;
  nome: Scalars['String']['output'];
  sigla?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "locus.instituicao_ensino" */
export type Locus_Instituicao_EnsinoMembroFormacoesInstituicaoEnsinoArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Formacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Formacao_Order_By>>;
  where?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "locus.instituicao_ensino". All fields are combined with a logical 'AND'. */
export type Locus_Instituicao_Ensino_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Instituicao_Ensino_Bool_Exp>>;
  _not?: InputMaybe<Locus_Instituicao_Ensino_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Instituicao_Ensino_Bool_Exp>>;
  atualizadoEm?: InputMaybe<Timestamptz_Comparison_Exp>;
  criadoEm?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletado?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  membroFormacoesInstituicaoEnsino?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  sigla?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "locus.instituicao_ensino". */
export type Locus_Instituicao_Ensino_Order_By = {
  atualizadoEm?: InputMaybe<Order_By>;
  criadoEm?: InputMaybe<Order_By>;
  deletado?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  membroFormacoesInstituicaoEnsino_aggregate?: InputMaybe<Locus_Membro_Formacao_Aggregate_Order_By>;
  nome?: InputMaybe<Order_By>;
  sigla?: InputMaybe<Order_By>;
};

/** select columns of table "locus.instituicao_ensino" */
export enum Locus_Instituicao_Ensino_Select_Column {
  /** column name */
  AtualizadoEm = 'atualizadoEm',
  /** column name */
  CriadoEm = 'criadoEm',
  /** column name */
  Deletado = 'deletado',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Nome = 'nome',
  /** column name */
  Sigla = 'sigla'
}

/** Streaming cursor of the table "locus_instituicao_ensino" */
export type Locus_Instituicao_Ensino_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Instituicao_Ensino_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Instituicao_Ensino_Stream_Cursor_Value_Input = {
  atualizadoEm?: InputMaybe<Scalars['timestamptz']['input']>;
  criadoEm?: InputMaybe<Scalars['timestamptz']['input']>;
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  sigla?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "locus.instituicao_medica" */
export type Locus_Instituicao_Medica = {
  __typename?: 'locus_instituicao_medica';
  atualizadoEm: Scalars['timestamptz']['output'];
  criadoEm: Scalars['timestamptz']['output'];
  deletado: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  membroInstituicoesMedicas: Array<Locus_Membro_Instituicao_Medica>;
  nome: Scalars['String']['output'];
  tipoInstituicao: Scalars['String']['output'];
};


/** columns and relationships of "locus.instituicao_medica" */
export type Locus_Instituicao_MedicaMembroInstituicoesMedicasArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Order_By>>;
  where?: InputMaybe<Locus_Membro_Instituicao_Medica_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "locus.instituicao_medica". All fields are combined with a logical 'AND'. */
export type Locus_Instituicao_Medica_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Instituicao_Medica_Bool_Exp>>;
  _not?: InputMaybe<Locus_Instituicao_Medica_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Instituicao_Medica_Bool_Exp>>;
  atualizadoEm?: InputMaybe<Timestamptz_Comparison_Exp>;
  criadoEm?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletado?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  logo?: InputMaybe<String_Comparison_Exp>;
  membroInstituicoesMedicas?: InputMaybe<Locus_Membro_Instituicao_Medica_Bool_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  tipoInstituicao?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "locus.instituicao_medica". */
export type Locus_Instituicao_Medica_Order_By = {
  atualizadoEm?: InputMaybe<Order_By>;
  criadoEm?: InputMaybe<Order_By>;
  deletado?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Order_By>;
  membroInstituicoesMedicas_aggregate?: InputMaybe<Locus_Membro_Instituicao_Medica_Aggregate_Order_By>;
  nome?: InputMaybe<Order_By>;
  tipoInstituicao?: InputMaybe<Order_By>;
};

/** select columns of table "locus.instituicao_medica" */
export enum Locus_Instituicao_Medica_Select_Column {
  /** column name */
  AtualizadoEm = 'atualizadoEm',
  /** column name */
  CriadoEm = 'criadoEm',
  /** column name */
  Deletado = 'deletado',
  /** column name */
  Id = 'id',
  /** column name */
  Logo = 'logo',
  /** column name */
  Nome = 'nome',
  /** column name */
  TipoInstituicao = 'tipoInstituicao'
}

/** Streaming cursor of the table "locus_instituicao_medica" */
export type Locus_Instituicao_Medica_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Instituicao_Medica_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Instituicao_Medica_Stream_Cursor_Value_Input = {
  atualizadoEm?: InputMaybe<Scalars['timestamptz']['input']>;
  criadoEm?: InputMaybe<Scalars['timestamptz']['input']>;
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  tipoInstituicao?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "locus.membro" */
export type Locus_Membro = {
  __typename?: 'locus_membro';
  apelido: Scalars['String']['output'];
  ativo: Scalars['Boolean']['output'];
  codConselhoClasse?: Maybe<Scalars['String']['output']>;
  codUsuario: Scalars['Int']['output'];
  /** An object relationship */
  conselhoProfissional?: Maybe<Locus_Conselho_Profissional>;
  duracaoInicialConsulta?: Maybe<Scalars['time']['output']>;
  /** An array relationship */
  experiencias: Array<Locus_Experiencia_Membro>;
  /** An array relationship */
  faqs: Array<Locus_Faq_Membro>;
  /** An array relationship */
  focosTratamentos: Array<Locus_Foco_Tratamento_Membro>;
  formasPagamento?: Maybe<Scalars['String']['output']>;
  fotoUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  idConselhoProfissional?: Maybe<Scalars['Int']['output']>;
  maisInformacoes?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  membroEspecialidades: Array<Locus_Membro_Especialidade>;
  /** An array relationship */
  membroFormacoes: Array<Locus_Membro_Formacao>;
  /** An array relationship */
  membroInstituicoesMedicas: Array<Locus_Membro_Instituicao_Medica>;
  nome: Scalars['String']['output'];
  numeroConselhoClasse: Scalars['String']['output'];
  observacoes?: Maybe<Scalars['String']['output']>;
  pronome?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  rede_social_membros: Array<Locus_Rede_Social_Membro>;
  resumo: Scalars['String']['output'];
  resumoSecundario?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sobre?: Maybe<Scalars['String']['output']>;
  sobrenome: Scalars['String']['output'];
  telefone?: Maybe<Scalars['String']['output']>;
  ufConselhoClasse: Scalars['String']['output'];
  usuarioLivance?: Maybe<Usuarios>;
  valorInicialConsulta?: Maybe<Scalars['numeric']['output']>;
};


/** columns and relationships of "locus.membro" */
export type Locus_MembroExperienciasArgs = {
  distinct_on?: InputMaybe<Array<Locus_Experiencia_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Experiencia_Membro_Order_By>>;
  where?: InputMaybe<Locus_Experiencia_Membro_Bool_Exp>;
};


/** columns and relationships of "locus.membro" */
export type Locus_MembroFaqsArgs = {
  distinct_on?: InputMaybe<Array<Locus_Faq_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Faq_Membro_Order_By>>;
  where?: InputMaybe<Locus_Faq_Membro_Bool_Exp>;
};


/** columns and relationships of "locus.membro" */
export type Locus_MembroFocosTratamentosArgs = {
  distinct_on?: InputMaybe<Array<Locus_Foco_Tratamento_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Foco_Tratamento_Membro_Order_By>>;
  where?: InputMaybe<Locus_Foco_Tratamento_Membro_Bool_Exp>;
};


/** columns and relationships of "locus.membro" */
export type Locus_MembroMembroEspecialidadesArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Especialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Especialidade_Order_By>>;
  where?: InputMaybe<Locus_Membro_Especialidade_Bool_Exp>;
};


/** columns and relationships of "locus.membro" */
export type Locus_MembroMembroFormacoesArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Formacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Formacao_Order_By>>;
  where?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
};


/** columns and relationships of "locus.membro" */
export type Locus_MembroMembroInstituicoesMedicasArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Order_By>>;
  where?: InputMaybe<Locus_Membro_Instituicao_Medica_Bool_Exp>;
};


/** columns and relationships of "locus.membro" */
export type Locus_MembroRede_Social_MembrosArgs = {
  distinct_on?: InputMaybe<Array<Locus_Rede_Social_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Rede_Social_Membro_Order_By>>;
  where?: InputMaybe<Locus_Rede_Social_Membro_Bool_Exp>;
};

/** order by aggregate values of table "locus.membro" */
export type Locus_Membro_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Membro_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Membro_Max_Order_By>;
  min?: InputMaybe<Locus_Membro_Min_Order_By>;
  stddev?: InputMaybe<Locus_Membro_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Membro_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Membro_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Membro_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Membro_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Membro_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Membro_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.membro" */
export type Locus_Membro_Avg_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.membro". All fields are combined with a logical 'AND'. */
export type Locus_Membro_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Membro_Bool_Exp>>;
  _not?: InputMaybe<Locus_Membro_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Membro_Bool_Exp>>;
  apelido?: InputMaybe<String_Comparison_Exp>;
  ativo?: InputMaybe<Boolean_Comparison_Exp>;
  codConselhoClasse?: InputMaybe<String_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Comparison_Exp>;
  conselhoProfissional?: InputMaybe<Locus_Conselho_Profissional_Bool_Exp>;
  duracaoInicialConsulta?: InputMaybe<Time_Comparison_Exp>;
  experiencias?: InputMaybe<Locus_Experiencia_Membro_Bool_Exp>;
  faqs?: InputMaybe<Locus_Faq_Membro_Bool_Exp>;
  focosTratamentos?: InputMaybe<Locus_Foco_Tratamento_Membro_Bool_Exp>;
  formasPagamento?: InputMaybe<String_Comparison_Exp>;
  fotoUrl?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  idConselhoProfissional?: InputMaybe<Int_Comparison_Exp>;
  maisInformacoes?: InputMaybe<String_Comparison_Exp>;
  membroEspecialidades?: InputMaybe<Locus_Membro_Especialidade_Bool_Exp>;
  membroFormacoes?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
  membroInstituicoesMedicas?: InputMaybe<Locus_Membro_Instituicao_Medica_Bool_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
  numeroConselhoClasse?: InputMaybe<String_Comparison_Exp>;
  observacoes?: InputMaybe<String_Comparison_Exp>;
  pronome?: InputMaybe<String_Comparison_Exp>;
  rede_social_membros?: InputMaybe<Locus_Rede_Social_Membro_Bool_Exp>;
  resumo?: InputMaybe<String_Comparison_Exp>;
  resumoSecundario?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  sobre?: InputMaybe<String_Comparison_Exp>;
  sobrenome?: InputMaybe<String_Comparison_Exp>;
  telefone?: InputMaybe<String_Comparison_Exp>;
  ufConselhoClasse?: InputMaybe<String_Comparison_Exp>;
  valorInicialConsulta?: InputMaybe<Numeric_Comparison_Exp>;
};

/** columns and relationships of "locus.membro_especialidade" */
export type Locus_Membro_Especialidade = {
  __typename?: 'locus_membro_especialidade';
  /** An object relationship */
  especialidade: Locus_Especialidade;
  idEspecialidade: Scalars['Int']['output'];
  idMembro: Scalars['Int']['output'];
  /** An object relationship */
  membro: Locus_Membro;
  /** An array relationship */
  membroEspecialidadeSubespecialidades: Array<Locus_Membro_Especialidade_Subespecialidade>;
  prioridade?: Maybe<Scalars['Int']['output']>;
  rqe?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "locus.membro_especialidade" */
export type Locus_Membro_EspecialidadeMembroEspecialidadeSubespecialidadesArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Especialidade_Subespecialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Especialidade_Subespecialidade_Order_By>>;
  where?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Bool_Exp>;
};

/** order by aggregate values of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Membro_Especialidade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Membro_Especialidade_Max_Order_By>;
  min?: InputMaybe<Locus_Membro_Especialidade_Min_Order_By>;
  stddev?: InputMaybe<Locus_Membro_Especialidade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Membro_Especialidade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Membro_Especialidade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Membro_Especialidade_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Membro_Especialidade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Membro_Especialidade_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Membro_Especialidade_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Avg_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.membro_especialidade". All fields are combined with a logical 'AND'. */
export type Locus_Membro_Especialidade_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Membro_Especialidade_Bool_Exp>>;
  _not?: InputMaybe<Locus_Membro_Especialidade_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Membro_Especialidade_Bool_Exp>>;
  especialidade?: InputMaybe<Locus_Especialidade_Bool_Exp>;
  idEspecialidade?: InputMaybe<Int_Comparison_Exp>;
  idMembro?: InputMaybe<Int_Comparison_Exp>;
  membro?: InputMaybe<Locus_Membro_Bool_Exp>;
  membroEspecialidadeSubespecialidades?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Bool_Exp>;
  prioridade?: InputMaybe<Int_Comparison_Exp>;
  rqe?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Max_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
  rqe?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Min_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
  rqe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "locus.membro_especialidade". */
export type Locus_Membro_Especialidade_Order_By = {
  especialidade?: InputMaybe<Locus_Especialidade_Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  membro?: InputMaybe<Locus_Membro_Order_By>;
  membroEspecialidadeSubespecialidades_aggregate?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Aggregate_Order_By>;
  prioridade?: InputMaybe<Order_By>;
  rqe?: InputMaybe<Order_By>;
};

/** select columns of table "locus.membro_especialidade" */
export enum Locus_Membro_Especialidade_Select_Column {
  /** column name */
  IdEspecialidade = 'idEspecialidade',
  /** column name */
  IdMembro = 'idMembro',
  /** column name */
  Prioridade = 'prioridade',
  /** column name */
  Rqe = 'rqe'
}

/** order by stddev() on columns of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Stddev_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Stddev_Pop_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Stddev_Samp_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_membro_especialidade" */
export type Locus_Membro_Especialidade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Membro_Especialidade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Membro_Especialidade_Stream_Cursor_Value_Input = {
  idEspecialidade?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
  prioridade?: InputMaybe<Scalars['Int']['input']>;
  rqe?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade = {
  __typename?: 'locus_membro_especialidade_subespecialidade';
  ativo: Scalars['Boolean']['output'];
  /** An object relationship */
  especialidadeSubespecialidade: Locus_Especialidade_Subespecialidade;
  idEspecialidade: Scalars['Int']['output'];
  idMembro: Scalars['Int']['output'];
  idSubespecialidade: Scalars['Int']['output'];
  /** An object relationship */
  membroEspecialidade: Locus_Membro_Especialidade;
  rqe?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Max_Order_By>;
  min?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Min_Order_By>;
  stddev?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Avg_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.membro_especialidade_subespecialidade". All fields are combined with a logical 'AND'. */
export type Locus_Membro_Especialidade_Subespecialidade_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Membro_Especialidade_Subespecialidade_Bool_Exp>>;
  _not?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Membro_Especialidade_Subespecialidade_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Comparison_Exp>;
  especialidadeSubespecialidade?: InputMaybe<Locus_Especialidade_Subespecialidade_Bool_Exp>;
  idEspecialidade?: InputMaybe<Int_Comparison_Exp>;
  idMembro?: InputMaybe<Int_Comparison_Exp>;
  idSubespecialidade?: InputMaybe<Int_Comparison_Exp>;
  membroEspecialidade?: InputMaybe<Locus_Membro_Especialidade_Bool_Exp>;
  rqe?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Max_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
  rqe?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Min_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
  rqe?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "locus.membro_especialidade_subespecialidade". */
export type Locus_Membro_Especialidade_Subespecialidade_Order_By = {
  ativo?: InputMaybe<Order_By>;
  especialidadeSubespecialidade?: InputMaybe<Locus_Especialidade_Subespecialidade_Order_By>;
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
  membroEspecialidade?: InputMaybe<Locus_Membro_Especialidade_Order_By>;
  rqe?: InputMaybe<Order_By>;
};

/** select columns of table "locus.membro_especialidade_subespecialidade" */
export enum Locus_Membro_Especialidade_Subespecialidade_Select_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  IdEspecialidade = 'idEspecialidade',
  /** column name */
  IdMembro = 'idMembro',
  /** column name */
  IdSubespecialidade = 'idSubespecialidade',
  /** column name */
  Rqe = 'rqe'
}

/** order by stddev() on columns of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Stddev_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Stddev_Pop_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Stddev_Samp_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Membro_Especialidade_Subespecialidade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Membro_Especialidade_Subespecialidade_Stream_Cursor_Value_Input = {
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  idEspecialidade?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
  idSubespecialidade?: InputMaybe<Scalars['Int']['input']>;
  rqe?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Sum_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Var_Pop_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Var_Samp_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.membro_especialidade_subespecialidade" */
export type Locus_Membro_Especialidade_Subespecialidade_Variance_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  idSubespecialidade?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Sum_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Var_Pop_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Var_Samp_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.membro_especialidade" */
export type Locus_Membro_Especialidade_Variance_Order_By = {
  idEspecialidade?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** columns and relationships of "locus.membro_formacao" */
export type Locus_Membro_Formacao = {
  __typename?: 'locus_membro_formacao';
  conclusao: Scalars['date']['output'];
  /** An object relationship */
  cursoFormacao: Locus_Curso_Formacao;
  idCurso: Scalars['Int']['output'];
  idInstituicaoEnsino: Scalars['Int']['output'];
  idMembro: Scalars['Int']['output'];
  inicio?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  instituicaoEnsino: Locus_Instituicao_Ensino;
  /** An object relationship */
  membro: Locus_Membro;
};

/** order by aggregate values of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Membro_Formacao_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Membro_Formacao_Max_Order_By>;
  min?: InputMaybe<Locus_Membro_Formacao_Min_Order_By>;
  stddev?: InputMaybe<Locus_Membro_Formacao_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Membro_Formacao_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Membro_Formacao_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Membro_Formacao_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Membro_Formacao_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Membro_Formacao_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Membro_Formacao_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Avg_Order_By = {
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.membro_formacao". All fields are combined with a logical 'AND'. */
export type Locus_Membro_Formacao_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Membro_Formacao_Bool_Exp>>;
  _not?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Membro_Formacao_Bool_Exp>>;
  conclusao?: InputMaybe<Date_Comparison_Exp>;
  cursoFormacao?: InputMaybe<Locus_Curso_Formacao_Bool_Exp>;
  idCurso?: InputMaybe<Int_Comparison_Exp>;
  idInstituicaoEnsino?: InputMaybe<Int_Comparison_Exp>;
  idMembro?: InputMaybe<Int_Comparison_Exp>;
  inicio?: InputMaybe<Date_Comparison_Exp>;
  instituicaoEnsino?: InputMaybe<Locus_Instituicao_Ensino_Bool_Exp>;
  membro?: InputMaybe<Locus_Membro_Bool_Exp>;
};

/** unique or primary key constraints on table "locus.membro_formacao" */
export enum Locus_Membro_Formacao_Constraint {
  /** unique or primary key constraint on columns "id_curso", "id_membro", "id_instituicao_ensino" */
  MembroFormacaoPkey1 = 'membro_formacao_pkey1'
}

/** input type for incrementing numeric columns in table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Inc_Input = {
  idCurso?: InputMaybe<Scalars['Int']['input']>;
  idInstituicaoEnsino?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Insert_Input = {
  conclusao?: InputMaybe<Scalars['date']['input']>;
  idCurso?: InputMaybe<Scalars['Int']['input']>;
  idInstituicaoEnsino?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Max_Order_By = {
  conclusao?: InputMaybe<Order_By>;
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  inicio?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Min_Order_By = {
  conclusao?: InputMaybe<Order_By>;
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  inicio?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Mutation_Response = {
  __typename?: 'locus_membro_formacao_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Locus_Membro_Formacao>;
};

/** on_conflict condition type for table "locus.membro_formacao" */
export type Locus_Membro_Formacao_On_Conflict = {
  constraint: Locus_Membro_Formacao_Constraint;
  update_columns?: Array<Locus_Membro_Formacao_Update_Column>;
  where?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
};

/** Ordering options when selecting data from "locus.membro_formacao". */
export type Locus_Membro_Formacao_Order_By = {
  conclusao?: InputMaybe<Order_By>;
  cursoFormacao?: InputMaybe<Locus_Curso_Formacao_Order_By>;
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  inicio?: InputMaybe<Order_By>;
  instituicaoEnsino?: InputMaybe<Locus_Instituicao_Ensino_Order_By>;
  membro?: InputMaybe<Locus_Membro_Order_By>;
};

/** primary key columns input for table: locus.membro_formacao */
export type Locus_Membro_Formacao_Pk_Columns_Input = {
  idCurso: Scalars['Int']['input'];
  idInstituicaoEnsino: Scalars['Int']['input'];
  idMembro: Scalars['Int']['input'];
};

/** select columns of table "locus.membro_formacao" */
export enum Locus_Membro_Formacao_Select_Column {
  /** column name */
  Conclusao = 'conclusao',
  /** column name */
  IdCurso = 'idCurso',
  /** column name */
  IdInstituicaoEnsino = 'idInstituicaoEnsino',
  /** column name */
  IdMembro = 'idMembro',
  /** column name */
  Inicio = 'inicio'
}

/** input type for updating data in table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Set_Input = {
  conclusao?: InputMaybe<Scalars['date']['input']>;
  idCurso?: InputMaybe<Scalars['Int']['input']>;
  idInstituicaoEnsino?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Stddev_Order_By = {
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Stddev_Pop_Order_By = {
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Stddev_Samp_Order_By = {
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_membro_formacao" */
export type Locus_Membro_Formacao_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Membro_Formacao_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Membro_Formacao_Stream_Cursor_Value_Input = {
  conclusao?: InputMaybe<Scalars['date']['input']>;
  idCurso?: InputMaybe<Scalars['Int']['input']>;
  idInstituicaoEnsino?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
  inicio?: InputMaybe<Scalars['date']['input']>;
};

/** order by sum() on columns of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Sum_Order_By = {
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** update columns of table "locus.membro_formacao" */
export enum Locus_Membro_Formacao_Update_Column {
  /** column name */
  Conclusao = 'conclusao',
  /** column name */
  IdCurso = 'idCurso',
  /** column name */
  IdInstituicaoEnsino = 'idInstituicaoEnsino',
  /** column name */
  IdMembro = 'idMembro'
}

export type Locus_Membro_Formacao_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Locus_Membro_Formacao_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Locus_Membro_Formacao_Set_Input>;
  /** filter the rows which have to be updated */
  where: Locus_Membro_Formacao_Bool_Exp;
};

/** order by var_pop() on columns of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Var_Pop_Order_By = {
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Var_Samp_Order_By = {
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.membro_formacao" */
export type Locus_Membro_Formacao_Variance_Order_By = {
  idCurso?: InputMaybe<Order_By>;
  idInstituicaoEnsino?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** columns and relationships of "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica = {
  __typename?: 'locus_membro_instituicao_medica';
  ativo: Scalars['Boolean']['output'];
  idInstituicaoMedica: Scalars['Int']['output'];
  idMembro: Scalars['Int']['output'];
  inicioEm?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  instituicao_medica: Locus_Instituicao_Medica;
  /** An object relationship */
  membro: Locus_Membro;
  terminoEm?: Maybe<Scalars['date']['output']>;
};

/** order by aggregate values of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Membro_Instituicao_Medica_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Membro_Instituicao_Medica_Max_Order_By>;
  min?: InputMaybe<Locus_Membro_Instituicao_Medica_Min_Order_By>;
  stddev?: InputMaybe<Locus_Membro_Instituicao_Medica_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Membro_Instituicao_Medica_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Membro_Instituicao_Medica_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Membro_Instituicao_Medica_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Membro_Instituicao_Medica_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Membro_Instituicao_Medica_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Membro_Instituicao_Medica_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Avg_Order_By = {
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.membro_instituicao_medica". All fields are combined with a logical 'AND'. */
export type Locus_Membro_Instituicao_Medica_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Bool_Exp>>;
  _not?: InputMaybe<Locus_Membro_Instituicao_Medica_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Comparison_Exp>;
  idInstituicaoMedica?: InputMaybe<Int_Comparison_Exp>;
  idMembro?: InputMaybe<Int_Comparison_Exp>;
  inicioEm?: InputMaybe<Date_Comparison_Exp>;
  instituicao_medica?: InputMaybe<Locus_Instituicao_Medica_Bool_Exp>;
  membro?: InputMaybe<Locus_Membro_Bool_Exp>;
  terminoEm?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "locus.membro_instituicao_medica" */
export enum Locus_Membro_Instituicao_Medica_Constraint {
  /** unique or primary key constraint on columns "id_instituicao_medica", "id_membro" */
  MembroInstituicaoMedicaPkey = 'membro_instituicao_medica_pkey'
}

/** input type for incrementing numeric columns in table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Inc_Input = {
  idInstituicaoMedica?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Insert_Input = {
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  idInstituicaoMedica?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Max_Order_By = {
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  inicioEm?: InputMaybe<Order_By>;
  terminoEm?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Min_Order_By = {
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  inicioEm?: InputMaybe<Order_By>;
  terminoEm?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Mutation_Response = {
  __typename?: 'locus_membro_instituicao_medica_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Locus_Membro_Instituicao_Medica>;
};

/** on_conflict condition type for table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_On_Conflict = {
  constraint: Locus_Membro_Instituicao_Medica_Constraint;
  update_columns?: Array<Locus_Membro_Instituicao_Medica_Update_Column>;
  where?: InputMaybe<Locus_Membro_Instituicao_Medica_Bool_Exp>;
};

/** Ordering options when selecting data from "locus.membro_instituicao_medica". */
export type Locus_Membro_Instituicao_Medica_Order_By = {
  ativo?: InputMaybe<Order_By>;
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  inicioEm?: InputMaybe<Order_By>;
  instituicao_medica?: InputMaybe<Locus_Instituicao_Medica_Order_By>;
  membro?: InputMaybe<Locus_Membro_Order_By>;
  terminoEm?: InputMaybe<Order_By>;
};

/** primary key columns input for table: locus.membro_instituicao_medica */
export type Locus_Membro_Instituicao_Medica_Pk_Columns_Input = {
  idInstituicaoMedica: Scalars['Int']['input'];
  idMembro: Scalars['Int']['input'];
};

/** select columns of table "locus.membro_instituicao_medica" */
export enum Locus_Membro_Instituicao_Medica_Select_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  IdInstituicaoMedica = 'idInstituicaoMedica',
  /** column name */
  IdMembro = 'idMembro',
  /** column name */
  InicioEm = 'inicioEm',
  /** column name */
  TerminoEm = 'terminoEm'
}

/** input type for updating data in table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Set_Input = {
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  idInstituicaoMedica?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Stddev_Order_By = {
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Stddev_Pop_Order_By = {
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Stddev_Samp_Order_By = {
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Membro_Instituicao_Medica_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Membro_Instituicao_Medica_Stream_Cursor_Value_Input = {
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  idInstituicaoMedica?: InputMaybe<Scalars['Int']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
  inicioEm?: InputMaybe<Scalars['date']['input']>;
  terminoEm?: InputMaybe<Scalars['date']['input']>;
};

/** order by sum() on columns of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Sum_Order_By = {
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** update columns of table "locus.membro_instituicao_medica" */
export enum Locus_Membro_Instituicao_Medica_Update_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  IdInstituicaoMedica = 'idInstituicaoMedica',
  /** column name */
  IdMembro = 'idMembro'
}

export type Locus_Membro_Instituicao_Medica_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Locus_Membro_Instituicao_Medica_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Locus_Membro_Instituicao_Medica_Set_Input>;
  /** filter the rows which have to be updated */
  where: Locus_Membro_Instituicao_Medica_Bool_Exp;
};

/** order by var_pop() on columns of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Var_Pop_Order_By = {
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Var_Samp_Order_By = {
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.membro_instituicao_medica" */
export type Locus_Membro_Instituicao_Medica_Variance_Order_By = {
  idInstituicaoMedica?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
};

/** order by max() on columns of table "locus.membro" */
export type Locus_Membro_Max_Order_By = {
  apelido?: InputMaybe<Order_By>;
  codConselhoClasse?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  formasPagamento?: InputMaybe<Order_By>;
  fotoUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  maisInformacoes?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  numeroConselhoClasse?: InputMaybe<Order_By>;
  observacoes?: InputMaybe<Order_By>;
  pronome?: InputMaybe<Order_By>;
  resumo?: InputMaybe<Order_By>;
  resumoSecundario?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  sobre?: InputMaybe<Order_By>;
  sobrenome?: InputMaybe<Order_By>;
  telefone?: InputMaybe<Order_By>;
  ufConselhoClasse?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.membro" */
export type Locus_Membro_Min_Order_By = {
  apelido?: InputMaybe<Order_By>;
  codConselhoClasse?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  formasPagamento?: InputMaybe<Order_By>;
  fotoUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  maisInformacoes?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  numeroConselhoClasse?: InputMaybe<Order_By>;
  observacoes?: InputMaybe<Order_By>;
  pronome?: InputMaybe<Order_By>;
  resumo?: InputMaybe<Order_By>;
  resumoSecundario?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  sobre?: InputMaybe<Order_By>;
  sobrenome?: InputMaybe<Order_By>;
  telefone?: InputMaybe<Order_By>;
  ufConselhoClasse?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "locus.membro" */
export type Locus_Membro_Mutation_Response = {
  __typename?: 'locus_membro_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Locus_Membro>;
};

/** Ordering options when selecting data from "locus.membro". */
export type Locus_Membro_Order_By = {
  apelido?: InputMaybe<Order_By>;
  ativo?: InputMaybe<Order_By>;
  codConselhoClasse?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  conselhoProfissional?: InputMaybe<Locus_Conselho_Profissional_Order_By>;
  duracaoInicialConsulta?: InputMaybe<Order_By>;
  experiencias_aggregate?: InputMaybe<Locus_Experiencia_Membro_Aggregate_Order_By>;
  faqs_aggregate?: InputMaybe<Locus_Faq_Membro_Aggregate_Order_By>;
  focosTratamentos_aggregate?: InputMaybe<Locus_Foco_Tratamento_Membro_Aggregate_Order_By>;
  formasPagamento?: InputMaybe<Order_By>;
  fotoUrl?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  maisInformacoes?: InputMaybe<Order_By>;
  membroEspecialidades_aggregate?: InputMaybe<Locus_Membro_Especialidade_Aggregate_Order_By>;
  membroFormacoes_aggregate?: InputMaybe<Locus_Membro_Formacao_Aggregate_Order_By>;
  membroInstituicoesMedicas_aggregate?: InputMaybe<Locus_Membro_Instituicao_Medica_Aggregate_Order_By>;
  nome?: InputMaybe<Order_By>;
  numeroConselhoClasse?: InputMaybe<Order_By>;
  observacoes?: InputMaybe<Order_By>;
  pronome?: InputMaybe<Order_By>;
  rede_social_membros_aggregate?: InputMaybe<Locus_Rede_Social_Membro_Aggregate_Order_By>;
  resumo?: InputMaybe<Order_By>;
  resumoSecundario?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  sobre?: InputMaybe<Order_By>;
  sobrenome?: InputMaybe<Order_By>;
  telefone?: InputMaybe<Order_By>;
  ufConselhoClasse?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

/** primary key columns input for table: locus.membro */
export type Locus_Membro_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "locus.membro" */
export enum Locus_Membro_Select_Column {
  /** column name */
  Apelido = 'apelido',
  /** column name */
  Ativo = 'ativo',
  /** column name */
  CodConselhoClasse = 'codConselhoClasse',
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  DuracaoInicialConsulta = 'duracaoInicialConsulta',
  /** column name */
  FormasPagamento = 'formasPagamento',
  /** column name */
  FotoUrl = 'fotoUrl',
  /** column name */
  Id = 'id',
  /** column name */
  IdConselhoProfissional = 'idConselhoProfissional',
  /** column name */
  MaisInformacoes = 'maisInformacoes',
  /** column name */
  Nome = 'nome',
  /** column name */
  NumeroConselhoClasse = 'numeroConselhoClasse',
  /** column name */
  Observacoes = 'observacoes',
  /** column name */
  Pronome = 'pronome',
  /** column name */
  Resumo = 'resumo',
  /** column name */
  ResumoSecundario = 'resumoSecundario',
  /** column name */
  Slug = 'slug',
  /** column name */
  Sobre = 'sobre',
  /** column name */
  Sobrenome = 'sobrenome',
  /** column name */
  Telefone = 'telefone',
  /** column name */
  UfConselhoClasse = 'ufConselhoClasse',
  /** column name */
  ValorInicialConsulta = 'valorInicialConsulta'
}

/** input type for updating data in table "locus.membro" */
export type Locus_Membro_Set_Input = {
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  dataReativacao?: InputMaybe<Scalars['date']['input']>;
  dataSaida?: InputMaybe<Scalars['date']['input']>;
  maisInformacoes?: InputMaybe<Scalars['String']['input']>;
  motivoInativacao?: InputMaybe<Scalars['String']['input']>;
  resumoSecundario?: InputMaybe<Scalars['String']['input']>;
  sobre?: InputMaybe<Scalars['String']['input']>;
};

/** order by stddev() on columns of table "locus.membro" */
export type Locus_Membro_Stddev_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.membro" */
export type Locus_Membro_Stddev_Pop_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.membro" */
export type Locus_Membro_Stddev_Samp_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_membro" */
export type Locus_Membro_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Membro_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Membro_Stream_Cursor_Value_Input = {
  apelido?: InputMaybe<Scalars['String']['input']>;
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  codConselhoClasse?: InputMaybe<Scalars['String']['input']>;
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  duracaoInicialConsulta?: InputMaybe<Scalars['time']['input']>;
  formasPagamento?: InputMaybe<Scalars['String']['input']>;
  fotoUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idConselhoProfissional?: InputMaybe<Scalars['Int']['input']>;
  maisInformacoes?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  numeroConselhoClasse?: InputMaybe<Scalars['String']['input']>;
  observacoes?: InputMaybe<Scalars['String']['input']>;
  pronome?: InputMaybe<Scalars['String']['input']>;
  resumo?: InputMaybe<Scalars['String']['input']>;
  resumoSecundario?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sobre?: InputMaybe<Scalars['String']['input']>;
  sobrenome?: InputMaybe<Scalars['String']['input']>;
  telefone?: InputMaybe<Scalars['String']['input']>;
  ufConselhoClasse?: InputMaybe<Scalars['String']['input']>;
  valorInicialConsulta?: InputMaybe<Scalars['numeric']['input']>;
};

/** order by sum() on columns of table "locus.membro" */
export type Locus_Membro_Sum_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

export type Locus_Membro_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Locus_Membro_Set_Input>;
  /** filter the rows which have to be updated */
  where: Locus_Membro_Bool_Exp;
};

/** order by var_pop() on columns of table "locus.membro" */
export type Locus_Membro_Var_Pop_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.membro" */
export type Locus_Membro_Var_Samp_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.membro" */
export type Locus_Membro_Variance_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idConselhoProfissional?: InputMaybe<Order_By>;
  valorInicialConsulta?: InputMaybe<Order_By>;
};

/** columns and relationships of "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro = {
  __typename?: 'locus_rede_social_membro';
  deletado: Scalars['Boolean']['output'];
  idMembro: Scalars['Int']['output'];
  /** An object relationship */
  membro: Locus_Membro;
  redeSocial: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** order by aggregate values of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Aggregate_Order_By = {
  avg?: InputMaybe<Locus_Rede_Social_Membro_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Locus_Rede_Social_Membro_Max_Order_By>;
  min?: InputMaybe<Locus_Rede_Social_Membro_Min_Order_By>;
  stddev?: InputMaybe<Locus_Rede_Social_Membro_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Locus_Rede_Social_Membro_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Locus_Rede_Social_Membro_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Locus_Rede_Social_Membro_Sum_Order_By>;
  var_pop?: InputMaybe<Locus_Rede_Social_Membro_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Locus_Rede_Social_Membro_Var_Samp_Order_By>;
  variance?: InputMaybe<Locus_Rede_Social_Membro_Variance_Order_By>;
};

/** order by avg() on columns of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Avg_Order_By = {
  idMembro?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "locus.rede_social_membro". All fields are combined with a logical 'AND'. */
export type Locus_Rede_Social_Membro_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Rede_Social_Membro_Bool_Exp>>;
  _not?: InputMaybe<Locus_Rede_Social_Membro_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Rede_Social_Membro_Bool_Exp>>;
  deletado?: InputMaybe<Boolean_Comparison_Exp>;
  idMembro?: InputMaybe<Int_Comparison_Exp>;
  membro?: InputMaybe<Locus_Membro_Bool_Exp>;
  redeSocial?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Max_Order_By = {
  idMembro?: InputMaybe<Order_By>;
  redeSocial?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Min_Order_By = {
  idMembro?: InputMaybe<Order_By>;
  redeSocial?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "locus.rede_social_membro". */
export type Locus_Rede_Social_Membro_Order_By = {
  deletado?: InputMaybe<Order_By>;
  idMembro?: InputMaybe<Order_By>;
  membro?: InputMaybe<Locus_Membro_Order_By>;
  redeSocial?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** select columns of table "locus.rede_social_membro" */
export enum Locus_Rede_Social_Membro_Select_Column {
  /** column name */
  Deletado = 'deletado',
  /** column name */
  IdMembro = 'idMembro',
  /** column name */
  RedeSocial = 'redeSocial',
  /** column name */
  Url = 'url'
}

/** order by stddev() on columns of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Stddev_Order_By = {
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Stddev_Pop_Order_By = {
  idMembro?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Stddev_Samp_Order_By = {
  idMembro?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "locus_rede_social_membro" */
export type Locus_Rede_Social_Membro_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Rede_Social_Membro_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Rede_Social_Membro_Stream_Cursor_Value_Input = {
  deletado?: InputMaybe<Scalars['Boolean']['input']>;
  idMembro?: InputMaybe<Scalars['Int']['input']>;
  redeSocial?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** order by sum() on columns of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Sum_Order_By = {
  idMembro?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Var_Pop_Order_By = {
  idMembro?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Var_Samp_Order_By = {
  idMembro?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "locus.rede_social_membro" */
export type Locus_Rede_Social_Membro_Variance_Order_By = {
  idMembro?: InputMaybe<Order_By>;
};

/** columns and relationships of "locus.subespecialidade" */
export type Locus_Subespecialidade = {
  __typename?: 'locus_subespecialidade';
  /** An array relationship */
  especialidade_subespecialidades: Array<Locus_Especialidade_Subespecialidade>;
  especialista: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
};


/** columns and relationships of "locus.subespecialidade" */
export type Locus_SubespecialidadeEspecialidade_SubespecialidadesArgs = {
  distinct_on?: InputMaybe<Array<Locus_Especialidade_Subespecialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Especialidade_Subespecialidade_Order_By>>;
  where?: InputMaybe<Locus_Especialidade_Subespecialidade_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "locus.subespecialidade". All fields are combined with a logical 'AND'. */
export type Locus_Subespecialidade_Bool_Exp = {
  _and?: InputMaybe<Array<Locus_Subespecialidade_Bool_Exp>>;
  _not?: InputMaybe<Locus_Subespecialidade_Bool_Exp>;
  _or?: InputMaybe<Array<Locus_Subespecialidade_Bool_Exp>>;
  especialidade_subespecialidades?: InputMaybe<Locus_Especialidade_Subespecialidade_Bool_Exp>;
  especialista?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  nome?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "locus.subespecialidade". */
export type Locus_Subespecialidade_Order_By = {
  especialidade_subespecialidades_aggregate?: InputMaybe<Locus_Especialidade_Subespecialidade_Aggregate_Order_By>;
  especialista?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** select columns of table "locus.subespecialidade" */
export enum Locus_Subespecialidade_Select_Column {
  /** column name */
  Especialista = 'especialista',
  /** column name */
  Id = 'id',
  /** column name */
  Nome = 'nome'
}

/** Streaming cursor of the table "locus_subespecialidade" */
export type Locus_Subespecialidade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locus_Subespecialidade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locus_Subespecialidade_Stream_Cursor_Value_Input = {
  especialista?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  AnimusCancelSalesVisit?: Maybe<AnimusCancelSalesVisitOutput>;
  /** AnimusCancelVisit */
  AnimusCancelVisit?: Maybe<AnimusCancelVisitOutput>;
  /** AnimusCreateNewVirtualSalesVisit */
  AnimusCreateNewVirtualSalesVisit?: Maybe<CreateNewVirtualSalesVisitResponse>;
  AnimusCreateVirtualSalesVisit?: Maybe<CreateVirtualSalesVisitResponse>;
  /** AnimusDeleteVirtualSalesVisit */
  AnimusDeleteVirtualSalesVisit?: Maybe<AnimusDeleteVirtualSalesVisitOutput>;
  AnimusScheduleSalesVisit?: Maybe<AnimusScheduleSalesVisitOutput>;
  /** AnimusUpdateLivanceNickname */
  AnimusUpdateLivanceNickname?: Maybe<AnimusUpdateLivanceNicknameOutput>;
  AnimusUploadProfessionalIdPicture?: Maybe<AnimusUploadProfessionalIdPictureOutput>;
  /** CancelOnboardingVisit */
  CancelOnboardingVisit?: Maybe<CancelOnboardingOutput>;
  /** CreateUserAppointmentType */
  CreateUserAppointmentType?: Maybe<CreateUserAppointmentTypeOutput>;
  ExpensumCancelTotemPayment?: Maybe<ExpensumCancelTotemPaymentOutput>;
  ExpensumChargeCancel?: Maybe<ExpensumChargeCancelOutput>;
  ExpensumCreateOnlinePayment?: Maybe<ExpensumCreateOnlinePaymentOutput>;
  /** InitiumUploadCheckInFile */
  InitiumUploadCheckInFile?: Maybe<InitiumUploadCheckInFileOutput>;
  LivanceApiAgendamentoCancela?: Maybe<AgendamentoOutput>;
  LivanceApiAlteraUsuarioCompromissoPatch?: Maybe<LivanceApiAlteraUsuarioCompromissoOutput>;
  /** Cadastro de cartão de credito */
  LivanceApiCadastraNovoCartao?: Maybe<LivanceApiCadastraNovoCartaoOutput>;
  /** Action criada para acessar a rota de cancelamento de um período garantido pontual na LivanceAPI */
  LivanceApiCancelaPeriodoGarantido?: Maybe<LivanceApiCancelaPeriodoGarantidoOutput>;
  /** Action criada para acessar a rota de cancelamento de um período garantido recorrente na LivanceAPI */
  LivanceApiCancelaPeriodoGarantidoRecorrente?: Maybe<LivanceApiCancelaPeriodoGarantidoRecorrenteOutput>;
  /** LivanceApiCreateAgendamento */
  LivanceApiCreateAgendamento: Scalars['Int']['output'];
  /** Alternativa temporária para a mutation LivanceApiCreateAgendamento - possui o parâmetro adicional "cobraCancelamento". Criado para evitar quebrar os outros projetos que usam a mutation antiga. A duplicidade será removida quando migrarmos os outros projetos. */
  LivanceApiCreateAppointment: Scalars['Int']['output'];
  /** Action that calls LivanceAPI to create new schedule (UsuarioAgenda). */
  LivanceApiCreateUsuarioAgenda: Scalars['Int']['output'];
  LivanceApiCreateUsuarioFormaRecebimento: Scalars['json']['output'];
  /** LivanceApiCriaFechamento */
  LivanceApiCriaFechamento: Scalars['Int']['output'];
  /** LivanceApiCriaPeriodoGarantidoRecorrente */
  LivanceApiCriaPeriodoGarantidoRecorrente?: Maybe<LivanceApiCriaPeriodoGarantidoRecorrenteOutput>;
  LivanceApiCriaUsuarioCompromisso?: Maybe<LivanceApiCriaUsuarioCompromissoOutput>;
  /** Action that calls LivanceAPI to delete unavailable-slot (Fechamento). */
  LivanceApiDeleteFechamento: Scalars['String']['output'];
  /** Action that calls LivanceAPI to delete schedule (UsuarioAgenda). */
  LivanceApiDeleteUsuarioAgenda: Scalars['json']['output'];
  LivanceApiDeleteUsuarioCompromisso: Scalars['json']['output'];
  LivanceApiDeleteUsuarioFormaRecebimento: Scalars['json']['output'];
  LivanceApiPatchDadosBancarios: LivanceApiPatchDadosBancariosOutput;
  /** Action that calls LivanceAPI to patch schedule (UsuarioAgenda). */
  LivanceApiPatchUsuarioAgenda: Scalars['json']['output'];
  LivanceApiPatchUsuarioFormaRecebimento: Scalars['json']['output'];
  LivanceApiReceberSalaAgora: Scalars['Int']['output'];
  LivanceApiRemarcaAgendamento: Scalars['Int']['output'];
  /** LivanceApiUpsertUsuarioEndereco */
  LivanceApiUpsertUsuarioEndereco?: Maybe<LivanceApiUpsertUsuarioEnderecoOutput>;
  LivanceApiUsuarioPlanoMigracao?: Maybe<LivanceApiUsuarioPlanoMigracaoOutput>;
  LocusUpdateMemberSocialMedia: Scalars['json']['output'];
  LocusUpsertBasicProfile?: Maybe<LocusUpsertBasicProfileOutput>;
  PagarmeAutomaticAnticipationSettingsUpdate: Scalars['json']['output'];
  /** ScheduleOnboardingVisit */
  ScheduleOnboardingVisit?: Maybe<OnboardingSchedulingOutput>;
  /** SetAppointmentAgeRange */
  SetAppointmentAgeRange?: Maybe<AppointmentAgeRangeOutput>;
  /** SetAppointmentRequirements */
  SetAppointmentRequirements?: Maybe<AppointmentRequirementsOutput>;
  /** SetupReturnSettings */
  SetupReturnSettings?: Maybe<SetupReturnSettingsOutput>;
  /** UpdateProfessionalInfo */
  UpdateProfessionalInfo: Scalars['json']['output'];
  /** UpdateReturnPolicies */
  UpdateReturnPolicies: Scalars['json']['output'];
  /** UploadProfessionalCard */
  UploadProfessionalCard?: Maybe<UploadProfessionalCardOutput>;
  /** Atualiza data desativacao do pacote de servico. Fluxo no qual o membro já nasce com o pacote Pro e precisa concondar com os termos, caso ele concorde, faremos a atualização da data desativao para nula */
  aceitarPacoteServicos: AceitarPacoteServicosPayload;
  /** Adiantar ou atrasar agendamento */
  adiantarOuAtrasar: AdiantarOuAtrasarPayload;
  /** Cria tag de agendamento atendido */
  agendamentoAtendido: AgendamentoAtendidoPayload;
  /** Remove tag de agendamento atendido */
  agendamentoNaoAtendido: AgendamentoNaoAtendidoPayload;
  /** Altera paciente existente */
  alterarPaciente: AlterarPacientePayload;
  /** Atualiza o telefone público do usuário profissional */
  atualizarTelefonePublico: AtualizarTelefonePublicoPayload;
  /** Cancela pacote de serviço contratado pelo usuário */
  cancelarPacoteServicos: CancelarPacoteServicosPayload;
  /** Vincula usuário ao pacote de serviços assist Pro */
  cancelarPacoteServicosAssistPro: CancelarPacoteServicosAssistProPayload;
  /** Vincula usuário a determinado pacote de serviços */
  contratarPacoteServicos: ContratarPacoteServicosPayload;
  /** Criar agendamento */
  criarAgendamento: CriarAgendamentoPayload;
  /** Cria múltiplos fechamentos */
  criarMultiplosFechamentos: CriarMultiplosFechamentosPayload;
  /** Cria um link de rastreamento para acompanhamento */
  criarUsuarioLinkRastreamento: CriarUsuarioLinkRastreamentoPayload;
  /** delete data from the table: "tbFuncionalidadesDesativadas" */
  delete_funcionalidadesDesativadas?: Maybe<FuncionalidadesDesativadas_Mutation_Response>;
  /** delete single row from the table: "tbFuncionalidadesDesativadas" */
  delete_funcionalidadesDesativadas_by_pk?: Maybe<FuncionalidadesDesativadas>;
  /** delete data from the table: "locus.membro_formacao" */
  delete_locus_membro_formacao?: Maybe<Locus_Membro_Formacao_Mutation_Response>;
  /** delete single row from the table: "locus.membro_formacao" */
  delete_locus_membro_formacao_by_pk?: Maybe<Locus_Membro_Formacao>;
  /** delete data from the table: "locus.membro_instituicao_medica" */
  delete_locus_membro_instituicao_medica?: Maybe<Locus_Membro_Instituicao_Medica_Mutation_Response>;
  /** delete single row from the table: "locus.membro_instituicao_medica" */
  delete_locus_membro_instituicao_medica_by_pk?: Maybe<Locus_Membro_Instituicao_Medica>;
  /** delete data from the table: "nexus.follow" */
  delete_nexus_follow?: Maybe<Nexus_Follow_Mutation_Response>;
  /** delete single row from the table: "nexus.follow" */
  delete_nexus_follow_by_pk?: Maybe<Nexus_Follow>;
  /** delete data from the table: "tbFechamentos" */
  delete_tbFechamentos?: Maybe<TbFechamentos_Mutation_Response>;
  /** delete single row from the table: "tbFechamentos" */
  delete_tbFechamentos_by_pk?: Maybe<TbFechamentos>;
  /** delete data from the table: "users_professional_cards" */
  delete_users_professional_cards?: Maybe<Users_Professional_Cards_Mutation_Response>;
  /** delete single row from the table: "users_professional_cards" */
  delete_users_professional_cards_by_pk?: Maybe<Users_Professional_Cards>;
  /** Estender agendamento */
  estenderAgendamento: EstenderAgendamentoPayload;
  /** Finaliza a alocação ativa de um usuário */
  finalizaAlocacao: FinalizaAlocacaoPayload;
  /** Realiza indicação de profissional. */
  indicarProfissional: IndicarProfissionalPayload;
  /** insert data into the table: "tbUsuariosCompromissosStatusSugestoesDuracoes" */
  insert_UsuariosCompromissosStatusSugestoesDuracoes?: Maybe<UsuariosCompromissosStatusSugestoesDuracoes_Mutation_Response>;
  /** insert a single row into the table: "tbUsuariosCompromissosStatusSugestoesDuracoes" */
  insert_UsuariosCompromissosStatusSugestoesDuracoes_one?: Maybe<UsuariosCompromissosStatusSugestoesDuracoes>;
  /** insert data into the table: "deliverus.read_app_notifications" */
  insert_deliverus_read_app_notifications?: Maybe<Deliverus_Read_App_Notifications_Mutation_Response>;
  /** insert data into the table: "expensum.event_automatic_anticipation_settings_update" */
  insert_expensum_event_automatic_anticipation_settings_update?: Maybe<Expensum_Event_Automatic_Anticipation_Settings_Update_Mutation_Response>;
  /** insert a single row into the table: "expensum.event_automatic_anticipation_settings_update" */
  insert_expensum_event_automatic_anticipation_settings_update_one?: Maybe<Expensum_Event_Automatic_Anticipation_Settings_Update>;
  /** insert data into the table: "expensum.event_bank_account_update" */
  insert_expensum_event_bank_account_update?: Maybe<Expensum_Event_Bank_Account_Update_Mutation_Response>;
  /** insert a single row into the table: "expensum.event_bank_account_update" */
  insert_expensum_event_bank_account_update_one?: Maybe<Expensum_Event_Bank_Account_Update>;
  /** insert data into the table: "expensum.event_totem_payment_sent" */
  insert_expensum_event_totem_payment_sent?: Maybe<Expensum_Event_Totem_Payment_Sent_Mutation_Response>;
  /** insert a single row into the table: "expensum.event_totem_payment_sent" */
  insert_expensum_event_totem_payment_sent_one?: Maybe<Expensum_Event_Totem_Payment_Sent>;
  /** insert data into the table: "expensum.online_payment_activity" */
  insert_expensum_online_payment_activity?: Maybe<Expensum_Online_Payment_Activity_Mutation_Response>;
  /** insert a single row into the table: "expensum.online_payment_activity" */
  insert_expensum_online_payment_activity_one?: Maybe<Expensum_Online_Payment_Activity>;
  /** insert data into the table: "expensum.recipient_terms_of_use_agreed" */
  insert_expensum_recipient_terms_of_use_agreed?: Maybe<Expensum_Recipient_Terms_Of_Use_Agreed_Mutation_Response>;
  /** insert a single row into the table: "expensum.recipient_terms_of_use_agreed" */
  insert_expensum_recipient_terms_of_use_agreed_one?: Maybe<Expensum_Recipient_Terms_Of_Use_Agreed>;
  /** insert data into the table: "tbFuncionalidadesDesativadas" */
  insert_funcionalidadesDesativadas?: Maybe<FuncionalidadesDesativadas_Mutation_Response>;
  /** insert a single row into the table: "tbFuncionalidadesDesativadas" */
  insert_funcionalidadesDesativadas_one?: Maybe<FuncionalidadesDesativadas>;
  /** insert data into the table: "tbLembretes" */
  insert_lembretes?: Maybe<Lembretes_Mutation_Response>;
  /** insert a single row into the table: "tbLembretes" */
  insert_lembretes_one?: Maybe<Lembretes>;
  /** insert data into the table: "locus.experiencia_membro" */
  insert_locus_experiencia_membro?: Maybe<Locus_Experiencia_Membro_Mutation_Response>;
  /** insert a single row into the table: "locus.experiencia_membro" */
  insert_locus_experiencia_membro_one?: Maybe<Locus_Experiencia_Membro>;
  /** insert data into the table: "locus.faq_membro" */
  insert_locus_faq_membro?: Maybe<Locus_Faq_Membro_Mutation_Response>;
  /** insert a single row into the table: "locus.faq_membro" */
  insert_locus_faq_membro_one?: Maybe<Locus_Faq_Membro>;
  /** insert data into the table: "locus.foco_tratamento_membro" */
  insert_locus_foco_tratamento_membro?: Maybe<Locus_Foco_Tratamento_Membro_Mutation_Response>;
  /** insert a single row into the table: "locus.foco_tratamento_membro" */
  insert_locus_foco_tratamento_membro_one?: Maybe<Locus_Foco_Tratamento_Membro>;
  /** insert data into the table: "locus.membro_formacao" */
  insert_locus_membro_formacao?: Maybe<Locus_Membro_Formacao_Mutation_Response>;
  /** insert a single row into the table: "locus.membro_formacao" */
  insert_locus_membro_formacao_one?: Maybe<Locus_Membro_Formacao>;
  /** insert data into the table: "locus.membro_instituicao_medica" */
  insert_locus_membro_instituicao_medica?: Maybe<Locus_Membro_Instituicao_Medica_Mutation_Response>;
  /** insert a single row into the table: "locus.membro_instituicao_medica" */
  insert_locus_membro_instituicao_medica_one?: Maybe<Locus_Membro_Instituicao_Medica>;
  /** insert data into the table: "nexus.follow" */
  insert_nexus_follow?: Maybe<Nexus_Follow_Mutation_Response>;
  /** insert a single row into the table: "nexus.follow" */
  insert_nexus_follow_one?: Maybe<Nexus_Follow>;
  /** insert data into the table: "tbUsuariosTermosDeUso" */
  insert_tbUsuariosTermosDeUso?: Maybe<TbUsuariosTermosDeUso_Mutation_Response>;
  /** insert a single row into the table: "tbUsuariosTermosDeUso" */
  insert_tbUsuariosTermosDeUso_one?: Maybe<TbUsuariosTermosDeUso>;
  /** insert data into the table: "users_professional_cards" */
  insert_users_professional_cards?: Maybe<Users_Professional_Cards_Mutation_Response>;
  /** insert a single row into the table: "users_professional_cards" */
  insert_users_professional_cards_one?: Maybe<Users_Professional_Cards>;
  /** insert data into the table: "users_terms_of_use_agreed" */
  insert_users_terms_of_use_agreed?: Maybe<Users_Terms_Of_Use_Agreed_Mutation_Response>;
  /** insert a single row into the table: "users_terms_of_use_agreed" */
  insert_users_terms_of_use_agreed_one?: Maybe<Users_Terms_Of_Use_Agreed>;
  /** insert data into the table: "tbUsuariosProfissionaisOrientacoesSecretarias" */
  insert_usuariosProfissionaisOrientacoesSecretarias?: Maybe<UsuariosProfissionaisOrientacoesSecretarias_Mutation_Response>;
  /** insert a single row into the table: "tbUsuariosProfissionaisOrientacoesSecretarias" */
  insert_usuariosProfissionaisOrientacoesSecretarias_one?: Maybe<UsuariosProfissionaisOrientacoesSecretarias>;
  /** Receber sala agora */
  receberSalaAgora: ReceberSalaAgoraPayload;
  /** Remarca agendamento */
  remarcarAgendamento: RemarcarAgendamentoPayload;
  /** Troca paciente do agendamento */
  trocarPaciente: TrocarPacientePayload;
  /** update data of the table: "tbUsuariosCompromissosStatusSugestoesDuracoes" */
  update_UsuariosCompromissosStatusSugestoesDuracoes?: Maybe<UsuariosCompromissosStatusSugestoesDuracoes_Mutation_Response>;
  /** update single row of the table: "tbUsuariosCompromissosStatusSugestoesDuracoes" */
  update_UsuariosCompromissosStatusSugestoesDuracoes_by_pk?: Maybe<UsuariosCompromissosStatusSugestoesDuracoes>;
  /** update data of the table: "expensum.online_payment" */
  update_expensum_online_payment?: Maybe<Expensum_Online_Payment_Mutation_Response>;
  /** update single row of the table: "expensum.online_payment" */
  update_expensum_online_payment_by_pk?: Maybe<Expensum_Online_Payment>;
  /** update multiples rows of table: "expensum.online_payment" */
  update_expensum_online_payment_many?: Maybe<Array<Maybe<Expensum_Online_Payment_Mutation_Response>>>;
  /** update data of the table: "tbFuncionalidadesDesativadas" */
  update_funcionalidadesDesativadas?: Maybe<FuncionalidadesDesativadas_Mutation_Response>;
  /** update single row of the table: "tbFuncionalidadesDesativadas" */
  update_funcionalidadesDesativadas_by_pk?: Maybe<FuncionalidadesDesativadas>;
  /** update data of the table: "tbLembretes" */
  update_lembretes?: Maybe<Lembretes_Mutation_Response>;
  /** update single row of the table: "tbLembretes" */
  update_lembretes_by_pk?: Maybe<Lembretes>;
  /** update data of the table: "locus.experiencia_membro" */
  update_locus_experiencia_membro?: Maybe<Locus_Experiencia_Membro_Mutation_Response>;
  /** update single row of the table: "locus.experiencia_membro" */
  update_locus_experiencia_membro_by_pk?: Maybe<Locus_Experiencia_Membro>;
  /** update multiples rows of table: "locus.experiencia_membro" */
  update_locus_experiencia_membro_many?: Maybe<Array<Maybe<Locus_Experiencia_Membro_Mutation_Response>>>;
  /** update data of the table: "locus.faq_membro" */
  update_locus_faq_membro?: Maybe<Locus_Faq_Membro_Mutation_Response>;
  /** update single row of the table: "locus.faq_membro" */
  update_locus_faq_membro_by_pk?: Maybe<Locus_Faq_Membro>;
  /** update multiples rows of table: "locus.faq_membro" */
  update_locus_faq_membro_many?: Maybe<Array<Maybe<Locus_Faq_Membro_Mutation_Response>>>;
  /** update data of the table: "locus.foco_tratamento_membro" */
  update_locus_foco_tratamento_membro?: Maybe<Locus_Foco_Tratamento_Membro_Mutation_Response>;
  /** update single row of the table: "locus.foco_tratamento_membro" */
  update_locus_foco_tratamento_membro_by_pk?: Maybe<Locus_Foco_Tratamento_Membro>;
  /** update multiples rows of table: "locus.foco_tratamento_membro" */
  update_locus_foco_tratamento_membro_many?: Maybe<Array<Maybe<Locus_Foco_Tratamento_Membro_Mutation_Response>>>;
  /** update data of the table: "locus.membro" */
  update_locus_membro?: Maybe<Locus_Membro_Mutation_Response>;
  /** update single row of the table: "locus.membro" */
  update_locus_membro_by_pk?: Maybe<Locus_Membro>;
  /** update data of the table: "locus.membro_formacao" */
  update_locus_membro_formacao?: Maybe<Locus_Membro_Formacao_Mutation_Response>;
  /** update single row of the table: "locus.membro_formacao" */
  update_locus_membro_formacao_by_pk?: Maybe<Locus_Membro_Formacao>;
  /** update multiples rows of table: "locus.membro_formacao" */
  update_locus_membro_formacao_many?: Maybe<Array<Maybe<Locus_Membro_Formacao_Mutation_Response>>>;
  /** update data of the table: "locus.membro_instituicao_medica" */
  update_locus_membro_instituicao_medica?: Maybe<Locus_Membro_Instituicao_Medica_Mutation_Response>;
  /** update single row of the table: "locus.membro_instituicao_medica" */
  update_locus_membro_instituicao_medica_by_pk?: Maybe<Locus_Membro_Instituicao_Medica>;
  /** update multiples rows of table: "locus.membro_instituicao_medica" */
  update_locus_membro_instituicao_medica_many?: Maybe<Array<Maybe<Locus_Membro_Instituicao_Medica_Mutation_Response>>>;
  /** update multiples rows of table: "locus.membro" */
  update_locus_membro_many?: Maybe<Array<Maybe<Locus_Membro_Mutation_Response>>>;
  /** update data of the table: "tbUsuariosTermosDeUso" */
  update_tbUsuariosTermosDeUso?: Maybe<TbUsuariosTermosDeUso_Mutation_Response>;
  /** update single row of the table: "tbUsuariosTermosDeUso" */
  update_tbUsuariosTermosDeUso_by_pk?: Maybe<TbUsuariosTermosDeUso>;
  /** update data of the table: "user_addresses" */
  update_user_addresses?: Maybe<User_Addresses_Mutation_Response>;
  /** update multiples rows of table: "user_addresses" */
  update_user_addresses_many?: Maybe<Array<Maybe<User_Addresses_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "users_professional_cards" */
  update_users_professional_cards?: Maybe<Users_Professional_Cards_Mutation_Response>;
  /** update single row of the table: "users_professional_cards" */
  update_users_professional_cards_by_pk?: Maybe<Users_Professional_Cards>;
  /** update multiples rows of table: "users_professional_cards" */
  update_users_professional_cards_many?: Maybe<Array<Maybe<Users_Professional_Cards_Mutation_Response>>>;
  /** update data of the table: "tbUsuarios" */
  update_usuarios?: Maybe<Usuarios_Mutation_Response>;
  /** update data of the table: "tbUsuariosCompromissos" */
  update_usuariosCompromissos?: Maybe<UsuariosCompromissos_Mutation_Response>;
  /** update single row of the table: "tbUsuariosCompromissos" */
  update_usuariosCompromissos_by_pk?: Maybe<UsuariosCompromissos>;
  /** update data of the table: "tbUsuariosProfissionaisOrientacoesSecretarias" */
  update_usuariosProfissionaisOrientacoesSecretarias?: Maybe<UsuariosProfissionaisOrientacoesSecretarias_Mutation_Response>;
  /** update single row of the table: "tbUsuariosProfissionaisOrientacoesSecretarias" */
  update_usuariosProfissionaisOrientacoesSecretarias_by_pk?: Maybe<UsuariosProfissionaisOrientacoesSecretarias>;
  /** update single row of the table: "tbUsuarios" */
  update_usuarios_by_pk?: Maybe<Usuarios>;
};


/** mutation root */
export type Mutation_RootAnimusCancelSalesVisitArgs = {
  arg1: AnimusCancelSalesVisitInput;
};


/** mutation root */
export type Mutation_RootAnimusCreateNewVirtualSalesVisitArgs = {
  arg1: CreateNewVirtualSalesVisitInput;
};


/** mutation root */
export type Mutation_RootAnimusCreateVirtualSalesVisitArgs = {
  arg1: CreateVirtualSalesVisitInput;
};


/** mutation root */
export type Mutation_RootAnimusDeleteVirtualSalesVisitArgs = {
  arg1: AnimusDeleteVirtualSalesVisitInput;
};


/** mutation root */
export type Mutation_RootAnimusScheduleSalesVisitArgs = {
  arg1: AnimusScheduleSalesVisitInput;
};


/** mutation root */
export type Mutation_RootAnimusUpdateLivanceNicknameArgs = {
  arg1: AnimusUpdateLivanceNicknameInput;
};


/** mutation root */
export type Mutation_RootAnimusUploadProfessionalIdPictureArgs = {
  arg1: AnimusUploadProfessionalIdPictureInput;
};


/** mutation root */
export type Mutation_RootCreateUserAppointmentTypeArgs = {
  arg1: CreateUserAppointmentTypeInput;
};


/** mutation root */
export type Mutation_RootExpensumCancelTotemPaymentArgs = {
  arg1: ExpensumCancelTotemPaymentInput;
};


/** mutation root */
export type Mutation_RootExpensumChargeCancelArgs = {
  arg1: ExpensumChargeCancelInput;
};


/** mutation root */
export type Mutation_RootExpensumCreateOnlinePaymentArgs = {
  arg1: ExpensumCreateOnlinePaymentInput;
};


/** mutation root */
export type Mutation_RootInitiumUploadCheckInFileArgs = {
  arg1: InitiumUploadCheckInFileInput;
};


/** mutation root */
export type Mutation_RootLivanceApiAgendamentoCancelaArgs = {
  codAgendamento: Scalars['Int']['input'];
  motivo?: InputMaybe<Scalars['String']['input']>;
  origem?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootLivanceApiAlteraUsuarioCompromissoPatchArgs = {
  arg1: LivanceApiAlteraUsuarioCompromissoInput;
};


/** mutation root */
export type Mutation_RootLivanceApiCadastraNovoCartaoArgs = {
  arg1: LivanceApiCadastraNovoCartaoInput;
};


/** mutation root */
export type Mutation_RootLivanceApiCancelaPeriodoGarantidoArgs = {
  arg1: LivanceApiCancelaPeriodoGarantidoInput;
};


/** mutation root */
export type Mutation_RootLivanceApiCancelaPeriodoGarantidoRecorrenteArgs = {
  periodoGarantidoRecorrente: LivanceApiCancelaPeriodoGarantidoRecorrenteInput;
};


/** mutation root */
export type Mutation_RootLivanceApiCreateAgendamentoArgs = {
  arg1: LivanceApiCreateAgendamentoInput;
};


/** mutation root */
export type Mutation_RootLivanceApiCreateAppointmentArgs = {
  arg1: LivanceApiCreateAppointmentInput;
};


/** mutation root */
export type Mutation_RootLivanceApiCreateUsuarioAgendaArgs = {
  arg1: LivanceApiCreateUsuarioAgendaInput;
};


/** mutation root */
export type Mutation_RootLivanceApiCreateUsuarioFormaRecebimentoArgs = {
  arg1?: InputMaybe<UsuarioFormaRecebimentoInput>;
};


/** mutation root */
export type Mutation_RootLivanceApiCriaFechamentoArgs = {
  arg1: LivanceApiCriaFechamentoInput;
};


/** mutation root */
export type Mutation_RootLivanceApiCriaPeriodoGarantidoRecorrenteArgs = {
  periodoGarantidoRecorrente: LivanceApiCriaPeriodoGarantidoRecorrenteInput;
};


/** mutation root */
export type Mutation_RootLivanceApiCriaUsuarioCompromissoArgs = {
  arg1: LivanceApiCriaUsuarioCompromissoInput;
};


/** mutation root */
export type Mutation_RootLivanceApiDeleteFechamentoArgs = {
  codFechamento: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootLivanceApiDeleteUsuarioAgendaArgs = {
  arg1: LivanceApiDeleteUsuarioAgendaInput;
};


/** mutation root */
export type Mutation_RootLivanceApiDeleteUsuarioCompromissoArgs = {
  arg1: LivanceApiDeleteUsuarioCompromissoInput;
};


/** mutation root */
export type Mutation_RootLivanceApiDeleteUsuarioFormaRecebimentoArgs = {
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootLivanceApiPatchDadosBancariosArgs = {
  arg1: LivanceApiPatchDadosBancariosInput;
};


/** mutation root */
export type Mutation_RootLivanceApiPatchUsuarioAgendaArgs = {
  arg1: LivanceApiPatchUsuarioAgendaInput;
};


/** mutation root */
export type Mutation_RootLivanceApiPatchUsuarioFormaRecebimentoArgs = {
  arg1?: InputMaybe<LivanceApiPatchUsuarioFormaRecebimentoInput>;
};


/** mutation root */
export type Mutation_RootLivanceApiReceberSalaAgoraArgs = {
  codAgendamento: Scalars['Int']['input'];
  origem?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootLivanceApiRemarcaAgendamentoArgs = {
  arg1: LivanceApiRemarcaAgendamentoInput;
};


/** mutation root */
export type Mutation_RootLivanceApiUpsertUsuarioEnderecoArgs = {
  arg1: LivanceApiUpsertUsuarioEnderecoInput;
};


/** mutation root */
export type Mutation_RootLivanceApiUsuarioPlanoMigracaoArgs = {
  arg1: LivanceApiUsuarioPlanoMigracaoInput;
};


/** mutation root */
export type Mutation_RootLocusUpdateMemberSocialMediaArgs = {
  arg1: LocusUpdateMemberSocialMediaInput;
};


/** mutation root */
export type Mutation_RootLocusUpsertBasicProfileArgs = {
  arg1: LocusUpsertBasicProfileInput;
};


/** mutation root */
export type Mutation_RootPagarmeAutomaticAnticipationSettingsUpdateArgs = {
  arg1: PagarmeAutomaticAnticipationSettingsUpdateInput;
};


/** mutation root */
export type Mutation_RootScheduleOnboardingVisitArgs = {
  arg1?: InputMaybe<OnboardingSchedulingInfos>;
};


/** mutation root */
export type Mutation_RootSetAppointmentAgeRangeArgs = {
  arg1: AppointmentAgeRangeInput;
};


/** mutation root */
export type Mutation_RootSetAppointmentRequirementsArgs = {
  arg1: AppointmentRequirementsInput;
};


/** mutation root */
export type Mutation_RootSetupReturnSettingsArgs = {
  arg1: SetupReturnSettingsInput;
};


/** mutation root */
export type Mutation_RootUpdateProfessionalInfoArgs = {
  arg1: UpdateProfessionalInfoInput;
};


/** mutation root */
export type Mutation_RootUpdateReturnPoliciesArgs = {
  arg1: UpdateReturnPoliciesInput;
};


/** mutation root */
export type Mutation_RootUploadProfessionalCardArgs = {
  arg1: UploadProfessionalCardInput;
};


/** mutation root */
export type Mutation_RootAceitarPacoteServicosArgs = {
  input: AceitarPacoteServicosInput;
};


/** mutation root */
export type Mutation_RootAdiantarOuAtrasarArgs = {
  input?: InputMaybe<AdiantarOuAtrasarInput>;
};


/** mutation root */
export type Mutation_RootAgendamentoAtendidoArgs = {
  input: AgendamentoAtendidoInput;
};


/** mutation root */
export type Mutation_RootAgendamentoNaoAtendidoArgs = {
  input: AgendamentoNaoAtendidoInput;
};


/** mutation root */
export type Mutation_RootAlterarPacienteArgs = {
  input: AlterarPacienteInput;
};


/** mutation root */
export type Mutation_RootAtualizarTelefonePublicoArgs = {
  input: AtualizarTelefonePublicoInput;
};


/** mutation root */
export type Mutation_RootCancelarPacoteServicosArgs = {
  input: CancelarPacoteServicosInput;
};


/** mutation root */
export type Mutation_RootCancelarPacoteServicosAssistProArgs = {
  input: CancelarPacoteServicosAssistProInput;
};


/** mutation root */
export type Mutation_RootContratarPacoteServicosArgs = {
  input?: InputMaybe<ContratarPacoteServicosInput>;
};


/** mutation root */
export type Mutation_RootCriarAgendamentoArgs = {
  input?: InputMaybe<CriarAgendamentoInput>;
};


/** mutation root */
export type Mutation_RootCriarMultiplosFechamentosArgs = {
  input?: InputMaybe<CriarMultiplosFechamentosInput>;
};


/** mutation root */
export type Mutation_RootCriarUsuarioLinkRastreamentoArgs = {
  input?: InputMaybe<CriarUsuarioLinkRastreamentoInput>;
};


/** mutation root */
export type Mutation_RootDelete_FuncionalidadesDesativadasArgs = {
  where: FuncionalidadesDesativadas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FuncionalidadesDesativadas_By_PkArgs = {
  codFuncionalidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Locus_Membro_FormacaoArgs = {
  where: Locus_Membro_Formacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Locus_Membro_Formacao_By_PkArgs = {
  idCurso: Scalars['Int']['input'];
  idInstituicaoEnsino: Scalars['Int']['input'];
  idMembro: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Locus_Membro_Instituicao_MedicaArgs = {
  where: Locus_Membro_Instituicao_Medica_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Locus_Membro_Instituicao_Medica_By_PkArgs = {
  idInstituicaoMedica: Scalars['Int']['input'];
  idMembro: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Nexus_FollowArgs = {
  where: Nexus_Follow_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Nexus_Follow_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TbFechamentosArgs = {
  where: TbFechamentos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_TbFechamentos_By_PkArgs = {
  codFechamento: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Users_Professional_CardsArgs = {
  where: Users_Professional_Cards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_Professional_Cards_By_PkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootEstenderAgendamentoArgs = {
  input?: InputMaybe<EstenderAgendamentoInput>;
};


/** mutation root */
export type Mutation_RootIndicarProfissionalArgs = {
  input?: InputMaybe<IndicarProfissionalInput>;
};


/** mutation root */
export type Mutation_RootInsert_UsuariosCompromissosStatusSugestoesDuracoesArgs = {
  if_matched?: InputMaybe<UsuariosCompromissosStatusSugestoesDuracoes_If_Matched>;
  objects: Array<UsuariosCompromissosStatusSugestoesDuracoes_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_UsuariosCompromissosStatusSugestoesDuracoes_OneArgs = {
  if_matched?: InputMaybe<UsuariosCompromissosStatusSugestoesDuracoes_If_Matched>;
  object: UsuariosCompromissosStatusSugestoesDuracoes_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Deliverus_Read_App_NotificationsArgs = {
  objects: Array<Deliverus_Read_App_Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Deliverus_Read_App_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expensum_Event_Automatic_Anticipation_Settings_UpdateArgs = {
  objects: Array<Expensum_Event_Automatic_Anticipation_Settings_Update_Insert_Input>;
  on_conflict?: InputMaybe<Expensum_Event_Automatic_Anticipation_Settings_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expensum_Event_Automatic_Anticipation_Settings_Update_OneArgs = {
  object: Expensum_Event_Automatic_Anticipation_Settings_Update_Insert_Input;
  on_conflict?: InputMaybe<Expensum_Event_Automatic_Anticipation_Settings_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expensum_Event_Bank_Account_UpdateArgs = {
  objects: Array<Expensum_Event_Bank_Account_Update_Insert_Input>;
  on_conflict?: InputMaybe<Expensum_Event_Bank_Account_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expensum_Event_Bank_Account_Update_OneArgs = {
  object: Expensum_Event_Bank_Account_Update_Insert_Input;
  on_conflict?: InputMaybe<Expensum_Event_Bank_Account_Update_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expensum_Event_Totem_Payment_SentArgs = {
  objects: Array<Expensum_Event_Totem_Payment_Sent_Insert_Input>;
  on_conflict?: InputMaybe<Expensum_Event_Totem_Payment_Sent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expensum_Event_Totem_Payment_Sent_OneArgs = {
  object: Expensum_Event_Totem_Payment_Sent_Insert_Input;
  on_conflict?: InputMaybe<Expensum_Event_Totem_Payment_Sent_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expensum_Online_Payment_ActivityArgs = {
  objects: Array<Expensum_Online_Payment_Activity_Insert_Input>;
  on_conflict?: InputMaybe<Expensum_Online_Payment_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expensum_Online_Payment_Activity_OneArgs = {
  object: Expensum_Online_Payment_Activity_Insert_Input;
  on_conflict?: InputMaybe<Expensum_Online_Payment_Activity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expensum_Recipient_Terms_Of_Use_AgreedArgs = {
  objects: Array<Expensum_Recipient_Terms_Of_Use_Agreed_Insert_Input>;
  on_conflict?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expensum_Recipient_Terms_Of_Use_Agreed_OneArgs = {
  object: Expensum_Recipient_Terms_Of_Use_Agreed_Insert_Input;
  on_conflict?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FuncionalidadesDesativadasArgs = {
  if_matched?: InputMaybe<FuncionalidadesDesativadas_If_Matched>;
  objects: Array<FuncionalidadesDesativadas_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_FuncionalidadesDesativadas_OneArgs = {
  if_matched?: InputMaybe<FuncionalidadesDesativadas_If_Matched>;
  object: FuncionalidadesDesativadas_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_LembretesArgs = {
  if_matched?: InputMaybe<Lembretes_If_Matched>;
  objects: Array<Lembretes_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Lembretes_OneArgs = {
  if_matched?: InputMaybe<Lembretes_If_Matched>;
  object: Lembretes_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Locus_Experiencia_MembroArgs = {
  objects: Array<Locus_Experiencia_Membro_Insert_Input>;
  on_conflict?: InputMaybe<Locus_Experiencia_Membro_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locus_Experiencia_Membro_OneArgs = {
  object: Locus_Experiencia_Membro_Insert_Input;
  on_conflict?: InputMaybe<Locus_Experiencia_Membro_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locus_Faq_MembroArgs = {
  objects: Array<Locus_Faq_Membro_Insert_Input>;
  on_conflict?: InputMaybe<Locus_Faq_Membro_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locus_Faq_Membro_OneArgs = {
  object: Locus_Faq_Membro_Insert_Input;
  on_conflict?: InputMaybe<Locus_Faq_Membro_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locus_Foco_Tratamento_MembroArgs = {
  objects: Array<Locus_Foco_Tratamento_Membro_Insert_Input>;
  on_conflict?: InputMaybe<Locus_Foco_Tratamento_Membro_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locus_Foco_Tratamento_Membro_OneArgs = {
  object: Locus_Foco_Tratamento_Membro_Insert_Input;
  on_conflict?: InputMaybe<Locus_Foco_Tratamento_Membro_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locus_Membro_FormacaoArgs = {
  objects: Array<Locus_Membro_Formacao_Insert_Input>;
  on_conflict?: InputMaybe<Locus_Membro_Formacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locus_Membro_Formacao_OneArgs = {
  object: Locus_Membro_Formacao_Insert_Input;
  on_conflict?: InputMaybe<Locus_Membro_Formacao_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locus_Membro_Instituicao_MedicaArgs = {
  objects: Array<Locus_Membro_Instituicao_Medica_Insert_Input>;
  on_conflict?: InputMaybe<Locus_Membro_Instituicao_Medica_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Locus_Membro_Instituicao_Medica_OneArgs = {
  object: Locus_Membro_Instituicao_Medica_Insert_Input;
  on_conflict?: InputMaybe<Locus_Membro_Instituicao_Medica_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nexus_FollowArgs = {
  objects: Array<Nexus_Follow_Insert_Input>;
  on_conflict?: InputMaybe<Nexus_Follow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Nexus_Follow_OneArgs = {
  object: Nexus_Follow_Insert_Input;
  on_conflict?: InputMaybe<Nexus_Follow_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TbUsuariosTermosDeUsoArgs = {
  if_matched?: InputMaybe<TbUsuariosTermosDeUso_If_Matched>;
  objects: Array<TbUsuariosTermosDeUso_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_TbUsuariosTermosDeUso_OneArgs = {
  if_matched?: InputMaybe<TbUsuariosTermosDeUso_If_Matched>;
  object: TbUsuariosTermosDeUso_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Users_Professional_CardsArgs = {
  objects: Array<Users_Professional_Cards_Insert_Input>;
  on_conflict?: InputMaybe<Users_Professional_Cards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Professional_Cards_OneArgs = {
  object: Users_Professional_Cards_Insert_Input;
  on_conflict?: InputMaybe<Users_Professional_Cards_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Terms_Of_Use_AgreedArgs = {
  objects: Array<Users_Terms_Of_Use_Agreed_Insert_Input>;
  on_conflict?: InputMaybe<Users_Terms_Of_Use_Agreed_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Terms_Of_Use_Agreed_OneArgs = {
  object: Users_Terms_Of_Use_Agreed_Insert_Input;
  on_conflict?: InputMaybe<Users_Terms_Of_Use_Agreed_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsuariosProfissionaisOrientacoesSecretariasArgs = {
  if_matched?: InputMaybe<UsuariosProfissionaisOrientacoesSecretarias_If_Matched>;
  objects: Array<UsuariosProfissionaisOrientacoesSecretarias_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_UsuariosProfissionaisOrientacoesSecretarias_OneArgs = {
  if_matched?: InputMaybe<UsuariosProfissionaisOrientacoesSecretarias_If_Matched>;
  object: UsuariosProfissionaisOrientacoesSecretarias_Insert_Input;
};


/** mutation root */
export type Mutation_RootReceberSalaAgoraArgs = {
  input?: InputMaybe<ReceberSalaAgoraInput>;
};


/** mutation root */
export type Mutation_RootRemarcarAgendamentoArgs = {
  input?: InputMaybe<RemarcarAgendamentoInput>;
};


/** mutation root */
export type Mutation_RootTrocarPacienteArgs = {
  input?: InputMaybe<TrocarPacienteInput>;
};


/** mutation root */
export type Mutation_RootUpdate_UsuariosCompromissosStatusSugestoesDuracoesArgs = {
  _inc?: InputMaybe<UsuariosCompromissosStatusSugestoesDuracoes_Inc_Input>;
  _set?: InputMaybe<UsuariosCompromissosStatusSugestoesDuracoes_Set_Input>;
  where: UsuariosCompromissosStatusSugestoesDuracoes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UsuariosCompromissosStatusSugestoesDuracoes_By_PkArgs = {
  _inc?: InputMaybe<UsuariosCompromissosStatusSugestoesDuracoes_Inc_Input>;
  _set?: InputMaybe<UsuariosCompromissosStatusSugestoesDuracoes_Set_Input>;
  pk_columns: UsuariosCompromissosStatusSugestoesDuracoes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Expensum_Online_PaymentArgs = {
  _set?: InputMaybe<Expensum_Online_Payment_Set_Input>;
  where: Expensum_Online_Payment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Expensum_Online_Payment_By_PkArgs = {
  _set?: InputMaybe<Expensum_Online_Payment_Set_Input>;
  pk_columns: Expensum_Online_Payment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Expensum_Online_Payment_ManyArgs = {
  updates: Array<Expensum_Online_Payment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FuncionalidadesDesativadasArgs = {
  _set?: InputMaybe<FuncionalidadesDesativadas_Set_Input>;
  where: FuncionalidadesDesativadas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FuncionalidadesDesativadas_By_PkArgs = {
  _set?: InputMaybe<FuncionalidadesDesativadas_Set_Input>;
  pk_columns: FuncionalidadesDesativadas_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_LembretesArgs = {
  _set?: InputMaybe<Lembretes_Set_Input>;
  where: Lembretes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lembretes_By_PkArgs = {
  _set?: InputMaybe<Lembretes_Set_Input>;
  pk_columns: Lembretes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Experiencia_MembroArgs = {
  _set?: InputMaybe<Locus_Experiencia_Membro_Set_Input>;
  where: Locus_Experiencia_Membro_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Experiencia_Membro_By_PkArgs = {
  _set?: InputMaybe<Locus_Experiencia_Membro_Set_Input>;
  pk_columns: Locus_Experiencia_Membro_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Experiencia_Membro_ManyArgs = {
  updates: Array<Locus_Experiencia_Membro_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Faq_MembroArgs = {
  _inc?: InputMaybe<Locus_Faq_Membro_Inc_Input>;
  _set?: InputMaybe<Locus_Faq_Membro_Set_Input>;
  where: Locus_Faq_Membro_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Faq_Membro_By_PkArgs = {
  _inc?: InputMaybe<Locus_Faq_Membro_Inc_Input>;
  _set?: InputMaybe<Locus_Faq_Membro_Set_Input>;
  pk_columns: Locus_Faq_Membro_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Faq_Membro_ManyArgs = {
  updates: Array<Locus_Faq_Membro_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Foco_Tratamento_MembroArgs = {
  _set?: InputMaybe<Locus_Foco_Tratamento_Membro_Set_Input>;
  where: Locus_Foco_Tratamento_Membro_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Foco_Tratamento_Membro_By_PkArgs = {
  _set?: InputMaybe<Locus_Foco_Tratamento_Membro_Set_Input>;
  pk_columns: Locus_Foco_Tratamento_Membro_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Foco_Tratamento_Membro_ManyArgs = {
  updates: Array<Locus_Foco_Tratamento_Membro_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_MembroArgs = {
  _set?: InputMaybe<Locus_Membro_Set_Input>;
  where: Locus_Membro_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Membro_By_PkArgs = {
  _set?: InputMaybe<Locus_Membro_Set_Input>;
  pk_columns: Locus_Membro_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Membro_FormacaoArgs = {
  _inc?: InputMaybe<Locus_Membro_Formacao_Inc_Input>;
  _set?: InputMaybe<Locus_Membro_Formacao_Set_Input>;
  where: Locus_Membro_Formacao_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Membro_Formacao_By_PkArgs = {
  _inc?: InputMaybe<Locus_Membro_Formacao_Inc_Input>;
  _set?: InputMaybe<Locus_Membro_Formacao_Set_Input>;
  pk_columns: Locus_Membro_Formacao_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Membro_Formacao_ManyArgs = {
  updates: Array<Locus_Membro_Formacao_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Membro_Instituicao_MedicaArgs = {
  _inc?: InputMaybe<Locus_Membro_Instituicao_Medica_Inc_Input>;
  _set?: InputMaybe<Locus_Membro_Instituicao_Medica_Set_Input>;
  where: Locus_Membro_Instituicao_Medica_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Membro_Instituicao_Medica_By_PkArgs = {
  _inc?: InputMaybe<Locus_Membro_Instituicao_Medica_Inc_Input>;
  _set?: InputMaybe<Locus_Membro_Instituicao_Medica_Set_Input>;
  pk_columns: Locus_Membro_Instituicao_Medica_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Membro_Instituicao_Medica_ManyArgs = {
  updates: Array<Locus_Membro_Instituicao_Medica_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Locus_Membro_ManyArgs = {
  updates: Array<Locus_Membro_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TbUsuariosTermosDeUsoArgs = {
  _set?: InputMaybe<TbUsuariosTermosDeUso_Set_Input>;
  where: TbUsuariosTermosDeUso_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_TbUsuariosTermosDeUso_By_PkArgs = {
  _set?: InputMaybe<TbUsuariosTermosDeUso_Set_Input>;
  pk_columns: TbUsuariosTermosDeUso_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_AddressesArgs = {
  _set?: InputMaybe<User_Addresses_Set_Input>;
  where: User_Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Addresses_ManyArgs = {
  updates: Array<User_Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Professional_CardsArgs = {
  _set?: InputMaybe<Users_Professional_Cards_Set_Input>;
  where: Users_Professional_Cards_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Professional_Cards_By_PkArgs = {
  _set?: InputMaybe<Users_Professional_Cards_Set_Input>;
  pk_columns: Users_Professional_Cards_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Professional_Cards_ManyArgs = {
  updates: Array<Users_Professional_Cards_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsuariosArgs = {
  _set?: InputMaybe<Usuarios_Set_Input>;
  where: Usuarios_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UsuariosCompromissosArgs = {
  _inc?: InputMaybe<UsuariosCompromissos_Inc_Input>;
  _set?: InputMaybe<UsuariosCompromissos_Set_Input>;
  where: UsuariosCompromissos_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UsuariosCompromissos_By_PkArgs = {
  _inc?: InputMaybe<UsuariosCompromissos_Inc_Input>;
  _set?: InputMaybe<UsuariosCompromissos_Set_Input>;
  pk_columns: UsuariosCompromissos_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsuariosProfissionaisOrientacoesSecretariasArgs = {
  _set?: InputMaybe<UsuariosProfissionaisOrientacoesSecretarias_Set_Input>;
  where: UsuariosProfissionaisOrientacoesSecretarias_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UsuariosProfissionaisOrientacoesSecretarias_By_PkArgs = {
  _set?: InputMaybe<UsuariosProfissionaisOrientacoesSecretarias_Set_Input>;
  pk_columns: UsuariosProfissionaisOrientacoesSecretarias_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Usuarios_By_PkArgs = {
  _set?: InputMaybe<Usuarios_Set_Input>;
  pk_columns: Usuarios_Pk_Columns_Input;
};

/** columns and relationships of "nexus.follow" */
export type Nexus_Follow = {
  __typename?: 'nexus_follow';
  codUsuarioFollower: Scalars['Int']['output'];
  codUsuarioFollowing: Scalars['Int']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "nexus.follow". All fields are combined with a logical 'AND'. */
export type Nexus_Follow_Bool_Exp = {
  _and?: InputMaybe<Array<Nexus_Follow_Bool_Exp>>;
  _not?: InputMaybe<Nexus_Follow_Bool_Exp>;
  _or?: InputMaybe<Array<Nexus_Follow_Bool_Exp>>;
  codUsuarioFollower?: InputMaybe<Int_Comparison_Exp>;
  codUsuarioFollowing?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "nexus.follow" */
export enum Nexus_Follow_Constraint {
  /** unique or primary key constraint on columns "id" */
  FollowPkey = 'follow_pkey'
}

/** input type for inserting data into table "nexus.follow" */
export type Nexus_Follow_Insert_Input = {
  codUsuarioFollowing?: InputMaybe<Scalars['Int']['input']>;
};

/** response of any mutation on the table "nexus.follow" */
export type Nexus_Follow_Mutation_Response = {
  __typename?: 'nexus_follow_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Nexus_Follow>;
};

/** on_conflict condition type for table "nexus.follow" */
export type Nexus_Follow_On_Conflict = {
  constraint: Nexus_Follow_Constraint;
  update_columns?: Array<Nexus_Follow_Update_Column>;
  where?: InputMaybe<Nexus_Follow_Bool_Exp>;
};

/** Ordering options when selecting data from "nexus.follow". */
export type Nexus_Follow_Order_By = {
  codUsuarioFollower?: InputMaybe<Order_By>;
  codUsuarioFollowing?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "nexus.follow" */
export enum Nexus_Follow_Select_Column {
  /** column name */
  CodUsuarioFollower = 'codUsuarioFollower',
  /** column name */
  CodUsuarioFollowing = 'codUsuarioFollowing',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** Streaming cursor of the table "nexus_follow" */
export type Nexus_Follow_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nexus_Follow_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nexus_Follow_Stream_Cursor_Value_Input = {
  codUsuarioFollower?: InputMaybe<Scalars['Int']['input']>;
  codUsuarioFollowing?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** placeholder for update columns of table "nexus.follow" (current role has no relevant permissions) */
export enum Nexus_Follow_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados = {
  __typename?: 'notificacoesPacientesAtrasados';
  /** An object relationship */
  Agendamento: Agendamentos;
  /** An object relationship */
  Paciente: Pacientes;
  /** An object relationship */
  Usuario?: Maybe<Usuarios>;
  codAgendamento: Scalars['Int']['output'];
  codNotificacaoPacienteAtrasado: Scalars['Int']['output'];
  codPaciente: Scalars['Int']['output'];
  codUsuarioAuditoria?: Maybe<Scalars['Int']['output']>;
  dataCadastro: Scalars['datetime2']['output'];
  tempoAtraso?: Maybe<Scalars['String']['output']>;
};

/** order by aggregate values of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Aggregate_Order_By = {
  avg?: InputMaybe<NotificacoesPacientesAtrasados_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<NotificacoesPacientesAtrasados_Max_Order_By>;
  min?: InputMaybe<NotificacoesPacientesAtrasados_Min_Order_By>;
  stddev?: InputMaybe<NotificacoesPacientesAtrasados_Stddev_Order_By>;
  stddev_pop?: InputMaybe<NotificacoesPacientesAtrasados_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<NotificacoesPacientesAtrasados_Stddev_Samp_Order_By>;
  sum?: InputMaybe<NotificacoesPacientesAtrasados_Sum_Order_By>;
  var_pop?: InputMaybe<NotificacoesPacientesAtrasados_Var_Pop_Order_By>;
  var_samp?: InputMaybe<NotificacoesPacientesAtrasados_Var_Samp_Order_By>;
  variance?: InputMaybe<NotificacoesPacientesAtrasados_Variance_Order_By>;
};

/** order by avg() on columns of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Avg_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbNotificacoesPacientesAtrasados". All fields are combined with a logical 'AND'. */
export type NotificacoesPacientesAtrasados_Bool_Exp = {
  Agendamento?: InputMaybe<Agendamentos_Bool_Exp>;
  Paciente?: InputMaybe<Pacientes_Bool_Exp>;
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  _and?: InputMaybe<Array<NotificacoesPacientesAtrasados_Bool_Exp>>;
  _not?: InputMaybe<NotificacoesPacientesAtrasados_Bool_Exp>;
  _or?: InputMaybe<Array<NotificacoesPacientesAtrasados_Bool_Exp>>;
  codAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPaciente?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioAuditoria?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  tempoAtraso?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Max_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  tempoAtraso?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Min_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  tempoAtraso?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbNotificacoesPacientesAtrasados". */
export type NotificacoesPacientesAtrasados_Order_By = {
  Agendamento?: InputMaybe<Agendamentos_Order_By>;
  Paciente?: InputMaybe<Pacientes_Order_By>;
  Usuario?: InputMaybe<Usuarios_Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  tempoAtraso?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Stddev_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Stddev_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Stddev_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Sum_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Var_Pop_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Var_Samp_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbNotificacoesPacientesAtrasados" */
export type NotificacoesPacientesAtrasados_Variance_Order_By = {
  codAgendamento?: InputMaybe<Order_By>;
  codNotificacaoPacienteAtrasado?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codUsuarioAuditoria?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "nuntius.contatos_por_dia" */
export type Nuntius_Contatos_Por_Dia = {
  __typename?: 'nuntius_contatos_por_dia';
  data: Scalars['date']['output'];
  /** An object relationship */
  loteContatosCobranca?: Maybe<Nuntius_Lote_Contatos_Cobranca>;
  totalCobravel: Scalars['Int']['output'];
  totalDigitalCobravel: Scalars['Int']['output'];
  totalHumanoCobravel: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "nuntius.contatos_por_dia". All fields are combined with a logical 'AND'. */
export type Nuntius_Contatos_Por_Dia_Bool_Exp = {
  _and?: InputMaybe<Array<Nuntius_Contatos_Por_Dia_Bool_Exp>>;
  _not?: InputMaybe<Nuntius_Contatos_Por_Dia_Bool_Exp>;
  _or?: InputMaybe<Array<Nuntius_Contatos_Por_Dia_Bool_Exp>>;
  data?: InputMaybe<Date_Comparison_Exp>;
  loteContatosCobranca?: InputMaybe<Nuntius_Lote_Contatos_Cobranca_Bool_Exp>;
  totalCobravel?: InputMaybe<Int_Comparison_Exp>;
  totalDigitalCobravel?: InputMaybe<Int_Comparison_Exp>;
  totalHumanoCobravel?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "nuntius.contatos_por_dia". */
export type Nuntius_Contatos_Por_Dia_Order_By = {
  data?: InputMaybe<Order_By>;
  loteContatosCobranca?: InputMaybe<Nuntius_Lote_Contatos_Cobranca_Order_By>;
  totalCobravel?: InputMaybe<Order_By>;
  totalDigitalCobravel?: InputMaybe<Order_By>;
  totalHumanoCobravel?: InputMaybe<Order_By>;
};

/** select columns of table "nuntius.contatos_por_dia" */
export enum Nuntius_Contatos_Por_Dia_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  TotalCobravel = 'totalCobravel',
  /** column name */
  TotalDigitalCobravel = 'totalDigitalCobravel',
  /** column name */
  TotalHumanoCobravel = 'totalHumanoCobravel'
}

/** Streaming cursor of the table "nuntius_contatos_por_dia" */
export type Nuntius_Contatos_Por_Dia_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nuntius_Contatos_Por_Dia_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nuntius_Contatos_Por_Dia_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['date']['input']>;
  totalCobravel?: InputMaybe<Scalars['Int']['input']>;
  totalDigitalCobravel?: InputMaybe<Scalars['Int']['input']>;
  totalHumanoCobravel?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "nuntius.lote_contatos_cobranca" */
export type Nuntius_Lote_Contatos_Cobranca = {
  __typename?: 'nuntius_lote_contatos_cobranca';
  /** An object relationship */
  contatosPorDia: Nuntius_Contatos_Por_Dia;
  id: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "nuntius.lote_contatos_cobranca". All fields are combined with a logical 'AND'. */
export type Nuntius_Lote_Contatos_Cobranca_Bool_Exp = {
  _and?: InputMaybe<Array<Nuntius_Lote_Contatos_Cobranca_Bool_Exp>>;
  _not?: InputMaybe<Nuntius_Lote_Contatos_Cobranca_Bool_Exp>;
  _or?: InputMaybe<Array<Nuntius_Lote_Contatos_Cobranca_Bool_Exp>>;
  contatosPorDia?: InputMaybe<Nuntius_Contatos_Por_Dia_Bool_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "nuntius.lote_contatos_cobranca". */
export type Nuntius_Lote_Contatos_Cobranca_Order_By = {
  contatosPorDia?: InputMaybe<Nuntius_Contatos_Por_Dia_Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "nuntius.lote_contatos_cobranca" */
export enum Nuntius_Lote_Contatos_Cobranca_Select_Column {
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "nuntius_lote_contatos_cobranca" */
export type Nuntius_Lote_Contatos_Cobranca_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nuntius_Lote_Contatos_Cobranca_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nuntius_Lote_Contatos_Cobranca_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls first */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls last */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "tbPacientes" */
export type Pacientes = {
  __typename?: 'pacientes';
  /** An array relationship */
  Agendamentos: Array<Agendamentos>;
  /** An aggregate relationship */
  Agendamentos_aggregate: Agendamentos_Aggregate;
  /** An object relationship */
  UsuariosProfissionais?: Maybe<UsuariosProfissionais>;
  ativo: Scalars['Boolean']['output'];
  codPaciente: Scalars['Int']['output'];
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  cpfProprio: Scalars['Boolean']['output'];
  dataNascimento?: Maybe<Scalars['date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  foto?: Maybe<Scalars['image']['output']>;
  nome: Scalars['String']['output'];
  nomeConvenio?: Maybe<Scalars['String']['output']>;
  nomePlano?: Maybe<Scalars['String']['output']>;
  numeroCarteirinha?: Maybe<Scalars['String']['output']>;
  receberWhatsAppConfirmacao: Scalars['Boolean']['output'];
  registroVirtual: Scalars['Boolean']['output'];
  telefone: Scalars['String']['output'];
  telefoneInternacionalNormalizado?: Maybe<Scalars['String']['output']>;
  telefoneNormalizado?: Maybe<Scalars['String']['output']>;
  telefoneProprio: Scalars['Boolean']['output'];
  telefone_replace?: Maybe<Scalars['String']['output']>;
  validadeCarteirinha?: Maybe<Scalars['date']['output']>;
};


/** columns and relationships of "tbPacientes" */
export type PacientesAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbPacientes" */
export type PacientesAgendamentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tbPacientes". All fields are combined with a logical 'AND'. */
export type Pacientes_Bool_Exp = {
  Agendamentos?: InputMaybe<Agendamentos_Bool_Exp>;
  UsuariosProfissionais?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
  _and?: InputMaybe<Array<Pacientes_Bool_Exp>>;
  _not?: InputMaybe<Pacientes_Bool_Exp>;
  _or?: InputMaybe<Array<Pacientes_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codPaciente?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoConvenio?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  cpf?: InputMaybe<String_Mssql_Comparison_Exp>;
  cpfProprio?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  dataNascimento?: InputMaybe<Date_Mssql_Comparison_Exp>;
  email?: InputMaybe<String_Mssql_Comparison_Exp>;
  foto?: InputMaybe<Image_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  nomeConvenio?: InputMaybe<String_Mssql_Comparison_Exp>;
  nomePlano?: InputMaybe<String_Mssql_Comparison_Exp>;
  numeroCarteirinha?: InputMaybe<String_Mssql_Comparison_Exp>;
  receberWhatsAppConfirmacao?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  registroVirtual?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  telefone?: InputMaybe<String_Mssql_Comparison_Exp>;
  telefoneInternacionalNormalizado?: InputMaybe<String_Mssql_Comparison_Exp>;
  telefoneNormalizado?: InputMaybe<String_Mssql_Comparison_Exp>;
  telefoneProprio?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  telefone_replace?: InputMaybe<String_Mssql_Comparison_Exp>;
  validadeCarteirinha?: InputMaybe<Date_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbPacientes". */
export type Pacientes_Order_By = {
  Agendamentos_aggregate?: InputMaybe<Agendamentos_Aggregate_Order_By>;
  UsuariosProfissionais?: InputMaybe<UsuariosProfissionais_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codPaciente?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  cpf?: InputMaybe<Order_By>;
  cpfProprio?: InputMaybe<Order_By>;
  dataNascimento?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  foto?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  nomeConvenio?: InputMaybe<Order_By>;
  nomePlano?: InputMaybe<Order_By>;
  numeroCarteirinha?: InputMaybe<Order_By>;
  receberWhatsAppConfirmacao?: InputMaybe<Order_By>;
  registroVirtual?: InputMaybe<Order_By>;
  telefone?: InputMaybe<Order_By>;
  telefoneInternacionalNormalizado?: InputMaybe<Order_By>;
  telefoneNormalizado?: InputMaybe<Order_By>;
  telefoneProprio?: InputMaybe<Order_By>;
  telefone_replace?: InputMaybe<Order_By>;
  validadeCarteirinha?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbPacotesServicosPrecos" */
export type PacoteServicoPreco = {
  __typename?: 'pacoteServicoPreco';
  codPacoteServicosPreco: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  /** An array relationship */
  pacotesServicosPrecosVariaveis: Array<TbPacotesServicosPrecosVariaveis>;
  valorUnitarioFixo: Scalars['Float']['output'];
  valorUnitarioVariavel: Scalars['Float']['output'];
};


/** columns and relationships of "tbPacotesServicosPrecos" */
export type PacoteServicoPrecoPacotesServicosPrecosVariaveisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPacotesServicosPrecosVariaveis_Order_By>>;
  where?: InputMaybe<TbPacotesServicosPrecosVariaveis_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tbPacotesServicosPrecos". All fields are combined with a logical 'AND'. */
export type PacoteServicoPreco_Bool_Exp = {
  _and?: InputMaybe<Array<PacoteServicoPreco_Bool_Exp>>;
  _not?: InputMaybe<PacoteServicoPreco_Bool_Exp>;
  _or?: InputMaybe<Array<PacoteServicoPreco_Bool_Exp>>;
  codPacoteServicosPreco?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  pacotesServicosPrecosVariaveis?: InputMaybe<TbPacotesServicosPrecosVariaveis_Bool_Exp>;
  valorUnitarioFixo?: InputMaybe<Float_Mssql_Comparison_Exp>;
  valorUnitarioVariavel?: InputMaybe<Float_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbPacotesServicosPrecos". */
export type PacoteServicoPreco_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  pacotesServicosPrecosVariaveis_aggregate?: InputMaybe<TbPacotesServicosPrecosVariaveis_Aggregate_Order_By>;
  valorUnitarioFixo?: InputMaybe<Order_By>;
  valorUnitarioVariavel?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbPacotesServicos" */
export type PacotesServicos = {
  __typename?: 'pacotesServicos';
  ativo: Scalars['Boolean']['output'];
  cancelavel: Scalars['Boolean']['output'];
  codPacoteServicos: Scalars['Int']['output'];
  codPacoteServicosBase?: Maybe<Scalars['Int']['output']>;
  codPacoteServicosPreco?: Maybe<Scalars['Int']['output']>;
  dataCadastro: Scalars['datetime2']['output'];
  grupoUpgrade?: Maybe<Scalars['String']['output']>;
  nome: Scalars['String']['output'];
  /** An object relationship */
  pacotesServicosPreco?: Maybe<PacoteServicoPreco>;
};

/** Boolean expression to filter rows from the table "tbPacotesServicos". All fields are combined with a logical 'AND'. */
export type PacotesServicos_Bool_Exp = {
  _and?: InputMaybe<Array<PacotesServicos_Bool_Exp>>;
  _not?: InputMaybe<PacotesServicos_Bool_Exp>;
  _or?: InputMaybe<Array<PacotesServicos_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  cancelavel?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codPacoteServicos?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPacoteServicosBase?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPacoteServicosPreco?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  grupoUpgrade?: InputMaybe<String_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  pacotesServicosPreco?: InputMaybe<PacoteServicoPreco_Bool_Exp>;
};

/** Ordering options when selecting data from "tbPacotesServicos". */
export type PacotesServicos_Order_By = {
  ativo?: InputMaybe<Order_By>;
  cancelavel?: InputMaybe<Order_By>;
  codPacoteServicos?: InputMaybe<Order_By>;
  codPacoteServicosBase?: InputMaybe<Order_By>;
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  grupoUpgrade?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  pacotesServicosPreco?: InputMaybe<PacoteServicoPreco_Order_By>;
};

/** columns and relationships of "tbPlanos" */
export type Planos = {
  __typename?: 'planos';
  ativo: Scalars['Boolean']['output'];
  carenciaEmMeses: Scalars['Int']['output'];
  codPlano: Scalars['Int']['output'];
  codTipoMovimentacao?: Maybe<Scalars['Int']['output']>;
  dataCadastro: Scalars['datetime2']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  duracaoFidelidadeEmMeses: Scalars['Int']['output'];
  migravel: Scalars['Boolean']['output'];
  nome: Scalars['String']['output'];
  nomeExibicao: Scalars['String']['output'];
  observacao?: Maybe<Scalars['String']['output']>;
  temFidelidade: Scalars['Boolean']['output'];
  /** An object relationship */
  tipoMovimentacao?: Maybe<TiposMovimentacoes>;
  tipoMovimentacaoRepeticao: Scalars['Int']['output'];
  tipoPlano: Scalars['String']['output'];
  valor: Scalars['Float']['output'];
};

/** columns and relationships of "tbPlanosMigracoes" */
export type PlanosMigracoes = {
  __typename?: 'planosMigracoes';
  ativo: Scalars['Boolean']['output'];
  codPlanoDestino: Scalars['Int']['output'];
  codPlanoOrigem: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "tbPlanosMigracoes". All fields are combined with a logical 'AND'. */
export type PlanosMigracoes_Bool_Exp = {
  _and?: InputMaybe<Array<PlanosMigracoes_Bool_Exp>>;
  _not?: InputMaybe<PlanosMigracoes_Bool_Exp>;
  _or?: InputMaybe<Array<PlanosMigracoes_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codPlanoDestino?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPlanoOrigem?: InputMaybe<Int_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbPlanosMigracoes". */
export type PlanosMigracoes_Order_By = {
  ativo?: InputMaybe<Order_By>;
  codPlanoDestino?: InputMaybe<Order_By>;
  codPlanoOrigem?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "tbPlanos" */
export type Planos_Aggregate_Order_By = {
  avg?: InputMaybe<Planos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Planos_Max_Order_By>;
  min?: InputMaybe<Planos_Min_Order_By>;
  stddev?: InputMaybe<Planos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Planos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Planos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Planos_Sum_Order_By>;
  var_pop?: InputMaybe<Planos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Planos_Var_Samp_Order_By>;
  variance?: InputMaybe<Planos_Variance_Order_By>;
};

/** order by avg() on columns of table "tbPlanos" */
export type Planos_Avg_Order_By = {
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbPlanos". All fields are combined with a logical 'AND'. */
export type Planos_Bool_Exp = {
  _and?: InputMaybe<Array<Planos_Bool_Exp>>;
  _not?: InputMaybe<Planos_Bool_Exp>;
  _or?: InputMaybe<Array<Planos_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  carenciaEmMeses?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPlano?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoMovimentacao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  descricao?: InputMaybe<String_Mssql_Comparison_Exp>;
  duracaoFidelidadeEmMeses?: InputMaybe<Int_Mssql_Comparison_Exp>;
  migravel?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  nomeExibicao?: InputMaybe<String_Mssql_Comparison_Exp>;
  observacao?: InputMaybe<String_Mssql_Comparison_Exp>;
  temFidelidade?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  tipoMovimentacao?: InputMaybe<TiposMovimentacoes_Bool_Exp>;
  tipoMovimentacaoRepeticao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  tipoPlano?: InputMaybe<String_Mssql_Comparison_Exp>;
  valor?: InputMaybe<Float_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbPlanos" */
export type Planos_Max_Order_By = {
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  nomeExibicao?: InputMaybe<Order_By>;
  observacao?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  tipoPlano?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbPlanos" */
export type Planos_Min_Order_By = {
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  nomeExibicao?: InputMaybe<Order_By>;
  observacao?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  tipoPlano?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbPlanos". */
export type Planos_Order_By = {
  ativo?: InputMaybe<Order_By>;
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  migravel?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  nomeExibicao?: InputMaybe<Order_By>;
  observacao?: InputMaybe<Order_By>;
  temFidelidade?: InputMaybe<Order_By>;
  tipoMovimentacao?: InputMaybe<TiposMovimentacoes_Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  tipoPlano?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbPlanos" */
export type Planos_Stddev_Order_By = {
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbPlanos" */
export type Planos_Stddev_Pop_Order_By = {
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbPlanos" */
export type Planos_Stddev_Samp_Order_By = {
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbPlanos" */
export type Planos_Sum_Order_By = {
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbPlanos" */
export type Planos_Var_Pop_Order_By = {
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbPlanos" */
export type Planos_Var_Samp_Order_By = {
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbPlanos" */
export type Planos_Variance_Order_By = {
  carenciaEmMeses?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  duracaoFidelidadeEmMeses?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** An array relationship */
  AgendamentosAlocacoesAtivas: Array<AgendamentosAlocacoesAtivas>;
  /** fetch data from the table: "tbAgendamentosAlocacoesAtivas" using primary key columns */
  AgendamentosAlocacoesAtivas_by_pk?: Maybe<AgendamentosAlocacoesAtivas>;
  /** AnimusGetNewVirtualSalesVisitAvailability */
  AnimusGetNewVirtualSalesVisitAvailability?: Maybe<Array<Maybe<VirtualNewSalesVisitAvailability>>>;
  AnimusGetSalesVisitAvailability?: Maybe<Array<Maybe<GetSalesVisitAvailabilityOutput>>>;
  AnimusGetVirtualSalesVisitAvailability?: Maybe<Array<Maybe<VirtualSalesVisitAvailability>>>;
  AnimusGetVirtualSalesVisitDurations: Scalars['Int']['output'];
  AnimusOnboardingTimeAvailability: Scalars['json']['output'];
  ExpensumGetAutomaticAnticipationSettingsByRecipient?: Maybe<ExpensumGetAutomaticAnticipationSettingsByRecipientOutput>;
  ExpensumGetBankAccountByRecipient?: Maybe<ExpensumGetBankAccountByRecipientOutput>;
  ExpensumGetPayables?: Maybe<ExpensumGetPayablesOutput>;
  /** ExpensumGetPayablesChartsInfo */
  ExpensumGetPayablesChartsInfo: ExpensumGetPayablesChartsInfoOutput;
  ExpensumGetPayablesV2?: Maybe<ExpensumGetPayablesV2Output>;
  ExpensumGetPayments?: Maybe<ExpensumGetPaymentsOutput>;
  ExpensumGetPaymentsChartsInfo: ExpensumGetPaymentsChartsInfoOutput;
  ExpensumGetRecipient?: Maybe<ExpensumGetRecipientOutput>;
  /** ExpensumGetRefundReceipt */
  ExpensumGetRefundReceipt?: Maybe<ExpensumGetRefundReceiptOutput>;
  ExpensumPaymentDetails?: Maybe<ExpensumPaymentDetailsOutput>;
  GetAllBanks?: Maybe<Array<Maybe<GetAllBanksOutput>>>;
  GetAvailableTimes?: Maybe<Array<Maybe<TimeSuggestion>>>;
  /** LivanceApiBuscaHorarioLivre */
  LivanceApiBuscaHorarioLivre?: Maybe<Array<Maybe<LivanceApiBuscaHorarioLivreOutput>>>;
  /**
   * ## Verifica se o agendamento desejado pode ser reagendado para os horários informados.
   *             
   * Verifica se o agendamento desejado pode ser reagendado para os horários informados, essa verificação busca uma sala na unidade
   * e retorna a lista de horários e caso não seja possível a remarcação, informa o motivo.
   * 
   * ## Restrições
   *             
   * 1. Não é possível buscar horário para profissionais bloqueados;
   *  
   * ## Retorno
   *             
   * Uma lista de horários autorizados e não autorizados com seus motivos para não serem autorizados.
   */
  LivanceApiBuscaHorarioLivreReagendamento?: Maybe<Array<Maybe<LivanceApiBuscaHorarioLivreReagendamentoOutput>>>;
  /** Action that calls the endpoint to search for available times by day of the week for guaranteed periods */
  LivanceApiBuscaHorariosDisponiveisDiaDaSemana?: Maybe<LivanceApiBuscaHorariosDisponiveisDiaDaSemanaOutput>;
  /** LivanceApiBuscaHorariosParaEstender */
  LivanceApiBuscaHorariosParaEstender?: Maybe<Array<Maybe<TimeSuggestion>>>;
  /** LivanceApiBuscaSelecionaFaixasLivresAgenda */
  LivanceApiBuscaSelecionaFaixasLivresAgenda?: Maybe<Array<Maybe<LivanceApiBuscaSelecionaFaixasLivresAgendaOutput>>>;
  /** LivanceApiBuscaTipoSalaSugestoes */
  LivanceApiBuscaTipoSalaSugestoes?: Maybe<Array<Maybe<LivanceApiBuscaTipoSalaSugestoesOutput>>>;
  /** LivanceApiBuscaUsuarioCompromissoSugestaoDuracao */
  LivanceApiBuscaUsuarioCompromissoSugestaoDuracao?: Maybe<LivanceApiBuscaUsuarioCompromissoSugestaoDuracaoOutput>;
  LivanceApiFeriadosPorPeriodo?: Maybe<Array<Maybe<LivanceApiFeriado>>>;
  /** Busca a foto de perfil do profissional se existir */
  LivanceApiSelecionaFotoDePerfil?: Maybe<LivanceApiSelecionaFotoDePerfilOutput>;
  /** LivanceApiBuscaHorariosProximos */
  LivanceApiSelecionaHorariosProximos?: Maybe<LivanceApiSelecionaHorariosProximosOutput>;
  LivanceApiSimulaCobrancaDeCancelamento?: Maybe<LivanceApiSimulaCobrancaDeCancelamentoOutput>;
  /** Action criada para simular o valor de cobrança de um período garantido */
  LivanceApiSimulaCobrancaPeriodoGarantido?: Maybe<LivanceApiSimulaCobrancaPeriodoGarantidoOutput>;
  /** LivanceApiUsuarioAgendaAtivosPorUsuario */
  LivanceApiUsuarioAgendaAtivosPorUsuario?: Maybe<Array<Maybe<LivanceApiUsuarioAgendaAtivosPorUsuarioOutput>>>;
  /** LocusGetProfileCompletionPercentage */
  LocusGetProfileCompletionPercentage?: Maybe<LocusGetProfileCompletionPercentageOutput>;
  NuntiusGetAssistContactBatchDetails?: Maybe<NuntiusGetAssistContactBatchDetailsOutput>;
  /** NuntiusGetCustomerContactManyPeriodSummary */
  NuntiusGetCustomerContactManyPeriodSummary?: Maybe<Array<NuntiusGetCustomerContactManyPeriodSummaryOutput>>;
  /** NuntiusGetCustomerContactPeriodSummary */
  NuntiusGetCustomerContactPeriodSummary?: Maybe<NuntiusGetCustomerContactPeriodSummaryOutput>;
  /** NuntiusGetFutureAppointmentByPhoneNumber */
  NuntiusGetFutureAppointmentByPhoneNumber?: Maybe<NuntiusGetFutureAppointmentByPhoneNumberOutput>;
  PagarmePayablesList?: Maybe<PagarmePayablesListOutput>;
  /** An array relationship */
  PrecificacoesTiposSalas: Array<PrecificacoesTiposSalas>;
  /** fetch data from the table: "tbPrecificacoesTiposSalas" using primary key columns */
  PrecificacoesTiposSalas_by_pk?: Maybe<PrecificacoesTiposSalas>;
  /** fetch data from the table: "tbUnidadesPrecosFlexiveis" */
  UnidadesPrecosFlexiveis: Array<UnidadesPrecosFlexiveis>;
  /** An array relationship */
  UnidadesPrecosFlexiveisParceirosIntegracoes: Array<UnidadesPrecosFlexiveisParceirosIntegracoes>;
  /** An aggregate relationship */
  UnidadesPrecosFlexiveisParceirosIntegracoes_aggregate: UnidadesPrecosFlexiveisParceirosIntegracoes_Aggregate;
  /** fetch data from the table: "tbUnidadesPrecosFlexiveisParceirosIntegracoes" using primary key columns */
  UnidadesPrecosFlexiveisParceirosIntegracoes_by_pk?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes>;
  /** fetch aggregated fields from the table: "tbUnidadesPrecosFlexiveis" */
  UnidadesPrecosFlexiveis_aggregate: UnidadesPrecosFlexiveis_Aggregate;
  /** fetch data from the table: "tbUnidadesPrecosFlexiveis" using primary key columns */
  UnidadesPrecosFlexiveis_by_pk?: Maybe<UnidadesPrecosFlexiveis>;
  /** fetch data from the table: "tbUnidadesSalasMotivosBloqueios" */
  UnidadesSalasMotivosBloqueios: Array<UnidadesSalasMotivosBloqueios>;
  /** fetch data from the table: "tbUnidadesSalasMotivosBloqueios" using primary key columns */
  UnidadesSalasMotivosBloqueios_by_pk?: Maybe<UnidadesSalasMotivosBloqueios>;
  /** fetch data from the table: "tbUsuariosArquivos" */
  UsuariosArquivos: Array<UsuariosArquivos>;
  /** fetch data from the table: "tbUsuariosArquivos" using primary key columns */
  UsuariosArquivos_by_pk?: Maybe<UsuariosArquivos>;
  /** fetch data from the table: "tbUsuariosCompromissosStatusSugestoesDuracoes" */
  UsuariosCompromissosStatusSugestoesDuracoes: Array<UsuariosCompromissosStatusSugestoesDuracoes>;
  /** fetch data from the table: "tbUsuariosCompromissosStatusSugestoesDuracoes" using primary key columns */
  UsuariosCompromissosStatusSugestoesDuracoes_by_pk?: Maybe<UsuariosCompromissosStatusSugestoesDuracoes>;
  /** ValidateCEP */
  ValidateCEP?: Maybe<ValidateCepOutput>;
  ValidateCNPJ?: Maybe<ValidateCnpjOutput>;
  /** An array relationship */
  agendamentos: Array<Agendamentos>;
  /** fetch data from the table: "tbAgendamentosAlocacoes" */
  agendamentosAlocacoes: Array<AgendamentosAlocacoes>;
  /** fetch aggregated fields from the table: "tbAgendamentosAlocacoes" */
  agendamentosAlocacoes_aggregate: AgendamentosAlocacoes_Aggregate;
  /** fetch data from the table: "tbAgendamentosAlocacoes" using primary key columns */
  agendamentosAlocacoes_by_pk?: Maybe<AgendamentosAlocacoes>;
  /** fetch data from the table: "tbAgendamentosPreAlocacao" */
  agendamentosPreAlocacao: Array<AgendamentosPreAlocacao>;
  /** fetch aggregated fields from the table: "tbAgendamentosPreAlocacao" */
  agendamentosPreAlocacao_aggregate: AgendamentosPreAlocacao_Aggregate;
  /** fetch data from the table: "tbAgendamentosPreAlocacao" using primary key columns */
  agendamentosPreAlocacao_by_pk?: Maybe<AgendamentosPreAlocacao>;
  /** An array relationship */
  agendamentosTags: Array<AgendamentosTags>;
  /** fetch data from the table: "tbAgendamentosTags" using primary key columns */
  agendamentosTags_by_pk?: Maybe<AgendamentosTags>;
  /** fetch data from the table: "tbAgendamentosTiposTags" */
  agendamentosTiposTags: Array<AgendamentosTiposTags>;
  /** fetch data from the table: "tbAgendamentosTiposTags" using primary key columns */
  agendamentosTiposTags_by_pk?: Maybe<AgendamentosTiposTags>;
  /** An aggregate relationship */
  agendamentos_aggregate: Agendamentos_Aggregate;
  /** fetch data from the table: "tbAgendamentos" using primary key columns */
  agendamentos_by_pk?: Maybe<Agendamentos>;
  /** Método que retorna uma alocação ativa detalhadas */
  alocacaoAtivaDetalhada?: Maybe<AlocacaoAtiva>;
  /** Método que retorna todas as componentes de uma alocação detalhadas */
  alocacaoDetalhada?: Maybe<AlocacaoDetalhada>;
  analyticsMembroDadosDeUsuarioLinkRastreamento?: Maybe<AnalyticsMembroDadosDeUsuarioLinkRastreamento>;
  analyticsMembroRelatorioIndependente?: Maybe<AnalyticsMembroRelatorioIndependente>;
  analyticsMembroTotalDeAgendamentosResgatadosPorFluxo?: Maybe<AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo>;
  /** Método que retorna todos os horários livres próximos de uma unidade */
  buscaHorariosEmUnidadesAlternativas?: Maybe<BuscaHorariosUnidadeAlternativaOutput>;
  /** fetch data from the table: "tbCanaisAgendamentos" */
  canaisAgendamentos: Array<CanaisAgendamentos>;
  /** fetch data from the table: "tbCanaisAgendamentos" using primary key columns */
  canaisAgendamentos_by_pk?: Maybe<CanaisAgendamentos>;
  /** fetch data from the table: "tbCobrancas" */
  cobrancas: Array<Cobrancas>;
  /** Método que retorna as cobranças futuras, antes de serem criadas */
  cobrancasAbertas?: Maybe<CobrancasAbertasConnection>;
  /** Método que retorna as cobranças já fechadas do usuário com os cálculos de desconto, parcelas e etc. */
  cobrancasFechadas?: Maybe<CobrancasFechadasConnection>;
  /** fetch data from the table: "tbCsatCategorias" */
  csatCategorias: Array<CsatCategorias>;
  /** An array relationship */
  csatCategoriasNotas: Array<CsatCategoriasNotas>;
  /** fetch data from the table: "tbCsatCategoriasNotas" using primary key columns */
  csatCategoriasNotas_by_pk?: Maybe<CsatCategoriasNotas>;
  /** fetch data from the table: "tbCsatCategorias" using primary key columns */
  csatCategorias_by_pk?: Maybe<CsatCategorias>;
  /** Esse método busca a possivel data de final do trial para o assist pro */
  dataFimTrialAssistPro?: Maybe<BuscaDataFimTrialAssistProOutput>;
  /** fetch data from the table: "tbEspecialidades" */
  especialidades: Array<Especialidades>;
  /** fetch data from the table: "tbEspecialidades" using primary key columns */
  especialidades_by_pk?: Maybe<Especialidades>;
  /** fetch data from the table: "expensum.appointment_paid" */
  expensum_appointment_paid: Array<Expensum_Appointment_Paid>;
  /** fetch aggregated fields from the table: "expensum.appointment_paid" */
  expensum_appointment_paid_aggregate: Expensum_Appointment_Paid_Aggregate;
  /** fetch data from the table: "expensum.event_automatic_anticipation_settings_update" */
  expensum_event_automatic_anticipation_settings_update: Array<Expensum_Event_Automatic_Anticipation_Settings_Update>;
  /** fetch data from the table: "expensum.event_automatic_anticipation_settings_update" using primary key columns */
  expensum_event_automatic_anticipation_settings_update_by_pk?: Maybe<Expensum_Event_Automatic_Anticipation_Settings_Update>;
  /** fetch data from the table: "expensum.event_bank_account_update" */
  expensum_event_bank_account_update: Array<Expensum_Event_Bank_Account_Update>;
  /** fetch data from the table: "expensum.event_bank_account_update" using primary key columns */
  expensum_event_bank_account_update_by_pk?: Maybe<Expensum_Event_Bank_Account_Update>;
  /** fetch data from the table: "expensum.event_totem_payment_sent" */
  expensum_event_totem_payment_sent: Array<Expensum_Event_Totem_Payment_Sent>;
  /** fetch aggregated fields from the table: "expensum.event_totem_payment_sent" */
  expensum_event_totem_payment_sent_aggregate: Expensum_Event_Totem_Payment_Sent_Aggregate;
  /** fetch data from the table: "expensum.event_totem_payment_sent" using primary key columns */
  expensum_event_totem_payment_sent_by_pk?: Maybe<Expensum_Event_Totem_Payment_Sent>;
  /** fetch data from the table: "expensum.online_payment" */
  expensum_online_payment: Array<Expensum_Online_Payment>;
  /** fetch data from the table: "expensum.online_payment_activity" */
  expensum_online_payment_activity: Array<Expensum_Online_Payment_Activity>;
  /** fetch aggregated fields from the table: "expensum.online_payment" */
  expensum_online_payment_aggregate: Expensum_Online_Payment_Aggregate;
  /** fetch data from the table: "expensum.online_payment" using primary key columns */
  expensum_online_payment_by_pk?: Maybe<Expensum_Online_Payment>;
  /** fetch data from the table: "expensum.payment_type" */
  expensum_payment_type: Array<Expensum_Payment_Type>;
  /** fetch data from the table: "expensum.payment_type" using primary key columns */
  expensum_payment_type_by_pk?: Maybe<Expensum_Payment_Type>;
  /** fetch data from the table: "expensum.recipient_terms_of_use_agreed" */
  expensum_recipient_terms_of_use_agreed: Array<Expensum_Recipient_Terms_Of_Use_Agreed>;
  /** fetch data from the table: "expensum.recipient_terms_of_use_agreed" using primary key columns */
  expensum_recipient_terms_of_use_agreed_by_pk?: Maybe<Expensum_Recipient_Terms_Of_Use_Agreed>;
  /** fetch data from the table: "expensum.terms_of_use" */
  expensum_terms_of_use: Array<Expensum_Terms_Of_Use>;
  /** fetch data from the table: "expensum.terms_of_use" using primary key columns */
  expensum_terms_of_use_by_pk?: Maybe<Expensum_Terms_Of_Use>;
  /** fetch data from the table: "tbFinalidadesAgendamentos" */
  finalidadesAgendamentos: Array<FinalidadesAgendamentos>;
  /** fetch data from the table: "tbFinalidadesAgendamentos" using primary key columns */
  finalidadesAgendamentos_by_pk?: Maybe<FinalidadesAgendamentos>;
  /** An array relationship */
  funcionalidadesDesativadas: Array<FuncionalidadesDesativadas>;
  /** fetch data from the table: "tbFuncionalidadesDesativadas" using primary key columns */
  funcionalidadesDesativadas_by_pk?: Maybe<FuncionalidadesDesativadas>;
  /**
   * Obtém a hora atual no formato "HH:mm:ss".
   *
   *
   * **Returns:**
   *
   * Uma string representando a hora atual no formato "HH:mm:ss".
   */
  horaAtual?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  lembretes: Array<Lembretes>;
  /** An aggregate relationship */
  lembretes_aggregate: Lembretes_Aggregate;
  /** fetch data from the table: "tbLembretes" using primary key columns */
  lembretes_by_pk?: Maybe<Lembretes>;
  /** fetch data from the table: "tbLinksDestinos" */
  linksDestinos: Array<LinksDestinos>;
  /** fetch data from the table: "tbLinksDestinos" using primary key columns */
  linksDestinos_by_pk?: Maybe<LinksDestinos>;
  /**
   * Obtém uma lista de ações bloqueadas para o usuário autenticado.
   *
   *
   * **Returns:**
   * Uma lista de ações bloqueadas para o usuário autenticado.
   */
  listaAcoesBloqueadas?: Maybe<Array<Maybe<UsuarioAcaoBloqueadaViewModel>>>;
  /** fetch data from the table: "locus.conselho_profissional" */
  locus_conselho_profissional: Array<Locus_Conselho_Profissional>;
  /** fetch data from the table: "locus.conselho_profissional" using primary key columns */
  locus_conselho_profissional_by_pk?: Maybe<Locus_Conselho_Profissional>;
  /** fetch data from the table: "locus.conselho_profissional_especialidade" */
  locus_conselho_profissional_especialidade: Array<Locus_Conselho_Profissional_Especialidade>;
  /** fetch data from the table: "locus.conselho_profissional_especialidade" using primary key columns */
  locus_conselho_profissional_especialidade_by_pk?: Maybe<Locus_Conselho_Profissional_Especialidade>;
  /** fetch data from the table: "locus.curso_formacao" */
  locus_curso_formacao: Array<Locus_Curso_Formacao>;
  /** fetch data from the table: "locus.curso_formacao" using primary key columns */
  locus_curso_formacao_by_pk?: Maybe<Locus_Curso_Formacao>;
  /** fetch data from the table: "locus.especialidade" */
  locus_especialidade: Array<Locus_Especialidade>;
  /** fetch data from the table: "locus.especialidade" using primary key columns */
  locus_especialidade_by_pk?: Maybe<Locus_Especialidade>;
  /** fetch data from the table: "locus.especialidade_subespecialidade" */
  locus_especialidade_subespecialidade: Array<Locus_Especialidade_Subespecialidade>;
  /** fetch data from the table: "locus.especialidade_subespecialidade" using primary key columns */
  locus_especialidade_subespecialidade_by_pk?: Maybe<Locus_Especialidade_Subespecialidade>;
  /** fetch data from the table: "locus.experiencia_membro" */
  locus_experiencia_membro: Array<Locus_Experiencia_Membro>;
  /** fetch data from the table: "locus.experiencia_membro" using primary key columns */
  locus_experiencia_membro_by_pk?: Maybe<Locus_Experiencia_Membro>;
  /** fetch data from the table: "locus.faq_membro" */
  locus_faq_membro: Array<Locus_Faq_Membro>;
  /** fetch data from the table: "locus.faq_membro" using primary key columns */
  locus_faq_membro_by_pk?: Maybe<Locus_Faq_Membro>;
  /** fetch data from the table: "locus.foco_tratamento_membro" */
  locus_foco_tratamento_membro: Array<Locus_Foco_Tratamento_Membro>;
  /** fetch data from the table: "locus.foco_tratamento_membro" using primary key columns */
  locus_foco_tratamento_membro_by_pk?: Maybe<Locus_Foco_Tratamento_Membro>;
  /** fetch data from the table: "locus.instituicao_ensino" */
  locus_instituicao_ensino: Array<Locus_Instituicao_Ensino>;
  /** fetch data from the table: "locus.instituicao_ensino" using primary key columns */
  locus_instituicao_ensino_by_pk?: Maybe<Locus_Instituicao_Ensino>;
  /** fetch data from the table: "locus.instituicao_medica" */
  locus_instituicao_medica: Array<Locus_Instituicao_Medica>;
  /** fetch data from the table: "locus.instituicao_medica" using primary key columns */
  locus_instituicao_medica_by_pk?: Maybe<Locus_Instituicao_Medica>;
  /** fetch data from the table: "locus.membro" */
  locus_membro: Array<Locus_Membro>;
  /** fetch data from the table: "locus.membro" using primary key columns */
  locus_membro_by_pk?: Maybe<Locus_Membro>;
  /** fetch data from the table: "locus.membro_especialidade" */
  locus_membro_especialidade: Array<Locus_Membro_Especialidade>;
  /** fetch data from the table: "locus.membro_especialidade" using primary key columns */
  locus_membro_especialidade_by_pk?: Maybe<Locus_Membro_Especialidade>;
  /** fetch data from the table: "locus.membro_especialidade_subespecialidade" */
  locus_membro_especialidade_subespecialidade: Array<Locus_Membro_Especialidade_Subespecialidade>;
  /** fetch data from the table: "locus.membro_especialidade_subespecialidade" using primary key columns */
  locus_membro_especialidade_subespecialidade_by_pk?: Maybe<Locus_Membro_Especialidade_Subespecialidade>;
  /** fetch data from the table: "locus.membro_formacao" */
  locus_membro_formacao: Array<Locus_Membro_Formacao>;
  /** fetch data from the table: "locus.membro_formacao" using primary key columns */
  locus_membro_formacao_by_pk?: Maybe<Locus_Membro_Formacao>;
  /** fetch data from the table: "locus.membro_instituicao_medica" */
  locus_membro_instituicao_medica: Array<Locus_Membro_Instituicao_Medica>;
  /** fetch data from the table: "locus.membro_instituicao_medica" using primary key columns */
  locus_membro_instituicao_medica_by_pk?: Maybe<Locus_Membro_Instituicao_Medica>;
  /** fetch data from the table: "locus.rede_social_membro" */
  locus_rede_social_membro: Array<Locus_Rede_Social_Membro>;
  /** fetch data from the table: "locus.subespecialidade" */
  locus_subespecialidade: Array<Locus_Subespecialidade>;
  /** fetch data from the table: "locus.subespecialidade" using primary key columns */
  locus_subespecialidade_by_pk?: Maybe<Locus_Subespecialidade>;
  /** Dados do usuário atual */
  membro?: Maybe<Membro>;
  /** Método que seleciona uma movimentação calculando detalhes de desconto e acréscimo */
  movimentacaoDetalhada?: Maybe<MovimentacaoExibicao>;
  /** fetch data from the table: "nexus.follow" */
  nexus_follow: Array<Nexus_Follow>;
  /** fetch data from the table: "nexus.follow" using primary key columns */
  nexus_follow_by_pk?: Maybe<Nexus_Follow>;
  /** An array relationship */
  notificacoesPacientesAtrasados: Array<NotificacoesPacientesAtrasados>;
  /** fetch data from the table: "tbNotificacoesPacientesAtrasados" using primary key columns */
  notificacoesPacientesAtrasados_by_pk?: Maybe<NotificacoesPacientesAtrasados>;
  /** fetch data from the table: "nuntius.contatos_por_dia" */
  nuntius_contatos_por_dia: Array<Nuntius_Contatos_Por_Dia>;
  /** fetch data from the table: "nuntius.lote_contatos_cobranca" */
  nuntius_lote_contatos_cobranca: Array<Nuntius_Lote_Contatos_Cobranca>;
  /** fetch data from the table: "nuntius.lote_contatos_cobranca" using primary key columns */
  nuntius_lote_contatos_cobranca_by_pk?: Maybe<Nuntius_Lote_Contatos_Cobranca>;
  /** fetch data from the table: "tbPacientes" */
  pacientes: Array<Pacientes>;
  /** fetch data from the table: "tbPacientes" using primary key columns */
  pacientes_by_pk?: Maybe<Pacientes>;
  /** fetch data from the table: "tbPacotesServicosPrecos" */
  pacoteServicoPreco: Array<PacoteServicoPreco>;
  /** fetch data from the table: "tbPacotesServicosPrecos" using primary key columns */
  pacoteServicoPreco_by_pk?: Maybe<PacoteServicoPreco>;
  /** fetch data from the table: "tbPacotesServicos" */
  pacotesServicos: Array<PacotesServicos>;
  /** fetch data from the table: "tbPacotesServicos" using primary key columns */
  pacotesServicos_by_pk?: Maybe<PacotesServicos>;
  /** Busca membros ativos na comunidade */
  perfisComunidade?: Maybe<PerfisComunidadeConnection>;
  /** Busca membros ativos e não bloqueados por nome */
  perfisPublicos?: Maybe<PerfisPublicosConnection>;
  /** An array relationship */
  planos: Array<Planos>;
  /** fetch data from the table: "tbPlanosMigracoes" */
  planosMigracoes: Array<PlanosMigracoes>;
  /** fetch data from the table: "tbPlanos" using primary key columns */
  planos_by_pk?: Maybe<Planos>;
  /** An array relationship */
  referrals: Array<Referrals>;
  /** fetch data from the table: "tbAgendamentosCheckins" */
  tbAgendamentosCheckins: Array<TbAgendamentosCheckins>;
  /** fetch aggregated fields from the table: "tbAgendamentosCheckins" */
  tbAgendamentosCheckins_aggregate: TbAgendamentosCheckins_Aggregate;
  /** fetch data from the table: "tbAgendamentosCheckins" using primary key columns */
  tbAgendamentosCheckins_by_pk?: Maybe<TbAgendamentosCheckins>;
  /** fetch data from the table: "tbAgendamentosVinculados" */
  tbAgendamentosVinculados: Array<TbAgendamentosVinculados>;
  /** fetch data from the table: "tbAgendamentosVinculados" using primary key columns */
  tbAgendamentosVinculados_by_pk?: Maybe<TbAgendamentosVinculados>;
  /** fetch data from the table: "tbClinicas" */
  tbClinicas: Array<TbClinicas>;
  /** fetch data from the table: "tbClinicas" using primary key columns */
  tbClinicas_by_pk?: Maybe<TbClinicas>;
  /** An array relationship */
  tbFechamentos: Array<TbFechamentos>;
  /** fetch data from the table: "tbFechamentos" using primary key columns */
  tbFechamentos_by_pk?: Maybe<TbFechamentos>;
  /** fetch data from the table: "tbFeriados" */
  tbFeriados: Array<TbFeriados>;
  /** fetch data from the table: "tbFeriados" using primary key columns */
  tbFeriados_by_pk?: Maybe<TbFeriados>;
  /** fetch data from the table: "tbMovimentacoes" */
  tbMovimentacoes: Array<TbMovimentacoes>;
  /** fetch data from the table: "tbMovimentacoes" using primary key columns */
  tbMovimentacoes_by_pk?: Maybe<TbMovimentacoes>;
  /** fetch data from the table: "tbPacotesServicosPrecosVariaveis" */
  tbPacotesServicosPrecosVariaveis: Array<TbPacotesServicosPrecosVariaveis>;
  /** fetch data from the table: "tbPacotesServicosPrecosVariaveis" using primary key columns */
  tbPacotesServicosPrecosVariaveis_by_pk?: Maybe<TbPacotesServicosPrecosVariaveis>;
  /** An array relationship */
  tbPeriodosGarantidos: Array<TbPeriodosGarantidos>;
  /** fetch data from the table: "tbPeriodosGarantidosRecorrentes" */
  tbPeriodosGarantidosRecorrentes: Array<TbPeriodosGarantidosRecorrentes>;
  /** fetch data from the table: "tbPeriodosGarantidosRecorrentesFrequencias" */
  tbPeriodosGarantidosRecorrentesFrequencias: Array<TbPeriodosGarantidosRecorrentesFrequencias>;
  /** fetch aggregated fields from the table: "tbPeriodosGarantidosRecorrentesFrequencias" */
  tbPeriodosGarantidosRecorrentesFrequencias_aggregate: TbPeriodosGarantidosRecorrentesFrequencias_Aggregate;
  /** fetch data from the table: "tbPeriodosGarantidosRecorrentesFrequencias" using primary key columns */
  tbPeriodosGarantidosRecorrentesFrequencias_by_pk?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias>;
  /** fetch aggregated fields from the table: "tbPeriodosGarantidosRecorrentes" */
  tbPeriodosGarantidosRecorrentes_aggregate: TbPeriodosGarantidosRecorrentes_Aggregate;
  /** fetch data from the table: "tbPeriodosGarantidosRecorrentes" using primary key columns */
  tbPeriodosGarantidosRecorrentes_by_pk?: Maybe<TbPeriodosGarantidosRecorrentes>;
  /** An aggregate relationship */
  tbPeriodosGarantidos_aggregate: TbPeriodosGarantidos_Aggregate;
  /** fetch data from the table: "tbPeriodosGarantidos" using primary key columns */
  tbPeriodosGarantidos_by_pk?: Maybe<TbPeriodosGarantidos>;
  /** fetch data from the table: "tbTipoPacotesServicosPrecoVariavel" */
  tbTipoPacotesServicosPrecoVariavel: Array<TbTipoPacotesServicosPrecoVariavel>;
  /** fetch data from the table: "tbTipoPacotesServicosPrecoVariavel" using primary key columns */
  tbTipoPacotesServicosPrecoVariavel_by_pk?: Maybe<TbTipoPacotesServicosPrecoVariavel>;
  /** An array relationship */
  tbUsuariosAgendasDiasSemanas: Array<TbUsuariosAgendasDiasSemanas>;
  /** fetch data from the table: "tbUsuariosIntegracoes" */
  tbUsuariosIntegracoes: Array<TbUsuariosIntegracoes>;
  /** fetch data from the table: "tbUsuariosIntegracoes" using primary key columns */
  tbUsuariosIntegracoes_by_pk?: Maybe<TbUsuariosIntegracoes>;
  /** fetch data from the table: "tbUsuariosTermosDeUso" */
  tbUsuariosTermosDeUso: Array<TbUsuariosTermosDeUso>;
  /** fetch data from the table: "tbUsuariosTermosDeUso" using primary key columns */
  tbUsuariosTermosDeUso_by_pk?: Maybe<TbUsuariosTermosDeUso>;
  /** fetch data from the table: "terms_of_use" */
  terms_of_use: Array<Terms_Of_Use>;
  /** fetch data from the table: "terms_of_use" using primary key columns */
  terms_of_use_by_pk?: Maybe<Terms_Of_Use>;
  /** fetch data from the table: "tbTiposAgendasRepeticoes" */
  tiposAgendasRepeticoes: Array<TiposAgendasRepeticoes>;
  /** fetch data from the table: "tbTiposAgendasRepeticoes" using primary key columns */
  tiposAgendasRepeticoes_by_pk?: Maybe<TiposAgendasRepeticoes>;
  /** fetch data from the table: "tbTiposConvenios" */
  tiposConvenios: Array<TiposConvenios>;
  /** fetch data from the table: "tbTiposConvenios" using primary key columns */
  tiposConvenios_by_pk?: Maybe<TiposConvenios>;
  /** fetch data from the table: "tbTiposFormasRecebimentos" */
  tiposFormasRecebimentos: Array<TiposFormasRecebimentos>;
  /** fetch data from the table: "tbTiposFormasRecebimentos" using primary key columns */
  tiposFormasRecebimentos_by_pk?: Maybe<TiposFormasRecebimentos>;
  /** fetch data from the table: "tbTiposMovimentacoes" */
  tiposMovimentacoes: Array<TiposMovimentacoes>;
  /** fetch data from the table: "tbTiposMovimentacoes" using primary key columns */
  tiposMovimentacoes_by_pk?: Maybe<TiposMovimentacoes>;
  /** fetch data from the table: "tbTiposPlanos" */
  tiposPlanos: Array<TiposPlanos>;
  /** fetch data from the table: "tbTiposPlanos" using primary key columns */
  tiposPlanos_by_pk?: Maybe<TiposPlanos>;
  /** fetch data from the table: "tbTiposSalas" */
  tiposSalas: Array<TiposSalas>;
  /** fetch data from the table: "tbTiposSalas" using primary key columns */
  tiposSalas_by_pk?: Maybe<TiposSalas>;
  /** fetch data from the table: "tbUnidades" */
  unidades: Array<Unidades>;
  /** fetch data from the table: "tbUnidadesHorariosFuncionamento" */
  unidadesHorariosFuncionamentos: Array<UnidadesHorariosFuncionamentos>;
  /** fetch data from the table: "tbUnidadesHorariosFuncionamento" using primary key columns */
  unidadesHorariosFuncionamentos_by_pk?: Maybe<UnidadesHorariosFuncionamentos>;
  /** fetch data from the table: "tbUnidadesPoliticasDeHorarios" */
  unidadesPoliticasDeHorarios: Array<UnidadesPoliticasDeHorarios>;
  /** fetch data from the table: "tbUnidadesPoliticasDeHorarios" using primary key columns */
  unidadesPoliticasDeHorarios_by_pk?: Maybe<UnidadesPoliticasDeHorarios>;
  /** fetch data from the table: "tbUnidadesSalas" */
  unidadesSalas: Array<UnidadesSalas>;
  /** fetch data from the table: "tbUnidadesSalasPeriodosBloqueados" */
  unidadesSalasPeriodosBloqueados: Array<UnidadesSalasPeriodosBloqueados>;
  /** fetch aggregated fields from the table: "tbUnidadesSalasPeriodosBloqueados" */
  unidadesSalasPeriodosBloqueados_aggregate: UnidadesSalasPeriodosBloqueados_Aggregate;
  /** fetch data from the table: "tbUnidadesSalasPeriodosBloqueados" using primary key columns */
  unidadesSalasPeriodosBloqueados_by_pk?: Maybe<UnidadesSalasPeriodosBloqueados>;
  /** fetch aggregated fields from the table: "tbUnidadesSalas" */
  unidadesSalas_aggregate: UnidadesSalas_Aggregate;
  /** fetch data from the table: "tbUnidadesSalas" using primary key columns */
  unidadesSalas_by_pk?: Maybe<UnidadesSalas>;
  /** fetch data from the table: "tbUnidades" using primary key columns */
  unidades_by_pk?: Maybe<Unidades>;
  /** fetch data from the table: "units" */
  units: Array<Units>;
  /** fetch data from the table: "units" using primary key columns */
  units_by_pk?: Maybe<Units>;
  /** fetch data from the table: "user_addresses" */
  user_addresses: Array<User_Addresses>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "users_professional_cards" */
  users_professional_cards: Array<Users_Professional_Cards>;
  /** fetch aggregated fields from the table: "users_professional_cards" */
  users_professional_cards_aggregate: Users_Professional_Cards_Aggregate;
  /** fetch data from the table: "users_professional_cards" using primary key columns */
  users_professional_cards_by_pk?: Maybe<Users_Professional_Cards>;
  /** fetch data from the table: "users_provider" */
  users_provider: Array<Users_Provider>;
  /** fetch data from the table: "users_terms_of_use_agreed" */
  users_terms_of_use_agreed: Array<Users_Terms_Of_Use_Agreed>;
  /** fetch data from the table: "users_terms_of_use_agreed" using primary key columns */
  users_terms_of_use_agreed_by_pk?: Maybe<Users_Terms_Of_Use_Agreed>;
  /** fetch data from the table: "tbUsuarios" */
  usuarios: Array<Usuarios>;
  /** An array relationship */
  usuariosAgendas: Array<UsuariosAgendas>;
  /** An array relationship */
  usuariosAgendasCompromissos: Array<UsuariosAgendasCompromissos>;
  /** An array relationship */
  usuariosAgendasUnidades: Array<UsuariosAgendasUnidades>;
  /** fetch data from the table: "tbUsuariosAgendasUnidades" using primary key columns */
  usuariosAgendasUnidades_by_pk?: Maybe<UsuariosAgendasUnidades>;
  /** fetch data from the table: "tbUsuariosAgendas" using primary key columns */
  usuariosAgendas_by_pk?: Maybe<UsuariosAgendas>;
  /** fetch data from the table: "tbUsuariosCartoes" */
  usuariosCartoes: Array<UsuariosCartoes>;
  /** fetch data from the table: "tbUsuariosCartoes" using primary key columns */
  usuariosCartoes_by_pk?: Maybe<UsuariosCartoes>;
  /** An array relationship */
  usuariosCompromissos: Array<UsuariosCompromissos>;
  /** An array relationship */
  usuariosCompromissosCanaisAgendamentos: Array<UsuariosCompromissosCanaisAgendamentos>;
  /** fetch data from the table: "tbUsuariosCompromissosCanaisAgendamentos" using primary key columns */
  usuariosCompromissosCanaisAgendamentos_by_pk?: Maybe<UsuariosCompromissosCanaisAgendamentos>;
  /** fetch data from the table: "tbUsuariosCompromissosCategorias" */
  usuariosCompromissosCategorias: Array<UsuariosCompromissosCategorias>;
  /** fetch aggregated fields from the table: "tbUsuariosCompromissosCategorias" */
  usuariosCompromissosCategorias_aggregate: UsuariosCompromissosCategorias_Aggregate;
  /** fetch data from the table: "tbUsuariosCompromissosCategorias" using primary key columns */
  usuariosCompromissosCategorias_by_pk?: Maybe<UsuariosCompromissosCategorias>;
  /** An array relationship */
  usuariosCompromissosFormasRecebimentos: Array<UsuariosCompromissosFormasRecebimentos>;
  /** fetch data from the table: "tbUsuariosCompromissosFormasRecebimentos" using primary key columns */
  usuariosCompromissosFormasRecebimentos_by_pk?: Maybe<UsuariosCompromissosFormasRecebimentos>;
  /** fetch data from the table: "tbUsuariosCompromissosModalidades" */
  usuariosCompromissosModalidades: Array<UsuariosCompromissosModalidades>;
  /** fetch aggregated fields from the table: "tbUsuariosCompromissosModalidades" */
  usuariosCompromissosModalidades_aggregate: UsuariosCompromissosModalidades_Aggregate;
  /** fetch data from the table: "tbUsuariosCompromissosModalidades" using primary key columns */
  usuariosCompromissosModalidades_by_pk?: Maybe<UsuariosCompromissosModalidades>;
  /** An array relationship */
  usuariosCompromissosTiposSalas: Array<UsuariosCompromissosTiposSalas>;
  /** An aggregate relationship */
  usuariosCompromissosTiposSalas_aggregate: UsuariosCompromissosTiposSalas_Aggregate;
  /** fetch data from the table: "tbUsuariosCompromissosTiposSalas" using primary key columns */
  usuariosCompromissosTiposSalas_by_pk?: Maybe<UsuariosCompromissosTiposSalas>;
  /** An aggregate relationship */
  usuariosCompromissos_aggregate: UsuariosCompromissos_Aggregate;
  /** fetch data from the table: "tbUsuariosCompromissos" using primary key columns */
  usuariosCompromissos_by_pk?: Maybe<UsuariosCompromissos>;
  /** fetch data from the table: "tbUsuariosEspecialidades" */
  usuariosEspecialidades: Array<UsuariosEspecialidades>;
  /** fetch data from the table: "tbUsuariosEspecialidades" using primary key columns */
  usuariosEspecialidades_by_pk?: Maybe<UsuariosEspecialidades>;
  /** fetch data from the table: "tbUsuariosFormasRecebimentos" */
  usuariosFormasRecebimentos: Array<UsuariosFormasRecebimentos>;
  /** fetch aggregated fields from the table: "tbUsuariosFormasRecebimentos" */
  usuariosFormasRecebimentos_aggregate: UsuariosFormasRecebimentos_Aggregate;
  /** fetch data from the table: "tbUsuariosFormasRecebimentos" using primary key columns */
  usuariosFormasRecebimentos_by_pk?: Maybe<UsuariosFormasRecebimentos>;
  /** fetch data from the table: "tbUsuariosLinksRastreamentos" */
  usuariosLinksRastreamentos: Array<UsuariosLinksRastreamentos>;
  /** fetch data from the table: "tbUsuariosLinksRastreamentos" using primary key columns */
  usuariosLinksRastreamentos_by_pk?: Maybe<UsuariosLinksRastreamentos>;
  /** An array relationship */
  usuariosMovimentacoesRecorrentes: Array<UsuariosMovimentacoesRecorrentes>;
  /** fetch data from the table: "tbUsuariosMovimentacoesRecorrentes" using primary key columns */
  usuariosMovimentacoesRecorrentes_by_pk?: Maybe<UsuariosMovimentacoesRecorrentes>;
  /** An array relationship */
  usuariosPacotesServicos: Array<UsuariosPacotesServicos>;
  /** fetch data from the table: "tbUsuariosPacotesServicos" using primary key columns */
  usuariosPacotesServicos_by_pk?: Maybe<UsuariosPacotesServicos>;
  /** An array relationship */
  usuariosProfissionais: Array<UsuariosProfissionais>;
  /** fetch data from the table: "tbUsuariosProfissionaisOrientacoesSecretarias" */
  usuariosProfissionaisOrientacoesSecretarias: Array<UsuariosProfissionaisOrientacoesSecretarias>;
  /** fetch data from the table: "tbUsuariosProfissionaisOrientacoesSecretarias" using primary key columns */
  usuariosProfissionaisOrientacoesSecretarias_by_pk?: Maybe<UsuariosProfissionaisOrientacoesSecretarias>;
  /** fetch data from the table: "tbUsuariosProfissionaisPlanos" */
  usuariosProfissionaisPlanos: Array<UsuariosProfissionaisPlanos>;
  /** fetch data from the table: "tbUsuariosProfissionaisPlanos" using primary key columns */
  usuariosProfissionaisPlanos_by_pk?: Maybe<UsuariosProfissionaisPlanos>;
  /** fetch data from the table: "tbUsuariosProfissionais" using primary key columns */
  usuariosProfissionais_by_pk?: Maybe<UsuariosProfissionais>;
  /** fetch data from the table: "tbUsuariosTelefones" */
  usuariosTelefones: Array<UsuariosTelefones>;
  /** fetch data from the table: "tbUsuariosTelefones" using primary key columns */
  usuariosTelefones_by_pk?: Maybe<UsuariosTelefones>;
  /** fetch data from the table: "tbUsuarios" using primary key columns */
  usuarios_by_pk?: Maybe<Usuarios>;
};


export type Query_RootAgendamentosAlocacoesAtivasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosAlocacoesAtivas_Order_By>>;
  where?: InputMaybe<AgendamentosAlocacoesAtivas_Bool_Exp>;
};


export type Query_RootAgendamentosAlocacoesAtivas_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
};


export type Query_RootAnimusGetNewVirtualSalesVisitAvailabilityArgs = {
  arg1: VirtualNewSalesVisitAvailabilityInput;
};


export type Query_RootAnimusGetSalesVisitAvailabilityArgs = {
  arg1: GetSalesVisitAvailabilityInput;
};


export type Query_RootAnimusGetVirtualSalesVisitAvailabilityArgs = {
  arg1: VirtualSalesVisitAvailabilityInput;
};


export type Query_RootAnimusOnboardingTimeAvailabilityArgs = {
  arg1: AnimusOnboardingTimeAvailabilityInput;
};


export type Query_RootExpensumGetAutomaticAnticipationSettingsByRecipientArgs = {
  arg1: ExpensumGetAutomaticAnticipationSettingsByRecipientInput;
};


export type Query_RootExpensumGetBankAccountByRecipientArgs = {
  arg1: ExpensumGetBankAccountByRecipientInput;
};


export type Query_RootExpensumGetPayablesArgs = {
  arg1: ExpensumGetPayablesInput;
};


export type Query_RootExpensumGetPayablesChartsInfoArgs = {
  arg1: ExpensumGetPayablesChartsInfoInput;
};


export type Query_RootExpensumGetPayablesV2Args = {
  arg1: ExpensumGetPayablesV2Input;
};


export type Query_RootExpensumGetPaymentsArgs = {
  arg1: ExpensumGetPaymentsInput;
};


export type Query_RootExpensumGetPaymentsChartsInfoArgs = {
  arg1: ExpensumGetPaymentsChartsInfoInput;
};


export type Query_RootExpensumGetRecipientArgs = {
  arg1: ExpensumGetRecipientInput;
};


export type Query_RootExpensumGetRefundReceiptArgs = {
  arg1: ExpensumGetRefundReceiptInput;
};


export type Query_RootExpensumPaymentDetailsArgs = {
  arg1: ExpensumPaymentDetailsInput;
};


export type Query_RootGetAvailableTimesArgs = {
  arg1: AvailableTimesInput;
};


export type Query_RootLivanceApiBuscaHorarioLivreArgs = {
  arg1: LivanceApiBuscaHorarioLivreInput;
};


export type Query_RootLivanceApiBuscaHorarioLivreReagendamentoArgs = {
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
  horarios?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootLivanceApiBuscaHorariosDisponiveisDiaDaSemanaArgs = {
  arg1: LivanceApiBuscaHorariosDisponiveisDiaDaSemanaInput;
};


export type Query_RootLivanceApiBuscaHorariosParaEstenderArgs = {
  arg1: LivanceApiBuscaHorariosParaEstenderInput;
};


export type Query_RootLivanceApiBuscaSelecionaFaixasLivresAgendaArgs = {
  arg1: LivanceApiBuscaSelecionaFaixasLivresAgendaInput;
};


export type Query_RootLivanceApiBuscaTipoSalaSugestoesArgs = {
  codUsuario: Scalars['Int']['input'];
};


export type Query_RootLivanceApiBuscaUsuarioCompromissoSugestaoDuracaoArgs = {
  codUsuarioCompromisso: Scalars['Int']['input'];
};


export type Query_RootLivanceApiFeriadosPorPeriodoArgs = {
  arg1: LivanceApiFeriadosPorPeriodoInput;
};


export type Query_RootLivanceApiSelecionaFotoDePerfilArgs = {
  arg1: LivanceApiSelecionaFotoDePerfilInput;
};


export type Query_RootLivanceApiSelecionaHorariosProximosArgs = {
  arg1: LivanceApiSelecionaHorariosProximosInput;
};


export type Query_RootLivanceApiSimulaCobrancaDeCancelamentoArgs = {
  arg1: LivanceApiSimulaCobrancaDeCancelamentoInput;
};


export type Query_RootLivanceApiSimulaCobrancaPeriodoGarantidoArgs = {
  params: LivanceApiSimulaCobrancaPeriodoGarantidoInput;
};


export type Query_RootLivanceApiUsuarioAgendaAtivosPorUsuarioArgs = {
  arg1: LivanceApiUsuarioAgendaAtivosPorUsuarioInput;
};


export type Query_RootNuntiusGetAssistContactBatchDetailsArgs = {
  arg1: NuntiusGetAssistContactBatchDetailsInput;
};


export type Query_RootNuntiusGetCustomerContactManyPeriodSummaryArgs = {
  arg1: NuntiusGetCustomerContactManyPeriodSummaryInput;
};


export type Query_RootNuntiusGetCustomerContactPeriodSummaryArgs = {
  arg1: NuntiusGetCustomerContactPeriodSummaryInput;
};


export type Query_RootNuntiusGetFutureAppointmentByPhoneNumberArgs = {
  arg1: NuntiusGetFutureAppointmentByPhoneNumberInput;
};


export type Query_RootPagarmePayablesListArgs = {
  arg1: PagarmePayablesListInput;
};


export type Query_RootPrecificacoesTiposSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PrecificacoesTiposSalas_Order_By>>;
  where?: InputMaybe<PrecificacoesTiposSalas_Bool_Exp>;
};


export type Query_RootPrecificacoesTiposSalas_By_PkArgs = {
  codPrecificacao: Scalars['Int']['input'];
};


export type Query_RootUnidadesPrecosFlexiveisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveis_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveis_Bool_Exp>;
};


export type Query_RootUnidadesPrecosFlexiveisParceirosIntegracoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveisParceirosIntegracoes_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp>;
};


export type Query_RootUnidadesPrecosFlexiveisParceirosIntegracoes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveisParceirosIntegracoes_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp>;
};


export type Query_RootUnidadesPrecosFlexiveisParceirosIntegracoes_By_PkArgs = {
  codParceiroIntegracao: Scalars['Int']['input'];
  codUnidadePrecoFlexivel: Scalars['Int']['input'];
};


export type Query_RootUnidadesPrecosFlexiveis_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveis_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveis_Bool_Exp>;
};


export type Query_RootUnidadesPrecosFlexiveis_By_PkArgs = {
  codUnidadePrecoFlexivel: Scalars['Int']['input'];
};


export type Query_RootUnidadesSalasMotivosBloqueiosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalasMotivosBloqueios_Order_By>>;
  where?: InputMaybe<UnidadesSalasMotivosBloqueios_Bool_Exp>;
};


export type Query_RootUnidadesSalasMotivosBloqueios_By_PkArgs = {
  codUnidadeSalaMotivoBloqueio: Scalars['Int']['input'];
};


export type Query_RootUsuariosArquivosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosArquivos_Order_By>>;
  where?: InputMaybe<UsuariosArquivos_Bool_Exp>;
};


export type Query_RootUsuariosArquivos_By_PkArgs = {
  codUsuarioArquivo: Scalars['Int']['input'];
};


export type Query_RootUsuariosCompromissosStatusSugestoesDuracoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosStatusSugestoesDuracoes_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosStatusSugestoesDuracoes_Bool_Exp>;
};


export type Query_RootUsuariosCompromissosStatusSugestoesDuracoes_By_PkArgs = {
  codUsuarioCompromisso: Scalars['Int']['input'];
};


export type Query_RootValidateCepArgs = {
  arg1: ValidateCepInput;
};


export type Query_RootValidateCnpjArgs = {
  arg1: ValidateCnpjInput;
};


export type Query_RootAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


export type Query_RootAgendamentosAlocacoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosAlocacoes_Order_By>>;
  where?: InputMaybe<AgendamentosAlocacoes_Bool_Exp>;
};


export type Query_RootAgendamentosAlocacoes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosAlocacoes_Order_By>>;
  where?: InputMaybe<AgendamentosAlocacoes_Bool_Exp>;
};


export type Query_RootAgendamentosAlocacoes_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
  codUnidadeSala: Scalars['Int']['input'];
};


export type Query_RootAgendamentosPreAlocacaoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosPreAlocacao_Order_By>>;
  where?: InputMaybe<AgendamentosPreAlocacao_Bool_Exp>;
};


export type Query_RootAgendamentosPreAlocacao_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosPreAlocacao_Order_By>>;
  where?: InputMaybe<AgendamentosPreAlocacao_Bool_Exp>;
};


export type Query_RootAgendamentosPreAlocacao_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
};


export type Query_RootAgendamentosTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosTags_Order_By>>;
  where?: InputMaybe<AgendamentosTags_Bool_Exp>;
};


export type Query_RootAgendamentosTags_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
  codAgendamentoTipoTag: Scalars['Int']['input'];
};


export type Query_RootAgendamentosTiposTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosTiposTags_Order_By>>;
  where?: InputMaybe<AgendamentosTiposTags_Bool_Exp>;
};


export type Query_RootAgendamentosTiposTags_By_PkArgs = {
  codAgendamentoTipoTag: Scalars['Int']['input'];
};


export type Query_RootAgendamentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


export type Query_RootAgendamentos_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
};


export type Query_RootAlocacaoDetalhadaArgs = {
  codAgendamento: Scalars['Int']['input'];
};


export type Query_RootAnalyticsMembroDadosDeUsuarioLinkRastreamentoArgs = {
  arg1: AnalyticsMembroDadosDeUsuarioLinkRastreamentoInput;
};


export type Query_RootAnalyticsMembroRelatorioIndependenteArgs = {
  arg1: AnalyticsMembroRelatorioIndependenteInput;
};


export type Query_RootAnalyticsMembroTotalDeAgendamentosResgatadosPorFluxoArgs = {
  arg1: AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxoInput;
};


export type Query_RootBuscaHorariosEmUnidadesAlternativasArgs = {
  codUnidadeOrigem: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
  comHorariosMenores?: Scalars['Boolean']['input'];
  data: Scalars['Date']['input'];
  horarioInicio: Scalars['TimeSpan']['input'];
};


export type Query_RootCanaisAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CanaisAgendamentos_Order_By>>;
  where?: InputMaybe<CanaisAgendamentos_Bool_Exp>;
};


export type Query_RootCanaisAgendamentos_By_PkArgs = {
  codCanalAgendamento: Scalars['Int']['input'];
};


export type Query_RootCobrancasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cobrancas_Order_By>>;
  where?: InputMaybe<Cobrancas_Bool_Exp>;
};


export type Query_RootCobrancasAbertasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootCobrancasFechadasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootCsatCategoriasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CsatCategorias_Order_By>>;
  where?: InputMaybe<CsatCategorias_Bool_Exp>;
};


export type Query_RootCsatCategoriasNotasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CsatCategoriasNotas_Order_By>>;
  where?: InputMaybe<CsatCategoriasNotas_Bool_Exp>;
};


export type Query_RootCsatCategoriasNotas_By_PkArgs = {
  codCsatCategoria: Scalars['Int']['input'];
  nota: Scalars['Int']['input'];
};


export type Query_RootCsatCategorias_By_PkArgs = {
  codCsatCategoria: Scalars['Int']['input'];
};


export type Query_RootEspecialidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Especialidades_Order_By>>;
  where?: InputMaybe<Especialidades_Bool_Exp>;
};


export type Query_RootEspecialidades_By_PkArgs = {
  codEspecialidade: Scalars['Int']['input'];
};


export type Query_RootExpensum_Appointment_PaidArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Appointment_Paid_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Appointment_Paid_Order_By>>;
  where?: InputMaybe<Expensum_Appointment_Paid_Bool_Exp>;
};


export type Query_RootExpensum_Appointment_Paid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Appointment_Paid_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Appointment_Paid_Order_By>>;
  where?: InputMaybe<Expensum_Appointment_Paid_Bool_Exp>;
};


export type Query_RootExpensum_Event_Automatic_Anticipation_Settings_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Event_Automatic_Anticipation_Settings_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Event_Automatic_Anticipation_Settings_Update_Order_By>>;
  where?: InputMaybe<Expensum_Event_Automatic_Anticipation_Settings_Update_Bool_Exp>;
};


export type Query_RootExpensum_Event_Automatic_Anticipation_Settings_Update_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootExpensum_Event_Bank_Account_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Event_Bank_Account_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Event_Bank_Account_Update_Order_By>>;
  where?: InputMaybe<Expensum_Event_Bank_Account_Update_Bool_Exp>;
};


export type Query_RootExpensum_Event_Bank_Account_Update_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootExpensum_Event_Totem_Payment_SentArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Order_By>>;
  where?: InputMaybe<Expensum_Event_Totem_Payment_Sent_Bool_Exp>;
};


export type Query_RootExpensum_Event_Totem_Payment_Sent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Order_By>>;
  where?: InputMaybe<Expensum_Event_Totem_Payment_Sent_Bool_Exp>;
};


export type Query_RootExpensum_Event_Totem_Payment_Sent_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootExpensum_Online_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
};


export type Query_RootExpensum_Online_Payment_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Activity_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Activity_Bool_Exp>;
};


export type Query_RootExpensum_Online_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
};


export type Query_RootExpensum_Online_Payment_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootExpensum_Payment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Payment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Payment_Type_Order_By>>;
  where?: InputMaybe<Expensum_Payment_Type_Bool_Exp>;
};


export type Query_RootExpensum_Payment_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootExpensum_Recipient_Terms_Of_Use_AgreedArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Recipient_Terms_Of_Use_Agreed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Recipient_Terms_Of_Use_Agreed_Order_By>>;
  where?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Bool_Exp>;
};


export type Query_RootExpensum_Recipient_Terms_Of_Use_Agreed_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootExpensum_Terms_Of_UseArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Terms_Of_Use_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Terms_Of_Use_Order_By>>;
  where?: InputMaybe<Expensum_Terms_Of_Use_Bool_Exp>;
};


export type Query_RootExpensum_Terms_Of_Use_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFinalidadesAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FinalidadesAgendamentos_Order_By>>;
  where?: InputMaybe<FinalidadesAgendamentos_Bool_Exp>;
};


export type Query_RootFinalidadesAgendamentos_By_PkArgs = {
  codFinalidadeAgendamento: Scalars['Int']['input'];
};


export type Query_RootFuncionalidadesDesativadasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FuncionalidadesDesativadas_Order_By>>;
  where?: InputMaybe<FuncionalidadesDesativadas_Bool_Exp>;
};


export type Query_RootFuncionalidadesDesativadas_By_PkArgs = {
  codFuncionalidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
};


export type Query_RootLembretesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lembretes_Order_By>>;
  where?: InputMaybe<Lembretes_Bool_Exp>;
};


export type Query_RootLembretes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lembretes_Order_By>>;
  where?: InputMaybe<Lembretes_Bool_Exp>;
};


export type Query_RootLembretes_By_PkArgs = {
  codLembrete: Scalars['Int']['input'];
};


export type Query_RootLinksDestinosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LinksDestinos_Order_By>>;
  where?: InputMaybe<LinksDestinos_Bool_Exp>;
};


export type Query_RootLinksDestinos_By_PkArgs = {
  codLinkDestino: Scalars['Int']['input'];
};


export type Query_RootLocus_Conselho_ProfissionalArgs = {
  distinct_on?: InputMaybe<Array<Locus_Conselho_Profissional_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Conselho_Profissional_Order_By>>;
  where?: InputMaybe<Locus_Conselho_Profissional_Bool_Exp>;
};


export type Query_RootLocus_Conselho_Profissional_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLocus_Conselho_Profissional_EspecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Conselho_Profissional_Especialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Conselho_Profissional_Especialidade_Order_By>>;
  where?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Bool_Exp>;
};


export type Query_RootLocus_Conselho_Profissional_Especialidade_By_PkArgs = {
  idConselhoProfissional: Scalars['Int']['input'];
  idEspecialidade: Scalars['Int']['input'];
};


export type Query_RootLocus_Curso_FormacaoArgs = {
  distinct_on?: InputMaybe<Array<Locus_Curso_Formacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Curso_Formacao_Order_By>>;
  where?: InputMaybe<Locus_Curso_Formacao_Bool_Exp>;
};


export type Query_RootLocus_Curso_Formacao_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLocus_EspecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Especialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Especialidade_Order_By>>;
  where?: InputMaybe<Locus_Especialidade_Bool_Exp>;
};


export type Query_RootLocus_Especialidade_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLocus_Especialidade_SubespecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Especialidade_Subespecialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Especialidade_Subespecialidade_Order_By>>;
  where?: InputMaybe<Locus_Especialidade_Subespecialidade_Bool_Exp>;
};


export type Query_RootLocus_Especialidade_Subespecialidade_By_PkArgs = {
  idEspecialidade: Scalars['Int']['input'];
  idSubespecialidade: Scalars['Int']['input'];
};


export type Query_RootLocus_Experiencia_MembroArgs = {
  distinct_on?: InputMaybe<Array<Locus_Experiencia_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Experiencia_Membro_Order_By>>;
  where?: InputMaybe<Locus_Experiencia_Membro_Bool_Exp>;
};


export type Query_RootLocus_Experiencia_Membro_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLocus_Faq_MembroArgs = {
  distinct_on?: InputMaybe<Array<Locus_Faq_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Faq_Membro_Order_By>>;
  where?: InputMaybe<Locus_Faq_Membro_Bool_Exp>;
};


export type Query_RootLocus_Faq_Membro_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLocus_Foco_Tratamento_MembroArgs = {
  distinct_on?: InputMaybe<Array<Locus_Foco_Tratamento_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Foco_Tratamento_Membro_Order_By>>;
  where?: InputMaybe<Locus_Foco_Tratamento_Membro_Bool_Exp>;
};


export type Query_RootLocus_Foco_Tratamento_Membro_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLocus_Instituicao_EnsinoArgs = {
  distinct_on?: InputMaybe<Array<Locus_Instituicao_Ensino_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Instituicao_Ensino_Order_By>>;
  where?: InputMaybe<Locus_Instituicao_Ensino_Bool_Exp>;
};


export type Query_RootLocus_Instituicao_Ensino_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLocus_Instituicao_MedicaArgs = {
  distinct_on?: InputMaybe<Array<Locus_Instituicao_Medica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Instituicao_Medica_Order_By>>;
  where?: InputMaybe<Locus_Instituicao_Medica_Bool_Exp>;
};


export type Query_RootLocus_Instituicao_Medica_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLocus_MembroArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Order_By>>;
  where?: InputMaybe<Locus_Membro_Bool_Exp>;
};


export type Query_RootLocus_Membro_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootLocus_Membro_EspecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Especialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Especialidade_Order_By>>;
  where?: InputMaybe<Locus_Membro_Especialidade_Bool_Exp>;
};


export type Query_RootLocus_Membro_Especialidade_By_PkArgs = {
  idEspecialidade: Scalars['Int']['input'];
  idMembro: Scalars['Int']['input'];
};


export type Query_RootLocus_Membro_Especialidade_SubespecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Especialidade_Subespecialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Especialidade_Subespecialidade_Order_By>>;
  where?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Bool_Exp>;
};


export type Query_RootLocus_Membro_Especialidade_Subespecialidade_By_PkArgs = {
  idMembro: Scalars['Int']['input'];
  idSubespecialidade: Scalars['Int']['input'];
};


export type Query_RootLocus_Membro_FormacaoArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Formacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Formacao_Order_By>>;
  where?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
};


export type Query_RootLocus_Membro_Formacao_By_PkArgs = {
  idCurso: Scalars['Int']['input'];
  idInstituicaoEnsino: Scalars['Int']['input'];
  idMembro: Scalars['Int']['input'];
};


export type Query_RootLocus_Membro_Instituicao_MedicaArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Order_By>>;
  where?: InputMaybe<Locus_Membro_Instituicao_Medica_Bool_Exp>;
};


export type Query_RootLocus_Membro_Instituicao_Medica_By_PkArgs = {
  idInstituicaoMedica: Scalars['Int']['input'];
  idMembro: Scalars['Int']['input'];
};


export type Query_RootLocus_Rede_Social_MembroArgs = {
  distinct_on?: InputMaybe<Array<Locus_Rede_Social_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Rede_Social_Membro_Order_By>>;
  where?: InputMaybe<Locus_Rede_Social_Membro_Bool_Exp>;
};


export type Query_RootLocus_SubespecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Subespecialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Subespecialidade_Order_By>>;
  where?: InputMaybe<Locus_Subespecialidade_Bool_Exp>;
};


export type Query_RootLocus_Subespecialidade_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootMovimentacaoDetalhadaArgs = {
  codMovimentacao: Scalars['Int']['input'];
};


export type Query_RootNexus_FollowArgs = {
  distinct_on?: InputMaybe<Array<Nexus_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nexus_Follow_Order_By>>;
  where?: InputMaybe<Nexus_Follow_Bool_Exp>;
};


export type Query_RootNexus_Follow_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootNotificacoesPacientesAtrasadosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificacoesPacientesAtrasados_Order_By>>;
  where?: InputMaybe<NotificacoesPacientesAtrasados_Bool_Exp>;
};


export type Query_RootNotificacoesPacientesAtrasados_By_PkArgs = {
  codNotificacaoPacienteAtrasado: Scalars['Int']['input'];
};


export type Query_RootNuntius_Contatos_Por_DiaArgs = {
  distinct_on?: InputMaybe<Array<Nuntius_Contatos_Por_Dia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nuntius_Contatos_Por_Dia_Order_By>>;
  where?: InputMaybe<Nuntius_Contatos_Por_Dia_Bool_Exp>;
};


export type Query_RootNuntius_Lote_Contatos_CobrancaArgs = {
  distinct_on?: InputMaybe<Array<Nuntius_Lote_Contatos_Cobranca_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nuntius_Lote_Contatos_Cobranca_Order_By>>;
  where?: InputMaybe<Nuntius_Lote_Contatos_Cobranca_Bool_Exp>;
};


export type Query_RootNuntius_Lote_Contatos_Cobranca_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPacientesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pacientes_Order_By>>;
  where?: InputMaybe<Pacientes_Bool_Exp>;
};


export type Query_RootPacientes_By_PkArgs = {
  codPaciente: Scalars['Int']['input'];
};


export type Query_RootPacoteServicoPrecoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PacoteServicoPreco_Order_By>>;
  where?: InputMaybe<PacoteServicoPreco_Bool_Exp>;
};


export type Query_RootPacoteServicoPreco_By_PkArgs = {
  codPacoteServicosPreco: Scalars['Int']['input'];
};


export type Query_RootPacotesServicosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PacotesServicos_Order_By>>;
  where?: InputMaybe<PacotesServicos_Bool_Exp>;
};


export type Query_RootPacotesServicos_By_PkArgs = {
  codPacoteServicos: Scalars['Int']['input'];
};


export type Query_RootPerfisComunidadeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  codEspecialidades?: InputMaybe<Array<Scalars['Int']['input']>>;
  codUnidades?: InputMaybe<Array<Scalars['Int']['input']>>;
  codUsuarios?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  stringBusca?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootPerfisPublicosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nomeMembro?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootPlanosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planos_Order_By>>;
  where?: InputMaybe<Planos_Bool_Exp>;
};


export type Query_RootPlanosMigracoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PlanosMigracoes_Order_By>>;
  where?: InputMaybe<PlanosMigracoes_Bool_Exp>;
};


export type Query_RootPlanos_By_PkArgs = {
  codPlano: Scalars['Int']['input'];
};


export type Query_RootReferralsArgs = {
  distinct_on?: InputMaybe<Array<Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Referrals_Order_By>>;
  where?: InputMaybe<Referrals_Bool_Exp>;
};


export type Query_RootTbAgendamentosCheckinsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbAgendamentosCheckins_Order_By>>;
  where?: InputMaybe<TbAgendamentosCheckins_Bool_Exp>;
};


export type Query_RootTbAgendamentosCheckins_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbAgendamentosCheckins_Order_By>>;
  where?: InputMaybe<TbAgendamentosCheckins_Bool_Exp>;
};


export type Query_RootTbAgendamentosCheckins_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
};


export type Query_RootTbAgendamentosVinculadosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbAgendamentosVinculados_Order_By>>;
  where?: InputMaybe<TbAgendamentosVinculados_Bool_Exp>;
};


export type Query_RootTbAgendamentosVinculados_By_PkArgs = {
  codAgendamentoPrincipal: Scalars['Int']['input'];
  codAgendamentoVinculado: Scalars['Int']['input'];
};


export type Query_RootTbClinicasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbClinicas_Order_By>>;
  where?: InputMaybe<TbClinicas_Bool_Exp>;
};


export type Query_RootTbClinicas_By_PkArgs = {
  codClinica: Scalars['Int']['input'];
};


export type Query_RootTbFechamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbFechamentos_Order_By>>;
  where?: InputMaybe<TbFechamentos_Bool_Exp>;
};


export type Query_RootTbFechamentos_By_PkArgs = {
  codFechamento: Scalars['Int']['input'];
};


export type Query_RootTbFeriadosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbFeriados_Order_By>>;
  where?: InputMaybe<TbFeriados_Bool_Exp>;
};


export type Query_RootTbFeriados_By_PkArgs = {
  codFeriado: Scalars['Int']['input'];
};


export type Query_RootTbMovimentacoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbMovimentacoes_Order_By>>;
  where?: InputMaybe<TbMovimentacoes_Bool_Exp>;
};


export type Query_RootTbMovimentacoes_By_PkArgs = {
  codMovimentacao: Scalars['Int']['input'];
};


export type Query_RootTbPacotesServicosPrecosVariaveisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPacotesServicosPrecosVariaveis_Order_By>>;
  where?: InputMaybe<TbPacotesServicosPrecosVariaveis_Bool_Exp>;
};


export type Query_RootTbPacotesServicosPrecosVariaveis_By_PkArgs = {
  codPacoteServicosPrecoVariavel: Scalars['Int']['input'];
};


export type Query_RootTbPeriodosGarantidosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidos_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
};


export type Query_RootTbPeriodosGarantidosRecorrentesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidosRecorrentes_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidosRecorrentes_Bool_Exp>;
};


export type Query_RootTbPeriodosGarantidosRecorrentesFrequenciasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidosRecorrentesFrequencias_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidosRecorrentesFrequencias_Bool_Exp>;
};


export type Query_RootTbPeriodosGarantidosRecorrentesFrequencias_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidosRecorrentesFrequencias_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidosRecorrentesFrequencias_Bool_Exp>;
};


export type Query_RootTbPeriodosGarantidosRecorrentesFrequencias_By_PkArgs = {
  codPeriodoGarantidoRecorrenteFrequencia: Scalars['Int']['input'];
};


export type Query_RootTbPeriodosGarantidosRecorrentes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidosRecorrentes_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidosRecorrentes_Bool_Exp>;
};


export type Query_RootTbPeriodosGarantidosRecorrentes_By_PkArgs = {
  codPeriodoGarantidoRecorrente: Scalars['Int']['input'];
};


export type Query_RootTbPeriodosGarantidos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidos_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
};


export type Query_RootTbPeriodosGarantidos_By_PkArgs = {
  codPeriodoGarantido: Scalars['Int']['input'];
};


export type Query_RootTbTipoPacotesServicosPrecoVariavelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbTipoPacotesServicosPrecoVariavel_Order_By>>;
  where?: InputMaybe<TbTipoPacotesServicosPrecoVariavel_Bool_Exp>;
};


export type Query_RootTbTipoPacotesServicosPrecoVariavel_By_PkArgs = {
  codTipoPacoteServicosPrecoVariavel: Scalars['Int']['input'];
};


export type Query_RootTbUsuariosAgendasDiasSemanasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbUsuariosAgendasDiasSemanas_Order_By>>;
  where?: InputMaybe<TbUsuariosAgendasDiasSemanas_Bool_Exp>;
};


export type Query_RootTbUsuariosIntegracoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbUsuariosIntegracoes_Order_By>>;
  where?: InputMaybe<TbUsuariosIntegracoes_Bool_Exp>;
};


export type Query_RootTbUsuariosIntegracoes_By_PkArgs = {
  codParceiroIntegracao: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
};


export type Query_RootTbUsuariosTermosDeUsoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbUsuariosTermosDeUso_Order_By>>;
  where?: InputMaybe<TbUsuariosTermosDeUso_Bool_Exp>;
};


export type Query_RootTbUsuariosTermosDeUso_By_PkArgs = {
  codTermosDeUso: Scalars['Int']['input'];
};


export type Query_RootTerms_Of_UseArgs = {
  distinct_on?: InputMaybe<Array<Terms_Of_Use_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Terms_Of_Use_Order_By>>;
  where?: InputMaybe<Terms_Of_Use_Bool_Exp>;
};


export type Query_RootTerms_Of_Use_By_PkArgs = {
  file: Scalars['String']['input'];
};


export type Query_RootTiposAgendasRepeticoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposAgendasRepeticoes_Order_By>>;
  where?: InputMaybe<TiposAgendasRepeticoes_Bool_Exp>;
};


export type Query_RootTiposAgendasRepeticoes_By_PkArgs = {
  codTipoAgendaRepeticao: Scalars['Int']['input'];
};


export type Query_RootTiposConveniosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposConvenios_Order_By>>;
  where?: InputMaybe<TiposConvenios_Bool_Exp>;
};


export type Query_RootTiposConvenios_By_PkArgs = {
  codTipoConvenio: Scalars['Int']['input'];
};


export type Query_RootTiposFormasRecebimentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposFormasRecebimentos_Order_By>>;
  where?: InputMaybe<TiposFormasRecebimentos_Bool_Exp>;
};


export type Query_RootTiposFormasRecebimentos_By_PkArgs = {
  codTipoFormaRecebimento: Scalars['Int']['input'];
};


export type Query_RootTiposMovimentacoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposMovimentacoes_Order_By>>;
  where?: InputMaybe<TiposMovimentacoes_Bool_Exp>;
};


export type Query_RootTiposMovimentacoes_By_PkArgs = {
  codTipoMovimentacao: Scalars['Int']['input'];
};


export type Query_RootTiposPlanosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposPlanos_Order_By>>;
  where?: InputMaybe<TiposPlanos_Bool_Exp>;
};


export type Query_RootTiposPlanos_By_PkArgs = {
  codTipoPlano: Scalars['Int']['input'];
};


export type Query_RootTiposSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposSalas_Order_By>>;
  where?: InputMaybe<TiposSalas_Bool_Exp>;
};


export type Query_RootTiposSalas_By_PkArgs = {
  codTipoSala: Scalars['Int']['input'];
};


export type Query_RootUnidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unidades_Order_By>>;
  where?: InputMaybe<Unidades_Bool_Exp>;
};


export type Query_RootUnidadesHorariosFuncionamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesHorariosFuncionamentos_Order_By>>;
  where?: InputMaybe<UnidadesHorariosFuncionamentos_Bool_Exp>;
};


export type Query_RootUnidadesHorariosFuncionamentos_By_PkArgs = {
  codUnidadeHorarioFuncionamento: Scalars['Int']['input'];
};


export type Query_RootUnidadesPoliticasDeHorariosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPoliticasDeHorarios_Order_By>>;
  where?: InputMaybe<UnidadesPoliticasDeHorarios_Bool_Exp>;
};


export type Query_RootUnidadesPoliticasDeHorarios_By_PkArgs = {
  codUnidadePoliticaDeHorario: Scalars['Int']['input'];
};


export type Query_RootUnidadesSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalas_Order_By>>;
  where?: InputMaybe<UnidadesSalas_Bool_Exp>;
};


export type Query_RootUnidadesSalasPeriodosBloqueadosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalasPeriodosBloqueados_Order_By>>;
  where?: InputMaybe<UnidadesSalasPeriodosBloqueados_Bool_Exp>;
};


export type Query_RootUnidadesSalasPeriodosBloqueados_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalasPeriodosBloqueados_Order_By>>;
  where?: InputMaybe<UnidadesSalasPeriodosBloqueados_Bool_Exp>;
};


export type Query_RootUnidadesSalasPeriodosBloqueados_By_PkArgs = {
  codUnidadeSalaPeriodoBloqueado: Scalars['Int']['input'];
};


export type Query_RootUnidadesSalas_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalas_Order_By>>;
  where?: InputMaybe<UnidadesSalas_Bool_Exp>;
};


export type Query_RootUnidadesSalas_By_PkArgs = {
  codUnidadeSala: Scalars['Int']['input'];
};


export type Query_RootUnidades_By_PkArgs = {
  codUnidade: Scalars['Int']['input'];
};


export type Query_RootUnitsArgs = {
  distinct_on?: InputMaybe<Array<Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Units_Order_By>>;
  where?: InputMaybe<Units_Bool_Exp>;
};


export type Query_RootUnits_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUser_AddressesArgs = {
  distinct_on?: InputMaybe<Array<User_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Addresses_Order_By>>;
  where?: InputMaybe<User_Addresses_Bool_Exp>;
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUsers_Professional_CardsArgs = {
  distinct_on?: InputMaybe<Array<Users_Professional_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Professional_Cards_Order_By>>;
  where?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
};


export type Query_RootUsers_Professional_Cards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Professional_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Professional_Cards_Order_By>>;
  where?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
};


export type Query_RootUsers_Professional_Cards_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUsers_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Users_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Provider_Order_By>>;
  where?: InputMaybe<Users_Provider_Bool_Exp>;
};


export type Query_RootUsers_Terms_Of_Use_AgreedArgs = {
  distinct_on?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Order_By>>;
  where?: InputMaybe<Users_Terms_Of_Use_Agreed_Bool_Exp>;
};


export type Query_RootUsers_Terms_Of_Use_Agreed_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUsuariosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Usuarios_Order_By>>;
  where?: InputMaybe<Usuarios_Bool_Exp>;
};


export type Query_RootUsuariosAgendasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendas_Order_By>>;
  where?: InputMaybe<UsuariosAgendas_Bool_Exp>;
};


export type Query_RootUsuariosAgendasCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosAgendasCompromissos_Bool_Exp>;
};


export type Query_RootUsuariosAgendasUnidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasUnidades_Order_By>>;
  where?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
};


export type Query_RootUsuariosAgendasUnidades_By_PkArgs = {
  codUnidade: Scalars['Int']['input'];
  codUsuarioAgenda: Scalars['Int']['input'];
};


export type Query_RootUsuariosAgendas_By_PkArgs = {
  codUsuarioAgenda: Scalars['Int']['input'];
};


export type Query_RootUsuariosCartoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCartoes_Order_By>>;
  where?: InputMaybe<UsuariosCartoes_Bool_Exp>;
};


export type Query_RootUsuariosCartoes_By_PkArgs = {
  codUsuarioCartao: Scalars['Int']['input'];
};


export type Query_RootUsuariosCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};


export type Query_RootUsuariosCompromissosCanaisAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosCanaisAgendamentos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Bool_Exp>;
};


export type Query_RootUsuariosCompromissosCanaisAgendamentos_By_PkArgs = {
  codCanalAgendamento: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
};


export type Query_RootUsuariosCompromissosCategoriasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosCategorias_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosCategorias_Bool_Exp>;
};


export type Query_RootUsuariosCompromissosCategorias_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosCategorias_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosCategorias_Bool_Exp>;
};


export type Query_RootUsuariosCompromissosCategorias_By_PkArgs = {
  codUsuarioCompromissoCategoria: Scalars['Int']['input'];
};


export type Query_RootUsuariosCompromissosFormasRecebimentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosFormasRecebimentos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Bool_Exp>;
};


export type Query_RootUsuariosCompromissosFormasRecebimentos_By_PkArgs = {
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
};


export type Query_RootUsuariosCompromissosModalidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosModalidades_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosModalidades_Bool_Exp>;
};


export type Query_RootUsuariosCompromissosModalidades_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosModalidades_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosModalidades_Bool_Exp>;
};


export type Query_RootUsuariosCompromissosModalidades_By_PkArgs = {
  codUsuarioCompromissoModalidade: Scalars['Int']['input'];
};


export type Query_RootUsuariosCompromissosTiposSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};


export type Query_RootUsuariosCompromissosTiposSalas_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};


export type Query_RootUsuariosCompromissosTiposSalas_By_PkArgs = {
  codTipoSala: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
};


export type Query_RootUsuariosCompromissos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};


export type Query_RootUsuariosCompromissos_By_PkArgs = {
  codUsuarioCompromisso: Scalars['Int']['input'];
};


export type Query_RootUsuariosEspecialidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosEspecialidades_Order_By>>;
  where?: InputMaybe<UsuariosEspecialidades_Bool_Exp>;
};


export type Query_RootUsuariosEspecialidades_By_PkArgs = {
  codEspecialidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
};


export type Query_RootUsuariosFormasRecebimentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosFormasRecebimentos_Order_By>>;
  where?: InputMaybe<UsuariosFormasRecebimentos_Bool_Exp>;
};


export type Query_RootUsuariosFormasRecebimentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosFormasRecebimentos_Order_By>>;
  where?: InputMaybe<UsuariosFormasRecebimentos_Bool_Exp>;
};


export type Query_RootUsuariosFormasRecebimentos_By_PkArgs = {
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
};


export type Query_RootUsuariosLinksRastreamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosLinksRastreamentos_Order_By>>;
  where?: InputMaybe<UsuariosLinksRastreamentos_Bool_Exp>;
};


export type Query_RootUsuariosLinksRastreamentos_By_PkArgs = {
  codUsuarioLinkRastreamento: Scalars['Int']['input'];
};


export type Query_RootUsuariosMovimentacoesRecorrentesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosMovimentacoesRecorrentes_Order_By>>;
  where?: InputMaybe<UsuariosMovimentacoesRecorrentes_Bool_Exp>;
};


export type Query_RootUsuariosMovimentacoesRecorrentes_By_PkArgs = {
  codUsuarioMovimentacaoRecorrente: Scalars['Int']['input'];
};


export type Query_RootUsuariosPacotesServicosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosPacotesServicos_Order_By>>;
  where?: InputMaybe<UsuariosPacotesServicos_Bool_Exp>;
};


export type Query_RootUsuariosPacotesServicos_By_PkArgs = {
  codUsuarioPacoteServicos: Scalars['Int']['input'];
};


export type Query_RootUsuariosProfissionaisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosProfissionais_Order_By>>;
  where?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};


export type Query_RootUsuariosProfissionaisOrientacoesSecretariasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosProfissionaisOrientacoesSecretarias_Order_By>>;
  where?: InputMaybe<UsuariosProfissionaisOrientacoesSecretarias_Bool_Exp>;
};


export type Query_RootUsuariosProfissionaisOrientacoesSecretarias_By_PkArgs = {
  codUsuario: Scalars['Int']['input'];
};


export type Query_RootUsuariosProfissionaisPlanosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosProfissionaisPlanos_Order_By>>;
  where?: InputMaybe<UsuariosProfissionaisPlanos_Bool_Exp>;
};


export type Query_RootUsuariosProfissionaisPlanos_By_PkArgs = {
  codUsuarioProfissionalPlano: Scalars['Int']['input'];
};


export type Query_RootUsuariosProfissionais_By_PkArgs = {
  codUsuario: Scalars['Int']['input'];
};


export type Query_RootUsuariosTelefonesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosTelefones_Order_By>>;
  where?: InputMaybe<UsuariosTelefones_Bool_Exp>;
};


export type Query_RootUsuariosTelefones_By_PkArgs = {
  codUsuarioTelefone: Scalars['Int']['input'];
};


export type Query_RootUsuarios_By_PkArgs = {
  codUsuario: Scalars['Int']['input'];
};

/** columns and relationships of "referrals" */
export type Referrals = {
  __typename?: 'referrals';
  created_at: Scalars['timestamptz']['output'];
  refereeName: Scalars['String']['output'];
  refereePhone: Scalars['String']['output'];
  refereeSpecialty?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
  userId: Scalars['Int']['output'];
};

/** order by aggregate values of table "referrals" */
export type Referrals_Aggregate_Order_By = {
  avg?: InputMaybe<Referrals_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Referrals_Max_Order_By>;
  min?: InputMaybe<Referrals_Min_Order_By>;
  stddev?: InputMaybe<Referrals_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Referrals_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Referrals_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Referrals_Sum_Order_By>;
  var_pop?: InputMaybe<Referrals_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Referrals_Var_Samp_Order_By>;
  variance?: InputMaybe<Referrals_Variance_Order_By>;
};

/** order by avg() on columns of table "referrals" */
export type Referrals_Avg_Order_By = {
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "referrals". All fields are combined with a logical 'AND'. */
export type Referrals_Bool_Exp = {
  _and?: InputMaybe<Array<Referrals_Bool_Exp>>;
  _not?: InputMaybe<Referrals_Bool_Exp>;
  _or?: InputMaybe<Array<Referrals_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  refereeName?: InputMaybe<String_Comparison_Exp>;
  refereePhone?: InputMaybe<String_Comparison_Exp>;
  refereeSpecialty?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "referrals" */
export type Referrals_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  refereeName?: InputMaybe<Order_By>;
  refereePhone?: InputMaybe<Order_By>;
  refereeSpecialty?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "referrals" */
export type Referrals_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  refereeName?: InputMaybe<Order_By>;
  refereePhone?: InputMaybe<Order_By>;
  refereeSpecialty?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "referrals". */
export type Referrals_Order_By = {
  created_at?: InputMaybe<Order_By>;
  refereeName?: InputMaybe<Order_By>;
  refereePhone?: InputMaybe<Order_By>;
  refereeSpecialty?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "referrals" */
export enum Referrals_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  RefereeName = 'refereeName',
  /** column name */
  RefereePhone = 'refereePhone',
  /** column name */
  RefereeSpecialty = 'refereeSpecialty',
  /** column name */
  UserId = 'userId'
}

/** order by stddev() on columns of table "referrals" */
export type Referrals_Stddev_Order_By = {
  userId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "referrals" */
export type Referrals_Stddev_Pop_Order_By = {
  userId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "referrals" */
export type Referrals_Stddev_Samp_Order_By = {
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "referrals" */
export type Referrals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Referrals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Referrals_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  refereeName?: InputMaybe<Scalars['String']['input']>;
  refereePhone?: InputMaybe<Scalars['String']['input']>;
  refereeSpecialty?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "referrals" */
export type Referrals_Sum_Order_By = {
  userId?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "referrals" */
export type Referrals_Var_Pop_Order_By = {
  userId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "referrals" */
export type Referrals_Var_Samp_Order_By = {
  userId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "referrals" */
export type Referrals_Variance_Order_By = {
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "smalldatetime". All fields are combined with logical 'AND'. */
export type Smalldatetime_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smalldatetime']['input']>;
  _gt?: InputMaybe<Scalars['smalldatetime']['input']>;
  _gte?: InputMaybe<Scalars['smalldatetime']['input']>;
  _in?: InputMaybe<Array<Scalars['smalldatetime']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smalldatetime']['input']>;
  _lte?: InputMaybe<Scalars['smalldatetime']['input']>;
  _neq?: InputMaybe<Scalars['smalldatetime']['input']>;
  _nin?: InputMaybe<Array<Scalars['smalldatetime']['input']>>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** An array relationship */
  AgendamentosAlocacoesAtivas: Array<AgendamentosAlocacoesAtivas>;
  /** fetch data from the table: "tbAgendamentosAlocacoesAtivas" using primary key columns */
  AgendamentosAlocacoesAtivas_by_pk?: Maybe<AgendamentosAlocacoesAtivas>;
  /** An array relationship */
  PrecificacoesTiposSalas: Array<PrecificacoesTiposSalas>;
  /** fetch data from the table: "tbPrecificacoesTiposSalas" using primary key columns */
  PrecificacoesTiposSalas_by_pk?: Maybe<PrecificacoesTiposSalas>;
  /** fetch data from the table: "tbUnidadesPrecosFlexiveis" */
  UnidadesPrecosFlexiveis: Array<UnidadesPrecosFlexiveis>;
  /** An array relationship */
  UnidadesPrecosFlexiveisParceirosIntegracoes: Array<UnidadesPrecosFlexiveisParceirosIntegracoes>;
  /** An aggregate relationship */
  UnidadesPrecosFlexiveisParceirosIntegracoes_aggregate: UnidadesPrecosFlexiveisParceirosIntegracoes_Aggregate;
  /** fetch data from the table: "tbUnidadesPrecosFlexiveisParceirosIntegracoes" using primary key columns */
  UnidadesPrecosFlexiveisParceirosIntegracoes_by_pk?: Maybe<UnidadesPrecosFlexiveisParceirosIntegracoes>;
  /** fetch aggregated fields from the table: "tbUnidadesPrecosFlexiveis" */
  UnidadesPrecosFlexiveis_aggregate: UnidadesPrecosFlexiveis_Aggregate;
  /** fetch data from the table: "tbUnidadesPrecosFlexiveis" using primary key columns */
  UnidadesPrecosFlexiveis_by_pk?: Maybe<UnidadesPrecosFlexiveis>;
  /** fetch data from the table: "tbUnidadesSalasMotivosBloqueios" */
  UnidadesSalasMotivosBloqueios: Array<UnidadesSalasMotivosBloqueios>;
  /** fetch data from the table: "tbUnidadesSalasMotivosBloqueios" using primary key columns */
  UnidadesSalasMotivosBloqueios_by_pk?: Maybe<UnidadesSalasMotivosBloqueios>;
  /** fetch data from the table: "tbUsuariosArquivos" */
  UsuariosArquivos: Array<UsuariosArquivos>;
  /** fetch data from the table: "tbUsuariosArquivos" using primary key columns */
  UsuariosArquivos_by_pk?: Maybe<UsuariosArquivos>;
  /** fetch data from the table: "tbUsuariosCompromissosStatusSugestoesDuracoes" */
  UsuariosCompromissosStatusSugestoesDuracoes: Array<UsuariosCompromissosStatusSugestoesDuracoes>;
  /** fetch data from the table: "tbUsuariosCompromissosStatusSugestoesDuracoes" using primary key columns */
  UsuariosCompromissosStatusSugestoesDuracoes_by_pk?: Maybe<UsuariosCompromissosStatusSugestoesDuracoes>;
  /** An array relationship */
  agendamentos: Array<Agendamentos>;
  /** fetch data from the table: "tbAgendamentosAlocacoes" */
  agendamentosAlocacoes: Array<AgendamentosAlocacoes>;
  /** fetch aggregated fields from the table: "tbAgendamentosAlocacoes" */
  agendamentosAlocacoes_aggregate: AgendamentosAlocacoes_Aggregate;
  /** fetch data from the table: "tbAgendamentosAlocacoes" using primary key columns */
  agendamentosAlocacoes_by_pk?: Maybe<AgendamentosAlocacoes>;
  /** fetch data from the table: "tbAgendamentosPreAlocacao" */
  agendamentosPreAlocacao: Array<AgendamentosPreAlocacao>;
  /** fetch aggregated fields from the table: "tbAgendamentosPreAlocacao" */
  agendamentosPreAlocacao_aggregate: AgendamentosPreAlocacao_Aggregate;
  /** fetch data from the table: "tbAgendamentosPreAlocacao" using primary key columns */
  agendamentosPreAlocacao_by_pk?: Maybe<AgendamentosPreAlocacao>;
  /** An array relationship */
  agendamentosTags: Array<AgendamentosTags>;
  /** fetch data from the table: "tbAgendamentosTags" using primary key columns */
  agendamentosTags_by_pk?: Maybe<AgendamentosTags>;
  /** fetch data from the table: "tbAgendamentosTiposTags" */
  agendamentosTiposTags: Array<AgendamentosTiposTags>;
  /** fetch data from the table: "tbAgendamentosTiposTags" using primary key columns */
  agendamentosTiposTags_by_pk?: Maybe<AgendamentosTiposTags>;
  /** An aggregate relationship */
  agendamentos_aggregate: Agendamentos_Aggregate;
  /** fetch data from the table: "tbAgendamentos" using primary key columns */
  agendamentos_by_pk?: Maybe<Agendamentos>;
  /** fetch data from the table: "tbCanaisAgendamentos" */
  canaisAgendamentos: Array<CanaisAgendamentos>;
  /** fetch data from the table: "tbCanaisAgendamentos" using primary key columns */
  canaisAgendamentos_by_pk?: Maybe<CanaisAgendamentos>;
  /** fetch data from the table: "tbCobrancas" */
  cobrancas: Array<Cobrancas>;
  /** fetch data from the table: "tbCsatCategorias" */
  csatCategorias: Array<CsatCategorias>;
  /** An array relationship */
  csatCategoriasNotas: Array<CsatCategoriasNotas>;
  /** fetch data from the table: "tbCsatCategoriasNotas" using primary key columns */
  csatCategoriasNotas_by_pk?: Maybe<CsatCategoriasNotas>;
  /** fetch data from the table: "tbCsatCategorias" using primary key columns */
  csatCategorias_by_pk?: Maybe<CsatCategorias>;
  /** fetch data from the table: "tbEspecialidades" */
  especialidades: Array<Especialidades>;
  /** fetch data from the table: "tbEspecialidades" using primary key columns */
  especialidades_by_pk?: Maybe<Especialidades>;
  /** fetch data from the table: "expensum.appointment_paid" */
  expensum_appointment_paid: Array<Expensum_Appointment_Paid>;
  /** fetch aggregated fields from the table: "expensum.appointment_paid" */
  expensum_appointment_paid_aggregate: Expensum_Appointment_Paid_Aggregate;
  /** fetch data from the table in a streaming manner: "expensum.appointment_paid" */
  expensum_appointment_paid_stream: Array<Expensum_Appointment_Paid>;
  /** fetch data from the table: "expensum.event_automatic_anticipation_settings_update" */
  expensum_event_automatic_anticipation_settings_update: Array<Expensum_Event_Automatic_Anticipation_Settings_Update>;
  /** fetch data from the table: "expensum.event_automatic_anticipation_settings_update" using primary key columns */
  expensum_event_automatic_anticipation_settings_update_by_pk?: Maybe<Expensum_Event_Automatic_Anticipation_Settings_Update>;
  /** fetch data from the table in a streaming manner: "expensum.event_automatic_anticipation_settings_update" */
  expensum_event_automatic_anticipation_settings_update_stream: Array<Expensum_Event_Automatic_Anticipation_Settings_Update>;
  /** fetch data from the table: "expensum.event_bank_account_update" */
  expensum_event_bank_account_update: Array<Expensum_Event_Bank_Account_Update>;
  /** fetch data from the table: "expensum.event_bank_account_update" using primary key columns */
  expensum_event_bank_account_update_by_pk?: Maybe<Expensum_Event_Bank_Account_Update>;
  /** fetch data from the table in a streaming manner: "expensum.event_bank_account_update" */
  expensum_event_bank_account_update_stream: Array<Expensum_Event_Bank_Account_Update>;
  /** fetch data from the table: "expensum.event_totem_payment_sent" */
  expensum_event_totem_payment_sent: Array<Expensum_Event_Totem_Payment_Sent>;
  /** fetch aggregated fields from the table: "expensum.event_totem_payment_sent" */
  expensum_event_totem_payment_sent_aggregate: Expensum_Event_Totem_Payment_Sent_Aggregate;
  /** fetch data from the table: "expensum.event_totem_payment_sent" using primary key columns */
  expensum_event_totem_payment_sent_by_pk?: Maybe<Expensum_Event_Totem_Payment_Sent>;
  /** fetch data from the table in a streaming manner: "expensum.event_totem_payment_sent" */
  expensum_event_totem_payment_sent_stream: Array<Expensum_Event_Totem_Payment_Sent>;
  /** fetch data from the table: "expensum.online_payment" */
  expensum_online_payment: Array<Expensum_Online_Payment>;
  /** fetch data from the table: "expensum.online_payment_activity" */
  expensum_online_payment_activity: Array<Expensum_Online_Payment_Activity>;
  /** fetch data from the table in a streaming manner: "expensum.online_payment_activity" */
  expensum_online_payment_activity_stream: Array<Expensum_Online_Payment_Activity>;
  /** fetch aggregated fields from the table: "expensum.online_payment" */
  expensum_online_payment_aggregate: Expensum_Online_Payment_Aggregate;
  /** fetch data from the table: "expensum.online_payment" using primary key columns */
  expensum_online_payment_by_pk?: Maybe<Expensum_Online_Payment>;
  /** fetch data from the table in a streaming manner: "expensum.online_payment" */
  expensum_online_payment_stream: Array<Expensum_Online_Payment>;
  /** fetch data from the table: "expensum.payment_type" */
  expensum_payment_type: Array<Expensum_Payment_Type>;
  /** fetch data from the table: "expensum.payment_type" using primary key columns */
  expensum_payment_type_by_pk?: Maybe<Expensum_Payment_Type>;
  /** fetch data from the table in a streaming manner: "expensum.payment_type" */
  expensum_payment_type_stream: Array<Expensum_Payment_Type>;
  /** fetch data from the table: "expensum.recipient_terms_of_use_agreed" */
  expensum_recipient_terms_of_use_agreed: Array<Expensum_Recipient_Terms_Of_Use_Agreed>;
  /** fetch data from the table: "expensum.recipient_terms_of_use_agreed" using primary key columns */
  expensum_recipient_terms_of_use_agreed_by_pk?: Maybe<Expensum_Recipient_Terms_Of_Use_Agreed>;
  /** fetch data from the table in a streaming manner: "expensum.recipient_terms_of_use_agreed" */
  expensum_recipient_terms_of_use_agreed_stream: Array<Expensum_Recipient_Terms_Of_Use_Agreed>;
  /** fetch data from the table: "expensum.terms_of_use" */
  expensum_terms_of_use: Array<Expensum_Terms_Of_Use>;
  /** fetch data from the table: "expensum.terms_of_use" using primary key columns */
  expensum_terms_of_use_by_pk?: Maybe<Expensum_Terms_Of_Use>;
  /** fetch data from the table in a streaming manner: "expensum.terms_of_use" */
  expensum_terms_of_use_stream: Array<Expensum_Terms_Of_Use>;
  /** fetch data from the table: "tbFinalidadesAgendamentos" */
  finalidadesAgendamentos: Array<FinalidadesAgendamentos>;
  /** fetch data from the table: "tbFinalidadesAgendamentos" using primary key columns */
  finalidadesAgendamentos_by_pk?: Maybe<FinalidadesAgendamentos>;
  /** An array relationship */
  funcionalidadesDesativadas: Array<FuncionalidadesDesativadas>;
  /** fetch data from the table: "tbFuncionalidadesDesativadas" using primary key columns */
  funcionalidadesDesativadas_by_pk?: Maybe<FuncionalidadesDesativadas>;
  /** An array relationship */
  lembretes: Array<Lembretes>;
  /** An aggregate relationship */
  lembretes_aggregate: Lembretes_Aggregate;
  /** fetch data from the table: "tbLembretes" using primary key columns */
  lembretes_by_pk?: Maybe<Lembretes>;
  /** fetch data from the table: "tbLinksDestinos" */
  linksDestinos: Array<LinksDestinos>;
  /** fetch data from the table: "tbLinksDestinos" using primary key columns */
  linksDestinos_by_pk?: Maybe<LinksDestinos>;
  /** fetch data from the table: "locus.conselho_profissional" */
  locus_conselho_profissional: Array<Locus_Conselho_Profissional>;
  /** fetch data from the table: "locus.conselho_profissional" using primary key columns */
  locus_conselho_profissional_by_pk?: Maybe<Locus_Conselho_Profissional>;
  /** fetch data from the table: "locus.conselho_profissional_especialidade" */
  locus_conselho_profissional_especialidade: Array<Locus_Conselho_Profissional_Especialidade>;
  /** fetch data from the table: "locus.conselho_profissional_especialidade" using primary key columns */
  locus_conselho_profissional_especialidade_by_pk?: Maybe<Locus_Conselho_Profissional_Especialidade>;
  /** fetch data from the table in a streaming manner: "locus.conselho_profissional_especialidade" */
  locus_conselho_profissional_especialidade_stream: Array<Locus_Conselho_Profissional_Especialidade>;
  /** fetch data from the table in a streaming manner: "locus.conselho_profissional" */
  locus_conselho_profissional_stream: Array<Locus_Conselho_Profissional>;
  /** fetch data from the table: "locus.curso_formacao" */
  locus_curso_formacao: Array<Locus_Curso_Formacao>;
  /** fetch data from the table: "locus.curso_formacao" using primary key columns */
  locus_curso_formacao_by_pk?: Maybe<Locus_Curso_Formacao>;
  /** fetch data from the table in a streaming manner: "locus.curso_formacao" */
  locus_curso_formacao_stream: Array<Locus_Curso_Formacao>;
  /** fetch data from the table: "locus.especialidade" */
  locus_especialidade: Array<Locus_Especialidade>;
  /** fetch data from the table: "locus.especialidade" using primary key columns */
  locus_especialidade_by_pk?: Maybe<Locus_Especialidade>;
  /** fetch data from the table in a streaming manner: "locus.especialidade" */
  locus_especialidade_stream: Array<Locus_Especialidade>;
  /** fetch data from the table: "locus.especialidade_subespecialidade" */
  locus_especialidade_subespecialidade: Array<Locus_Especialidade_Subespecialidade>;
  /** fetch data from the table: "locus.especialidade_subespecialidade" using primary key columns */
  locus_especialidade_subespecialidade_by_pk?: Maybe<Locus_Especialidade_Subespecialidade>;
  /** fetch data from the table in a streaming manner: "locus.especialidade_subespecialidade" */
  locus_especialidade_subespecialidade_stream: Array<Locus_Especialidade_Subespecialidade>;
  /** fetch data from the table: "locus.experiencia_membro" */
  locus_experiencia_membro: Array<Locus_Experiencia_Membro>;
  /** fetch data from the table: "locus.experiencia_membro" using primary key columns */
  locus_experiencia_membro_by_pk?: Maybe<Locus_Experiencia_Membro>;
  /** fetch data from the table in a streaming manner: "locus.experiencia_membro" */
  locus_experiencia_membro_stream: Array<Locus_Experiencia_Membro>;
  /** fetch data from the table: "locus.faq_membro" */
  locus_faq_membro: Array<Locus_Faq_Membro>;
  /** fetch data from the table: "locus.faq_membro" using primary key columns */
  locus_faq_membro_by_pk?: Maybe<Locus_Faq_Membro>;
  /** fetch data from the table in a streaming manner: "locus.faq_membro" */
  locus_faq_membro_stream: Array<Locus_Faq_Membro>;
  /** fetch data from the table: "locus.foco_tratamento_membro" */
  locus_foco_tratamento_membro: Array<Locus_Foco_Tratamento_Membro>;
  /** fetch data from the table: "locus.foco_tratamento_membro" using primary key columns */
  locus_foco_tratamento_membro_by_pk?: Maybe<Locus_Foco_Tratamento_Membro>;
  /** fetch data from the table in a streaming manner: "locus.foco_tratamento_membro" */
  locus_foco_tratamento_membro_stream: Array<Locus_Foco_Tratamento_Membro>;
  /** fetch data from the table: "locus.instituicao_ensino" */
  locus_instituicao_ensino: Array<Locus_Instituicao_Ensino>;
  /** fetch data from the table: "locus.instituicao_ensino" using primary key columns */
  locus_instituicao_ensino_by_pk?: Maybe<Locus_Instituicao_Ensino>;
  /** fetch data from the table in a streaming manner: "locus.instituicao_ensino" */
  locus_instituicao_ensino_stream: Array<Locus_Instituicao_Ensino>;
  /** fetch data from the table: "locus.instituicao_medica" */
  locus_instituicao_medica: Array<Locus_Instituicao_Medica>;
  /** fetch data from the table: "locus.instituicao_medica" using primary key columns */
  locus_instituicao_medica_by_pk?: Maybe<Locus_Instituicao_Medica>;
  /** fetch data from the table in a streaming manner: "locus.instituicao_medica" */
  locus_instituicao_medica_stream: Array<Locus_Instituicao_Medica>;
  /** fetch data from the table: "locus.membro" */
  locus_membro: Array<Locus_Membro>;
  /** fetch data from the table: "locus.membro" using primary key columns */
  locus_membro_by_pk?: Maybe<Locus_Membro>;
  /** fetch data from the table: "locus.membro_especialidade" */
  locus_membro_especialidade: Array<Locus_Membro_Especialidade>;
  /** fetch data from the table: "locus.membro_especialidade" using primary key columns */
  locus_membro_especialidade_by_pk?: Maybe<Locus_Membro_Especialidade>;
  /** fetch data from the table in a streaming manner: "locus.membro_especialidade" */
  locus_membro_especialidade_stream: Array<Locus_Membro_Especialidade>;
  /** fetch data from the table: "locus.membro_especialidade_subespecialidade" */
  locus_membro_especialidade_subespecialidade: Array<Locus_Membro_Especialidade_Subespecialidade>;
  /** fetch data from the table: "locus.membro_especialidade_subespecialidade" using primary key columns */
  locus_membro_especialidade_subespecialidade_by_pk?: Maybe<Locus_Membro_Especialidade_Subespecialidade>;
  /** fetch data from the table in a streaming manner: "locus.membro_especialidade_subespecialidade" */
  locus_membro_especialidade_subespecialidade_stream: Array<Locus_Membro_Especialidade_Subespecialidade>;
  /** fetch data from the table: "locus.membro_formacao" */
  locus_membro_formacao: Array<Locus_Membro_Formacao>;
  /** fetch data from the table: "locus.membro_formacao" using primary key columns */
  locus_membro_formacao_by_pk?: Maybe<Locus_Membro_Formacao>;
  /** fetch data from the table in a streaming manner: "locus.membro_formacao" */
  locus_membro_formacao_stream: Array<Locus_Membro_Formacao>;
  /** fetch data from the table: "locus.membro_instituicao_medica" */
  locus_membro_instituicao_medica: Array<Locus_Membro_Instituicao_Medica>;
  /** fetch data from the table: "locus.membro_instituicao_medica" using primary key columns */
  locus_membro_instituicao_medica_by_pk?: Maybe<Locus_Membro_Instituicao_Medica>;
  /** fetch data from the table in a streaming manner: "locus.membro_instituicao_medica" */
  locus_membro_instituicao_medica_stream: Array<Locus_Membro_Instituicao_Medica>;
  /** fetch data from the table in a streaming manner: "locus.membro" */
  locus_membro_stream: Array<Locus_Membro>;
  /** fetch data from the table: "locus.rede_social_membro" */
  locus_rede_social_membro: Array<Locus_Rede_Social_Membro>;
  /** fetch data from the table in a streaming manner: "locus.rede_social_membro" */
  locus_rede_social_membro_stream: Array<Locus_Rede_Social_Membro>;
  /** fetch data from the table: "locus.subespecialidade" */
  locus_subespecialidade: Array<Locus_Subespecialidade>;
  /** fetch data from the table: "locus.subespecialidade" using primary key columns */
  locus_subespecialidade_by_pk?: Maybe<Locus_Subespecialidade>;
  /** fetch data from the table in a streaming manner: "locus.subespecialidade" */
  locus_subespecialidade_stream: Array<Locus_Subespecialidade>;
  /** fetch data from the table: "nexus.follow" */
  nexus_follow: Array<Nexus_Follow>;
  /** fetch data from the table: "nexus.follow" using primary key columns */
  nexus_follow_by_pk?: Maybe<Nexus_Follow>;
  /** fetch data from the table in a streaming manner: "nexus.follow" */
  nexus_follow_stream: Array<Nexus_Follow>;
  /** An array relationship */
  notificacoesPacientesAtrasados: Array<NotificacoesPacientesAtrasados>;
  /** fetch data from the table: "tbNotificacoesPacientesAtrasados" using primary key columns */
  notificacoesPacientesAtrasados_by_pk?: Maybe<NotificacoesPacientesAtrasados>;
  /** fetch data from the table: "nuntius.contatos_por_dia" */
  nuntius_contatos_por_dia: Array<Nuntius_Contatos_Por_Dia>;
  /** fetch data from the table in a streaming manner: "nuntius.contatos_por_dia" */
  nuntius_contatos_por_dia_stream: Array<Nuntius_Contatos_Por_Dia>;
  /** fetch data from the table: "nuntius.lote_contatos_cobranca" */
  nuntius_lote_contatos_cobranca: Array<Nuntius_Lote_Contatos_Cobranca>;
  /** fetch data from the table: "nuntius.lote_contatos_cobranca" using primary key columns */
  nuntius_lote_contatos_cobranca_by_pk?: Maybe<Nuntius_Lote_Contatos_Cobranca>;
  /** fetch data from the table in a streaming manner: "nuntius.lote_contatos_cobranca" */
  nuntius_lote_contatos_cobranca_stream: Array<Nuntius_Lote_Contatos_Cobranca>;
  /** fetch data from the table: "tbPacientes" */
  pacientes: Array<Pacientes>;
  /** fetch data from the table: "tbPacientes" using primary key columns */
  pacientes_by_pk?: Maybe<Pacientes>;
  /** fetch data from the table: "tbPacotesServicosPrecos" */
  pacoteServicoPreco: Array<PacoteServicoPreco>;
  /** fetch data from the table: "tbPacotesServicosPrecos" using primary key columns */
  pacoteServicoPreco_by_pk?: Maybe<PacoteServicoPreco>;
  /** fetch data from the table: "tbPacotesServicos" */
  pacotesServicos: Array<PacotesServicos>;
  /** fetch data from the table: "tbPacotesServicos" using primary key columns */
  pacotesServicos_by_pk?: Maybe<PacotesServicos>;
  /** An array relationship */
  planos: Array<Planos>;
  /** fetch data from the table: "tbPlanosMigracoes" */
  planosMigracoes: Array<PlanosMigracoes>;
  /** fetch data from the table: "tbPlanos" using primary key columns */
  planos_by_pk?: Maybe<Planos>;
  /** An array relationship */
  referrals: Array<Referrals>;
  /** fetch data from the table in a streaming manner: "referrals" */
  referrals_stream: Array<Referrals>;
  /** fetch data from the table: "tbAgendamentosCheckins" */
  tbAgendamentosCheckins: Array<TbAgendamentosCheckins>;
  /** fetch aggregated fields from the table: "tbAgendamentosCheckins" */
  tbAgendamentosCheckins_aggregate: TbAgendamentosCheckins_Aggregate;
  /** fetch data from the table: "tbAgendamentosCheckins" using primary key columns */
  tbAgendamentosCheckins_by_pk?: Maybe<TbAgendamentosCheckins>;
  /** fetch data from the table: "tbAgendamentosVinculados" */
  tbAgendamentosVinculados: Array<TbAgendamentosVinculados>;
  /** fetch data from the table: "tbAgendamentosVinculados" using primary key columns */
  tbAgendamentosVinculados_by_pk?: Maybe<TbAgendamentosVinculados>;
  /** fetch data from the table: "tbClinicas" */
  tbClinicas: Array<TbClinicas>;
  /** fetch data from the table: "tbClinicas" using primary key columns */
  tbClinicas_by_pk?: Maybe<TbClinicas>;
  /** An array relationship */
  tbFechamentos: Array<TbFechamentos>;
  /** fetch data from the table: "tbFechamentos" using primary key columns */
  tbFechamentos_by_pk?: Maybe<TbFechamentos>;
  /** fetch data from the table: "tbFeriados" */
  tbFeriados: Array<TbFeriados>;
  /** fetch data from the table: "tbFeriados" using primary key columns */
  tbFeriados_by_pk?: Maybe<TbFeriados>;
  /** fetch data from the table: "tbMovimentacoes" */
  tbMovimentacoes: Array<TbMovimentacoes>;
  /** fetch data from the table: "tbMovimentacoes" using primary key columns */
  tbMovimentacoes_by_pk?: Maybe<TbMovimentacoes>;
  /** fetch data from the table: "tbPacotesServicosPrecosVariaveis" */
  tbPacotesServicosPrecosVariaveis: Array<TbPacotesServicosPrecosVariaveis>;
  /** fetch data from the table: "tbPacotesServicosPrecosVariaveis" using primary key columns */
  tbPacotesServicosPrecosVariaveis_by_pk?: Maybe<TbPacotesServicosPrecosVariaveis>;
  /** An array relationship */
  tbPeriodosGarantidos: Array<TbPeriodosGarantidos>;
  /** fetch data from the table: "tbPeriodosGarantidosRecorrentes" */
  tbPeriodosGarantidosRecorrentes: Array<TbPeriodosGarantidosRecorrentes>;
  /** fetch data from the table: "tbPeriodosGarantidosRecorrentesFrequencias" */
  tbPeriodosGarantidosRecorrentesFrequencias: Array<TbPeriodosGarantidosRecorrentesFrequencias>;
  /** fetch aggregated fields from the table: "tbPeriodosGarantidosRecorrentesFrequencias" */
  tbPeriodosGarantidosRecorrentesFrequencias_aggregate: TbPeriodosGarantidosRecorrentesFrequencias_Aggregate;
  /** fetch data from the table: "tbPeriodosGarantidosRecorrentesFrequencias" using primary key columns */
  tbPeriodosGarantidosRecorrentesFrequencias_by_pk?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias>;
  /** fetch aggregated fields from the table: "tbPeriodosGarantidosRecorrentes" */
  tbPeriodosGarantidosRecorrentes_aggregate: TbPeriodosGarantidosRecorrentes_Aggregate;
  /** fetch data from the table: "tbPeriodosGarantidosRecorrentes" using primary key columns */
  tbPeriodosGarantidosRecorrentes_by_pk?: Maybe<TbPeriodosGarantidosRecorrentes>;
  /** An aggregate relationship */
  tbPeriodosGarantidos_aggregate: TbPeriodosGarantidos_Aggregate;
  /** fetch data from the table: "tbPeriodosGarantidos" using primary key columns */
  tbPeriodosGarantidos_by_pk?: Maybe<TbPeriodosGarantidos>;
  /** fetch data from the table: "tbTipoPacotesServicosPrecoVariavel" */
  tbTipoPacotesServicosPrecoVariavel: Array<TbTipoPacotesServicosPrecoVariavel>;
  /** fetch data from the table: "tbTipoPacotesServicosPrecoVariavel" using primary key columns */
  tbTipoPacotesServicosPrecoVariavel_by_pk?: Maybe<TbTipoPacotesServicosPrecoVariavel>;
  /** An array relationship */
  tbUsuariosAgendasDiasSemanas: Array<TbUsuariosAgendasDiasSemanas>;
  /** fetch data from the table: "tbUsuariosIntegracoes" */
  tbUsuariosIntegracoes: Array<TbUsuariosIntegracoes>;
  /** fetch data from the table: "tbUsuariosIntegracoes" using primary key columns */
  tbUsuariosIntegracoes_by_pk?: Maybe<TbUsuariosIntegracoes>;
  /** fetch data from the table: "tbUsuariosTermosDeUso" */
  tbUsuariosTermosDeUso: Array<TbUsuariosTermosDeUso>;
  /** fetch data from the table: "tbUsuariosTermosDeUso" using primary key columns */
  tbUsuariosTermosDeUso_by_pk?: Maybe<TbUsuariosTermosDeUso>;
  /** fetch data from the table: "terms_of_use" */
  terms_of_use: Array<Terms_Of_Use>;
  /** fetch data from the table: "terms_of_use" using primary key columns */
  terms_of_use_by_pk?: Maybe<Terms_Of_Use>;
  /** fetch data from the table in a streaming manner: "terms_of_use" */
  terms_of_use_stream: Array<Terms_Of_Use>;
  /** fetch data from the table: "tbTiposAgendasRepeticoes" */
  tiposAgendasRepeticoes: Array<TiposAgendasRepeticoes>;
  /** fetch data from the table: "tbTiposAgendasRepeticoes" using primary key columns */
  tiposAgendasRepeticoes_by_pk?: Maybe<TiposAgendasRepeticoes>;
  /** fetch data from the table: "tbTiposConvenios" */
  tiposConvenios: Array<TiposConvenios>;
  /** fetch data from the table: "tbTiposConvenios" using primary key columns */
  tiposConvenios_by_pk?: Maybe<TiposConvenios>;
  /** fetch data from the table: "tbTiposFormasRecebimentos" */
  tiposFormasRecebimentos: Array<TiposFormasRecebimentos>;
  /** fetch data from the table: "tbTiposFormasRecebimentos" using primary key columns */
  tiposFormasRecebimentos_by_pk?: Maybe<TiposFormasRecebimentos>;
  /** fetch data from the table: "tbTiposMovimentacoes" */
  tiposMovimentacoes: Array<TiposMovimentacoes>;
  /** fetch data from the table: "tbTiposMovimentacoes" using primary key columns */
  tiposMovimentacoes_by_pk?: Maybe<TiposMovimentacoes>;
  /** fetch data from the table: "tbTiposPlanos" */
  tiposPlanos: Array<TiposPlanos>;
  /** fetch data from the table: "tbTiposPlanos" using primary key columns */
  tiposPlanos_by_pk?: Maybe<TiposPlanos>;
  /** fetch data from the table: "tbTiposSalas" */
  tiposSalas: Array<TiposSalas>;
  /** fetch data from the table: "tbTiposSalas" using primary key columns */
  tiposSalas_by_pk?: Maybe<TiposSalas>;
  /** fetch data from the table: "tbUnidades" */
  unidades: Array<Unidades>;
  /** fetch data from the table: "tbUnidadesHorariosFuncionamento" */
  unidadesHorariosFuncionamentos: Array<UnidadesHorariosFuncionamentos>;
  /** fetch data from the table: "tbUnidadesHorariosFuncionamento" using primary key columns */
  unidadesHorariosFuncionamentos_by_pk?: Maybe<UnidadesHorariosFuncionamentos>;
  /** fetch data from the table: "tbUnidadesPoliticasDeHorarios" */
  unidadesPoliticasDeHorarios: Array<UnidadesPoliticasDeHorarios>;
  /** fetch data from the table: "tbUnidadesPoliticasDeHorarios" using primary key columns */
  unidadesPoliticasDeHorarios_by_pk?: Maybe<UnidadesPoliticasDeHorarios>;
  /** fetch data from the table: "tbUnidadesSalas" */
  unidadesSalas: Array<UnidadesSalas>;
  /** fetch data from the table: "tbUnidadesSalasPeriodosBloqueados" */
  unidadesSalasPeriodosBloqueados: Array<UnidadesSalasPeriodosBloqueados>;
  /** fetch aggregated fields from the table: "tbUnidadesSalasPeriodosBloqueados" */
  unidadesSalasPeriodosBloqueados_aggregate: UnidadesSalasPeriodosBloqueados_Aggregate;
  /** fetch data from the table: "tbUnidadesSalasPeriodosBloqueados" using primary key columns */
  unidadesSalasPeriodosBloqueados_by_pk?: Maybe<UnidadesSalasPeriodosBloqueados>;
  /** fetch aggregated fields from the table: "tbUnidadesSalas" */
  unidadesSalas_aggregate: UnidadesSalas_Aggregate;
  /** fetch data from the table: "tbUnidadesSalas" using primary key columns */
  unidadesSalas_by_pk?: Maybe<UnidadesSalas>;
  /** fetch data from the table: "tbUnidades" using primary key columns */
  unidades_by_pk?: Maybe<Unidades>;
  /** fetch data from the table: "units" */
  units: Array<Units>;
  /** fetch data from the table: "units" using primary key columns */
  units_by_pk?: Maybe<Units>;
  /** fetch data from the table in a streaming manner: "units" */
  units_stream: Array<Units>;
  /** fetch data from the table: "user_addresses" */
  user_addresses: Array<User_Addresses>;
  /** fetch data from the table in a streaming manner: "user_addresses" */
  user_addresses_stream: Array<User_Addresses>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table: "users_professional_cards" */
  users_professional_cards: Array<Users_Professional_Cards>;
  /** fetch aggregated fields from the table: "users_professional_cards" */
  users_professional_cards_aggregate: Users_Professional_Cards_Aggregate;
  /** fetch data from the table: "users_professional_cards" using primary key columns */
  users_professional_cards_by_pk?: Maybe<Users_Professional_Cards>;
  /** fetch data from the table in a streaming manner: "users_professional_cards" */
  users_professional_cards_stream: Array<Users_Professional_Cards>;
  /** fetch data from the table: "users_provider" */
  users_provider: Array<Users_Provider>;
  /** fetch data from the table in a streaming manner: "users_provider" */
  users_provider_stream: Array<Users_Provider>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "users_terms_of_use_agreed" */
  users_terms_of_use_agreed: Array<Users_Terms_Of_Use_Agreed>;
  /** fetch data from the table: "users_terms_of_use_agreed" using primary key columns */
  users_terms_of_use_agreed_by_pk?: Maybe<Users_Terms_Of_Use_Agreed>;
  /** fetch data from the table in a streaming manner: "users_terms_of_use_agreed" */
  users_terms_of_use_agreed_stream: Array<Users_Terms_Of_Use_Agreed>;
  /** fetch data from the table: "tbUsuarios" */
  usuarios: Array<Usuarios>;
  /** An array relationship */
  usuariosAgendas: Array<UsuariosAgendas>;
  /** An array relationship */
  usuariosAgendasCompromissos: Array<UsuariosAgendasCompromissos>;
  /** An array relationship */
  usuariosAgendasUnidades: Array<UsuariosAgendasUnidades>;
  /** fetch data from the table: "tbUsuariosAgendasUnidades" using primary key columns */
  usuariosAgendasUnidades_by_pk?: Maybe<UsuariosAgendasUnidades>;
  /** fetch data from the table: "tbUsuariosAgendas" using primary key columns */
  usuariosAgendas_by_pk?: Maybe<UsuariosAgendas>;
  /** fetch data from the table: "tbUsuariosCartoes" */
  usuariosCartoes: Array<UsuariosCartoes>;
  /** fetch data from the table: "tbUsuariosCartoes" using primary key columns */
  usuariosCartoes_by_pk?: Maybe<UsuariosCartoes>;
  /** An array relationship */
  usuariosCompromissos: Array<UsuariosCompromissos>;
  /** An array relationship */
  usuariosCompromissosCanaisAgendamentos: Array<UsuariosCompromissosCanaisAgendamentos>;
  /** fetch data from the table: "tbUsuariosCompromissosCanaisAgendamentos" using primary key columns */
  usuariosCompromissosCanaisAgendamentos_by_pk?: Maybe<UsuariosCompromissosCanaisAgendamentos>;
  /** fetch data from the table: "tbUsuariosCompromissosCategorias" */
  usuariosCompromissosCategorias: Array<UsuariosCompromissosCategorias>;
  /** fetch aggregated fields from the table: "tbUsuariosCompromissosCategorias" */
  usuariosCompromissosCategorias_aggregate: UsuariosCompromissosCategorias_Aggregate;
  /** fetch data from the table: "tbUsuariosCompromissosCategorias" using primary key columns */
  usuariosCompromissosCategorias_by_pk?: Maybe<UsuariosCompromissosCategorias>;
  /** An array relationship */
  usuariosCompromissosFormasRecebimentos: Array<UsuariosCompromissosFormasRecebimentos>;
  /** fetch data from the table: "tbUsuariosCompromissosFormasRecebimentos" using primary key columns */
  usuariosCompromissosFormasRecebimentos_by_pk?: Maybe<UsuariosCompromissosFormasRecebimentos>;
  /** fetch data from the table: "tbUsuariosCompromissosModalidades" */
  usuariosCompromissosModalidades: Array<UsuariosCompromissosModalidades>;
  /** fetch aggregated fields from the table: "tbUsuariosCompromissosModalidades" */
  usuariosCompromissosModalidades_aggregate: UsuariosCompromissosModalidades_Aggregate;
  /** fetch data from the table: "tbUsuariosCompromissosModalidades" using primary key columns */
  usuariosCompromissosModalidades_by_pk?: Maybe<UsuariosCompromissosModalidades>;
  /** An array relationship */
  usuariosCompromissosTiposSalas: Array<UsuariosCompromissosTiposSalas>;
  /** An aggregate relationship */
  usuariosCompromissosTiposSalas_aggregate: UsuariosCompromissosTiposSalas_Aggregate;
  /** fetch data from the table: "tbUsuariosCompromissosTiposSalas" using primary key columns */
  usuariosCompromissosTiposSalas_by_pk?: Maybe<UsuariosCompromissosTiposSalas>;
  /** An aggregate relationship */
  usuariosCompromissos_aggregate: UsuariosCompromissos_Aggregate;
  /** fetch data from the table: "tbUsuariosCompromissos" using primary key columns */
  usuariosCompromissos_by_pk?: Maybe<UsuariosCompromissos>;
  /** fetch data from the table: "tbUsuariosEspecialidades" */
  usuariosEspecialidades: Array<UsuariosEspecialidades>;
  /** fetch data from the table: "tbUsuariosEspecialidades" using primary key columns */
  usuariosEspecialidades_by_pk?: Maybe<UsuariosEspecialidades>;
  /** fetch data from the table: "tbUsuariosFormasRecebimentos" */
  usuariosFormasRecebimentos: Array<UsuariosFormasRecebimentos>;
  /** fetch aggregated fields from the table: "tbUsuariosFormasRecebimentos" */
  usuariosFormasRecebimentos_aggregate: UsuariosFormasRecebimentos_Aggregate;
  /** fetch data from the table: "tbUsuariosFormasRecebimentos" using primary key columns */
  usuariosFormasRecebimentos_by_pk?: Maybe<UsuariosFormasRecebimentos>;
  /** fetch data from the table: "tbUsuariosLinksRastreamentos" */
  usuariosLinksRastreamentos: Array<UsuariosLinksRastreamentos>;
  /** fetch data from the table: "tbUsuariosLinksRastreamentos" using primary key columns */
  usuariosLinksRastreamentos_by_pk?: Maybe<UsuariosLinksRastreamentos>;
  /** An array relationship */
  usuariosMovimentacoesRecorrentes: Array<UsuariosMovimentacoesRecorrentes>;
  /** fetch data from the table: "tbUsuariosMovimentacoesRecorrentes" using primary key columns */
  usuariosMovimentacoesRecorrentes_by_pk?: Maybe<UsuariosMovimentacoesRecorrentes>;
  /** An array relationship */
  usuariosPacotesServicos: Array<UsuariosPacotesServicos>;
  /** fetch data from the table: "tbUsuariosPacotesServicos" using primary key columns */
  usuariosPacotesServicos_by_pk?: Maybe<UsuariosPacotesServicos>;
  /** An array relationship */
  usuariosProfissionais: Array<UsuariosProfissionais>;
  /** fetch data from the table: "tbUsuariosProfissionaisOrientacoesSecretarias" */
  usuariosProfissionaisOrientacoesSecretarias: Array<UsuariosProfissionaisOrientacoesSecretarias>;
  /** fetch data from the table: "tbUsuariosProfissionaisOrientacoesSecretarias" using primary key columns */
  usuariosProfissionaisOrientacoesSecretarias_by_pk?: Maybe<UsuariosProfissionaisOrientacoesSecretarias>;
  /** fetch data from the table: "tbUsuariosProfissionaisPlanos" */
  usuariosProfissionaisPlanos: Array<UsuariosProfissionaisPlanos>;
  /** fetch data from the table: "tbUsuariosProfissionaisPlanos" using primary key columns */
  usuariosProfissionaisPlanos_by_pk?: Maybe<UsuariosProfissionaisPlanos>;
  /** fetch data from the table: "tbUsuariosProfissionais" using primary key columns */
  usuariosProfissionais_by_pk?: Maybe<UsuariosProfissionais>;
  /** fetch data from the table: "tbUsuariosTelefones" */
  usuariosTelefones: Array<UsuariosTelefones>;
  /** fetch data from the table: "tbUsuariosTelefones" using primary key columns */
  usuariosTelefones_by_pk?: Maybe<UsuariosTelefones>;
  /** fetch data from the table: "tbUsuarios" using primary key columns */
  usuarios_by_pk?: Maybe<Usuarios>;
};


export type Subscription_RootAgendamentosAlocacoesAtivasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosAlocacoesAtivas_Order_By>>;
  where?: InputMaybe<AgendamentosAlocacoesAtivas_Bool_Exp>;
};


export type Subscription_RootAgendamentosAlocacoesAtivas_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
};


export type Subscription_RootPrecificacoesTiposSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PrecificacoesTiposSalas_Order_By>>;
  where?: InputMaybe<PrecificacoesTiposSalas_Bool_Exp>;
};


export type Subscription_RootPrecificacoesTiposSalas_By_PkArgs = {
  codPrecificacao: Scalars['Int']['input'];
};


export type Subscription_RootUnidadesPrecosFlexiveisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveis_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveis_Bool_Exp>;
};


export type Subscription_RootUnidadesPrecosFlexiveisParceirosIntegracoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveisParceirosIntegracoes_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp>;
};


export type Subscription_RootUnidadesPrecosFlexiveisParceirosIntegracoes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveisParceirosIntegracoes_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveisParceirosIntegracoes_Bool_Exp>;
};


export type Subscription_RootUnidadesPrecosFlexiveisParceirosIntegracoes_By_PkArgs = {
  codParceiroIntegracao: Scalars['Int']['input'];
  codUnidadePrecoFlexivel: Scalars['Int']['input'];
};


export type Subscription_RootUnidadesPrecosFlexiveis_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveis_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveis_Bool_Exp>;
};


export type Subscription_RootUnidadesPrecosFlexiveis_By_PkArgs = {
  codUnidadePrecoFlexivel: Scalars['Int']['input'];
};


export type Subscription_RootUnidadesSalasMotivosBloqueiosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalasMotivosBloqueios_Order_By>>;
  where?: InputMaybe<UnidadesSalasMotivosBloqueios_Bool_Exp>;
};


export type Subscription_RootUnidadesSalasMotivosBloqueios_By_PkArgs = {
  codUnidadeSalaMotivoBloqueio: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosArquivosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosArquivos_Order_By>>;
  where?: InputMaybe<UsuariosArquivos_Bool_Exp>;
};


export type Subscription_RootUsuariosArquivos_By_PkArgs = {
  codUsuarioArquivo: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosCompromissosStatusSugestoesDuracoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosStatusSugestoesDuracoes_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosStatusSugestoesDuracoes_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissosStatusSugestoesDuracoes_By_PkArgs = {
  codUsuarioCompromisso: Scalars['Int']['input'];
};


export type Subscription_RootAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


export type Subscription_RootAgendamentosAlocacoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosAlocacoes_Order_By>>;
  where?: InputMaybe<AgendamentosAlocacoes_Bool_Exp>;
};


export type Subscription_RootAgendamentosAlocacoes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosAlocacoes_Order_By>>;
  where?: InputMaybe<AgendamentosAlocacoes_Bool_Exp>;
};


export type Subscription_RootAgendamentosAlocacoes_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
  codUnidadeSala: Scalars['Int']['input'];
};


export type Subscription_RootAgendamentosPreAlocacaoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosPreAlocacao_Order_By>>;
  where?: InputMaybe<AgendamentosPreAlocacao_Bool_Exp>;
};


export type Subscription_RootAgendamentosPreAlocacao_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosPreAlocacao_Order_By>>;
  where?: InputMaybe<AgendamentosPreAlocacao_Bool_Exp>;
};


export type Subscription_RootAgendamentosPreAlocacao_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
};


export type Subscription_RootAgendamentosTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosTags_Order_By>>;
  where?: InputMaybe<AgendamentosTags_Bool_Exp>;
};


export type Subscription_RootAgendamentosTags_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
  codAgendamentoTipoTag: Scalars['Int']['input'];
};


export type Subscription_RootAgendamentosTiposTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AgendamentosTiposTags_Order_By>>;
  where?: InputMaybe<AgendamentosTiposTags_Bool_Exp>;
};


export type Subscription_RootAgendamentosTiposTags_By_PkArgs = {
  codAgendamentoTipoTag: Scalars['Int']['input'];
};


export type Subscription_RootAgendamentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


export type Subscription_RootAgendamentos_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
};


export type Subscription_RootCanaisAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CanaisAgendamentos_Order_By>>;
  where?: InputMaybe<CanaisAgendamentos_Bool_Exp>;
};


export type Subscription_RootCanaisAgendamentos_By_PkArgs = {
  codCanalAgendamento: Scalars['Int']['input'];
};


export type Subscription_RootCobrancasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cobrancas_Order_By>>;
  where?: InputMaybe<Cobrancas_Bool_Exp>;
};


export type Subscription_RootCsatCategoriasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CsatCategorias_Order_By>>;
  where?: InputMaybe<CsatCategorias_Bool_Exp>;
};


export type Subscription_RootCsatCategoriasNotasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CsatCategoriasNotas_Order_By>>;
  where?: InputMaybe<CsatCategoriasNotas_Bool_Exp>;
};


export type Subscription_RootCsatCategoriasNotas_By_PkArgs = {
  codCsatCategoria: Scalars['Int']['input'];
  nota: Scalars['Int']['input'];
};


export type Subscription_RootCsatCategorias_By_PkArgs = {
  codCsatCategoria: Scalars['Int']['input'];
};


export type Subscription_RootEspecialidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Especialidades_Order_By>>;
  where?: InputMaybe<Especialidades_Bool_Exp>;
};


export type Subscription_RootEspecialidades_By_PkArgs = {
  codEspecialidade: Scalars['Int']['input'];
};


export type Subscription_RootExpensum_Appointment_PaidArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Appointment_Paid_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Appointment_Paid_Order_By>>;
  where?: InputMaybe<Expensum_Appointment_Paid_Bool_Exp>;
};


export type Subscription_RootExpensum_Appointment_Paid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Appointment_Paid_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Appointment_Paid_Order_By>>;
  where?: InputMaybe<Expensum_Appointment_Paid_Bool_Exp>;
};


export type Subscription_RootExpensum_Appointment_Paid_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Expensum_Appointment_Paid_Stream_Cursor_Input>>;
  where?: InputMaybe<Expensum_Appointment_Paid_Bool_Exp>;
};


export type Subscription_RootExpensum_Event_Automatic_Anticipation_Settings_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Event_Automatic_Anticipation_Settings_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Event_Automatic_Anticipation_Settings_Update_Order_By>>;
  where?: InputMaybe<Expensum_Event_Automatic_Anticipation_Settings_Update_Bool_Exp>;
};


export type Subscription_RootExpensum_Event_Automatic_Anticipation_Settings_Update_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExpensum_Event_Automatic_Anticipation_Settings_Update_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Expensum_Event_Automatic_Anticipation_Settings_Update_Stream_Cursor_Input>>;
  where?: InputMaybe<Expensum_Event_Automatic_Anticipation_Settings_Update_Bool_Exp>;
};


export type Subscription_RootExpensum_Event_Bank_Account_UpdateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Event_Bank_Account_Update_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Event_Bank_Account_Update_Order_By>>;
  where?: InputMaybe<Expensum_Event_Bank_Account_Update_Bool_Exp>;
};


export type Subscription_RootExpensum_Event_Bank_Account_Update_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExpensum_Event_Bank_Account_Update_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Expensum_Event_Bank_Account_Update_Stream_Cursor_Input>>;
  where?: InputMaybe<Expensum_Event_Bank_Account_Update_Bool_Exp>;
};


export type Subscription_RootExpensum_Event_Totem_Payment_SentArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Order_By>>;
  where?: InputMaybe<Expensum_Event_Totem_Payment_Sent_Bool_Exp>;
};


export type Subscription_RootExpensum_Event_Totem_Payment_Sent_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Event_Totem_Payment_Sent_Order_By>>;
  where?: InputMaybe<Expensum_Event_Totem_Payment_Sent_Bool_Exp>;
};


export type Subscription_RootExpensum_Event_Totem_Payment_Sent_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExpensum_Event_Totem_Payment_Sent_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Expensum_Event_Totem_Payment_Sent_Stream_Cursor_Input>>;
  where?: InputMaybe<Expensum_Event_Totem_Payment_Sent_Bool_Exp>;
};


export type Subscription_RootExpensum_Online_PaymentArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
};


export type Subscription_RootExpensum_Online_Payment_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Activity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Activity_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Activity_Bool_Exp>;
};


export type Subscription_RootExpensum_Online_Payment_Activity_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Expensum_Online_Payment_Activity_Stream_Cursor_Input>>;
  where?: InputMaybe<Expensum_Online_Payment_Activity_Bool_Exp>;
};


export type Subscription_RootExpensum_Online_Payment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
};


export type Subscription_RootExpensum_Online_Payment_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExpensum_Online_Payment_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Expensum_Online_Payment_Stream_Cursor_Input>>;
  where?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
};


export type Subscription_RootExpensum_Payment_TypeArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Payment_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Payment_Type_Order_By>>;
  where?: InputMaybe<Expensum_Payment_Type_Bool_Exp>;
};


export type Subscription_RootExpensum_Payment_Type_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExpensum_Payment_Type_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Expensum_Payment_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Expensum_Payment_Type_Bool_Exp>;
};


export type Subscription_RootExpensum_Recipient_Terms_Of_Use_AgreedArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Recipient_Terms_Of_Use_Agreed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Recipient_Terms_Of_Use_Agreed_Order_By>>;
  where?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Bool_Exp>;
};


export type Subscription_RootExpensum_Recipient_Terms_Of_Use_Agreed_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExpensum_Recipient_Terms_Of_Use_Agreed_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Stream_Cursor_Input>>;
  where?: InputMaybe<Expensum_Recipient_Terms_Of_Use_Agreed_Bool_Exp>;
};


export type Subscription_RootExpensum_Terms_Of_UseArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Terms_Of_Use_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Terms_Of_Use_Order_By>>;
  where?: InputMaybe<Expensum_Terms_Of_Use_Bool_Exp>;
};


export type Subscription_RootExpensum_Terms_Of_Use_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootExpensum_Terms_Of_Use_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Expensum_Terms_Of_Use_Stream_Cursor_Input>>;
  where?: InputMaybe<Expensum_Terms_Of_Use_Bool_Exp>;
};


export type Subscription_RootFinalidadesAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FinalidadesAgendamentos_Order_By>>;
  where?: InputMaybe<FinalidadesAgendamentos_Bool_Exp>;
};


export type Subscription_RootFinalidadesAgendamentos_By_PkArgs = {
  codFinalidadeAgendamento: Scalars['Int']['input'];
};


export type Subscription_RootFuncionalidadesDesativadasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FuncionalidadesDesativadas_Order_By>>;
  where?: InputMaybe<FuncionalidadesDesativadas_Bool_Exp>;
};


export type Subscription_RootFuncionalidadesDesativadas_By_PkArgs = {
  codFuncionalidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
};


export type Subscription_RootLembretesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lembretes_Order_By>>;
  where?: InputMaybe<Lembretes_Bool_Exp>;
};


export type Subscription_RootLembretes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lembretes_Order_By>>;
  where?: InputMaybe<Lembretes_Bool_Exp>;
};


export type Subscription_RootLembretes_By_PkArgs = {
  codLembrete: Scalars['Int']['input'];
};


export type Subscription_RootLinksDestinosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<LinksDestinos_Order_By>>;
  where?: InputMaybe<LinksDestinos_Bool_Exp>;
};


export type Subscription_RootLinksDestinos_By_PkArgs = {
  codLinkDestino: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Conselho_ProfissionalArgs = {
  distinct_on?: InputMaybe<Array<Locus_Conselho_Profissional_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Conselho_Profissional_Order_By>>;
  where?: InputMaybe<Locus_Conselho_Profissional_Bool_Exp>;
};


export type Subscription_RootLocus_Conselho_Profissional_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Conselho_Profissional_EspecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Conselho_Profissional_Especialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Conselho_Profissional_Especialidade_Order_By>>;
  where?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Conselho_Profissional_Especialidade_By_PkArgs = {
  idConselhoProfissional: Scalars['Int']['input'];
  idEspecialidade: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Conselho_Profissional_Especialidade_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Conselho_Profissional_Especialidade_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Conselho_Profissional_Especialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Conselho_Profissional_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Conselho_Profissional_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Conselho_Profissional_Bool_Exp>;
};


export type Subscription_RootLocus_Curso_FormacaoArgs = {
  distinct_on?: InputMaybe<Array<Locus_Curso_Formacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Curso_Formacao_Order_By>>;
  where?: InputMaybe<Locus_Curso_Formacao_Bool_Exp>;
};


export type Subscription_RootLocus_Curso_Formacao_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Curso_Formacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Curso_Formacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Curso_Formacao_Bool_Exp>;
};


export type Subscription_RootLocus_EspecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Especialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Especialidade_Order_By>>;
  where?: InputMaybe<Locus_Especialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Especialidade_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Especialidade_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Especialidade_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Especialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Especialidade_SubespecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Especialidade_Subespecialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Especialidade_Subespecialidade_Order_By>>;
  where?: InputMaybe<Locus_Especialidade_Subespecialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Especialidade_Subespecialidade_By_PkArgs = {
  idEspecialidade: Scalars['Int']['input'];
  idSubespecialidade: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Especialidade_Subespecialidade_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Especialidade_Subespecialidade_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Especialidade_Subespecialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Experiencia_MembroArgs = {
  distinct_on?: InputMaybe<Array<Locus_Experiencia_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Experiencia_Membro_Order_By>>;
  where?: InputMaybe<Locus_Experiencia_Membro_Bool_Exp>;
};


export type Subscription_RootLocus_Experiencia_Membro_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Experiencia_Membro_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Experiencia_Membro_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Experiencia_Membro_Bool_Exp>;
};


export type Subscription_RootLocus_Faq_MembroArgs = {
  distinct_on?: InputMaybe<Array<Locus_Faq_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Faq_Membro_Order_By>>;
  where?: InputMaybe<Locus_Faq_Membro_Bool_Exp>;
};


export type Subscription_RootLocus_Faq_Membro_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Faq_Membro_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Faq_Membro_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Faq_Membro_Bool_Exp>;
};


export type Subscription_RootLocus_Foco_Tratamento_MembroArgs = {
  distinct_on?: InputMaybe<Array<Locus_Foco_Tratamento_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Foco_Tratamento_Membro_Order_By>>;
  where?: InputMaybe<Locus_Foco_Tratamento_Membro_Bool_Exp>;
};


export type Subscription_RootLocus_Foco_Tratamento_Membro_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Foco_Tratamento_Membro_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Foco_Tratamento_Membro_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Foco_Tratamento_Membro_Bool_Exp>;
};


export type Subscription_RootLocus_Instituicao_EnsinoArgs = {
  distinct_on?: InputMaybe<Array<Locus_Instituicao_Ensino_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Instituicao_Ensino_Order_By>>;
  where?: InputMaybe<Locus_Instituicao_Ensino_Bool_Exp>;
};


export type Subscription_RootLocus_Instituicao_Ensino_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Instituicao_Ensino_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Instituicao_Ensino_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Instituicao_Ensino_Bool_Exp>;
};


export type Subscription_RootLocus_Instituicao_MedicaArgs = {
  distinct_on?: InputMaybe<Array<Locus_Instituicao_Medica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Instituicao_Medica_Order_By>>;
  where?: InputMaybe<Locus_Instituicao_Medica_Bool_Exp>;
};


export type Subscription_RootLocus_Instituicao_Medica_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Instituicao_Medica_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Instituicao_Medica_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Instituicao_Medica_Bool_Exp>;
};


export type Subscription_RootLocus_MembroArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Order_By>>;
  where?: InputMaybe<Locus_Membro_Bool_Exp>;
};


export type Subscription_RootLocus_Membro_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Membro_EspecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Especialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Especialidade_Order_By>>;
  where?: InputMaybe<Locus_Membro_Especialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Membro_Especialidade_By_PkArgs = {
  idEspecialidade: Scalars['Int']['input'];
  idMembro: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Membro_Especialidade_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Membro_Especialidade_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Membro_Especialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Membro_Especialidade_SubespecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Especialidade_Subespecialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Especialidade_Subespecialidade_Order_By>>;
  where?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Membro_Especialidade_Subespecialidade_By_PkArgs = {
  idMembro: Scalars['Int']['input'];
  idSubespecialidade: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Membro_Especialidade_Subespecialidade_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Membro_Especialidade_Subespecialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Membro_FormacaoArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Formacao_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Formacao_Order_By>>;
  where?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
};


export type Subscription_RootLocus_Membro_Formacao_By_PkArgs = {
  idCurso: Scalars['Int']['input'];
  idInstituicaoEnsino: Scalars['Int']['input'];
  idMembro: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Membro_Formacao_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Membro_Formacao_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Membro_Formacao_Bool_Exp>;
};


export type Subscription_RootLocus_Membro_Instituicao_MedicaArgs = {
  distinct_on?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Order_By>>;
  where?: InputMaybe<Locus_Membro_Instituicao_Medica_Bool_Exp>;
};


export type Subscription_RootLocus_Membro_Instituicao_Medica_By_PkArgs = {
  idInstituicaoMedica: Scalars['Int']['input'];
  idMembro: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Membro_Instituicao_Medica_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Membro_Instituicao_Medica_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Membro_Instituicao_Medica_Bool_Exp>;
};


export type Subscription_RootLocus_Membro_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Membro_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Membro_Bool_Exp>;
};


export type Subscription_RootLocus_Rede_Social_MembroArgs = {
  distinct_on?: InputMaybe<Array<Locus_Rede_Social_Membro_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Rede_Social_Membro_Order_By>>;
  where?: InputMaybe<Locus_Rede_Social_Membro_Bool_Exp>;
};


export type Subscription_RootLocus_Rede_Social_Membro_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Rede_Social_Membro_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Rede_Social_Membro_Bool_Exp>;
};


export type Subscription_RootLocus_SubespecialidadeArgs = {
  distinct_on?: InputMaybe<Array<Locus_Subespecialidade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locus_Subespecialidade_Order_By>>;
  where?: InputMaybe<Locus_Subespecialidade_Bool_Exp>;
};


export type Subscription_RootLocus_Subespecialidade_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootLocus_Subespecialidade_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locus_Subespecialidade_Stream_Cursor_Input>>;
  where?: InputMaybe<Locus_Subespecialidade_Bool_Exp>;
};


export type Subscription_RootNexus_FollowArgs = {
  distinct_on?: InputMaybe<Array<Nexus_Follow_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nexus_Follow_Order_By>>;
  where?: InputMaybe<Nexus_Follow_Bool_Exp>;
};


export type Subscription_RootNexus_Follow_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNexus_Follow_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nexus_Follow_Stream_Cursor_Input>>;
  where?: InputMaybe<Nexus_Follow_Bool_Exp>;
};


export type Subscription_RootNotificacoesPacientesAtrasadosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificacoesPacientesAtrasados_Order_By>>;
  where?: InputMaybe<NotificacoesPacientesAtrasados_Bool_Exp>;
};


export type Subscription_RootNotificacoesPacientesAtrasados_By_PkArgs = {
  codNotificacaoPacienteAtrasado: Scalars['Int']['input'];
};


export type Subscription_RootNuntius_Contatos_Por_DiaArgs = {
  distinct_on?: InputMaybe<Array<Nuntius_Contatos_Por_Dia_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nuntius_Contatos_Por_Dia_Order_By>>;
  where?: InputMaybe<Nuntius_Contatos_Por_Dia_Bool_Exp>;
};


export type Subscription_RootNuntius_Contatos_Por_Dia_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nuntius_Contatos_Por_Dia_Stream_Cursor_Input>>;
  where?: InputMaybe<Nuntius_Contatos_Por_Dia_Bool_Exp>;
};


export type Subscription_RootNuntius_Lote_Contatos_CobrancaArgs = {
  distinct_on?: InputMaybe<Array<Nuntius_Lote_Contatos_Cobranca_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nuntius_Lote_Contatos_Cobranca_Order_By>>;
  where?: InputMaybe<Nuntius_Lote_Contatos_Cobranca_Bool_Exp>;
};


export type Subscription_RootNuntius_Lote_Contatos_Cobranca_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootNuntius_Lote_Contatos_Cobranca_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nuntius_Lote_Contatos_Cobranca_Stream_Cursor_Input>>;
  where?: InputMaybe<Nuntius_Lote_Contatos_Cobranca_Bool_Exp>;
};


export type Subscription_RootPacientesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pacientes_Order_By>>;
  where?: InputMaybe<Pacientes_Bool_Exp>;
};


export type Subscription_RootPacientes_By_PkArgs = {
  codPaciente: Scalars['Int']['input'];
};


export type Subscription_RootPacoteServicoPrecoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PacoteServicoPreco_Order_By>>;
  where?: InputMaybe<PacoteServicoPreco_Bool_Exp>;
};


export type Subscription_RootPacoteServicoPreco_By_PkArgs = {
  codPacoteServicosPreco: Scalars['Int']['input'];
};


export type Subscription_RootPacotesServicosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PacotesServicos_Order_By>>;
  where?: InputMaybe<PacotesServicos_Bool_Exp>;
};


export type Subscription_RootPacotesServicos_By_PkArgs = {
  codPacoteServicos: Scalars['Int']['input'];
};


export type Subscription_RootPlanosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planos_Order_By>>;
  where?: InputMaybe<Planos_Bool_Exp>;
};


export type Subscription_RootPlanosMigracoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PlanosMigracoes_Order_By>>;
  where?: InputMaybe<PlanosMigracoes_Bool_Exp>;
};


export type Subscription_RootPlanos_By_PkArgs = {
  codPlano: Scalars['Int']['input'];
};


export type Subscription_RootReferralsArgs = {
  distinct_on?: InputMaybe<Array<Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Referrals_Order_By>>;
  where?: InputMaybe<Referrals_Bool_Exp>;
};


export type Subscription_RootReferrals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Referrals_Stream_Cursor_Input>>;
  where?: InputMaybe<Referrals_Bool_Exp>;
};


export type Subscription_RootTbAgendamentosCheckinsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbAgendamentosCheckins_Order_By>>;
  where?: InputMaybe<TbAgendamentosCheckins_Bool_Exp>;
};


export type Subscription_RootTbAgendamentosCheckins_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbAgendamentosCheckins_Order_By>>;
  where?: InputMaybe<TbAgendamentosCheckins_Bool_Exp>;
};


export type Subscription_RootTbAgendamentosCheckins_By_PkArgs = {
  codAgendamento: Scalars['Int']['input'];
};


export type Subscription_RootTbAgendamentosVinculadosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbAgendamentosVinculados_Order_By>>;
  where?: InputMaybe<TbAgendamentosVinculados_Bool_Exp>;
};


export type Subscription_RootTbAgendamentosVinculados_By_PkArgs = {
  codAgendamentoPrincipal: Scalars['Int']['input'];
  codAgendamentoVinculado: Scalars['Int']['input'];
};


export type Subscription_RootTbClinicasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbClinicas_Order_By>>;
  where?: InputMaybe<TbClinicas_Bool_Exp>;
};


export type Subscription_RootTbClinicas_By_PkArgs = {
  codClinica: Scalars['Int']['input'];
};


export type Subscription_RootTbFechamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbFechamentos_Order_By>>;
  where?: InputMaybe<TbFechamentos_Bool_Exp>;
};


export type Subscription_RootTbFechamentos_By_PkArgs = {
  codFechamento: Scalars['Int']['input'];
};


export type Subscription_RootTbFeriadosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbFeriados_Order_By>>;
  where?: InputMaybe<TbFeriados_Bool_Exp>;
};


export type Subscription_RootTbFeriados_By_PkArgs = {
  codFeriado: Scalars['Int']['input'];
};


export type Subscription_RootTbMovimentacoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbMovimentacoes_Order_By>>;
  where?: InputMaybe<TbMovimentacoes_Bool_Exp>;
};


export type Subscription_RootTbMovimentacoes_By_PkArgs = {
  codMovimentacao: Scalars['Int']['input'];
};


export type Subscription_RootTbPacotesServicosPrecosVariaveisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPacotesServicosPrecosVariaveis_Order_By>>;
  where?: InputMaybe<TbPacotesServicosPrecosVariaveis_Bool_Exp>;
};


export type Subscription_RootTbPacotesServicosPrecosVariaveis_By_PkArgs = {
  codPacoteServicosPrecoVariavel: Scalars['Int']['input'];
};


export type Subscription_RootTbPeriodosGarantidosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidos_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
};


export type Subscription_RootTbPeriodosGarantidosRecorrentesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidosRecorrentes_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidosRecorrentes_Bool_Exp>;
};


export type Subscription_RootTbPeriodosGarantidosRecorrentesFrequenciasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidosRecorrentesFrequencias_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidosRecorrentesFrequencias_Bool_Exp>;
};


export type Subscription_RootTbPeriodosGarantidosRecorrentesFrequencias_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidosRecorrentesFrequencias_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidosRecorrentesFrequencias_Bool_Exp>;
};


export type Subscription_RootTbPeriodosGarantidosRecorrentesFrequencias_By_PkArgs = {
  codPeriodoGarantidoRecorrenteFrequencia: Scalars['Int']['input'];
};


export type Subscription_RootTbPeriodosGarantidosRecorrentes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidosRecorrentes_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidosRecorrentes_Bool_Exp>;
};


export type Subscription_RootTbPeriodosGarantidosRecorrentes_By_PkArgs = {
  codPeriodoGarantidoRecorrente: Scalars['Int']['input'];
};


export type Subscription_RootTbPeriodosGarantidos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidos_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
};


export type Subscription_RootTbPeriodosGarantidos_By_PkArgs = {
  codPeriodoGarantido: Scalars['Int']['input'];
};


export type Subscription_RootTbTipoPacotesServicosPrecoVariavelArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbTipoPacotesServicosPrecoVariavel_Order_By>>;
  where?: InputMaybe<TbTipoPacotesServicosPrecoVariavel_Bool_Exp>;
};


export type Subscription_RootTbTipoPacotesServicosPrecoVariavel_By_PkArgs = {
  codTipoPacoteServicosPrecoVariavel: Scalars['Int']['input'];
};


export type Subscription_RootTbUsuariosAgendasDiasSemanasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbUsuariosAgendasDiasSemanas_Order_By>>;
  where?: InputMaybe<TbUsuariosAgendasDiasSemanas_Bool_Exp>;
};


export type Subscription_RootTbUsuariosIntegracoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbUsuariosIntegracoes_Order_By>>;
  where?: InputMaybe<TbUsuariosIntegracoes_Bool_Exp>;
};


export type Subscription_RootTbUsuariosIntegracoes_By_PkArgs = {
  codParceiroIntegracao: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
};


export type Subscription_RootTbUsuariosTermosDeUsoArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbUsuariosTermosDeUso_Order_By>>;
  where?: InputMaybe<TbUsuariosTermosDeUso_Bool_Exp>;
};


export type Subscription_RootTbUsuariosTermosDeUso_By_PkArgs = {
  codTermosDeUso: Scalars['Int']['input'];
};


export type Subscription_RootTerms_Of_UseArgs = {
  distinct_on?: InputMaybe<Array<Terms_Of_Use_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Terms_Of_Use_Order_By>>;
  where?: InputMaybe<Terms_Of_Use_Bool_Exp>;
};


export type Subscription_RootTerms_Of_Use_By_PkArgs = {
  file: Scalars['String']['input'];
};


export type Subscription_RootTerms_Of_Use_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Terms_Of_Use_Stream_Cursor_Input>>;
  where?: InputMaybe<Terms_Of_Use_Bool_Exp>;
};


export type Subscription_RootTiposAgendasRepeticoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposAgendasRepeticoes_Order_By>>;
  where?: InputMaybe<TiposAgendasRepeticoes_Bool_Exp>;
};


export type Subscription_RootTiposAgendasRepeticoes_By_PkArgs = {
  codTipoAgendaRepeticao: Scalars['Int']['input'];
};


export type Subscription_RootTiposConveniosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposConvenios_Order_By>>;
  where?: InputMaybe<TiposConvenios_Bool_Exp>;
};


export type Subscription_RootTiposConvenios_By_PkArgs = {
  codTipoConvenio: Scalars['Int']['input'];
};


export type Subscription_RootTiposFormasRecebimentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposFormasRecebimentos_Order_By>>;
  where?: InputMaybe<TiposFormasRecebimentos_Bool_Exp>;
};


export type Subscription_RootTiposFormasRecebimentos_By_PkArgs = {
  codTipoFormaRecebimento: Scalars['Int']['input'];
};


export type Subscription_RootTiposMovimentacoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposMovimentacoes_Order_By>>;
  where?: InputMaybe<TiposMovimentacoes_Bool_Exp>;
};


export type Subscription_RootTiposMovimentacoes_By_PkArgs = {
  codTipoMovimentacao: Scalars['Int']['input'];
};


export type Subscription_RootTiposPlanosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposPlanos_Order_By>>;
  where?: InputMaybe<TiposPlanos_Bool_Exp>;
};


export type Subscription_RootTiposPlanos_By_PkArgs = {
  codTipoPlano: Scalars['Int']['input'];
};


export type Subscription_RootTiposSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TiposSalas_Order_By>>;
  where?: InputMaybe<TiposSalas_Bool_Exp>;
};


export type Subscription_RootTiposSalas_By_PkArgs = {
  codTipoSala: Scalars['Int']['input'];
};


export type Subscription_RootUnidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Unidades_Order_By>>;
  where?: InputMaybe<Unidades_Bool_Exp>;
};


export type Subscription_RootUnidadesHorariosFuncionamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesHorariosFuncionamentos_Order_By>>;
  where?: InputMaybe<UnidadesHorariosFuncionamentos_Bool_Exp>;
};


export type Subscription_RootUnidadesHorariosFuncionamentos_By_PkArgs = {
  codUnidadeHorarioFuncionamento: Scalars['Int']['input'];
};


export type Subscription_RootUnidadesPoliticasDeHorariosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPoliticasDeHorarios_Order_By>>;
  where?: InputMaybe<UnidadesPoliticasDeHorarios_Bool_Exp>;
};


export type Subscription_RootUnidadesPoliticasDeHorarios_By_PkArgs = {
  codUnidadePoliticaDeHorario: Scalars['Int']['input'];
};


export type Subscription_RootUnidadesSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalas_Order_By>>;
  where?: InputMaybe<UnidadesSalas_Bool_Exp>;
};


export type Subscription_RootUnidadesSalasPeriodosBloqueadosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalasPeriodosBloqueados_Order_By>>;
  where?: InputMaybe<UnidadesSalasPeriodosBloqueados_Bool_Exp>;
};


export type Subscription_RootUnidadesSalasPeriodosBloqueados_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalasPeriodosBloqueados_Order_By>>;
  where?: InputMaybe<UnidadesSalasPeriodosBloqueados_Bool_Exp>;
};


export type Subscription_RootUnidadesSalasPeriodosBloqueados_By_PkArgs = {
  codUnidadeSalaPeriodoBloqueado: Scalars['Int']['input'];
};


export type Subscription_RootUnidadesSalas_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalas_Order_By>>;
  where?: InputMaybe<UnidadesSalas_Bool_Exp>;
};


export type Subscription_RootUnidadesSalas_By_PkArgs = {
  codUnidadeSala: Scalars['Int']['input'];
};


export type Subscription_RootUnidades_By_PkArgs = {
  codUnidade: Scalars['Int']['input'];
};


export type Subscription_RootUnitsArgs = {
  distinct_on?: InputMaybe<Array<Units_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Units_Order_By>>;
  where?: InputMaybe<Units_Bool_Exp>;
};


export type Subscription_RootUnits_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUnits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Units_Stream_Cursor_Input>>;
  where?: InputMaybe<Units_Bool_Exp>;
};


export type Subscription_RootUser_AddressesArgs = {
  distinct_on?: InputMaybe<Array<User_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Addresses_Order_By>>;
  where?: InputMaybe<User_Addresses_Bool_Exp>;
};


export type Subscription_RootUser_Addresses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Addresses_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUsers_Professional_CardsArgs = {
  distinct_on?: InputMaybe<Array<Users_Professional_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Professional_Cards_Order_By>>;
  where?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
};


export type Subscription_RootUsers_Professional_Cards_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Professional_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Professional_Cards_Order_By>>;
  where?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
};


export type Subscription_RootUsers_Professional_Cards_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUsers_Professional_Cards_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Professional_Cards_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
};


export type Subscription_RootUsers_ProviderArgs = {
  distinct_on?: InputMaybe<Array<Users_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Provider_Order_By>>;
  where?: InputMaybe<Users_Provider_Bool_Exp>;
};


export type Subscription_RootUsers_Provider_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Provider_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Provider_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_Terms_Of_Use_AgreedArgs = {
  distinct_on?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Order_By>>;
  where?: InputMaybe<Users_Terms_Of_Use_Agreed_Bool_Exp>;
};


export type Subscription_RootUsers_Terms_Of_Use_Agreed_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUsers_Terms_Of_Use_Agreed_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Terms_Of_Use_Agreed_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Terms_Of_Use_Agreed_Bool_Exp>;
};


export type Subscription_RootUsuariosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Usuarios_Order_By>>;
  where?: InputMaybe<Usuarios_Bool_Exp>;
};


export type Subscription_RootUsuariosAgendasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendas_Order_By>>;
  where?: InputMaybe<UsuariosAgendas_Bool_Exp>;
};


export type Subscription_RootUsuariosAgendasCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosAgendasCompromissos_Bool_Exp>;
};


export type Subscription_RootUsuariosAgendasUnidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasUnidades_Order_By>>;
  where?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
};


export type Subscription_RootUsuariosAgendasUnidades_By_PkArgs = {
  codUnidade: Scalars['Int']['input'];
  codUsuarioAgenda: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosAgendas_By_PkArgs = {
  codUsuarioAgenda: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosCartoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCartoes_Order_By>>;
  where?: InputMaybe<UsuariosCartoes_Bool_Exp>;
};


export type Subscription_RootUsuariosCartoes_By_PkArgs = {
  codUsuarioCartao: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissosCanaisAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosCanaisAgendamentos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissosCanaisAgendamentos_By_PkArgs = {
  codCanalAgendamento: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosCompromissosCategoriasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosCategorias_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosCategorias_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissosCategorias_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosCategorias_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosCategorias_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissosCategorias_By_PkArgs = {
  codUsuarioCompromissoCategoria: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosCompromissosFormasRecebimentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosFormasRecebimentos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissosFormasRecebimentos_By_PkArgs = {
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosCompromissosModalidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosModalidades_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosModalidades_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissosModalidades_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosModalidades_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosModalidades_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissosModalidades_By_PkArgs = {
  codUsuarioCompromissoModalidade: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosCompromissosTiposSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissosTiposSalas_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissosTiposSalas_By_PkArgs = {
  codTipoSala: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosCompromissos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};


export type Subscription_RootUsuariosCompromissos_By_PkArgs = {
  codUsuarioCompromisso: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosEspecialidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosEspecialidades_Order_By>>;
  where?: InputMaybe<UsuariosEspecialidades_Bool_Exp>;
};


export type Subscription_RootUsuariosEspecialidades_By_PkArgs = {
  codEspecialidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosFormasRecebimentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosFormasRecebimentos_Order_By>>;
  where?: InputMaybe<UsuariosFormasRecebimentos_Bool_Exp>;
};


export type Subscription_RootUsuariosFormasRecebimentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosFormasRecebimentos_Order_By>>;
  where?: InputMaybe<UsuariosFormasRecebimentos_Bool_Exp>;
};


export type Subscription_RootUsuariosFormasRecebimentos_By_PkArgs = {
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosLinksRastreamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosLinksRastreamentos_Order_By>>;
  where?: InputMaybe<UsuariosLinksRastreamentos_Bool_Exp>;
};


export type Subscription_RootUsuariosLinksRastreamentos_By_PkArgs = {
  codUsuarioLinkRastreamento: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosMovimentacoesRecorrentesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosMovimentacoesRecorrentes_Order_By>>;
  where?: InputMaybe<UsuariosMovimentacoesRecorrentes_Bool_Exp>;
};


export type Subscription_RootUsuariosMovimentacoesRecorrentes_By_PkArgs = {
  codUsuarioMovimentacaoRecorrente: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosPacotesServicosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosPacotesServicos_Order_By>>;
  where?: InputMaybe<UsuariosPacotesServicos_Bool_Exp>;
};


export type Subscription_RootUsuariosPacotesServicos_By_PkArgs = {
  codUsuarioPacoteServicos: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosProfissionaisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosProfissionais_Order_By>>;
  where?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};


export type Subscription_RootUsuariosProfissionaisOrientacoesSecretariasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosProfissionaisOrientacoesSecretarias_Order_By>>;
  where?: InputMaybe<UsuariosProfissionaisOrientacoesSecretarias_Bool_Exp>;
};


export type Subscription_RootUsuariosProfissionaisOrientacoesSecretarias_By_PkArgs = {
  codUsuario: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosProfissionaisPlanosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosProfissionaisPlanos_Order_By>>;
  where?: InputMaybe<UsuariosProfissionaisPlanos_Bool_Exp>;
};


export type Subscription_RootUsuariosProfissionaisPlanos_By_PkArgs = {
  codUsuarioProfissionalPlano: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosProfissionais_By_PkArgs = {
  codUsuario: Scalars['Int']['input'];
};


export type Subscription_RootUsuariosTelefonesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosTelefones_Order_By>>;
  where?: InputMaybe<UsuariosTelefones_Bool_Exp>;
};


export type Subscription_RootUsuariosTelefones_By_PkArgs = {
  codUsuarioTelefone: Scalars['Int']['input'];
};


export type Subscription_RootUsuarios_By_PkArgs = {
  codUsuario: Scalars['Int']['input'];
};

/** columns and relationships of "tbAgendamentosCheckins" */
export type TbAgendamentosCheckins = {
  __typename?: 'tbAgendamentosCheckins';
  /** An object relationship */
  agendamento: Agendamentos;
  codAgendamento: Scalars['Int']['output'];
  dataCheckin: Scalars['datetime']['output'];
};

/** aggregated selection of "tbAgendamentosCheckins" */
export type TbAgendamentosCheckins_Aggregate = {
  __typename?: 'tbAgendamentosCheckins_aggregate';
  aggregate?: Maybe<TbAgendamentosCheckins_Aggregate_Fields>;
  nodes: Array<TbAgendamentosCheckins>;
};

/** aggregate fields of "tbAgendamentosCheckins" */
export type TbAgendamentosCheckins_Aggregate_Fields = {
  __typename?: 'tbAgendamentosCheckins_aggregate_fields';
  avg?: Maybe<TbAgendamentosCheckins_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TbAgendamentosCheckins_Max_Fields>;
  min?: Maybe<TbAgendamentosCheckins_Min_Fields>;
  stddev?: Maybe<TbAgendamentosCheckins_Stddev_Fields>;
  stddev_pop?: Maybe<TbAgendamentosCheckins_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TbAgendamentosCheckins_Stddev_Samp_Fields>;
  sum?: Maybe<TbAgendamentosCheckins_Sum_Fields>;
  var_pop?: Maybe<TbAgendamentosCheckins_Var_Pop_Fields>;
  var_samp?: Maybe<TbAgendamentosCheckins_Var_Samp_Fields>;
  variance?: Maybe<TbAgendamentosCheckins_Variance_Fields>;
};


/** aggregate fields of "tbAgendamentosCheckins" */
export type TbAgendamentosCheckins_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<TbAgendamentosCheckins_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TbAgendamentosCheckins_Avg_Fields = {
  __typename?: 'tbAgendamentosCheckins_avg_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tbAgendamentosCheckins". All fields are combined with a logical 'AND'. */
export type TbAgendamentosCheckins_Bool_Exp = {
  _and?: InputMaybe<Array<TbAgendamentosCheckins_Bool_Exp>>;
  _not?: InputMaybe<TbAgendamentosCheckins_Bool_Exp>;
  _or?: InputMaybe<Array<TbAgendamentosCheckins_Bool_Exp>>;
  agendamento?: InputMaybe<Agendamentos_Bool_Exp>;
  codAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCheckin?: InputMaybe<Datetime_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type TbAgendamentosCheckins_Max_Fields = {
  __typename?: 'tbAgendamentosCheckins_max_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  dataCheckin?: Maybe<Scalars['datetime']['output']>;
};

/** aggregate min on columns */
export type TbAgendamentosCheckins_Min_Fields = {
  __typename?: 'tbAgendamentosCheckins_min_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
  dataCheckin?: Maybe<Scalars['datetime']['output']>;
};

/** Ordering options when selecting data from "tbAgendamentosCheckins". */
export type TbAgendamentosCheckins_Order_By = {
  agendamento?: InputMaybe<Agendamentos_Order_By>;
  codAgendamento?: InputMaybe<Order_By>;
  dataCheckin?: InputMaybe<Order_By>;
};

/** select columns of table "tbAgendamentosCheckins" */
export enum TbAgendamentosCheckins_Select_Column {
  /** column name */
  CodAgendamento = 'codAgendamento',
  /** column name */
  DataCheckin = 'dataCheckin'
}

/** aggregate stddev on columns */
export type TbAgendamentosCheckins_Stddev_Fields = {
  __typename?: 'tbAgendamentosCheckins_stddev_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TbAgendamentosCheckins_Stddev_Pop_Fields = {
  __typename?: 'tbAgendamentosCheckins_stddev_pop_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TbAgendamentosCheckins_Stddev_Samp_Fields = {
  __typename?: 'tbAgendamentosCheckins_stddev_samp_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type TbAgendamentosCheckins_Sum_Fields = {
  __typename?: 'tbAgendamentosCheckins_sum_fields';
  codAgendamento?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type TbAgendamentosCheckins_Var_Pop_Fields = {
  __typename?: 'tbAgendamentosCheckins_var_pop_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TbAgendamentosCheckins_Var_Samp_Fields = {
  __typename?: 'tbAgendamentosCheckins_var_samp_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TbAgendamentosCheckins_Variance_Fields = {
  __typename?: 'tbAgendamentosCheckins_variance_fields';
  codAgendamento?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados = {
  __typename?: 'tbAgendamentosVinculados';
  /** An object relationship */
  agendamento: Agendamentos;
  /** An object relationship */
  agendamentoPrincipal: Agendamentos;
  codAgendamentoPrincipal: Scalars['Int']['output'];
  codAgendamentoTipoVinculo: Scalars['Int']['output'];
  codAgendamentoVinculado: Scalars['Int']['output'];
  onlinePayments: Array<Expensum_Online_Payment>;
  onlinePayments_aggregate: Expensum_Online_Payment_Aggregate;
};


/** columns and relationships of "tbAgendamentosVinculados" */
export type TbAgendamentosVinculadosOnlinePaymentsArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
};


/** columns and relationships of "tbAgendamentosVinculados" */
export type TbAgendamentosVinculadosOnlinePayments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expensum_Online_Payment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Expensum_Online_Payment_Order_By>>;
  where?: InputMaybe<Expensum_Online_Payment_Bool_Exp>;
};

/** order by aggregate values of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Aggregate_Order_By = {
  avg?: InputMaybe<TbAgendamentosVinculados_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TbAgendamentosVinculados_Max_Order_By>;
  min?: InputMaybe<TbAgendamentosVinculados_Min_Order_By>;
  stddev?: InputMaybe<TbAgendamentosVinculados_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TbAgendamentosVinculados_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TbAgendamentosVinculados_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TbAgendamentosVinculados_Sum_Order_By>;
  var_pop?: InputMaybe<TbAgendamentosVinculados_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TbAgendamentosVinculados_Var_Samp_Order_By>;
  variance?: InputMaybe<TbAgendamentosVinculados_Variance_Order_By>;
};

/** order by avg() on columns of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Avg_Order_By = {
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbAgendamentosVinculados". All fields are combined with a logical 'AND'. */
export type TbAgendamentosVinculados_Bool_Exp = {
  _and?: InputMaybe<Array<TbAgendamentosVinculados_Bool_Exp>>;
  _not?: InputMaybe<TbAgendamentosVinculados_Bool_Exp>;
  _or?: InputMaybe<Array<TbAgendamentosVinculados_Bool_Exp>>;
  agendamento?: InputMaybe<Agendamentos_Bool_Exp>;
  agendamentoPrincipal?: InputMaybe<Agendamentos_Bool_Exp>;
  codAgendamentoPrincipal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codAgendamentoTipoVinculo?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codAgendamentoVinculado?: InputMaybe<Int_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Max_Order_By = {
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Min_Order_By = {
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbAgendamentosVinculados". */
export type TbAgendamentosVinculados_Order_By = {
  agendamento?: InputMaybe<Agendamentos_Order_By>;
  agendamentoPrincipal?: InputMaybe<Agendamentos_Order_By>;
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Stddev_Order_By = {
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Stddev_Pop_Order_By = {
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Stddev_Samp_Order_By = {
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Sum_Order_By = {
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Var_Pop_Order_By = {
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Var_Samp_Order_By = {
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbAgendamentosVinculados" */
export type TbAgendamentosVinculados_Variance_Order_By = {
  codAgendamentoPrincipal?: InputMaybe<Order_By>;
  codAgendamentoTipoVinculo?: InputMaybe<Order_By>;
  codAgendamentoVinculado?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbClinicas" */
export type TbClinicas = {
  __typename?: 'tbClinicas';
  /** An array relationship */
  UsuariosProfissionais: Array<UsuariosProfissionais>;
  ativo: Scalars['Boolean']['output'];
  celularResponsavel?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  codClinica: Scalars['Int']['output'];
  cpfResponsavel?: Maybe<Scalars['String']['output']>;
  emailResponsavel?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  nomeResponsavel?: Maybe<Scalars['String']['output']>;
  ramal?: Maybe<Scalars['String']['output']>;
  razaoSocial?: Maybe<Scalars['String']['output']>;
  simplesNacional: Scalars['Boolean']['output'];
  telefoneResponsavel?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "tbClinicas" */
export type TbClinicasUsuariosProfissionaisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosProfissionais_Order_By>>;
  where?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tbClinicas". All fields are combined with a logical 'AND'. */
export type TbClinicas_Bool_Exp = {
  UsuariosProfissionais?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
  _and?: InputMaybe<Array<TbClinicas_Bool_Exp>>;
  _not?: InputMaybe<TbClinicas_Bool_Exp>;
  _or?: InputMaybe<Array<TbClinicas_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  celularResponsavel?: InputMaybe<String_Mssql_Comparison_Exp>;
  cnpj?: InputMaybe<String_Mssql_Comparison_Exp>;
  codClinica?: InputMaybe<Int_Mssql_Comparison_Exp>;
  cpfResponsavel?: InputMaybe<String_Mssql_Comparison_Exp>;
  emailResponsavel?: InputMaybe<String_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  nomeResponsavel?: InputMaybe<String_Mssql_Comparison_Exp>;
  ramal?: InputMaybe<String_Mssql_Comparison_Exp>;
  razaoSocial?: InputMaybe<String_Mssql_Comparison_Exp>;
  simplesNacional?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  telefoneResponsavel?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbClinicas". */
export type TbClinicas_Order_By = {
  UsuariosProfissionais_aggregate?: InputMaybe<UsuariosProfissionais_Aggregate_Order_By>;
  ativo?: InputMaybe<Order_By>;
  celularResponsavel?: InputMaybe<Order_By>;
  cnpj?: InputMaybe<Order_By>;
  codClinica?: InputMaybe<Order_By>;
  cpfResponsavel?: InputMaybe<Order_By>;
  emailResponsavel?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  nomeResponsavel?: InputMaybe<Order_By>;
  ramal?: InputMaybe<Order_By>;
  razaoSocial?: InputMaybe<Order_By>;
  simplesNacional?: InputMaybe<Order_By>;
  telefoneResponsavel?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbFechamentos" */
export type TbFechamentos = {
  __typename?: 'tbFechamentos';
  codFechamento: Scalars['Int']['output'];
  codTipoFechamento: Scalars['Int']['output'];
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  data: Scalars['date']['output'];
  horaFim: Scalars['time']['output'];
  horaInicio: Scalars['time']['output'];
  motivo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tbUnidade?: Maybe<Unidades>;
  /** An object relationship */
  tbUsuario: Usuarios;
};

/** order by aggregate values of table "tbFechamentos" */
export type TbFechamentos_Aggregate_Order_By = {
  avg?: InputMaybe<TbFechamentos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TbFechamentos_Max_Order_By>;
  min?: InputMaybe<TbFechamentos_Min_Order_By>;
  stddev?: InputMaybe<TbFechamentos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TbFechamentos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TbFechamentos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TbFechamentos_Sum_Order_By>;
  var_pop?: InputMaybe<TbFechamentos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TbFechamentos_Var_Samp_Order_By>;
  variance?: InputMaybe<TbFechamentos_Variance_Order_By>;
};

/** order by avg() on columns of table "tbFechamentos" */
export type TbFechamentos_Avg_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbFechamentos". All fields are combined with a logical 'AND'. */
export type TbFechamentos_Bool_Exp = {
  _and?: InputMaybe<Array<TbFechamentos_Bool_Exp>>;
  _not?: InputMaybe<TbFechamentos_Bool_Exp>;
  _or?: InputMaybe<Array<TbFechamentos_Bool_Exp>>;
  codFechamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoFechamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  data?: InputMaybe<Date_Mssql_Comparison_Exp>;
  horaFim?: InputMaybe<Time_Mssql_Comparison_Exp>;
  horaInicio?: InputMaybe<Time_Mssql_Comparison_Exp>;
  motivo?: InputMaybe<String_Mssql_Comparison_Exp>;
  tbUnidade?: InputMaybe<Unidades_Bool_Exp>;
  tbUsuario?: InputMaybe<Usuarios_Bool_Exp>;
};

/** order by max() on columns of table "tbFechamentos" */
export type TbFechamentos_Max_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
  motivo?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbFechamentos" */
export type TbFechamentos_Min_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
  motivo?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tbFechamentos" */
export type TbFechamentos_Mutation_Response = {
  __typename?: 'tbFechamentos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TbFechamentos>;
};

/** Ordering options when selecting data from "tbFechamentos". */
export type TbFechamentos_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
  motivo?: InputMaybe<Order_By>;
  tbUnidade?: InputMaybe<Unidades_Order_By>;
  tbUsuario?: InputMaybe<Usuarios_Order_By>;
};

/** order by stddev() on columns of table "tbFechamentos" */
export type TbFechamentos_Stddev_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbFechamentos" */
export type TbFechamentos_Stddev_Pop_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbFechamentos" */
export type TbFechamentos_Stddev_Samp_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbFechamentos" */
export type TbFechamentos_Sum_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbFechamentos" */
export type TbFechamentos_Var_Pop_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbFechamentos" */
export type TbFechamentos_Var_Samp_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbFechamentos" */
export type TbFechamentos_Variance_Order_By = {
  codFechamento?: InputMaybe<Order_By>;
  codTipoFechamento?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbFeriados" */
export type TbFeriados = {
  __typename?: 'tbFeriados';
  ano?: Maybe<Scalars['Int']['output']>;
  codFeriado: Scalars['Int']['output'];
  codUnidade?: Maybe<Scalars['Int']['output']>;
  dia: Scalars['Int']['output'];
  horaFim: Scalars['time']['output'];
  horaInicio: Scalars['time']['output'];
  mes?: Maybe<Scalars['Int']['output']>;
  nome: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "tbFeriados". All fields are combined with a logical 'AND'. */
export type TbFeriados_Bool_Exp = {
  _and?: InputMaybe<Array<TbFeriados_Bool_Exp>>;
  _not?: InputMaybe<TbFeriados_Bool_Exp>;
  _or?: InputMaybe<Array<TbFeriados_Bool_Exp>>;
  ano?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codFeriado?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dia?: InputMaybe<Int_Mssql_Comparison_Exp>;
  horaFim?: InputMaybe<Time_Mssql_Comparison_Exp>;
  horaInicio?: InputMaybe<Time_Mssql_Comparison_Exp>;
  mes?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbFeriados". */
export type TbFeriados_Order_By = {
  ano?: InputMaybe<Order_By>;
  codFeriado?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  dia?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
  mes?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbMovimentacoes" */
export type TbMovimentacoes = {
  __typename?: 'tbMovimentacoes';
  /** An object relationship */
  TipoMovimentacao: TiposMovimentacoes;
  codMovimentacao: Scalars['Int']['output'];
  codOrigem?: Maybe<Scalars['Int']['output']>;
  tipoOrigem: Scalars['String']['output'];
  /** An object relationship */
  usuario: Usuarios;
};

/** order by aggregate values of table "tbMovimentacoes" */
export type TbMovimentacoes_Aggregate_Order_By = {
  avg?: InputMaybe<TbMovimentacoes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TbMovimentacoes_Max_Order_By>;
  min?: InputMaybe<TbMovimentacoes_Min_Order_By>;
  stddev?: InputMaybe<TbMovimentacoes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TbMovimentacoes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TbMovimentacoes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TbMovimentacoes_Sum_Order_By>;
  var_pop?: InputMaybe<TbMovimentacoes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TbMovimentacoes_Var_Samp_Order_By>;
  variance?: InputMaybe<TbMovimentacoes_Variance_Order_By>;
};

/** order by avg() on columns of table "tbMovimentacoes" */
export type TbMovimentacoes_Avg_Order_By = {
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbMovimentacoes". All fields are combined with a logical 'AND'. */
export type TbMovimentacoes_Bool_Exp = {
  TipoMovimentacao?: InputMaybe<TiposMovimentacoes_Bool_Exp>;
  _and?: InputMaybe<Array<TbMovimentacoes_Bool_Exp>>;
  _not?: InputMaybe<TbMovimentacoes_Bool_Exp>;
  _or?: InputMaybe<Array<TbMovimentacoes_Bool_Exp>>;
  codMovimentacao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codOrigem?: InputMaybe<Int_Mssql_Comparison_Exp>;
  tipoOrigem?: InputMaybe<String_Mssql_Comparison_Exp>;
  usuario?: InputMaybe<Usuarios_Bool_Exp>;
};

/** order by max() on columns of table "tbMovimentacoes" */
export type TbMovimentacoes_Max_Order_By = {
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
  tipoOrigem?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbMovimentacoes" */
export type TbMovimentacoes_Min_Order_By = {
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
  tipoOrigem?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbMovimentacoes". */
export type TbMovimentacoes_Order_By = {
  TipoMovimentacao?: InputMaybe<TiposMovimentacoes_Order_By>;
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
  tipoOrigem?: InputMaybe<Order_By>;
  usuario?: InputMaybe<Usuarios_Order_By>;
};

/** order by stddev() on columns of table "tbMovimentacoes" */
export type TbMovimentacoes_Stddev_Order_By = {
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbMovimentacoes" */
export type TbMovimentacoes_Stddev_Pop_Order_By = {
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbMovimentacoes" */
export type TbMovimentacoes_Stddev_Samp_Order_By = {
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbMovimentacoes" */
export type TbMovimentacoes_Sum_Order_By = {
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbMovimentacoes" */
export type TbMovimentacoes_Var_Pop_Order_By = {
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbMovimentacoes" */
export type TbMovimentacoes_Var_Samp_Order_By = {
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbMovimentacoes" */
export type TbMovimentacoes_Variance_Order_By = {
  codMovimentacao?: InputMaybe<Order_By>;
  codOrigem?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis = {
  __typename?: 'tbPacotesServicosPrecosVariaveis';
  codPacoteServicosPreco: Scalars['Int']['output'];
  codPacoteServicosPrecoVariavel: Scalars['Int']['output'];
  codTipoPacoteServicosPrecoVariavel: Scalars['Int']['output'];
  valorUnitario: Scalars['Float']['output'];
};

/** order by aggregate values of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Aggregate_Order_By = {
  avg?: InputMaybe<TbPacotesServicosPrecosVariaveis_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TbPacotesServicosPrecosVariaveis_Max_Order_By>;
  min?: InputMaybe<TbPacotesServicosPrecosVariaveis_Min_Order_By>;
  stddev?: InputMaybe<TbPacotesServicosPrecosVariaveis_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TbPacotesServicosPrecosVariaveis_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TbPacotesServicosPrecosVariaveis_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TbPacotesServicosPrecosVariaveis_Sum_Order_By>;
  var_pop?: InputMaybe<TbPacotesServicosPrecosVariaveis_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TbPacotesServicosPrecosVariaveis_Var_Samp_Order_By>;
  variance?: InputMaybe<TbPacotesServicosPrecosVariaveis_Variance_Order_By>;
};

/** order by avg() on columns of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Avg_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbPacotesServicosPrecosVariaveis". All fields are combined with a logical 'AND'. */
export type TbPacotesServicosPrecosVariaveis_Bool_Exp = {
  _and?: InputMaybe<Array<TbPacotesServicosPrecosVariaveis_Bool_Exp>>;
  _not?: InputMaybe<TbPacotesServicosPrecosVariaveis_Bool_Exp>;
  _or?: InputMaybe<Array<TbPacotesServicosPrecosVariaveis_Bool_Exp>>;
  codPacoteServicosPreco?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Int_Mssql_Comparison_Exp>;
  valorUnitario?: InputMaybe<Float_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Max_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Min_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbPacotesServicosPrecosVariaveis". */
export type TbPacotesServicosPrecosVariaveis_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Stddev_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Stddev_Pop_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Stddev_Samp_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Sum_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Var_Pop_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Var_Samp_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbPacotesServicosPrecosVariaveis" */
export type TbPacotesServicosPrecosVariaveis_Variance_Order_By = {
  codPacoteServicosPreco?: InputMaybe<Order_By>;
  codPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos = {
  __typename?: 'tbPeriodosGarantidos';
  /** An object relationship */
  Agendamento: Agendamentos;
  /** An object relationship */
  PeriodoGarantidoRecorrente?: Maybe<TbPeriodosGarantidosRecorrentes>;
  ativo: Scalars['Boolean']['output'];
  codAgendamentoFinalidadePeriodoGarantido: Scalars['Int']['output'];
  codModalidadePeriodoGarantido: Scalars['Int']['output'];
  codPeriodoGarantido: Scalars['Int']['output'];
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Int']['output']>;
  dataCadastro: Scalars['datetime2']['output'];
  margemInicial: Scalars['time']['output'];
};

/** columns and relationships of "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes = {
  __typename?: 'tbPeriodosGarantidosRecorrentes';
  /** An array relationship */
  PeriodosGarantidos: Array<TbPeriodosGarantidos>;
  /** An object relationship */
  PeriodosGarantidosRecorrentesFrequencia: TbPeriodosGarantidosRecorrentesFrequencias;
  /** An aggregate relationship */
  PeriodosGarantidos_aggregate: TbPeriodosGarantidos_Aggregate;
  /** An object relationship */
  TipoSala: TiposSalas;
  /** An object relationship */
  Unidade: Unidades;
  /** An object relationship */
  Usuario: Usuarios;
  ativo: Scalars['Boolean']['output'];
  codModalidadePeriodoGarantido: Scalars['Int']['output'];
  codPeriodoGarantidoRecorrente: Scalars['Int']['output'];
  codPeriodoGarantidoRecorrenteFrequencia: Scalars['Int']['output'];
  codTipoSala: Scalars['Int']['output'];
  codUnidade: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  dataInicio: Scalars['datetime2']['output'];
  dataUltimaReserva: Scalars['datetime2']['output'];
  diaDaSemana: Scalars['Int']['output'];
  horaFim: Scalars['time']['output'];
  horaInicio: Scalars['time']['output'];
  margemInicial: Scalars['time']['output'];
};


/** columns and relationships of "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentesPeriodosGarantidosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidos_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
};


/** columns and relationships of "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentesPeriodosGarantidos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidos_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
};

/** columns and relationships of "tbPeriodosGarantidosRecorrentesFrequencias" */
export type TbPeriodosGarantidosRecorrentesFrequencias = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias';
  /** An array relationship */
  PeriodosGarantidosRecorrentes: Array<TbPeriodosGarantidosRecorrentes>;
  /** An aggregate relationship */
  PeriodosGarantidosRecorrentes_aggregate: TbPeriodosGarantidosRecorrentes_Aggregate;
  codPeriodoGarantidoRecorrenteFrequencia: Scalars['Int']['output'];
  descricao: Scalars['String']['output'];
  nome: Scalars['String']['output'];
};


/** columns and relationships of "tbPeriodosGarantidosRecorrentesFrequencias" */
export type TbPeriodosGarantidosRecorrentesFrequenciasPeriodosGarantidosRecorrentesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidosRecorrentes_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidosRecorrentes_Bool_Exp>;
};


/** columns and relationships of "tbPeriodosGarantidosRecorrentesFrequencias" */
export type TbPeriodosGarantidosRecorrentesFrequenciasPeriodosGarantidosRecorrentes_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbPeriodosGarantidosRecorrentes_Order_By>>;
  where?: InputMaybe<TbPeriodosGarantidosRecorrentes_Bool_Exp>;
};

/** aggregated selection of "tbPeriodosGarantidosRecorrentesFrequencias" */
export type TbPeriodosGarantidosRecorrentesFrequencias_Aggregate = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_aggregate';
  aggregate?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Aggregate_Fields>;
  nodes: Array<TbPeriodosGarantidosRecorrentesFrequencias>;
};

/** aggregate fields of "tbPeriodosGarantidosRecorrentesFrequencias" */
export type TbPeriodosGarantidosRecorrentesFrequencias_Aggregate_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_aggregate_fields';
  avg?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Max_Fields>;
  min?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Min_Fields>;
  stddev?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Stddev_Fields>;
  stddev_pop?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Stddev_Samp_Fields>;
  sum?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Sum_Fields>;
  var_pop?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Var_Pop_Fields>;
  var_samp?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Var_Samp_Fields>;
  variance?: Maybe<TbPeriodosGarantidosRecorrentesFrequencias_Variance_Fields>;
};


/** aggregate fields of "tbPeriodosGarantidosRecorrentesFrequencias" */
export type TbPeriodosGarantidosRecorrentesFrequencias_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<TbPeriodosGarantidosRecorrentesFrequencias_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TbPeriodosGarantidosRecorrentesFrequencias_Avg_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_avg_fields';
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tbPeriodosGarantidosRecorrentesFrequencias". All fields are combined with a logical 'AND'. */
export type TbPeriodosGarantidosRecorrentesFrequencias_Bool_Exp = {
  PeriodosGarantidosRecorrentes?: InputMaybe<TbPeriodosGarantidosRecorrentes_Bool_Exp>;
  _and?: InputMaybe<Array<TbPeriodosGarantidosRecorrentesFrequencias_Bool_Exp>>;
  _not?: InputMaybe<TbPeriodosGarantidosRecorrentesFrequencias_Bool_Exp>;
  _or?: InputMaybe<Array<TbPeriodosGarantidosRecorrentesFrequencias_Bool_Exp>>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Int_Mssql_Comparison_Exp>;
  descricao?: InputMaybe<String_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type TbPeriodosGarantidosRecorrentesFrequencias_Max_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_max_fields';
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Int']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TbPeriodosGarantidosRecorrentesFrequencias_Min_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_min_fields';
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Int']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "tbPeriodosGarantidosRecorrentesFrequencias". */
export type TbPeriodosGarantidosRecorrentesFrequencias_Order_By = {
  PeriodosGarantidosRecorrentes_aggregate?: InputMaybe<TbPeriodosGarantidosRecorrentes_Aggregate_Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** select columns of table "tbPeriodosGarantidosRecorrentesFrequencias" */
export enum TbPeriodosGarantidosRecorrentesFrequencias_Select_Column {
  /** column name */
  CodPeriodoGarantidoRecorrenteFrequencia = 'codPeriodoGarantidoRecorrenteFrequencia',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Nome = 'nome'
}

/** aggregate stddev on columns */
export type TbPeriodosGarantidosRecorrentesFrequencias_Stddev_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_stddev_fields';
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TbPeriodosGarantidosRecorrentesFrequencias_Stddev_Pop_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_stddev_pop_fields';
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TbPeriodosGarantidosRecorrentesFrequencias_Stddev_Samp_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_stddev_samp_fields';
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type TbPeriodosGarantidosRecorrentesFrequencias_Sum_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_sum_fields';
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type TbPeriodosGarantidosRecorrentesFrequencias_Var_Pop_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_var_pop_fields';
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TbPeriodosGarantidosRecorrentesFrequencias_Var_Samp_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_var_samp_fields';
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TbPeriodosGarantidosRecorrentesFrequencias_Variance_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias_variance_fields';
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Aggregate = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_aggregate';
  aggregate?: Maybe<TbPeriodosGarantidosRecorrentes_Aggregate_Fields>;
  nodes: Array<TbPeriodosGarantidosRecorrentes>;
};

/** aggregate fields of "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Aggregate_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_aggregate_fields';
  avg?: Maybe<TbPeriodosGarantidosRecorrentes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TbPeriodosGarantidosRecorrentes_Max_Fields>;
  min?: Maybe<TbPeriodosGarantidosRecorrentes_Min_Fields>;
  stddev?: Maybe<TbPeriodosGarantidosRecorrentes_Stddev_Fields>;
  stddev_pop?: Maybe<TbPeriodosGarantidosRecorrentes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TbPeriodosGarantidosRecorrentes_Stddev_Samp_Fields>;
  sum?: Maybe<TbPeriodosGarantidosRecorrentes_Sum_Fields>;
  var_pop?: Maybe<TbPeriodosGarantidosRecorrentes_Var_Pop_Fields>;
  var_samp?: Maybe<TbPeriodosGarantidosRecorrentes_Var_Samp_Fields>;
  variance?: Maybe<TbPeriodosGarantidosRecorrentes_Variance_Fields>;
};


/** aggregate fields of "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<TbPeriodosGarantidosRecorrentes_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Aggregate_Order_By = {
  avg?: InputMaybe<TbPeriodosGarantidosRecorrentes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TbPeriodosGarantidosRecorrentes_Max_Order_By>;
  min?: InputMaybe<TbPeriodosGarantidosRecorrentes_Min_Order_By>;
  stddev?: InputMaybe<TbPeriodosGarantidosRecorrentes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TbPeriodosGarantidosRecorrentes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TbPeriodosGarantidosRecorrentes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TbPeriodosGarantidosRecorrentes_Sum_Order_By>;
  var_pop?: InputMaybe<TbPeriodosGarantidosRecorrentes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TbPeriodosGarantidosRecorrentes_Var_Samp_Order_By>;
  variance?: InputMaybe<TbPeriodosGarantidosRecorrentes_Variance_Order_By>;
};

/** aggregate avg on columns */
export type TbPeriodosGarantidosRecorrentes_Avg_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_avg_fields';
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  diaDaSemana?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Avg_Order_By = {
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbPeriodosGarantidosRecorrentes". All fields are combined with a logical 'AND'. */
export type TbPeriodosGarantidosRecorrentes_Bool_Exp = {
  PeriodosGarantidos?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
  PeriodosGarantidosRecorrentesFrequencia?: InputMaybe<TbPeriodosGarantidosRecorrentesFrequencias_Bool_Exp>;
  TipoSala?: InputMaybe<TiposSalas_Bool_Exp>;
  Unidade?: InputMaybe<Unidades_Bool_Exp>;
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  _and?: InputMaybe<Array<TbPeriodosGarantidosRecorrentes_Bool_Exp>>;
  _not?: InputMaybe<TbPeriodosGarantidosRecorrentes_Bool_Exp>;
  _or?: InputMaybe<Array<TbPeriodosGarantidosRecorrentes_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codModalidadePeriodoGarantido?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataInicio?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataUltimaReserva?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  diaDaSemana?: InputMaybe<Int_Mssql_Comparison_Exp>;
  horaFim?: InputMaybe<Time_Mssql_Comparison_Exp>;
  horaInicio?: InputMaybe<Time_Mssql_Comparison_Exp>;
  margemInicial?: InputMaybe<Time_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type TbPeriodosGarantidosRecorrentes_Max_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_max_fields';
  codModalidadePeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Int']['output']>;
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['datetime2']['output']>;
  dataInicio?: Maybe<Scalars['datetime2']['output']>;
  dataUltimaReserva?: Maybe<Scalars['datetime2']['output']>;
  diaDaSemana?: Maybe<Scalars['Int']['output']>;
  horaFim?: Maybe<Scalars['time']['output']>;
  horaInicio?: Maybe<Scalars['time']['output']>;
  margemInicial?: Maybe<Scalars['time']['output']>;
};

/** order by max() on columns of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Max_Order_By = {
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  dataUltimaReserva?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
  margemInicial?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TbPeriodosGarantidosRecorrentes_Min_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_min_fields';
  codModalidadePeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Int']['output']>;
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['datetime2']['output']>;
  dataInicio?: Maybe<Scalars['datetime2']['output']>;
  dataUltimaReserva?: Maybe<Scalars['datetime2']['output']>;
  diaDaSemana?: Maybe<Scalars['Int']['output']>;
  horaFim?: Maybe<Scalars['time']['output']>;
  horaInicio?: Maybe<Scalars['time']['output']>;
  margemInicial?: Maybe<Scalars['time']['output']>;
};

/** order by min() on columns of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Min_Order_By = {
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  dataUltimaReserva?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
  margemInicial?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbPeriodosGarantidosRecorrentes". */
export type TbPeriodosGarantidosRecorrentes_Order_By = {
  PeriodosGarantidosRecorrentesFrequencia?: InputMaybe<TbPeriodosGarantidosRecorrentesFrequencias_Order_By>;
  PeriodosGarantidos_aggregate?: InputMaybe<TbPeriodosGarantidos_Aggregate_Order_By>;
  TipoSala?: InputMaybe<TiposSalas_Order_By>;
  Unidade?: InputMaybe<Unidades_Order_By>;
  Usuario?: InputMaybe<Usuarios_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  dataUltimaReserva?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
  margemInicial?: InputMaybe<Order_By>;
};

/** select columns of table "tbPeriodosGarantidosRecorrentes" */
export enum TbPeriodosGarantidosRecorrentes_Select_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  CodModalidadePeriodoGarantido = 'codModalidadePeriodoGarantido',
  /** column name */
  CodPeriodoGarantidoRecorrente = 'codPeriodoGarantidoRecorrente',
  /** column name */
  CodPeriodoGarantidoRecorrenteFrequencia = 'codPeriodoGarantidoRecorrenteFrequencia',
  /** column name */
  CodTipoSala = 'codTipoSala',
  /** column name */
  CodUnidade = 'codUnidade',
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  DataCadastro = 'dataCadastro',
  /** column name */
  DataInicio = 'dataInicio',
  /** column name */
  DataUltimaReserva = 'dataUltimaReserva',
  /** column name */
  DiaDaSemana = 'diaDaSemana',
  /** column name */
  HoraFim = 'horaFim',
  /** column name */
  HoraInicio = 'horaInicio',
  /** column name */
  MargemInicial = 'margemInicial'
}

/** aggregate stddev on columns */
export type TbPeriodosGarantidosRecorrentes_Stddev_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_stddev_fields';
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  diaDaSemana?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Stddev_Order_By = {
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type TbPeriodosGarantidosRecorrentes_Stddev_Pop_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_stddev_pop_fields';
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  diaDaSemana?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Stddev_Pop_Order_By = {
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type TbPeriodosGarantidosRecorrentes_Stddev_Samp_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_stddev_samp_fields';
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  diaDaSemana?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Stddev_Samp_Order_By = {
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type TbPeriodosGarantidosRecorrentes_Sum_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_sum_fields';
  codModalidadePeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Int']['output']>;
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  diaDaSemana?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Sum_Order_By = {
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type TbPeriodosGarantidosRecorrentes_Var_Pop_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_var_pop_fields';
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  diaDaSemana?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Var_Pop_Order_By = {
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type TbPeriodosGarantidosRecorrentes_Var_Samp_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_var_samp_fields';
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  diaDaSemana?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Var_Samp_Order_By = {
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type TbPeriodosGarantidosRecorrentes_Variance_Fields = {
  __typename?: 'tbPeriodosGarantidosRecorrentes_variance_fields';
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrenteFrequencia?: Maybe<Scalars['Float']['output']>;
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  diaDaSemana?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbPeriodosGarantidosRecorrentes" */
export type TbPeriodosGarantidosRecorrentes_Variance_Order_By = {
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrenteFrequencia?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  diaDaSemana?: InputMaybe<Order_By>;
};

/** aggregated selection of "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Aggregate = {
  __typename?: 'tbPeriodosGarantidos_aggregate';
  aggregate?: Maybe<TbPeriodosGarantidos_Aggregate_Fields>;
  nodes: Array<TbPeriodosGarantidos>;
};

/** aggregate fields of "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Aggregate_Fields = {
  __typename?: 'tbPeriodosGarantidos_aggregate_fields';
  avg?: Maybe<TbPeriodosGarantidos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<TbPeriodosGarantidos_Max_Fields>;
  min?: Maybe<TbPeriodosGarantidos_Min_Fields>;
  stddev?: Maybe<TbPeriodosGarantidos_Stddev_Fields>;
  stddev_pop?: Maybe<TbPeriodosGarantidos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TbPeriodosGarantidos_Stddev_Samp_Fields>;
  sum?: Maybe<TbPeriodosGarantidos_Sum_Fields>;
  var_pop?: Maybe<TbPeriodosGarantidos_Var_Pop_Fields>;
  var_samp?: Maybe<TbPeriodosGarantidos_Var_Samp_Fields>;
  variance?: Maybe<TbPeriodosGarantidos_Variance_Fields>;
};


/** aggregate fields of "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<TbPeriodosGarantidos_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Aggregate_Order_By = {
  avg?: InputMaybe<TbPeriodosGarantidos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TbPeriodosGarantidos_Max_Order_By>;
  min?: InputMaybe<TbPeriodosGarantidos_Min_Order_By>;
  stddev?: InputMaybe<TbPeriodosGarantidos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TbPeriodosGarantidos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TbPeriodosGarantidos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TbPeriodosGarantidos_Sum_Order_By>;
  var_pop?: InputMaybe<TbPeriodosGarantidos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TbPeriodosGarantidos_Var_Samp_Order_By>;
  variance?: InputMaybe<TbPeriodosGarantidos_Variance_Order_By>;
};

/** aggregate avg on columns */
export type TbPeriodosGarantidos_Avg_Fields = {
  __typename?: 'tbPeriodosGarantidos_avg_fields';
  codAgendamentoFinalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Avg_Order_By = {
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbPeriodosGarantidos". All fields are combined with a logical 'AND'. */
export type TbPeriodosGarantidos_Bool_Exp = {
  Agendamento?: InputMaybe<Agendamentos_Bool_Exp>;
  PeriodoGarantidoRecorrente?: InputMaybe<TbPeriodosGarantidosRecorrentes_Bool_Exp>;
  _and?: InputMaybe<Array<TbPeriodosGarantidos_Bool_Exp>>;
  _not?: InputMaybe<TbPeriodosGarantidos_Bool_Exp>;
  _or?: InputMaybe<Array<TbPeriodosGarantidos_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codModalidadePeriodoGarantido?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPeriodoGarantido?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  margemInicial?: InputMaybe<Time_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type TbPeriodosGarantidos_Max_Fields = {
  __typename?: 'tbPeriodosGarantidos_max_fields';
  codAgendamentoFinalidadePeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codModalidadePeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['datetime2']['output']>;
  margemInicial?: Maybe<Scalars['time']['output']>;
};

/** order by max() on columns of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Max_Order_By = {
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  margemInicial?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TbPeriodosGarantidos_Min_Fields = {
  __typename?: 'tbPeriodosGarantidos_min_fields';
  codAgendamentoFinalidadePeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codModalidadePeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['datetime2']['output']>;
  margemInicial?: Maybe<Scalars['time']['output']>;
};

/** order by min() on columns of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Min_Order_By = {
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  margemInicial?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbPeriodosGarantidos". */
export type TbPeriodosGarantidos_Order_By = {
  Agendamento?: InputMaybe<Agendamentos_Order_By>;
  PeriodoGarantidoRecorrente?: InputMaybe<TbPeriodosGarantidosRecorrentes_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  margemInicial?: InputMaybe<Order_By>;
};

/** select columns of table "tbPeriodosGarantidos" */
export enum TbPeriodosGarantidos_Select_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  CodAgendamentoFinalidadePeriodoGarantido = 'codAgendamentoFinalidadePeriodoGarantido',
  /** column name */
  CodModalidadePeriodoGarantido = 'codModalidadePeriodoGarantido',
  /** column name */
  CodPeriodoGarantido = 'codPeriodoGarantido',
  /** column name */
  CodPeriodoGarantidoRecorrente = 'codPeriodoGarantidoRecorrente',
  /** column name */
  DataCadastro = 'dataCadastro',
  /** column name */
  MargemInicial = 'margemInicial'
}

/** aggregate stddev on columns */
export type TbPeriodosGarantidos_Stddev_Fields = {
  __typename?: 'tbPeriodosGarantidos_stddev_fields';
  codAgendamentoFinalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Stddev_Order_By = {
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type TbPeriodosGarantidos_Stddev_Pop_Fields = {
  __typename?: 'tbPeriodosGarantidos_stddev_pop_fields';
  codAgendamentoFinalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Stddev_Pop_Order_By = {
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type TbPeriodosGarantidos_Stddev_Samp_Fields = {
  __typename?: 'tbPeriodosGarantidos_stddev_samp_fields';
  codAgendamentoFinalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Stddev_Samp_Order_By = {
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type TbPeriodosGarantidos_Sum_Fields = {
  __typename?: 'tbPeriodosGarantidos_sum_fields';
  codAgendamentoFinalidadePeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codModalidadePeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantido?: Maybe<Scalars['Int']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Sum_Order_By = {
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type TbPeriodosGarantidos_Var_Pop_Fields = {
  __typename?: 'tbPeriodosGarantidos_var_pop_fields';
  codAgendamentoFinalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Var_Pop_Order_By = {
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type TbPeriodosGarantidos_Var_Samp_Fields = {
  __typename?: 'tbPeriodosGarantidos_var_samp_fields';
  codAgendamentoFinalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Var_Samp_Order_By = {
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type TbPeriodosGarantidos_Variance_Fields = {
  __typename?: 'tbPeriodosGarantidos_variance_fields';
  codAgendamentoFinalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codModalidadePeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantido?: Maybe<Scalars['Float']['output']>;
  codPeriodoGarantidoRecorrente?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbPeriodosGarantidos" */
export type TbPeriodosGarantidos_Variance_Order_By = {
  codAgendamentoFinalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codModalidadePeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantido?: InputMaybe<Order_By>;
  codPeriodoGarantidoRecorrente?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbTipoPacotesServicosPrecoVariavel" */
export type TbTipoPacotesServicosPrecoVariavel = {
  __typename?: 'tbTipoPacotesServicosPrecoVariavel';
  codTipoPacoteServicosPrecoVariavel: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "tbTipoPacotesServicosPrecoVariavel". All fields are combined with a logical 'AND'. */
export type TbTipoPacotesServicosPrecoVariavel_Bool_Exp = {
  _and?: InputMaybe<Array<TbTipoPacotesServicosPrecoVariavel_Bool_Exp>>;
  _not?: InputMaybe<TbTipoPacotesServicosPrecoVariavel_Bool_Exp>;
  _or?: InputMaybe<Array<TbTipoPacotesServicosPrecoVariavel_Bool_Exp>>;
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbTipoPacotesServicosPrecoVariavel". */
export type TbTipoPacotesServicosPrecoVariavel_Order_By = {
  codTipoPacoteServicosPrecoVariavel?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas = {
  __typename?: 'tbUsuariosAgendasDiasSemanas';
  ativo: Scalars['Boolean']['output'];
  diaSemana: Scalars['Int']['output'];
  /** An object relationship */
  tbUsuariosAgenda: UsuariosAgendas;
};

/** order by aggregate values of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Aggregate_Order_By = {
  avg?: InputMaybe<TbUsuariosAgendasDiasSemanas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TbUsuariosAgendasDiasSemanas_Max_Order_By>;
  min?: InputMaybe<TbUsuariosAgendasDiasSemanas_Min_Order_By>;
  stddev?: InputMaybe<TbUsuariosAgendasDiasSemanas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TbUsuariosAgendasDiasSemanas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TbUsuariosAgendasDiasSemanas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TbUsuariosAgendasDiasSemanas_Sum_Order_By>;
  var_pop?: InputMaybe<TbUsuariosAgendasDiasSemanas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TbUsuariosAgendasDiasSemanas_Var_Samp_Order_By>;
  variance?: InputMaybe<TbUsuariosAgendasDiasSemanas_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Avg_Order_By = {
  diaSemana?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosAgendasDiasSemanas". All fields are combined with a logical 'AND'. */
export type TbUsuariosAgendasDiasSemanas_Bool_Exp = {
  _and?: InputMaybe<Array<TbUsuariosAgendasDiasSemanas_Bool_Exp>>;
  _not?: InputMaybe<TbUsuariosAgendasDiasSemanas_Bool_Exp>;
  _or?: InputMaybe<Array<TbUsuariosAgendasDiasSemanas_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  diaSemana?: InputMaybe<Int_Mssql_Comparison_Exp>;
  tbUsuariosAgenda?: InputMaybe<UsuariosAgendas_Bool_Exp>;
};

/** order by max() on columns of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Max_Order_By = {
  diaSemana?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Min_Order_By = {
  diaSemana?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosAgendasDiasSemanas". */
export type TbUsuariosAgendasDiasSemanas_Order_By = {
  ativo?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  tbUsuariosAgenda?: InputMaybe<UsuariosAgendas_Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Stddev_Order_By = {
  diaSemana?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Stddev_Pop_Order_By = {
  diaSemana?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Stddev_Samp_Order_By = {
  diaSemana?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Sum_Order_By = {
  diaSemana?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Var_Pop_Order_By = {
  diaSemana?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Var_Samp_Order_By = {
  diaSemana?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosAgendasDiasSemanas" */
export type TbUsuariosAgendasDiasSemanas_Variance_Order_By = {
  diaSemana?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosIntegracoes" */
export type TbUsuariosIntegracoes = {
  __typename?: 'tbUsuariosIntegracoes';
  /** An object relationship */
  Unidade?: Maybe<Unidades>;
  /** An object relationship */
  Usuario: Usuarios;
  ativo: Scalars['Boolean']['output'];
  codParceiro?: Maybe<Scalars['Int']['output']>;
  codParceiroIntegracao: Scalars['Int']['output'];
  codUnidadePadrao?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  codUsuarioExterno?: Maybe<Scalars['String']['output']>;
  dataCadastro: Scalars['datetime2']['output'];
  tipoFaturamento: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "tbUsuariosIntegracoes". All fields are combined with a logical 'AND'. */
export type TbUsuariosIntegracoes_Bool_Exp = {
  Unidade?: InputMaybe<Unidades_Bool_Exp>;
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  _and?: InputMaybe<Array<TbUsuariosIntegracoes_Bool_Exp>>;
  _not?: InputMaybe<TbUsuariosIntegracoes_Bool_Exp>;
  _or?: InputMaybe<Array<TbUsuariosIntegracoes_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codParceiro?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codParceiroIntegracao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadePadrao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioExterno?: InputMaybe<String_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  tipoFaturamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbUsuariosIntegracoes". */
export type TbUsuariosIntegracoes_Order_By = {
  Unidade?: InputMaybe<Unidades_Order_By>;
  Usuario?: InputMaybe<Usuarios_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codParceiro?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUnidadePadrao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioExterno?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  tipoFaturamento?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosTermosDeUso" */
export type TbUsuariosTermosDeUso = {
  __typename?: 'tbUsuariosTermosDeUso';
  /** An object relationship */
  Usuario: Usuarios;
  ativo: Scalars['Boolean']['output'];
  codTermosDeUso: Scalars['Int']['output'];
  codTipoTermoDeUso: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  dataUltimaAtualizacao: Scalars['datetime2']['output'];
};

/** Boolean expression to filter rows from the table "tbUsuariosTermosDeUso". All fields are combined with a logical 'AND'. */
export type TbUsuariosTermosDeUso_Bool_Exp = {
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  _and?: InputMaybe<Array<TbUsuariosTermosDeUso_Bool_Exp>>;
  _not?: InputMaybe<TbUsuariosTermosDeUso_Bool_Exp>;
  _or?: InputMaybe<Array<TbUsuariosTermosDeUso_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codTermosDeUso?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoTermoDeUso?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataUltimaAtualizacao?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
};

/** upsert condition type for table "tbUsuariosTermosDeUso" */
export type TbUsuariosTermosDeUso_If_Matched = {
  match_columns?: Array<TbUsuariosTermosDeUso_Insert_Match_Column>;
  update_columns?: Array<TbUsuariosTermosDeUso_Update_Column>;
  where?: InputMaybe<TbUsuariosTermosDeUso_Bool_Exp>;
};

/** input type for inserting data into table "tbUsuariosTermosDeUso" */
export type TbUsuariosTermosDeUso_Insert_Input = {
  IP?: InputMaybe<Scalars['String']['input']>;
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  codTipoTermoDeUso?: InputMaybe<Scalars['Int']['input']>;
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  dataCadastro?: InputMaybe<Scalars['datetime2']['input']>;
  dataUltimaAtualizacao?: InputMaybe<Scalars['datetime2']['input']>;
};

/** select match_columns of table "tbUsuariosTermosDeUso" */
export enum TbUsuariosTermosDeUso_Insert_Match_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  CodTermosDeUso = 'codTermosDeUso',
  /** column name */
  CodTipoTermoDeUso = 'codTipoTermoDeUso',
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  DataCadastro = 'dataCadastro',
  /** column name */
  DataUltimaAtualizacao = 'dataUltimaAtualizacao'
}

/** response of any mutation on the table "tbUsuariosTermosDeUso" */
export type TbUsuariosTermosDeUso_Mutation_Response = {
  __typename?: 'tbUsuariosTermosDeUso_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TbUsuariosTermosDeUso>;
};

/** Ordering options when selecting data from "tbUsuariosTermosDeUso". */
export type TbUsuariosTermosDeUso_Order_By = {
  Usuario?: InputMaybe<Usuarios_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codTermosDeUso?: InputMaybe<Order_By>;
  codTipoTermoDeUso?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataUltimaAtualizacao?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tbUsuariosTermosDeUso */
export type TbUsuariosTermosDeUso_Pk_Columns_Input = {
  codTermosDeUso: Scalars['Int']['input'];
};

/** input type for updating data in table "tbUsuariosTermosDeUso" */
export type TbUsuariosTermosDeUso_Set_Input = {
  IP?: InputMaybe<Scalars['String']['input']>;
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
  dataUltimaAtualizacao?: InputMaybe<Scalars['datetime2']['input']>;
};

/** update columns of table "tbUsuariosTermosDeUso" */
export enum TbUsuariosTermosDeUso_Update_Column {
  /** column name */
  Ip = 'IP',
  /** column name */
  Ativo = 'ativo',
  /** column name */
  DataUltimaAtualizacao = 'dataUltimaAtualizacao'
}

/** TERMS OF USE VERSIONS */
export type Terms_Of_Use = {
  __typename?: 'terms_of_use';
  file: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  release_date: Scalars['timestamptz']['output'];
  /** An array relationship */
  users_terms_of_use_agreeds: Array<Users_Terms_Of_Use_Agreed>;
};


/** TERMS OF USE VERSIONS */
export type Terms_Of_UseUsers_Terms_Of_Use_AgreedsArgs = {
  distinct_on?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Order_By>>;
  where?: InputMaybe<Users_Terms_Of_Use_Agreed_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "terms_of_use". All fields are combined with a logical 'AND'. */
export type Terms_Of_Use_Bool_Exp = {
  _and?: InputMaybe<Array<Terms_Of_Use_Bool_Exp>>;
  _not?: InputMaybe<Terms_Of_Use_Bool_Exp>;
  _or?: InputMaybe<Array<Terms_Of_Use_Bool_Exp>>;
  file?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  release_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  users_terms_of_use_agreeds?: InputMaybe<Users_Terms_Of_Use_Agreed_Bool_Exp>;
};

/** Ordering options when selecting data from "terms_of_use". */
export type Terms_Of_Use_Order_By = {
  file?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  release_date?: InputMaybe<Order_By>;
  users_terms_of_use_agreeds_aggregate?: InputMaybe<Users_Terms_Of_Use_Agreed_Aggregate_Order_By>;
};

/** select columns of table "terms_of_use" */
export enum Terms_Of_Use_Select_Column {
  /** column name */
  File = 'file',
  /** column name */
  Id = 'id',
  /** column name */
  ReleaseDate = 'release_date'
}

/** Streaming cursor of the table "terms_of_use" */
export type Terms_Of_Use_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Terms_Of_Use_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Terms_Of_Use_Stream_Cursor_Value_Input = {
  file?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  release_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type Time_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "tbTiposAgendasRepeticoes" */
export type TiposAgendasRepeticoes = {
  __typename?: 'tiposAgendasRepeticoes';
  codTipoAgendaRepeticao: Scalars['Int']['output'];
  nome?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  usuariosAgendas: Array<UsuariosAgendas>;
};


/** columns and relationships of "tbTiposAgendasRepeticoes" */
export type TiposAgendasRepeticoesUsuariosAgendasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendas_Order_By>>;
  where?: InputMaybe<UsuariosAgendas_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tbTiposAgendasRepeticoes". All fields are combined with a logical 'AND'. */
export type TiposAgendasRepeticoes_Bool_Exp = {
  _and?: InputMaybe<Array<TiposAgendasRepeticoes_Bool_Exp>>;
  _not?: InputMaybe<TiposAgendasRepeticoes_Bool_Exp>;
  _or?: InputMaybe<Array<TiposAgendasRepeticoes_Bool_Exp>>;
  codTipoAgendaRepeticao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  usuariosAgendas?: InputMaybe<UsuariosAgendas_Bool_Exp>;
};

/** Ordering options when selecting data from "tbTiposAgendasRepeticoes". */
export type TiposAgendasRepeticoes_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  usuariosAgendas_aggregate?: InputMaybe<UsuariosAgendas_Aggregate_Order_By>;
};

/** columns and relationships of "tbTiposConvenios" */
export type TiposConvenios = {
  __typename?: 'tiposConvenios';
  codTipoConvenio: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
  sistema: Scalars['Boolean']['output'];
};

/** Boolean expression to filter rows from the table "tbTiposConvenios". All fields are combined with a logical 'AND'. */
export type TiposConvenios_Bool_Exp = {
  _and?: InputMaybe<Array<TiposConvenios_Bool_Exp>>;
  _not?: InputMaybe<TiposConvenios_Bool_Exp>;
  _or?: InputMaybe<Array<TiposConvenios_Bool_Exp>>;
  codTipoConvenio?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  sistema?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbTiposConvenios". */
export type TiposConvenios_Order_By = {
  codTipoConvenio?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  sistema?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbTiposFormasRecebimentos" */
export type TiposFormasRecebimentos = {
  __typename?: 'tiposFormasRecebimentos';
  codTipoFormaRecebimento: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "tbTiposFormasRecebimentos". All fields are combined with a logical 'AND'. */
export type TiposFormasRecebimentos_Bool_Exp = {
  _and?: InputMaybe<Array<TiposFormasRecebimentos_Bool_Exp>>;
  _not?: InputMaybe<TiposFormasRecebimentos_Bool_Exp>;
  _or?: InputMaybe<Array<TiposFormasRecebimentos_Bool_Exp>>;
  codTipoFormaRecebimento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbTiposFormasRecebimentos". */
export type TiposFormasRecebimentos_Order_By = {
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbTiposMovimentacoes" */
export type TiposMovimentacoes = {
  __typename?: 'tiposMovimentacoes';
  /** An array relationship */
  PrecificacoesTiposSalas: Array<PrecificacoesTiposSalas>;
  ativo: Scalars['Boolean']['output'];
  codModalidadeFiscal: Scalars['Int']['output'];
  codTipoMovimentacao: Scalars['Int']['output'];
  codUnidade?: Maybe<Scalars['Int']['output']>;
  identificacao?: Maybe<Scalars['String']['output']>;
  nome: Scalars['String']['output'];
  /** An array relationship */
  planos: Array<Planos>;
  sistema: Scalars['Boolean']['output'];
  tempoUnitario: Scalars['time']['output'];
  tipoOperacao: Scalars['String']['output'];
  /** An array relationship */
  usuariosMovimentacoesRecorrentes: Array<UsuariosMovimentacoesRecorrentes>;
  valorUnitario: Scalars['Float']['output'];
};


/** columns and relationships of "tbTiposMovimentacoes" */
export type TiposMovimentacoesPrecificacoesTiposSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PrecificacoesTiposSalas_Order_By>>;
  where?: InputMaybe<PrecificacoesTiposSalas_Bool_Exp>;
};


/** columns and relationships of "tbTiposMovimentacoes" */
export type TiposMovimentacoesPlanosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Planos_Order_By>>;
  where?: InputMaybe<Planos_Bool_Exp>;
};


/** columns and relationships of "tbTiposMovimentacoes" */
export type TiposMovimentacoesUsuariosMovimentacoesRecorrentesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosMovimentacoesRecorrentes_Order_By>>;
  where?: InputMaybe<UsuariosMovimentacoesRecorrentes_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tbTiposMovimentacoes". All fields are combined with a logical 'AND'. */
export type TiposMovimentacoes_Bool_Exp = {
  PrecificacoesTiposSalas?: InputMaybe<PrecificacoesTiposSalas_Bool_Exp>;
  _and?: InputMaybe<Array<TiposMovimentacoes_Bool_Exp>>;
  _not?: InputMaybe<TiposMovimentacoes_Bool_Exp>;
  _or?: InputMaybe<Array<TiposMovimentacoes_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codModalidadeFiscal?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoMovimentacao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  identificacao?: InputMaybe<String_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  planos?: InputMaybe<Planos_Bool_Exp>;
  sistema?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  tempoUnitario?: InputMaybe<Time_Mssql_Comparison_Exp>;
  tipoOperacao?: InputMaybe<String_Mssql_Comparison_Exp>;
  usuariosMovimentacoesRecorrentes?: InputMaybe<UsuariosMovimentacoesRecorrentes_Bool_Exp>;
  valorUnitario?: InputMaybe<Float_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbTiposMovimentacoes". */
export type TiposMovimentacoes_Order_By = {
  PrecificacoesTiposSalas_aggregate?: InputMaybe<PrecificacoesTiposSalas_Aggregate_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codModalidadeFiscal?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  identificacao?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  planos_aggregate?: InputMaybe<Planos_Aggregate_Order_By>;
  sistema?: InputMaybe<Order_By>;
  tempoUnitario?: InputMaybe<Order_By>;
  tipoOperacao?: InputMaybe<Order_By>;
  usuariosMovimentacoesRecorrentes_aggregate?: InputMaybe<UsuariosMovimentacoesRecorrentes_Aggregate_Order_By>;
  valorUnitario?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbTiposPlanos" */
export type TiposPlanos = {
  __typename?: 'tiposPlanos';
  codTipoPlano: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "tbTiposPlanos". All fields are combined with a logical 'AND'. */
export type TiposPlanos_Bool_Exp = {
  _and?: InputMaybe<Array<TiposPlanos_Bool_Exp>>;
  _not?: InputMaybe<TiposPlanos_Bool_Exp>;
  _or?: InputMaybe<Array<TiposPlanos_Bool_Exp>>;
  codTipoPlano?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbTiposPlanos". */
export type TiposPlanos_Order_By = {
  codTipoPlano?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbTiposSalas" */
export type TiposSalas = {
  __typename?: 'tiposSalas';
  /** An array relationship */
  Especialidades: Array<Especialidades>;
  /** An array relationship */
  Precificacoes: Array<PrecificacoesTiposSalas>;
  alocavel: Scalars['Boolean']['output'];
  codTipoSala: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
  /** An array relationship */
  unidadesPrecosFlexiveis: Array<UnidadesPrecosFlexiveis>;
  /** An aggregate relationship */
  unidadesPrecosFlexiveis_aggregate: UnidadesPrecosFlexiveis_Aggregate;
  /** An array relationship */
  usuariosCompromissosTiposSalas: Array<UsuariosCompromissosTiposSalas>;
  /** An aggregate relationship */
  usuariosCompromissosTiposSalas_aggregate: UsuariosCompromissosTiposSalas_Aggregate;
};


/** columns and relationships of "tbTiposSalas" */
export type TiposSalasEspecialidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Especialidades_Order_By>>;
  where?: InputMaybe<Especialidades_Bool_Exp>;
};


/** columns and relationships of "tbTiposSalas" */
export type TiposSalasPrecificacoesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PrecificacoesTiposSalas_Order_By>>;
  where?: InputMaybe<PrecificacoesTiposSalas_Bool_Exp>;
};


/** columns and relationships of "tbTiposSalas" */
export type TiposSalasUnidadesPrecosFlexiveisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveis_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveis_Bool_Exp>;
};


/** columns and relationships of "tbTiposSalas" */
export type TiposSalasUnidadesPrecosFlexiveis_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPrecosFlexiveis_Order_By>>;
  where?: InputMaybe<UnidadesPrecosFlexiveis_Bool_Exp>;
};


/** columns and relationships of "tbTiposSalas" */
export type TiposSalasUsuariosCompromissosTiposSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};


/** columns and relationships of "tbTiposSalas" */
export type TiposSalasUsuariosCompromissosTiposSalas_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tbTiposSalas". All fields are combined with a logical 'AND'. */
export type TiposSalas_Bool_Exp = {
  Especialidades?: InputMaybe<Especialidades_Bool_Exp>;
  Precificacoes?: InputMaybe<PrecificacoesTiposSalas_Bool_Exp>;
  _and?: InputMaybe<Array<TiposSalas_Bool_Exp>>;
  _not?: InputMaybe<TiposSalas_Bool_Exp>;
  _or?: InputMaybe<Array<TiposSalas_Bool_Exp>>;
  alocavel?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codTipoSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  unidadesPrecosFlexiveis?: InputMaybe<UnidadesPrecosFlexiveis_Bool_Exp>;
  usuariosCompromissosTiposSalas?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};

/** Ordering options when selecting data from "tbTiposSalas". */
export type TiposSalas_Order_By = {
  Especialidades_aggregate?: InputMaybe<Especialidades_Aggregate_Order_By>;
  Precificacoes_aggregate?: InputMaybe<PrecificacoesTiposSalas_Aggregate_Order_By>;
  alocavel?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  unidadesPrecosFlexiveis_aggregate?: InputMaybe<UnidadesPrecosFlexiveis_Aggregate_Order_By>;
  usuariosCompromissosTiposSalas_aggregate?: InputMaybe<UsuariosCompromissosTiposSalas_Aggregate_Order_By>;
};

/** columns and relationships of "tbUnidades" */
export type Unidades = {
  __typename?: 'unidades';
  /** An array relationship */
  UnidadesPoliticasDeHorarios: Array<UnidadesPoliticasDeHorarios>;
  /** An array relationship */
  agendamentos: Array<Agendamentos>;
  /** An aggregate relationship */
  agendamentos_aggregate: Agendamentos_Aggregate;
  ativo: Scalars['Boolean']['output'];
  codUnidade: Scalars['Int']['output'];
  desligarAlocacao: Scalars['Boolean']['output'];
  nome: Scalars['String']['output'];
  nomeLimpo?: Maybe<Scalars['String']['output']>;
  preAlocacaoAtiva: Scalars['Boolean']['output'];
  sigla?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tbUnidades_tbUnidadesSalas: Array<UnidadesSalas>;
  /** An aggregate relationship */
  tbUnidades_tbUnidadesSalas_aggregate: UnidadesSalas_Aggregate;
  /** An array relationship */
  tbUsuariosAgendasUnidades: Array<UsuariosAgendasUnidades>;
  /** An array relationship */
  unidadeHorariosFuncionamentos: Array<UnidadesHorariosFuncionamentos>;
  /** An array relationship */
  usuariosAgendasUnidades: Array<UsuariosAgendasUnidades>;
};


/** columns and relationships of "tbUnidades" */
export type UnidadesUnidadesPoliticasDeHorariosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesPoliticasDeHorarios_Order_By>>;
  where?: InputMaybe<UnidadesPoliticasDeHorarios_Bool_Exp>;
};


/** columns and relationships of "tbUnidades" */
export type UnidadesAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbUnidades" */
export type UnidadesAgendamentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbUnidades" */
export type UnidadesTbUnidades_TbUnidadesSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalas_Order_By>>;
  where?: InputMaybe<UnidadesSalas_Bool_Exp>;
};


/** columns and relationships of "tbUnidades" */
export type UnidadesTbUnidades_TbUnidadesSalas_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesSalas_Order_By>>;
  where?: InputMaybe<UnidadesSalas_Bool_Exp>;
};


/** columns and relationships of "tbUnidades" */
export type UnidadesTbUsuariosAgendasUnidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasUnidades_Order_By>>;
  where?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
};


/** columns and relationships of "tbUnidades" */
export type UnidadesUnidadeHorariosFuncionamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UnidadesHorariosFuncionamentos_Order_By>>;
  where?: InputMaybe<UnidadesHorariosFuncionamentos_Bool_Exp>;
};


/** columns and relationships of "tbUnidades" */
export type UnidadesUsuariosAgendasUnidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasUnidades_Order_By>>;
  where?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
};

/** columns and relationships of "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos = {
  __typename?: 'unidadesHorariosFuncionamentos';
  abertura: Scalars['time']['output'];
  codUnidade: Scalars['Int']['output'];
  codUnidadeHorarioFuncionamento: Scalars['Int']['output'];
  diaSemana: Scalars['Int']['output'];
  fechamento: Scalars['time']['output'];
};

/** order by aggregate values of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Aggregate_Order_By = {
  avg?: InputMaybe<UnidadesHorariosFuncionamentos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UnidadesHorariosFuncionamentos_Max_Order_By>;
  min?: InputMaybe<UnidadesHorariosFuncionamentos_Min_Order_By>;
  stddev?: InputMaybe<UnidadesHorariosFuncionamentos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UnidadesHorariosFuncionamentos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UnidadesHorariosFuncionamentos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UnidadesHorariosFuncionamentos_Sum_Order_By>;
  var_pop?: InputMaybe<UnidadesHorariosFuncionamentos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UnidadesHorariosFuncionamentos_Var_Samp_Order_By>;
  variance?: InputMaybe<UnidadesHorariosFuncionamentos_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Avg_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUnidadesHorariosFuncionamento". All fields are combined with a logical 'AND'. */
export type UnidadesHorariosFuncionamentos_Bool_Exp = {
  _and?: InputMaybe<Array<UnidadesHorariosFuncionamentos_Bool_Exp>>;
  _not?: InputMaybe<UnidadesHorariosFuncionamentos_Bool_Exp>;
  _or?: InputMaybe<Array<UnidadesHorariosFuncionamentos_Bool_Exp>>;
  abertura?: InputMaybe<Time_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  diaSemana?: InputMaybe<Int_Mssql_Comparison_Exp>;
  fechamento?: InputMaybe<Time_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Max_Order_By = {
  abertura?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  fechamento?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Min_Order_By = {
  abertura?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  fechamento?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUnidadesHorariosFuncionamento". */
export type UnidadesHorariosFuncionamentos_Order_By = {
  abertura?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  fechamento?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Stddev_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Stddev_Pop_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Stddev_Samp_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Sum_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Var_Pop_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Var_Samp_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUnidadesHorariosFuncionamento" */
export type UnidadesHorariosFuncionamentos_Variance_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeHorarioFuncionamento?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios = {
  __typename?: 'unidadesPoliticasDeHorarios';
  /** An object relationship */
  Unidade: Unidades;
  ativo: Scalars['Boolean']['output'];
  codUnidade: Scalars['Int']['output'];
  codUnidadePoliticaDeHorario: Scalars['Int']['output'];
  dataInicio: Scalars['datetime2']['output'];
  diaSemana: Scalars['Int']['output'];
  fim: Scalars['time']['output'];
  inicio: Scalars['time']['output'];
  politica: Scalars['Int']['output'];
};

/** order by aggregate values of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Aggregate_Order_By = {
  avg?: InputMaybe<UnidadesPoliticasDeHorarios_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UnidadesPoliticasDeHorarios_Max_Order_By>;
  min?: InputMaybe<UnidadesPoliticasDeHorarios_Min_Order_By>;
  stddev?: InputMaybe<UnidadesPoliticasDeHorarios_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UnidadesPoliticasDeHorarios_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UnidadesPoliticasDeHorarios_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UnidadesPoliticasDeHorarios_Sum_Order_By>;
  var_pop?: InputMaybe<UnidadesPoliticasDeHorarios_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UnidadesPoliticasDeHorarios_Var_Samp_Order_By>;
  variance?: InputMaybe<UnidadesPoliticasDeHorarios_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Avg_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUnidadesPoliticasDeHorarios". All fields are combined with a logical 'AND'. */
export type UnidadesPoliticasDeHorarios_Bool_Exp = {
  Unidade?: InputMaybe<Unidades_Bool_Exp>;
  _and?: InputMaybe<Array<UnidadesPoliticasDeHorarios_Bool_Exp>>;
  _not?: InputMaybe<UnidadesPoliticasDeHorarios_Bool_Exp>;
  _or?: InputMaybe<Array<UnidadesPoliticasDeHorarios_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadePoliticaDeHorario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataInicio?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  diaSemana?: InputMaybe<Int_Mssql_Comparison_Exp>;
  fim?: InputMaybe<Time_Mssql_Comparison_Exp>;
  inicio?: InputMaybe<Time_Mssql_Comparison_Exp>;
  politica?: InputMaybe<Int_Mssql_Comparison_Exp>;
};

/** order by max() on columns of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Max_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  fim?: InputMaybe<Order_By>;
  inicio?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Min_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  fim?: InputMaybe<Order_By>;
  inicio?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUnidadesPoliticasDeHorarios". */
export type UnidadesPoliticasDeHorarios_Order_By = {
  Unidade?: InputMaybe<Unidades_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  fim?: InputMaybe<Order_By>;
  inicio?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** order by stddev() on columns of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Stddev_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Stddev_Pop_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Stddev_Samp_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Sum_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Var_Pop_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Var_Samp_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUnidadesPoliticasDeHorarios" */
export type UnidadesPoliticasDeHorarios_Variance_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUnidadePoliticaDeHorario?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  politica?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUnidadesSalas" */
export type UnidadesSalas = {
  __typename?: 'unidadesSalas';
  /** An object relationship */
  TipoSala: TiposSalas;
  /** An object relationship */
  alocacaoAtiva?: Maybe<AgendamentosAlocacoesAtivas>;
  alocavel: Scalars['Boolean']['output'];
  codTipoSala: Scalars['Int']['output'];
  codUnidade: Scalars['Int']['output'];
  codUnidadeSala: Scalars['Int']['output'];
  codUnidadeSalaStatus: Scalars['Int']['output'];
  nome?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tbUnidadesSalas_tbUnidade: Unidades;
};

/** columns and relationships of "tbUnidadesSalasPeriodosBloqueados" */
export type UnidadesSalasPeriodosBloqueados = {
  __typename?: 'unidadesSalasPeriodosBloqueados';
  /** An object relationship */
  UnidadeSala: UnidadesSalas;
  ativo: Scalars['Boolean']['output'];
  codUnidadeSala: Scalars['Int']['output'];
  codUnidadeSalaPeriodoBloqueado: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  dataFim?: Maybe<Scalars['datetime2']['output']>;
  dataInicio: Scalars['datetime2']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  diaSemana: Scalars['Int']['output'];
  horaFim: Scalars['time']['output'];
  horaInicio: Scalars['time']['output'];
};

/** aggregated selection of "tbUnidadesSalasPeriodosBloqueados" */
export type UnidadesSalasPeriodosBloqueados_Aggregate = {
  __typename?: 'unidadesSalasPeriodosBloqueados_aggregate';
  aggregate?: Maybe<UnidadesSalasPeriodosBloqueados_Aggregate_Fields>;
  nodes: Array<UnidadesSalasPeriodosBloqueados>;
};

/** aggregate fields of "tbUnidadesSalasPeriodosBloqueados" */
export type UnidadesSalasPeriodosBloqueados_Aggregate_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_aggregate_fields';
  avg?: Maybe<UnidadesSalasPeriodosBloqueados_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UnidadesSalasPeriodosBloqueados_Max_Fields>;
  min?: Maybe<UnidadesSalasPeriodosBloqueados_Min_Fields>;
  stddev?: Maybe<UnidadesSalasPeriodosBloqueados_Stddev_Fields>;
  stddev_pop?: Maybe<UnidadesSalasPeriodosBloqueados_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UnidadesSalasPeriodosBloqueados_Stddev_Samp_Fields>;
  sum?: Maybe<UnidadesSalasPeriodosBloqueados_Sum_Fields>;
  var_pop?: Maybe<UnidadesSalasPeriodosBloqueados_Var_Pop_Fields>;
  var_samp?: Maybe<UnidadesSalasPeriodosBloqueados_Var_Samp_Fields>;
  variance?: Maybe<UnidadesSalasPeriodosBloqueados_Variance_Fields>;
};


/** aggregate fields of "tbUnidadesSalasPeriodosBloqueados" */
export type UnidadesSalasPeriodosBloqueados_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<UnidadesSalasPeriodosBloqueados_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type UnidadesSalasPeriodosBloqueados_Avg_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_avg_fields';
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaPeriodoBloqueado?: Maybe<Scalars['Float']['output']>;
  diaSemana?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tbUnidadesSalasPeriodosBloqueados". All fields are combined with a logical 'AND'. */
export type UnidadesSalasPeriodosBloqueados_Bool_Exp = {
  UnidadeSala?: InputMaybe<UnidadesSalas_Bool_Exp>;
  _and?: InputMaybe<Array<UnidadesSalasPeriodosBloqueados_Bool_Exp>>;
  _not?: InputMaybe<UnidadesSalasPeriodosBloqueados_Bool_Exp>;
  _or?: InputMaybe<Array<UnidadesSalasPeriodosBloqueados_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codUnidadeSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadeSalaPeriodoBloqueado?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataFim?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataInicio?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  descricao?: InputMaybe<String_Mssql_Comparison_Exp>;
  diaSemana?: InputMaybe<Int_Mssql_Comparison_Exp>;
  horaFim?: InputMaybe<Time_Mssql_Comparison_Exp>;
  horaInicio?: InputMaybe<Time_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type UnidadesSalasPeriodosBloqueados_Max_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_max_fields';
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  codUnidadeSalaPeriodoBloqueado?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['datetime2']['output']>;
  dataFim?: Maybe<Scalars['datetime2']['output']>;
  dataInicio?: Maybe<Scalars['datetime2']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  diaSemana?: Maybe<Scalars['Int']['output']>;
  horaFim?: Maybe<Scalars['time']['output']>;
  horaInicio?: Maybe<Scalars['time']['output']>;
};

/** aggregate min on columns */
export type UnidadesSalasPeriodosBloqueados_Min_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_min_fields';
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  codUnidadeSalaPeriodoBloqueado?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['datetime2']['output']>;
  dataFim?: Maybe<Scalars['datetime2']['output']>;
  dataInicio?: Maybe<Scalars['datetime2']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  diaSemana?: Maybe<Scalars['Int']['output']>;
  horaFim?: Maybe<Scalars['time']['output']>;
  horaInicio?: Maybe<Scalars['time']['output']>;
};

/** Ordering options when selecting data from "tbUnidadesSalasPeriodosBloqueados". */
export type UnidadesSalasPeriodosBloqueados_Order_By = {
  UnidadeSala?: InputMaybe<UnidadesSalas_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaPeriodoBloqueado?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataFim?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  diaSemana?: InputMaybe<Order_By>;
  horaFim?: InputMaybe<Order_By>;
  horaInicio?: InputMaybe<Order_By>;
};

/** select columns of table "tbUnidadesSalasPeriodosBloqueados" */
export enum UnidadesSalasPeriodosBloqueados_Select_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  CodUnidadeSala = 'codUnidadeSala',
  /** column name */
  CodUnidadeSalaPeriodoBloqueado = 'codUnidadeSalaPeriodoBloqueado',
  /** column name */
  DataCadastro = 'dataCadastro',
  /** column name */
  DataFim = 'dataFim',
  /** column name */
  DataInicio = 'dataInicio',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  DiaSemana = 'diaSemana',
  /** column name */
  HoraFim = 'horaFim',
  /** column name */
  HoraInicio = 'horaInicio'
}

/** aggregate stddev on columns */
export type UnidadesSalasPeriodosBloqueados_Stddev_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_stddev_fields';
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaPeriodoBloqueado?: Maybe<Scalars['Float']['output']>;
  diaSemana?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type UnidadesSalasPeriodosBloqueados_Stddev_Pop_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_stddev_pop_fields';
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaPeriodoBloqueado?: Maybe<Scalars['Float']['output']>;
  diaSemana?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type UnidadesSalasPeriodosBloqueados_Stddev_Samp_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_stddev_samp_fields';
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaPeriodoBloqueado?: Maybe<Scalars['Float']['output']>;
  diaSemana?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type UnidadesSalasPeriodosBloqueados_Sum_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_sum_fields';
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  codUnidadeSalaPeriodoBloqueado?: Maybe<Scalars['Int']['output']>;
  diaSemana?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type UnidadesSalasPeriodosBloqueados_Var_Pop_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_var_pop_fields';
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaPeriodoBloqueado?: Maybe<Scalars['Float']['output']>;
  diaSemana?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type UnidadesSalasPeriodosBloqueados_Var_Samp_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_var_samp_fields';
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaPeriodoBloqueado?: Maybe<Scalars['Float']['output']>;
  diaSemana?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type UnidadesSalasPeriodosBloqueados_Variance_Fields = {
  __typename?: 'unidadesSalasPeriodosBloqueados_variance_fields';
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaPeriodoBloqueado?: Maybe<Scalars['Float']['output']>;
  diaSemana?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "tbUnidadesSalas" */
export type UnidadesSalas_Aggregate = {
  __typename?: 'unidadesSalas_aggregate';
  aggregate?: Maybe<UnidadesSalas_Aggregate_Fields>;
  nodes: Array<UnidadesSalas>;
};

/** aggregate fields of "tbUnidadesSalas" */
export type UnidadesSalas_Aggregate_Fields = {
  __typename?: 'unidadesSalas_aggregate_fields';
  avg?: Maybe<UnidadesSalas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UnidadesSalas_Max_Fields>;
  min?: Maybe<UnidadesSalas_Min_Fields>;
  stddev?: Maybe<UnidadesSalas_Stddev_Fields>;
  stddev_pop?: Maybe<UnidadesSalas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UnidadesSalas_Stddev_Samp_Fields>;
  sum?: Maybe<UnidadesSalas_Sum_Fields>;
  var_pop?: Maybe<UnidadesSalas_Var_Pop_Fields>;
  var_samp?: Maybe<UnidadesSalas_Var_Samp_Fields>;
  variance?: Maybe<UnidadesSalas_Variance_Fields>;
};


/** aggregate fields of "tbUnidadesSalas" */
export type UnidadesSalas_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<UnidadesSalas_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbUnidadesSalas" */
export type UnidadesSalas_Aggregate_Order_By = {
  avg?: InputMaybe<UnidadesSalas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UnidadesSalas_Max_Order_By>;
  min?: InputMaybe<UnidadesSalas_Min_Order_By>;
  stddev?: InputMaybe<UnidadesSalas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UnidadesSalas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UnidadesSalas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UnidadesSalas_Sum_Order_By>;
  var_pop?: InputMaybe<UnidadesSalas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UnidadesSalas_Var_Samp_Order_By>;
  variance?: InputMaybe<UnidadesSalas_Variance_Order_By>;
};

/** aggregate avg on columns */
export type UnidadesSalas_Avg_Fields = {
  __typename?: 'unidadesSalas_avg_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaStatus?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbUnidadesSalas" */
export type UnidadesSalas_Avg_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUnidadesSalas". All fields are combined with a logical 'AND'. */
export type UnidadesSalas_Bool_Exp = {
  TipoSala?: InputMaybe<TiposSalas_Bool_Exp>;
  _and?: InputMaybe<Array<UnidadesSalas_Bool_Exp>>;
  _not?: InputMaybe<UnidadesSalas_Bool_Exp>;
  _or?: InputMaybe<Array<UnidadesSalas_Bool_Exp>>;
  alocacaoAtiva?: InputMaybe<AgendamentosAlocacoesAtivas_Bool_Exp>;
  alocavel?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codTipoSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadeSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidadeSalaStatus?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  tbUnidadesSalas_tbUnidade?: InputMaybe<Unidades_Bool_Exp>;
};

/** aggregate max on columns */
export type UnidadesSalas_Max_Fields = {
  __typename?: 'unidadesSalas_max_fields';
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  codUnidadeSalaStatus?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tbUnidadesSalas" */
export type UnidadesSalas_Max_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UnidadesSalas_Min_Fields = {
  __typename?: 'unidadesSalas_min_fields';
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  codUnidadeSalaStatus?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tbUnidadesSalas" */
export type UnidadesSalas_Min_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUnidadesSalas". */
export type UnidadesSalas_Order_By = {
  TipoSala?: InputMaybe<TiposSalas_Order_By>;
  alocacaoAtiva?: InputMaybe<AgendamentosAlocacoesAtivas_Order_By>;
  alocavel?: InputMaybe<Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  tbUnidadesSalas_tbUnidade?: InputMaybe<Unidades_Order_By>;
};

/** select columns of table "tbUnidadesSalas" */
export enum UnidadesSalas_Select_Column {
  /** column name */
  Alocavel = 'alocavel',
  /** column name */
  CodTipoSala = 'codTipoSala',
  /** column name */
  CodUnidade = 'codUnidade',
  /** column name */
  CodUnidadeSala = 'codUnidadeSala',
  /** column name */
  CodUnidadeSalaStatus = 'codUnidadeSalaStatus',
  /** column name */
  Nome = 'nome'
}

/** aggregate stddev on columns */
export type UnidadesSalas_Stddev_Fields = {
  __typename?: 'unidadesSalas_stddev_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaStatus?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbUnidadesSalas" */
export type UnidadesSalas_Stddev_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UnidadesSalas_Stddev_Pop_Fields = {
  __typename?: 'unidadesSalas_stddev_pop_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaStatus?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbUnidadesSalas" */
export type UnidadesSalas_Stddev_Pop_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UnidadesSalas_Stddev_Samp_Fields = {
  __typename?: 'unidadesSalas_stddev_samp_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaStatus?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbUnidadesSalas" */
export type UnidadesSalas_Stddev_Samp_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type UnidadesSalas_Sum_Fields = {
  __typename?: 'unidadesSalas_sum_fields';
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUnidadeSala?: Maybe<Scalars['Int']['output']>;
  codUnidadeSalaStatus?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tbUnidadesSalas" */
export type UnidadesSalas_Sum_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type UnidadesSalas_Var_Pop_Fields = {
  __typename?: 'unidadesSalas_var_pop_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaStatus?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbUnidadesSalas" */
export type UnidadesSalas_Var_Pop_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UnidadesSalas_Var_Samp_Fields = {
  __typename?: 'unidadesSalas_var_samp_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaStatus?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbUnidadesSalas" */
export type UnidadesSalas_Var_Samp_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UnidadesSalas_Variance_Fields = {
  __typename?: 'unidadesSalas_variance_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUnidade?: Maybe<Scalars['Float']['output']>;
  codUnidadeSala?: Maybe<Scalars['Float']['output']>;
  codUnidadeSalaStatus?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbUnidadesSalas" */
export type UnidadesSalas_Variance_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUnidadeSala?: InputMaybe<Order_By>;
  codUnidadeSalaStatus?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUnidades". All fields are combined with a logical 'AND'. */
export type Unidades_Bool_Exp = {
  UnidadesPoliticasDeHorarios?: InputMaybe<UnidadesPoliticasDeHorarios_Bool_Exp>;
  _and?: InputMaybe<Array<Unidades_Bool_Exp>>;
  _not?: InputMaybe<Unidades_Bool_Exp>;
  _or?: InputMaybe<Array<Unidades_Bool_Exp>>;
  agendamentos?: InputMaybe<Agendamentos_Bool_Exp>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  desligarAlocacao?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  nomeLimpo?: InputMaybe<String_Mssql_Comparison_Exp>;
  preAlocacaoAtiva?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  sigla?: InputMaybe<String_Mssql_Comparison_Exp>;
  tbUnidades_tbUnidadesSalas?: InputMaybe<UnidadesSalas_Bool_Exp>;
  tbUsuariosAgendasUnidades?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
  unidadeHorariosFuncionamentos?: InputMaybe<UnidadesHorariosFuncionamentos_Bool_Exp>;
  usuariosAgendasUnidades?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
};

/** Ordering options when selecting data from "tbUnidades". */
export type Unidades_Order_By = {
  UnidadesPoliticasDeHorarios_aggregate?: InputMaybe<UnidadesPoliticasDeHorarios_Aggregate_Order_By>;
  agendamentos_aggregate?: InputMaybe<Agendamentos_Aggregate_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  desligarAlocacao?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  nomeLimpo?: InputMaybe<Order_By>;
  preAlocacaoAtiva?: InputMaybe<Order_By>;
  sigla?: InputMaybe<Order_By>;
  tbUnidades_tbUnidadesSalas_aggregate?: InputMaybe<UnidadesSalas_Aggregate_Order_By>;
  tbUsuariosAgendasUnidades_aggregate?: InputMaybe<UsuariosAgendasUnidades_Aggregate_Order_By>;
  unidadeHorariosFuncionamentos_aggregate?: InputMaybe<UnidadesHorariosFuncionamentos_Aggregate_Order_By>;
  usuariosAgendasUnidades_aggregate?: InputMaybe<UsuariosAgendasUnidades_Aggregate_Order_By>;
};

/** Boolean expression to compare columns of type "uniqueidentifier". All fields are combined with logical 'AND'. */
export type Uniqueidentifier_Mssql_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _gt?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _gte?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _in?: InputMaybe<Array<Scalars['uniqueidentifier']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _lte?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _neq?: InputMaybe<Scalars['uniqueidentifier']['input']>;
  _nin?: InputMaybe<Array<Scalars['uniqueidentifier']['input']>>;
};

/** columns and relationships of "units" */
export type Units = {
  __typename?: 'units';
  active?: Maybe<Scalars['Boolean']['output']>;
  address_complement?: Maybe<Scalars['String']['output']>;
  allow_onboarding?: Maybe<Scalars['Boolean']['output']>;
  allow_visit?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  city_description?: Maybe<Scalars['String']['output']>;
  city_id?: Maybe<Scalars['Int']['output']>;
  city_zip_code?: Maybe<Scalars['String']['output']>;
  full_address?: Maybe<Scalars['String']['output']>;
  has_go_room?: Maybe<Scalars['Boolean']['output']>;
  has_multi_room?: Maybe<Scalars['Boolean']['output']>;
  has_psico_room?: Maybe<Scalars['Boolean']['output']>;
  has_tele_room?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  neighborhood?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  opening_date: Scalars['timestamptz']['output'];
  reference_point?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  uf?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "units". All fields are combined with a logical 'AND'. */
export type Units_Bool_Exp = {
  _and?: InputMaybe<Array<Units_Bool_Exp>>;
  _not?: InputMaybe<Units_Bool_Exp>;
  _or?: InputMaybe<Array<Units_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  address_complement?: InputMaybe<String_Comparison_Exp>;
  allow_onboarding?: InputMaybe<Boolean_Comparison_Exp>;
  allow_visit?: InputMaybe<Boolean_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  city_description?: InputMaybe<String_Comparison_Exp>;
  city_id?: InputMaybe<Int_Comparison_Exp>;
  city_zip_code?: InputMaybe<String_Comparison_Exp>;
  full_address?: InputMaybe<String_Comparison_Exp>;
  has_go_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_multi_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_psico_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_tele_room?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighborhood?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  observation?: InputMaybe<String_Comparison_Exp>;
  opening_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  reference_point?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  uf?: InputMaybe<String_Comparison_Exp>;
  zip_code?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "units". */
export type Units_Order_By = {
  active?: InputMaybe<Order_By>;
  address_complement?: InputMaybe<Order_By>;
  allow_onboarding?: InputMaybe<Order_By>;
  allow_visit?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  city_description?: InputMaybe<Order_By>;
  city_id?: InputMaybe<Order_By>;
  city_zip_code?: InputMaybe<Order_By>;
  full_address?: InputMaybe<Order_By>;
  has_go_room?: InputMaybe<Order_By>;
  has_multi_room?: InputMaybe<Order_By>;
  has_psico_room?: InputMaybe<Order_By>;
  has_tele_room?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighborhood?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  observation?: InputMaybe<Order_By>;
  opening_date?: InputMaybe<Order_By>;
  reference_point?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  uf?: InputMaybe<Order_By>;
  zip_code?: InputMaybe<Order_By>;
};

/** select columns of table "units" */
export enum Units_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  AddressComplement = 'address_complement',
  /** column name */
  AllowOnboarding = 'allow_onboarding',
  /** column name */
  AllowVisit = 'allow_visit',
  /** column name */
  City = 'city',
  /** column name */
  CityDescription = 'city_description',
  /** column name */
  CityId = 'city_id',
  /** column name */
  CityZipCode = 'city_zip_code',
  /** column name */
  FullAddress = 'full_address',
  /** column name */
  HasGoRoom = 'has_go_room',
  /** column name */
  HasMultiRoom = 'has_multi_room',
  /** column name */
  HasPsicoRoom = 'has_psico_room',
  /** column name */
  HasTeleRoom = 'has_tele_room',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Neighborhood = 'neighborhood',
  /** column name */
  Number = 'number',
  /** column name */
  Observation = 'observation',
  /** column name */
  OpeningDate = 'opening_date',
  /** column name */
  ReferencePoint = 'reference_point',
  /** column name */
  Street = 'street',
  /** column name */
  Uf = 'uf',
  /** column name */
  ZipCode = 'zip_code'
}

/** Streaming cursor of the table "units" */
export type Units_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Units_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Units_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address_complement?: InputMaybe<Scalars['String']['input']>;
  allow_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  allow_visit?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  city_description?: InputMaybe<Scalars['String']['input']>;
  city_id?: InputMaybe<Scalars['Int']['input']>;
  city_zip_code?: InputMaybe<Scalars['String']['input']>;
  full_address?: InputMaybe<Scalars['String']['input']>;
  has_go_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_multi_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_psico_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_tele_room?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  observation?: InputMaybe<Scalars['String']['input']>;
  opening_date?: InputMaybe<Scalars['timestamptz']['input']>;
  reference_point?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  uf?: InputMaybe<Scalars['String']['input']>;
  zip_code?: InputMaybe<Scalars['String']['input']>;
};

/** Tabela para armazenar os endereços dos usuários */
export type User_Addresses = {
  __typename?: 'user_addresses';
  addressType: Scalars['String']['output'];
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  street?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
  zipCode: Scalars['String']['output'];
};

/** order by aggregate values of table "user_addresses" */
export type User_Addresses_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Addresses_Max_Order_By>;
  min?: InputMaybe<User_Addresses_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "user_addresses". All fields are combined with a logical 'AND'. */
export type User_Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<User_Addresses_Bool_Exp>>;
  _not?: InputMaybe<User_Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<User_Addresses_Bool_Exp>>;
  addressType?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  complement?: InputMaybe<String_Comparison_Exp>;
  neighborhood?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  zipCode?: InputMaybe<String_Comparison_Exp>;
};

/** order by max() on columns of table "user_addresses" */
export type User_Addresses_Max_Order_By = {
  addressType?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  complement?: InputMaybe<Order_By>;
  neighborhood?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  zipCode?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_addresses" */
export type User_Addresses_Min_Order_By = {
  addressType?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  complement?: InputMaybe<Order_By>;
  neighborhood?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  zipCode?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_addresses" */
export type User_Addresses_Mutation_Response = {
  __typename?: 'user_addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Addresses>;
};

/** Ordering options when selecting data from "user_addresses". */
export type User_Addresses_Order_By = {
  addressType?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  complement?: InputMaybe<Order_By>;
  neighborhood?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  zipCode?: InputMaybe<Order_By>;
};

/** select columns of table "user_addresses" */
export enum User_Addresses_Select_Column {
  /** column name */
  AddressType = 'addressType',
  /** column name */
  City = 'city',
  /** column name */
  Complement = 'complement',
  /** column name */
  Neighborhood = 'neighborhood',
  /** column name */
  Number = 'number',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  ZipCode = 'zipCode'
}

/** input type for updating data in table "user_addresses" */
export type User_Addresses_Set_Input = {
  addressType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "user_addresses" */
export type User_Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Addresses_Stream_Cursor_Value_Input = {
  addressType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  complement?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type User_Addresses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Addresses_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Addresses_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  account_number?: Maybe<Scalars['String']['output']>;
  account_type?: Maybe<Scalars['Int']['output']>;
  address_complement?: Maybe<Scalars['String']['output']>;
  agency_number?: Maybe<Scalars['String']['output']>;
  bank_ispb?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['String']['output']>;
  blocking_id?: Maybe<Scalars['Int']['output']>;
  cep?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamp']['output'];
  disqualified: Scalars['Boolean']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  domain_option?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  livance_core_id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Int']['output']>;
  onboarding_location?: Maybe<Scalars['String']['output']>;
  onboarding_scheduled_visit?: Maybe<Scalars['timestamptz']['output']>;
  phone: Scalars['String']['output'];
  pipedrive_deal_id?: Maybe<Scalars['Int']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['Int']['output']>;
  preferred_unit_id?: Maybe<Scalars['Int']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  professional_card_council?: Maybe<Scalars['String']['output']>;
  professional_card_council_state?: Maybe<Scalars['String']['output']>;
  professional_card_register_number?: Maybe<Scalars['String']['output']>;
  professional_card_specialty?: Maybe<Scalars['String']['output']>;
  professional_card_subspecialty?: Maybe<Scalars['String']['output']>;
  redirect_to_admin?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  referrals: Array<Referrals>;
  rg?: Maybe<Scalars['String']['output']>;
  rg_issuing_body?: Maybe<Scalars['String']['output']>;
  rg_state?: Maybe<Scalars['String']['output']>;
  scheduled_visit?: Maybe<Scalars['timestamptz']['output']>;
  selectedPlan?: Maybe<Scalars['Int']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  unit?: Maybe<Units>;
  /** An array relationship */
  userAddresses: Array<User_Addresses>;
  /** An array relationship */
  users_professional_ids: Array<Users_Professional_Cards>;
  /** An aggregate relationship */
  users_professional_ids_aggregate: Users_Professional_Cards_Aggregate;
  /** An array relationship */
  users_providers: Array<Users_Provider>;
  /** An array relationship */
  users_terms_of_use_agreeds: Array<Users_Terms_Of_Use_Agreed>;
  visit_id?: Maybe<Scalars['Int']['output']>;
  want_visit?: Maybe<Scalars['Boolean']['output']>;
  workspace_email?: Maybe<Scalars['String']['output']>;
  workspace_email_option?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "users" */
export type UsersReferralsArgs = {
  distinct_on?: InputMaybe<Array<Referrals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Referrals_Order_By>>;
  where?: InputMaybe<Referrals_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserAddressesArgs = {
  distinct_on?: InputMaybe<Array<User_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Addresses_Order_By>>;
  where?: InputMaybe<User_Addresses_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Professional_IdsArgs = {
  distinct_on?: InputMaybe<Array<Users_Professional_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Professional_Cards_Order_By>>;
  where?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Professional_Ids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Professional_Cards_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Professional_Cards_Order_By>>;
  where?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_ProvidersArgs = {
  distinct_on?: InputMaybe<Array<Users_Provider_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Provider_Order_By>>;
  where?: InputMaybe<Users_Provider_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsers_Terms_Of_Use_AgreedsArgs = {
  distinct_on?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Order_By>>;
  where?: InputMaybe<Users_Terms_Of_Use_Agreed_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  account_type?: Maybe<Scalars['Float']['output']>;
  blocking_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  livance_core_id?: Maybe<Scalars['Float']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_deal_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Float']['output']>;
  planId?: Maybe<Scalars['Float']['output']>;
  preferred_unit_id?: Maybe<Scalars['Float']['output']>;
  selectedPlan?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  visit_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  account_number?: InputMaybe<String_Comparison_Exp>;
  account_type?: InputMaybe<Int_Comparison_Exp>;
  address_complement?: InputMaybe<String_Comparison_Exp>;
  agency_number?: InputMaybe<String_Comparison_Exp>;
  bank_ispb?: InputMaybe<String_Comparison_Exp>;
  birthdate?: InputMaybe<String_Comparison_Exp>;
  blocking_id?: InputMaybe<Int_Comparison_Exp>;
  cep?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  cnpj?: InputMaybe<String_Comparison_Exp>;
  cpf?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  disqualified?: InputMaybe<Boolean_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  domain_option?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  last_login?: InputMaybe<Timestamptz_Comparison_Exp>;
  livance_core_id?: InputMaybe<Int_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighborhood?: InputMaybe<String_Comparison_Exp>;
  onboarding_blocking_id?: InputMaybe<Int_Comparison_Exp>;
  onboarding_location?: InputMaybe<String_Comparison_Exp>;
  onboarding_scheduled_visit?: InputMaybe<Timestamptz_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  pipedrive_deal_id?: InputMaybe<Int_Comparison_Exp>;
  pipedrive_person_id?: InputMaybe<Int_Comparison_Exp>;
  plan?: InputMaybe<String_Comparison_Exp>;
  planId?: InputMaybe<Int_Comparison_Exp>;
  preferred_unit_id?: InputMaybe<Int_Comparison_Exp>;
  profession?: InputMaybe<String_Comparison_Exp>;
  professional_card_council?: InputMaybe<String_Comparison_Exp>;
  professional_card_council_state?: InputMaybe<String_Comparison_Exp>;
  professional_card_register_number?: InputMaybe<String_Comparison_Exp>;
  professional_card_specialty?: InputMaybe<String_Comparison_Exp>;
  professional_card_subspecialty?: InputMaybe<String_Comparison_Exp>;
  redirect_to_admin?: InputMaybe<Boolean_Comparison_Exp>;
  referrals?: InputMaybe<Referrals_Bool_Exp>;
  rg?: InputMaybe<String_Comparison_Exp>;
  rg_issuing_body?: InputMaybe<String_Comparison_Exp>;
  rg_state?: InputMaybe<String_Comparison_Exp>;
  scheduled_visit?: InputMaybe<Timestamptz_Comparison_Exp>;
  selectedPlan?: InputMaybe<Int_Comparison_Exp>;
  specialty?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  step?: InputMaybe<Int_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  unit?: InputMaybe<Units_Bool_Exp>;
  userAddresses?: InputMaybe<User_Addresses_Bool_Exp>;
  users_professional_ids?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
  users_professional_ids_aggregate?: InputMaybe<Users_Professional_Cards_Aggregate_Bool_Exp>;
  users_providers?: InputMaybe<Users_Provider_Bool_Exp>;
  users_terms_of_use_agreeds?: InputMaybe<Users_Terms_Of_Use_Agreed_Bool_Exp>;
  visit_id?: InputMaybe<Int_Comparison_Exp>;
  want_visit?: InputMaybe<Boolean_Comparison_Exp>;
  workspace_email?: InputMaybe<String_Comparison_Exp>;
  workspace_email_option?: InputMaybe<String_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  account_type?: InputMaybe<Scalars['Int']['input']>;
  blocking_id?: InputMaybe<Scalars['Int']['input']>;
  onboarding_blocking_id?: InputMaybe<Scalars['Int']['input']>;
  pipedrive_deal_id?: InputMaybe<Scalars['Int']['input']>;
  pipedrive_person_id?: InputMaybe<Scalars['Int']['input']>;
  preferred_unit_id?: InputMaybe<Scalars['Int']['input']>;
  selectedPlan?: InputMaybe<Scalars['Int']['input']>;
  step?: InputMaybe<Scalars['Int']['input']>;
  visit_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  account_number?: Maybe<Scalars['String']['output']>;
  account_type?: Maybe<Scalars['Int']['output']>;
  address_complement?: Maybe<Scalars['String']['output']>;
  agency_number?: Maybe<Scalars['String']['output']>;
  bank_ispb?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['String']['output']>;
  blocking_id?: Maybe<Scalars['Int']['output']>;
  cep?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  domain_option?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  livance_core_id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Int']['output']>;
  onboarding_location?: Maybe<Scalars['String']['output']>;
  onboarding_scheduled_visit?: Maybe<Scalars['timestamptz']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pipedrive_deal_id?: Maybe<Scalars['Int']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['Int']['output']>;
  preferred_unit_id?: Maybe<Scalars['Int']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  professional_card_council?: Maybe<Scalars['String']['output']>;
  professional_card_council_state?: Maybe<Scalars['String']['output']>;
  professional_card_register_number?: Maybe<Scalars['String']['output']>;
  professional_card_specialty?: Maybe<Scalars['String']['output']>;
  professional_card_subspecialty?: Maybe<Scalars['String']['output']>;
  rg?: Maybe<Scalars['String']['output']>;
  rg_issuing_body?: Maybe<Scalars['String']['output']>;
  rg_state?: Maybe<Scalars['String']['output']>;
  scheduled_visit?: Maybe<Scalars['timestamptz']['output']>;
  selectedPlan?: Maybe<Scalars['Int']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  visit_id?: Maybe<Scalars['Int']['output']>;
  workspace_email?: Maybe<Scalars['String']['output']>;
  workspace_email_option?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  account_number?: Maybe<Scalars['String']['output']>;
  account_type?: Maybe<Scalars['Int']['output']>;
  address_complement?: Maybe<Scalars['String']['output']>;
  agency_number?: Maybe<Scalars['String']['output']>;
  bank_ispb?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['String']['output']>;
  blocking_id?: Maybe<Scalars['Int']['output']>;
  cep?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamp']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  domain_option?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  last_login?: Maybe<Scalars['timestamptz']['output']>;
  livance_core_id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Int']['output']>;
  onboarding_location?: Maybe<Scalars['String']['output']>;
  onboarding_scheduled_visit?: Maybe<Scalars['timestamptz']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pipedrive_deal_id?: Maybe<Scalars['Int']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Int']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<Scalars['Int']['output']>;
  preferred_unit_id?: Maybe<Scalars['Int']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  professional_card_council?: Maybe<Scalars['String']['output']>;
  professional_card_council_state?: Maybe<Scalars['String']['output']>;
  professional_card_register_number?: Maybe<Scalars['String']['output']>;
  professional_card_specialty?: Maybe<Scalars['String']['output']>;
  professional_card_subspecialty?: Maybe<Scalars['String']['output']>;
  rg?: Maybe<Scalars['String']['output']>;
  rg_issuing_body?: Maybe<Scalars['String']['output']>;
  rg_state?: Maybe<Scalars['String']['output']>;
  scheduled_visit?: Maybe<Scalars['timestamptz']['output']>;
  selectedPlan?: Maybe<Scalars['Int']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  visit_id?: Maybe<Scalars['Int']['output']>;
  workspace_email?: Maybe<Scalars['String']['output']>;
  workspace_email_option?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  account_number?: InputMaybe<Order_By>;
  account_type?: InputMaybe<Order_By>;
  address_complement?: InputMaybe<Order_By>;
  agency_number?: InputMaybe<Order_By>;
  bank_ispb?: InputMaybe<Order_By>;
  birthdate?: InputMaybe<Order_By>;
  blocking_id?: InputMaybe<Order_By>;
  cep?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  cnpj?: InputMaybe<Order_By>;
  cpf?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  disqualified?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  domain_option?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_login?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighborhood?: InputMaybe<Order_By>;
  onboarding_blocking_id?: InputMaybe<Order_By>;
  onboarding_location?: InputMaybe<Order_By>;
  onboarding_scheduled_visit?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  pipedrive_deal_id?: InputMaybe<Order_By>;
  pipedrive_person_id?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  planId?: InputMaybe<Order_By>;
  preferred_unit_id?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  professional_card_council?: InputMaybe<Order_By>;
  professional_card_council_state?: InputMaybe<Order_By>;
  professional_card_register_number?: InputMaybe<Order_By>;
  professional_card_specialty?: InputMaybe<Order_By>;
  professional_card_subspecialty?: InputMaybe<Order_By>;
  redirect_to_admin?: InputMaybe<Order_By>;
  referrals_aggregate?: InputMaybe<Referrals_Aggregate_Order_By>;
  rg?: InputMaybe<Order_By>;
  rg_issuing_body?: InputMaybe<Order_By>;
  rg_state?: InputMaybe<Order_By>;
  scheduled_visit?: InputMaybe<Order_By>;
  selectedPlan?: InputMaybe<Order_By>;
  specialty?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  step?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  unit?: InputMaybe<Units_Order_By>;
  userAddresses_aggregate?: InputMaybe<User_Addresses_Aggregate_Order_By>;
  users_professional_ids_aggregate?: InputMaybe<Users_Professional_Cards_Aggregate_Order_By>;
  users_providers_aggregate?: InputMaybe<Users_Provider_Aggregate_Order_By>;
  users_terms_of_use_agreeds_aggregate?: InputMaybe<Users_Terms_Of_Use_Agreed_Aggregate_Order_By>;
  visit_id?: InputMaybe<Order_By>;
  want_visit?: InputMaybe<Order_By>;
  workspace_email?: InputMaybe<Order_By>;
  workspace_email_option?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** Users professional ids */
export type Users_Professional_Cards = {
  __typename?: 'users_professional_cards';
  created_at: Scalars['timestamptz']['output'];
  document_side: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['Int']['output'];
};

/** aggregated selection of "users_professional_cards" */
export type Users_Professional_Cards_Aggregate = {
  __typename?: 'users_professional_cards_aggregate';
  aggregate?: Maybe<Users_Professional_Cards_Aggregate_Fields>;
  nodes: Array<Users_Professional_Cards>;
};

export type Users_Professional_Cards_Aggregate_Bool_Exp = {
  count?: InputMaybe<Users_Professional_Cards_Aggregate_Bool_Exp_Count>;
};

export type Users_Professional_Cards_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Professional_Cards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users_professional_cards" */
export type Users_Professional_Cards_Aggregate_Fields = {
  __typename?: 'users_professional_cards_aggregate_fields';
  avg?: Maybe<Users_Professional_Cards_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Professional_Cards_Max_Fields>;
  min?: Maybe<Users_Professional_Cards_Min_Fields>;
  stddev?: Maybe<Users_Professional_Cards_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Professional_Cards_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Professional_Cards_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Professional_Cards_Sum_Fields>;
  var_pop?: Maybe<Users_Professional_Cards_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Professional_Cards_Var_Samp_Fields>;
  variance?: Maybe<Users_Professional_Cards_Variance_Fields>;
};


/** aggregate fields of "users_professional_cards" */
export type Users_Professional_Cards_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Professional_Cards_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users_professional_cards" */
export type Users_Professional_Cards_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Professional_Cards_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Professional_Cards_Max_Order_By>;
  min?: InputMaybe<Users_Professional_Cards_Min_Order_By>;
  stddev?: InputMaybe<Users_Professional_Cards_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Professional_Cards_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Professional_Cards_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Professional_Cards_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Professional_Cards_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Professional_Cards_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Professional_Cards_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Users_Professional_Cards_Avg_Fields = {
  __typename?: 'users_professional_cards_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users_professional_cards" */
export type Users_Professional_Cards_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_professional_cards". All fields are combined with a logical 'AND'. */
export type Users_Professional_Cards_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Professional_Cards_Bool_Exp>>;
  _not?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Professional_Cards_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_side?: InputMaybe<String_Comparison_Exp>;
  filename?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_professional_cards" */
export enum Users_Professional_Cards_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersProfessionalIdsPkey = 'users_professional_ids_pkey'
}

/** input type for inserting data into table "users_professional_cards" */
export type Users_Professional_Cards_Insert_Input = {
  document_side?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Users_Professional_Cards_Max_Fields = {
  __typename?: 'users_professional_cards_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_side?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "users_professional_cards" */
export type Users_Professional_Cards_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_side?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Professional_Cards_Min_Fields = {
  __typename?: 'users_professional_cards_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  document_side?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "users_professional_cards" */
export type Users_Professional_Cards_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_side?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_professional_cards" */
export type Users_Professional_Cards_Mutation_Response = {
  __typename?: 'users_professional_cards_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Professional_Cards>;
};

/** on_conflict condition type for table "users_professional_cards" */
export type Users_Professional_Cards_On_Conflict = {
  constraint: Users_Professional_Cards_Constraint;
  update_columns?: Array<Users_Professional_Cards_Update_Column>;
  where?: InputMaybe<Users_Professional_Cards_Bool_Exp>;
};

/** Ordering options when selecting data from "users_professional_cards". */
export type Users_Professional_Cards_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_side?: InputMaybe<Order_By>;
  filename?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users_professional_cards */
export type Users_Professional_Cards_Pk_Columns_Input = {
  id: Scalars['Int']['input'];
};

/** select columns of table "users_professional_cards" */
export enum Users_Professional_Cards_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentSide = 'document_side',
  /** column name */
  Filename = 'filename',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "users_professional_cards" */
export type Users_Professional_Cards_Set_Input = {
  document_side?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Users_Professional_Cards_Stddev_Fields = {
  __typename?: 'users_professional_cards_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users_professional_cards" */
export type Users_Professional_Cards_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Professional_Cards_Stddev_Pop_Fields = {
  __typename?: 'users_professional_cards_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users_professional_cards" */
export type Users_Professional_Cards_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Professional_Cards_Stddev_Samp_Fields = {
  __typename?: 'users_professional_cards_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users_professional_cards" */
export type Users_Professional_Cards_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users_professional_cards" */
export type Users_Professional_Cards_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Professional_Cards_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Professional_Cards_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_side?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Users_Professional_Cards_Sum_Fields = {
  __typename?: 'users_professional_cards_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users_professional_cards" */
export type Users_Professional_Cards_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** update columns of table "users_professional_cards" */
export enum Users_Professional_Cards_Update_Column {
  /** column name */
  DocumentSide = 'document_side',
  /** column name */
  Filename = 'filename'
}

export type Users_Professional_Cards_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Professional_Cards_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Professional_Cards_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Professional_Cards_Var_Pop_Fields = {
  __typename?: 'users_professional_cards_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users_professional_cards" */
export type Users_Professional_Cards_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Professional_Cards_Var_Samp_Fields = {
  __typename?: 'users_professional_cards_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users_professional_cards" */
export type Users_Professional_Cards_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Professional_Cards_Variance_Fields = {
  __typename?: 'users_professional_cards_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users_professional_cards" */
export type Users_Professional_Cards_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "users_provider" */
export type Users_Provider = {
  __typename?: 'users_provider';
  sub_id: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "users_provider" */
export type Users_Provider_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Provider_Max_Order_By>;
  min?: InputMaybe<Users_Provider_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "users_provider". All fields are combined with a logical 'AND'. */
export type Users_Provider_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Provider_Bool_Exp>>;
  _not?: InputMaybe<Users_Provider_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Provider_Bool_Exp>>;
  sub_id?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "users_provider" */
export type Users_Provider_Max_Order_By = {
  sub_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "users_provider" */
export type Users_Provider_Min_Order_By = {
  sub_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "users_provider". */
export type Users_Provider_Order_By = {
  sub_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "users_provider" */
export enum Users_Provider_Select_Column {
  /** column name */
  SubId = 'sub_id'
}

/** Streaming cursor of the table "users_provider" */
export type Users_Provider_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Provider_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Provider_Stream_Cursor_Value_Input = {
  sub_id?: InputMaybe<Scalars['String']['input']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AccountNumber = 'account_number',
  /** column name */
  AccountType = 'account_type',
  /** column name */
  AddressComplement = 'address_complement',
  /** column name */
  AgencyNumber = 'agency_number',
  /** column name */
  BankIspb = 'bank_ispb',
  /** column name */
  Birthdate = 'birthdate',
  /** column name */
  BlockingId = 'blocking_id',
  /** column name */
  Cep = 'cep',
  /** column name */
  City = 'city',
  /** column name */
  Cnpj = 'cnpj',
  /** column name */
  Cpf = 'cpf',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Disqualified = 'disqualified',
  /** column name */
  Domain = 'domain',
  /** column name */
  DomainOption = 'domain_option',
  /** column name */
  Email = 'email',
  /** column name */
  Gender = 'gender',
  /** column name */
  Id = 'id',
  /** column name */
  LastLogin = 'last_login',
  /** column name */
  LivanceCoreId = 'livance_core_id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Neighborhood = 'neighborhood',
  /** column name */
  OnboardingBlockingId = 'onboarding_blocking_id',
  /** column name */
  OnboardingLocation = 'onboarding_location',
  /** column name */
  OnboardingScheduledVisit = 'onboarding_scheduled_visit',
  /** column name */
  Phone = 'phone',
  /** column name */
  PipedriveDealId = 'pipedrive_deal_id',
  /** column name */
  PipedrivePersonId = 'pipedrive_person_id',
  /** column name */
  Plan = 'plan',
  /** column name */
  PlanId = 'planId',
  /** column name */
  PreferredUnitId = 'preferred_unit_id',
  /** column name */
  Profession = 'profession',
  /** column name */
  ProfessionalCardCouncil = 'professional_card_council',
  /** column name */
  ProfessionalCardCouncilState = 'professional_card_council_state',
  /** column name */
  ProfessionalCardRegisterNumber = 'professional_card_register_number',
  /** column name */
  ProfessionalCardSpecialty = 'professional_card_specialty',
  /** column name */
  ProfessionalCardSubspecialty = 'professional_card_subspecialty',
  /** column name */
  RedirectToAdmin = 'redirect_to_admin',
  /** column name */
  Rg = 'rg',
  /** column name */
  RgIssuingBody = 'rg_issuing_body',
  /** column name */
  RgState = 'rg_state',
  /** column name */
  ScheduledVisit = 'scheduled_visit',
  /** column name */
  SelectedPlan = 'selectedPlan',
  /** column name */
  Specialty = 'specialty',
  /** column name */
  State = 'state',
  /** column name */
  Step = 'step',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  VisitId = 'visit_id',
  /** column name */
  WantVisit = 'want_visit',
  /** column name */
  WorkspaceEmail = 'workspace_email',
  /** column name */
  WorkspaceEmailOption = 'workspace_email_option'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  account_number?: InputMaybe<Scalars['String']['input']>;
  account_type?: InputMaybe<Scalars['Int']['input']>;
  address_complement?: InputMaybe<Scalars['String']['input']>;
  agency_number?: InputMaybe<Scalars['String']['input']>;
  bank_ispb?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['String']['input']>;
  blocking_id?: InputMaybe<Scalars['Int']['input']>;
  cep?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_option?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  onboarding_blocking_id?: InputMaybe<Scalars['Int']['input']>;
  onboarding_location?: InputMaybe<Scalars['String']['input']>;
  onboarding_scheduled_visit?: InputMaybe<Scalars['timestamptz']['input']>;
  pipedrive_deal_id?: InputMaybe<Scalars['Int']['input']>;
  pipedrive_person_id?: InputMaybe<Scalars['Int']['input']>;
  preferred_unit_id?: InputMaybe<Scalars['Int']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  professional_card_council?: InputMaybe<Scalars['String']['input']>;
  professional_card_council_state?: InputMaybe<Scalars['String']['input']>;
  professional_card_register_number?: InputMaybe<Scalars['String']['input']>;
  professional_card_specialty?: InputMaybe<Scalars['String']['input']>;
  professional_card_subspecialty?: InputMaybe<Scalars['String']['input']>;
  redirect_to_admin?: InputMaybe<Scalars['Boolean']['input']>;
  rg?: InputMaybe<Scalars['String']['input']>;
  rg_issuing_body?: InputMaybe<Scalars['String']['input']>;
  rg_state?: InputMaybe<Scalars['String']['input']>;
  scheduled_visit?: InputMaybe<Scalars['timestamptz']['input']>;
  selectedPlan?: InputMaybe<Scalars['Int']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  visit_id?: InputMaybe<Scalars['Int']['input']>;
  want_visit?: InputMaybe<Scalars['Boolean']['input']>;
  workspace_email?: InputMaybe<Scalars['String']['input']>;
  workspace_email_option?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  account_type?: Maybe<Scalars['Float']['output']>;
  blocking_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  livance_core_id?: Maybe<Scalars['Float']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_deal_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Float']['output']>;
  planId?: Maybe<Scalars['Float']['output']>;
  preferred_unit_id?: Maybe<Scalars['Float']['output']>;
  selectedPlan?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  visit_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  account_type?: Maybe<Scalars['Float']['output']>;
  blocking_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  livance_core_id?: Maybe<Scalars['Float']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_deal_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Float']['output']>;
  planId?: Maybe<Scalars['Float']['output']>;
  preferred_unit_id?: Maybe<Scalars['Float']['output']>;
  selectedPlan?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  visit_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  account_type?: Maybe<Scalars['Float']['output']>;
  blocking_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  livance_core_id?: Maybe<Scalars['Float']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_deal_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Float']['output']>;
  planId?: Maybe<Scalars['Float']['output']>;
  preferred_unit_id?: Maybe<Scalars['Float']['output']>;
  selectedPlan?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  visit_id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  account_number?: InputMaybe<Scalars['String']['input']>;
  account_type?: InputMaybe<Scalars['Int']['input']>;
  address_complement?: InputMaybe<Scalars['String']['input']>;
  agency_number?: InputMaybe<Scalars['String']['input']>;
  bank_ispb?: InputMaybe<Scalars['String']['input']>;
  birthdate?: InputMaybe<Scalars['String']['input']>;
  blocking_id?: InputMaybe<Scalars['Int']['input']>;
  cep?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamp']['input']>;
  disqualified?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  domain_option?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  last_login?: InputMaybe<Scalars['timestamptz']['input']>;
  livance_core_id?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  onboarding_blocking_id?: InputMaybe<Scalars['Int']['input']>;
  onboarding_location?: InputMaybe<Scalars['String']['input']>;
  onboarding_scheduled_visit?: InputMaybe<Scalars['timestamptz']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pipedrive_deal_id?: InputMaybe<Scalars['Int']['input']>;
  pipedrive_person_id?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['Int']['input']>;
  preferred_unit_id?: InputMaybe<Scalars['Int']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  professional_card_council?: InputMaybe<Scalars['String']['input']>;
  professional_card_council_state?: InputMaybe<Scalars['String']['input']>;
  professional_card_register_number?: InputMaybe<Scalars['String']['input']>;
  professional_card_specialty?: InputMaybe<Scalars['String']['input']>;
  professional_card_subspecialty?: InputMaybe<Scalars['String']['input']>;
  redirect_to_admin?: InputMaybe<Scalars['Boolean']['input']>;
  rg?: InputMaybe<Scalars['String']['input']>;
  rg_issuing_body?: InputMaybe<Scalars['String']['input']>;
  rg_state?: InputMaybe<Scalars['String']['input']>;
  scheduled_visit?: InputMaybe<Scalars['timestamptz']['input']>;
  selectedPlan?: InputMaybe<Scalars['Int']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['Int']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  visit_id?: InputMaybe<Scalars['Int']['input']>;
  want_visit?: InputMaybe<Scalars['Boolean']['input']>;
  workspace_email?: InputMaybe<Scalars['String']['input']>;
  workspace_email_option?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  account_type?: Maybe<Scalars['Int']['output']>;
  blocking_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  livance_core_id?: Maybe<Scalars['Int']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Int']['output']>;
  pipedrive_deal_id?: Maybe<Scalars['Int']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Int']['output']>;
  planId?: Maybe<Scalars['Int']['output']>;
  preferred_unit_id?: Maybe<Scalars['Int']['output']>;
  selectedPlan?: Maybe<Scalars['Int']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
  visit_id?: Maybe<Scalars['Int']['output']>;
};

/** when and which version the user has accepted */
export type Users_Terms_Of_Use_Agreed = {
  __typename?: 'users_terms_of_use_agreed';
  agreed_at: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  livanceUser?: Maybe<Usuarios>;
  livance_core_id?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  terms_of_use: Terms_Of_Use;
  terms_of_use_id: Scalars['Int']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Terms_Of_Use_Agreed_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Terms_Of_Use_Agreed_Max_Order_By>;
  min?: InputMaybe<Users_Terms_Of_Use_Agreed_Min_Order_By>;
  stddev?: InputMaybe<Users_Terms_Of_Use_Agreed_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Terms_Of_Use_Agreed_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Terms_Of_Use_Agreed_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Terms_Of_Use_Agreed_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Terms_Of_Use_Agreed_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Terms_Of_Use_Agreed_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Terms_Of_Use_Agreed_Variance_Order_By>;
};

/** order by avg() on columns of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_terms_of_use_agreed". All fields are combined with a logical 'AND'. */
export type Users_Terms_Of_Use_Agreed_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Bool_Exp>>;
  _not?: InputMaybe<Users_Terms_Of_Use_Agreed_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Bool_Exp>>;
  agreed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  livance_core_id?: InputMaybe<Int_Comparison_Exp>;
  terms_of_use?: InputMaybe<Terms_Of_Use_Bool_Exp>;
  terms_of_use_id?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "users_terms_of_use_agreed" */
export enum Users_Terms_Of_Use_Agreed_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersTermsOfUseAgreedPkey = 'users_terms_of_use_agreed_pkey',
  /** unique or primary key constraint on columns "summary_file" */
  UsersTermsOfUseAgreedSummaryFileKey = 'users_terms_of_use_agreed_summary_file_key',
  /** unique or primary key constraint on columns "summary_hash" */
  UsersTermsOfUseAgreedSummaryHashKey = 'users_terms_of_use_agreed_summary_hash_key'
}

/** input type for inserting data into table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Insert_Input = {
  agreed_from_ip?: InputMaybe<Scalars['String']['input']>;
  livance_core_id?: InputMaybe<Scalars['Int']['input']>;
  terms_of_use_id?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Max_Order_By = {
  agreed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Min_Order_By = {
  agreed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Mutation_Response = {
  __typename?: 'users_terms_of_use_agreed_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Terms_Of_Use_Agreed>;
};

/** on_conflict condition type for table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_On_Conflict = {
  constraint: Users_Terms_Of_Use_Agreed_Constraint;
  update_columns?: Array<Users_Terms_Of_Use_Agreed_Update_Column>;
  where?: InputMaybe<Users_Terms_Of_Use_Agreed_Bool_Exp>;
};

/** Ordering options when selecting data from "users_terms_of_use_agreed". */
export type Users_Terms_Of_Use_Agreed_Order_By = {
  agreed_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use?: InputMaybe<Terms_Of_Use_Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "users_terms_of_use_agreed" */
export enum Users_Terms_Of_Use_Agreed_Select_Column {
  /** column name */
  AgreedAt = 'agreed_at',
  /** column name */
  Id = 'id',
  /** column name */
  LivanceCoreId = 'livance_core_id',
  /** column name */
  TermsOfUseId = 'terms_of_use_id'
}

/** order by stddev() on columns of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Terms_Of_Use_Agreed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Terms_Of_Use_Agreed_Stream_Cursor_Value_Input = {
  agreed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  livance_core_id?: InputMaybe<Scalars['Int']['input']>;
  terms_of_use_id?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "users_terms_of_use_agreed" (current role has no relevant permissions) */
export enum Users_Terms_Of_Use_Agreed_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "users_terms_of_use_agreed" */
export type Users_Terms_Of_Use_Agreed_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  livance_core_id?: InputMaybe<Order_By>;
  terms_of_use_id?: InputMaybe<Order_By>;
};

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  account_type?: Maybe<Scalars['Float']['output']>;
  blocking_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  livance_core_id?: Maybe<Scalars['Float']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_deal_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Float']['output']>;
  planId?: Maybe<Scalars['Float']['output']>;
  preferred_unit_id?: Maybe<Scalars['Float']['output']>;
  selectedPlan?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  visit_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  account_type?: Maybe<Scalars['Float']['output']>;
  blocking_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  livance_core_id?: Maybe<Scalars['Float']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_deal_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Float']['output']>;
  planId?: Maybe<Scalars['Float']['output']>;
  preferred_unit_id?: Maybe<Scalars['Float']['output']>;
  selectedPlan?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  visit_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  account_type?: Maybe<Scalars['Float']['output']>;
  blocking_id?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  livance_core_id?: Maybe<Scalars['Float']['output']>;
  onboarding_blocking_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_deal_id?: Maybe<Scalars['Float']['output']>;
  pipedrive_person_id?: Maybe<Scalars['Float']['output']>;
  planId?: Maybe<Scalars['Float']['output']>;
  preferred_unit_id?: Maybe<Scalars['Float']['output']>;
  selectedPlan?: Maybe<Scalars['Float']['output']>;
  step?: Maybe<Scalars['Float']['output']>;
  visit_id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tbUsuarios" */
export type Usuarios = {
  __typename?: 'usuarios';
  UserTermsOfUse: Array<Users_Terms_Of_Use_Agreed>;
  /** An array relationship */
  UsuariosEspecialidades: Array<UsuariosEspecialidades>;
  /** An array relationship */
  UsuariosFormaRecebimentos: Array<UsuariosFormasRecebimentos>;
  /** An aggregate relationship */
  UsuariosFormaRecebimentos_aggregate: UsuariosFormasRecebimentos_Aggregate;
  /** An object relationship */
  UsuariosProfissionai?: Maybe<UsuariosProfissionais>;
  apelido?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  arquivos: Array<UsuariosArquivos>;
  ativo: Scalars['Boolean']['output'];
  codPerfil: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  cpf: Scalars['String']['output'];
  dataCadastro: Scalars['smalldatetime']['output'];
  email: Scalars['String']['output'];
  nome: Scalars['String']['output'];
  oneSignalId?: Maybe<Scalars['uniqueidentifier']['output']>;
  openidSub?: Maybe<Scalars['String']['output']>;
  pronome?: Maybe<Scalars['String']['output']>;
  sobrenome: Scalars['String']['output'];
  /** An array relationship */
  tbAgendamentos: Array<Agendamentos>;
  /** An aggregate relationship */
  tbAgendamentos_aggregate: Agendamentos_Aggregate;
  /** An array relationship */
  tbFechamentos: Array<TbFechamentos>;
  /** An array relationship */
  tbUsuariosAgendas: Array<UsuariosAgendas>;
  /** An array relationship */
  tbUsuariosCompromissos: Array<UsuariosCompromissos>;
  /** An aggregate relationship */
  tbUsuariosCompromissos_aggregate: UsuariosCompromissos_Aggregate;
  /** An array relationship */
  usuariosAgendas: Array<UsuariosAgendas>;
  /** An array relationship */
  usuariosCompromissos: Array<UsuariosCompromissos>;
  /** An aggregate relationship */
  usuariosCompromissos_aggregate: UsuariosCompromissos_Aggregate;
  /** An object relationship */
  usuariosProfissionais?: Maybe<UsuariosProfissionais>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosUserTermsOfUseArgs = {
  distinct_on?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Terms_Of_Use_Agreed_Order_By>>;
  where?: InputMaybe<Users_Terms_Of_Use_Agreed_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosUsuariosEspecialidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosEspecialidades_Order_By>>;
  where?: InputMaybe<UsuariosEspecialidades_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosUsuariosFormaRecebimentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosFormasRecebimentos_Order_By>>;
  where?: InputMaybe<UsuariosFormasRecebimentos_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosUsuariosFormaRecebimentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosFormasRecebimentos_Order_By>>;
  where?: InputMaybe<UsuariosFormasRecebimentos_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosArquivosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosArquivos_Order_By>>;
  where?: InputMaybe<UsuariosArquivos_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosTbAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosTbAgendamentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosTbFechamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbFechamentos_Order_By>>;
  where?: InputMaybe<TbFechamentos_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosTbUsuariosAgendasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendas_Order_By>>;
  where?: InputMaybe<UsuariosAgendas_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosTbUsuariosCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosTbUsuariosCompromissos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosUsuariosAgendasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendas_Order_By>>;
  where?: InputMaybe<UsuariosAgendas_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosUsuariosCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};


/** columns and relationships of "tbUsuarios" */
export type UsuariosUsuariosCompromissos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};

/** columns and relationships of "tbUsuariosAgendas" */
export type UsuariosAgendas = {
  __typename?: 'usuariosAgendas';
  /** An object relationship */
  Usuario?: Maybe<Usuarios>;
  ativo: Scalars['Boolean']['output'];
  codTipoAgendaRepeticao: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioAgenda: Scalars['Int']['output'];
  dataFim?: Maybe<Scalars['date']['output']>;
  dataInicio: Scalars['date']['output'];
  fim: Scalars['time']['output'];
  inicio: Scalars['time']['output'];
  /** An array relationship */
  tbUsuariosAgendasCompromissos: Array<UsuariosAgendasCompromissos>;
  /** An array relationship */
  tbUsuariosAgendasDiasSemanas: Array<TbUsuariosAgendasDiasSemanas>;
  /** An array relationship */
  tbUsuariosAgendasUnidades: Array<UsuariosAgendasUnidades>;
  /** An object relationship */
  tiposAgendasRepeticoes: TiposAgendasRepeticoes;
  /** An array relationship */
  usuariosAgendasCompromissos: Array<UsuariosAgendasCompromissos>;
  /** An array relationship */
  usuariosAgendasUnidades: Array<UsuariosAgendasUnidades>;
};


/** columns and relationships of "tbUsuariosAgendas" */
export type UsuariosAgendasTbUsuariosAgendasCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosAgendasCompromissos_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosAgendas" */
export type UsuariosAgendasTbUsuariosAgendasDiasSemanasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TbUsuariosAgendasDiasSemanas_Order_By>>;
  where?: InputMaybe<TbUsuariosAgendasDiasSemanas_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosAgendas" */
export type UsuariosAgendasTbUsuariosAgendasUnidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasUnidades_Order_By>>;
  where?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosAgendas" */
export type UsuariosAgendasUsuariosAgendasCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosAgendasCompromissos_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosAgendas" */
export type UsuariosAgendasUsuariosAgendasUnidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasUnidades_Order_By>>;
  where?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
};

/** columns and relationships of "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos = {
  __typename?: 'usuariosAgendasCompromissos';
  /** An object relationship */
  UsuarioAgenda?: Maybe<UsuariosAgendas>;
  /** An object relationship */
  UsuarioAgendaUnidade?: Maybe<UsuariosAgendasUnidades>;
  /** An object relationship */
  UsuarioCompromisso: UsuariosCompromissos;
  ativo: Scalars['Boolean']['output'];
  codUsuarioCompromisso: Scalars['Int']['output'];
  /** An array relationship */
  usuariosAgendasUnidades: Array<UsuariosAgendasUnidades>;
};


/** columns and relationships of "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissosUsuariosAgendasUnidadesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasUnidades_Order_By>>;
  where?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
};

/** order by aggregate values of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosAgendasCompromissos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosAgendasCompromissos_Max_Order_By>;
  min?: InputMaybe<UsuariosAgendasCompromissos_Min_Order_By>;
  stddev?: InputMaybe<UsuariosAgendasCompromissos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosAgendasCompromissos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosAgendasCompromissos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosAgendasCompromissos_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosAgendasCompromissos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosAgendasCompromissos_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosAgendasCompromissos_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Avg_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosAgendasCompromissos". All fields are combined with a logical 'AND'. */
export type UsuariosAgendasCompromissos_Bool_Exp = {
  UsuarioAgenda?: InputMaybe<UsuariosAgendas_Bool_Exp>;
  UsuarioAgendaUnidade?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
  UsuarioCompromisso?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosAgendasCompromissos_Bool_Exp>>;
  _not?: InputMaybe<UsuariosAgendasCompromissos_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosAgendasCompromissos_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codUsuarioCompromisso?: InputMaybe<Int_Mssql_Comparison_Exp>;
  usuariosAgendasUnidades?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
};

/** order by max() on columns of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Max_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Min_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosAgendasCompromissos". */
export type UsuariosAgendasCompromissos_Order_By = {
  UsuarioAgenda?: InputMaybe<UsuariosAgendas_Order_By>;
  UsuarioAgendaUnidade?: InputMaybe<UsuariosAgendasUnidades_Order_By>;
  UsuarioCompromisso?: InputMaybe<UsuariosCompromissos_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  usuariosAgendasUnidades_aggregate?: InputMaybe<UsuariosAgendasUnidades_Aggregate_Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Stddev_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Stddev_Pop_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Stddev_Samp_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Sum_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Var_Pop_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Var_Samp_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosAgendasCompromissos" */
export type UsuariosAgendasCompromissos_Variance_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades = {
  __typename?: 'usuariosAgendasUnidades';
  /** An object relationship */
  Unidade?: Maybe<Unidades>;
  ativo: Scalars['Boolean']['output'];
  codUnidade: Scalars['Int']['output'];
  codUsuarioAgenda: Scalars['Int']['output'];
  /** An object relationship */
  tbUsuariosAgenda: UsuariosAgendas;
  /** An object relationship */
  usuariosAgenda?: Maybe<UsuariosAgendas>;
};

/** order by aggregate values of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosAgendasUnidades_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosAgendasUnidades_Max_Order_By>;
  min?: InputMaybe<UsuariosAgendasUnidades_Min_Order_By>;
  stddev?: InputMaybe<UsuariosAgendasUnidades_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosAgendasUnidades_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosAgendasUnidades_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosAgendasUnidades_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosAgendasUnidades_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosAgendasUnidades_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosAgendasUnidades_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Avg_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosAgendasUnidades". All fields are combined with a logical 'AND'. */
export type UsuariosAgendasUnidades_Bool_Exp = {
  Unidade?: InputMaybe<Unidades_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosAgendasUnidades_Bool_Exp>>;
  _not?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosAgendasUnidades_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioAgenda?: InputMaybe<Int_Mssql_Comparison_Exp>;
  tbUsuariosAgenda?: InputMaybe<UsuariosAgendas_Bool_Exp>;
  usuariosAgenda?: InputMaybe<UsuariosAgendas_Bool_Exp>;
};

/** order by max() on columns of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Max_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Min_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosAgendasUnidades". */
export type UsuariosAgendasUnidades_Order_By = {
  Unidade?: InputMaybe<Unidades_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  tbUsuariosAgenda?: InputMaybe<UsuariosAgendas_Order_By>;
  usuariosAgenda?: InputMaybe<UsuariosAgendas_Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Stddev_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Stddev_Pop_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Stddev_Samp_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Sum_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Var_Pop_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Var_Samp_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosAgendasUnidades" */
export type UsuariosAgendasUnidades_Variance_Order_By = {
  codUnidade?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by aggregate values of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosAgendas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosAgendas_Max_Order_By>;
  min?: InputMaybe<UsuariosAgendas_Min_Order_By>;
  stddev?: InputMaybe<UsuariosAgendas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosAgendas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosAgendas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosAgendas_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosAgendas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosAgendas_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosAgendas_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Avg_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosAgendas". All fields are combined with a logical 'AND'. */
export type UsuariosAgendas_Bool_Exp = {
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosAgendas_Bool_Exp>>;
  _not?: InputMaybe<UsuariosAgendas_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosAgendas_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codTipoAgendaRepeticao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioAgenda?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataFim?: InputMaybe<Date_Mssql_Comparison_Exp>;
  dataInicio?: InputMaybe<Date_Mssql_Comparison_Exp>;
  fim?: InputMaybe<Time_Mssql_Comparison_Exp>;
  inicio?: InputMaybe<Time_Mssql_Comparison_Exp>;
  tbUsuariosAgendasCompromissos?: InputMaybe<UsuariosAgendasCompromissos_Bool_Exp>;
  tbUsuariosAgendasDiasSemanas?: InputMaybe<TbUsuariosAgendasDiasSemanas_Bool_Exp>;
  tbUsuariosAgendasUnidades?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
  tiposAgendasRepeticoes?: InputMaybe<TiposAgendasRepeticoes_Bool_Exp>;
  usuariosAgendasCompromissos?: InputMaybe<UsuariosAgendasCompromissos_Bool_Exp>;
  usuariosAgendasUnidades?: InputMaybe<UsuariosAgendasUnidades_Bool_Exp>;
};

/** order by max() on columns of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Max_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  dataFim?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  fim?: InputMaybe<Order_By>;
  inicio?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Min_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  dataFim?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  fim?: InputMaybe<Order_By>;
  inicio?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosAgendas". */
export type UsuariosAgendas_Order_By = {
  Usuario?: InputMaybe<Usuarios_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
  dataFim?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  fim?: InputMaybe<Order_By>;
  inicio?: InputMaybe<Order_By>;
  tbUsuariosAgendasCompromissos_aggregate?: InputMaybe<UsuariosAgendasCompromissos_Aggregate_Order_By>;
  tbUsuariosAgendasDiasSemanas_aggregate?: InputMaybe<TbUsuariosAgendasDiasSemanas_Aggregate_Order_By>;
  tbUsuariosAgendasUnidades_aggregate?: InputMaybe<UsuariosAgendasUnidades_Aggregate_Order_By>;
  tiposAgendasRepeticoes?: InputMaybe<TiposAgendasRepeticoes_Order_By>;
  usuariosAgendasCompromissos_aggregate?: InputMaybe<UsuariosAgendasCompromissos_Aggregate_Order_By>;
  usuariosAgendasUnidades_aggregate?: InputMaybe<UsuariosAgendasUnidades_Aggregate_Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Stddev_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Stddev_Pop_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Stddev_Samp_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Sum_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Var_Pop_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Var_Samp_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosAgendas" */
export type UsuariosAgendas_Variance_Order_By = {
  codTipoAgendaRepeticao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioAgenda?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosCartoes" */
export type UsuariosCartoes = {
  __typename?: 'usuariosCartoes';
  /** An object relationship */
  Usuario: Usuarios;
  ativo: Scalars['Boolean']['output'];
  bandeira?: Maybe<Scalars['String']['output']>;
  codControlPay?: Maybe<Scalars['Int']['output']>;
  codStatus?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  codUsuarioCartao: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  descricaoStatus?: Maybe<Scalars['String']['output']>;
  numero?: Maybe<Scalars['String']['output']>;
  provedor: Scalars['String']['output'];
  tokenCartao?: Maybe<Scalars['String']['output']>;
  tokenControlPay?: Maybe<Scalars['String']['output']>;
  tokenUrl?: Maybe<Scalars['String']['output']>;
  validade?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "tbUsuariosCartoes". All fields are combined with a logical 'AND'. */
export type UsuariosCartoes_Bool_Exp = {
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosCartoes_Bool_Exp>>;
  _not?: InputMaybe<UsuariosCartoes_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosCartoes_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  bandeira?: InputMaybe<String_Mssql_Comparison_Exp>;
  codControlPay?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codStatus?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioCartao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  descricaoStatus?: InputMaybe<String_Mssql_Comparison_Exp>;
  numero?: InputMaybe<String_Mssql_Comparison_Exp>;
  provedor?: InputMaybe<String_Mssql_Comparison_Exp>;
  tokenCartao?: InputMaybe<String_Mssql_Comparison_Exp>;
  tokenControlPay?: InputMaybe<String_Mssql_Comparison_Exp>;
  tokenUrl?: InputMaybe<String_Mssql_Comparison_Exp>;
  validade?: InputMaybe<String_Mssql_Comparison_Exp>;
};

/** Ordering options when selecting data from "tbUsuariosCartoes". */
export type UsuariosCartoes_Order_By = {
  Usuario?: InputMaybe<Usuarios_Order_By>;
  ativo?: InputMaybe<Order_By>;
  bandeira?: InputMaybe<Order_By>;
  codControlPay?: InputMaybe<Order_By>;
  codStatus?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCartao?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  descricaoStatus?: InputMaybe<Order_By>;
  numero?: InputMaybe<Order_By>;
  provedor?: InputMaybe<Order_By>;
  tokenCartao?: InputMaybe<Order_By>;
  tokenControlPay?: InputMaybe<Order_By>;
  tokenUrl?: InputMaybe<Order_By>;
  validade?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosCompromissos" */
export type UsuariosCompromissos = {
  __typename?: 'usuariosCompromissos';
  /** An array relationship */
  UsuariosCompromissosTiposSalas: Array<UsuariosCompromissosTiposSalas>;
  /** An aggregate relationship */
  UsuariosCompromissosTiposSalas_aggregate: UsuariosCompromissosTiposSalas_Aggregate;
  /** An array relationship */
  agendamentos: Array<Agendamentos>;
  /** An aggregate relationship */
  agendamentos_aggregate: Agendamentos_Aggregate;
  ativo: Scalars['Boolean']['output'];
  categoria: Scalars['Int']['output'];
  codParceiroIntegracao?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  codUsuarioCompromisso: Scalars['Int']['output'];
  codUsuarioCompromissoModalidade: Scalars['Int']['output'];
  dataCadastro: Scalars['smalldatetime']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  duracao: Scalars['time']['output'];
  informacoesPaciente?: Maybe<Scalars['String']['output']>;
  modalidade: Scalars['Int']['output'];
  nome: Scalars['String']['output'];
  online: Scalars['Boolean']['output'];
  salaFlexHabilitada: Scalars['Boolean']['output'];
  sistema: Scalars['Boolean']['output'];
  /** An object relationship */
  tbUsuario: Usuarios;
  /** An array relationship */
  tbUsuariosCompromissosFormasRecebimentos: Array<UsuariosCompromissosFormasRecebimentos>;
  /** An array relationship */
  tiposSalas: Array<UsuariosCompromissosTiposSalas>;
  /** An aggregate relationship */
  tiposSalas_aggregate: UsuariosCompromissosTiposSalas_Aggregate;
  /** An array relationship */
  usuariosAgendasCompromissos: Array<UsuariosAgendasCompromissos>;
  /** An array relationship */
  usuariosCompromissosCanaisAgendamentos: Array<UsuariosCompromissosCanaisAgendamentos>;
  /** An object relationship */
  usuariosCompromissosCategoria: UsuariosCompromissosCategorias;
  /** An object relationship */
  usuariosCompromissosModalidade: UsuariosCompromissosModalidades;
  valor: Scalars['Float']['output'];
};


/** columns and relationships of "tbUsuariosCompromissos" */
export type UsuariosCompromissosUsuariosCompromissosTiposSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosCompromissos" */
export type UsuariosCompromissosUsuariosCompromissosTiposSalas_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosCompromissos" */
export type UsuariosCompromissosAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosCompromissos" */
export type UsuariosCompromissosAgendamentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosCompromissos" */
export type UsuariosCompromissosTbUsuariosCompromissosFormasRecebimentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosFormasRecebimentos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosCompromissos" */
export type UsuariosCompromissosTiposSalasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosCompromissos" */
export type UsuariosCompromissosTiposSalas_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosCompromissos" */
export type UsuariosCompromissosUsuariosAgendasCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosAgendasCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosAgendasCompromissos_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosCompromissos" */
export type UsuariosCompromissosUsuariosCompromissosCanaisAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosCanaisAgendamentos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Bool_Exp>;
};

/** columns and relationships of "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos = {
  __typename?: 'usuariosCompromissosCanaisAgendamentos';
  /** An object relationship */
  canalAgendamento?: Maybe<CanaisAgendamentos>;
  codCanalAgendamento: Scalars['Int']['output'];
  codUsuarioCompromisso: Scalars['Int']['output'];
  /** An object relationship */
  usuarioCompromisso: UsuariosCompromissos;
};

/** order by aggregate values of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Max_Order_By>;
  min?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Min_Order_By>;
  stddev?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Avg_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosCompromissosCanaisAgendamentos". All fields are combined with a logical 'AND'. */
export type UsuariosCompromissosCanaisAgendamentos_Bool_Exp = {
  _and?: InputMaybe<Array<UsuariosCompromissosCanaisAgendamentos_Bool_Exp>>;
  _not?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosCompromissosCanaisAgendamentos_Bool_Exp>>;
  canalAgendamento?: InputMaybe<CanaisAgendamentos_Bool_Exp>;
  codCanalAgendamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioCompromisso?: InputMaybe<Int_Mssql_Comparison_Exp>;
  usuarioCompromisso?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};

/** order by max() on columns of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Max_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Min_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosCompromissosCanaisAgendamentos". */
export type UsuariosCompromissosCanaisAgendamentos_Order_By = {
  canalAgendamento?: InputMaybe<CanaisAgendamentos_Order_By>;
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  usuarioCompromisso?: InputMaybe<UsuariosCompromissos_Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Stddev_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Stddev_Pop_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Stddev_Samp_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Sum_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Var_Pop_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Var_Samp_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosCompromissosCanaisAgendamentos" */
export type UsuariosCompromissosCanaisAgendamentos_Variance_Order_By = {
  codCanalAgendamento?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosCompromissosCategorias" */
export type UsuariosCompromissosCategorias = {
  __typename?: 'usuariosCompromissosCategorias';
  codUsuarioCompromissoCategoria: Scalars['Int']['output'];
  nome?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  usuariosCompromissos: Array<UsuariosCompromissos>;
  /** An aggregate relationship */
  usuariosCompromissos_aggregate: UsuariosCompromissos_Aggregate;
};


/** columns and relationships of "tbUsuariosCompromissosCategorias" */
export type UsuariosCompromissosCategoriasUsuariosCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosCompromissosCategorias" */
export type UsuariosCompromissosCategoriasUsuariosCompromissos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};

/** aggregated selection of "tbUsuariosCompromissosCategorias" */
export type UsuariosCompromissosCategorias_Aggregate = {
  __typename?: 'usuariosCompromissosCategorias_aggregate';
  aggregate?: Maybe<UsuariosCompromissosCategorias_Aggregate_Fields>;
  nodes: Array<UsuariosCompromissosCategorias>;
};

/** aggregate fields of "tbUsuariosCompromissosCategorias" */
export type UsuariosCompromissosCategorias_Aggregate_Fields = {
  __typename?: 'usuariosCompromissosCategorias_aggregate_fields';
  avg?: Maybe<UsuariosCompromissosCategorias_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UsuariosCompromissosCategorias_Max_Fields>;
  min?: Maybe<UsuariosCompromissosCategorias_Min_Fields>;
  stddev?: Maybe<UsuariosCompromissosCategorias_Stddev_Fields>;
  stddev_pop?: Maybe<UsuariosCompromissosCategorias_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsuariosCompromissosCategorias_Stddev_Samp_Fields>;
  sum?: Maybe<UsuariosCompromissosCategorias_Sum_Fields>;
  var_pop?: Maybe<UsuariosCompromissosCategorias_Var_Pop_Fields>;
  var_samp?: Maybe<UsuariosCompromissosCategorias_Var_Samp_Fields>;
  variance?: Maybe<UsuariosCompromissosCategorias_Variance_Fields>;
};


/** aggregate fields of "tbUsuariosCompromissosCategorias" */
export type UsuariosCompromissosCategorias_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<UsuariosCompromissosCategorias_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type UsuariosCompromissosCategorias_Avg_Fields = {
  __typename?: 'usuariosCompromissosCategorias_avg_fields';
  codUsuarioCompromissoCategoria?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tbUsuariosCompromissosCategorias". All fields are combined with a logical 'AND'. */
export type UsuariosCompromissosCategorias_Bool_Exp = {
  _and?: InputMaybe<Array<UsuariosCompromissosCategorias_Bool_Exp>>;
  _not?: InputMaybe<UsuariosCompromissosCategorias_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosCompromissosCategorias_Bool_Exp>>;
  codUsuarioCompromissoCategoria?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  usuariosCompromissos?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};

/** aggregate max on columns */
export type UsuariosCompromissosCategorias_Max_Fields = {
  __typename?: 'usuariosCompromissosCategorias_max_fields';
  codUsuarioCompromissoCategoria?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UsuariosCompromissosCategorias_Min_Fields = {
  __typename?: 'usuariosCompromissosCategorias_min_fields';
  codUsuarioCompromissoCategoria?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "tbUsuariosCompromissosCategorias". */
export type UsuariosCompromissosCategorias_Order_By = {
  codUsuarioCompromissoCategoria?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  usuariosCompromissos_aggregate?: InputMaybe<UsuariosCompromissos_Aggregate_Order_By>;
};

/** select columns of table "tbUsuariosCompromissosCategorias" */
export enum UsuariosCompromissosCategorias_Select_Column {
  /** column name */
  CodUsuarioCompromissoCategoria = 'codUsuarioCompromissoCategoria',
  /** column name */
  Nome = 'nome'
}

/** aggregate stddev on columns */
export type UsuariosCompromissosCategorias_Stddev_Fields = {
  __typename?: 'usuariosCompromissosCategorias_stddev_fields';
  codUsuarioCompromissoCategoria?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type UsuariosCompromissosCategorias_Stddev_Pop_Fields = {
  __typename?: 'usuariosCompromissosCategorias_stddev_pop_fields';
  codUsuarioCompromissoCategoria?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type UsuariosCompromissosCategorias_Stddev_Samp_Fields = {
  __typename?: 'usuariosCompromissosCategorias_stddev_samp_fields';
  codUsuarioCompromissoCategoria?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type UsuariosCompromissosCategorias_Sum_Fields = {
  __typename?: 'usuariosCompromissosCategorias_sum_fields';
  codUsuarioCompromissoCategoria?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type UsuariosCompromissosCategorias_Var_Pop_Fields = {
  __typename?: 'usuariosCompromissosCategorias_var_pop_fields';
  codUsuarioCompromissoCategoria?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type UsuariosCompromissosCategorias_Var_Samp_Fields = {
  __typename?: 'usuariosCompromissosCategorias_var_samp_fields';
  codUsuarioCompromissoCategoria?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type UsuariosCompromissosCategorias_Variance_Fields = {
  __typename?: 'usuariosCompromissosCategorias_variance_fields';
  codUsuarioCompromissoCategoria?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos = {
  __typename?: 'usuariosCompromissosFormasRecebimentos';
  /** An object relationship */
  UsuarioFormaRecebimento: UsuariosFormasRecebimentos;
  ativo: Scalars['Boolean']['output'];
  codUsuarioCompromisso: Scalars['Int']['output'];
  codUsuarioFormaRecebimento: Scalars['Int']['output'];
  dataCadastro: Scalars['smalldatetime']['output'];
  /** An object relationship */
  usuarioCompromisso: UsuariosCompromissos;
};

/** order by aggregate values of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Max_Order_By>;
  min?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Min_Order_By>;
  stddev?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Avg_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosCompromissosFormasRecebimentos". All fields are combined with a logical 'AND'. */
export type UsuariosCompromissosFormasRecebimentos_Bool_Exp = {
  UsuarioFormaRecebimento?: InputMaybe<UsuariosFormasRecebimentos_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosCompromissosFormasRecebimentos_Bool_Exp>>;
  _not?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosCompromissosFormasRecebimentos_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codUsuarioCompromisso?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioFormaRecebimento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Smalldatetime_Mssql_Comparison_Exp>;
  usuarioCompromisso?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};

/** order by max() on columns of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Max_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Min_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosCompromissosFormasRecebimentos". */
export type UsuariosCompromissosFormasRecebimentos_Order_By = {
  UsuarioFormaRecebimento?: InputMaybe<UsuariosFormasRecebimentos_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  usuarioCompromisso?: InputMaybe<UsuariosCompromissos_Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Stddev_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Stddev_Pop_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Stddev_Samp_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Sum_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Var_Pop_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Var_Samp_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosCompromissosFormasRecebimentos" */
export type UsuariosCompromissosFormasRecebimentos_Variance_Order_By = {
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosCompromissosModalidades" */
export type UsuariosCompromissosModalidades = {
  __typename?: 'usuariosCompromissosModalidades';
  codUsuarioCompromissoModalidade: Scalars['Int']['output'];
  nome?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  usuariosCompromissos: Array<UsuariosCompromissos>;
  /** An aggregate relationship */
  usuariosCompromissos_aggregate: UsuariosCompromissos_Aggregate;
};


/** columns and relationships of "tbUsuariosCompromissosModalidades" */
export type UsuariosCompromissosModalidadesUsuariosCompromissosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosCompromissosModalidades" */
export type UsuariosCompromissosModalidadesUsuariosCompromissos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};

/** aggregated selection of "tbUsuariosCompromissosModalidades" */
export type UsuariosCompromissosModalidades_Aggregate = {
  __typename?: 'usuariosCompromissosModalidades_aggregate';
  aggregate?: Maybe<UsuariosCompromissosModalidades_Aggregate_Fields>;
  nodes: Array<UsuariosCompromissosModalidades>;
};

/** aggregate fields of "tbUsuariosCompromissosModalidades" */
export type UsuariosCompromissosModalidades_Aggregate_Fields = {
  __typename?: 'usuariosCompromissosModalidades_aggregate_fields';
  avg?: Maybe<UsuariosCompromissosModalidades_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UsuariosCompromissosModalidades_Max_Fields>;
  min?: Maybe<UsuariosCompromissosModalidades_Min_Fields>;
  stddev?: Maybe<UsuariosCompromissosModalidades_Stddev_Fields>;
  stddev_pop?: Maybe<UsuariosCompromissosModalidades_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsuariosCompromissosModalidades_Stddev_Samp_Fields>;
  sum?: Maybe<UsuariosCompromissosModalidades_Sum_Fields>;
  var_pop?: Maybe<UsuariosCompromissosModalidades_Var_Pop_Fields>;
  var_samp?: Maybe<UsuariosCompromissosModalidades_Var_Samp_Fields>;
  variance?: Maybe<UsuariosCompromissosModalidades_Variance_Fields>;
};


/** aggregate fields of "tbUsuariosCompromissosModalidades" */
export type UsuariosCompromissosModalidades_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<UsuariosCompromissosModalidades_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type UsuariosCompromissosModalidades_Avg_Fields = {
  __typename?: 'usuariosCompromissosModalidades_avg_fields';
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tbUsuariosCompromissosModalidades". All fields are combined with a logical 'AND'. */
export type UsuariosCompromissosModalidades_Bool_Exp = {
  _and?: InputMaybe<Array<UsuariosCompromissosModalidades_Bool_Exp>>;
  _not?: InputMaybe<UsuariosCompromissosModalidades_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosCompromissosModalidades_Bool_Exp>>;
  codUsuarioCompromissoModalidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  usuariosCompromissos?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
};

/** aggregate max on columns */
export type UsuariosCompromissosModalidades_Max_Fields = {
  __typename?: 'usuariosCompromissosModalidades_max_fields';
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UsuariosCompromissosModalidades_Min_Fields = {
  __typename?: 'usuariosCompromissosModalidades_min_fields';
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "tbUsuariosCompromissosModalidades". */
export type UsuariosCompromissosModalidades_Order_By = {
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  usuariosCompromissos_aggregate?: InputMaybe<UsuariosCompromissos_Aggregate_Order_By>;
};

/** select columns of table "tbUsuariosCompromissosModalidades" */
export enum UsuariosCompromissosModalidades_Select_Column {
  /** column name */
  CodUsuarioCompromissoModalidade = 'codUsuarioCompromissoModalidade',
  /** column name */
  Nome = 'nome'
}

/** aggregate stddev on columns */
export type UsuariosCompromissosModalidades_Stddev_Fields = {
  __typename?: 'usuariosCompromissosModalidades_stddev_fields';
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type UsuariosCompromissosModalidades_Stddev_Pop_Fields = {
  __typename?: 'usuariosCompromissosModalidades_stddev_pop_fields';
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type UsuariosCompromissosModalidades_Stddev_Samp_Fields = {
  __typename?: 'usuariosCompromissosModalidades_stddev_samp_fields';
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type UsuariosCompromissosModalidades_Sum_Fields = {
  __typename?: 'usuariosCompromissosModalidades_sum_fields';
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type UsuariosCompromissosModalidades_Var_Pop_Fields = {
  __typename?: 'usuariosCompromissosModalidades_var_pop_fields';
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type UsuariosCompromissosModalidades_Var_Samp_Fields = {
  __typename?: 'usuariosCompromissosModalidades_var_samp_fields';
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type UsuariosCompromissosModalidades_Variance_Fields = {
  __typename?: 'usuariosCompromissosModalidades_variance_fields';
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas = {
  __typename?: 'usuariosCompromissosTiposSalas';
  /** An object relationship */
  TipoSala: TiposSalas;
  /** An object relationship */
  UsuarioCompromisso: UsuariosCompromissos;
  codTipoSala: Scalars['Int']['output'];
  codUsuarioCompromisso: Scalars['Int']['output'];
  prioridade: Scalars['Int']['output'];
};

/** aggregated selection of "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Aggregate = {
  __typename?: 'usuariosCompromissosTiposSalas_aggregate';
  aggregate?: Maybe<UsuariosCompromissosTiposSalas_Aggregate_Fields>;
  nodes: Array<UsuariosCompromissosTiposSalas>;
};

/** aggregate fields of "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Aggregate_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_aggregate_fields';
  avg?: Maybe<UsuariosCompromissosTiposSalas_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UsuariosCompromissosTiposSalas_Max_Fields>;
  min?: Maybe<UsuariosCompromissosTiposSalas_Min_Fields>;
  stddev?: Maybe<UsuariosCompromissosTiposSalas_Stddev_Fields>;
  stddev_pop?: Maybe<UsuariosCompromissosTiposSalas_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsuariosCompromissosTiposSalas_Stddev_Samp_Fields>;
  sum?: Maybe<UsuariosCompromissosTiposSalas_Sum_Fields>;
  var_pop?: Maybe<UsuariosCompromissosTiposSalas_Var_Pop_Fields>;
  var_samp?: Maybe<UsuariosCompromissosTiposSalas_Var_Samp_Fields>;
  variance?: Maybe<UsuariosCompromissosTiposSalas_Variance_Fields>;
};


/** aggregate fields of "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<UsuariosCompromissosTiposSalas_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosCompromissosTiposSalas_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosCompromissosTiposSalas_Max_Order_By>;
  min?: InputMaybe<UsuariosCompromissosTiposSalas_Min_Order_By>;
  stddev?: InputMaybe<UsuariosCompromissosTiposSalas_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosCompromissosTiposSalas_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosCompromissosTiposSalas_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosCompromissosTiposSalas_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosCompromissosTiposSalas_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosCompromissosTiposSalas_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosCompromissosTiposSalas_Variance_Order_By>;
};

/** aggregate avg on columns */
export type UsuariosCompromissosTiposSalas_Avg_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_avg_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  prioridade?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Avg_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosCompromissosTiposSalas". All fields are combined with a logical 'AND'. */
export type UsuariosCompromissosTiposSalas_Bool_Exp = {
  TipoSala?: InputMaybe<TiposSalas_Bool_Exp>;
  UsuarioCompromisso?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Bool_Exp>>;
  _not?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosCompromissosTiposSalas_Bool_Exp>>;
  codTipoSala?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioCompromisso?: InputMaybe<Int_Mssql_Comparison_Exp>;
  prioridade?: InputMaybe<Int_Mssql_Comparison_Exp>;
};

/** aggregate max on columns */
export type UsuariosCompromissosTiposSalas_Max_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_max_fields';
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  prioridade?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Max_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UsuariosCompromissosTiposSalas_Min_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_min_fields';
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  prioridade?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Min_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosCompromissosTiposSalas". */
export type UsuariosCompromissosTiposSalas_Order_By = {
  TipoSala?: InputMaybe<TiposSalas_Order_By>;
  UsuarioCompromisso?: InputMaybe<UsuariosCompromissos_Order_By>;
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** select columns of table "tbUsuariosCompromissosTiposSalas" */
export enum UsuariosCompromissosTiposSalas_Select_Column {
  /** column name */
  CodTipoSala = 'codTipoSala',
  /** column name */
  CodUsuarioCompromisso = 'codUsuarioCompromisso',
  /** column name */
  Prioridade = 'prioridade'
}

/** aggregate stddev on columns */
export type UsuariosCompromissosTiposSalas_Stddev_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_stddev_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  prioridade?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Stddev_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UsuariosCompromissosTiposSalas_Stddev_Pop_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_stddev_pop_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  prioridade?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Stddev_Pop_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UsuariosCompromissosTiposSalas_Stddev_Samp_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_stddev_samp_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  prioridade?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Stddev_Samp_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type UsuariosCompromissosTiposSalas_Sum_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_sum_fields';
  codTipoSala?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  prioridade?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Sum_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type UsuariosCompromissosTiposSalas_Var_Pop_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_var_pop_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  prioridade?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Var_Pop_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UsuariosCompromissosTiposSalas_Var_Samp_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_var_samp_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  prioridade?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Var_Samp_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UsuariosCompromissosTiposSalas_Variance_Fields = {
  __typename?: 'usuariosCompromissosTiposSalas_variance_fields';
  codTipoSala?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  prioridade?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbUsuariosCompromissosTiposSalas" */
export type UsuariosCompromissosTiposSalas_Variance_Order_By = {
  codTipoSala?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  prioridade?: InputMaybe<Order_By>;
};

/** aggregated selection of "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Aggregate = {
  __typename?: 'usuariosCompromissos_aggregate';
  aggregate?: Maybe<UsuariosCompromissos_Aggregate_Fields>;
  nodes: Array<UsuariosCompromissos>;
};

/** aggregate fields of "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Aggregate_Fields = {
  __typename?: 'usuariosCompromissos_aggregate_fields';
  avg?: Maybe<UsuariosCompromissos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UsuariosCompromissos_Max_Fields>;
  min?: Maybe<UsuariosCompromissos_Min_Fields>;
  stddev?: Maybe<UsuariosCompromissos_Stddev_Fields>;
  stddev_pop?: Maybe<UsuariosCompromissos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsuariosCompromissos_Stddev_Samp_Fields>;
  sum?: Maybe<UsuariosCompromissos_Sum_Fields>;
  var_pop?: Maybe<UsuariosCompromissos_Var_Pop_Fields>;
  var_samp?: Maybe<UsuariosCompromissos_Var_Samp_Fields>;
  variance?: Maybe<UsuariosCompromissos_Variance_Fields>;
};


/** aggregate fields of "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<UsuariosCompromissos_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosCompromissos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosCompromissos_Max_Order_By>;
  min?: InputMaybe<UsuariosCompromissos_Min_Order_By>;
  stddev?: InputMaybe<UsuariosCompromissos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosCompromissos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosCompromissos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosCompromissos_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosCompromissos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosCompromissos_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosCompromissos_Variance_Order_By>;
};

/** aggregate avg on columns */
export type UsuariosCompromissos_Avg_Fields = {
  __typename?: 'usuariosCompromissos_avg_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
  modalidade?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Avg_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosCompromissos". All fields are combined with a logical 'AND'. */
export type UsuariosCompromissos_Bool_Exp = {
  UsuariosCompromissosTiposSalas?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosCompromissos_Bool_Exp>>;
  _not?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosCompromissos_Bool_Exp>>;
  agendamentos?: InputMaybe<Agendamentos_Bool_Exp>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  categoria?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codParceiroIntegracao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioCompromisso?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioCompromissoModalidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Smalldatetime_Mssql_Comparison_Exp>;
  descricao?: InputMaybe<String_Mssql_Comparison_Exp>;
  duracao?: InputMaybe<Time_Mssql_Comparison_Exp>;
  informacoesPaciente?: InputMaybe<String_Mssql_Comparison_Exp>;
  modalidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  online?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  salaFlexHabilitada?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  sistema?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  tbUsuario?: InputMaybe<Usuarios_Bool_Exp>;
  tbUsuariosCompromissosFormasRecebimentos?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Bool_Exp>;
  tiposSalas?: InputMaybe<UsuariosCompromissosTiposSalas_Bool_Exp>;
  usuariosAgendasCompromissos?: InputMaybe<UsuariosAgendasCompromissos_Bool_Exp>;
  usuariosCompromissosCanaisAgendamentos?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Bool_Exp>;
  usuariosCompromissosCategoria?: InputMaybe<UsuariosCompromissosCategorias_Bool_Exp>;
  usuariosCompromissosModalidade?: InputMaybe<UsuariosCompromissosModalidades_Bool_Exp>;
  valor?: InputMaybe<Float_Mssql_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Inc_Input = {
  valor?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate max on columns */
export type UsuariosCompromissos_Max_Fields = {
  __typename?: 'usuariosCompromissos_max_fields';
  categoria?: Maybe<Scalars['Int']['output']>;
  codParceiroIntegracao?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['smalldatetime']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  duracao?: Maybe<Scalars['time']['output']>;
  informacoesPaciente?: Maybe<Scalars['String']['output']>;
  modalidade?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Max_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  duracao?: InputMaybe<Order_By>;
  informacoesPaciente?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UsuariosCompromissos_Min_Fields = {
  __typename?: 'usuariosCompromissos_min_fields';
  categoria?: Maybe<Scalars['Int']['output']>;
  codParceiroIntegracao?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Int']['output']>;
  dataCadastro?: Maybe<Scalars['smalldatetime']['output']>;
  descricao?: Maybe<Scalars['String']['output']>;
  duracao?: Maybe<Scalars['time']['output']>;
  informacoesPaciente?: Maybe<Scalars['String']['output']>;
  modalidade?: Maybe<Scalars['Int']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Min_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  duracao?: InputMaybe<Order_By>;
  informacoesPaciente?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Mutation_Response = {
  __typename?: 'usuariosCompromissos_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UsuariosCompromissos>;
};

/** Ordering options when selecting data from "tbUsuariosCompromissos". */
export type UsuariosCompromissos_Order_By = {
  UsuariosCompromissosTiposSalas_aggregate?: InputMaybe<UsuariosCompromissosTiposSalas_Aggregate_Order_By>;
  agendamentos_aggregate?: InputMaybe<Agendamentos_Aggregate_Order_By>;
  ativo?: InputMaybe<Order_By>;
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  duracao?: InputMaybe<Order_By>;
  informacoesPaciente?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  online?: InputMaybe<Order_By>;
  salaFlexHabilitada?: InputMaybe<Order_By>;
  sistema?: InputMaybe<Order_By>;
  tbUsuario?: InputMaybe<Usuarios_Order_By>;
  tbUsuariosCompromissosFormasRecebimentos_aggregate?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Aggregate_Order_By>;
  tiposSalas_aggregate?: InputMaybe<UsuariosCompromissosTiposSalas_Aggregate_Order_By>;
  usuariosAgendasCompromissos_aggregate?: InputMaybe<UsuariosAgendasCompromissos_Aggregate_Order_By>;
  usuariosCompromissosCanaisAgendamentos_aggregate?: InputMaybe<UsuariosCompromissosCanaisAgendamentos_Aggregate_Order_By>;
  usuariosCompromissosCategoria?: InputMaybe<UsuariosCompromissosCategorias_Order_By>;
  usuariosCompromissosModalidade?: InputMaybe<UsuariosCompromissosModalidades_Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tbUsuariosCompromissos */
export type UsuariosCompromissos_Pk_Columns_Input = {
  codUsuarioCompromisso: Scalars['Int']['input'];
};

/** select columns of table "tbUsuariosCompromissos" */
export enum UsuariosCompromissos_Select_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  Categoria = 'categoria',
  /** column name */
  CodParceiroIntegracao = 'codParceiroIntegracao',
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  CodUsuarioCompromisso = 'codUsuarioCompromisso',
  /** column name */
  CodUsuarioCompromissoModalidade = 'codUsuarioCompromissoModalidade',
  /** column name */
  DataCadastro = 'dataCadastro',
  /** column name */
  Descricao = 'descricao',
  /** column name */
  Duracao = 'duracao',
  /** column name */
  InformacoesPaciente = 'informacoesPaciente',
  /** column name */
  Modalidade = 'modalidade',
  /** column name */
  Nome = 'nome',
  /** column name */
  Online = 'online',
  /** column name */
  SalaFlexHabilitada = 'salaFlexHabilitada',
  /** column name */
  Sistema = 'sistema',
  /** column name */
  Valor = 'valor'
}

/** input type for updating data in table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Set_Input = {
  descricao?: InputMaybe<Scalars['String']['input']>;
  duracao?: InputMaybe<Scalars['time']['input']>;
  informacoesPaciente?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  online?: InputMaybe<Scalars['Boolean']['input']>;
  salaFlexHabilitada?: InputMaybe<Scalars['Boolean']['input']>;
  valor?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate stddev on columns */
export type UsuariosCompromissos_Stddev_Fields = {
  __typename?: 'usuariosCompromissos_stddev_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
  modalidade?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Stddev_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UsuariosCompromissos_Stddev_Pop_Fields = {
  __typename?: 'usuariosCompromissos_stddev_pop_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
  modalidade?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Stddev_Pop_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UsuariosCompromissos_Stddev_Samp_Fields = {
  __typename?: 'usuariosCompromissos_stddev_samp_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
  modalidade?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Stddev_Samp_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type UsuariosCompromissos_Sum_Fields = {
  __typename?: 'usuariosCompromissos_sum_fields';
  categoria?: Maybe<Scalars['Int']['output']>;
  codParceiroIntegracao?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Int']['output']>;
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Int']['output']>;
  modalidade?: Maybe<Scalars['Int']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Sum_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type UsuariosCompromissos_Var_Pop_Fields = {
  __typename?: 'usuariosCompromissos_var_pop_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
  modalidade?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Var_Pop_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UsuariosCompromissos_Var_Samp_Fields = {
  __typename?: 'usuariosCompromissos_var_samp_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
  modalidade?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Var_Samp_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UsuariosCompromissos_Variance_Fields = {
  __typename?: 'usuariosCompromissos_variance_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codParceiroIntegracao?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromisso?: Maybe<Scalars['Float']['output']>;
  codUsuarioCompromissoModalidade?: Maybe<Scalars['Float']['output']>;
  modalidade?: Maybe<Scalars['Float']['output']>;
  valor?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbUsuariosCompromissos" */
export type UsuariosCompromissos_Variance_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codParceiroIntegracao?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioCompromisso?: InputMaybe<Order_By>;
  codUsuarioCompromissoModalidade?: InputMaybe<Order_By>;
  modalidade?: InputMaybe<Order_By>;
  valor?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades = {
  __typename?: 'usuariosEspecialidades';
  /** An object relationship */
  Especialidade: Especialidades;
  codEspecialidade: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  /** An object relationship */
  usuario: Usuarios;
};

/** order by aggregate values of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosEspecialidades_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosEspecialidades_Max_Order_By>;
  min?: InputMaybe<UsuariosEspecialidades_Min_Order_By>;
  stddev?: InputMaybe<UsuariosEspecialidades_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosEspecialidades_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosEspecialidades_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosEspecialidades_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosEspecialidades_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosEspecialidades_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosEspecialidades_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Avg_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosEspecialidades". All fields are combined with a logical 'AND'. */
export type UsuariosEspecialidades_Bool_Exp = {
  Especialidade?: InputMaybe<Especialidades_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosEspecialidades_Bool_Exp>>;
  _not?: InputMaybe<UsuariosEspecialidades_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosEspecialidades_Bool_Exp>>;
  codEspecialidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  usuario?: InputMaybe<Usuarios_Bool_Exp>;
};

/** order by max() on columns of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Max_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Min_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosEspecialidades". */
export type UsuariosEspecialidades_Order_By = {
  Especialidade?: InputMaybe<Especialidades_Order_By>;
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  usuario?: InputMaybe<Usuarios_Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Stddev_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Stddev_Pop_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Stddev_Samp_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Sum_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Var_Pop_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Var_Samp_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosEspecialidades" */
export type UsuariosEspecialidades_Variance_Order_By = {
  codEspecialidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos = {
  __typename?: 'usuariosFormasRecebimentos';
  /** An object relationship */
  TipoConvenio?: Maybe<TiposConvenios>;
  /** An object relationship */
  TipoFormaRecebimento: TiposFormasRecebimentos;
  /** An object relationship */
  Usuario?: Maybe<Usuarios>;
  ativo: Scalars['Boolean']['output'];
  categoria: Scalars['Int']['output'];
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  codTipoFormaRecebimento: Scalars['Int']['output'];
  codTipoPlano?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  codUsuarioFormaRecebimento: Scalars['Int']['output'];
  nomeConvenio?: Maybe<Scalars['String']['output']>;
  sistema: Scalars['Boolean']['output'];
  /** An object relationship */
  tipoPlano?: Maybe<TiposPlanos>;
  /** An array relationship */
  usuariosCompromissosFormasRecebimentos: Array<UsuariosCompromissosFormasRecebimentos>;
};


/** columns and relationships of "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentosUsuariosCompromissosFormasRecebimentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosCompromissosFormasRecebimentos_Order_By>>;
  where?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Bool_Exp>;
};

/** aggregated selection of "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Aggregate = {
  __typename?: 'usuariosFormasRecebimentos_aggregate';
  aggregate?: Maybe<UsuariosFormasRecebimentos_Aggregate_Fields>;
  nodes: Array<UsuariosFormasRecebimentos>;
};

/** aggregate fields of "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Aggregate_Fields = {
  __typename?: 'usuariosFormasRecebimentos_aggregate_fields';
  avg?: Maybe<UsuariosFormasRecebimentos_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UsuariosFormasRecebimentos_Max_Fields>;
  min?: Maybe<UsuariosFormasRecebimentos_Min_Fields>;
  stddev?: Maybe<UsuariosFormasRecebimentos_Stddev_Fields>;
  stddev_pop?: Maybe<UsuariosFormasRecebimentos_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsuariosFormasRecebimentos_Stddev_Samp_Fields>;
  sum?: Maybe<UsuariosFormasRecebimentos_Sum_Fields>;
  var_pop?: Maybe<UsuariosFormasRecebimentos_Var_Pop_Fields>;
  var_samp?: Maybe<UsuariosFormasRecebimentos_Var_Samp_Fields>;
  variance?: Maybe<UsuariosFormasRecebimentos_Variance_Fields>;
};


/** aggregate fields of "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Aggregate_FieldsCountArgs = {
  column?: InputMaybe<UsuariosFormasRecebimentos_Select_Column>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosFormasRecebimentos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosFormasRecebimentos_Max_Order_By>;
  min?: InputMaybe<UsuariosFormasRecebimentos_Min_Order_By>;
  stddev?: InputMaybe<UsuariosFormasRecebimentos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosFormasRecebimentos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosFormasRecebimentos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosFormasRecebimentos_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosFormasRecebimentos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosFormasRecebimentos_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosFormasRecebimentos_Variance_Order_By>;
};

/** aggregate avg on columns */
export type UsuariosFormasRecebimentos_Avg_Fields = {
  __typename?: 'usuariosFormasRecebimentos_avg_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codTipoFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  codTipoPlano?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Avg_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosFormasRecebimentos". All fields are combined with a logical 'AND'. */
export type UsuariosFormasRecebimentos_Bool_Exp = {
  TipoConvenio?: InputMaybe<TiposConvenios_Bool_Exp>;
  TipoFormaRecebimento?: InputMaybe<TiposFormasRecebimentos_Bool_Exp>;
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosFormasRecebimentos_Bool_Exp>>;
  _not?: InputMaybe<UsuariosFormasRecebimentos_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosFormasRecebimentos_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  categoria?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoConvenio?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoFormaRecebimento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codTipoPlano?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioFormaRecebimento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nomeConvenio?: InputMaybe<String_Mssql_Comparison_Exp>;
  sistema?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  tipoPlano?: InputMaybe<TiposPlanos_Bool_Exp>;
  usuariosCompromissosFormasRecebimentos?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Bool_Exp>;
};

/** aggregate max on columns */
export type UsuariosFormasRecebimentos_Max_Fields = {
  __typename?: 'usuariosFormasRecebimentos_max_fields';
  categoria?: Maybe<Scalars['Int']['output']>;
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  codTipoFormaRecebimento?: Maybe<Scalars['Int']['output']>;
  codTipoPlano?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Int']['output']>;
  nomeConvenio?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Max_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  nomeConvenio?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UsuariosFormasRecebimentos_Min_Fields = {
  __typename?: 'usuariosFormasRecebimentos_min_fields';
  categoria?: Maybe<Scalars['Int']['output']>;
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  codTipoFormaRecebimento?: Maybe<Scalars['Int']['output']>;
  codTipoPlano?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Int']['output']>;
  nomeConvenio?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Min_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  nomeConvenio?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosFormasRecebimentos". */
export type UsuariosFormasRecebimentos_Order_By = {
  TipoConvenio?: InputMaybe<TiposConvenios_Order_By>;
  TipoFormaRecebimento?: InputMaybe<TiposFormasRecebimentos_Order_By>;
  Usuario?: InputMaybe<Usuarios_Order_By>;
  ativo?: InputMaybe<Order_By>;
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
  nomeConvenio?: InputMaybe<Order_By>;
  sistema?: InputMaybe<Order_By>;
  tipoPlano?: InputMaybe<TiposPlanos_Order_By>;
  usuariosCompromissosFormasRecebimentos_aggregate?: InputMaybe<UsuariosCompromissosFormasRecebimentos_Aggregate_Order_By>;
};

/** select columns of table "tbUsuariosFormasRecebimentos" */
export enum UsuariosFormasRecebimentos_Select_Column {
  /** column name */
  Ativo = 'ativo',
  /** column name */
  Categoria = 'categoria',
  /** column name */
  CodTipoConvenio = 'codTipoConvenio',
  /** column name */
  CodTipoFormaRecebimento = 'codTipoFormaRecebimento',
  /** column name */
  CodTipoPlano = 'codTipoPlano',
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  CodUsuarioFormaRecebimento = 'codUsuarioFormaRecebimento',
  /** column name */
  NomeConvenio = 'nomeConvenio',
  /** column name */
  Sistema = 'sistema'
}

/** aggregate stddev on columns */
export type UsuariosFormasRecebimentos_Stddev_Fields = {
  __typename?: 'usuariosFormasRecebimentos_stddev_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codTipoFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  codTipoPlano?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Stddev_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UsuariosFormasRecebimentos_Stddev_Pop_Fields = {
  __typename?: 'usuariosFormasRecebimentos_stddev_pop_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codTipoFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  codTipoPlano?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Stddev_Pop_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UsuariosFormasRecebimentos_Stddev_Samp_Fields = {
  __typename?: 'usuariosFormasRecebimentos_stddev_samp_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codTipoFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  codTipoPlano?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Stddev_Samp_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type UsuariosFormasRecebimentos_Sum_Fields = {
  __typename?: 'usuariosFormasRecebimentos_sum_fields';
  categoria?: Maybe<Scalars['Int']['output']>;
  codTipoConvenio?: Maybe<Scalars['Int']['output']>;
  codTipoFormaRecebimento?: Maybe<Scalars['Int']['output']>;
  codTipoPlano?: Maybe<Scalars['Int']['output']>;
  codUsuario?: Maybe<Scalars['Int']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Sum_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type UsuariosFormasRecebimentos_Var_Pop_Fields = {
  __typename?: 'usuariosFormasRecebimentos_var_pop_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codTipoFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  codTipoPlano?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Var_Pop_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UsuariosFormasRecebimentos_Var_Samp_Fields = {
  __typename?: 'usuariosFormasRecebimentos_var_samp_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codTipoFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  codTipoPlano?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Var_Samp_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UsuariosFormasRecebimentos_Variance_Fields = {
  __typename?: 'usuariosFormasRecebimentos_variance_fields';
  categoria?: Maybe<Scalars['Float']['output']>;
  codTipoConvenio?: Maybe<Scalars['Float']['output']>;
  codTipoFormaRecebimento?: Maybe<Scalars['Float']['output']>;
  codTipoPlano?: Maybe<Scalars['Float']['output']>;
  codUsuario?: Maybe<Scalars['Float']['output']>;
  codUsuarioFormaRecebimento?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "tbUsuariosFormasRecebimentos" */
export type UsuariosFormasRecebimentos_Variance_Order_By = {
  categoria?: InputMaybe<Order_By>;
  codTipoConvenio?: InputMaybe<Order_By>;
  codTipoFormaRecebimento?: InputMaybe<Order_By>;
  codTipoPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioFormaRecebimento?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosLinksRastreamentos" */
export type UsuariosLinksRastreamentos = {
  __typename?: 'usuariosLinksRastreamentos';
  codLinkDestino: Scalars['Int']['output'];
  codLinkRastreamento: Scalars['String']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioLinkRastreamento: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  descricao?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  /** An object relationship */
  linksDestino: LinksDestinos;
  nome: Scalars['String']['output'];
  sistema: Scalars['Boolean']['output'];
  /** An object relationship */
  usuarioProfissional: UsuariosProfissionais;
};

/** Boolean expression to filter rows from the table "tbUsuariosLinksRastreamentos". All fields are combined with a logical 'AND'. */
export type UsuariosLinksRastreamentos_Bool_Exp = {
  _and?: InputMaybe<Array<UsuariosLinksRastreamentos_Bool_Exp>>;
  _not?: InputMaybe<UsuariosLinksRastreamentos_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosLinksRastreamentos_Bool_Exp>>;
  codLinkDestino?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codLinkRastreamento?: InputMaybe<String_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioLinkRastreamento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  descricao?: InputMaybe<String_Mssql_Comparison_Exp>;
  link?: InputMaybe<String_Mssql_Comparison_Exp>;
  linksDestino?: InputMaybe<LinksDestinos_Bool_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  sistema?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  usuarioProfissional?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};

/** Ordering options when selecting data from "tbUsuariosLinksRastreamentos". */
export type UsuariosLinksRastreamentos_Order_By = {
  codLinkDestino?: InputMaybe<Order_By>;
  codLinkRastreamento?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioLinkRastreamento?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  descricao?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  linksDestino?: InputMaybe<LinksDestinos_Order_By>;
  nome?: InputMaybe<Order_By>;
  sistema?: InputMaybe<Order_By>;
  usuarioProfissional?: InputMaybe<UsuariosProfissionais_Order_By>;
};

/** columns and relationships of "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes = {
  __typename?: 'usuariosMovimentacoesRecorrentes';
  ativo: Scalars['Boolean']['output'];
  codTipoMovimentacao: Scalars['Int']['output'];
  codUnidade?: Maybe<Scalars['Int']['output']>;
  codUsuario: Scalars['Int']['output'];
  codUsuarioMovimentacaoRecorrente: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  dataFim?: Maybe<Scalars['datetime2']['output']>;
  dataInicio: Scalars['datetime2']['output'];
  quantidade: Scalars['Float']['output'];
  /** An object relationship */
  tipoMovimentacao: TiposMovimentacoes;
  tipoMovimentacaoRepeticao: Scalars['Int']['output'];
  /** An object relationship */
  usuario: Usuarios;
};

/** order by aggregate values of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosMovimentacoesRecorrentes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosMovimentacoesRecorrentes_Max_Order_By>;
  min?: InputMaybe<UsuariosMovimentacoesRecorrentes_Min_Order_By>;
  stddev?: InputMaybe<UsuariosMovimentacoesRecorrentes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosMovimentacoesRecorrentes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosMovimentacoesRecorrentes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosMovimentacoesRecorrentes_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosMovimentacoesRecorrentes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosMovimentacoesRecorrentes_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosMovimentacoesRecorrentes_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Avg_Order_By = {
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosMovimentacoesRecorrentes". All fields are combined with a logical 'AND'. */
export type UsuariosMovimentacoesRecorrentes_Bool_Exp = {
  _and?: InputMaybe<Array<UsuariosMovimentacoesRecorrentes_Bool_Exp>>;
  _not?: InputMaybe<UsuariosMovimentacoesRecorrentes_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosMovimentacoesRecorrentes_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codTipoMovimentacao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUnidade?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataFim?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataInicio?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  quantidade?: InputMaybe<Float_Mssql_Comparison_Exp>;
  tipoMovimentacao?: InputMaybe<TiposMovimentacoes_Bool_Exp>;
  tipoMovimentacaoRepeticao?: InputMaybe<Int_Mssql_Comparison_Exp>;
  usuario?: InputMaybe<Usuarios_Bool_Exp>;
};

/** order by max() on columns of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Max_Order_By = {
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataFim?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Min_Order_By = {
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataFim?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosMovimentacoesRecorrentes". */
export type UsuariosMovimentacoesRecorrentes_Order_By = {
  ativo?: InputMaybe<Order_By>;
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataFim?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacao?: InputMaybe<TiposMovimentacoes_Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
  usuario?: InputMaybe<Usuarios_Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Stddev_Order_By = {
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Stddev_Pop_Order_By = {
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Stddev_Samp_Order_By = {
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Sum_Order_By = {
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Var_Pop_Order_By = {
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Var_Samp_Order_By = {
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosMovimentacoesRecorrentes" */
export type UsuariosMovimentacoesRecorrentes_Variance_Order_By = {
  codTipoMovimentacao?: InputMaybe<Order_By>;
  codUnidade?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioMovimentacaoRecorrente?: InputMaybe<Order_By>;
  quantidade?: InputMaybe<Order_By>;
  tipoMovimentacaoRepeticao?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos = {
  __typename?: 'usuariosPacotesServicos';
  ativo: Scalars['Boolean']['output'];
  codPacoteServicos: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioPacoteServicos: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  dataDesativacao?: Maybe<Scalars['datetime2']['output']>;
  dataFimTrial?: Maybe<Scalars['datetime2']['output']>;
  /** An object relationship */
  pacoteServico?: Maybe<PacotesServicos>;
  /** An object relationship */
  usuarioProfissional: UsuariosProfissionais;
};

/** order by aggregate values of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosPacotesServicos_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosPacotesServicos_Max_Order_By>;
  min?: InputMaybe<UsuariosPacotesServicos_Min_Order_By>;
  stddev?: InputMaybe<UsuariosPacotesServicos_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosPacotesServicos_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosPacotesServicos_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosPacotesServicos_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosPacotesServicos_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosPacotesServicos_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosPacotesServicos_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Avg_Order_By = {
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosPacotesServicos". All fields are combined with a logical 'AND'. */
export type UsuariosPacotesServicos_Bool_Exp = {
  _and?: InputMaybe<Array<UsuariosPacotesServicos_Bool_Exp>>;
  _not?: InputMaybe<UsuariosPacotesServicos_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosPacotesServicos_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codPacoteServicos?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioPacoteServicos?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataDesativacao?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataFimTrial?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  pacoteServico?: InputMaybe<PacotesServicos_Bool_Exp>;
  usuarioProfissional?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};

/** order by max() on columns of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Max_Order_By = {
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataDesativacao?: InputMaybe<Order_By>;
  dataFimTrial?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Min_Order_By = {
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataDesativacao?: InputMaybe<Order_By>;
  dataFimTrial?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosPacotesServicos". */
export type UsuariosPacotesServicos_Order_By = {
  ativo?: InputMaybe<Order_By>;
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataDesativacao?: InputMaybe<Order_By>;
  dataFimTrial?: InputMaybe<Order_By>;
  pacoteServico?: InputMaybe<PacotesServicos_Order_By>;
  usuarioProfissional?: InputMaybe<UsuariosProfissionais_Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Stddev_Order_By = {
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Stddev_Pop_Order_By = {
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Stddev_Samp_Order_By = {
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Sum_Order_By = {
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Var_Pop_Order_By = {
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Var_Samp_Order_By = {
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosPacotesServicos" */
export type UsuariosPacotesServicos_Variance_Order_By = {
  codPacoteServicos?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioPacoteServicos?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosProfissionais" */
export type UsuariosProfissionais = {
  __typename?: 'usuariosProfissionais';
  /** An object relationship */
  Clinica?: Maybe<TbClinicas>;
  /** An array relationship */
  Cobrancas: Array<Cobrancas>;
  /** An object relationship */
  Usuario: Usuarios;
  bloqueado: Scalars['Boolean']['output'];
  codConselhoClasse?: Maybe<Scalars['String']['output']>;
  codUsuario: Scalars['Int']['output'];
  codUsuarioTelefone?: Maybe<Scalars['Int']['output']>;
  dataInicioDivida?: Maybe<Scalars['datetime2']['output']>;
  dataValidacao?: Maybe<Scalars['date']['output']>;
  diaVencimento?: Maybe<Scalars['Int']['output']>;
  especialidade?: Maybe<Scalars['String']['output']>;
  formaDePagamento: Scalars['String']['output'];
  /** An array relationship */
  funcionalidadesDesativadas: Array<FuncionalidadesDesativadas>;
  membroOneLiv?: Maybe<Locus_Membro>;
  profissao?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tbAgendamentos: Array<Agendamentos>;
  /** An aggregate relationship */
  tbAgendamentos_aggregate: Agendamentos_Aggregate;
  telefonePublico?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  usuarioTelefone?: Maybe<UsuariosTelefones>;
  /** An array relationship */
  usuariosPacotesServicos: Array<UsuariosPacotesServicos>;
};


/** columns and relationships of "tbUsuariosProfissionais" */
export type UsuariosProfissionaisCobrancasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cobrancas_Order_By>>;
  where?: InputMaybe<Cobrancas_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosProfissionais" */
export type UsuariosProfissionaisFuncionalidadesDesativadasArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FuncionalidadesDesativadas_Order_By>>;
  where?: InputMaybe<FuncionalidadesDesativadas_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosProfissionais" */
export type UsuariosProfissionaisTbAgendamentosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosProfissionais" */
export type UsuariosProfissionaisTbAgendamentos_AggregateArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agendamentos_Order_By>>;
  where?: InputMaybe<Agendamentos_Bool_Exp>;
};


/** columns and relationships of "tbUsuariosProfissionais" */
export type UsuariosProfissionaisUsuariosPacotesServicosArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosPacotesServicos_Order_By>>;
  where?: InputMaybe<UsuariosPacotesServicos_Bool_Exp>;
};

/** columns and relationships of "tbUsuariosProfissionaisOrientacoesSecretarias" */
export type UsuariosProfissionaisOrientacoesSecretarias = {
  __typename?: 'usuariosProfissionaisOrientacoesSecretarias';
  codUsuario: Scalars['Int']['output'];
  informacoesDuvidasFrequentes?: Maybe<Scalars['String']['output']>;
  informacoesSobreAgendamento?: Maybe<Scalars['String']['output']>;
  informacoesSobreProfissional?: Maybe<Scalars['String']['output']>;
  informacoesSobreRestricoes?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  usuario?: Maybe<Usuarios>;
  /** An object relationship */
  usuarioProfissional: UsuariosProfissionais;
};

/** Boolean expression to filter rows from the table "tbUsuariosProfissionaisOrientacoesSecretarias". All fields are combined with a logical 'AND'. */
export type UsuariosProfissionaisOrientacoesSecretarias_Bool_Exp = {
  _and?: InputMaybe<Array<UsuariosProfissionaisOrientacoesSecretarias_Bool_Exp>>;
  _not?: InputMaybe<UsuariosProfissionaisOrientacoesSecretarias_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosProfissionaisOrientacoesSecretarias_Bool_Exp>>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  informacoesDuvidasFrequentes?: InputMaybe<String_Mssql_Comparison_Exp>;
  informacoesSobreAgendamento?: InputMaybe<String_Mssql_Comparison_Exp>;
  informacoesSobreProfissional?: InputMaybe<String_Mssql_Comparison_Exp>;
  informacoesSobreRestricoes?: InputMaybe<String_Mssql_Comparison_Exp>;
  usuario?: InputMaybe<Usuarios_Bool_Exp>;
  usuarioProfissional?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};

/** upsert condition type for table "tbUsuariosProfissionaisOrientacoesSecretarias" */
export type UsuariosProfissionaisOrientacoesSecretarias_If_Matched = {
  match_columns?: Array<UsuariosProfissionaisOrientacoesSecretarias_Insert_Match_Column>;
  update_columns?: Array<UsuariosProfissionaisOrientacoesSecretarias_Update_Column>;
  where?: InputMaybe<UsuariosProfissionaisOrientacoesSecretarias_Bool_Exp>;
};

/** input type for inserting data into table "tbUsuariosProfissionaisOrientacoesSecretarias" */
export type UsuariosProfissionaisOrientacoesSecretarias_Insert_Input = {
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  informacoesDuvidasFrequentes?: InputMaybe<Scalars['String']['input']>;
  informacoesSobreAgendamento?: InputMaybe<Scalars['String']['input']>;
  informacoesSobreProfissional?: InputMaybe<Scalars['String']['input']>;
  informacoesSobreRestricoes?: InputMaybe<Scalars['String']['input']>;
};

/** select match_columns of table "tbUsuariosProfissionaisOrientacoesSecretarias" */
export enum UsuariosProfissionaisOrientacoesSecretarias_Insert_Match_Column {
  /** column name */
  CodUsuario = 'codUsuario',
  /** column name */
  InformacoesDuvidasFrequentes = 'informacoesDuvidasFrequentes',
  /** column name */
  InformacoesSobreAgendamento = 'informacoesSobreAgendamento',
  /** column name */
  InformacoesSobreProfissional = 'informacoesSobreProfissional',
  /** column name */
  InformacoesSobreRestricoes = 'informacoesSobreRestricoes'
}

/** response of any mutation on the table "tbUsuariosProfissionaisOrientacoesSecretarias" */
export type UsuariosProfissionaisOrientacoesSecretarias_Mutation_Response = {
  __typename?: 'usuariosProfissionaisOrientacoesSecretarias_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UsuariosProfissionaisOrientacoesSecretarias>;
};

/** Ordering options when selecting data from "tbUsuariosProfissionaisOrientacoesSecretarias". */
export type UsuariosProfissionaisOrientacoesSecretarias_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  informacoesDuvidasFrequentes?: InputMaybe<Order_By>;
  informacoesSobreAgendamento?: InputMaybe<Order_By>;
  informacoesSobreProfissional?: InputMaybe<Order_By>;
  informacoesSobreRestricoes?: InputMaybe<Order_By>;
  usuario?: InputMaybe<Usuarios_Order_By>;
  usuarioProfissional?: InputMaybe<UsuariosProfissionais_Order_By>;
};

/** primary key columns input for table: tbUsuariosProfissionaisOrientacoesSecretarias */
export type UsuariosProfissionaisOrientacoesSecretarias_Pk_Columns_Input = {
  codUsuario: Scalars['Int']['input'];
};

/** input type for updating data in table "tbUsuariosProfissionaisOrientacoesSecretarias" */
export type UsuariosProfissionaisOrientacoesSecretarias_Set_Input = {
  informacoesDuvidasFrequentes?: InputMaybe<Scalars['String']['input']>;
  informacoesSobreAgendamento?: InputMaybe<Scalars['String']['input']>;
  informacoesSobreProfissional?: InputMaybe<Scalars['String']['input']>;
  informacoesSobreRestricoes?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tbUsuariosProfissionaisOrientacoesSecretarias" */
export enum UsuariosProfissionaisOrientacoesSecretarias_Update_Column {
  /** column name */
  InformacoesDuvidasFrequentes = 'informacoesDuvidasFrequentes',
  /** column name */
  InformacoesSobreAgendamento = 'informacoesSobreAgendamento',
  /** column name */
  InformacoesSobreProfissional = 'informacoesSobreProfissional',
  /** column name */
  InformacoesSobreRestricoes = 'informacoesSobreRestricoes'
}

/** columns and relationships of "tbUsuariosProfissionaisPlanos" */
export type UsuariosProfissionaisPlanos = {
  __typename?: 'usuariosProfissionaisPlanos';
  ativo: Scalars['Boolean']['output'];
  codPlano: Scalars['Int']['output'];
  codUsuario: Scalars['Int']['output'];
  codUsuarioProfissionalPlano: Scalars['Int']['output'];
  dataCadastro: Scalars['datetime2']['output'];
  dataFim?: Maybe<Scalars['datetime2']['output']>;
  dataInicio: Scalars['datetime2']['output'];
  /** An object relationship */
  plano: Planos;
  /** An object relationship */
  usuario?: Maybe<Usuarios>;
};

/** Boolean expression to filter rows from the table "tbUsuariosProfissionaisPlanos". All fields are combined with a logical 'AND'. */
export type UsuariosProfissionaisPlanos_Bool_Exp = {
  _and?: InputMaybe<Array<UsuariosProfissionaisPlanos_Bool_Exp>>;
  _not?: InputMaybe<UsuariosProfissionaisPlanos_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosProfissionaisPlanos_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codPlano?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioProfissionalPlano?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataFim?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataInicio?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  plano?: InputMaybe<Planos_Bool_Exp>;
  usuario?: InputMaybe<Usuarios_Bool_Exp>;
};

/** Ordering options when selecting data from "tbUsuariosProfissionaisPlanos". */
export type UsuariosProfissionaisPlanos_Order_By = {
  ativo?: InputMaybe<Order_By>;
  codPlano?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioProfissionalPlano?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  dataFim?: InputMaybe<Order_By>;
  dataInicio?: InputMaybe<Order_By>;
  plano?: InputMaybe<Planos_Order_By>;
  usuario?: InputMaybe<Usuarios_Order_By>;
};

/** order by aggregate values of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Aggregate_Order_By = {
  avg?: InputMaybe<UsuariosProfissionais_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsuariosProfissionais_Max_Order_By>;
  min?: InputMaybe<UsuariosProfissionais_Min_Order_By>;
  stddev?: InputMaybe<UsuariosProfissionais_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsuariosProfissionais_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsuariosProfissionais_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsuariosProfissionais_Sum_Order_By>;
  var_pop?: InputMaybe<UsuariosProfissionais_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsuariosProfissionais_Var_Samp_Order_By>;
  variance?: InputMaybe<UsuariosProfissionais_Variance_Order_By>;
};

/** order by avg() on columns of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Avg_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuariosProfissionais". All fields are combined with a logical 'AND'. */
export type UsuariosProfissionais_Bool_Exp = {
  Clinica?: InputMaybe<TbClinicas_Bool_Exp>;
  Cobrancas?: InputMaybe<Cobrancas_Bool_Exp>;
  Usuario?: InputMaybe<Usuarios_Bool_Exp>;
  _and?: InputMaybe<Array<UsuariosProfissionais_Bool_Exp>>;
  _not?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosProfissionais_Bool_Exp>>;
  bloqueado?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codConselhoClasse?: InputMaybe<String_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuarioTelefone?: InputMaybe<Int_Mssql_Comparison_Exp>;
  dataInicioDivida?: InputMaybe<Datetime2_Mssql_Comparison_Exp>;
  dataValidacao?: InputMaybe<Date_Mssql_Comparison_Exp>;
  diaVencimento?: InputMaybe<Int_Mssql_Comparison_Exp>;
  especialidade?: InputMaybe<String_Mssql_Comparison_Exp>;
  formaDePagamento?: InputMaybe<String_Mssql_Comparison_Exp>;
  funcionalidadesDesativadas?: InputMaybe<FuncionalidadesDesativadas_Bool_Exp>;
  profissao?: InputMaybe<String_Mssql_Comparison_Exp>;
  tbAgendamentos?: InputMaybe<Agendamentos_Bool_Exp>;
  telefonePublico?: InputMaybe<String_Mssql_Comparison_Exp>;
  usuarioTelefone?: InputMaybe<UsuariosTelefones_Bool_Exp>;
  usuariosPacotesServicos?: InputMaybe<UsuariosPacotesServicos_Bool_Exp>;
};

/** order by max() on columns of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Max_Order_By = {
  codConselhoClasse?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  dataInicioDivida?: InputMaybe<Order_By>;
  dataValidacao?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
  especialidade?: InputMaybe<Order_By>;
  formaDePagamento?: InputMaybe<Order_By>;
  profissao?: InputMaybe<Order_By>;
  telefonePublico?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Min_Order_By = {
  codConselhoClasse?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  dataInicioDivida?: InputMaybe<Order_By>;
  dataValidacao?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
  especialidade?: InputMaybe<Order_By>;
  formaDePagamento?: InputMaybe<Order_By>;
  profissao?: InputMaybe<Order_By>;
  telefonePublico?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "tbUsuariosProfissionais". */
export type UsuariosProfissionais_Order_By = {
  Clinica?: InputMaybe<TbClinicas_Order_By>;
  Cobrancas_aggregate?: InputMaybe<Cobrancas_Aggregate_Order_By>;
  Usuario?: InputMaybe<Usuarios_Order_By>;
  bloqueado?: InputMaybe<Order_By>;
  codConselhoClasse?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  dataInicioDivida?: InputMaybe<Order_By>;
  dataValidacao?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
  especialidade?: InputMaybe<Order_By>;
  formaDePagamento?: InputMaybe<Order_By>;
  funcionalidadesDesativadas_aggregate?: InputMaybe<FuncionalidadesDesativadas_Aggregate_Order_By>;
  profissao?: InputMaybe<Order_By>;
  tbAgendamentos_aggregate?: InputMaybe<Agendamentos_Aggregate_Order_By>;
  telefonePublico?: InputMaybe<Order_By>;
  usuarioTelefone?: InputMaybe<UsuariosTelefones_Order_By>;
  usuariosPacotesServicos_aggregate?: InputMaybe<UsuariosPacotesServicos_Aggregate_Order_By>;
};

/** order by stddev() on columns of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Stddev_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Stddev_Pop_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Stddev_Samp_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Sum_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Var_Pop_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Var_Samp_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "tbUsuariosProfissionais" */
export type UsuariosProfissionais_Variance_Order_By = {
  codUsuario?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  diaVencimento?: InputMaybe<Order_By>;
};

/** columns and relationships of "tbUsuariosTelefones" */
export type UsuariosTelefones = {
  __typename?: 'usuariosTelefones';
  ativo: Scalars['Boolean']['output'];
  codUsuarioTelefone: Scalars['Int']['output'];
  nomeClinica?: Maybe<Scalars['String']['output']>;
  ramalTroncoNormalizado: Scalars['String']['output'];
  /** An array relationship */
  usuariosProfissionais: Array<UsuariosProfissionais>;
};


/** columns and relationships of "tbUsuariosTelefones" */
export type UsuariosTelefonesUsuariosProfissionaisArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UsuariosProfissionais_Order_By>>;
  where?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "tbUsuariosTelefones". All fields are combined with a logical 'AND'. */
export type UsuariosTelefones_Bool_Exp = {
  _and?: InputMaybe<Array<UsuariosTelefones_Bool_Exp>>;
  _not?: InputMaybe<UsuariosTelefones_Bool_Exp>;
  _or?: InputMaybe<Array<UsuariosTelefones_Bool_Exp>>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codUsuarioTelefone?: InputMaybe<Int_Mssql_Comparison_Exp>;
  nomeClinica?: InputMaybe<String_Mssql_Comparison_Exp>;
  ramalTroncoNormalizado?: InputMaybe<String_Mssql_Comparison_Exp>;
  usuariosProfissionais?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};

/** Ordering options when selecting data from "tbUsuariosTelefones". */
export type UsuariosTelefones_Order_By = {
  ativo?: InputMaybe<Order_By>;
  codUsuarioTelefone?: InputMaybe<Order_By>;
  nomeClinica?: InputMaybe<Order_By>;
  ramalTroncoNormalizado?: InputMaybe<Order_By>;
  usuariosProfissionais_aggregate?: InputMaybe<UsuariosProfissionais_Aggregate_Order_By>;
};

/** Boolean expression to filter rows from the table "tbUsuarios". All fields are combined with a logical 'AND'. */
export type Usuarios_Bool_Exp = {
  UsuariosEspecialidades?: InputMaybe<UsuariosEspecialidades_Bool_Exp>;
  UsuariosFormaRecebimentos?: InputMaybe<UsuariosFormasRecebimentos_Bool_Exp>;
  UsuariosProfissionai?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
  _and?: InputMaybe<Array<Usuarios_Bool_Exp>>;
  _not?: InputMaybe<Usuarios_Bool_Exp>;
  _or?: InputMaybe<Array<Usuarios_Bool_Exp>>;
  apelido?: InputMaybe<String_Mssql_Comparison_Exp>;
  arquivos?: InputMaybe<UsuariosArquivos_Bool_Exp>;
  ativo?: InputMaybe<Boolean_Mssql_Comparison_Exp>;
  codPerfil?: InputMaybe<Int_Mssql_Comparison_Exp>;
  codUsuario?: InputMaybe<Int_Mssql_Comparison_Exp>;
  cpf?: InputMaybe<String_Mssql_Comparison_Exp>;
  dataCadastro?: InputMaybe<Smalldatetime_Mssql_Comparison_Exp>;
  email?: InputMaybe<String_Mssql_Comparison_Exp>;
  nome?: InputMaybe<String_Mssql_Comparison_Exp>;
  oneSignalId?: InputMaybe<Uniqueidentifier_Mssql_Comparison_Exp>;
  openidSub?: InputMaybe<String_Mssql_Comparison_Exp>;
  pronome?: InputMaybe<String_Mssql_Comparison_Exp>;
  sobrenome?: InputMaybe<String_Mssql_Comparison_Exp>;
  tbAgendamentos?: InputMaybe<Agendamentos_Bool_Exp>;
  tbFechamentos?: InputMaybe<TbFechamentos_Bool_Exp>;
  tbUsuariosAgendas?: InputMaybe<UsuariosAgendas_Bool_Exp>;
  tbUsuariosCompromissos?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
  usuariosAgendas?: InputMaybe<UsuariosAgendas_Bool_Exp>;
  usuariosCompromissos?: InputMaybe<UsuariosCompromissos_Bool_Exp>;
  usuariosProfissionais?: InputMaybe<UsuariosProfissionais_Bool_Exp>;
};

/** response of any mutation on the table "tbUsuarios" */
export type Usuarios_Mutation_Response = {
  __typename?: 'usuarios_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Usuarios>;
};

/** Ordering options when selecting data from "tbUsuarios". */
export type Usuarios_Order_By = {
  UsuariosEspecialidades_aggregate?: InputMaybe<UsuariosEspecialidades_Aggregate_Order_By>;
  UsuariosFormaRecebimentos_aggregate?: InputMaybe<UsuariosFormasRecebimentos_Aggregate_Order_By>;
  UsuariosProfissionai?: InputMaybe<UsuariosProfissionais_Order_By>;
  apelido?: InputMaybe<Order_By>;
  arquivos_aggregate?: InputMaybe<UsuariosArquivos_Aggregate_Order_By>;
  ativo?: InputMaybe<Order_By>;
  codPerfil?: InputMaybe<Order_By>;
  codUsuario?: InputMaybe<Order_By>;
  cpf?: InputMaybe<Order_By>;
  dataCadastro?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  nome?: InputMaybe<Order_By>;
  oneSignalId?: InputMaybe<Order_By>;
  openidSub?: InputMaybe<Order_By>;
  pronome?: InputMaybe<Order_By>;
  sobrenome?: InputMaybe<Order_By>;
  tbAgendamentos_aggregate?: InputMaybe<Agendamentos_Aggregate_Order_By>;
  tbFechamentos_aggregate?: InputMaybe<TbFechamentos_Aggregate_Order_By>;
  tbUsuariosAgendas_aggregate?: InputMaybe<UsuariosAgendas_Aggregate_Order_By>;
  tbUsuariosCompromissos_aggregate?: InputMaybe<UsuariosCompromissos_Aggregate_Order_By>;
  usuariosAgendas_aggregate?: InputMaybe<UsuariosAgendas_Aggregate_Order_By>;
  usuariosCompromissos_aggregate?: InputMaybe<UsuariosCompromissos_Aggregate_Order_By>;
  usuariosProfissionais?: InputMaybe<UsuariosProfissionais_Order_By>;
};

/** primary key columns input for table: tbUsuarios */
export type Usuarios_Pk_Columns_Input = {
  codUsuario: Scalars['Int']['input'];
};

/** input type for updating data in table "tbUsuarios" */
export type Usuarios_Set_Input = {
  apelido?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type ActiveAllocationQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAllocationQueryQuery = { __typename?: 'query_root', activeAllocation: Array<{ __typename?: 'AgendamentosAlocacoesAtivas', horaInicio: string, appointment: (
      { __typename?: 'agendamentos', data: string, codAgendamento: number, horaFim: string, horaInicio: string }
      & { ' $fragmentRefs'?: { 'ReturnRoomDrawerFragmentFragment': ReturnRoomDrawerFragmentFragment } }
    ), locationRoom: { __typename?: 'unidadesSalas', nome?: string | null } }> };

export type CsatCategoriesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CsatCategoriesQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'GetAllCsatCategoriesQueryFragmentFragment': GetAllCsatCategoriesQueryFragmentFragment } }
);

export type ActiveAllocationDetailsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveAllocationDetailsQueryQuery = { __typename?: 'query_root', activeAllocationDetails?: { __typename?: 'AlocacaoAtiva', codAgendamento: number, codFinalidadeAgendamento: number, dataAgendamento: string, horaInicioAlocacao: string, horaFimAlocacao: string, horaInicioAgendamento: string, horaFimAgendamento: string, nomePaciente?: string | null, nomeUsuarioCompromisso?: string | null, nomeUnidadeSala?: string | null, pacienteRegistroVirtual: boolean, tempoAtrasado: string, tempoRestante: string, tempoAlocado: string, progresso: number, atrasado: boolean, siglaSala?: string | null } | null };

export type AppointmentAvailableOptionsFormQueryQueryVariables = Exact<{
  codUnidadeOrigem: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
  data: Scalars['Date']['input'];
  horarioInicio: Scalars['TimeSpan']['input'];
  codUsuario: Scalars['Int']['input'];
}>;


export type AppointmentAvailableOptionsFormQueryQuery = { __typename?: 'query_root', buscaHorariosEmUnidadesAlternativas?: { __typename?: 'BuscaHorariosUnidadeAlternativaOutput', unidadesProximas: { __typename?: 'HorariosUnidadesAlternativas', totalUnidadesBuscadas: number, horarios: Array<{ __typename?: 'HorarioUnidadeAlternativa', codUnidade: number, dataHoraFim: string, dataHoraInicio: string, distancia: number, nomeLimpoUnidade: string, siglaUnidade: string, tipoHorarioSugestao: number }> }, unidadesComAgendaAberta: { __typename?: 'HorariosUnidadesAlternativas', totalUnidadesBuscadas: number, horarios: Array<{ __typename?: 'HorarioUnidadeAlternativa', codUnidade: number, dataHoraFim: string, dataHoraInicio: string, distancia: number, nomeLimpoUnidade: string, siglaUnidade: string, tipoHorarioSugestao: number }> } } | null };

export type CancelAppointmentMutationMutationVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
  origem?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelAppointmentMutationMutation = { __typename?: 'mutation_root', LivanceApiAgendamentoCancela?: { __typename?: 'AgendamentoOutput', codAgendamento?: number | null } | null };

export type AppointmentChannelsListToMultiSelectTestQueryFragmentFragment = { __typename?: 'query_root', canaisAgendamentos: Array<(
    { __typename?: 'canaisAgendamentos' }
    & { ' $fragmentRefs'?: { 'AppointmentChannelsListToMultiSelectQueryFragmentFragment': AppointmentChannelsListToMultiSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'AppointmentChannelsListToMultiSelectTestQueryFragmentFragment' };

export type AppointmentChannelsListToMultiSelectQueryFragmentFragment = { __typename?: 'canaisAgendamentos', codCanalAgendamento: number, nome: string } & { ' $fragmentName'?: 'AppointmentChannelsListToMultiSelectQueryFragmentFragment' };

export type AppointmentDrawerOnlinePaymentButtonFragmentFragment = { __typename?: 'agendamentos', codAgendamento: number, data: string, horaInicio: string, pago: boolean, pagar: boolean, valor: number, onlinePayments: Array<{ __typename?: 'expensum_online_payment', codAgendamento?: number | null, amount: number, status: string }>, agendamentosVinculados: Array<{ __typename?: 'tbAgendamentosVinculados', onlinePayments: Array<{ __typename?: 'expensum_online_payment', codAgendamento?: number | null, amount: number, status: string }> }> } & { ' $fragmentName'?: 'AppointmentDrawerOnlinePaymentButtonFragmentFragment' };

export type AppointmentDrawerPatientContactActionsFragmentFragment = { __typename?: 'pacientes', telefone: string, email?: string | null } & { ' $fragmentName'?: 'AppointmentDrawerPatientContactActionsFragmentFragment' };

export type AppointmentDrawerPatientInfoFragmentFragment = (
  { __typename?: 'pacientes', nome: string }
  & { ' $fragmentRefs'?: { 'PatientAvatarFragmentFragment': PatientAvatarFragmentFragment } }
) & { ' $fragmentName'?: 'AppointmentDrawerPatientInfoFragmentFragment' };

export type CalendarAppointmentDetailsDrawerAppointmentQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type CalendarAppointmentDetailsDrawerAppointmentQuery = { __typename?: 'query_root', agendamento?: (
    { __typename?: 'agendamentos', codAgendamento: number, data: string, horaInicio: string, horaFim: string, cancelado: boolean, confirmado: boolean, cobraCancelamento: boolean, pago: boolean, Unidade: { __typename?: 'unidades', nome: string }, UsuarioCompromisso?: { __typename?: 'usuariosCompromissos', nome: string } | null, AgendamentosCheckin?: { __typename?: 'tbAgendamentosCheckins', codAgendamento: number } | null, FinalidadesAgendamento: { __typename?: 'finalidadesAgendamentos', codFinalidadeAgendamento: number, taxaCobrancaAtraso: number }, Paciente?: (
      { __typename?: 'pacientes', codPaciente: number }
      & { ' $fragmentRefs'?: { 'AppointmentDrawerPatientInfoFragmentFragment': AppointmentDrawerPatientInfoFragmentFragment;'AppointmentDrawerPatientContactActionsFragmentFragment': AppointmentDrawerPatientContactActionsFragmentFragment } }
    ) | null }
    & { ' $fragmentRefs'?: { 'AppointmentDrawerOnlinePaymentButtonFragmentFragment': AppointmentDrawerOnlinePaymentButtonFragmentFragment } }
  ) | null };

export type AppointmentFlexiblePriceFormFragmentFragment = { __typename?: 'query_root', unidadesPrecosFlexiveis: Array<{ __typename?: 'UnidadesPrecosFlexiveis', taxaDesconto: number }>, unidade?: { __typename?: 'unidades', sigla?: string | null } | null, periodosGarantidos: Array<{ __typename?: 'tbPeriodosGarantidos', codPeriodoGarantido: number }> } & { ' $fragmentName'?: 'AppointmentFlexiblePriceFormFragmentFragment' };

export type CreateFlexiblePriceAppointmentMutationVariables = Exact<{
  input: CriarAgendamentoInput;
}>;


export type CreateFlexiblePriceAppointmentMutation = { __typename?: 'mutation_root', criarAgendamento: { __typename?: 'CriarAgendamentoPayload', data?: { __typename?: 'AgendamentoApiOutput', codAgendamento: number } | null, errors?: Array<{ __typename: 'RepeatedPatientError', message: string } | { __typename: 'ValidationError', message: string }> | null } };

export type GetAvailableTimesQueryQueryVariables = Exact<{
  codUnidade: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
  data: Scalars['String']['input'];
  diaSemana: Scalars['Int']['input'];
  selectedDate: Scalars['date']['input'];
}>;


export type GetAvailableTimesQueryQuery = { __typename?: 'query_root', GetAvailableTimes?: Array<{ __typename?: 'TimeSuggestion', dataHora: string, dataHoraFim: string, tipoHorarioSugestao?: number | null } | null> | null, LivanceApiFeriadosPorPeriodo?: Array<{ __typename?: 'LivanceApiFeriado', horaInicio: string, horaFim: string, codUnidade?: number | null } | null> | null, agendamentos: Array<{ __typename?: 'agendamentos', horaInicio: string, horaFim: string, data: string, codAgendamento: number, Unidade: { __typename?: 'unidades', nomeLimpo?: string | null, sigla?: string | null, codUnidade: number }, Paciente?: { __typename?: 'pacientes', nome: string } | null }>, tbFechamentos: Array<{ __typename?: 'tbFechamentos', horaFim: string, horaInicio: string, data: string, motivo?: string | null, codFechamento: number, codUnidade?: number | null, codTipoFechamento: number, Unidade?: { __typename?: 'unidades', nomeLimpo?: string | null, sigla?: string | null, codUnidade: number } | null }>, usuarioCompromisso?: { __typename?: 'usuariosCompromissos', duracao: string, tiposSalas: Array<{ __typename?: 'usuariosCompromissosTiposSalas', codTipoSala: number }> } | null, usuariosAgendas: Array<{ __typename?: 'usuariosAgendas', codUsuarioAgenda: number }> };

export type SearchSpecificSlotQueryQueryVariables = Exact<{
  input: LivanceApiBuscaHorarioLivreInput;
}>;


export type SearchSpecificSlotQueryQuery = { __typename?: 'query_root', LivanceApiBuscaHorarioLivre?: Array<{ __typename?: 'LivanceApiBuscaHorarioLivreOutput', autorizado: boolean, codUnidade: number, codUsuario: number, codUsuarioAgenda: number, fim: string, inicio: string, tipoHorarioSugestao: number, prioridade: number, podeExceder: boolean } | null> | null };

export type AppointmentTypeDurationSuggestionAlertQueryQueryVariables = Exact<{
  codUsuarioCompromisso: Scalars['Int']['input'];
}>;


export type AppointmentTypeDurationSuggestionAlertQueryQuery = { __typename?: 'query_root', sugestaoDuracao?: { __typename?: 'LivanceApiBuscaUsuarioCompromissoSugestaoDuracaoOutput', novaDuracao?: string | null, deveSugerir?: boolean | null } | null, tipoDeAtendimento?: { __typename?: 'usuariosCompromissos', duracao: string, nome: string } | null };

export type AppointmentFormFragmentFragment = { __typename?: 'query_root', usuariosAgendas: Array<{ __typename?: 'usuariosAgendas', codUsuarioAgenda: number, usuariosAgendasCompromissos: Array<{ __typename?: 'usuariosAgendasCompromissos', usuarioCompromisso: (
        { __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number, nome: string, duracao: string, usuariosCompromissosFormasRecebimentos: Array<{ __typename?: 'usuariosCompromissosFormasRecebimentos', codUsuarioFormaRecebimento: number, codUsuarioCompromisso: number, UsuarioFormaRecebimento: (
            { __typename?: 'usuariosFormasRecebimentos', codUsuarioFormaRecebimento: number }
            & { ' $fragmentRefs'?: { 'PaymentMethodsListToSelectQueryFragmentFragment': PaymentMethodsListToSelectQueryFragmentFragment } }
          ) }> }
        & { ' $fragmentRefs'?: { 'AppointmentTypesListToSelectQueryFragmentFragment': AppointmentTypesListToSelectQueryFragmentFragment } }
      ), UsuarioAgenda?: { __typename?: 'usuariosAgendas', codUsuarioAgenda: number } | null }>, usuariosAgendasUnidades: Array<{ __typename?: 'usuariosAgendasUnidades', codUsuarioAgenda: number, codUnidade: number, Unidade?: (
        { __typename?: 'unidades', codUnidade: number, nomeLimpo?: string | null, sigla?: string | null }
        & { ' $fragmentRefs'?: { 'UnitsListToSelectQueryFragmentFragment': UnitsListToSelectQueryFragmentFragment } }
      ) | null }>, usuariosAgendasDiasSemanas: Array<{ __typename?: 'tbUsuariosAgendasDiasSemanas', diaSemana: number }> }>, usuariosFormasRecebimentosAggregate: { __typename?: 'usuariosFormasRecebimentos_aggregate', aggregate?: { __typename?: 'usuariosFormasRecebimentos_aggregate_fields', count: number } | null }, finalidadesAgendamentos: Array<{ __typename?: 'finalidadesAgendamentos', codFinalidadeAgendamento: number, taxaCobrancaAtraso: number }> } & { ' $fragmentName'?: 'AppointmentFormFragmentFragment' };

export type AppointmentFormPatientFragmentFragment = { __typename?: 'query_root', appointmentType?: { __typename?: 'usuariosCompromissos', nome: string, codParceiroIntegracao?: number | null, tiposSalas: Array<{ __typename?: 'usuariosCompromissosTiposSalas', codTipoSala: number, TipoSala: { __typename?: 'tiposSalas', nome: string, unidadesPrecosFlexiveis: Array<{ __typename?: 'UnidadesPrecosFlexiveis', UnidadesPrecosFlexiveisParceirosIntegracoes: Array<{ __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes', codParceiroIntegracao: number }> }> } }> } | null, unit?: { __typename?: 'unidades', codUnidade: number, nomeLimpo?: string | null, sigla?: string | null } | null } & { ' $fragmentName'?: 'AppointmentFormPatientFragmentFragment' };

export type CreateAppointmentMutationVariables = Exact<{
  input: CriarAgendamentoInput;
}>;


export type CreateAppointmentMutation = { __typename?: 'mutation_root', criarAgendamento: { __typename?: 'CriarAgendamentoPayload', data?: { __typename?: 'AgendamentoApiOutput', codAgendamento: number } | null, errors?: Array<{ __typename: 'RepeatedPatientError', message: string } | { __typename: 'ValidationError', message: string }> | null } };

export type AppointmentPatientListFragmentFragment = { __typename?: 'query_root', pacientes: Array<(
    { __typename?: 'pacientes', nome: string, telefone: string, codPaciente: number }
    & { ' $fragmentRefs'?: { 'PatientListItemFragmentFragment': PatientListItemFragmentFragment } }
  )> } & { ' $fragmentName'?: 'AppointmentPatientListFragmentFragment' };

export type AppointmentPatientSwapFormFragmentFragment = { __typename?: 'agendamentos', codAgendamento: number, codUnidade: number, codUsuarioCompromisso: number, codUsuarioFormaRecebimento: number, data: string, nome?: string | null, nomeConvenio?: string | null, nomePlano?: string | null, numeroCarteirinha?: string | null, validadeCarteirinha?: string | null, horaInicio: string, horaFim: string, dataNascimento?: string | null, confirmado: boolean, cobraCancelamento: boolean, cancelado: boolean, telefone: string, codUsuarioAgenda?: number | null, telefoneProprio: boolean, email?: string | null, ignorarEnvioEmail: boolean, ignorarEnvioWhatsApp: boolean, codFinalidadeAgendamento: number, Unidade: { __typename?: 'unidades', nomeLimpo?: string | null }, UsuarioCompromisso?: { __typename?: 'usuariosCompromissos', nome: string, UsuariosCompromissosTiposSalas: Array<{ __typename?: 'usuariosCompromissosTiposSalas', TipoSala: { __typename?: 'tiposSalas', nome: string, codTipoSala: number } }> } | null } & { ' $fragmentName'?: 'AppointmentPatientSwapFormFragmentFragment' };

export type PatientSwapMutationMutationVariables = Exact<{
  input: TrocarPacienteInput;
}>;


export type PatientSwapMutationMutation = { __typename?: 'mutation_root', trocarPaciente: { __typename?: 'TrocarPacientePayload', data?: { __typename?: 'AgendamentoApiOutput', codAgendamento: number } | null, errors?: Array<{ __typename: 'RepeatedPatientError', message: string } | { __typename: 'ValidationError', message: string }> | null } };

export type AppointmentReceivingOptionsFormQueryFragmentFragment = { __typename?: 'query_root', formaRecebimento?: { __typename?: 'usuariosFormasRecebimentos', codUsuarioFormaRecebimento: number, codTipoConvenio?: number | null, codTipoPlano?: number | null, nomeConvenio?: string | null, sistema: boolean } | null, tiposConvenios: Array<(
    { __typename?: 'tiposConvenios' }
    & { ' $fragmentRefs'?: { 'HealthInsurancesListToSelectQueryFragmentFragment': HealthInsurancesListToSelectQueryFragmentFragment } }
  )>, tiposPlanos: Array<(
    { __typename?: 'tiposPlanos' }
    & { ' $fragmentRefs'?: { 'HealthInsurancePlansListToSelectQueryFragmentFragment': HealthInsurancePlansListToSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'AppointmentReceivingOptionsFormQueryFragmentFragment' };

export type CreateAppointmentReceivingOptionMutationVariables = Exact<{
  input: UsuarioFormaRecebimentoInput;
}>;


export type CreateAppointmentReceivingOptionMutation = { __typename?: 'mutation_root', LivanceApiCreateUsuarioFormaRecebimento: any };

export type UpdateAppointmentReceivingOptionMutationVariables = Exact<{
  input: LivanceApiPatchUsuarioFormaRecebimentoInput;
}>;


export type UpdateAppointmentReceivingOptionMutation = { __typename?: 'mutation_root', LivanceApiPatchUsuarioFormaRecebimento: any };

export type AppointmentReceivingOptionsListQueryFragmentFragment = { __typename?: 'query_root', usuariosFormasRecebimentos: Array<{ __typename?: 'usuariosFormasRecebimentos', codUsuarioFormaRecebimento: number, nomeConvenio?: string | null, TipoConvenio?: { __typename?: 'tiposConvenios', codTipoConvenio: number, nome: string } | null, tipoPlano?: { __typename?: 'tiposPlanos', nome: string } | null }> } & { ' $fragmentName'?: 'AppointmentReceivingOptionsListQueryFragmentFragment' };

export type DenyDurationSuggestionMutationMutationVariables = Exact<{
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUsuarioCompromissoTiposStatusSugestaoDuracao: Scalars['Int']['input'];
  dataUltimaAtualizacao: Scalars['datetime2']['input'];
}>;


export type DenyDurationSuggestionMutationMutation = { __typename?: 'mutation_root', update_UsuariosCompromissosStatusSugestoesDuracoes_by_pk?: { __typename?: 'UsuariosCompromissosStatusSugestoesDuracoes', codUsuarioCompromisso: number, codUsuarioCompromissoTiposStatusSugestaoDuracao: number, dataUltimaAtualizacao: string } | null };

export type AcceptDurationSuggestionMutationMutationVariables = Exact<{
  codUsuarioCompromisso: Scalars['Int']['input'];
  duracao: Scalars['time']['input'];
  codUsuarioCompromissoTiposStatusSugestaoDuracao: Scalars['Int']['input'];
  dataUltimaAtualizacao: Scalars['datetime2']['input'];
}>;


export type AcceptDurationSuggestionMutationMutation = { __typename?: 'mutation_root', update_usuariosCompromissos_by_pk?: { __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number } | null, insert_UsuariosCompromissosStatusSugestoesDuracoes_one?: { __typename?: 'UsuariosCompromissosStatusSugestoesDuracoes', codUsuarioCompromissoTiposStatusSugestaoDuracao: number } | null };

export type GetAppointmentTypeFormQueryFragmentFragment = { __typename?: 'query_root', appointmentType?: { __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number, nome: string, duracao: string, valor: number, informacoesPaciente?: string | null, descricao?: string | null, sistema: boolean, codParceiroIntegracao?: number | null, modality: { __typename?: 'usuariosCompromissosModalidades', codUsuarioCompromissoModalidade: number, nome?: string | null }, appointmentChannels: Array<{ __typename?: 'usuariosCompromissosCanaisAgendamentos', codCanalAgendamento: number }>, roomTypes: Array<{ __typename?: 'usuariosCompromissosTiposSalas', codTipoSala: number, prioridade: number }>, paymentReceiptMethods: Array<{ __typename?: 'usuariosCompromissosFormasRecebimentos', codUsuarioFormaRecebimento: number }>, category: { __typename?: 'usuariosCompromissosCategorias', codUsuarioCompromissoCategoria: number } } | null, usuariosFormasRecebimentos: Array<(
    { __typename?: 'usuariosFormasRecebimentos' }
    & { ' $fragmentRefs'?: { 'PaymentMethodsListToMultiSelectQueryFragmentFragment': PaymentMethodsListToMultiSelectQueryFragmentFragment } }
  )>, canaisAgendamentos: Array<(
    { __typename?: 'canaisAgendamentos' }
    & { ' $fragmentRefs'?: { 'AppointmentChannelsListToMultiSelectQueryFragmentFragment': AppointmentChannelsListToMultiSelectQueryFragmentFragment } }
  )>, usuariosCompromissosModalidades: Array<(
    { __typename?: 'usuariosCompromissosModalidades' }
    & { ' $fragmentRefs'?: { 'AppointmentTypeModalitiesListToSelectQueryFragmentFragment': AppointmentTypeModalitiesListToSelectQueryFragmentFragment } }
  )>, tiposSalas: Array<(
    { __typename?: 'tiposSalas' }
    & { ' $fragmentRefs'?: { 'RoomTypesListQueryFragmentFragment': RoomTypesListQueryFragmentFragment } }
  )>, usuariosEspecialidades: Array<{ __typename?: 'usuariosEspecialidades', codEspecialidade: number, Especialidade: { __typename?: 'especialidades', codTipoSala: number } }> } & { ' $fragmentName'?: 'GetAppointmentTypeFormQueryFragmentFragment' };

export type CreateAppointmentTypeMutationVariables = Exact<{
  input: LivanceApiCriaUsuarioCompromissoInput;
}>;


export type CreateAppointmentTypeMutation = { __typename?: 'mutation_root', LivanceApiCriaUsuarioCompromisso?: { __typename?: 'LivanceApiCriaUsuarioCompromissoOutput', response?: any | null } | null };

export type EditAppointmentTypeMutationVariables = Exact<{
  input: LivanceApiAlteraUsuarioCompromissoInput;
}>;


export type EditAppointmentTypeMutation = { __typename?: 'mutation_root', LivanceApiAlteraUsuarioCompromissoPatch?: { __typename?: 'LivanceApiAlteraUsuarioCompromissoOutput', codUsuarioCompromisso: number } | null };

export type AppointmentTypeListItemQueryFragmentFragment = { __typename?: 'usuariosCompromissos', nome: string, duracao: string, valor: number, codUsuarioCompromisso: number, tbUsuariosCompromissosFormasRecebimentos: Array<{ __typename?: 'usuariosCompromissosFormasRecebimentos', UsuarioFormaRecebimento: { __typename?: 'usuariosFormasRecebimentos', TipoFormaRecebimento: { __typename?: 'tiposFormasRecebimentos', nome: string } } }> } & { ' $fragmentName'?: 'AppointmentTypeListItemQueryFragmentFragment' };

export type AppointmentTypeListQueryFragmentFragment = { __typename?: 'query_root', usuariosCompromissos: Array<(
    { __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number }
    & { ' $fragmentRefs'?: { 'AppointmentTypeListItemQueryFragmentFragment': AppointmentTypeListItemQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'AppointmentTypeListQueryFragmentFragment' };

export type AppointmentTypeModalitiesListToSelectTestQueryFragmentFragment = { __typename?: 'query_root', usuariosCompromissosModalidades: Array<(
    { __typename?: 'usuariosCompromissosModalidades' }
    & { ' $fragmentRefs'?: { 'AppointmentTypeModalitiesListToSelectQueryFragmentFragment': AppointmentTypeModalitiesListToSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'AppointmentTypeModalitiesListToSelectTestQueryFragmentFragment' };

export type AppointmentTypeModalitiesListToSelectQueryFragmentFragment = { __typename?: 'usuariosCompromissosModalidades', codUsuarioCompromissoModalidade: number, nome?: string | null } & { ' $fragmentName'?: 'AppointmentTypeModalitiesListToSelectQueryFragmentFragment' };

export type AppointmentTypesListToMultiselectTestQueryFragmentFragment = { __typename?: 'query_root', usuariosCompromissos: Array<(
    { __typename?: 'usuariosCompromissos' }
    & { ' $fragmentRefs'?: { 'AppointmentTypesListToMultiSelectQueryFragmentFragment': AppointmentTypesListToMultiSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'AppointmentTypesListToMultiselectTestQueryFragmentFragment' };

export type AppointmentTypesListToMultiSelectQueryFragmentFragment = { __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number, nome: string } & { ' $fragmentName'?: 'AppointmentTypesListToMultiSelectQueryFragmentFragment' };

export type AppointmentTypesListToSelectTestQueryFragmentFragment = { __typename?: 'query_root', usuariosCompromissos: Array<(
    { __typename?: 'usuariosCompromissos' }
    & { ' $fragmentRefs'?: { 'AppointmentTypesListToSelectQueryFragmentFragment': AppointmentTypesListToSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'AppointmentTypesListToSelectTestQueryFragmentFragment' };

export type AppointmentTypesListToSelectQueryFragmentFragment = { __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number, nome: string } & { ' $fragmentName'?: 'AppointmentTypesListToSelectQueryFragmentFragment' };

export type AutomaticAnticipationToggleQueryFragmentFragment = { __typename?: 'query_root', ExpensumGetAutomaticAnticipationSettingsByRecipient?: { __typename?: 'ExpensumGetAutomaticAnticipationSettingsByRecipientOutput', automaticAnticipationSettings: { __typename?: 'ExpensumAutomaticAnticipationSettingsByRecipientOutput', enabled?: boolean | null } } | null } & { ' $fragmentName'?: 'AutomaticAnticipationToggleQueryFragmentFragment' };

export type EnableAutomaticAnticipationMutationMutationVariables = Exact<{
  object: Expensum_Event_Automatic_Anticipation_Settings_Update_Insert_Input;
}>;


export type EnableAutomaticAnticipationMutationMutation = { __typename?: 'mutation_root', insert_expensum_event_automatic_anticipation_settings_update_one?: { __typename?: 'expensum_event_automatic_anticipation_settings_update', id: number } | null };

export type DisableAutomaticAnticipationMutationMutationVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codClinica?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DisableAutomaticAnticipationMutationMutation = { __typename?: 'mutation_root', insert_expensum_event_automatic_anticipation_settings_update_one?: { __typename?: 'expensum_event_automatic_anticipation_settings_update', id: number } | null };

export type BankAccountDetailsQueryFragmentFragment = (
  { __typename?: 'query_root', ExpensumGetRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', document?: string | null, type?: string | null, bankAccounts?: Array<{ __typename?: 'ExpensumBankAccount', name?: string | null, branchNumber?: string | null, branchCheckDigit?: string | null, accountNumber?: string | null, accountCheckDigit?: string | null, type?: string | null } | null> | null } | null } | null }
  & { ' $fragmentRefs'?: { 'AutomaticAnticipationToggleQueryFragmentFragment': AutomaticAnticipationToggleQueryFragmentFragment } }
) & { ' $fragmentName'?: 'BankAccountDetailsQueryFragmentFragment' };

export type BankAccountFormQueryFragmentFragment = { __typename?: 'query_root', ExpensumGetRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', name?: string | null, type?: string | null, document?: string | null, bankAccounts?: Array<{ __typename?: 'ExpensumBankAccount', accountNumber?: string | null, accountCheckDigit?: string | null, name?: string | null } | null> | null } | null } | null, banks?: Array<(
    { __typename?: 'GetAllBanksOutput', code?: number | null, name?: string | null }
    & { ' $fragmentRefs'?: { 'BanksListToSelectQueryFragmentFragment': BanksListToSelectQueryFragmentFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'BankAccountFormQueryFragmentFragment' };

export type BankAccountUpdateMutationMutationVariables = Exact<{
  object: Expensum_Event_Bank_Account_Update_Insert_Input;
}>;


export type BankAccountUpdateMutationMutation = { __typename?: 'mutation_root', insert_expensum_event_bank_account_update_one?: { __typename?: 'expensum_event_bank_account_update', id: number } | null };

export type BanksListToSelectTestQueryFragmentFragment = { __typename?: 'query_root', banks?: Array<(
    { __typename?: 'GetAllBanksOutput' }
    & { ' $fragmentRefs'?: { 'BanksListToSelectQueryFragmentFragment': BanksListToSelectQueryFragmentFragment } }
  ) | null> | null } & { ' $fragmentName'?: 'BanksListToSelectTestQueryFragmentFragment' };

export type BanksListToSelectQueryFragmentFragment = { __typename?: 'GetAllBanksOutput', code?: number | null, fullName?: string | null } & { ' $fragmentName'?: 'BanksListToSelectQueryFragmentFragment' };

export type BillingItemDetailsAssistDownloadQueryQueryVariables = Exact<{
  assistBillingBatchId: Scalars['Int']['input'];
}>;


export type BillingItemDetailsAssistDownloadQueryQuery = { __typename?: 'query_root', NuntiusGetAssistContactBatchDetails?: { __typename?: 'NuntiusGetAssistContactBatchDetailsOutput', assistContactBatchDetails: Array<{ __typename?: 'NuntiusAssistContactBatchDetails', billingDate: string, channel: string, contactId: string, contactReason: string, contactType: string, direction: string, endDate: string, patientName: string, phoneNumber: string, price: string, startDate: string } | null> } | null };

export type AssistBillingBatchQueryFragmentFragment = { __typename?: 'nuntius_lote_contatos_cobranca', contatosPorDia: { __typename?: 'nuntius_contatos_por_dia', totalCobravel: number, totalDigitalCobravel: number, totalHumanoCobravel: number, data: string } } & { ' $fragmentName'?: 'AssistBillingBatchQueryFragmentFragment' };

export type AssistBillingBatchVariablePricesFragmentFragment = { __typename?: 'pacoteServicoPreco', pacotesServicosPrecosVariaveis: Array<{ __typename?: 'tbPacotesServicosPrecosVariaveis', valorUnitario: number, codPacoteServicosPrecoVariavel: number }> } & { ' $fragmentName'?: 'AssistBillingBatchVariablePricesFragmentFragment' };

export type BillingItemDetailsQueryFragmentFragment = { __typename?: 'MovimentacaoExibicao', cobrado: boolean, codCobranca?: number | null, codModalidadeFiscal: number, codMovimentacao: number, codOrigem?: number | null, codTipoMovimentacao: number, codUnidade?: number | null, codUsuario: number, dataCadastro: string, dataVencimento: string, identificacaoTipoMovimentacao?: string | null, valorUnitario: any, valorDesconto: any, valorAcrescimo: any, valor: any, tipoOrigem?: string | null, tempoUnitario: string, quantidade: any, possuiExtensao: boolean, nomeTipoMovimentacao: string, nomeUnidade?: string | null } & { ' $fragmentName'?: 'BillingItemDetailsQueryFragmentFragment' };

export type AllocationDetailsQueryFragmentFragment = { __typename?: 'AlocacaoDetalhada', horaFimCobrado: string, horaFimDevolvido: string, horaInicio: string, partes: Array<{ __typename?: 'AlocacaoParcial', horaFim: string, horaInicio: string, taxaCobranca: any, tipoAlocacao: TipoAlocacao }> } & { ' $fragmentName'?: 'AllocationDetailsQueryFragmentFragment' };

export type AppointmentDetailsQueryFragmentFragment = { __typename?: 'agendamentos', nome?: string | null, cobraCancelamento: boolean, codFinalidadeAgendamento: number, data: string, horaInicio: string, horaFim: string } & { ' $fragmentName'?: 'AppointmentDetailsQueryFragmentFragment' };

export type BillingListItemQueryFragmentFragment = { __typename?: 'MovimentacaoExibicao', codCobranca?: number | null, codMovimentacao: number, codOrigem?: number | null, codUsuario: number, dataCadastro: string, quantidade: any, tempoUnitario: string, tipoOrigem?: string | null, valor: any, valorDesconto: any, valorUnitario: any, valorAcrescimo: any, nomeUnidade?: string | null, nomeTipoMovimentacao: string, identificacaoTipoMovimentacao?: string | null } & { ' $fragmentName'?: 'BillingListItemQueryFragmentFragment' };

export type BillingItemQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type BillingItemQueryQuery = { __typename?: 'query_root', agendamento?: { __typename?: 'agendamentos', nome?: string | null, cobraCancelamento: boolean, codFinalidadeAgendamento: number, data: string, horaInicio: string, horaFim: string } | null, agendamentosAlocacoes: Array<{ __typename?: 'agendamentosAlocacoes', duracaoEmMinutos?: number | null }> };

export type BillingListQueryFragmentFragment = { __typename?: 'CobrancaExibicao', codCobranca: number, valor: any, dataVencimento?: string | null, movimentacoes: Array<(
    { __typename?: 'MovimentacaoExibicao' }
    & { ' $fragmentRefs'?: { 'BillingListItemQueryFragmentFragment': BillingListItemQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'BillingListQueryFragmentFragment' };

export type BillingQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingQueryQuery = { __typename?: 'query_root', cobrancasAbertas?: { __typename?: 'CobrancasAbertasConnection', Billings?: Array<(
      { __typename?: 'CobrancaExibicao' }
      & { ' $fragmentRefs'?: { 'BillingListQueryFragmentFragment': BillingListQueryFragmentFragment } }
    ) | null> | null } | null, cobrancasFechadas?: { __typename?: 'CobrancasFechadasConnection', Billings?: Array<(
      { __typename?: 'CobrancaExibicao' }
      & { ' $fragmentRefs'?: { 'BillingListQueryFragmentFragment': BillingListQueryFragmentFragment } }
    ) | null> | null } | null };

export type BlockedActionsListAlertFragmentFragment = { __typename?: 'query_root', listaAcoesBloqueadas?: Array<{ __typename?: 'UsuarioAcaoBloqueadaViewModel', codUsuarioAcao: CodUsuarioAcao } | null> | null } & { ' $fragmentName'?: 'BlockedActionsListAlertFragmentFragment' };

export type UnsubscribeAssistProMutationMutationVariables = Exact<{
  telefone: Scalars['String']['input'];
}>;


export type UnsubscribeAssistProMutationMutation = { __typename?: 'mutation_root', cancelarPacoteServicosAssistPro: { __typename?: 'CancelarPacoteServicosAssistProPayload', boolean?: boolean | null, errors?: Array<{ __typename: 'ValidationError', message: string }> | null } };

export type UpsertPublicPhoneFragmentFragment = { __typename?: 'query_root', usuariosProfissionais: Array<{ __typename?: 'usuariosProfissionais', telefonePublico?: string | null }> } & { ' $fragmentName'?: 'UpsertPublicPhoneFragmentFragment' };

export type CardDetailsQueryFragmentFragment = { __typename?: 'query_root', usuarioProfissional?: { __typename?: 'usuariosProfissionais', formaDePagamento: string } | null, usuariosCartoes: Array<{ __typename?: 'usuariosCartoes', ativo: boolean, bandeira?: string | null, numero?: string | null, validade?: string | null }> } & { ' $fragmentName'?: 'CardDetailsQueryFragmentFragment' };

export type CardInfoQueryFragmentFragment = { __typename?: 'query_root', usuariosCartoes: Array<{ __typename?: 'usuariosCartoes', bandeira?: string | null, numero?: string | null, validade?: string | null }> } & { ' $fragmentName'?: 'CardInfoQueryFragmentFragment' };

export type ChangeBankingInstitutionQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codClinica?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChangeBankingInstitutionQueryQuery = { __typename?: 'query_root', expensumRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', document?: string | null, type?: string | null } | null } | null };

export type GetOnlinePaymentInfoByGuidQueryVariables = Exact<{
  guid: Scalars['uuid']['input'];
}>;


export type GetOnlinePaymentInfoByGuidQuery = { __typename?: 'query_root', onlinePayment: Array<{ __typename?: 'expensum_online_payment', id: number }> };

export type ChangeOnlinePaymentStatusMutationVariables = Exact<{
  onlinePaymentId: Scalars['Int']['input'];
  object: Expensum_Online_Payment_Activity_Insert_Input;
}>;


export type ChangeOnlinePaymentStatusMutation = { __typename?: 'mutation_root', update_expensum_online_payment_by_pk?: { __typename?: 'expensum_online_payment', guid: any } | null, insert_expensum_online_payment_activity_one?: { __typename?: 'expensum_online_payment_activity', onlinePaymentId: number } | null };

export type ChangePlanAlertFragmentFragment = { __typename?: 'query_root', usuarioPlano: Array<{ __typename?: 'usuariosProfissionaisPlanos', dataInicio: string, plano: { __typename?: 'planos', temFidelidade: boolean, nomeExibicao: string, observacao?: string | null, duracaoFidelidadeEmMeses: number } }>, usuariosEspecialidades: Array<{ __typename?: 'usuariosEspecialidades', codEspecialidade: number }> } & { ' $fragmentName'?: 'ChangePlanAlertFragmentFragment' };

export type ProfilePictureFragmentFragment = { __typename?: 'query_root', profilePictureFile?: { __typename?: 'LivanceApiSelecionaFotoDePerfilOutput', arquivo?: string | null, mimetype?: string | null } | null } & { ' $fragmentName'?: 'ProfilePictureFragmentFragment' };

export type ChangeTimeConfirmFragmentFragment = { __typename?: 'agendamentos', codAgendamento: number, codUnidade: number, codUsuarioCompromisso: number, codUsuarioFormaRecebimento: number, codUsuarioAgenda?: number | null, data: string, nome?: string | null, nomeConvenio?: string | null, nomePlano?: string | null, numeroCarteirinha?: string | null, validadeCarteirinha?: string | null, dataNascimento?: string | null, confirmado: boolean, cancelado: boolean, cobraCancelamento: boolean, codPaciente?: number | null, telefone: string, telefoneProprio: boolean, email?: string | null, ignorarEnvioEmail: boolean, ignorarEnvioWhatsApp: boolean, codFinalidadeAgendamento: number, paciente?: { __typename?: 'pacientes', cpfProprio: boolean } | null, unidade: { __typename?: 'unidades', nomeLimpo?: string | null } } & { ' $fragmentName'?: 'ChangeTimeConfirmFragmentFragment' };

export type ChangeTimeMutationVariables = Exact<{
  input: AdiantarOuAtrasarInput;
}>;


export type ChangeTimeMutation = { __typename?: 'mutation_root', adiantarOuAtrasar: { __typename?: 'AdiantarOuAtrasarPayload', data?: { __typename?: 'AgendamentoApiOutput', codAgendamento: number } | null, errors?: Array<{ __typename: 'RepeatedPatientError', message: string } | { __typename: 'ValidationError', message: string }> | null } };

export type ChangeTimeMinutesFragmentFragment = { __typename?: 'agendamentos', codAgendamento: number, horaInicio: string, horaFim: string } & { ' $fragmentName'?: 'ChangeTimeMinutesFragmentFragment' };

export type ChangeTimeFormQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
  horarios: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ChangeTimeFormQueryQuery = { __typename?: 'query_root', horarios?: Array<{ __typename?: 'LivanceApiBuscaHorarioLivreReagendamentoOutput', autorizado?: boolean | null, fim?: string | null, inicio?: string | null, motivo?: string | null } | null> | null };

export type HandleFavoriteMemberMutationMutationVariables = Exact<{
  codUsuarioFollowing: Scalars['Int']['input'];
}>;


export type HandleFavoriteMemberMutationMutation = { __typename?: 'mutation_root', insert_nexus_follow_one?: { __typename?: 'nexus_follow', id: number } | null };

export type HandleNotFavoriteMemberMutationMutationVariables = Exact<{
  codUsuarioFollowing: Scalars['Int']['input'];
}>;


export type HandleNotFavoriteMemberMutationMutation = { __typename?: 'mutation_root', delete_nexus_follow?: { __typename?: 'nexus_follow_mutation_response', affected_rows: number } | null };

export type CommunityFilterDrawerQueryFragmentFragment = { __typename?: 'query_root', locations: Array<{ __typename?: 'unidades', codUnidade: number, nome: string }>, specialties: Array<{ __typename?: 'especialidades', nome?: string | null, codEspecialidade: number }> } & { ' $fragmentName'?: 'CommunityFilterDrawerQueryFragmentFragment' };

export type CommunityListFollowersQueryQueryVariables = Exact<{
  nomeMembro?: Scalars['String']['input'];
  codEspecialidades?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  codUnidades?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  codUsuarios?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type CommunityListFollowersQueryQuery = { __typename?: 'query_root', perfisComunidade?: (
    { __typename?: 'PerfisComunidadeConnection' }
    & { ' $fragmentRefs'?: { 'CommunityListMapFragmentFragment': CommunityListMapFragmentFragment } }
  ) | null };

export type CommunityListMapFragmentFragment = { __typename?: 'PerfisComunidadeConnection', listaMembros?: Array<{ __typename?: 'MembroPerfilComunidade', codUsuario: number, nome?: string | null, site?: string | null, telefone?: string | null, ramal?: string | null, urlFoto?: string | null, follow: Array<{ __typename?: 'nexus_follow', codUsuarioFollowing: number, codUsuarioFollower: number }>, unidades?: Array<{ __typename?: 'Unidade', nome?: string | null }> | null, especialidades?: Array<{ __typename?: 'Especialidade', nome?: string | null }> | null } | null> | null } & { ' $fragmentName'?: 'CommunityListMapFragmentFragment' };

export type CommunityListSearchQueryQueryVariables = Exact<{
  nomeMembro?: Scalars['String']['input'];
  codEspecialidades?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  codUnidades?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  codUsuario: Scalars['Int']['input'];
}>;


export type CommunityListSearchQueryQuery = { __typename?: 'query_root', perfisComunidade?: (
    { __typename?: 'PerfisComunidadeConnection' }
    & { ' $fragmentRefs'?: { 'CommunityListMapFragmentFragment': CommunityListMapFragmentFragment } }
  ) | null, seguindo: Array<{ __typename?: 'nexus_follow', codUsuarioFollowing: number }> };

export type CreateAppointmentPatientListFragmentFragment = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'AppointmentPatientListFragmentFragment': AppointmentPatientListFragmentFragment } }
) & { ' $fragmentName'?: 'CreateAppointmentPatientListFragmentFragment' };

export type InsertOnlinePaymentMutationVariables = Exact<{
  object: ExpensumCreateOnlinePaymentInput;
}>;


export type InsertOnlinePaymentMutation = { __typename?: 'mutation_root', ExpensumCreateOnlinePayment?: { __typename?: 'ExpensumCreateOnlinePaymentOutput', guid: string } | null };

export type SearchPatientsQueryVariables = Exact<{
  nome: Scalars['String']['input'];
}>;


export type SearchPatientsQuery = { __typename?: 'query_root', pacientes: Array<{ __typename?: 'pacientes', codPaciente: number, nome: string, email?: string | null, telefone: string }> };

export type CreatePaymentFormFragmentFragment = { __typename?: 'query_root', agendamento?: { __typename?: 'agendamentos', nome?: string | null, telefone: string, email?: string | null, codAgendamento: number, horaInicio: string, data: string, compromisso?: { __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number, valor: number, nome: string } | null } | null, paciente?: { __typename?: 'pacientes', nome: string, email?: string | null, telefone: string } | null, formasDePagamento: Array<(
    { __typename?: 'expensum_payment_type' }
    & { ' $fragmentRefs'?: { 'OnlinePaymentTypesCheckboxGroupFragmentFragment': OnlinePaymentTypesCheckboxGroupFragmentFragment } }
  )> } & { ' $fragmentName'?: 'CreatePaymentFormFragmentFragment' };

export type LivanceApiCadastraCartaoMutationMutationVariables = Exact<{
  cardHash: Scalars['String']['input'];
  codUsuario: Scalars['Int']['input'];
}>;


export type LivanceApiCadastraCartaoMutationMutation = { __typename?: 'mutation_root', LivanceApiCadastraNovoCartao?: { __typename?: 'LivanceApiCadastraNovoCartaoOutput', ativo: boolean, codUsuario: number, cardHash?: string | null } | null };

export type GetAllCsatCategoriesQueryFragmentFragment = { __typename?: 'query_root', csatCategorias: Array<(
    { __typename?: 'csatCategorias' }
    & { ' $fragmentRefs'?: { 'CsatCategoriesListQueryFragmentFragment': CsatCategoriesListQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'GetAllCsatCategoriesQueryFragmentFragment' };

export type CsatCategoriesTestListQueryFragment = { __typename?: 'query_root', csatCategorias: Array<(
    { __typename?: 'csatCategorias' }
    & { ' $fragmentRefs'?: { 'CsatCategoriesListQueryFragmentFragment': CsatCategoriesListQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'CsatCategoriesTestListQueryFragment' };

export type CsatCategoriesListQueryFragmentFragment = { __typename?: 'csatCategorias', nome: string, csatCategoriasNotas: Array<{ __typename?: 'csatCategoriasNotas', codCsatCategoria: number, nota: number, ordem: number }> } & { ' $fragmentName'?: 'CsatCategoriesListQueryFragmentFragment' };

export type CurrentPlanCardFragmentFragment = { __typename?: 'query_root', tiposMovimentacoes: Array<{ __typename?: 'tiposMovimentacoes', valorUnitario: number }>, usuariosProfissionaisPlanos: Array<{ __typename?: 'usuariosProfissionaisPlanos', plano: { __typename?: 'planos', tipoMovimentacao?: { __typename?: 'tiposMovimentacoes', valorUnitario: number, usuariosMovimentacoesRecorrentes: Array<{ __typename?: 'usuariosMovimentacoesRecorrentes', quantidade: number, ativo: boolean, dataInicio: string }> } | null } }>, usuarioPlano: Array<{ __typename?: 'usuariosProfissionaisPlanos', plano: { __typename?: 'planos', nome: string, valor: number, temFidelidade: boolean, nomeExibicao: string, descricao?: string | null, tipoPlano: string, duracaoFidelidadeEmMeses: number, carenciaEmMeses: number } }> } & { ' $fragmentName'?: 'CurrentPlanCardFragmentFragment' };

export type CurrentPlanInfoFragmentFragment = { __typename?: 'query_root', tiposMovimentacoes: Array<{ __typename?: 'tiposMovimentacoes', valorUnitario: number }>, usuariosProfissionaisPlanos: Array<{ __typename?: 'usuariosProfissionaisPlanos', plano: { __typename?: 'planos', tipoMovimentacao?: { __typename?: 'tiposMovimentacoes', valorUnitario: number, usuariosMovimentacoesRecorrentes: Array<{ __typename?: 'usuariosMovimentacoesRecorrentes', quantidade: number, ativo: boolean, dataInicio: string }> } | null } }>, usuarioPlano: Array<{ __typename?: 'usuariosProfissionaisPlanos', plano: { __typename?: 'planos', nome: string, temFidelidade: boolean, nomeExibicao: string, tipoPlano: string } }>, usuarioPlanoFuturo: Array<{ __typename?: 'usuariosProfissionaisPlanos', dataInicio: string, plano: { __typename?: 'planos', nomeExibicao: string } }>, usuariosProfissionais: Array<{ __typename?: 'usuariosProfissionais', diaVencimento?: number | null, dataValidacao?: string | null }> } & { ' $fragmentName'?: 'CurrentPlanInfoFragmentFragment' };

export type AppointmentDashboardCompletedAppointmentsSectionQueryFragmentFragment = { __typename?: 'DataItemRelatorioIndependente', mes?: string | null, consultasRealizadas?: any | null, consultasPresenciais?: any | null, consultasVirtuais?: any | null } & { ' $fragmentName'?: 'AppointmentDashboardCompletedAppointmentsSectionQueryFragmentFragment' };

export type AppointmentDashboardLatePatientsSectionQueryFragmentFragment = { __typename?: 'DataItemRelatorioIndependente', mes?: string | null, agendamentosPacienteAtrasado?: any | null } & { ' $fragmentName'?: 'AppointmentDashboardLatePatientsSectionQueryFragmentFragment' };

export type AppointmentDashboardNoShowSectionQueryFragmentFragment = { __typename?: 'DataItemRelatorioIndependente', mes?: string | null, consultasNoShow?: any | null } & { ' $fragmentName'?: 'AppointmentDashboardNoShowSectionQueryFragmentFragment' };

export type AppointmentDashboardShareReportQueryQueryVariables = Exact<{
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type AppointmentDashboardShareReportQueryQuery = { __typename?: 'query_root', analyticsMembroRelatorioIndependente?: { __typename?: 'AnalyticsMembroRelatorioIndependente', data: Array<{ __typename?: 'DataItemRelatorioIndependente', agendamentosMarcados?: any | null, consultasRealizadas?: any | null, consultasVirtuais?: any | null, mes?: string | null, reagendamentos?: any | null, agendamentosNovos?: any | null, consultasPresenciais?: any | null, consultasNoShow?: any | null, cancelamentosDefinitivos?: any | null, agendamentosPacienteAtrasado?: any | null, agendamentosConveniosParaOMes?: any | null, agendamentosMarcadosParaOMes?: any | null, agendamentosParticularesParaOMes?: any | null, cancelamentos?: any | null } | null> } | null };

export type AppointmentDashboardTotalCancelledSectionQueryFragmentFragment = { __typename?: 'DataItemRelatorioIndependente', cancelamentos?: any | null, cancelamentosDefinitivos?: any | null, mes?: string | null } & { ' $fragmentName'?: 'AppointmentDashboardTotalCancelledSectionQueryFragmentFragment' };

export type AppointmentDashboardTotalSchedulesPerAppointmentReceivingOptionsQueryFragmentFragment = { __typename?: 'DataItemRelatorioIndependente', agendamentosMarcadosParaOMes?: any | null, agendamentosParticularesParaOMes?: any | null, agendamentosConveniosParaOMes?: any | null, mes?: string | null } & { ' $fragmentName'?: 'AppointmentDashboardTotalSchedulesPerAppointmentReceivingOptionsQueryFragmentFragment' };

export type CustomerContactDashboardContactByTypeSectionQueryFragmentFragment = { __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', period: string, percentDigitalCustomerContacts: number, percentHumanCustomerContacts: number, totalDigitalCustomerContacts: number, totalCustomerContacts: number, totalHumanCustomerContacts: number, percentGrowthTotalCustomerContacts: number } & { ' $fragmentName'?: 'CustomerContactDashboardContactByTypeSectionQueryFragmentFragment' };

export type CustomerContactDashboardContactReasonSectionQueryFragmentFragment = { __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', totalCustomerContacts: number, period: string, percentGrowthTotalCustomerContacts: number, mainReasonsOccurrences: Array<{ __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOccurrenceData', key: number, total: number }> } & { ' $fragmentName'?: 'CustomerContactDashboardContactReasonSectionQueryFragmentFragment' };

export type CustomerContactDashboardContactSummarySectionQueryFragmentFragment = { __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', period: string, totalCustomerContacts: number, totalBeforeFiltering: number, totalFiltered: number, percentTotalFilteredCustomerContacts: number } & { ' $fragmentName'?: 'CustomerContactDashboardContactSummarySectionQueryFragmentFragment' };

export type CustomerContactDashboardContactsDistributionSectionQueryFragmentFragment = { __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', totalCustomerContacts: number, totalOldCustomerContacts: number, percentOldCustomerContacts: number, totalNewCustomerContacts: number, percentNewCustomerContacts: number, period: string, percentGrowthTotalCustomerContacts: number } & { ' $fragmentName'?: 'CustomerContactDashboardContactsDistributionSectionQueryFragmentFragment' };

export type CustomerContactDashboardHumanContactsSectionQueryFragmentFragment = { __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', totalHumanCustomerContacts: number, totalHumanCustomerContactsChat: number, percentHumanCustomerContactsChat: number, totalHumanCustomerContactsVoice: number, percentHumanCustomerContactsVoice: number, period: string, percentGrowthTotalHumanCustomerContacts: number } & { ' $fragmentName'?: 'CustomerContactDashboardHumanContactsSectionQueryFragmentFragment' };

export type CustomerContactDashboardReasonsForNotSchedulingSectionQueryFragmentFragment = { __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', period: string, mostFrequentNotScheduledAppointmentReasons: Array<{ __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOccurrenceData', key: number, total: number, percent: number }> } & { ' $fragmentName'?: 'CustomerContactDashboardReasonsForNotSchedulingSectionQueryFragmentFragment' };

export type CustomerContactDashboardSchedulingConversionRateSectionQueryFragmentFragment = { __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', percentCustomerContactsAppointmentsScheduled: number, totalCustomerContactsNewAppointmentMainReason: number, totalCustomerContactsAppointmentsScheduled: number, period: string } & { ' $fragmentName'?: 'CustomerContactDashboardSchedulingConversionRateSectionQueryFragmentFragment' };

export type CustomerContactDashboardShareReportQueryQueryVariables = Exact<{
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type CustomerContactDashboardShareReportQueryQuery = { __typename?: 'query_root', NuntiusGetCustomerContactManyPeriodSummary?: Array<{ __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', totalHumanCustomerContacts: number, totalHumanCustomerContactsChat: number, totalHumanCustomerContactsVoice: number, period: string, totalCustomerContacts: number, totalCustomerContactsChat: number, totalCustomerContactsVoice: number, percentCustomerContactsAppointmentsScheduled: number, totalCustomerContactsAppointmentsScheduled: number, totalCustomerContactsNewAppointmentMainReason: number, totalNewCustomerContacts: number, totalOldCustomerContacts: number, totalDigitalCustomerContacts: number, totalBeforeFiltering: number, totalFiltered: number, mainReasonsOccurrences: Array<{ __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOccurrenceData', key: number, total: number, percent: number }>, mostFrequentNotScheduledAppointmentReasons: Array<{ __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOccurrenceData', key: number, total: number, percent: number }>, removedFilters: Array<{ __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOccurrenceData', key: number, total: number, percent: number } | null> }> | null };

export type CustomerContactDashboardTotalContactsSectionQueryFragmentFragment = { __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', totalCustomerContacts: number, totalCustomerContactsVoice: number, percentCustomerContactsVoice: number, totalCustomerContactsChat: number, percentCustomerContactsChat: number, period: string, percentGrowthTotalCustomerContacts: number } & { ' $fragmentName'?: 'CustomerContactDashboardTotalContactsSectionQueryFragmentFragment' };

export type DashboardFeatureStatusBadgeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardFeatureStatusBadgeQueryQuery = { __typename?: 'query_root', funcionalidadesDesativadas: Array<{ __typename?: 'funcionalidadesDesativadas', codFuncionalidade: number }> };

export type DeleteAppointmentReminderMutationVariables = Exact<{
  codLembrete: Scalars['Int']['input'];
}>;


export type DeleteAppointmentReminderMutation = { __typename?: 'mutation_root', update_lembretes_by_pk?: { __typename?: 'lembretes', ativo: boolean, codLembrete: number } | null };

export type ExtendTimeFormFragmentFragment = { __typename?: 'query_root', LivanceApiBuscaHorariosParaEstender?: Array<{ __typename?: 'TimeSuggestion', dataHora: string, dataHoraFim: string, duracao: string, tipoHorarioSugestao?: number | null } | null> | null, activeAllocation?: { __typename?: 'AgendamentosAlocacoesAtivas', codAgendamento: number, Agendamento: { __typename?: 'agendamentos', codUsuario: number, codUnidade: number, UsuarioCompromisso?: { __typename?: 'usuariosCompromissos', duracao: string } | null } } | null } & { ' $fragmentName'?: 'ExtendTimeFormFragmentFragment' };

export type CreateExtendTimeMutationMutationVariables = Exact<{
  input: EstenderAgendamentoInput;
}>;


export type CreateExtendTimeMutationMutation = { __typename?: 'mutation_root', estenderAgendamento: { __typename?: 'EstenderAgendamentoPayload', errors?: Array<{ __typename: 'ValidationError', message: string }> | null, agendamentoApiOutput?: { __typename?: 'AgendamentoApiOutput', codAgendamento: number } | null } };

export type DisabledFeatureQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DisabledFeatureQueryQuery = { __typename?: 'query_root', funcionalidadesDesativadas: Array<{ __typename?: 'funcionalidadesDesativadas', codFuncionalidade: number, codUsuario: number }> };

export type DisableFeatureMutationMutationVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codFuncionalidade: Scalars['Int']['input'];
}>;


export type DisableFeatureMutationMutation = { __typename?: 'mutation_root', insert_funcionalidadesDesativadas_one?: { __typename?: 'funcionalidadesDesativadas', codUsuario: number } | null };

export type EnableFeatureMutationMutationVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codFuncionalidade: Scalars['Int']['input'];
}>;


export type EnableFeatureMutationMutation = { __typename?: 'mutation_root', delete_funcionalidadesDesativadas?: { __typename?: 'funcionalidadesDesativadas_mutation_response', affected_rows: number } | null };

export type FeedbackDesiredTimeQueryQueryVariables = Exact<{
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUnidade: Scalars['Int']['input'];
}>;


export type FeedbackDesiredTimeQueryQuery = { __typename?: 'query_root', tipoDeAtendimento?: { __typename?: 'usuariosCompromissos', duracao: string, tiposSalas: Array<{ __typename?: 'usuariosCompromissosTiposSalas', codTipoSala: number }> } | null, unidade?: { __typename?: 'unidades', sigla?: string | null } | null };

export type FlexiblePriceDrawerQueryQueryVariables = Exact<{
  appointmentId: Scalars['Int']['input'];
}>;


export type FlexiblePriceDrawerQueryQuery = { __typename?: 'query_root', agendamento?: { __typename?: 'agendamentos', horaInicio: string, horaFim: string } | null, PrecificacoesTiposSalas: Array<{ __typename?: 'PrecificacoesTiposSalas', TipoMovimentacao: { __typename?: 'tiposMovimentacoes', valorUnitario: number } }> };

export type FollowUpAppointmentReminderInsertMutationMutationVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
  codPaciente: Scalars['Int']['input'];
  codUsuario?: InputMaybe<Scalars['Int']['input']>;
  dataCadastro: Scalars['datetime2']['input'];
  codTipoLembrete: Scalars['Int']['input'];
  dataParaEnvio: Scalars['datetime2']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
}>;


export type FollowUpAppointmentReminderInsertMutationMutation = { __typename?: 'mutation_root', insert_lembretes_one?: { __typename?: 'lembretes', codLembrete: number, codUsuario: number, codAgendamento: number, dataParaEnvio: string, codTipoLembrete: number, usuarioCompromisso?: { __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number, nome: string } | null, paciente: { __typename?: 'pacientes', nome: string } } | null };

export type FollowUpAppointmentReminderFormFragmentFragment = { __typename?: 'query_root', usuariosAgendas: Array<{ __typename?: 'usuariosAgendas', usuariosAgendasCompromissos: Array<{ __typename?: 'usuariosAgendasCompromissos', usuariosCompromissos: (
        { __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number, nome: string, duracao: string }
        & { ' $fragmentRefs'?: { 'AppointmentTypesListToSelectQueryFragmentFragment': AppointmentTypesListToSelectQueryFragmentFragment } }
      ) }> }>, appointment?: { __typename?: 'agendamentos', codPaciente?: number | null, codUsuario: number, codAgendamento: number } | null } & { ' $fragmentName'?: 'FollowUpAppointmentReminderFormFragmentFragment' };

export type FollowUpAppointmentReminderListItemQueryFragment = { __typename?: 'lembretes', codLembrete: number, dataParaEnvio: string, paciente: { __typename?: 'pacientes', nome: string }, tipoDeAtendimento?: { __typename?: 'usuariosCompromissos', nome: string } | null } & { ' $fragmentName'?: 'FollowUpAppointmentReminderListItemQueryFragment' };

export type FollowUpAppointmentReminderListQueryFragment = { __typename?: 'query_root', lembretes: Array<(
    { __typename?: 'lembretes', codLembrete: number, paciente: { __typename?: 'pacientes', nome: string }, usuarioCompromisso?: { __typename?: 'usuariosCompromissos', nome: string } | null }
    & { ' $fragmentRefs'?: { 'FollowUpAppointmentReminderListItemQueryFragment': FollowUpAppointmentReminderListItemQueryFragment } }
  )> } & { ' $fragmentName'?: 'FollowUpAppointmentReminderListQueryFragment' };

export type FollowUpAppointmentReminderMessageDrawerFragmentFragment = { __typename?: 'agendamentos', nome?: string | null, Usuario?: { __typename?: 'usuarios', apelido?: string | null, nome: string, sobrenome: string } | null, UsuarioCompromisso?: { __typename?: 'usuariosCompromissos', nome: string } | null } & { ' $fragmentName'?: 'FollowUpAppointmentReminderMessageDrawerFragmentFragment' };

export type GetLatestTermsOfUseQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestTermsOfUseQueryQuery = { __typename?: 'query_root', termsOfUse: Array<{ __typename?: 'terms_of_use', file: string, id: number, release_date: any }> };

export type InsertTermsOfUseAgreementMutationVariables = Exact<{
  agreedFromIp: Scalars['String']['input'];
  termsOfUseId: Scalars['Int']['input'];
  livanceCoreId: Scalars['Int']['input'];
}>;


export type InsertTermsOfUseAgreementMutation = { __typename?: 'mutation_root', insertTerms?: { __typename?: 'users_terms_of_use_agreed_mutation_response', affected_rows: number } | null };

export type HealthInsurancePlansListToSelectTestQueryFragmentFragment = { __typename?: 'query_root', tiposPlanos: Array<(
    { __typename?: 'tiposPlanos' }
    & { ' $fragmentRefs'?: { 'HealthInsurancePlansListToSelectQueryFragmentFragment': HealthInsurancePlansListToSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'HealthInsurancePlansListToSelectTestQueryFragmentFragment' };

export type HealthInsurancePlansListToSelectQueryFragmentFragment = { __typename?: 'tiposPlanos', codTipoPlano: number, nome: string } & { ' $fragmentName'?: 'HealthInsurancePlansListToSelectQueryFragmentFragment' };

export type HealthInsurancesListToSelectTestQueryFragmentFragment = { __typename?: 'query_root', tiposConvenios: Array<(
    { __typename?: 'tiposConvenios' }
    & { ' $fragmentRefs'?: { 'HealthInsurancesListToSelectQueryFragmentFragment': HealthInsurancesListToSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'HealthInsurancesListToSelectTestQueryFragmentFragment' };

export type HealthInsurancesListToSelectQueryFragmentFragment = { __typename?: 'tiposConvenios', codTipoConvenio: number, nome: string } & { ' $fragmentName'?: 'HealthInsurancesListToSelectQueryFragmentFragment' };

export type HomeCalendarDayEventFragmentFragment = { __typename?: 'query_root', agendamentos: Array<{ __typename?: 'agendamentos', codAgendamento: number, data: string, horaInicio: string, horaFim: string, nome?: string | null, confirmado: boolean, cancelado: boolean, cobraCancelamento: boolean, codFinalidadeAgendamento: number, pago: boolean, AgendamentosCheckin?: { __typename?: 'tbAgendamentosCheckins', codAgendamento: number } | null, FinalidadesAgendamento: { __typename?: 'finalidadesAgendamentos', codFinalidadeAgendamento: number, taxaCobrancaAtraso: number }, Paciente?: { __typename?: 'pacientes', telefone: string, nome: string, email?: string | null, codPaciente: number } | null, UsuarioCompromisso?: { __typename?: 'usuariosCompromissos', nome: string } | null, Unidade: { __typename?: 'unidades', codUnidade: number, nome: string, sigla?: string | null, nomeLimpo?: string | null, ativo: boolean } }>, tbFechamentos: Array<{ __typename?: 'tbFechamentos', codUnidade?: number | null, data: string, horaFim: string, horaInicio: string, motivo?: string | null, codFechamento: number, codTipoFechamento: number, tbUnidade?: { __typename?: 'unidades', nome: string, sigla?: string | null, nomeLimpo?: string | null, codUnidade: number, ativo: boolean } | null }> } & { ' $fragmentName'?: 'HomeCalendarDayEventFragmentFragment' };

export type HolidaysHomeCalendarDayEventFragmentFragment = { __typename?: 'query_root', LivanceApiFeriadosPorPeriodo?: Array<{ __typename?: 'LivanceApiFeriado', codFeriado: number, codUnidade?: number | null, dia: number, mes: number, ano?: number | null, horaInicio: string, horaFim: string, nome: string } | null> | null } & { ' $fragmentName'?: 'HolidaysHomeCalendarDayEventFragmentFragment' };

export type TimePoliciesHomeCalendarDayEventFragmentFragment = { __typename?: 'query_root', unidadesPoliticasDeHorarios: Array<{ __typename?: 'unidadesPoliticasDeHorarios', codUnidadePoliticaDeHorario: number, diaSemana: number, inicio: string, fim: string, dataInicio: string, codUnidade: number, Unidade: { __typename?: 'unidades', nome: string, nomeLimpo?: string | null, codUnidade: number, ativo: boolean, sigla?: string | null } }> } & { ' $fragmentName'?: 'TimePoliciesHomeCalendarDayEventFragmentFragment' };

export type FreeSchedulesSlotsHomeCalendarDayEventFragmentFragment = { __typename?: 'query_root', LivanceApiUsuarioAgendaAtivosPorUsuario?: Array<{ __typename?: 'LivanceApiUsuarioAgendaAtivosPorUsuarioOutput', dataInicio: string, dataFim?: string | null, inicio: string, fim: string, codTipoAgendaRepeticao: number, usuariosAgendasUnidades?: Array<{ __typename?: 'LivanceApiUsuarioAgendaUnidade', codUnidade: number }> | null, usuariosAgendasDiasSemanas?: Array<{ __typename?: 'LivanceApiUsuarioAgendaDiaSemana', diaSemana: number }> | null } | null> | null } & { ' $fragmentName'?: 'FreeSchedulesSlotsHomeCalendarDayEventFragmentFragment' };

export type AppointmentsQueryFragmentFragment = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'HomePageCalendarFragmentFragment': HomePageCalendarFragmentFragment;'HomeCalendarDayEventFragmentFragment': HomeCalendarDayEventFragmentFragment } }
) & { ' $fragmentName'?: 'AppointmentsQueryFragmentFragment' };

export type FreeScheduleSlotsFragmentFragment = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'FreeSchedulesSlotsHomePageCalendarFragmentFragment': FreeSchedulesSlotsHomePageCalendarFragmentFragment } }
) & { ' $fragmentName'?: 'FreeScheduleSlotsFragmentFragment' };

export type ScheduleSlotsFragmentFragment = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'FreeSchedulesSlotsHomeCalendarDayEventFragmentFragment': FreeSchedulesSlotsHomeCalendarDayEventFragmentFragment } }
) & { ' $fragmentName'?: 'ScheduleSlotsFragmentFragment' };

export type HolidaysQueryFragmentFragment = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'HolidaysHomeCalendarDayEventFragmentFragment': HolidaysHomeCalendarDayEventFragmentFragment } }
) & { ' $fragmentName'?: 'HolidaysQueryFragmentFragment' };

export type TimePoliciesQueryFragmentFragment = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'TimePoliciesHomeCalendarDayEventFragmentFragment': TimePoliciesHomeCalendarDayEventFragmentFragment } }
) & { ' $fragmentName'?: 'TimePoliciesQueryFragmentFragment' };

export type BlockedActionsListFragmentFragment = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'BlockedActionsListAlertFragmentFragment': BlockedActionsListAlertFragmentFragment } }
) & { ' $fragmentName'?: 'BlockedActionsListFragmentFragment' };

export type UnitsBySchedulesQueryFragmentFragment = { __typename?: 'query_root', usuariosAgendas: Array<{ __typename?: 'usuariosAgendas', usuariosAgendasUnidades: Array<{ __typename?: 'usuariosAgendasUnidades', Unidade?: { __typename?: 'unidades', nome: string, nomeLimpo?: string | null, codUnidade: number, ativo: boolean, sigla?: string | null } | null }> }> } & { ' $fragmentName'?: 'UnitsBySchedulesQueryFragmentFragment' };

export type HomePageCalendarFragmentFragment = { __typename?: 'query_root', agendamentos: Array<{ __typename?: 'agendamentos', codAgendamento: number, data: string, horaInicio: string, horaFim: string, nome?: string | null, confirmado: boolean, cancelado: boolean, cobraCancelamento: boolean, codFinalidadeAgendamento: number, pago: boolean, AgendamentosCheckin?: { __typename?: 'tbAgendamentosCheckins', codAgendamento: number } | null, FinalidadesAgendamento: { __typename?: 'finalidadesAgendamentos', codFinalidadeAgendamento: number, taxaCobrancaAtraso: number }, Paciente?: { __typename?: 'pacientes', telefone: string, nome: string, email?: string | null, codPaciente: number } | null, UsuarioCompromisso?: { __typename?: 'usuariosCompromissos', nome: string } | null, Unidade: { __typename?: 'unidades', codUnidade: number, nome: string, sigla?: string | null, nomeLimpo?: string | null, ativo: boolean } }>, tbFechamentos: Array<{ __typename?: 'tbFechamentos', codUnidade?: number | null, data: string, horaFim: string, horaInicio: string, motivo?: string | null, codFechamento: number, codTipoFechamento: number, tbUnidade?: { __typename?: 'unidades', nome: string, sigla?: string | null, nomeLimpo?: string | null, codUnidade: number, ativo: boolean } | null }> } & { ' $fragmentName'?: 'HomePageCalendarFragmentFragment' };

export type FreeSchedulesSlotsHomePageCalendarFragmentFragment = { __typename?: 'query_root', LivanceApiBuscaSelecionaFaixasLivresAgenda?: Array<{ __typename?: 'LivanceApiBuscaSelecionaFaixasLivresAgendaOutput', inicio: string, fim: string, prioridade: number, podeExceder: boolean, codUsuarioAgenda: number, autorizado: boolean } | null> | null } & { ' $fragmentName'?: 'FreeSchedulesSlotsHomePageCalendarFragmentFragment' };

export type HomeProfileHeaderFragmentFragment = { __typename?: 'query_root', profilePictureFile?: { __typename?: 'LivanceApiSelecionaFotoDePerfilOutput', arquivo?: string | null, mimetype?: string | null } | null } & { ' $fragmentName'?: 'HomeProfileHeaderFragmentFragment' };

export type HomeNextSchedulesCarouselQueryFragmentFragment = { __typename?: 'query_root', agendamentos: Array<(
    { __typename?: 'agendamentos', codAgendamento: number, horaFim: string, horaInicio: string, agendamentoPreAlocacao: Array<{ __typename?: 'agendamentosPreAlocacao', UnidadeSala?: { __typename?: 'unidadesSalas', TipoSala: { __typename?: 'tiposSalas', nome: string, codTipoSala: number } } | null }>, agendamentoAlocacaoAtiva: Array<{ __typename?: 'AgendamentosAlocacoesAtivas', UnidadeSala: { __typename?: 'unidadesSalas', TipoSala: { __typename?: 'tiposSalas', nome: string, codTipoSala: number } } }>, compromisso?: { __typename?: 'usuariosCompromissos', UsuariosCompromissosTiposSalas: Array<{ __typename?: 'usuariosCompromissosTiposSalas', codTipoSala: number, codUsuarioCompromisso: number, prioridade: number }> } | null }
    & { ' $fragmentRefs'?: { 'WaitingRoomAppointmentListItemFragmentFragment': WaitingRoomAppointmentListItemFragmentFragment } }
  )> } & { ' $fragmentName'?: 'HomeNextSchedulesCarouselQueryFragmentFragment' };

export type HomeNextSchedulesSectionQueryQueryVariables = Exact<{
  today?: InputMaybe<Scalars['date']['input']>;
}>;


export type HomeNextSchedulesSectionQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'HomeNextSchedulesCarouselQueryFragmentFragment': HomeNextSchedulesCarouselQueryFragmentFragment } }
);

export type HomeSectionLivanceAssistCardGroupQueryFragmentFragment = { __typename?: 'query_root', customerContactData?: Array<{ __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', totalCustomerContacts: number, convertedAppointmentsPercent: number }> | null, rescueAppointmentsData?: { __typename?: 'AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', data: Array<{ __typename?: 'DataItemAnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', rescuedAppointments?: any | null } | null> } | null, lembretes: { __typename?: 'lembretes_aggregate', lembretesEnviados?: { __typename?: 'lembretes_aggregate_fields', total: number } | null } } & { ' $fragmentName'?: 'HomeSectionLivanceAssistCardGroupQueryFragmentFragment' };

export type HomeSectionLivanceAssistQueryQueryVariables = Exact<{
  fromStr: Scalars['String']['input'];
  toStr: Scalars['String']['input'];
  fromDateTime: Scalars['datetime2']['input'];
  toDateTime: Scalars['datetime2']['input'];
}>;


export type HomeSectionLivanceAssistQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'HomeSectionLivanceAssistCardGroupQueryFragmentFragment': HomeSectionLivanceAssistCardGroupQueryFragmentFragment } }
);

export type HomeSectionLivancePayCardGroupFragmentFragment = { __typename?: 'query_root', pagosOnline: { __typename?: 'expensum_online_payment_aggregate', aggregate?: { __typename?: 'expensum_online_payment_aggregate_fields', count: number } | null }, pendentesOnline: { __typename?: 'expensum_online_payment_aggregate', aggregate?: { __typename?: 'expensum_online_payment_aggregate_fields', count: number } | null }, pagosTotem: { __typename?: 'expensum_appointment_paid_aggregate', aggregate?: { __typename?: 'expensum_appointment_paid_aggregate_fields', count: number } | null }, pendentesTotem: { __typename?: 'expensum_event_totem_payment_sent_aggregate', aggregate?: { __typename?: 'expensum_event_totem_payment_sent_aggregate_fields', count: number } | null }, ExpensumGetPaymentsChartsInfo: { __typename?: 'ExpensumGetPaymentsChartsInfoOutput', periods: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoIntervalData', intervalEnd: string, intervalStart: string, totalAmount: number, onlinePayments: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsBySource', created: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number }, paid: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number } }, totemPayments: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsBySource', created: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number }, paid: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number } } }> }, expensumRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', pagarmeId?: string | null } | null } | null } & { ' $fragmentName'?: 'HomeSectionLivancePayCardGroupFragmentFragment' };

export type HomeSectionLivancePayQueryQueryVariables = Exact<{
  dateStartAction: Scalars['String']['input'];
  dateEndAction: Scalars['String']['input'];
  dateStartCount: Scalars['timestamptz']['input'];
  dateEndCount: Scalars['timestamptz']['input'];
  codUsuario: Scalars['Int']['input'];
  codClinica?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HomeSectionLivancePayQueryQuery = (
  { __typename?: 'query_root', expensumRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', pagarmeId?: string | null } | null } | null }
  & { ' $fragmentRefs'?: { 'HomeSectionLivancePayCardGroupFragmentFragment': HomeSectionLivancePayCardGroupFragmentFragment } }
);

export type HomeSectionOneLivActiveFragmentFragment = { __typename?: 'query_root', LocusGetProfileCompletionPercentage?: { __typename?: 'LocusGetProfileCompletionPercentageOutput', porcentagemPerfil: number, pendente?: { __typename?: 'LocusGetProfileCompletionPercentagePending', experiencias?: string | null, faqs?: string | null, focosTratamentos?: string | null, membroFormacoes?: string | null, sobre?: string | null } | null, membro?: { __typename?: 'locus_membro', slug: string } | null } | null } & { ' $fragmentName'?: 'HomeSectionOneLivActiveFragmentFragment' };

export type HomeSectionOneLivQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
}>;


export type HomeSectionOneLivQueryQuery = (
  { __typename?: 'query_root', locus_membro: Array<{ __typename?: 'locus_membro', ativo: boolean }>, locus_conselho_profissional: Array<{ __typename?: 'locus_conselho_profissional', sigla: string }> }
  & { ' $fragmentRefs'?: { 'HomeSectionOneLivActiveFragmentFragment': HomeSectionOneLivActiveFragmentFragment } }
);

export type LinkDestinationSelectInputQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type LinkDestinationSelectInputQueryQuery = { __typename?: 'query_root', linksDestinos: Array<{ __typename?: 'linksDestinos', nome: string, codLinkDestino: number }> };

export type MembersListFragmentFragment = { __typename?: 'PerfisPublicosConnection', listaMembros?: Array<{ __typename?: 'MembroPerfilPublico', codUsuario: number, nome?: string | null, especialidades?: Array<{ __typename?: 'Especialidade', nome?: string | null }> | null } | null> | null } & { ' $fragmentName'?: 'MembersListFragmentFragment' };

export type MyProfileDetailsSectionFragmentFragment = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'ProfilePictureFragmentFragment': ProfilePictureFragmentFragment;'ProfilePictureAlertFragmentFragment': ProfilePictureAlertFragmentFragment;'ProfessionalUserPreferredNameFragmentFragment': ProfessionalUserPreferredNameFragmentFragment } }
) & { ' $fragmentName'?: 'MyProfileDetailsSectionFragmentFragment' };

export type OneLivProfileCardFragmentFragment = { __typename?: 'query_root', locus_membro: Array<{ __typename?: 'locus_membro', slug: string, ativo: boolean }>, locus_conselho_profissional: Array<{ __typename?: 'locus_conselho_profissional', sigla: string }> } & { ' $fragmentName'?: 'OneLivProfileCardFragmentFragment' };

export type OneLivAdditionalInfoFormFragmentFragment = { __typename?: 'locus_membro', codUsuario: number, sobre?: string | null, maisInformacoes?: string | null } & { ' $fragmentName'?: 'OneLivAdditionalInfoFormFragmentFragment' };

export type UpdateMemberAdditionalInfoMutationVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  setObject: Locus_Membro_Set_Input;
}>;


export type UpdateMemberAdditionalInfoMutation = { __typename?: 'mutation_root', updateMember?: { __typename?: 'locus_membro_mutation_response', affected_rows: number } | null };

export type OneLivBasicInfoFormFragmentFragment = (
  { __typename?: 'query_root', locus_membro: Array<{ __typename?: 'locus_membro', id: number, apelido: string, pronome?: string | null, ufConselhoClasse: string, numeroConselhoClasse: string, duracaoInicialConsulta?: string | null, valorInicialConsulta?: number | null, formasPagamento?: string | null, resumo: string, fotoUrl?: string | null, ativo: boolean, idConselhoProfissional?: number | null, membroEspecialidades: Array<{ __typename?: 'locus_membro_especialidade', rqe?: string | null, prioridade?: number | null, idEspecialidade: number, membroEspecialidadeSubespecialidades: Array<{ __typename?: 'locus_membro_especialidade_subespecialidade', idSubespecialidade: number, rqe?: string | null }> }> }> }
  & { ' $fragmentRefs'?: { 'OneLivSpecialtiesInputFragmentFragment': OneLivSpecialtiesInputFragmentFragment;'OneLivProfessionalCouncilSelectInputFragmentFragment': OneLivProfessionalCouncilSelectInputFragmentFragment } }
) & { ' $fragmentName'?: 'OneLivBasicInfoFormFragmentFragment' };

export type ActivateMemberProfileMutationMutationVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  set: Locus_Membro_Set_Input;
}>;


export type ActivateMemberProfileMutationMutation = { __typename?: 'mutation_root', updateMember?: { __typename?: 'locus_membro_mutation_response', affected_rows: number } | null };

export type UpsertBasicProfileMutationVariables = Exact<{
  input: LocusUpsertBasicProfileInput;
}>;


export type UpsertBasicProfileMutation = { __typename?: 'mutation_root', LocusUpsertBasicProfile?: { __typename?: 'LocusUpsertBasicProfileOutput', id: number } | null };

export type OneLivCoursesSelectInputFragmentFragment = { __typename?: 'locus_curso_formacao', id: number, nome: string } & { ' $fragmentName'?: 'OneLivCoursesSelectInputFragmentFragment' };

export type DisableMemberProfileMutationMutationVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  setObject: Locus_Membro_Set_Input;
}>;


export type DisableMemberProfileMutationMutation = { __typename?: 'mutation_root', updateMember?: { __typename?: 'locus_membro_mutation_response', affected_rows: number } | null };

export type OneLivEducationalBackgroundFormFragmentFragment = { __typename?: 'query_root', membro: Array<{ __typename?: 'locus_membro', id: number }>, membroFormacao: Array<{ __typename?: 'locus_membro_formacao', conclusao: string, idCurso: number, idInstituicaoEnsino: number }>, cursos: Array<(
    { __typename?: 'locus_curso_formacao' }
    & { ' $fragmentRefs'?: { 'OneLivCoursesSelectInputFragmentFragment': OneLivCoursesSelectInputFragmentFragment } }
  )>, instituicoesEnsino: Array<(
    { __typename?: 'locus_instituicao_ensino' }
    & { ' $fragmentRefs'?: { 'OneLivEducationalInstitutionSelectInputFragmentFragment': OneLivEducationalInstitutionSelectInputFragmentFragment } }
  )> } & { ' $fragmentName'?: 'OneLivEducationalBackgroundFormFragmentFragment' };

export type InsertAndUpdateMembroFormacoesMutationVariables = Exact<{
  updates: Array<Locus_Membro_Formacao_Updates> | Locus_Membro_Formacao_Updates;
  inserts: Array<Locus_Membro_Formacao_Insert_Input> | Locus_Membro_Formacao_Insert_Input;
  deletes?: InputMaybe<Array<Locus_Membro_Formacao_Bool_Exp> | Locus_Membro_Formacao_Bool_Exp>;
}>;


export type InsertAndUpdateMembroFormacoesMutation = { __typename?: 'mutation_root', update_locus_membro_formacao_many?: Array<{ __typename?: 'locus_membro_formacao_mutation_response', affected_rows: number } | null> | null, insert_locus_membro_formacao?: { __typename?: 'locus_membro_formacao_mutation_response', affected_rows: number } | null, delete_locus_membro_formacao?: { __typename?: 'locus_membro_formacao_mutation_response', affected_rows: number } | null };

export type OneLivEducationalInstitutionSelectInputFragmentFragment = { __typename?: 'locus_instituicao_ensino', id: number, nome: string, sigla?: string | null } & { ' $fragmentName'?: 'OneLivEducationalInstitutionSelectInputFragmentFragment' };

export type OneLivExperiencesFormFragmentFragment = { __typename?: 'locus_membro', id: number, experiencias: Array<{ __typename?: 'locus_experiencia_membro', id: number, experiencia: string }> } & { ' $fragmentName'?: 'OneLivExperiencesFormFragmentFragment' };

export type UpdateMemberExperiencesMutationMutationVariables = Exact<{
  objects: Array<Locus_Experiencia_Membro_Insert_Input> | Locus_Experiencia_Membro_Insert_Input;
}>;


export type UpdateMemberExperiencesMutationMutation = { __typename?: 'mutation_root', insert_locus_experiencia_membro?: { __typename?: 'locus_experiencia_membro_mutation_response', affected_rows: number } | null };

export type OneLivFaqFormFragmentFragment = { __typename?: 'locus_membro', id: number, faqs: Array<{ __typename?: 'locus_faq_membro', id: number, pergunta: string, resposta: string }> } & { ' $fragmentName'?: 'OneLivFaqFormFragmentFragment' };

export type UpdateMemberFaqMutationMutationVariables = Exact<{
  objects: Array<Locus_Faq_Membro_Insert_Input> | Locus_Faq_Membro_Insert_Input;
}>;


export type UpdateMemberFaqMutationMutation = { __typename?: 'mutation_root', insert_locus_faq_membro?: { __typename?: 'locus_faq_membro_mutation_response', affected_rows: number } | null };

export type OneLivMedicalInstitutionsFormFragmentFragment = { __typename?: 'query_root', membro: Array<{ __typename?: 'locus_membro', id: number }>, membroInstituicoesMedicas: Array<{ __typename?: 'locus_membro_instituicao_medica', idInstituicaoMedica: number }>, instituicoesMedicas: Array<(
    { __typename?: 'locus_instituicao_medica' }
    & { ' $fragmentRefs'?: { 'OneLivMedicalInstitutionsSelectInputFragmentFragment': OneLivMedicalInstitutionsSelectInputFragmentFragment } }
  )> } & { ' $fragmentName'?: 'OneLivMedicalInstitutionsFormFragmentFragment' };

export type InsertAndUpdateMembroInstituicoesMedicasMutationMutationVariables = Exact<{
  updates: Array<Locus_Membro_Instituicao_Medica_Updates> | Locus_Membro_Instituicao_Medica_Updates;
  inserts: Array<Locus_Membro_Instituicao_Medica_Insert_Input> | Locus_Membro_Instituicao_Medica_Insert_Input;
  deletes?: InputMaybe<Array<Locus_Membro_Instituicao_Medica_Bool_Exp> | Locus_Membro_Instituicao_Medica_Bool_Exp>;
}>;


export type InsertAndUpdateMembroInstituicoesMedicasMutationMutation = { __typename?: 'mutation_root', update_locus_membro_instituicao_medica_many?: Array<{ __typename?: 'locus_membro_instituicao_medica_mutation_response', affected_rows: number } | null> | null, insert_locus_membro_instituicao_medica?: { __typename?: 'locus_membro_instituicao_medica_mutation_response', affected_rows: number } | null, delete_locus_membro_instituicao_medica?: { __typename?: 'locus_membro_instituicao_medica_mutation_response', affected_rows: number } | null };

export type OneLivMedicalInstitutionsSelectInputFragmentFragment = { __typename?: 'locus_instituicao_medica', id: number, nome: string } & { ' $fragmentName'?: 'OneLivMedicalInstitutionsSelectInputFragmentFragment' };

export type OneLivProfessionalCouncilSelectInputFragmentFragment = { __typename?: 'query_root', professionalCouncils: Array<{ __typename?: 'locus_conselho_profissional', id: number, nome: string }> } & { ' $fragmentName'?: 'OneLivProfessionalCouncilSelectInputFragmentFragment' };

export type OneLivSocialMediaFormFragmentFragment = { __typename?: 'query_root', locus_rede_social_membro: Array<{ __typename?: 'locus_rede_social_membro', redeSocial: string, url: string }> } & { ' $fragmentName'?: 'OneLivSocialMediaFormFragmentFragment' };

export type UpdateMemberSocialMediaMutationVariables = Exact<{
  input: LocusUpdateMemberSocialMediaInput;
}>;


export type UpdateMemberSocialMediaMutation = { __typename?: 'mutation_root', LocusUpdateMemberSocialMedia: any };

export type OneLivSpecialtiesInputFragmentFragment = { __typename?: 'query_root', specialties: Array<(
    { __typename?: 'locus_especialidade', id: number, especialista?: string | null, conselhoProfissionalEspecialidades: Array<{ __typename?: 'locus_conselho_profissional_especialidade', idConselhoProfissional: number }> }
    & { ' $fragmentRefs'?: { 'OneLivSpecialtySelectInputFragmentFragment': OneLivSpecialtySelectInputFragmentFragment;'OneLivSubspecialtySelectInputFragmentFragment': OneLivSubspecialtySelectInputFragmentFragment } }
  )>, professionalCouncil: Array<{ __typename?: 'locus_conselho_profissional', id: number }> } & { ' $fragmentName'?: 'OneLivSpecialtiesInputFragmentFragment' };

export type OneLivSpecialtySelectInputFragmentFragment = { __typename?: 'locus_especialidade', id: number, especialista?: string | null } & { ' $fragmentName'?: 'OneLivSpecialtySelectInputFragmentFragment' };

export type OneLivSubspecialtySelectInputFragmentFragment = { __typename?: 'locus_especialidade', id: number, especialidadeSubespecialidades: Array<{ __typename?: 'locus_especialidade_subespecialidade', subespecialidade: { __typename?: 'locus_subespecialidade', id: number, especialista: string } }> } & { ' $fragmentName'?: 'OneLivSubspecialtySelectInputFragmentFragment' };

export type OneLivTreatmentFocusFormFragmentFragment = { __typename?: 'locus_membro', id: number, focosTratamentos: Array<{ __typename?: 'locus_foco_tratamento_membro', id: number, focoTratamento: string }> } & { ' $fragmentName'?: 'OneLivTreatmentFocusFormFragmentFragment' };

export type UpdateMemberTreatmentFocusMMutationMutationVariables = Exact<{
  objects: Array<Locus_Foco_Tratamento_Membro_Insert_Input> | Locus_Foco_Tratamento_Membro_Insert_Input;
}>;


export type UpdateMemberTreatmentFocusMMutationMutation = { __typename?: 'mutation_root', insert_locus_foco_tratamento_membro?: { __typename?: 'locus_foco_tratamento_membro_mutation_response', affected_rows: number } | null };

export type OnlinePaymentTypesCheckboxGroupFragmentFragment = { __typename?: 'expensum_payment_type', name: string, id: number, description: string } & { ' $fragmentName'?: 'OnlinePaymentTypesCheckboxGroupFragmentFragment' };

export type PatientPhotoQueryQueryVariables = Exact<{
  codPaciente: Scalars['Int']['input'];
}>;


export type PatientPhotoQueryQuery = { __typename?: 'query_root', patient?: { __typename?: 'pacientes', foto?: any | null } | null };

export type PatientAvatarFragmentFragment = { __typename?: 'pacientes', codPaciente: number, nome: string } & { ' $fragmentName'?: 'PatientAvatarFragmentFragment' };

export type PatientDetailActionListFragmentFragment = (
  { __typename?: 'pacientes', telefone: string, nome: string, email?: string | null, codPaciente: number }
  & { ' $fragmentRefs'?: { 'PatientAvatarFragmentFragment': PatientAvatarFragmentFragment } }
) & { ' $fragmentName'?: 'PatientDetailActionListFragmentFragment' };

export type PatientDetailPropertyListFragmentFragment = { __typename?: 'pacientes', cpf?: string | null, email?: string | null, dataNascimento?: string | null, telefone: string, telefoneInternacionalNormalizado?: string | null, receberWhatsAppConfirmacao: boolean, nomeConvenio?: string | null, nomePlano?: string | null, numeroCarteirinha?: string | null, validadeCarteirinha?: string | null, codTipoConvenio?: number | null, codPaciente: number } & { ' $fragmentName'?: 'PatientDetailPropertyListFragmentFragment' };

export type PatientDetailLastAppointmentFragmentFragment = { __typename?: 'pacientes', lastAppointment: Array<{ __typename?: 'agendamentos', codAgendamento: number, reminders: Array<{ __typename?: 'lembretes', codAgendamento: number }> }> } & { ' $fragmentName'?: 'PatientDetailLastAppointmentFragmentFragment' };

export type PatientDetailHeaderActionsFragmentFragment = { __typename?: 'pacientes', telefone: string, email?: string | null, codPaciente: number } & { ' $fragmentName'?: 'PatientDetailHeaderActionsFragmentFragment' };

export type PatientDetailHeaderFragmentFragment = (
  { __typename?: 'pacientes', telefone: string, nome: string, email?: string | null, codPaciente: number }
  & { ' $fragmentRefs'?: { 'PatientAvatarFragmentFragment': PatientAvatarFragmentFragment } }
) & { ' $fragmentName'?: 'PatientDetailHeaderFragmentFragment' };

export type PatientDetailTabsFragmentFragment = (
  { __typename?: 'pacientes', codPaciente: number }
  & { ' $fragmentRefs'?: { 'PatientDetailPropertyListFragmentFragment': PatientDetailPropertyListFragmentFragment;'PatientHistoryListFragmentFragment': PatientHistoryListFragmentFragment } }
) & { ' $fragmentName'?: 'PatientDetailTabsFragmentFragment' };

export type PatientUpdateFormQueryFragment = { __typename?: 'pacientes', ativo: boolean, codPaciente: number, codTipoConvenio?: number | null, cpfProprio: boolean, cpf?: string | null, email?: string | null, dataNascimento?: string | null, nomeConvenio?: string | null, nomePlano?: string | null, nome: string, numeroCarteirinha?: string | null, receberWhatsAppConfirmacao: boolean, telefone: string, telefoneInternacionalNormalizado?: string | null, telefoneProprio: boolean, validadeCarteirinha?: string | null } & { ' $fragmentName'?: 'PatientUpdateFormQueryFragment' };

export type MyMutationMutationVariables = Exact<{
  patientData: PacienteGraphQlInput;
}>;


export type MyMutationMutation = { __typename?: 'mutation_root', alterarPaciente: { __typename?: 'AlterarPacientePayload', errors?: Array<{ __typename: 'ValidationError', message: string }> | null, pacienteGraphQL?: { __typename?: 'PacienteGraphQL', ativo?: boolean | null, codPaciente: number, codTipoConvenio?: number | null, cpfProprio?: boolean | null, cpf?: string | null, email: string, dataNascimento?: string | null, nomeConvenio?: string | null, nomePlano?: string | null, nome: string, numeroCarteirinha?: string | null, receberWhatsAppConfirmacao?: boolean | null, telefone?: string | null, telefoneInternacionalNormalizado?: string | null, telefoneProprio?: boolean | null, validadeCarteirinha?: string | null } | null } };

export type PatientHistoryListFragmentFragment = { __typename?: 'pacientes', Agendamentos: Array<{ __typename?: 'agendamentos', codAgendamento: number, codAgendamentoOrigem?: number | null, data: string, horaInicio: string, horaFim: string, cancelado: boolean, AgendamentoAlocacao: Array<{ __typename?: 'agendamentosAlocacoes', horaFim?: string | null }>, Unidade: { __typename?: 'unidades', nome: string } }> } & { ' $fragmentName'?: 'PatientHistoryListFragmentFragment' };

export type PatientListItemFragmentFragment = (
  { __typename?: 'pacientes', telefone: string, telefoneInternacionalNormalizado?: string | null, codPaciente: number, nome: string, email?: string | null, cpf?: string | null, dataNascimento?: string | null }
  & { ' $fragmentRefs'?: { 'PatientAvatarFragmentFragment': PatientAvatarFragmentFragment } }
) & { ' $fragmentName'?: 'PatientListItemFragmentFragment' };

export type PatientListQueryFragmentFragment = { __typename?: 'query_root', pacientes: Array<(
    { __typename?: 'pacientes', nome: string, telefone: string, codPaciente: number }
    & { ' $fragmentRefs'?: { 'PatientListItemFragmentFragment': PatientListItemFragmentFragment } }
  )> } & { ' $fragmentName'?: 'PatientListQueryFragmentFragment' };

export type PatientPaymentDetailsFragmentFragment = (
  { __typename?: 'ExpensumPaymentDetailsOutput', amount: number, status: string, origin: string, paymentMethod?: string | null, installments?: number | null, paidAt?: string | null, patient: { __typename?: 'ExpensumPaymentDetailsPatientInfo', name: string, phone: string, email: string }, onlinePaymentInfo?: { __typename?: 'ExpensumPaymentDetailsOnlinePaymentInfo', guid: string } | null, appointment?: { __typename?: 'ExpensumPaymentDetailsAppointmentInfo', codAgendamento: number } | null }
  & { ' $fragmentRefs'?: { 'PatientPaymentDetailsAppointmentSectionFragmentFragment': PatientPaymentDetailsAppointmentSectionFragmentFragment;'PatientPaymentsDetailsPaymentSectionFragmentFragment': PatientPaymentsDetailsPaymentSectionFragmentFragment;'PatientPaymentsDetailsPayableSectionFragmentFragment': PatientPaymentsDetailsPayableSectionFragmentFragment } }
) & { ' $fragmentName'?: 'PatientPaymentDetailsFragmentFragment' };

export type PatientPaymentDetailsAppointmentSectionFragmentFragment = { __typename?: 'ExpensumPaymentDetailsOutput', appointment?: { __typename?: 'ExpensumPaymentDetailsAppointmentInfo', date: string, startHour: string, unit: string } | null } & { ' $fragmentName'?: 'PatientPaymentDetailsAppointmentSectionFragmentFragment' };

export type PatientPaymentsDetailsPayableSectionFragmentFragment = { __typename?: 'ExpensumPaymentDetailsOutput', installments?: number | null, createdAt: string, payablesInfo: { __typename?: 'ExpensumPaymentDetailsPayablesInfo', payables: Array<{ __typename?: 'ExpensumPaymentDetailsPayableInfo', paymentDate: string, grossValue: number, netValue: number, fee?: number | null, installment?: number | null, status: string, anticipationFee?: number | null }> } } & { ' $fragmentName'?: 'PatientPaymentsDetailsPayableSectionFragmentFragment' };

export type PatientPaymentsDetailsPaymentSectionFragmentFragment = { __typename?: 'ExpensumPaymentDetailsOutput', acquirerTransactionKey?: string | null, createdAt: string, installments?: number | null, origin: string, paidAt?: string | null, paymentMethod?: string | null, status: string, refundedAt?: string | null, note?: string | null, brand?: string | null, onlinePaymentInfo?: { __typename?: 'ExpensumPaymentDetailsOnlinePaymentInfo', type?: string | null } | null } & { ' $fragmentName'?: 'PatientPaymentsDetailsPaymentSectionFragmentFragment' };

export type PatientPaymentsListItemFragmentFragment = { __typename?: 'ExpensumGetPaymentInfo', status: string, meioPagamentoSelecionado?: string | null, valor: number, criadoEm?: string | null, codAgendamento?: number | null, parcelas?: number | null, hasAutomaticAnticipation: boolean, agendamento?: { __typename?: 'ExpensumGetPaymentInfoAppointment', data: string, horaInicio: string, paciente: { __typename?: 'LivanceApiPaciente', nome: string } } | null, checkout?: { __typename?: 'ExpensumGetPaymentInfoCheckout', guid: string, nomeDoPagador: string } | null, payableInfo?: { __typename?: 'ExpensumGetPaymentPayableInfo', status?: string | null, installment?: number | null, nextPaymentDate?: string | null } | null } & { ' $fragmentName'?: 'PatientPaymentsListItemFragmentFragment' };

export type PatientPaymentsListFragmentFragment = { __typename?: 'ExpensumGetPaymentsOutput', payments: Array<(
    { __typename?: 'ExpensumGetPaymentInfo', codAgendamento?: number | null }
    & { ' $fragmentRefs'?: { 'PatientPaymentsListItemFragmentFragment': PatientPaymentsListItemFragmentFragment } }
  ) | null> } & { ' $fragmentName'?: 'PatientPaymentsListFragmentFragment' };

export type PatientPaymentsRefundDetailsSectionFragmentFragment = { __typename?: 'ExpensumGetRefundReceiptOutput', receipt?: { __typename?: 'ExpensumRefundReceipt', transactionId?: string | null, authorizationId?: string | null, paidAt?: string | null, paidAmount?: number | null, canceledAt?: string | null, canceledAmount?: number | null } | null } & { ' $fragmentName'?: 'PatientPaymentsRefundDetailsSectionFragmentFragment' };

export type PatientPaymentsRefundPayeeSectionFragmentFragment = { __typename?: 'ExpensumGetRefundReceiptOutput', receipt?: { __typename?: 'ExpensumRefundReceipt', name?: string | null, installments?: number | null, paymentMethod?: string | null, card?: { __typename?: 'ExpensumGetRecipientCard', brand?: string | null, lastFourDigits?: string | null } | null, bankAccount?: { __typename?: 'ExpensumGetRecipientBankAccount', bankName?: string | null } | null } | null } & { ' $fragmentName'?: 'PatientPaymentsRefundPayeeSectionFragmentFragment' };

export type PatientSwapPatientListFragmentFragment = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'AppointmentPatientListFragmentFragment': AppointmentPatientListFragmentFragment } }
) & { ' $fragmentName'?: 'PatientSwapPatientListFragmentFragment' };

export type PayablesStatusChartFragmentFragment = { __typename?: 'ExpensumGetPayablesChartsInfoOutput', periods: Array<{ __typename?: 'ExpensumGetPayablesChartsInfoIntervalData', intervalEnd: string, intervalStart: string, waitingFunds: { __typename?: 'ExpensumGetPayablesChartsInfoByStatus', totalAmount: number }, paid: { __typename?: 'ExpensumGetPayablesChartsInfoByStatus', totalAmount: number } }> } & { ' $fragmentName'?: 'PayablesStatusChartFragmentFragment' };

export type PaymentMethodsListToMultiSelectTestQueryFragmentFragment = { __typename?: 'query_root', usuariosFormasRecebimentos: Array<(
    { __typename?: 'usuariosFormasRecebimentos' }
    & { ' $fragmentRefs'?: { 'PaymentMethodsListToMultiSelectQueryFragmentFragment': PaymentMethodsListToMultiSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'PaymentMethodsListToMultiSelectTestQueryFragmentFragment' };

export type PaymentMethodsListToMultiSelectQueryFragmentFragment = { __typename?: 'usuariosFormasRecebimentos', codUsuarioFormaRecebimento: number, codTipoFormaRecebimento: number, codTipoConvenio?: number | null, nomeConvenio?: string | null, TipoConvenio?: { __typename?: 'tiposConvenios', nome: string } | null, TipoFormaRecebimento: { __typename?: 'tiposFormasRecebimentos', nome: string } } & { ' $fragmentName'?: 'PaymentMethodsListToMultiSelectQueryFragmentFragment' };

export type PaymentMethodsListToSelectTestQueryFragmentFragment = { __typename?: 'query_root', usuariosFormasRecebimentos: Array<(
    { __typename?: 'usuariosFormasRecebimentos' }
    & { ' $fragmentRefs'?: { 'PaymentMethodsListToSelectQueryFragmentFragment': PaymentMethodsListToSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'PaymentMethodsListToSelectTestQueryFragmentFragment' };

export type PaymentMethodsListToSelectQueryFragmentFragment = { __typename?: 'usuariosFormasRecebimentos', codUsuarioFormaRecebimento: number, codTipoFormaRecebimento: number, codTipoConvenio?: number | null, nomeConvenio?: string | null, TipoConvenio?: { __typename?: 'tiposConvenios', nome: string } | null, TipoFormaRecebimento: { __typename?: 'tiposFormasRecebimentos', nome: string } } & { ' $fragmentName'?: 'PaymentMethodsListToSelectQueryFragmentFragment' };

export type CancelTotemPaymentMutationVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type CancelTotemPaymentMutation = { __typename?: 'mutation_root', ExpensumCancelTotemPayment?: { __typename?: 'ExpensumCancelTotemPaymentOutput', codAgendamento: number } | null };

export type PaymentsOriginChartFragmentFragment = { __typename?: 'ExpensumGetPaymentsChartsInfoOutput', periods: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoIntervalData', intervalEnd: string, intervalStart: string, totalAmount: number, onlinePayments: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsBySource', totalAmount: number, created: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number, payments: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoPaymentDetail', amount: number, paymentType?: string | null, status: string }> }, paid: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number, payments: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoPaymentDetail', amount: number, paymentType?: string | null, status: string }> } }, totemPayments: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsBySource', totalAmount: number, created: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number, payments: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoPaymentDetail', amount: number, paymentType?: string | null, status: string }> }, paid: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number, payments: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoPaymentDetail', amount: number, paymentType?: string | null, status: string }> } } }> } & { ' $fragmentName'?: 'PaymentsOriginChartFragmentFragment' };

export type PaymentsStatusChartFragmentFragment = { __typename?: 'ExpensumGetPaymentsChartsInfoOutput', periods: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoIntervalData', intervalEnd: string, intervalStart: string, totalAmount: number, onlinePayments: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsBySource', totalAmount: number, created: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number, payments: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoPaymentDetail', amount: number, status: string }> }, paid: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number, payments: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoPaymentDetail', amount: number, status: string }> } }, totemPayments: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsBySource', totalAmount: number, created: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number, payments: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoPaymentDetail', amount: number, status: string }> }, paid: { __typename?: 'ExpensumGetPaymentsChartsInfoPaymentsByStatus', totalAmount: number, payments: Array<{ __typename?: 'ExpensumGetPaymentsChartsInfoPaymentDetail', amount: number, status: string }> } } }> } & { ' $fragmentName'?: 'PaymentsStatusChartFragmentFragment' };

export type ProfessionalUserPreferredNameFragmentFragment = { __typename?: 'query_root', usuariosProfissionais: Array<{ __typename?: 'usuariosProfissionais', Usuario: { __typename?: 'usuarios', nome: string, sobrenome: string, apelido?: string | null } }> } & { ' $fragmentName'?: 'ProfessionalUserPreferredNameFragmentFragment' };

export type ProfilePictureAlertFragmentFragment = { __typename?: 'query_root', profilePictureFile?: { __typename?: 'LivanceApiSelecionaFotoDePerfilOutput', arquivo?: string | null, mimetype?: string | null } | null } & { ' $fragmentName'?: 'ProfilePictureAlertFragmentFragment' };

export type PublicPhoneNumberFragmentFragment = { __typename?: 'query_root', usuariosProfissionais: Array<{ __typename?: 'usuariosProfissionais', telefonePublico?: string | null }> } & { ' $fragmentName'?: 'PublicPhoneNumberFragmentFragment' };

export type ReceiveRoomNowFragmentFragment = { __typename?: 'agendamentos', codAgendamento: number, nome?: string | null, horaInicio: string, horaFim: string, unidade: { __typename?: 'unidades', nomeLimpo?: string | null } } & { ' $fragmentName'?: 'ReceiveRoomNowFragmentFragment' };

export type ReceiveRoomNowMutationVariables = Exact<{
  input?: InputMaybe<ReceberSalaAgoraInput>;
}>;


export type ReceiveRoomNowMutation = { __typename?: 'mutation_root', receberSalaAgora: { __typename?: 'ReceberSalaAgoraPayload', data?: { __typename?: 'AgendamentoApiOutput', codAgendamento: number } | null, errors?: Array<{ __typename: 'RepeatedPatientError', message: string } | { __typename: 'ValidationError', message: string }> | null } };

export type RecipientEmptyStateWrapperQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codClinica?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecipientEmptyStateWrapperQueryQuery = { __typename?: 'query_root', expensumRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', pagarmeId?: string | null } | null } | null };

export type RecipientInvalidAlertWrapperQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codClinica?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecipientInvalidAlertWrapperQueryQuery = { __typename?: 'query_root', expensumRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', status?: string | null } | null } | null };

export type RecommendationMembersForPatientFormFragmentFragment = { __typename?: 'query_root', paciente?: { __typename?: 'pacientes', nome: string, telefone: string } | null, fotoPerfilMembro?: { __typename?: 'LivanceApiSelecionaFotoDePerfilOutput', arquivo?: string | null, mimetype?: string | null } | null } & { ' $fragmentName'?: 'RecommendationMembersForPatientFormFragmentFragment' };

export type IndicateMemberForPatientMutationMutationVariables = Exact<{
  input: IndicarProfissionalInput;
}>;


export type IndicateMemberForPatientMutationMutation = { __typename?: 'mutation_root', indicarProfissional: { __typename?: 'IndicarProfissionalPayload', sucesso?: boolean | null, errors?: Array<{ __typename: 'ValidationError', message: string }> | null } };

export type RecommendationMembersForPatientQueryQueryVariables = Exact<{
  nomeMembro: Scalars['String']['input'];
}>;


export type RecommendationMembersForPatientQueryQuery = { __typename?: 'query_root', perfisPublicos?: (
    { __typename?: 'PerfisPublicosConnection' }
    & { ' $fragmentRefs'?: { 'MembersListFragmentFragment': MembersListFragmentFragment } }
  ) | null };

export type RecommendationPatientsForMemberQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendationPatientsForMemberQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'PatientListQueryFragmentFragment': PatientListQueryFragmentFragment } }
);

export type RefundDetailsQueryFragmentFragment = { __typename?: 'query_root', ExpensumPaymentDetails?: { __typename?: 'ExpensumPaymentDetailsOutput', acquirerTransactionKey?: string | null, amount: number, paidAt?: string | null, origin: string, paymentMethod?: string | null, payablesInfo: { __typename?: 'ExpensumPaymentDetailsPayablesInfo', payables: Array<{ __typename?: 'ExpensumPaymentDetailsPayableInfo', fee?: number | null }> } } | null, ExpensumGetRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', pagarmeId?: string | null } | null } | null } & { ' $fragmentName'?: 'RefundDetailsQueryFragmentFragment' };

export type PatientPaymentRefundMutationMutationVariables = Exact<{
  acquirerTransactionKey: Scalars['String']['input'];
}>;


export type PatientPaymentRefundMutationMutation = { __typename?: 'mutation_root', ExpensumChargeCancel?: { __typename?: 'ExpensumChargeCancelOutput', charge: { __typename?: 'ExpensumCharge', id?: string | null } } | null };

export type RefundReceiptDetailsQueryFragmentFragment = (
  { __typename?: 'ExpensumGetRefundReceiptOutput' }
  & { ' $fragmentRefs'?: { 'PatientPaymentsRefundDetailsSectionFragmentFragment': PatientPaymentsRefundDetailsSectionFragmentFragment;'PatientPaymentsRefundPayeeSectionFragmentFragment': PatientPaymentsRefundPayeeSectionFragmentFragment } }
) & { ' $fragmentName'?: 'RefundReceiptDetailsQueryFragmentFragment' };

export type RemoveUnavailableSlotMutationMutationVariables = Exact<{
  codFechamento: Scalars['Int']['input'];
}>;


export type RemoveUnavailableSlotMutationMutation = { __typename?: 'mutation_root', LivanceApiDeleteFechamento: string };

export type RescheduleAppointmentFlexiblePriceFormFragmentFragment = { __typename?: 'query_root', agendamento?: { __typename?: 'agendamentos', nomePlano?: string | null, numeroCarteirinha?: string | null, validadeCarteirinha?: string | null, confirmado: boolean, cancelado: boolean, ignorarEnvioEmail: boolean, ignorarEnvioWhatsApp: boolean, Paciente?: { __typename?: 'pacientes', cpfProprio: boolean, codPaciente: number } | null } | null, unidadesPrecosFlexiveis: Array<{ __typename?: 'UnidadesPrecosFlexiveis', taxaDesconto: number }>, periodosGarantidos: Array<{ __typename?: 'tbPeriodosGarantidos', codPeriodoGarantido: number }> } & { ' $fragmentName'?: 'RescheduleAppointmentFlexiblePriceFormFragmentFragment' };

export type RescheduleAppointmentApiMutationVariables = Exact<{
  input: RemarcarAgendamentoInput;
}>;


export type RescheduleAppointmentApiMutation = { __typename?: 'mutation_root', remarcarAgendamento: { __typename?: 'RemarcarAgendamentoPayload', data?: { __typename?: 'AgendamentoApiOutput', codAgendamento: number } | null, errors?: Array<{ __typename: 'RepeatedPatientError', message: string } | { __typename: 'ValidationError', message: string }> | null } };

export type RescheduleAppointmentPatientFormFragmentFragment = { __typename?: 'query_root', agendamento?: { __typename?: 'agendamentos', nomePlano?: string | null, numeroCarteirinha?: string | null, validadeCarteirinha?: string | null, nome?: string | null, dataNascimento?: string | null, confirmado: boolean, cancelado: boolean, telefone: string, telefoneProprio: boolean, email?: string | null, ignorarEnvioEmail: boolean, ignorarEnvioWhatsApp: boolean, Paciente?: { __typename?: 'pacientes', receberWhatsAppConfirmacao: boolean, cpf?: string | null, cpfProprio: boolean, codPaciente: number } | null } | null, newAppointmentType?: { __typename?: 'usuariosCompromissos', nome: string, codParceiroIntegracao?: number | null, tiposSalas: Array<{ __typename?: 'usuariosCompromissosTiposSalas', codTipoSala: number, TipoSala: { __typename?: 'tiposSalas', nome: string, unidadesPrecosFlexiveis: Array<{ __typename?: 'UnidadesPrecosFlexiveis', UnidadesPrecosFlexiveisParceirosIntegracoes: Array<{ __typename?: 'UnidadesPrecosFlexiveisParceirosIntegracoes', codParceiroIntegracao: number }> }> } }> } | null, newUnit?: { __typename?: 'unidades', nomeLimpo?: string | null, sigla?: string | null } | null } & { ' $fragmentName'?: 'RescheduleAppointmentPatientFormFragmentFragment' };

export type RescuedAppointmentDashboardCancelledAppointmentsSectionQueryFragmentFragment = { __typename?: 'AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', data: Array<{ __typename?: 'DataItemAnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', month?: string | null, rescuedAppointmentType?: string | null, appointmentsRescuedSum?: any | null, sentMessagesSum?: any | null } | null> } & { ' $fragmentName'?: 'RescuedAppointmentDashboardCancelledAppointmentsSectionQueryFragmentFragment' };

export type RescuedAppointmentDashboardNoShowAppointmentsSectionQueryFragmentFragment = { __typename?: 'AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', data: Array<{ __typename?: 'DataItemAnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', month?: string | null, rescuedAppointmentType?: string | null, appointmentsRescuedSum?: any | null, sentMessagesSum?: any | null } | null> } & { ' $fragmentName'?: 'RescuedAppointmentDashboardNoShowAppointmentsSectionQueryFragmentFragment' };

export type RescuedAppointmentDashboardTotalRescuedSectionQueryFragmentFragment = { __typename?: 'AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', data: Array<{ __typename?: 'DataItemAnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', month?: string | null, appointmentsRescuedSum?: any | null, sentMessagesSum?: any | null } | null> } & { ' $fragmentName'?: 'RescuedAppointmentDashboardTotalRescuedSectionQueryFragmentFragment' };

export type RescuedAppointmentDashboardUnscheduledAppointmentsSectionQueryFragmentFragment = { __typename?: 'AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', data: Array<{ __typename?: 'DataItemAnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', month?: string | null, rescuedAppointmentType?: string | null, appointmentsRescuedSum?: any | null, sentMessagesSum?: any | null } | null> } & { ' $fragmentName'?: 'RescuedAppointmentDashboardUnscheduledAppointmentsSectionQueryFragmentFragment' };

export type RescuedAppointmentsSectionQueryFragmentFragment = { __typename?: 'AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', data: Array<{ __typename?: 'DataItemAnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo', month?: string | null, rescuedAppointmentType?: string | null, appointmentsRescuedSum?: any | null, sentMessagesSum?: any | null } | null> } & { ' $fragmentName'?: 'RescuedAppointmentsSectionQueryFragmentFragment' };

export type GetReservedSchedulePriceFragmentFragment = { __typename?: 'query_root', ReservedSchedulePrice?: { __typename?: 'LivanceApiSimulaCobrancaPeriodoGarantidoOutput', price: number } | null } & { ' $fragmentName'?: 'GetReservedSchedulePriceFragmentFragment' };

export type CreateReservedScheduleMutationMutationVariables = Exact<{
  dataInicio: Scalars['String']['input'];
  horaInicio: Scalars['String']['input'];
  horaFim: Scalars['String']['input'];
  margemInicial: Scalars['String']['input'];
  codUsuario: Scalars['Int']['input'];
  codUnidade: Scalars['Int']['input'];
  codTipoSala: Scalars['Int']['input'];
  codModalidadePeriodoGarantido: Scalars['Int']['input'];
  codPeriodoGarantidoRecorrenteFrequencia: Scalars['Int']['input'];
}>;


export type CreateReservedScheduleMutationMutation = { __typename?: 'mutation_root', LivanceApiCriaPeriodoGarantidoRecorrente?: { __typename?: 'LivanceApiCriaPeriodoGarantidoRecorrenteOutput', codPeriodoGarantidoRecorrente?: number | null, message?: string | null, success?: boolean | null } | null };

export type GetLocationsFragmentFragment = { __typename?: 'query_root', locations: Array<(
    { __typename?: 'unidades', codUnidade: number, nome: string, rooms: Array<{ __typename?: 'unidadesSalas', codTipoSala: number, alocavel: boolean, roomType: { __typename?: 'tiposSalas', nome: string, alocavel: boolean } }> }
    & { ' $fragmentRefs'?: { 'UnitsListToSelectQueryFragmentFragment': UnitsListToSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'GetLocationsFragmentFragment' };

export type ReservedScheduleListItemQueryFragmentFragment = { __typename?: 'tbPeriodosGarantidosRecorrentes', codPeriodoGarantidoRecorrente: number, diaDaSemana: number, horaFim: string, horaInicio: string, PeriodosGarantidos: Array<{ __typename?: 'tbPeriodosGarantidos', ativo: boolean, codPeriodoGarantido: number, codAgendamentoFinalidadePeriodoGarantido: number, Agendamento: { __typename?: 'agendamentos', codAgendamento: number, data: string, horaInicio: string, horaFim: string, cancelado: boolean, codPaciente?: number | null, codUnidade: number, codUsuario: number, codUsuarioFormaRecebimento: number, codUsuarioCompromisso: number, codUsuarioAgenda?: number | null, confirmado: boolean, nome?: string | null, meioPagamento?: string | null, telefone: string, email?: string | null } }>, Unidade: { __typename?: 'unidades', nomeLimpo?: string | null }, PeriodosGarantidosRecorrentesFrequencia: { __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias', descricao: string }, TipoSala: { __typename?: 'tiposSalas', nome: string } } & { ' $fragmentName'?: 'ReservedScheduleListItemQueryFragmentFragment' };

export type ReservedScheduleListQueryFragmentFragment = { __typename?: 'query_root', periodosGarantidosRecorrentes: Array<(
    { __typename?: 'tbPeriodosGarantidosRecorrentes', codPeriodoGarantidoRecorrente: number, codPeriodoGarantidoRecorrenteFrequencia: number, PeriodosGarantidos: Array<{ __typename?: 'tbPeriodosGarantidos', codPeriodoGarantido: number }> }
    & { ' $fragmentRefs'?: { 'ReservedScheduleListItemQueryFragmentFragment': ReservedScheduleListItemQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'ReservedScheduleListQueryFragmentFragment' };

export type ReservedSchedulesSlotsFragmentFragment = { __typename?: 'query_root', Slots?: { __typename?: 'LivanceApiBuscaHorariosDisponiveisDiaDaSemanaOutput', sugestoesHorarios?: Array<{ __typename?: 'LivanceApiSugestaoDeHorariosPeriodoGarantido', data: string, horaFim: string, horaInicio: string } | null> | null } | null } & { ' $fragmentName'?: 'ReservedSchedulesSlotsFragmentFragment' };

export type ReservedSchedulesNextSchedulesFragmentFragment = { __typename?: 'tbPeriodosGarantidosRecorrentes', PeriodosGarantidos: Array<{ __typename?: 'tbPeriodosGarantidos', ativo: boolean, codPeriodoGarantido: number, codPeriodoGarantidoRecorrente?: number | null, Agendamento: { __typename?: 'agendamentos', codAgendamento: number, data: string, horaInicio: string, horaFim: string, Unidade: { __typename?: 'unidades', nomeLimpo?: string | null } } }> } & { ' $fragmentName'?: 'ReservedSchedulesNextSchedulesFragmentFragment' };

export type ReturnRoomDrawerFragmentFragment = { __typename?: 'agendamentos', name?: string | null, startTime: string, endTime: string, appointmentId: number, activeAllocation: Array<{ __typename?: 'AgendamentosAlocacoesAtivas', locationRoom: { __typename?: 'unidadesSalas', locationId: number, roomType: number } }> } & { ' $fragmentName'?: 'ReturnRoomDrawerFragmentFragment' };

export type ReturnRoomMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type ReturnRoomMutationMutation = { __typename?: 'mutation_root', finalizaAlocacao: { __typename?: 'FinalizaAlocacaoPayload', sucesso?: boolean | null } };

export type RoomTypesListQueryFragmentFragment = { __typename?: 'tiposSalas', codTipoSala: number, nome: string } & { ' $fragmentName'?: 'RoomTypesListQueryFragmentFragment' };

export type ScheduleDaysOfWeekListFragmentFragment = { __typename?: 'usuariosAgendas', agendasDiasSemanas: Array<{ __typename?: 'tbUsuariosAgendasDiasSemanas', diaSemana: number }> } & { ' $fragmentName'?: 'ScheduleDaysOfWeekListFragmentFragment' };

export type ScheduleFormQueryFragmentFragment = { __typename?: 'query_root', usuariosCompromissos: Array<(
    { __typename?: 'usuariosCompromissos' }
    & { ' $fragmentRefs'?: { 'AppointmentTypesListToMultiSelectQueryFragmentFragment': AppointmentTypesListToMultiSelectQueryFragmentFragment } }
  )>, tiposAgendasRepeticoes: Array<(
    { __typename?: 'tiposAgendasRepeticoes' }
    & { ' $fragmentRefs'?: { 'ScheduleFrequenciesListToSelectQueryFragmentFragment': ScheduleFrequenciesListToSelectQueryFragmentFragment } }
  )>, unidades: Array<(
    { __typename?: 'unidades', codUnidade: number, nomeLimpo?: string | null, unidadeHorariosFuncionamentos: Array<{ __typename?: 'unidadesHorariosFuncionamentos', codUnidade: number, diaSemana: number, abertura: string, fechamento: string }> }
    & { ' $fragmentRefs'?: { 'UnitsListToMultiSelectQueryFragmentFragment': UnitsListToMultiSelectQueryFragmentFragment } }
  )>, schedule?: { __typename?: 'usuariosAgendas', codUsuarioAgenda: number, dataInicio: string, dataFim?: string | null, inicio: string, fim: string, codTipoAgendaRepeticao: number, compromissos: Array<{ __typename?: 'usuariosAgendasCompromissos', codUsuarioCompromisso: number }>, diasSemana: Array<{ __typename?: 'tbUsuariosAgendasDiasSemanas', diaSemana: number }>, unidades: Array<{ __typename?: 'usuariosAgendasUnidades', codUnidade: number }> } | null } & { ' $fragmentName'?: 'ScheduleFormQueryFragmentFragment' };

export type CreateScheduleMutationMutationVariables = Exact<{
  input: LivanceApiCreateUsuarioAgendaInput;
}>;


export type CreateScheduleMutationMutation = { __typename?: 'mutation_root', LivanceApiCreateUsuarioAgenda: number };

export type UpdateScheduleMutationMutationVariables = Exact<{
  input: LivanceApiPatchUsuarioAgendaInput;
}>;


export type UpdateScheduleMutationMutation = { __typename?: 'mutation_root', LivanceApiPatchUsuarioAgenda: any };

export type ScheduleFrequenciesListToSelectTestQueryFragmentFragment = { __typename?: 'query_root', tiposAgendasRepeticoes: Array<(
    { __typename?: 'tiposAgendasRepeticoes' }
    & { ' $fragmentRefs'?: { 'ScheduleFrequenciesListToSelectQueryFragmentFragment': ScheduleFrequenciesListToSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'ScheduleFrequenciesListToSelectTestQueryFragmentFragment' };

export type ScheduleFrequenciesListToSelectQueryFragmentFragment = { __typename?: 'tiposAgendasRepeticoes', codTipoAgendaRepeticao: number, nome?: string | null } & { ' $fragmentName'?: 'ScheduleFrequenciesListToSelectQueryFragmentFragment' };

export type ScheduleListItemCardAppointmentTypeFragmentFragment = { __typename?: 'usuariosAgendas', agendasCompromissos: Array<{ __typename?: 'usuariosAgendasCompromissos', compromisso: { __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number, nome: string } }> } & { ' $fragmentName'?: 'ScheduleListItemCardAppointmentTypeFragmentFragment' };

export type ScheduleListItemCardFrequencyFragmentFragment = { __typename?: 'usuariosAgendas', tipoRepeticao: number } & { ' $fragmentName'?: 'ScheduleListItemCardFrequencyFragmentFragment' };

export type ScheduleListItemCardHeadFragmentFragment = { __typename?: 'usuariosAgendas', inicio: string, fim: string } & { ' $fragmentName'?: 'ScheduleListItemCardHeadFragmentFragment' };

export type ScheduleListItemCardStartDateFragmentFragment = { __typename?: 'usuariosAgendas', tipoRepeticao: number, startDate: string } & { ' $fragmentName'?: 'ScheduleListItemCardStartDateFragmentFragment' };

export type ScheduleListItemCardUnitFragmentFragment = { __typename?: 'usuariosAgendas', agendasUnidades: Array<{ __typename?: 'usuariosAgendasUnidades', Unidade?: { __typename?: 'unidades', sigla?: string | null, nomeLimpo?: string | null } | null }> } & { ' $fragmentName'?: 'ScheduleListItemCardUnitFragmentFragment' };

export type ScheduleListItemFragmentFragment = (
  { __typename?: 'usuariosAgendas', codUsuarioAgenda: number, tipoRepeticao: number, startDate: string }
  & { ' $fragmentRefs'?: { 'ScheduleListItemCardFrequencyFragmentFragment': ScheduleListItemCardFrequencyFragmentFragment;'ScheduleListItemCardAppointmentTypeFragmentFragment': ScheduleListItemCardAppointmentTypeFragmentFragment;'ScheduleListItemCardHeadFragmentFragment': ScheduleListItemCardHeadFragmentFragment;'ScheduleListItemCardUnitFragmentFragment': ScheduleListItemCardUnitFragmentFragment;'ScheduleDaysOfWeekListFragmentFragment': ScheduleDaysOfWeekListFragmentFragment;'ScheduleListItemCardStartDateFragmentFragment': ScheduleListItemCardStartDateFragmentFragment } }
) & { ' $fragmentName'?: 'ScheduleListItemFragmentFragment' };

export type SchedulesListQueryFragmentFragment = { __typename?: 'query_root', usuariosAgendas: Array<(
    { __typename?: 'usuariosAgendas', codUsuarioAgenda: number, startDate: string, tipoRepeticao: number }
    & { ' $fragmentRefs'?: { 'ScheduleListItemFragmentFragment': ScheduleListItemFragmentFragment } }
  )>, usuariosCompromissos: Array<{ __typename?: 'usuariosCompromissos', codUsuarioCompromisso: number }> } & { ' $fragmentName'?: 'SchedulesListQueryFragmentFragment' };

export type AppointmentInfosFormFragmentFragment = { __typename?: 'query_root', personalizeAppointment: Array<{ __typename?: 'usuariosProfissionaisOrientacoesSecretarias', appointmentInfos?: string | null }> } & { ' $fragmentName'?: 'AppointmentInfosFormFragmentFragment' };

export type UpsertSecretaryDetailsAppointmentInfosMutationMutationVariables = Exact<{
  input: UsuariosProfissionaisOrientacoesSecretarias_Insert_Input;
}>;


export type UpsertSecretaryDetailsAppointmentInfosMutationMutation = { __typename?: 'mutation_root', insert_usuariosProfissionaisOrientacoesSecretarias_one?: { __typename?: 'usuariosProfissionaisOrientacoesSecretarias', informacoesSobreAgendamento?: string | null } | null };

export type SecretaryDetailsFaqFormFragmentFragment = { __typename?: 'query_root', personalizeAppointment: Array<{ __typename?: 'usuariosProfissionaisOrientacoesSecretarias', Faq?: string | null }> } & { ' $fragmentName'?: 'SecretaryDetailsFaqFormFragmentFragment' };

export type UpsertSecretaryDetailsFaqMutationMutationVariables = Exact<{
  input: UsuariosProfissionaisOrientacoesSecretarias_Insert_Input;
}>;


export type UpsertSecretaryDetailsFaqMutationMutation = { __typename?: 'mutation_root', insert_usuariosProfissionaisOrientacoesSecretarias_one?: { __typename?: 'usuariosProfissionaisOrientacoesSecretarias', informacoesDuvidasFrequentes?: string | null } | null };

export type PersonalizeAppointmentFormFragmentFragment = { __typename?: 'query_root', personalizeAppointment: Array<{ __typename?: 'usuariosProfissionaisOrientacoesSecretarias', professionalInfos?: string | null, appointmentInfos?: string | null, restrictions?: string | null, faq?: string | null }> } & { ' $fragmentName'?: 'PersonalizeAppointmentFormFragmentFragment' };

export type SecretaryDetailsProfessionalInfosFormFragmentFragment = { __typename?: 'query_root', personalizeAppointment: Array<{ __typename?: 'usuariosProfissionaisOrientacoesSecretarias', professionalInfos?: string | null }> } & { ' $fragmentName'?: 'SecretaryDetailsProfessionalInfosFormFragmentFragment' };

export type UpsertSecretaryDetailsProfessionalInfosMutationMutationVariables = Exact<{
  input: UsuariosProfissionaisOrientacoesSecretarias_Insert_Input;
}>;


export type UpsertSecretaryDetailsProfessionalInfosMutationMutation = { __typename?: 'mutation_root', insert_usuariosProfissionaisOrientacoesSecretarias_one?: { __typename?: 'usuariosProfissionaisOrientacoesSecretarias', informacoesSobreProfissional?: string | null } | null };

export type SecretaryDetailsRestrictionsFormFragmentFragment = { __typename?: 'query_root', personalizeAppointment: Array<{ __typename?: 'usuariosProfissionaisOrientacoesSecretarias', restrictions?: string | null }> } & { ' $fragmentName'?: 'SecretaryDetailsRestrictionsFormFragmentFragment' };

export type UpsertSecretaryDetailsRestrictionsMutationMutationVariables = Exact<{
  input: UsuariosProfissionaisOrientacoesSecretarias_Insert_Input;
}>;


export type UpsertSecretaryDetailsRestrictionsMutationMutation = { __typename?: 'mutation_root', insert_usuariosProfissionaisOrientacoesSecretarias_one?: { __typename?: 'usuariosProfissionaisOrientacoesSecretarias', informacoesSobreRestricoes?: string | null } | null };

export type SendPaymentFormFragmentFragment = { __typename?: 'agendamentos', codAgendamento: number, valor: number, compromisso?: { __typename?: 'usuariosCompromissos', valor: number } | null, AgendamentosVinculados: Array<{ __typename?: 'tbAgendamentosVinculados', codAgendamentoPrincipal: number }> } & { ' $fragmentName'?: 'SendPaymentFormFragmentFragment' };

export type SendPaymentMutationMutationVariables = Exact<{
  payment: Expensum_Event_Totem_Payment_Sent_Insert_Input;
}>;


export type SendPaymentMutationMutation = { __typename?: 'mutation_root', paymentSent?: { __typename?: 'expensum_event_totem_payment_sent', id: number } | null };

export type AcceptLivanceAssistMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptLivanceAssistMutationMutation = { __typename?: 'mutation_root', contratarPacoteServicos: { __typename?: 'ContratarPacoteServicosPayload', contratarPacoteServicosOutput?: { __typename?: 'ContratarPacoteServicosOutput', codPacoteServico: number } | null, errors?: Array<{ __typename: 'ValidationError', message: string }> | null } };

export type SubscribeAssistProSubscriptionConfirmCardFragmentFragment = { __typename?: 'query_root', servicePackage?: { __typename?: 'pacotesServicos', pacotesServicosPreco?: { __typename?: 'pacoteServicoPreco', valorUnitarioFixo: number, pacotesServicosPrecosVariaveis: Array<{ __typename?: 'tbPacotesServicosPrecosVariaveis', valorUnitario: number, codPacoteServicosPrecoVariavel: number }> } | null } | null } & { ' $fragmentName'?: 'SubscribeAssistProSubscriptionConfirmCardFragmentFragment' };

export type ServicePackagesFragmentFragment = { __typename?: 'query_root', servicePackage?: { __typename?: 'pacotesServicos', pacotesServicosPreco?: { __typename?: 'pacoteServicoPreco', valorUnitarioFixo: number, pacotesServicosPrecosVariaveis: Array<{ __typename?: 'tbPacotesServicosPrecosVariaveis', valorUnitario: number, codPacoteServicosPrecoVariavel: number }> } | null } | null } & { ' $fragmentName'?: 'ServicePackagesFragmentFragment' };

export type SubscribedAssistFragmentFragment = (
  { __typename?: 'pacoteServicoPreco' }
  & { ' $fragmentRefs'?: { 'SubscribedAssistProPriceFragmentFragment': SubscribedAssistProPriceFragmentFragment } }
) & { ' $fragmentName'?: 'SubscribedAssistFragmentFragment' };

export type SubscribedAssistProPriceFragmentFragment = { __typename?: 'pacoteServicoPreco', valorUnitarioFixo: number, pacotesServicosPrecosVariaveis: Array<{ __typename?: 'tbPacotesServicosPrecosVariaveis', valorUnitario: number, codPacoteServicosPrecoVariavel: number }> } & { ' $fragmentName'?: 'SubscribedAssistProPriceFragmentFragment' };

export type UnavailableSlotFormFragmentFragment = { __typename?: 'usuariosAgendas', usuariosAgendasUnidades: Array<{ __typename?: 'usuariosAgendasUnidades', Unidade?: (
      { __typename?: 'unidades', codUnidade: number, nomeLimpo?: string | null }
      & { ' $fragmentRefs'?: { 'UnitsListToMultiSelectQueryFragmentFragment': UnitsListToMultiSelectQueryFragmentFragment } }
    ) | null }> } & { ' $fragmentName'?: 'UnavailableSlotFormFragmentFragment' };

export type UnavailableSlotCreateMutationMutationVariables = Exact<{
  input: CriarMultiplosFechamentosInput;
}>;


export type UnavailableSlotCreateMutationMutation = { __typename?: 'mutation_root', criarMultiplosFechamentos: { __typename?: 'CriarMultiplosFechamentosPayload', data?: Array<{ __typename?: 'FechamentoApiOutput', codFechamento: number } | null> | null, errors?: Array<{ __typename: 'ValidationError', message: string }> | null } };

export type UnitsListToMultiSelectTestQueryFragmentFragment = { __typename?: 'query_root', unidades: Array<(
    { __typename?: 'unidades' }
    & { ' $fragmentRefs'?: { 'UnitsListToMultiSelectQueryFragmentFragment': UnitsListToMultiSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'UnitsListToMultiSelectTestQueryFragmentFragment' };

export type UnitsListToMultiSelectQueryFragmentFragment = { __typename?: 'unidades', codUnidade: number, nome: string } & { ' $fragmentName'?: 'UnitsListToMultiSelectQueryFragmentFragment' };

export type UnitsListToSelectTestQueryFragmentFragment = { __typename?: 'query_root', unidades: Array<(
    { __typename?: 'unidades' }
    & { ' $fragmentRefs'?: { 'UnitsListToSelectQueryFragmentFragment': UnitsListToSelectQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'UnitsListToSelectTestQueryFragmentFragment' };

export type UnitsListToSelectQueryFragmentFragment = { __typename?: 'unidades', codUnidade: number, nome: string } & { ' $fragmentName'?: 'UnitsListToSelectQueryFragmentFragment' };

export type UpsertPublicPhoneMutationMutationVariables = Exact<{
  telefone?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertPublicPhoneMutationMutation = { __typename?: 'mutation_root', atualizarTelefonePublico: { __typename?: 'AtualizarTelefonePublicoPayload', boolean?: boolean | null, errors?: Array<{ __typename: 'ValidationError' }> | null } };

export type UserTrackableLinksDetailsActionsFragmentFragment = { __typename?: 'usuariosLinksRastreamentos', nome: string, descricao?: string | null, link: string } & { ' $fragmentName'?: 'UserTrackableLinksDetailsActionsFragmentFragment' };

export type UserTrackableLinksDetailsDescriptionFragmentFragment = { __typename?: 'usuariosLinksRastreamentos', nome: string, descricao?: string | null } & { ' $fragmentName'?: 'UserTrackableLinksDetailsDescriptionFragmentFragment' };

export type UserTrackableLinksDetailsLinkInputFragmentFragment = { __typename?: 'usuariosLinksRastreamentos', link: string } & { ' $fragmentName'?: 'UserTrackableLinksDetailsLinkInputFragmentFragment' };

export type UserTrackableLinkReportDetailListItemQueryQueryVariables = Exact<{
  codLinkRastreamento: Scalars['String']['input'];
  dataCadastro: Scalars['String']['input'];
}>;


export type UserTrackableLinkReportDetailListItemQueryQuery = { __typename?: 'query_root', userTrackableLinkReportDetails?: { __typename?: 'AnalyticsMembroDadosDeUsuarioLinkRastreamento', data: Array<{ __typename?: 'DataItemUsuarioLinkRastreavelPipe', totalAcesso?: any | null, totalAgendamento?: any | null, totalUso?: any | null, totalRecebido?: string | null, totalBuscasRealizadas?: any | null } | null> } | null };

export type UserTrackableLinkReportDetailSummaryFragmentFragment = { __typename?: 'usuariosLinksRastreamentos', nome: string, descricao?: string | null } & { ' $fragmentName'?: 'UserTrackableLinkReportDetailSummaryFragmentFragment' };

export type CreateTrackableLinkMutationMutationVariables = Exact<{
  input: CriarUsuarioLinkRastreamentoInput;
}>;


export type CreateTrackableLinkMutationMutation = { __typename?: 'mutation_root', criarUsuarioLinkRastreamento: { __typename?: 'CriarUsuarioLinkRastreamentoPayload', criarUsuarioLinkRastreamentoOutput?: { __typename?: 'CriarUsuarioLinkRastreamentoOutput', codUsuarioLinkRastreamento: number, link: string } | null } };

export type UserTrackableLinkListItemQueryFragmentFragment = { __typename?: 'usuariosLinksRastreamentos', nome: string, descricao?: string | null, dataCadastro: string, codUsuarioLinkRastreamento: number, sistema: boolean } & { ' $fragmentName'?: 'UserTrackableLinkListItemQueryFragmentFragment' };

export type UserTrackableLinksQueryFragmentFragment = { __typename?: 'query_root', usuariosLinksRastreamentos: Array<(
    { __typename?: 'usuariosLinksRastreamentos', codUsuarioLinkRastreamento: number }
    & { ' $fragmentRefs'?: { 'UserTrackableLinkListItemQueryFragmentFragment': UserTrackableLinkListItemQueryFragmentFragment } }
  )> } & { ' $fragmentName'?: 'UserTrackableLinksQueryFragmentFragment' };

export type WaitingRoomAppointmentListItemPaymentFragmentFragment = { __typename?: 'agendamentos', codAgendamento: number, pago: boolean, pagar: boolean, valor: number, onlinePayments: Array<{ __typename?: 'expensum_online_payment', codAgendamento?: number | null, amount: number, status: string }>, agendamentosVinculados: Array<{ __typename?: 'tbAgendamentosVinculados', onlinePayments: Array<{ __typename?: 'expensum_online_payment', codAgendamento?: number | null, amount: number, status: string }> }> } & { ' $fragmentName'?: 'WaitingRoomAppointmentListItemPaymentFragmentFragment' };

export type WaitingRoomAppointmentListItemFragmentFragment = (
  { __typename?: 'agendamentos', codAgendamento: number, horaInicio: string, horaFim: string, codFinalidadeAgendamento: number, paciente?: (
    { __typename?: 'pacientes', codPaciente: number, nome: string }
    & { ' $fragmentRefs'?: { 'PatientAvatarFragmentFragment': PatientAvatarFragmentFragment } }
  ) | null, unidade: { __typename?: 'unidades', nome: string }, compromisso?: { __typename?: 'usuariosCompromissos', nome: string } | null, checkin?: { __typename?: 'tbAgendamentosCheckins', dataCheckin: string } | null, atraso: Array<{ __typename?: 'notificacoesPacientesAtrasados', tempoAtraso?: string | null, dataCadastro: string }>, tags: Array<{ __typename?: 'agendamentosTags', dataCadastro: string, codAgendamentoTipoTag: number }> }
  & { ' $fragmentRefs'?: { 'WaitingRoomAppointmentListItemPaymentFragmentFragment': WaitingRoomAppointmentListItemPaymentFragmentFragment } }
) & { ' $fragmentName'?: 'WaitingRoomAppointmentListItemFragmentFragment' };

export type WaitingRoomAppointmentListQueryFragmentFragment = { __typename?: 'query_root', agendamentos: Array<(
    { __typename?: 'agendamentos', codAgendamento: number, horaFim: string, agendamentoPreAlocacao: Array<{ __typename?: 'agendamentosPreAlocacao', UnidadeSala?: { __typename?: 'unidadesSalas', TipoSala: { __typename?: 'tiposSalas', nome: string, codTipoSala: number } } | null }>, agendamentoAlocacaoAtiva: Array<{ __typename?: 'AgendamentosAlocacoesAtivas', UnidadeSala: { __typename?: 'unidadesSalas', TipoSala: { __typename?: 'tiposSalas', nome: string, codTipoSala: number } } }>, compromisso?: { __typename?: 'usuariosCompromissos', UsuariosCompromissosTiposSalas: Array<{ __typename?: 'usuariosCompromissosTiposSalas', codTipoSala: number, codUsuarioCompromisso: number, prioridade: number }> } | null }
    & { ' $fragmentRefs'?: { 'WaitingRoomAppointmentListItemFragmentFragment': WaitingRoomAppointmentListItemFragmentFragment } }
  )> } & { ' $fragmentName'?: 'WaitingRoomAppointmentListQueryFragmentFragment' };

export type CriaTagAgendamentoAtendidoMutationVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type CriaTagAgendamentoAtendidoMutation = { __typename?: 'mutation_root', agendamentoAtendido: { __typename?: 'AgendamentoAtendidoPayload', sucesso?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type RemoveTagAgendamentoAtendidoMutationVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type RemoveTagAgendamentoAtendidoMutation = { __typename?: 'mutation_root', agendamentoNaoAtendido: { __typename?: 'AgendamentoNaoAtendidoPayload', sucesso?: boolean | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };

export type WaitingRoomFilterButtonFragmentFragment = { __typename?: 'query_root', agendamentos: Array<{ __typename?: 'agendamentos', codAgendamento: number }> } & { ' $fragmentName'?: 'WaitingRoomFilterButtonFragmentFragment' };

export type WaitingRoomAppointmentMenuFragmentFragment = { __typename?: 'agendamentos', codAgendamento: number, horaInicio: string, horaFim: string, pago: boolean, data: string, cobraCancelamento: boolean, AgendamentosCheckin?: { __typename?: 'tbAgendamentosCheckins', codAgendamento: number } | null, unidade: { __typename?: 'unidades', codUnidade: number }, compromisso?: { __typename?: 'usuariosCompromissos', codUsuarioCompromissoModalidade: number } | null, paciente?: (
    { __typename?: 'pacientes', codPaciente: number, nome: string }
    & { ' $fragmentRefs'?: { 'PatientAvatarFragmentFragment': PatientAvatarFragmentFragment } }
  ) | null, atraso: Array<{ __typename?: 'notificacoesPacientesAtrasados', tempoAtraso?: string | null, dataCadastro: string }>, tags: Array<{ __typename?: 'agendamentosTags', dataCadastro: string, codAgendamentoTipoTag: number }>, followUpAppointment: Array<{ __typename?: 'lembretes', codLembrete: number }> } & { ' $fragmentName'?: 'WaitingRoomAppointmentMenuFragmentFragment' };

export type EnsureRecipientHasAcceptedTermsOfUseQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codClinica?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EnsureRecipientHasAcceptedTermsOfUseQueryQuery = { __typename?: 'query_root', recipientTermsOfUseAgreed: Array<{ __typename?: 'expensum_recipient_terms_of_use_agreed', id: number }>, ExpensumGetRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', id?: number | null } | null } | null };

export type UserQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQueryQuery = { __typename?: 'query_root', usuarios: Array<{ __typename?: 'usuarios', codUsuario: number, ativo: boolean, apelido?: string | null, codPerfil: number, email: string, nome: string, sobrenome: string, usuarioProfissional?: { __typename?: 'usuariosProfissionais', codConselhoClasse?: string | null, bloqueado: boolean, dataInicioDivida?: string | null, dataValidacao?: string | null, usuarioTelefone?: { __typename?: 'usuariosTelefones', ramalTroncoNormalizado: string } | null } | null, userTermsOfUse: Array<{ __typename?: 'users_terms_of_use_agreed', id: number, termsOfUseId: number, agreedAt: any }>, especialidades: Array<{ __typename?: 'usuariosEspecialidades', codEspecialidade: number }> }>, clinicas: Array<{ __typename?: 'tbClinicas', codClinica: number }>, integracoes: Array<{ __typename?: 'tbUsuariosIntegracoes', codParceiro?: number | null }>, membro?: { __typename?: 'Membro', altaTaxaCancelamento: boolean, funcionalidadesContratadas?: Array<{ __typename?: 'FuncionalidadeContratadaOutput', codFuncionalidade: number, ativo: boolean, contratada: boolean } | null> | null, pacotesServicos?: Array<{ __typename?: 'PacoteServicoOutput', cancelado: boolean, codPacoteServicos: number, dataDesativacao?: string | null, dataContratacao: string, dataFimTrial?: string | null, trialAtivo: boolean, trialFinalizado: boolean, grupoUpgrade: string, codUsuarioPacoteServicos: number, pacoteServicoPreco?: { __typename?: 'PacoteServicoPrecoOutput', valorUnitarioVariavel: any, valorUnitarioFixo: any } | null } | null> | null, possivelDataFimTrialAssistPro?: { __typename?: 'BuscaDataFimTrialAssistProOutput', dataFimTrialAssistPro: string, temTrialDisponivel: boolean } | null } | null };

export type RescheduleAppointmentFlexiblePricingPageQueryQueryVariables = Exact<{
  codTipoSala?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  data: Scalars['date']['input'];
  horaInicio: Scalars['time']['input'];
  codAgendamento: Scalars['Int']['input'];
}>;


export type RescheduleAppointmentFlexiblePricingPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'RescheduleAppointmentFlexiblePriceFormFragmentFragment': RescheduleAppointmentFlexiblePriceFormFragmentFragment } }
);

export type PatientSwapSearchPageQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type PatientSwapSearchPageQueryQuery = (
  { __typename?: 'query_root', appointment?: { __typename?: 'agendamentos', codAgendamento: number, data: string, horaInicio: string, horaFim: string } | null }
  & { ' $fragmentRefs'?: { 'PatientSwapPatientListFragmentFragment': PatientSwapPatientListFragmentFragment } }
);

export type PatientSwapPageQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type PatientSwapPageQueryQuery = { __typename?: 'query_root', agendamento?: (
    { __typename?: 'agendamentos', codAgendamento: number, data: string, horaInicio: string, codFinalidadeAgendamento: number, horaFim: string }
    & { ' $fragmentRefs'?: { 'AppointmentPatientSwapFormFragmentFragment': AppointmentPatientSwapFormFragmentFragment } }
  ) | null };

export type RescheduleAppointmentPatientPageQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
  codUnidade: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
}>;


export type RescheduleAppointmentPatientPageQueryQuery = (
  { __typename?: 'query_root', agendamento?: { __typename?: 'agendamentos', codAgendamento: number } | null }
  & { ' $fragmentRefs'?: { 'RescheduleAppointmentPatientFormFragmentFragment': RescheduleAppointmentPatientFormFragmentFragment } }
);

export type ReschedulePageQueryQueryVariables = Exact<{
  dataInicio: Scalars['date']['input'];
  codAgendamento: Scalars['Int']['input'];
}>;


export type ReschedulePageQueryQuery = (
  { __typename?: 'query_root', usuariosAgendas: Array<{ __typename?: 'usuariosAgendas', codUsuarioAgenda: number }>, agendamento?: { __typename?: 'agendamentos', codUnidade: number, codUsuarioCompromisso: number, codUsuarioFormaRecebimento: number, data: string, codAgendamento: number } | null }
  & { ' $fragmentRefs'?: { 'AppointmentFormFragmentFragment': AppointmentFormFragmentFragment;'BlockedActionsListAlertFragmentFragment': BlockedActionsListAlertFragmentFragment } }
);

export type AppointmentFlexiblePricePageQueryQueryVariables = Exact<{
  codTipoSala?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  data: Scalars['date']['input'];
  horaInicio: Scalars['time']['input'];
}>;


export type AppointmentFlexiblePricePageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'AppointmentFlexiblePriceFormFragmentFragment': AppointmentFlexiblePriceFormFragmentFragment } }
);

export type AppointmentPageQueryQueryVariables = Exact<{
  dataInicio: Scalars['date']['input'];
  codAgendamento: Scalars['Int']['input'];
  codPaciente: Scalars['Int']['input'];
}>;


export type AppointmentPageQueryQuery = (
  { __typename?: 'query_root', usuariosAgendas: Array<{ __typename?: 'usuariosAgendas', codUsuarioAgenda: number }>, paciente?: { __typename?: 'pacientes', codPaciente: number, telefone: string, cpf?: string | null, nome: string, email?: string | null, receberWhatsAppConfirmacao: boolean, dataNascimento?: string | null } | null, agendamento?: { __typename?: 'agendamentos', codUnidade: number, codUsuarioCompromisso: number, codUsuarioFormaRecebimento: number, data: string } | null }
  & { ' $fragmentRefs'?: { 'AppointmentFormFragmentFragment': AppointmentFormFragmentFragment;'BlockedActionsListAlertFragmentFragment': BlockedActionsListAlertFragmentFragment } }
);

export type AppointmentPatientPageQueryQueryVariables = Exact<{
  codUsuarioCompromisso: Scalars['Int']['input'];
  codUnidade: Scalars['Int']['input'];
}>;


export type AppointmentPatientPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'AppointmentFormPatientFragmentFragment': AppointmentFormPatientFragmentFragment } }
);

export type AppointmentPatientSearchPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AppointmentPatientSearchPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'CreateAppointmentPatientListFragmentFragment': CreateAppointmentPatientListFragmentFragment } }
);

export type UnavailableSlotPageQueryVariables = Exact<{
  codFechamento: Scalars['Int']['input'];
}>;


export type UnavailableSlotPageQuery = { __typename?: 'query_root', tbFechamentos: Array<{ __typename?: 'tbFechamentos', codTipoFechamento: number }> };

export type CalendarPageScheduleQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
}>;


export type CalendarPageScheduleQueryQuery = (
  { __typename?: 'query_root', usuariosAgendas: Array<{ __typename?: 'usuariosAgendas', agendasUnidades: Array<{ __typename?: 'usuariosAgendasUnidades', Unidade?: { __typename?: 'unidades', nome: string, nomeLimpo?: string | null, codUnidade: number, ativo: boolean, sigla?: string | null } | null }> }> }
  & { ' $fragmentRefs'?: { 'UnitsBySchedulesQueryFragmentFragment': UnitsBySchedulesQueryFragmentFragment;'BlockedActionsListFragmentFragment': BlockedActionsListFragmentFragment;'TimePoliciesQueryFragmentFragment': TimePoliciesQueryFragmentFragment;'ScheduleSlotsFragmentFragment': ScheduleSlotsFragmentFragment } }
);

export type CalendarPageAppointmentsQueryQueryVariables = Exact<{
  dataInicio: Scalars['date']['input'];
  dataFim: Scalars['date']['input'];
  dataInicioToString: Scalars['String']['input'];
  dataFimToString: Scalars['String']['input'];
  availableAppointmentsPurpose: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CalendarPageAppointmentsQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'AppointmentsQueryFragmentFragment': AppointmentsQueryFragmentFragment;'HolidaysQueryFragmentFragment': HolidaysQueryFragmentFragment } }
);

export type CalendarPageFreeSlotsQueryQueryVariables = Exact<{
  dataInicio: Scalars['date']['input'];
  dataFim: Scalars['date']['input'];
  codUsuario: Scalars['Int']['input'];
  codUnidade?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CalendarPageFreeSlotsQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'FreeScheduleSlotsFragmentFragment': FreeScheduleSlotsFragmentFragment } }
);

export type UnavailableSlotsPageQueryQueryVariables = Exact<{
  dataInicio: Scalars['date']['input'];
}>;


export type UnavailableSlotsPageQueryQuery = { __typename?: 'query_root', usuariosAgendas: Array<(
    { __typename?: 'usuariosAgendas' }
    & { ' $fragmentRefs'?: { 'UnavailableSlotFormFragmentFragment': UnavailableSlotFormFragmentFragment } }
  )> };

export type ExtendTimePageQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type ExtendTimePageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'ExtendTimeFormFragmentFragment': ExtendTimeFormFragmentFragment } }
);

export type HomePageQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type HomePageQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'HomeProfileHeaderFragmentFragment': HomeProfileHeaderFragmentFragment } }
);

export type GetOneLivUserAdditionalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneLivUserAdditionalInfoQuery = { __typename?: 'query_root', locus_membro: Array<(
    { __typename?: 'locus_membro' }
    & { ' $fragmentRefs'?: { 'OneLivAdditionalInfoFormFragmentFragment': OneLivAdditionalInfoFormFragmentFragment } }
  )> };

export type GetOneLivUserBasicInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneLivUserBasicInfoQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'OneLivBasicInfoFormFragmentFragment': OneLivBasicInfoFormFragmentFragment } }
);

export type GetOneLivUserEducationalBackgroundQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneLivUserEducationalBackgroundQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'OneLivEducationalBackgroundFormFragmentFragment': OneLivEducationalBackgroundFormFragmentFragment } }
);

export type GetOneLivUserExperiencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneLivUserExperiencesQuery = { __typename?: 'query_root', locus_membro: Array<(
    { __typename?: 'locus_membro' }
    & { ' $fragmentRefs'?: { 'OneLivExperiencesFormFragmentFragment': OneLivExperiencesFormFragmentFragment } }
  )> };

export type GetOneLivUserFaqQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneLivUserFaqQuery = { __typename?: 'query_root', locus_membro: Array<(
    { __typename?: 'locus_membro' }
    & { ' $fragmentRefs'?: { 'OneLivFaqFormFragmentFragment': OneLivFaqFormFragmentFragment } }
  )> };

export type GetOneLivUserMedicalInstitutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneLivUserMedicalInstitutionsQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'OneLivMedicalInstitutionsFormFragmentFragment': OneLivMedicalInstitutionsFormFragmentFragment } }
);

export type GetOneLivUserSocialMediaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneLivUserSocialMediaQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'OneLivSocialMediaFormFragmentFragment': OneLivSocialMediaFormFragmentFragment } }
);

export type GetOneLivUserTreatmentFocusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneLivUserTreatmentFocusQuery = { __typename?: 'query_root', locus_membro: Array<(
    { __typename?: 'locus_membro' }
    & { ' $fragmentRefs'?: { 'OneLivTreatmentFocusFormFragmentFragment': OneLivTreatmentFocusFormFragmentFragment } }
  )> };

export type GetOneLivUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOneLivUserQuery = { __typename?: 'query_root', locus_membro: Array<{ __typename?: 'locus_membro', id: number }> };

export type PatientDetailPageQueryQueryVariables = Exact<{
  patientId: Scalars['Int']['input'];
  today: Scalars['datetime2']['input'];
}>;


export type PatientDetailPageQueryQuery = { __typename?: 'query_root', patient?: (
    { __typename?: 'pacientes' }
    & { ' $fragmentRefs'?: { 'PatientDetailActionListFragmentFragment': PatientDetailActionListFragmentFragment;'PatientDetailPropertyListFragmentFragment': PatientDetailPropertyListFragmentFragment;'PatientHistoryListFragmentFragment': PatientHistoryListFragmentFragment;'PatientDetailHeaderFragmentFragment': PatientDetailHeaderFragmentFragment;'PatientDetailHeaderActionsFragmentFragment': PatientDetailHeaderActionsFragmentFragment;'PatientDetailLastAppointmentFragmentFragment': PatientDetailLastAppointmentFragmentFragment;'PatientDetailTabsFragmentFragment': PatientDetailTabsFragmentFragment } }
  ) | null };

export type PatientUpdatePageQueryQueryVariables = Exact<{
  patientId: Scalars['Int']['input'];
}>;


export type PatientUpdatePageQueryQuery = { __typename?: 'query_root', patient?: (
    { __typename?: 'pacientes' }
    & { ' $fragmentRefs'?: { 'PatientAvatarFragmentFragment': PatientAvatarFragmentFragment;'PatientUpdateFormQueryFragment': PatientUpdateFormQueryFragment } }
  ) | null };

export type PatientPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PatientPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'PatientListQueryFragmentFragment': PatientListQueryFragmentFragment } }
);

export type RecommendationMemberForPatientConfirmationPageQueryQueryVariables = Exact<{
  codPaciente: Scalars['Int']['input'];
  codMembro: Scalars['Int']['input'];
}>;


export type RecommendationMemberForPatientConfirmationPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'RecommendationMembersForPatientFormFragmentFragment': RecommendationMembersForPatientFormFragmentFragment } }
);

export type AceitarPacoteServicosMutationVariables = Exact<{
  input: AceitarPacoteServicosInput;
}>;


export type AceitarPacoteServicosMutation = { __typename?: 'mutation_root', aceitarPacoteServicos: { __typename?: 'AceitarPacoteServicosPayload', aceitarPacoteServicosOutput?: { __typename?: 'AceitarPacoteServicosOutput', codPacoteServicos: number, codUsuario: number } | null, errors?: Array<{ __typename: 'ValidationError', message: string }> | null } };

export type AssistProAcceptanceCostPredictionCardFragmentFragment = { __typename?: 'query_root', servicePackage?: { __typename?: 'pacotesServicos', pacotesServicosPreco?: { __typename?: 'pacoteServicoPreco', valorUnitarioFixo: number, pacotesServicosPrecosVariaveis: Array<{ __typename?: 'tbPacotesServicosPrecosVariaveis', valorUnitario: number, codPacoteServicosPrecoVariavel: number }> } | null } | null, NuntiusGetCustomerContactManyPeriodSummary?: Array<{ __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', totalDigitalCustomerContacts: number, totalHumanCustomerContacts: number }> | null } & { ' $fragmentName'?: 'AssistProAcceptanceCostPredictionCardFragmentFragment' };

export type AssistProAcceptanceCostPredictionQueryQueryVariables = Exact<{
  codPacoteServicos: Scalars['Int']['input'];
  to: Scalars['String']['input'];
  from: Scalars['String']['input'];
}>;


export type AssistProAcceptanceCostPredictionQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'AssistProAcceptanceCostPredictionCardFragmentFragment': AssistProAcceptanceCostPredictionCardFragmentFragment } }
);

export type CustomerAppointmentOverviewPageQueryQueryVariables = Exact<{
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type CustomerAppointmentOverviewPageQueryQuery = { __typename?: 'query_root', analyticsMembroRelatorioIndependente?: { __typename?: 'AnalyticsMembroRelatorioIndependente', data: Array<(
      { __typename?: 'DataItemRelatorioIndependente' }
      & { ' $fragmentRefs'?: { 'AppointmentDashboardTotalCancelledSectionQueryFragmentFragment': AppointmentDashboardTotalCancelledSectionQueryFragmentFragment;'AppointmentDashboardCompletedAppointmentsSectionQueryFragmentFragment': AppointmentDashboardCompletedAppointmentsSectionQueryFragmentFragment;'AppointmentDashboardNoShowSectionQueryFragmentFragment': AppointmentDashboardNoShowSectionQueryFragmentFragment;'AppointmentDashboardLatePatientsSectionQueryFragmentFragment': AppointmentDashboardLatePatientsSectionQueryFragmentFragment;'AppointmentDashboardTotalSchedulesPerAppointmentReceivingOptionsQueryFragmentFragment': AppointmentDashboardTotalSchedulesPerAppointmentReceivingOptionsQueryFragmentFragment } }
    ) | null> } | null };

export type CustomerContactOverviewPageQueryQueryVariables = Exact<{
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type CustomerContactOverviewPageQueryQuery = { __typename?: 'query_root', NuntiusGetCustomerContactManyPeriodSummary?: Array<(
    { __typename?: 'NuntiusGetCustomerContactManyPeriodSummaryOutput', period: string }
    & { ' $fragmentRefs'?: { 'CustomerContactDashboardTotalContactsSectionQueryFragmentFragment': CustomerContactDashboardTotalContactsSectionQueryFragmentFragment;'CustomerContactDashboardContactsDistributionSectionQueryFragmentFragment': CustomerContactDashboardContactsDistributionSectionQueryFragmentFragment;'CustomerContactDashboardSchedulingConversionRateSectionQueryFragmentFragment': CustomerContactDashboardSchedulingConversionRateSectionQueryFragmentFragment;'CustomerContactDashboardReasonsForNotSchedulingSectionQueryFragmentFragment': CustomerContactDashboardReasonsForNotSchedulingSectionQueryFragmentFragment;'CustomerContactDashboardHumanContactsSectionQueryFragmentFragment': CustomerContactDashboardHumanContactsSectionQueryFragmentFragment;'CustomerContactDashboardContactReasonSectionQueryFragmentFragment': CustomerContactDashboardContactReasonSectionQueryFragmentFragment;'CustomerContactDashboardContactByTypeSectionQueryFragmentFragment': CustomerContactDashboardContactByTypeSectionQueryFragmentFragment;'CustomerContactDashboardContactSummarySectionQueryFragmentFragment': CustomerContactDashboardContactSummarySectionQueryFragmentFragment } }
  )> | null };

export type NuntiusGetCustomerContactPeriodSummaryQueryVariables = Exact<{
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type NuntiusGetCustomerContactPeriodSummaryQuery = { __typename?: 'query_root', NuntiusGetCustomerContactPeriodSummary?: { __typename?: 'NuntiusGetCustomerContactPeriodSummaryOutput', totalCustomerContacts: number, totalCustomers: number, totalOldCustomers: number, percentOldCustomers: number, totalNewCustomers: number, percentNewCustomers: number, mostFrequentMainReasonId?: number | null, totalMostFrequentMainReason: number, percentMostFrequentMainReason: number, totalCustomerContactsNewAppointmentMainReason: number, totalCustomerContactsAppointmentsScheduled: number, percentCustomerContactsAppointmentsScheduled: number, mostFrequentNotScheduledAppointmentReasonsIds: Array<number>, totalAllocatedRooms: number, totalAllocatedRoomsOnPeriod: number } | null };

export type FollowUpAppointmentReminderPageQueryQueryVariables = Exact<{
  codTipoLembreteRetorno: Scalars['Int']['input'];
  hoje: Scalars['datetime2']['input'];
}>;


export type FollowUpAppointmentReminderPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'FollowUpAppointmentReminderListQueryFragment': FollowUpAppointmentReminderListQueryFragment } }
);

export type FollowUpAppointmentReminderPatientsPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FollowUpAppointmentReminderPatientsPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'PatientListQueryFragmentFragment': PatientListQueryFragmentFragment } }
);

export type RescuedAppointmentOverviewPageQueryQueryVariables = Exact<{
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type RescuedAppointmentOverviewPageQueryQuery = { __typename?: 'query_root', rescuedAppointments?: (
    { __typename?: 'AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo' }
    & { ' $fragmentRefs'?: { 'RescuedAppointmentsSectionQueryFragmentFragment': RescuedAppointmentsSectionQueryFragmentFragment;'RescuedAppointmentDashboardTotalRescuedSectionQueryFragmentFragment': RescuedAppointmentDashboardTotalRescuedSectionQueryFragmentFragment;'RescuedAppointmentDashboardUnscheduledAppointmentsSectionQueryFragmentFragment': RescuedAppointmentDashboardUnscheduledAppointmentsSectionQueryFragmentFragment;'RescuedAppointmentDashboardCancelledAppointmentsSectionQueryFragmentFragment': RescuedAppointmentDashboardCancelledAppointmentsSectionQueryFragmentFragment;'RescuedAppointmentDashboardNoShowAppointmentsSectionQueryFragmentFragment': RescuedAppointmentDashboardNoShowAppointmentsSectionQueryFragmentFragment } }
  ) | null };

export type GetSecretaryAppointmentInfosQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSecretaryAppointmentInfosQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'AppointmentInfosFormFragmentFragment': AppointmentInfosFormFragmentFragment } }
);

export type GetSecretaryDetailsFaqQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSecretaryDetailsFaqQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'SecretaryDetailsFaqFormFragmentFragment': SecretaryDetailsFaqFormFragmentFragment } }
);

export type GetSecretaryDetailsPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSecretaryDetailsPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'PersonalizeAppointmentFormFragmentFragment': PersonalizeAppointmentFormFragmentFragment } }
);

export type GetSecretaryProfessionalInfosQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSecretaryProfessionalInfosQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'SecretaryDetailsProfessionalInfosFormFragmentFragment': SecretaryDetailsProfessionalInfosFormFragmentFragment } }
);

export type GetSecretaryRestrictionsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSecretaryRestrictionsQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'SecretaryDetailsRestrictionsFormFragmentFragment': SecretaryDetailsRestrictionsFormFragmentFragment } }
);

export type ServicePackagesQueryQueryVariables = Exact<{
  codPacoteServico: Scalars['Int']['input'];
}>;


export type ServicePackagesQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'ServicePackagesFragmentFragment': ServicePackagesFragmentFragment } }
);

export type SubscribeAssistProConfirmPageQueryQueryVariables = Exact<{
  codPacoteServico: Scalars['Int']['input'];
}>;


export type SubscribeAssistProConfirmPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'SubscribeAssistProSubscriptionConfirmCardFragmentFragment': SubscribeAssistProSubscriptionConfirmCardFragmentFragment } }
);

export type SubscribedAssistProQueryQueryVariables = Exact<{
  codPacoteServicos: Scalars['Int']['input'];
}>;


export type SubscribedAssistProQueryQuery = { __typename?: 'query_root', servicePackage?: { __typename?: 'pacotesServicos', pacotesServicosPreco?: (
      { __typename?: 'pacoteServicoPreco' }
      & { ' $fragmentRefs'?: { 'SubscribedAssistFragmentFragment': SubscribedAssistFragmentFragment } }
    ) | null } | null };

export type UpsertPhonePageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UpsertPhonePageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'UpsertPublicPhoneFragmentFragment': UpsertPublicPhoneFragmentFragment } }
);

export type UserTrackableLinksDetailsPageQueryQueryVariables = Exact<{
  userTrackableLinkId: Scalars['Int']['input'];
}>;


export type UserTrackableLinksDetailsPageQueryQuery = { __typename?: 'query_root', userTrackableLink?: (
    { __typename?: 'usuariosLinksRastreamentos', nome: string }
    & { ' $fragmentRefs'?: { 'UserTrackableLinksDetailsDescriptionFragmentFragment': UserTrackableLinksDetailsDescriptionFragmentFragment;'UserTrackableLinksDetailsLinkInputFragmentFragment': UserTrackableLinksDetailsLinkInputFragmentFragment;'UserTrackableLinksDetailsActionsFragmentFragment': UserTrackableLinksDetailsActionsFragmentFragment } }
  ) | null };

export type UserTrackableLinkReportPageQueryQueryVariables = Exact<{
  userTrackableLinkId: Scalars['Int']['input'];
}>;


export type UserTrackableLinkReportPageQueryQuery = { __typename?: 'query_root', userTrackableLink?: (
    { __typename?: 'usuariosLinksRastreamentos', codLinkRastreamento: string, dataCadastro: string }
    & { ' $fragmentRefs'?: { 'UserTrackableLinkReportDetailSummaryFragmentFragment': UserTrackableLinkReportDetailSummaryFragmentFragment } }
  ) | null };

export type UserTrackableLinksQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTrackableLinksQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'UserTrackableLinksQueryFragmentFragment': UserTrackableLinksQueryFragmentFragment } }
);

export type BillingDetailsQueryQueryVariables = Exact<{
  billingItemId: Scalars['Int']['input'];
}>;


export type BillingDetailsQueryQuery = { __typename?: 'query_root', billingItem?: (
    { __typename?: 'MovimentacaoExibicao' }
    & { ' $fragmentRefs'?: { 'BillingItemDetailsQueryFragmentFragment': BillingItemDetailsQueryFragmentFragment } }
  ) | null };

export type AllocationDetailsQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type AllocationDetailsQueryQuery = { __typename?: 'query_root', allocation?: (
    { __typename?: 'AlocacaoDetalhada' }
    & { ' $fragmentRefs'?: { 'AllocationDetailsQueryFragmentFragment': AllocationDetailsQueryFragmentFragment } }
  ) | null };

export type AppointmentDetailsQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type AppointmentDetailsQueryQuery = { __typename?: 'query_root', appointment?: (
    { __typename?: 'agendamentos' }
    & { ' $fragmentRefs'?: { 'AppointmentDetailsQueryFragmentFragment': AppointmentDetailsQueryFragmentFragment } }
  ) | null };

export type AssistBillingBatchQueryQueryVariables = Exact<{
  billingItemId: Scalars['Int']['input'];
}>;


export type AssistBillingBatchQueryQuery = { __typename?: 'query_root', assistBillingBatch: Array<(
    { __typename?: 'nuntius_lote_contatos_cobranca' }
    & { ' $fragmentRefs'?: { 'AssistBillingBatchQueryFragmentFragment': AssistBillingBatchQueryFragmentFragment } }
  )>, servicePackagePrices: Array<(
    { __typename?: 'pacoteServicoPreco' }
    & { ' $fragmentRefs'?: { 'AssistBillingBatchVariablePricesFragmentFragment': AssistBillingBatchVariablePricesFragmentFragment } }
  )> };

export type CommunityPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'CommunityFilterDrawerQueryFragmentFragment': CommunityFilterDrawerQueryFragmentFragment } }
);

export type BankAccountPageQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codClinica?: Scalars['Int']['input'];
}>;


export type BankAccountPageQueryQuery = (
  { __typename?: 'query_root', ExpensumGetRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', bankAccounts?: Array<{ __typename?: 'ExpensumBankAccount', pagarmeId?: string | null } | null> | null } | null } | null }
  & { ' $fragmentRefs'?: { 'BankAccountDetailsQueryFragmentFragment': BankAccountDetailsQueryFragmentFragment } }
);

export type BankAccountUpdatePageQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codClinica?: Scalars['Int']['input'];
}>;


export type BankAccountUpdatePageQueryQuery = (
  { __typename?: 'query_root', ExpensumGetRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', bankAccounts?: Array<{ __typename?: 'ExpensumBankAccount', pagarmeId?: string | null } | null> | null } | null } | null }
  & { ' $fragmentRefs'?: { 'BankAccountFormQueryFragmentFragment': BankAccountFormQueryFragmentFragment } }
);

export type CreatePaymentPageQueryQueryVariables = Exact<{
  appointmentId: Scalars['Int']['input'];
  patientId: Scalars['Int']['input'];
}>;


export type CreatePaymentPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'CreatePaymentFormFragmentFragment': CreatePaymentFormFragmentFragment } }
);

export type EvolutionChartsPageQueryQueryVariables = Exact<{
  paymentsInput: ExpensumGetPaymentsChartsInfoInput;
  payablesInput: ExpensumGetPayablesChartsInfoInput;
}>;


export type EvolutionChartsPageQueryQuery = { __typename?: 'query_root', ExpensumGetPaymentsChartsInfo: (
    { __typename?: 'ExpensumGetPaymentsChartsInfoOutput' }
    & { ' $fragmentRefs'?: { 'PaymentsStatusChartFragmentFragment': PaymentsStatusChartFragmentFragment;'PaymentsOriginChartFragmentFragment': PaymentsOriginChartFragmentFragment } }
  ), ExpensumGetPayablesChartsInfo: (
    { __typename?: 'ExpensumGetPayablesChartsInfoOutput' }
    & { ' $fragmentRefs'?: { 'PayablesStatusChartFragmentFragment': PayablesStatusChartFragmentFragment } }
  ) };

export type GetOnlinePaymentByGuidQueryVariables = Exact<{
  guid: Scalars['uuid']['input'];
}>;


export type GetOnlinePaymentByGuidQuery = { __typename?: 'query_root', onlinePayment: Array<{ __typename?: 'expensum_online_payment', guid: any }> };

export type PatientPaymentDetailsPageQueryVariables = Exact<{
  onlinePaymentGuid?: InputMaybe<Scalars['String']['input']>;
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PatientPaymentDetailsPageQuery = { __typename?: 'query_root', ExpensumPaymentDetails?: (
    { __typename?: 'ExpensumPaymentDetailsOutput' }
    & { ' $fragmentRefs'?: { 'PatientPaymentDetailsFragmentFragment': PatientPaymentDetailsFragmentFragment } }
  ) | null };

export type PatientsPaymentsQueryQueryVariables = Exact<{
  intervalStart: Scalars['String']['input'];
  intervalEnd: Scalars['String']['input'];
  codClinica?: InputMaybe<Scalars['Int']['input']>;
  origins?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PatientsPaymentsQueryQuery = { __typename?: 'query_root', patientPayments?: (
    { __typename?: 'ExpensumGetPaymentsOutput', totalAmount: number }
    & { ' $fragmentRefs'?: { 'PatientPaymentsListFragmentFragment': PatientPaymentsListFragmentFragment } }
  ) | null };

export type RefundReceiptPageQueryQueryVariables = Exact<{
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
  onlinePaymentGuid?: InputMaybe<Scalars['String']['input']>;
}>;


export type RefundReceiptPageQueryQuery = { __typename?: 'query_root', ExpensumGetRefundReceipt?: (
    { __typename?: 'ExpensumGetRefundReceiptOutput', receipt?: { __typename?: 'ExpensumRefundReceipt', transactionId?: string | null } | null }
    & { ' $fragmentRefs'?: { 'RefundReceiptDetailsQueryFragmentFragment': RefundReceiptDetailsQueryFragmentFragment } }
  ) | null };

export type PatientPaymentRefundPageQueryVariables = Exact<{
  onlinePaymentGuid?: InputMaybe<Scalars['String']['input']>;
  codAgendamento?: InputMaybe<Scalars['Int']['input']>;
  codUsuario: Scalars['Int']['input'];
  codClinica?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PatientPaymentRefundPageQuery = (
  { __typename?: 'query_root', ExpensumPaymentDetails?: { __typename?: 'ExpensumPaymentDetailsOutput', status: string } | null }
  & { ' $fragmentRefs'?: { 'RefundDetailsQueryFragmentFragment': RefundDetailsQueryFragmentFragment } }
);

export type ExpensumPayablesV2QueryQueryVariables = Exact<{
  input: ExpensumGetPayablesV2Input;
}>;


export type ExpensumPayablesV2QueryQuery = { __typename?: 'query_root', ExpensumGetPayablesV2?: { __typename?: 'ExpensumGetPayablesV2Output', data: Array<{ __typename?: 'ExpensumPayablesV2', date: string, totalAmount: number, payables: Array<{ __typename?: 'PagarmePayableV2', accrualAt?: string | null, amount?: number | null, status?: string | null, type?: string | null, paymentDate?: string | null, paymentMethod?: string | null, recipientId?: string | null, createdAt?: string | null, installment?: number | null, gatewayId?: number | null, patientName?: string | null, installments?: number | null, originPaymentType?: string | null, appointmentDate?: string | null, appointmentStart?: string | null, paymentCreatedAt?: string | null } | null> } | null> } | null };

export type TermsOfServiceQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codClinica?: InputMaybe<Scalars['Int']['input']>;
}>;


export type TermsOfServiceQueryQuery = { __typename?: 'query_root', expensum_terms_of_use: Array<{ __typename?: 'expensum_terms_of_use', urlTerms?: string | null, id: number }>, ExpensumGetRecipient?: { __typename?: 'ExpensumGetRecipientOutput', recipient?: { __typename?: 'ExpensumRecipient', id?: number | null } | null } | null };

export type InsertRecipientTermsOfUseMutationVariables = Exact<{
  objects?: InputMaybe<Array<Expensum_Recipient_Terms_Of_Use_Agreed_Insert_Input> | Expensum_Recipient_Terms_Of_Use_Agreed_Insert_Input>;
}>;


export type InsertRecipientTermsOfUseMutation = { __typename?: 'mutation_root', insert_expensum_recipient_terms_of_use_agreed?: { __typename?: 'expensum_recipient_terms_of_use_agreed_mutation_response', affected_rows: number } | null };

export type CardManagementPageQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
}>;


export type CardManagementPageQueryQuery = (
  { __typename?: 'query_root', usuariosProfissionais?: { __typename?: 'usuariosProfissionais', formaDePagamento: string } | null, usuariosCartoes: Array<{ __typename?: 'usuariosCartoes', ativo: boolean }> }
  & { ' $fragmentRefs'?: { 'CardDetailsQueryFragmentFragment': CardDetailsQueryFragmentFragment } }
);

export type ChangePlanPageQueryQueryVariables = Exact<{
  currentDate: Scalars['datetime2']['input'];
}>;


export type ChangePlanPageQueryQuery = (
  { __typename?: 'query_root', usuarioPlano: Array<{ __typename?: 'usuariosProfissionaisPlanos', dataInicio: string, plano: { __typename?: 'planos', codPlano: number, codTipoMovimentacao?: number | null, nome: string, valor: number, temFidelidade: boolean, nomeExibicao: string, descricao?: string | null, tipoPlano: string, duracaoFidelidadeEmMeses: number, carenciaEmMeses: number, migravel: boolean } }>, usuarioPlanoMovimentacoesRecorrentes: Array<{ __typename?: 'usuariosProfissionaisPlanos', plano: { __typename?: 'planos', tipoMovimentacao?: { __typename?: 'tiposMovimentacoes', usuariosMovimentacoesRecorrentes: Array<{ __typename?: 'usuariosMovimentacoesRecorrentes', codUsuarioMovimentacaoRecorrente: number }> } | null } }>, usuarioPlanoFuturo: Array<{ __typename?: 'usuariosProfissionaisPlanos', dataInicio: string, plano: { __typename?: 'planos', nomeExibicao: string } }>, planos: Array<{ __typename?: 'planos', codPlano: number, nome: string, valor: number, temFidelidade: boolean, nomeExibicao: string, descricao?: string | null, tipoPlano: string, duracaoFidelidadeEmMeses: number, carenciaEmMeses: number, migravel: boolean }>, usuariosProfissionais: Array<{ __typename?: 'usuariosProfissionais', dataValidacao?: string | null, diaVencimento?: number | null }>, usuariosEspecialidades: Array<{ __typename?: 'usuariosEspecialidades', codEspecialidade: number }>, planosMigracoes: Array<{ __typename?: 'planosMigracoes', codPlanoDestino: number, codPlanoOrigem: number }> }
  & { ' $fragmentRefs'?: { 'CurrentPlanCardFragmentFragment': CurrentPlanCardFragmentFragment;'ChangePlanAlertFragmentFragment': ChangePlanAlertFragmentFragment } }
);

export type LivanceApiUsuarioPlanoMigracaoMutationVariables = Exact<{
  input: LivanceApiUsuarioPlanoMigracaoInput;
}>;


export type LivanceApiUsuarioPlanoMigracaoMutation = { __typename?: 'mutation_root', LivanceApiUsuarioPlanoMigracao?: { __typename?: 'LivanceApiUsuarioPlanoMigracaoOutput', codPlano: number } | null };

export type GetMovimentacoesByMovimentacaoRecorrenteQueryQueryVariables = Exact<{
  codMovimentacaoRecorrente: Scalars['Int']['input'];
}>;


export type GetMovimentacoesByMovimentacaoRecorrenteQueryQuery = { __typename?: 'query_root', tbMovimentacoes: Array<{ __typename?: 'tbMovimentacoes', codMovimentacao: number }> };

export type MyProfilePageQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  currentDate: Scalars['datetime2']['input'];
}>;


export type MyProfilePageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'MyProfileDetailsSectionFragmentFragment': MyProfileDetailsSectionFragmentFragment;'CardInfoQueryFragmentFragment': CardInfoQueryFragmentFragment;'CurrentPlanInfoFragmentFragment': CurrentPlanInfoFragmentFragment;'OneLivProfileCardFragmentFragment': OneLivProfileCardFragmentFragment;'PublicPhoneNumberFragmentFragment': PublicPhoneNumberFragmentFragment } }
);

export type ReservedScheduleIndividualCancelPageQueryQueryVariables = Exact<{
  codPeriodoGarantidoRecorrente: Scalars['Int']['input'];
  codPeriodoGarantido: Scalars['Int']['input'];
}>;


export type ReservedScheduleIndividualCancelPageQueryQuery = { __typename?: 'query_root', periodoGarantidoRecorrente?: { __typename?: 'tbPeriodosGarantidosRecorrentes', ativo: boolean, dataInicio: string, horaInicio: string, horaFim: string, diaDaSemana: number, Unidade: { __typename?: 'unidades', nomeLimpo?: string | null, codUnidade: number } } | null, periodoGarantido?: { __typename?: 'tbPeriodosGarantidos', ativo: boolean, codPeriodoGarantido: number, codModalidadePeriodoGarantido: number, Agendamento: { __typename?: 'agendamentos', data: string, codAgendamento: number } } | null };

export type ReservedScheduleIndividualCancelSimulationQueryQueryVariables = Exact<{
  codPeriodoGarantido: Scalars['Int']['input'];
}>;


export type ReservedScheduleIndividualCancelSimulationQueryQuery = { __typename?: 'query_root', LivanceApiSimulaCobrancaDeCancelamento?: { __typename?: 'LivanceApiSimulaCobrancaDeCancelamentoOutput', taxa?: number | null, valor?: number | null } | null };

export type CancelIndividualReservedScheduleMutationMutationVariables = Exact<{
  codPeriodoGarantido: Scalars['Int']['input'];
}>;


export type CancelIndividualReservedScheduleMutationMutation = { __typename?: 'mutation_root', LivanceApiCancelaPeriodoGarantido?: { __typename?: 'LivanceApiCancelaPeriodoGarantidoOutput', message?: string | null, success?: boolean | null } | null };

export type ReservedScheduleCancelPageQueryQueryVariables = Exact<{
  codPeriodoGarantidoRecorrente: Scalars['Int']['input'];
  dataAgendamento: Scalars['date']['input'];
  horaInicio: Scalars['time']['input'];
}>;


export type ReservedScheduleCancelPageQueryQuery = { __typename?: 'query_root', periodoGarantidoRecorrente?: { __typename?: 'tbPeriodosGarantidosRecorrentes', ativo: boolean, dataInicio: string, horaInicio: string, horaFim: string, diaDaSemana: number, Unidade: { __typename?: 'unidades', nomeLimpo?: string | null, codUnidade: number }, TipoSala: { __typename?: 'tiposSalas', nome: string }, PeriodosGarantidos: Array<{ __typename?: 'tbPeriodosGarantidos', codPeriodoGarantido: number, codModalidadePeriodoGarantido: number, Agendamento: { __typename?: 'agendamentos', data: string } }> } | null };

export type ReservedScheduleCancelSimulationQueryQueryVariables = Exact<{
  codPeriodoGarantido: Scalars['Int']['input'];
}>;


export type ReservedScheduleCancelSimulationQueryQuery = { __typename?: 'query_root', LivanceApiSimulaCobrancaDeCancelamento?: { __typename?: 'LivanceApiSimulaCobrancaDeCancelamentoOutput', taxa?: number | null, valor?: number | null } | null };

export type CancelReservedScheduleMutationMutationVariables = Exact<{
  codPeriodoGarantidoRecorrente: Scalars['Int']['input'];
}>;


export type CancelReservedScheduleMutationMutation = { __typename?: 'mutation_root', LivanceApiCancelaPeriodoGarantidoRecorrente?: { __typename?: 'LivanceApiCancelaPeriodoGarantidoRecorrenteOutput', message?: string | null, success?: boolean | null } | null };

export type ReservedSchedulesDetailsQueryQueryVariables = Exact<{
  dataAgendamento: Scalars['date']['input'];
  horaInicio: Scalars['time']['input'];
  codPeriodoGarantidoRecorrente: Scalars['Int']['input'];
}>;


export type ReservedSchedulesDetailsQueryQuery = { __typename?: 'query_root', periodoGarantidoRecorrente?: (
    { __typename?: 'tbPeriodosGarantidosRecorrentes', ativo: boolean, dataInicio: string, horaInicio: string, horaFim: string, diaDaSemana: number, Unidade: { __typename?: 'unidades', nomeLimpo?: string | null }, PeriodosGarantidosRecorrentesFrequencia: { __typename?: 'tbPeriodosGarantidosRecorrentesFrequencias', descricao: string }, TipoSala: { __typename?: 'tiposSalas', nome: string } }
    & { ' $fragmentRefs'?: { 'ReservedSchedulesNextSchedulesFragmentFragment': ReservedSchedulesNextSchedulesFragmentFragment } }
  ) | null };

export type GetReservedSchedulePriceQueryQueryVariables = Exact<{
  codModalidadePeriodoGarantido: Scalars['Int']['input'];
  codTipoSala: Scalars['Int']['input'];
  codUnidade: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  duracao: Scalars['String']['input'];
}>;


export type GetReservedSchedulePriceQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'GetReservedSchedulePriceFragmentFragment': GetReservedSchedulePriceFragmentFragment } }
);

export type HasUserAcceptedTermsOfUseQueryQueryVariables = Exact<{
  codTipoTermoDeUso: Scalars['Int']['input'];
}>;


export type HasUserAcceptedTermsOfUseQueryQuery = { __typename?: 'query_root', tbUsuariosTermosDeUso: Array<{ __typename?: 'tbUsuariosTermosDeUso', codTermosDeUso: number, codUsuario: number, ativo: boolean, dataCadastro: string, codTipoTermoDeUso: number, dataUltimaAtualizacao: string }> };

export type GetLocationsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'GetLocationsFragmentFragment': GetLocationsFragmentFragment } }
);

export type GetReservedSchedulesSlotsQueryQueryVariables = Exact<{
  duracao: Scalars['String']['input'];
  diaDaSemana: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  codUnidade: Scalars['Int']['input'];
  codTipoSala: Scalars['Int']['input'];
  codModalidadePeriodoGarantido: Scalars['Int']['input'];
  codPeriodoGarantidoRecorrenteFrequencia: Scalars['Int']['input'];
}>;


export type GetReservedSchedulesSlotsQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'ReservedSchedulesSlotsFragmentFragment': ReservedSchedulesSlotsFragmentFragment } }
);

export type GetPeriodosGarantidosRecorrentesDoUsuarioQueryVariables = Exact<{
  dataAgendamento: Scalars['date']['input'];
  horaInicio: Scalars['time']['input'];
}>;


export type GetPeriodosGarantidosRecorrentesDoUsuarioQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'ReservedScheduleListQueryFragmentFragment': ReservedScheduleListQueryFragmentFragment } }
);

export type UpsertTermsOfUseMutationMutationVariables = Exact<{
  IP: Scalars['String']['input'];
  codTipoTermoDeUso: Scalars['Int']['input'];
  codUsuario: Scalars['Int']['input'];
  dataUltimaAtualizacao: Scalars['datetime2']['input'];
  ativo?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpsertTermsOfUseMutationMutation = { __typename?: 'mutation_root', insert_tbUsuariosTermosDeUso_one?: { __typename?: 'tbUsuariosTermosDeUso', codTermosDeUso: number, codUsuario: number, codTipoTermoDeUso: number, dataCadastro: string, dataUltimaAtualizacao: string, ativo: boolean } | null };

export type AppointmentReceivingOptionPageQueryQueryVariables = Exact<{
  codUsuarioFormaRecebimento?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AppointmentReceivingOptionPageQueryQuery = (
  { __typename?: 'query_root', formaRecebimento?: { __typename?: 'usuariosFormasRecebimentos', codUsuarioFormaRecebimento: number, sistema: boolean } | null }
  & { ' $fragmentRefs'?: { 'AppointmentReceivingOptionsFormQueryFragmentFragment': AppointmentReceivingOptionsFormQueryFragmentFragment } }
);

export type DeleteAppointmentReceivingOptionMutationVariables = Exact<{
  input: Scalars['Int']['input'];
}>;


export type DeleteAppointmentReceivingOptionMutation = { __typename?: 'mutation_root', LivanceApiDeleteUsuarioFormaRecebimento: any };

export type AppointmentReceivingOptionsCreatePageQueryQueryVariables = Exact<{
  codUsuarioFormaRecebimento: Scalars['Int']['input'];
}>;


export type AppointmentReceivingOptionsCreatePageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'AppointmentReceivingOptionsFormQueryFragmentFragment': AppointmentReceivingOptionsFormQueryFragmentFragment } }
);

export type AppointmentReceivingOptionsPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AppointmentReceivingOptionsPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'AppointmentReceivingOptionsListQueryFragmentFragment': AppointmentReceivingOptionsListQueryFragmentFragment } }
);

export type GetAppointmentTypeEditPageQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
}>;


export type GetAppointmentTypeEditPageQueryQuery = (
  { __typename?: 'query_root', appointmentType?: { __typename?: 'usuariosCompromissos', sistema: boolean, ativo: boolean, category: { __typename?: 'usuariosCompromissosCategorias', codUsuarioCompromissoCategoria: number } } | null }
  & { ' $fragmentRefs'?: { 'GetAppointmentTypeFormQueryFragmentFragment': GetAppointmentTypeFormQueryFragmentFragment } }
);

export type DeleteAppointmentTypeMutationVariables = Exact<{
  input: LivanceApiDeleteUsuarioCompromissoInput;
}>;


export type DeleteAppointmentTypeMutation = { __typename?: 'mutation_root', LivanceApiDeleteUsuarioCompromisso: any };

export type GetAppointmentTypeCreatePageQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codUsuarioCompromisso: Scalars['Int']['input'];
}>;


export type GetAppointmentTypeCreatePageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'GetAppointmentTypeFormQueryFragmentFragment': GetAppointmentTypeFormQueryFragmentFragment } }
);

export type AppointmentTypesPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AppointmentTypesPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'AppointmentTypeListQueryFragmentFragment': AppointmentTypeListQueryFragmentFragment } }
);

export type EditSchedulePageQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codUsuarioAgenda?: Scalars['Int']['input'];
}>;


export type EditSchedulePageQueryQuery = (
  { __typename?: 'query_root', schedules: Array<{ __typename?: 'usuariosAgendas', codUsuarioAgenda: number }> }
  & { ' $fragmentRefs'?: { 'ScheduleFormQueryFragmentFragment': ScheduleFormQueryFragmentFragment } }
);

export type DeleteScheduleMutationMutationVariables = Exact<{
  input: LivanceApiDeleteUsuarioAgendaInput;
}>;


export type DeleteScheduleMutationMutation = { __typename?: 'mutation_root', LivanceApiDeleteUsuarioAgenda: any };

export type CreateSchedulePageQueryQueryVariables = Exact<{
  codUsuario: Scalars['Int']['input'];
  codUsuarioAgenda?: Scalars['Int']['input'];
}>;


export type CreateSchedulePageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'ScheduleFormQueryFragmentFragment': ScheduleFormQueryFragmentFragment } }
);

export type SchedulesPageQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SchedulesPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'SchedulesListQueryFragmentFragment': SchedulesListQueryFragmentFragment } }
);

export type ChangeTimeConfirmPageQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type ChangeTimeConfirmPageQueryQuery = { __typename?: 'query_root', agendamento?: (
    { __typename?: 'agendamentos', cancelado: boolean }
    & { ' $fragmentRefs'?: { 'ChangeTimeConfirmFragmentFragment': ChangeTimeConfirmFragmentFragment } }
  ) | null };

export type ChangeTimeMinutesPageQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type ChangeTimeMinutesPageQueryQuery = { __typename?: 'query_root', agendamento?: (
    { __typename?: 'agendamentos', horaInicio: string, cancelado: boolean }
    & { ' $fragmentRefs'?: { 'ChangeTimeMinutesFragmentFragment': ChangeTimeMinutesFragmentFragment } }
  ) | null };

export type WaitingRoomAppointmentMenuQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type WaitingRoomAppointmentMenuQueryQuery = { __typename?: 'query_root', agendamento?: (
    { __typename?: 'agendamentos' }
    & { ' $fragmentRefs'?: { 'WaitingRoomAppointmentMenuFragmentFragment': WaitingRoomAppointmentMenuFragmentFragment } }
  ) | null };

export type ReceiveRoomNowQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type ReceiveRoomNowQueryQuery = { __typename?: 'query_root', agendamento?: (
    { __typename?: 'agendamentos' }
    & { ' $fragmentRefs'?: { 'ReceiveRoomNowFragmentFragment': ReceiveRoomNowFragmentFragment } }
  ) | null };

export type SendPaymentPageQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
}>;


export type SendPaymentPageQueryQuery = { __typename?: 'query_root', agendamento?: (
    { __typename?: 'agendamentos', pago: boolean }
    & { ' $fragmentRefs'?: { 'SendPaymentFormFragmentFragment': SendPaymentFormFragmentFragment } }
  ) | null };

export type FollowUpAppointmentReminderPageCreateQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
  canalAgendamentoPaciente: Scalars['Int']['input'];
  categoriaPeriodoGarantido: Scalars['Int']['input'];
  dataInicio: Scalars['date']['input'];
}>;


export type FollowUpAppointmentReminderPageCreateQueryQuery = (
  { __typename?: 'query_root', appointment?: (
    { __typename?: 'agendamentos', nome?: string | null, Usuario?: { __typename?: 'usuarios', apelido?: string | null, nome: string, sobrenome: string } | null, UsuarioCompromisso?: { __typename?: 'usuariosCompromissos', nome: string } | null }
    & { ' $fragmentRefs'?: { 'FollowUpAppointmentReminderMessageDrawerFragmentFragment': FollowUpAppointmentReminderMessageDrawerFragmentFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'FollowUpAppointmentReminderFormFragmentFragment': FollowUpAppointmentReminderFormFragmentFragment } }
);

export type FollowUpAppointmentReminderPatientAppointmentQueryQueryVariables = Exact<{
  patientId: Scalars['Int']['input'];
  today: Scalars['datetime2']['input'];
}>;


export type FollowUpAppointmentReminderPatientAppointmentQueryQuery = { __typename?: 'query_root', patientAppointments: Array<{ __typename?: 'pacientes', Agendamentos: Array<(
      { __typename?: 'agendamentos', codAgendamento: number, codPaciente?: number | null, nome?: string | null, Usuario?: { __typename?: 'usuarios', apelido?: string | null, nome: string, sobrenome: string } | null, UsuarioCompromisso?: { __typename?: 'usuariosCompromissos', nome: string } | null, reminders: Array<{ __typename?: 'lembretes', codAgendamento: number }> }
      & { ' $fragmentRefs'?: { 'FollowUpAppointmentReminderMessageDrawerFragmentFragment': FollowUpAppointmentReminderMessageDrawerFragmentFragment } }
    )> }> };

export type FollowUpAppointmentReminderPatientQueryQueryVariables = Exact<{
  codAgendamento: Scalars['Int']['input'];
  canalAgendamentoPaciente: Scalars['Int']['input'];
  categoriaPeriodoGarantido: Scalars['Int']['input'];
  dataInicio: Scalars['date']['input'];
}>;


export type FollowUpAppointmentReminderPatientQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'FollowUpAppointmentReminderFormFragmentFragment': FollowUpAppointmentReminderFormFragmentFragment } }
);

export type WaitingRoomPageQueryQueryVariables = Exact<{
  whereBuild: Agendamentos_Bool_Exp;
}>;


export type WaitingRoomPageQueryQuery = (
  { __typename?: 'query_root' }
  & { ' $fragmentRefs'?: { 'WaitingRoomAppointmentListQueryFragmentFragment': WaitingRoomAppointmentListQueryFragmentFragment;'WaitingRoomFilterButtonFragmentFragment': WaitingRoomFilterButtonFragmentFragment } }
);

export const AppointmentChannelsListToMultiSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentChannelsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"canaisAgendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCanalAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentChannelsListToMultiSelectQueryFragmentFragment, unknown>;
export const AppointmentChannelsListToMultiSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentChannelsListToMultiSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canaisAgendamentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentChannelsListToMultiSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentChannelsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"canaisAgendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCanalAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentChannelsListToMultiSelectTestQueryFragmentFragment, unknown>;
export const AppointmentDrawerOnlinePaymentButtonFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDrawerOnlinePaymentButtonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"pagar"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentosVinculados"},"name":{"kind":"Name","value":"AgendamentosVinculados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoTipoVinculo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentDrawerOnlinePaymentButtonFragmentFragment, unknown>;
export const AppointmentDrawerPatientContactActionsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDrawerPatientContactActionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]} as unknown as DocumentNode<AppointmentDrawerPatientContactActionsFragmentFragment, unknown>;
export const PatientAvatarFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<PatientAvatarFragmentFragment, unknown>;
export const AppointmentDrawerPatientInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDrawerPatientInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentDrawerPatientInfoFragmentFragment, unknown>;
export const AppointmentFlexiblePriceFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentFlexiblePriceFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"unidadesPrecosFlexiveis"},"name":{"kind":"Name","value":"UnidadesPrecosFlexiveis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxaDesconto"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"unidades_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"periodosGarantidos"},"name":{"kind":"Name","value":"tbPeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"horaFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UsuariosCompromissosTiposSalas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}}]}}]}}]} as unknown as DocumentNode<AppointmentFlexiblePriceFormFragmentFragment, unknown>;
export const AppointmentTypesListToSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentTypesListToSelectQueryFragmentFragment, unknown>;
export const PaymentMethodsListToSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosFormasRecebimentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<PaymentMethodsListToSelectQueryFragmentFragment, unknown>;
export const UnitsListToSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<UnitsListToSelectQueryFragmentFragment, unknown>;
export const AppointmentFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasCompromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"3"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuarioCompromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosCompromissosFormasRecebimentos"},"name":{"kind":"Name","value":"tbUsuariosCompromissosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethodsListToSelectQueryFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioAgenda"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Unidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasDiasSemanas"},"name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosFormasRecebimentosAggregate"},"name":{"kind":"Name","value":"usuariosFormasRecebimentos_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalidadesAgendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"3"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobrancaAtraso"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosFormasRecebimentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentFormFragmentFragment, unknown>;
export const AppointmentFormPatientFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentFormPatientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentType"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}},{"kind":"Field","name":{"kind":"Name","value":"tiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unidadesPrecosFlexiveis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadesPrecosFlexiveisParceirosIntegracoes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"unidades_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]} as unknown as DocumentNode<AppointmentFormPatientFragmentFragment, unknown>;
export const AppointmentPatientSwapFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentPatientSwapFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneProprio"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioWhatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"UsuariosCompromissosTiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentPatientSwapFormFragmentFragment, unknown>;
export const HealthInsurancesListToSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposConvenios"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<HealthInsurancesListToSelectQueryFragmentFragment, unknown>;
export const HealthInsurancePlansListToSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancePlansListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposPlanos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<HealthInsurancePlansListToSelectQueryFragmentFragment, unknown>;
export const AppointmentReceivingOptionsFormQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentReceivingOptionsFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"formaRecebimento"},"name":{"kind":"Name","value":"usuariosFormasRecebimentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"sistema"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposConvenios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HealthInsurancesListToSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposPlanos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HealthInsurancePlansListToSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposConvenios"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancePlansListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposPlanos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentReceivingOptionsFormQueryFragmentFragment, unknown>;
export const AppointmentReceivingOptionsListQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentReceivingOptionsListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tipoPlano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentReceivingOptionsListQueryFragmentFragment, unknown>;
export const PaymentMethodsListToMultiSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosFormasRecebimentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<PaymentMethodsListToMultiSelectQueryFragmentFragment, unknown>;
export const AppointmentTypeModalitiesListToSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeModalitiesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissosModalidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentTypeModalitiesListToSelectQueryFragmentFragment, unknown>;
export const RoomTypesListQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomTypesListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposSalas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<RoomTypesListQueryFragmentFragment, unknown>;
export const GetAppointmentTypeFormQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetAppointmentTypeFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentType"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"informacoesPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"sistema"}},{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}},{"kind":"Field","alias":{"kind":"Name","value":"modality"},"name":{"kind":"Name","value":"usuariosCompromissosModalidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentChannels"},"name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCanalAgendamento"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"roomTypes"},"name":{"kind":"Name","value":"tiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"paymentReceiptMethods"},"name":{"kind":"Name","value":"tbUsuariosCompromissosFormasRecebimentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"category"},"name":{"kind":"Name","value":"usuariosCompromissosCategoria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoCategoria"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethodsListToMultiSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canaisAgendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentChannelsListToMultiSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissosModalidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypeModalitiesListToSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposSalas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"alocavel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"IntValue","value":"4"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomTypesListQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}},{"kind":"Field","name":{"kind":"Name","value":"Especialidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosFormasRecebimentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentChannelsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"canaisAgendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCanalAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeModalitiesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissosModalidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomTypesListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposSalas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<GetAppointmentTypeFormQueryFragmentFragment, unknown>;
export const AppointmentTypeListItemQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"tbUsuariosCompromissosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentTypeListItemQueryFragmentFragment, unknown>;
export const AppointmentTypeListQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"3"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypeListItemQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"tbUsuariosCompromissosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentTypeListQueryFragmentFragment, unknown>;
export const AppointmentTypeModalitiesListToSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeModalitiesListToSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissosModalidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypeModalitiesListToSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeModalitiesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissosModalidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentTypeModalitiesListToSelectTestQueryFragmentFragment, unknown>;
export const AppointmentTypesListToMultiSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentTypesListToMultiSelectQueryFragmentFragment, unknown>;
export const AppointmentTypesListToMultiselectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToMultiselectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToMultiSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentTypesListToMultiselectTestQueryFragmentFragment, unknown>;
export const AppointmentTypesListToSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<AppointmentTypesListToSelectTestQueryFragmentFragment, unknown>;
export const AutomaticAnticipationToggleQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutomaticAnticipationToggleQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetAutomaticAnticipationSettingsByRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticAnticipationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]}}]} as unknown as DocumentNode<AutomaticAnticipationToggleQueryFragmentFragment, unknown>;
export const BankAccountDetailsQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BankAccountDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branchNumber"}},{"kind":"Field","name":{"kind":"Name","value":"branchCheckDigit"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountCheckDigit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutomaticAnticipationToggleQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutomaticAnticipationToggleQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetAutomaticAnticipationSettingsByRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticAnticipationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]}}]} as unknown as DocumentNode<BankAccountDetailsQueryFragmentFragment, unknown>;
export const BanksListToSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BanksListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GetAllBanksOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]} as unknown as DocumentNode<BanksListToSelectQueryFragmentFragment, unknown>;
export const BankAccountFormQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BankAccountFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountCheckDigit"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"banks"},"name":{"kind":"Name","value":"GetAllBanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BanksListToSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BanksListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GetAllBanksOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]} as unknown as DocumentNode<BankAccountFormQueryFragmentFragment, unknown>;
export const BanksListToSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BanksListToSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"banks"},"name":{"kind":"Name","value":"GetAllBanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BanksListToSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BanksListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GetAllBanksOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]} as unknown as DocumentNode<BanksListToSelectTestQueryFragmentFragment, unknown>;
export const AssistBillingBatchQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssistBillingBatchQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"nuntius_lote_contatos_cobranca"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contatosPorDia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCobravel"}},{"kind":"Field","name":{"kind":"Name","value":"totalDigitalCobravel"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanoCobravel"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<AssistBillingBatchQueryFragmentFragment, unknown>;
export const AssistBillingBatchVariablePricesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssistBillingBatchVariablePricesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacoteServicoPreco"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}}]} as unknown as DocumentNode<AssistBillingBatchVariablePricesFragmentFragment, unknown>;
export const BillingItemDetailsQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingItemDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MovimentacaoExibicao"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cobrado"}},{"kind":"Field","name":{"kind":"Name","value":"codCobranca"}},{"kind":"Field","name":{"kind":"Name","value":"codModalidadeFiscal"}},{"kind":"Field","name":{"kind":"Name","value":"codMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"codOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"dataVencimento"}},{"kind":"Field","name":{"kind":"Name","value":"identificacaoTipoMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"valorDesconto"}},{"kind":"Field","name":{"kind":"Name","value":"valorAcrescimo"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"tipoOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"tempoUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"quantidade"}},{"kind":"Field","name":{"kind":"Name","value":"possuiExtensao"}},{"kind":"Field","name":{"kind":"Name","value":"nomeTipoMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"nomeUnidade"}}]}}]} as unknown as DocumentNode<BillingItemDetailsQueryFragmentFragment, unknown>;
export const AllocationDetailsQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllocationDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AlocacaoDetalhada"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaFimCobrado"}},{"kind":"Field","name":{"kind":"Name","value":"horaFimDevolvido"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"partes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobranca"}},{"kind":"Field","name":{"kind":"Name","value":"tipoAlocacao"}}]}}]}}]} as unknown as DocumentNode<AllocationDetailsQueryFragmentFragment, unknown>;
export const AppointmentDetailsQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}}]} as unknown as DocumentNode<AppointmentDetailsQueryFragmentFragment, unknown>;
export const BillingListItemQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MovimentacaoExibicao"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCobranca"}},{"kind":"Field","name":{"kind":"Name","value":"codMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"codOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"quantidade"}},{"kind":"Field","name":{"kind":"Name","value":"tempoUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"tipoOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"valorDesconto"}},{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"valorAcrescimo"}},{"kind":"Field","name":{"kind":"Name","value":"nomeUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeTipoMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"identificacaoTipoMovimentacao"}}]}}]} as unknown as DocumentNode<BillingListItemQueryFragmentFragment, unknown>;
export const BillingListQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CobrancaExibicao"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCobranca"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"dataVencimento"}},{"kind":"Field","name":{"kind":"Name","value":"movimentacoes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingListItemQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MovimentacaoExibicao"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCobranca"}},{"kind":"Field","name":{"kind":"Name","value":"codMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"codOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"quantidade"}},{"kind":"Field","name":{"kind":"Name","value":"tempoUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"tipoOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"valorDesconto"}},{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"valorAcrescimo"}},{"kind":"Field","name":{"kind":"Name","value":"nomeUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeTipoMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"identificacaoTipoMovimentacao"}}]}}]} as unknown as DocumentNode<BillingListQueryFragmentFragment, unknown>;
export const UpsertPublicPhoneFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpsertPublicPhoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionais"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefonePublico"}}]}}]}}]} as unknown as DocumentNode<UpsertPublicPhoneFragmentFragment, unknown>;
export const CardDetailsQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CardDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuarioProfissional"},"name":{"kind":"Name","value":"usuariosProfissionais_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formaDePagamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosCartoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"bandeira"}},{"kind":"Field","name":{"kind":"Name","value":"numero"}},{"kind":"Field","name":{"kind":"Name","value":"validade"}}]}}]}}]} as unknown as DocumentNode<CardDetailsQueryFragmentFragment, unknown>;
export const CardInfoQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CardInfoQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosCartoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bandeira"}},{"kind":"Field","name":{"kind":"Name","value":"numero"}},{"kind":"Field","name":{"kind":"Name","value":"validade"}}]}}]}}]} as unknown as DocumentNode<CardInfoQueryFragmentFragment, unknown>;
export const ChangePlanAlertFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangePlanAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlano"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"temFidelidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}},{"kind":"Field","name":{"kind":"Name","value":"observacao"}},{"kind":"Field","name":{"kind":"Name","value":"duracaoFidelidadeEmMeses"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}}]}}]}}]} as unknown as DocumentNode<ChangePlanAlertFragmentFragment, unknown>;
export const ChangeTimeConfirmFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeTimeConfirmFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneProprio"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioWhatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpfProprio"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}}]}}]} as unknown as DocumentNode<ChangeTimeConfirmFragmentFragment, unknown>;
export const ChangeTimeMinutesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeTimeMinutesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}}]} as unknown as DocumentNode<ChangeTimeMinutesFragmentFragment, unknown>;
export const CommunityFilterDrawerQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommunityFilterDrawerQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"unidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"},{"kind":"IntValue","value":"6"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"specialties"},"name":{"kind":"Name","value":"especialidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}}]}}]}}]} as unknown as DocumentNode<CommunityFilterDrawerQueryFragmentFragment, unknown>;
export const CommunityListMapFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommunityListMapFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PerfisComunidadeConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"listaMembros"},"name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"site"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"ramal"}},{"kind":"Field","name":{"kind":"Name","value":"urlFoto"}},{"kind":"Field","name":{"kind":"Name","value":"follow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFollowing"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFollower"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"especialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]} as unknown as DocumentNode<CommunityListMapFragmentFragment, unknown>;
export const PatientListItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<PatientListItemFragmentFragment, unknown>;
export const AppointmentPatientListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentPatientListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registroVirtual"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}}]} as unknown as DocumentNode<AppointmentPatientListFragmentFragment, unknown>;
export const CreateAppointmentPatientListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateAppointmentPatientListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentPatientListFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentPatientListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registroVirtual"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListItemFragment"}}]}}]}}]} as unknown as DocumentNode<CreateAppointmentPatientListFragmentFragment, unknown>;
export const OnlinePaymentTypesCheckboxGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OnlinePaymentTypesCheckboxGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"expensum_payment_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<OnlinePaymentTypesCheckboxGroupFragmentFragment, unknown>;
export const CreatePaymentFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatePaymentFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"pacientes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPaciente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"formasDePagamento"},"name":{"kind":"Name","value":"expensum_payment_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OnlinePaymentTypesCheckboxGroupFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OnlinePaymentTypesCheckboxGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"expensum_payment_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<CreatePaymentFormFragmentFragment, unknown>;
export const CsatCategoriesListQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CsatCategoriesListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"csatCategorias"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"csatCategoriasNotas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCsatCategoria"}},{"kind":"Field","name":{"kind":"Name","value":"nota"}},{"kind":"Field","name":{"kind":"Name","value":"ordem"}}]}}]}}]} as unknown as DocumentNode<CsatCategoriesListQueryFragmentFragment, unknown>;
export const GetAllCsatCategoriesQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetAllCsatCategoriesQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csatCategorias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CsatCategoriesListQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CsatCategoriesListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"csatCategorias"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"csatCategoriasNotas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCsatCategoria"}},{"kind":"Field","name":{"kind":"Name","value":"nota"}},{"kind":"Field","name":{"kind":"Name","value":"ordem"}}]}}]}}]} as unknown as DocumentNode<GetAllCsatCategoriesQueryFragmentFragment, unknown>;
export const CsatCategoriesTestListQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CsatCategoriesTestListQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csatCategorias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CsatCategoriesListQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CsatCategoriesListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"csatCategorias"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"csatCategoriasNotas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCsatCategoria"}},{"kind":"Field","name":{"kind":"Name","value":"nota"}},{"kind":"Field","name":{"kind":"Name","value":"ordem"}}]}}]}}]} as unknown as DocumentNode<CsatCategoriesTestListQueryFragment, unknown>;
export const CurrentPlanCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentPlanCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tiposMovimentacoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"identificacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"Mensalidade","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"plano"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tipoMovimentacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosMovimentacoesRecorrentes"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tipoMovimentacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"usuariosMovimentacoesRecorrentes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlano"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"temFidelidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"tipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"duracaoFidelidadeEmMeses"}},{"kind":"Field","name":{"kind":"Name","value":"carenciaEmMeses"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentPlanCardFragmentFragment, unknown>;
export const CurrentPlanInfoFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentPlanInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tiposMovimentacoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"identificacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"Mensalidade","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"plano"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tipoMovimentacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosMovimentacoesRecorrentes"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tipoMovimentacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"usuariosMovimentacoesRecorrentes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlano"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"temFidelidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}},{"kind":"Field","name":{"kind":"Name","value":"tipoPlano"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlanoFuturo"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionais"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaVencimento"}},{"kind":"Field","name":{"kind":"Name","value":"dataValidacao"}}]}}]}}]} as unknown as DocumentNode<CurrentPlanInfoFragmentFragment, unknown>;
export const AppointmentDashboardCompletedAppointmentsSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDashboardCompletedAppointmentsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mes"}},{"kind":"Field","name":{"kind":"Name","value":"consultasRealizadas"}},{"kind":"Field","name":{"kind":"Name","value":"consultasPresenciais"}},{"kind":"Field","name":{"kind":"Name","value":"consultasVirtuais"}}]}}]} as unknown as DocumentNode<AppointmentDashboardCompletedAppointmentsSectionQueryFragmentFragment, unknown>;
export const AppointmentDashboardLatePatientsSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDashboardLatePatientsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mes"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosPacienteAtrasado"}}]}}]} as unknown as DocumentNode<AppointmentDashboardLatePatientsSectionQueryFragmentFragment, unknown>;
export const AppointmentDashboardNoShowSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDashboardNoShowSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mes"}},{"kind":"Field","name":{"kind":"Name","value":"consultasNoShow"}}]}}]} as unknown as DocumentNode<AppointmentDashboardNoShowSectionQueryFragmentFragment, unknown>;
export const AppointmentDashboardTotalCancelledSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDashboardTotalCancelledSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelamentos"}},{"kind":"Field","name":{"kind":"Name","value":"cancelamentosDefinitivos"}},{"kind":"Field","name":{"kind":"Name","value":"mes"}}]}}]} as unknown as DocumentNode<AppointmentDashboardTotalCancelledSectionQueryFragmentFragment, unknown>;
export const AppointmentDashboardTotalSchedulesPerAppointmentReceivingOptionsQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDashboardTotalSchedulesPerAppointmentReceivingOptionsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentosMarcadosParaOMes"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosParticularesParaOMes"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosConveniosParaOMes"}},{"kind":"Field","name":{"kind":"Name","value":"mes"}}]}}]} as unknown as DocumentNode<AppointmentDashboardTotalSchedulesPerAppointmentReceivingOptionsQueryFragmentFragment, unknown>;
export const CustomerContactDashboardContactByTypeSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardContactByTypeSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"percentDigitalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"percentHumanCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalDigitalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"percentGrowthTotalCustomerContacts"}}]}}]} as unknown as DocumentNode<CustomerContactDashboardContactByTypeSectionQueryFragmentFragment, unknown>;
export const CustomerContactDashboardContactReasonSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardContactReasonSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"percentGrowthTotalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"mainReasonsOccurrences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<CustomerContactDashboardContactReasonSectionQueryFragmentFragment, unknown>;
export const CustomerContactDashboardContactSummarySectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardContactSummarySectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalBeforeFiltering"}},{"kind":"Field","name":{"kind":"Name","value":"totalFiltered"}},{"kind":"Field","name":{"kind":"Name","value":"percentTotalFilteredCustomerContacts"}}]}}]} as unknown as DocumentNode<CustomerContactDashboardContactSummarySectionQueryFragmentFragment, unknown>;
export const CustomerContactDashboardContactsDistributionSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardContactsDistributionSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalOldCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"percentOldCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalNewCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"percentNewCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"percentGrowthTotalCustomerContacts"}}]}}]} as unknown as DocumentNode<CustomerContactDashboardContactsDistributionSectionQueryFragmentFragment, unknown>;
export const CustomerContactDashboardHumanContactsSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardHumanContactsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContactsChat"}},{"kind":"Field","name":{"kind":"Name","value":"percentHumanCustomerContactsChat"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContactsVoice"}},{"kind":"Field","name":{"kind":"Name","value":"percentHumanCustomerContactsVoice"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"percentGrowthTotalHumanCustomerContacts"}}]}}]} as unknown as DocumentNode<CustomerContactDashboardHumanContactsSectionQueryFragmentFragment, unknown>;
export const CustomerContactDashboardReasonsForNotSchedulingSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardReasonsForNotSchedulingSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"mostFrequentNotScheduledAppointmentReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]} as unknown as DocumentNode<CustomerContactDashboardReasonsForNotSchedulingSectionQueryFragmentFragment, unknown>;
export const CustomerContactDashboardSchedulingConversionRateSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardSchedulingConversionRateSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentCustomerContactsAppointmentsScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsNewAppointmentMainReason"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsAppointmentsScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}}]} as unknown as DocumentNode<CustomerContactDashboardSchedulingConversionRateSectionQueryFragmentFragment, unknown>;
export const CustomerContactDashboardTotalContactsSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardTotalContactsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsVoice"}},{"kind":"Field","name":{"kind":"Name","value":"percentCustomerContactsVoice"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsChat"}},{"kind":"Field","name":{"kind":"Name","value":"percentCustomerContactsChat"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"percentGrowthTotalCustomerContacts"}}]}}]} as unknown as DocumentNode<CustomerContactDashboardTotalContactsSectionQueryFragmentFragment, unknown>;
export const ExtendTimeFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExtendTimeFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiBuscaHorariosParaEstender"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataHora"}},{"kind":"Field","name":{"kind":"Name","value":"dataHoraFim"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"tipoHorarioSugestao"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"activeAllocation"},"name":{"kind":"Name","value":"AgendamentosAlocacoesAtivas_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"Agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duracao"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExtendTimeFormFragmentFragment, unknown>;
export const FollowUpAppointmentReminderFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canalAgendamentoPaciente"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoriaPeriodoGarantido"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasCompromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuariosCompromissos"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appointment"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<FollowUpAppointmentReminderFormFragmentFragment, unknown>;
export const FollowUpAppointmentReminderListItemQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderListItemQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lembretes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codLembrete"}},{"kind":"Field","name":{"kind":"Name","value":"paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataParaEnvio"}},{"kind":"Field","alias":{"kind":"Name","value":"tipoDeAtendimento"},"name":{"kind":"Name","value":"usuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<FollowUpAppointmentReminderListItemQueryFragment, unknown>;
export const FollowUpAppointmentReminderListQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderListQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lembretes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoLembrete"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoLembreteRetorno"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataEnviado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hoje"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codLembrete"}},{"kind":"Field","name":{"kind":"Name","value":"paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FollowUpAppointmentReminderListItemQuery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderListItemQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lembretes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codLembrete"}},{"kind":"Field","name":{"kind":"Name","value":"paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataParaEnvio"}},{"kind":"Field","alias":{"kind":"Name","value":"tipoDeAtendimento"},"name":{"kind":"Name","value":"usuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<FollowUpAppointmentReminderListQueryFragment, unknown>;
export const FollowUpAppointmentReminderMessageDrawerFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderMessageDrawerFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"Usuario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apelido"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sobrenome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<FollowUpAppointmentReminderMessageDrawerFragmentFragment, unknown>;
export const HealthInsurancePlansListToSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancePlansListToSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tiposPlanos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HealthInsurancePlansListToSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancePlansListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposPlanos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<HealthInsurancePlansListToSelectTestQueryFragmentFragment, unknown>;
export const HealthInsurancesListToSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancesListToSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tiposConvenios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HealthInsurancesListToSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposConvenios"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<HealthInsurancesListToSelectTestQueryFragmentFragment, unknown>;
export const HomePageCalendarFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomePageCalendarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FinalidadesAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableAppointmentsPurpose"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FinalidadesAgendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobrancaAtraso"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tbFechamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"motivo"}},{"kind":"Field","name":{"kind":"Name","value":"codFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"tbUnidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}}]}}]} as unknown as DocumentNode<HomePageCalendarFragmentFragment, unknown>;
export const HomeCalendarDayEventFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FinalidadesAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableAppointmentsPurpose"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FinalidadesAgendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobrancaAtraso"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tbFechamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"motivo"}},{"kind":"Field","name":{"kind":"Name","value":"codFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"tbUnidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}}]}}]} as unknown as DocumentNode<HomeCalendarDayEventFragmentFragment, unknown>;
export const AppointmentsQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomePageCalendarFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeCalendarDayEventFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomePageCalendarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FinalidadesAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableAppointmentsPurpose"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FinalidadesAgendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobrancaAtraso"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tbFechamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"motivo"}},{"kind":"Field","name":{"kind":"Name","value":"codFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"tbUnidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FinalidadesAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableAppointmentsPurpose"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FinalidadesAgendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobrancaAtraso"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tbFechamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"motivo"}},{"kind":"Field","name":{"kind":"Name","value":"codFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"tbUnidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentsQueryFragmentFragment, unknown>;
export const FreeSchedulesSlotsHomePageCalendarFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeSchedulesSlotsHomePageCalendarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiBuscaSelecionaFaixasLivresAgenda"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}},{"kind":"Field","name":{"kind":"Name","value":"podeExceder"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"autorizado"}}]}}]}}]} as unknown as DocumentNode<FreeSchedulesSlotsHomePageCalendarFragmentFragment, unknown>;
export const FreeScheduleSlotsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeScheduleSlotsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeSchedulesSlotsHomePageCalendarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeSchedulesSlotsHomePageCalendarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiBuscaSelecionaFaixasLivresAgenda"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}},{"kind":"Field","name":{"kind":"Name","value":"podeExceder"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"autorizado"}}]}}]}}]} as unknown as DocumentNode<FreeScheduleSlotsFragmentFragment, unknown>;
export const FreeSchedulesSlotsHomeCalendarDayEventFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeSchedulesSlotsHomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiUsuarioAgendaAtivosPorUsuario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"dataFim"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendasUnidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendasDiasSemanas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}}]}}]}}]} as unknown as DocumentNode<FreeSchedulesSlotsHomeCalendarDayEventFragmentFragment, unknown>;
export const ScheduleSlotsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleSlotsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeSchedulesSlotsHomeCalendarDayEventFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeSchedulesSlotsHomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiUsuarioAgendaAtivosPorUsuario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"dataFim"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendasUnidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendasDiasSemanas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduleSlotsFragmentFragment, unknown>;
export const HolidaysHomeCalendarDayEventFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HolidaysHomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiFeriadosPorPeriodo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicioToString"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFimToString"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFeriado"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"dia"}},{"kind":"Field","name":{"kind":"Name","value":"mes"}},{"kind":"Field","name":{"kind":"Name","value":"ano"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<HolidaysHomeCalendarDayEventFragmentFragment, unknown>;
export const HolidaysQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HolidaysQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HolidaysHomeCalendarDayEventFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HolidaysHomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiFeriadosPorPeriodo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicioToString"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFimToString"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFeriado"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"dia"}},{"kind":"Field","name":{"kind":"Name","value":"mes"}},{"kind":"Field","name":{"kind":"Name","value":"ano"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<HolidaysQueryFragmentFragment, unknown>;
export const TimePoliciesHomeCalendarDayEventFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimePoliciesHomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unidadesPoliticasDeHorarios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"politica"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidadePoliticaDeHorario"}},{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]}}]} as unknown as DocumentNode<TimePoliciesHomeCalendarDayEventFragmentFragment, unknown>;
export const TimePoliciesQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimePoliciesQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimePoliciesHomeCalendarDayEventFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimePoliciesHomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unidadesPoliticasDeHorarios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"politica"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidadePoliticaDeHorario"}},{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]}}]} as unknown as DocumentNode<TimePoliciesQueryFragmentFragment, unknown>;
export const BlockedActionsListAlertFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockedActionsListAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listaAcoesBloqueadas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAcao"}}]}}]}}]} as unknown as DocumentNode<BlockedActionsListAlertFragmentFragment, unknown>;
export const BlockedActionsListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockedActionsListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockedActionsListAlertFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockedActionsListAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listaAcoesBloqueadas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAcao"}}]}}]}}]} as unknown as DocumentNode<BlockedActionsListFragmentFragment, unknown>;
export const UnitsBySchedulesQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsBySchedulesQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Unidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnitsBySchedulesQueryFragmentFragment, unknown>;
export const HomeProfileHeaderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeProfileHeaderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"profilePictureFile"},"name":{"kind":"Name","value":"LivanceApiSelecionaFotoDePerfil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arquivo"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]} as unknown as DocumentNode<HomeProfileHeaderFragmentFragment, unknown>;
export const WaitingRoomAppointmentListItemPaymentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"pagar"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentosVinculados"},"name":{"kind":"Name","value":"AgendamentosVinculados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoTipoVinculo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<WaitingRoomAppointmentListItemPaymentFragmentFragment, unknown>;
export const WaitingRoomAppointmentListItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"checkin"},"name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCheckin"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"atraso"},"name":{"kind":"Name","value":"notificacoesPacientesAtrasados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempoAtraso"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoTipoTag"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"pagar"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentosVinculados"},"name":{"kind":"Name","value":"AgendamentosVinculados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoTipoVinculo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<WaitingRoomAppointmentListItemFragmentFragment, unknown>;
export const HomeNextSchedulesCarouselQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeNextSchedulesCarouselQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"today"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"2"},{"kind":"IntValue","value":"4"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentoPreAlocacao"},"name":{"kind":"Name","value":"AgendamentoPreAlocacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentoAlocacaoAtiva"},"name":{"kind":"Name","value":"AgendamentosAlocacoesAtivas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UsuariosCompromissosTiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"pagar"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentosVinculados"},"name":{"kind":"Name","value":"AgendamentosVinculados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoTipoVinculo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"checkin"},"name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCheckin"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"atraso"},"name":{"kind":"Name","value":"notificacoesPacientesAtrasados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempoAtraso"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoTipoTag"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"}}]}}]} as unknown as DocumentNode<HomeNextSchedulesCarouselQueryFragmentFragment, unknown>;
export const HomeSectionLivanceAssistCardGroupQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeSectionLivanceAssistCardGroupQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"customerContactData"},"name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromStr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toStr"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","alias":{"kind":"Name","value":"convertedAppointmentsPercent"},"name":{"kind":"Name","value":"percentCustomerContactsAppointmentsScheduled"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rescueAppointmentsData"},"name":{"kind":"Name","value":"analyticsMembroTotalDeAgendamentosResgatadosPorFluxo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromStr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toStr"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointments"},"name":{"kind":"Name","value":"agendamentosRecuperados"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lembretes"},"name":{"kind":"Name","value":"lembretes_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataEnviado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lembretesEnviados"},"name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"total"},"name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<HomeSectionLivanceAssistCardGroupQueryFragmentFragment, unknown>;
export const HomeSectionLivancePayCardGroupFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeSectionLivancePayCardGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pagosOnline"},"name":{"kind":"Name","value":"expensum_online_payment_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStartCount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEndCount"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"paid","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pendentesOnline"},"name":{"kind":"Name","value":"expensum_online_payment_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStartCount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEndCount"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"pending","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pagosTotem"},"name":{"kind":"Name","value":"expensum_appointment_paid_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStartCount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEndCount"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pendentesTotem"},"name":{"kind":"Name","value":"expensum_event_totem_payment_sent_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStartCount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEndCount"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetPaymentsChartsInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"intervalEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEndAction"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"intervalStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStartAction"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"periodicity"},"value":{"kind":"StringValue","value":"monthly","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervalEnd"}},{"kind":"Field","name":{"kind":"Name","value":"intervalStart"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totemPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"expensumRecipient"},"name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagarmeId"}}]}}]}}]}}]} as unknown as DocumentNode<HomeSectionLivancePayCardGroupFragmentFragment, unknown>;
export const HomeSectionOneLivActiveFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeSectionOneLivActiveFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LocusGetProfileCompletionPercentage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"porcentagemPerfil"}},{"kind":"Field","name":{"kind":"Name","value":"pendente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiencias"}},{"kind":"Field","name":{"kind":"Name","value":"faqs"}},{"kind":"Field","name":{"kind":"Name","value":"focosTratamentos"}},{"kind":"Field","name":{"kind":"Name","value":"membroFormacoes"}},{"kind":"Field","name":{"kind":"Name","value":"sobre"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<HomeSectionOneLivActiveFragmentFragment, unknown>;
export const MembersListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembersListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PerfisPublicosConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"listaMembros"},"name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"especialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]} as unknown as DocumentNode<MembersListFragmentFragment, unknown>;
export const ProfilePictureFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilePictureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"profilePictureFile"},"name":{"kind":"Name","value":"LivanceApiSelecionaFotoDePerfil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arquivo"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]} as unknown as DocumentNode<ProfilePictureFragmentFragment, unknown>;
export const ProfilePictureAlertFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilePictureAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"profilePictureFile"},"name":{"kind":"Name","value":"LivanceApiSelecionaFotoDePerfil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arquivo"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]} as unknown as DocumentNode<ProfilePictureAlertFragmentFragment, unknown>;
export const ProfessionalUserPreferredNameFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfessionalUserPreferredNameFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionais"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Usuario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sobrenome"}},{"kind":"Field","name":{"kind":"Name","value":"apelido"}}]}}]}}]}}]} as unknown as DocumentNode<ProfessionalUserPreferredNameFragmentFragment, unknown>;
export const MyProfileDetailsSectionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyProfileDetailsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfilePictureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfilePictureAlertFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfessionalUserPreferredNameFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilePictureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"profilePictureFile"},"name":{"kind":"Name","value":"LivanceApiSelecionaFotoDePerfil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arquivo"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilePictureAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"profilePictureFile"},"name":{"kind":"Name","value":"LivanceApiSelecionaFotoDePerfil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arquivo"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfessionalUserPreferredNameFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionais"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Usuario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sobrenome"}},{"kind":"Field","name":{"kind":"Name","value":"apelido"}}]}}]}}]}}]} as unknown as DocumentNode<MyProfileDetailsSectionFragmentFragment, unknown>;
export const OneLivProfileCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivProfileCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locus_conselho_profissional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]} as unknown as DocumentNode<OneLivProfileCardFragmentFragment, unknown>;
export const OneLivAdditionalInfoFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivAdditionalInfoFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"sobre"}},{"kind":"Field","name":{"kind":"Name","value":"maisInformacoes"}}]}}]} as unknown as DocumentNode<OneLivAdditionalInfoFormFragmentFragment, unknown>;
export const OneLivSpecialtySelectInputFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSpecialtySelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_especialidade"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}}]}}]} as unknown as DocumentNode<OneLivSpecialtySelectInputFragmentFragment, unknown>;
export const OneLivSubspecialtySelectInputFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSubspecialtySelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_especialidade"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialidadeSubespecialidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subespecialidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"especialista"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subespecialidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}}]}}]}}]}}]} as unknown as DocumentNode<OneLivSubspecialtySelectInputFragmentFragment, unknown>;
export const OneLivSpecialtiesInputFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSpecialtiesInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"specialties"},"name":{"kind":"Name","value":"locus_especialidade"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"especialista"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codEspecialidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}},{"kind":"Field","name":{"kind":"Name","value":"conselhoProfissionalEspecialidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"conselhoProfissional"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idConselhoProfissional"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivSpecialtySelectInputFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivSubspecialtySelectInputFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"professionalCouncil"},"name":{"kind":"Name","value":"locus_conselho_profissional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sigla"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CRM","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSpecialtySelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_especialidade"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSubspecialtySelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_especialidade"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialidadeSubespecialidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subespecialidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"especialista"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subespecialidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}}]}}]}}]}}]} as unknown as DocumentNode<OneLivSpecialtiesInputFragmentFragment, unknown>;
export const OneLivProfessionalCouncilSelectInputFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivProfessionalCouncilSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"professionalCouncils"},"name":{"kind":"Name","value":"locus_conselho_profissional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<OneLivProfessionalCouncilSelectInputFragmentFragment, unknown>;
export const OneLivBasicInfoFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivBasicInfoFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apelido"}},{"kind":"Field","name":{"kind":"Name","value":"pronome"}},{"kind":"Field","name":{"kind":"Name","value":"ufConselhoClasse"}},{"kind":"Field","name":{"kind":"Name","value":"numeroConselhoClasse"}},{"kind":"Field","name":{"kind":"Name","value":"duracaoInicialConsulta"}},{"kind":"Field","name":{"kind":"Name","value":"valorInicialConsulta"}},{"kind":"Field","name":{"kind":"Name","value":"formasPagamento"}},{"kind":"Field","name":{"kind":"Name","value":"resumo"}},{"kind":"Field","name":{"kind":"Name","value":"fotoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idConselhoProfissional"}},{"kind":"Field","name":{"kind":"Name","value":"membroEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rqe"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}},{"kind":"Field","name":{"kind":"Name","value":"idEspecialidade"}},{"kind":"Field","name":{"kind":"Name","value":"membroEspecialidadeSubespecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSubespecialidade"}},{"kind":"Field","name":{"kind":"Name","value":"rqe"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivSpecialtiesInputFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivProfessionalCouncilSelectInputFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSpecialtySelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_especialidade"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSubspecialtySelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_especialidade"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialidadeSubespecialidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subespecialidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"especialista"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subespecialidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSpecialtiesInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"specialties"},"name":{"kind":"Name","value":"locus_especialidade"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"especialista"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codEspecialidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}},{"kind":"Field","name":{"kind":"Name","value":"conselhoProfissionalEspecialidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"conselhoProfissional"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idConselhoProfissional"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivSpecialtySelectInputFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivSubspecialtySelectInputFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"professionalCouncil"},"name":{"kind":"Name","value":"locus_conselho_profissional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sigla"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CRM","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivProfessionalCouncilSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"professionalCouncils"},"name":{"kind":"Name","value":"locus_conselho_profissional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<OneLivBasicInfoFormFragmentFragment, unknown>;
export const OneLivCoursesSelectInputFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivCoursesSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_curso_formacao"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<OneLivCoursesSelectInputFragmentFragment, unknown>;
export const OneLivEducationalInstitutionSelectInputFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivEducationalInstitutionSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_instituicao_ensino"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]} as unknown as DocumentNode<OneLivEducationalInstitutionSelectInputFragmentFragment, unknown>;
export const OneLivEducationalBackgroundFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivEducationalBackgroundFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"membro"},"name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"membroFormacao"},"name":{"kind":"Name","value":"locus_membro_formacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conclusao"}},{"kind":"Field","name":{"kind":"Name","value":"idCurso"}},{"kind":"Field","name":{"kind":"Name","value":"idInstituicaoEnsino"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cursos"},"name":{"kind":"Name","value":"locus_curso_formacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivCoursesSelectInputFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"instituicoesEnsino"},"name":{"kind":"Name","value":"locus_instituicao_ensino"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivEducationalInstitutionSelectInputFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivCoursesSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_curso_formacao"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivEducationalInstitutionSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_instituicao_ensino"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]} as unknown as DocumentNode<OneLivEducationalBackgroundFormFragmentFragment, unknown>;
export const OneLivExperiencesFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivExperiencesFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"experiencias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"experiencia"}}]}}]}}]} as unknown as DocumentNode<OneLivExperiencesFormFragmentFragment, unknown>;
export const OneLivFaqFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivFAQFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pergunta"}},{"kind":"Field","name":{"kind":"Name","value":"resposta"}}]}}]}}]} as unknown as DocumentNode<OneLivFaqFormFragmentFragment, unknown>;
export const OneLivMedicalInstitutionsSelectInputFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivMedicalInstitutionsSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_instituicao_medica"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<OneLivMedicalInstitutionsSelectInputFragmentFragment, unknown>;
export const OneLivMedicalInstitutionsFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivMedicalInstitutionsFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"membro"},"name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"membroInstituicoesMedicas"},"name":{"kind":"Name","value":"locus_membro_instituicao_medica"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idInstituicaoMedica"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"instituicoesMedicas"},"name":{"kind":"Name","value":"locus_instituicao_medica"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivMedicalInstitutionsSelectInputFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivMedicalInstitutionsSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_instituicao_medica"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<OneLivMedicalInstitutionsFormFragmentFragment, unknown>;
export const OneLivSocialMediaFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSocialMediaFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_rede_social_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redeSocial"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<OneLivSocialMediaFormFragmentFragment, unknown>;
export const OneLivTreatmentFocusFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivTreatmentFocusFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"focosTratamentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"focoTratamento"}}]}}]}}]} as unknown as DocumentNode<OneLivTreatmentFocusFormFragmentFragment, unknown>;
export const PatientDetailActionListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailActionListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<PatientDetailActionListFragmentFragment, unknown>;
export const PatientDetailLastAppointmentFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailLastAppointmentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lastAppointment"},"name":{"kind":"Name","value":"Agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"},{"kind":"IntValue","value":"3"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoOrigem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"reminders"},"name":{"kind":"Name","value":"lembretes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataEnviado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"today"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}}]}}]} as unknown as DocumentNode<PatientDetailLastAppointmentFragmentFragment, unknown>;
export const PatientDetailHeaderActionsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailHeaderActionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}}]} as unknown as DocumentNode<PatientDetailHeaderActionsFragmentFragment, unknown>;
export const PatientDetailHeaderFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailHeaderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<PatientDetailHeaderFragmentFragment, unknown>;
export const PatientDetailPropertyListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailPropertyListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"receberWhatsAppConfirmacao"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}}]} as unknown as DocumentNode<PatientDetailPropertyListFragmentFragment, unknown>;
export const PatientHistoryListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientHistoryListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"},{"kind":"IntValue","value":"3"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoOrigem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentoAlocacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]} as unknown as DocumentNode<PatientHistoryListFragmentFragment, unknown>;
export const PatientDetailTabsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailTabsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientDetailPropertyListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientHistoryListFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailPropertyListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"receberWhatsAppConfirmacao"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientHistoryListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"},{"kind":"IntValue","value":"3"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoOrigem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentoAlocacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]} as unknown as DocumentNode<PatientDetailTabsFragmentFragment, unknown>;
export const PatientUpdateFormQueryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientUpdateFormQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"cpfProprio"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"receberWhatsAppConfirmacao"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneProprio"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}}]}}]} as unknown as DocumentNode<PatientUpdateFormQueryFragment, unknown>;
export const PatientListQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registroVirtual"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}}]} as unknown as DocumentNode<PatientListQueryFragmentFragment, unknown>;
export const PatientPaymentDetailsAppointmentSectionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentDetailsAppointmentSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startHour"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}}]} as unknown as DocumentNode<PatientPaymentDetailsAppointmentSectionFragmentFragment, unknown>;
export const PatientPaymentsDetailsPaymentSectionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsDetailsPaymentSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acquirerTransactionKey"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"refundedAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePaymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<PatientPaymentsDetailsPaymentSectionFragmentFragment, unknown>;
export const PatientPaymentsDetailsPayableSectionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsDetailsPayableSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payablesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"grossValue"}},{"kind":"Field","name":{"kind":"Name","value":"netValue"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"installment"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"anticipationFee"}}]}}]}}]}}]} as unknown as DocumentNode<PatientPaymentsDetailsPayableSectionFragmentFragment, unknown>;
export const PatientPaymentDetailsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onlinePaymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentDetailsAppointmentSectionFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsDetailsPaymentSectionFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsDetailsPayableSectionFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentDetailsAppointmentSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startHour"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsDetailsPaymentSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acquirerTransactionKey"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"refundedAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePaymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsDetailsPayableSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payablesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"grossValue"}},{"kind":"Field","name":{"kind":"Name","value":"netValue"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"installment"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"anticipationFee"}}]}}]}}]}}]} as unknown as DocumentNode<PatientPaymentDetailsFragmentFragment, unknown>;
export const PatientPaymentsListItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPaymentInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"meioPagamentoSelecionado"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"criadoEm"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"nomeDoPagador"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parcelas"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutomaticAnticipation"}},{"kind":"Field","name":{"kind":"Name","value":"payableInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"installment"}},{"kind":"Field","name":{"kind":"Name","value":"nextPaymentDate"}}]}}]}}]} as unknown as DocumentNode<PatientPaymentsListItemFragmentFragment, unknown>;
export const PatientPaymentsListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPaymentsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsListItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPaymentInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"meioPagamentoSelecionado"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"criadoEm"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"nomeDoPagador"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parcelas"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutomaticAnticipation"}},{"kind":"Field","name":{"kind":"Name","value":"payableInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"installment"}},{"kind":"Field","name":{"kind":"Name","value":"nextPaymentDate"}}]}}]}}]} as unknown as DocumentNode<PatientPaymentsListFragmentFragment, unknown>;
export const PatientSwapPatientListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientSwapPatientListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentPatientListFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentPatientListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registroVirtual"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListItemFragment"}}]}}]}}]} as unknown as DocumentNode<PatientSwapPatientListFragmentFragment, unknown>;
export const PayablesStatusChartFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PayablesStatusChartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPayablesChartsInfoOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervalEnd"}},{"kind":"Field","name":{"kind":"Name","value":"intervalStart"}},{"kind":"Field","name":{"kind":"Name","value":"waitingFunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}}]}}]} as unknown as DocumentNode<PayablesStatusChartFragmentFragment, unknown>;
export const PaymentMethodsListToMultiSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToMultiSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosFormasRecebimentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethodsListToMultiSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosFormasRecebimentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<PaymentMethodsListToMultiSelectTestQueryFragmentFragment, unknown>;
export const PaymentMethodsListToSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosFormasRecebimentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethodsListToSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosFormasRecebimentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<PaymentMethodsListToSelectTestQueryFragmentFragment, unknown>;
export const PaymentsOriginChartFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentsOriginChartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPaymentsChartsInfoOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervalEnd"}},{"kind":"Field","name":{"kind":"Name","value":"intervalStart"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totemPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PaymentsOriginChartFragmentFragment, unknown>;
export const PaymentsStatusChartFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentsStatusChartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPaymentsChartsInfoOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervalEnd"}},{"kind":"Field","name":{"kind":"Name","value":"intervalStart"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totemPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PaymentsStatusChartFragmentFragment, unknown>;
export const PublicPhoneNumberFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicPhoneNumberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionais"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefonePublico"}}]}}]}}]} as unknown as DocumentNode<PublicPhoneNumberFragmentFragment, unknown>;
export const ReceiveRoomNowFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReceiveRoomNowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}}]} as unknown as DocumentNode<ReceiveRoomNowFragmentFragment, unknown>;
export const RecommendationMembersForPatientFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecommendationMembersForPatientFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"pacientes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPaciente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPaciente"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fotoPerfilMembro"},"name":{"kind":"Name","value":"LivanceApiSelecionaFotoDePerfil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codMembro"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arquivo"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]} as unknown as DocumentNode<RecommendationMembersForPatientFormFragmentFragment, unknown>;
export const RefundDetailsQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefundDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumPaymentDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onlinePaymentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlinePaymentGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acquirerTransactionKey"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"payablesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagarmeId"}}]}}]}}]}}]} as unknown as DocumentNode<RefundDetailsQueryFragmentFragment, unknown>;
export const PatientPaymentsRefundDetailsSectionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsRefundDetailsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetRefundReceiptOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"authorizationId"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAmount"}}]}}]}}]} as unknown as DocumentNode<PatientPaymentsRefundDetailsSectionFragmentFragment, unknown>;
export const PatientPaymentsRefundPayeeSectionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsRefundPayeeSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetRefundReceiptOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"lastFourDigits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}}]}}]} as unknown as DocumentNode<PatientPaymentsRefundPayeeSectionFragmentFragment, unknown>;
export const RefundReceiptDetailsQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefundReceiptDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetRefundReceiptOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsRefundDetailsSectionFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsRefundPayeeSectionFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsRefundDetailsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetRefundReceiptOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"authorizationId"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAmount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsRefundPayeeSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetRefundReceiptOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"lastFourDigits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}}]}}]} as unknown as DocumentNode<RefundReceiptDetailsQueryFragmentFragment, unknown>;
export const RescheduleAppointmentFlexiblePriceFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescheduleAppointmentFlexiblePriceFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioWhatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpfProprio"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidadesPrecosFlexiveis"},"name":{"kind":"Name","value":"UnidadesPrecosFlexiveis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxaDesconto"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"periodosGarantidos"},"name":{"kind":"Name","value":"tbPeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"horaFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UsuariosCompromissosTiposSalas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}}]}}]}}]} as unknown as DocumentNode<RescheduleAppointmentFlexiblePriceFormFragmentFragment, unknown>;
export const RescheduleAppointmentPatientFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescheduleAppointmentPatientFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneProprio"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioWhatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receberWhatsAppConfirmacao"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"cpfProprio"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"newAppointmentType"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}},{"kind":"Field","name":{"kind":"Name","value":"tiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unidadesPrecosFlexiveis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadesPrecosFlexiveisParceirosIntegracoes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"newUnit"},"name":{"kind":"Name","value":"unidades_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]} as unknown as DocumentNode<RescheduleAppointmentPatientFormFragmentFragment, unknown>;
export const RescuedAppointmentDashboardCancelledAppointmentsSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescuedAppointmentDashboardCancelledAppointmentsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"mes"}},{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointmentType"},"name":{"kind":"Name","value":"fluxo"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentsRescuedSum"},"name":{"kind":"Name","value":"agendamentosRecuperados"}},{"kind":"Field","alias":{"kind":"Name","value":"sentMessagesSum"},"name":{"kind":"Name","value":"totalMensagens"}}]}}]}}]} as unknown as DocumentNode<RescuedAppointmentDashboardCancelledAppointmentsSectionQueryFragmentFragment, unknown>;
export const RescuedAppointmentDashboardNoShowAppointmentsSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescuedAppointmentDashboardNoShowAppointmentsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"mes"}},{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointmentType"},"name":{"kind":"Name","value":"fluxo"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentsRescuedSum"},"name":{"kind":"Name","value":"agendamentosRecuperados"}},{"kind":"Field","alias":{"kind":"Name","value":"sentMessagesSum"},"name":{"kind":"Name","value":"totalMensagens"}}]}}]}}]} as unknown as DocumentNode<RescuedAppointmentDashboardNoShowAppointmentsSectionQueryFragmentFragment, unknown>;
export const RescuedAppointmentDashboardTotalRescuedSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescuedAppointmentDashboardTotalRescuedSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"mes"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentsRescuedSum"},"name":{"kind":"Name","value":"agendamentosRecuperados"}},{"kind":"Field","alias":{"kind":"Name","value":"sentMessagesSum"},"name":{"kind":"Name","value":"totalMensagens"}}]}}]}}]} as unknown as DocumentNode<RescuedAppointmentDashboardTotalRescuedSectionQueryFragmentFragment, unknown>;
export const RescuedAppointmentDashboardUnscheduledAppointmentsSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescuedAppointmentDashboardUnscheduledAppointmentsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"mes"}},{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointmentType"},"name":{"kind":"Name","value":"fluxo"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentsRescuedSum"},"name":{"kind":"Name","value":"agendamentosRecuperados"}},{"kind":"Field","alias":{"kind":"Name","value":"sentMessagesSum"},"name":{"kind":"Name","value":"totalMensagens"}}]}}]}}]} as unknown as DocumentNode<RescuedAppointmentDashboardUnscheduledAppointmentsSectionQueryFragmentFragment, unknown>;
export const RescuedAppointmentsSectionQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescuedAppointmentsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"mes"}},{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointmentType"},"name":{"kind":"Name","value":"fluxo"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentsRescuedSum"},"name":{"kind":"Name","value":"agendamentosRecuperados"}},{"kind":"Field","alias":{"kind":"Name","value":"sentMessagesSum"},"name":{"kind":"Name","value":"totalMensagens"}}]}}]}}]} as unknown as DocumentNode<RescuedAppointmentsSectionQueryFragmentFragment, unknown>;
export const GetReservedSchedulePriceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetReservedSchedulePriceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ReservedSchedulePrice"},"name":{"kind":"Name","value":"LivanceApiSimulaCobrancaPeriodoGarantido"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"duracao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duracao"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"price"},"name":{"kind":"Name","value":"valor"}}]}}]}}]} as unknown as DocumentNode<GetReservedSchedulePriceFragmentFragment, unknown>;
export const GetLocationsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetLocationsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"unidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"desligarAlocacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preAlocacaoAtiva"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","alias":{"kind":"Name","value":"rooms"},"name":{"kind":"Name","value":"tbUnidades_tbUnidadesSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"alocavel"}},{"kind":"Field","alias":{"kind":"Name","value":"roomType"},"name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"alocavel"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<GetLocationsFragmentFragment, unknown>;
export const ReservedScheduleListItemQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservedScheduleListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tbPeriodosGarantidosRecorrentes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},{"kind":"Field","name":{"kind":"Name","value":"diaDaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}}]}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoFinalidadePeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"Agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"meioPagamento"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidosRecorrentesFrequencia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"descricao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<ReservedScheduleListItemQueryFragmentFragment, unknown>;
export const ReservedScheduleListQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservedScheduleListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"periodosGarantidosRecorrentes"},"name":{"kind":"Name","value":"tbPeriodosGarantidosRecorrentes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrenteFrequencia"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReservedScheduleListItemQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}}]}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservedScheduleListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tbPeriodosGarantidosRecorrentes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},{"kind":"Field","name":{"kind":"Name","value":"diaDaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}}]}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoFinalidadePeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"Agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"meioPagamento"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidosRecorrentesFrequencia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"descricao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<ReservedScheduleListQueryFragmentFragment, unknown>;
export const ReservedSchedulesSlotsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservedSchedulesSlotsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Slots"},"name":{"kind":"Name","value":"LivanceApiBuscaHorariosDisponiveisDiaDaSemana"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"duracao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duracao"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"diaDaSemana"},"value":{"kind":"Variable","name":{"kind":"Name","value":"diaDaSemana"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrenteFrequencia"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrenteFrequencia"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sugestoesHorarios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}}]}}]}}]}}]} as unknown as DocumentNode<ReservedSchedulesSlotsFragmentFragment, unknown>;
export const ReservedSchedulesNextSchedulesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservedSchedulesNextSchedulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tbPeriodosGarantidosRecorrentes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}}]}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},{"kind":"Field","name":{"kind":"Name","value":"Agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReservedSchedulesNextSchedulesFragmentFragment, unknown>;
export const ReturnRoomDrawerFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReturnRoomDrawerFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"nome"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentId"},"name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"activeAllocation"},"name":{"kind":"Name","value":"AgendamentosAlocacoesAtivas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locationRoom"},"name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","alias":{"kind":"Name","value":"roomType"},"name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}}]} as unknown as DocumentNode<ReturnRoomDrawerFragmentFragment, unknown>;
export const ScheduleFrequenciesListToSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleFrequenciesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposAgendasRepeticoes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<ScheduleFrequenciesListToSelectQueryFragmentFragment, unknown>;
export const UnitsListToMultiSelectQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<UnitsListToMultiSelectQueryFragmentFragment, unknown>;
export const ScheduleFormQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"3"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToMultiSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposAgendasRepeticoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoAgendaRepeticao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"30"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleFrequenciesListToSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"unidadeHorariosFuncionamentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"abertura"}},{"kind":"Field","name":{"kind":"Name","value":"fechamento"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"schedule"},"name":{"kind":"Name","value":"usuariosAgendas_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioAgenda"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioAgenda"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"dataFim"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","alias":{"kind":"Name","value":"compromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"diasSemana"},"name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleFrequenciesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposAgendasRepeticoes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<ScheduleFormQueryFragmentFragment, unknown>;
export const ScheduleFrequenciesListToSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleFrequenciesListToSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tiposAgendasRepeticoes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleFrequenciesListToSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleFrequenciesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposAgendasRepeticoes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<ScheduleFrequenciesListToSelectTestQueryFragmentFragment, unknown>;
export const ScheduleListItemCardFrequencyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardFrequencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}}]}}]} as unknown as DocumentNode<ScheduleListItemCardFrequencyFragmentFragment, unknown>;
export const ScheduleListItemCardAppointmentTypeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardAppointmentTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasCompromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduleListItemCardAppointmentTypeFragmentFragment, unknown>;
export const ScheduleListItemCardHeadFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardHeadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}}]}}]} as unknown as DocumentNode<ScheduleListItemCardHeadFragmentFragment, unknown>;
export const ScheduleListItemCardUnitFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardUnitFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}}]}}]}}]} as unknown as DocumentNode<ScheduleListItemCardUnitFragmentFragment, unknown>;
export const ScheduleDaysOfWeekListFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleDaysOfWeekListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasDiasSemanas"},"name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}}]}}]} as unknown as DocumentNode<ScheduleDaysOfWeekListFragmentFragment, unknown>;
export const ScheduleListItemCardStartDateFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardStartDateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"dataInicio"}}]}}]} as unknown as DocumentNode<ScheduleListItemCardStartDateFragmentFragment, unknown>;
export const ScheduleListItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"dataInicio"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardFrequencyFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardAppointmentTypeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardHeadFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardUnitFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleDaysOfWeekListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardStartDateFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardFrequencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardAppointmentTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasCompromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardHeadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardUnitFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleDaysOfWeekListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasDiasSemanas"},"name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardStartDateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"dataInicio"}}]}}]} as unknown as DocumentNode<ScheduleListItemFragmentFragment, unknown>;
export const SchedulesListQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulesListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioAgenda"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"3"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardFrequencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardAppointmentTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasCompromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardHeadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardUnitFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleDaysOfWeekListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasDiasSemanas"},"name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardStartDateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"dataInicio"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"dataInicio"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardFrequencyFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardAppointmentTypeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardHeadFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardUnitFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleDaysOfWeekListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardStartDateFragment"}}]}}]} as unknown as DocumentNode<SchedulesListQueryFragmentFragment, unknown>;
export const AppointmentInfosFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentInfosFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personalizeAppointment"},"name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentInfos"},"name":{"kind":"Name","value":"informacoesSobreAgendamento"}}]}}]}}]} as unknown as DocumentNode<AppointmentInfosFormFragmentFragment, unknown>;
export const SecretaryDetailsFaqFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecretaryDetailsFaqFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personalizeAppointment"},"name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Faq"},"name":{"kind":"Name","value":"informacoesDuvidasFrequentes"}}]}}]}}]} as unknown as DocumentNode<SecretaryDetailsFaqFormFragmentFragment, unknown>;
export const PersonalizeAppointmentFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonalizeAppointmentFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personalizeAppointment"},"name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"professionalInfos"},"name":{"kind":"Name","value":"informacoesSobreProfissional"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentInfos"},"name":{"kind":"Name","value":"informacoesSobreAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"restrictions"},"name":{"kind":"Name","value":"informacoesSobreRestricoes"}},{"kind":"Field","alias":{"kind":"Name","value":"faq"},"name":{"kind":"Name","value":"informacoesDuvidasFrequentes"}}]}}]}}]} as unknown as DocumentNode<PersonalizeAppointmentFormFragmentFragment, unknown>;
export const SecretaryDetailsProfessionalInfosFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecretaryDetailsProfessionalInfosFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personalizeAppointment"},"name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"professionalInfos"},"name":{"kind":"Name","value":"informacoesSobreProfissional"}}]}}]}}]} as unknown as DocumentNode<SecretaryDetailsProfessionalInfosFormFragmentFragment, unknown>;
export const SecretaryDetailsRestrictionsFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecretaryDetailsRestrictionsFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personalizeAppointment"},"name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"restrictions"},"name":{"kind":"Name","value":"informacoesSobreRestricoes"}}]}}]}}]} as unknown as DocumentNode<SecretaryDetailsRestrictionsFormFragmentFragment, unknown>;
export const SendPaymentFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SendPaymentFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosVinculados"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoPrincipal"}}]}}]}}]} as unknown as DocumentNode<SendPaymentFormFragmentFragment, unknown>;
export const SubscribeAssistProSubscriptionConfirmCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscribeAssistProSubscriptionConfirmCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"servicePackage"},"name":{"kind":"Name","value":"pacotesServicos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPacoteServicos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServico"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPreco"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioFixo"}},{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubscribeAssistProSubscriptionConfirmCardFragmentFragment, unknown>;
export const ServicePackagesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServicePackagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"servicePackage"},"name":{"kind":"Name","value":"pacotesServicos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPacoteServicos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServico"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPreco"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioFixo"}},{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ServicePackagesFragmentFragment, unknown>;
export const SubscribedAssistProPriceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscribedAssistProPriceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacoteServicoPreco"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioFixo"}},{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}}]} as unknown as DocumentNode<SubscribedAssistProPriceFragmentFragment, unknown>;
export const SubscribedAssistFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscribedAssistFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacoteServicoPreco"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscribedAssistProPriceFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscribedAssistProPriceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacoteServicoPreco"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioFixo"}},{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}}]} as unknown as DocumentNode<SubscribedAssistFragmentFragment, unknown>;
export const UnavailableSlotFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnavailableSlotFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Unidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<UnavailableSlotFormFragmentFragment, unknown>;
export const UnitsListToMultiSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToMultiSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<UnitsListToMultiSelectTestQueryFragmentFragment, unknown>;
export const UnitsListToSelectTestQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToSelectTestQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<UnitsListToSelectTestQueryFragmentFragment, unknown>;
export const UserTrackableLinksDetailsActionsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinksDetailsActionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]} as unknown as DocumentNode<UserTrackableLinksDetailsActionsFragmentFragment, unknown>;
export const UserTrackableLinksDetailsDescriptionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinksDetailsDescriptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}}]}}]} as unknown as DocumentNode<UserTrackableLinksDetailsDescriptionFragmentFragment, unknown>;
export const UserTrackableLinksDetailsLinkInputFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinksDetailsLinkInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]} as unknown as DocumentNode<UserTrackableLinksDetailsLinkInputFragmentFragment, unknown>;
export const UserTrackableLinkReportDetailSummaryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinkReportDetailSummaryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}}]}}]} as unknown as DocumentNode<UserTrackableLinkReportDetailSummaryFragmentFragment, unknown>;
export const UserTrackableLinkListItemQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinkListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioLinkRastreamento"}},{"kind":"Field","name":{"kind":"Name","value":"sistema"}}]}}]} as unknown as DocumentNode<UserTrackableLinkListItemQueryFragmentFragment, unknown>;
export const UserTrackableLinksQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinksQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosLinksRastreamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioLinkRastreamento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserTrackableLinkListItemQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinkListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioLinkRastreamento"}},{"kind":"Field","name":{"kind":"Name","value":"sistema"}}]}}]} as unknown as DocumentNode<UserTrackableLinksQueryFragmentFragment, unknown>;
export const WaitingRoomAppointmentListQueryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereBuild"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentoPreAlocacao"},"name":{"kind":"Name","value":"AgendamentoPreAlocacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentoAlocacaoAtiva"},"name":{"kind":"Name","value":"AgendamentosAlocacoesAtivas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UsuariosCompromissosTiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"pagar"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentosVinculados"},"name":{"kind":"Name","value":"AgendamentosVinculados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoTipoVinculo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"checkin"},"name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCheckin"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"atraso"},"name":{"kind":"Name","value":"notificacoesPacientesAtrasados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempoAtraso"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoTipoTag"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"}}]}}]} as unknown as DocumentNode<WaitingRoomAppointmentListQueryFragmentFragment, unknown>;
export const WaitingRoomFilterButtonFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomFilterButtonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereBuild"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}}]} as unknown as DocumentNode<WaitingRoomFilterButtonFragmentFragment, unknown>;
export const WaitingRoomAppointmentMenuFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentMenuFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"atraso"},"name":{"kind":"Name","value":"notificacoesPacientesAtrasados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempoAtraso"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoTipoTag"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"followUpAppointment"},"name":{"kind":"Name","value":"lembretes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codLembrete"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]} as unknown as DocumentNode<WaitingRoomAppointmentMenuFragmentFragment, unknown>;
export const AssistProAcceptanceCostPredictionCardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssistProAcceptanceCostPredictionCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"servicePackage"},"name":{"kind":"Name","value":"pacotesServicos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPacoteServicos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServicos"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPreco"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioFixo"}},{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalDigitalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContacts"}}]}}]}}]} as unknown as DocumentNode<AssistProAcceptanceCostPredictionCardFragmentFragment, unknown>;
export const ActiveAllocationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActiveAllocationQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activeAllocation"},"name":{"kind":"Name","value":"AgendamentosAlocacoesAtivas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","alias":{"kind":"Name","value":"appointment"},"name":{"kind":"Name","value":"Agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReturnRoomDrawerFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"locationRoom"},"name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReturnRoomDrawerFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"nome"}},{"kind":"Field","alias":{"kind":"Name","value":"startTime"},"name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","alias":{"kind":"Name","value":"endTime"},"name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentId"},"name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"activeAllocation"},"name":{"kind":"Name","value":"AgendamentosAlocacoesAtivas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locationRoom"},"name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locationId"},"name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","alias":{"kind":"Name","value":"roomType"},"name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}}]} as unknown as DocumentNode<ActiveAllocationQueryQuery, ActiveAllocationQueryQueryVariables>;
export const CsatCategoriesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CsatCategoriesQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetAllCsatCategoriesQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CsatCategoriesListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"csatCategorias"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"csatCategoriasNotas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCsatCategoria"}},{"kind":"Field","name":{"kind":"Name","value":"nota"}},{"kind":"Field","name":{"kind":"Name","value":"ordem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetAllCsatCategoriesQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"csatCategorias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CsatCategoriesListQueryFragment"}}]}}]}}]} as unknown as DocumentNode<CsatCategoriesQueryQuery, CsatCategoriesQueryQueryVariables>;
export const ActiveAllocationDetailsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActiveAllocationDetailsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activeAllocationDetails"},"name":{"kind":"Name","value":"alocacaoAtivaDetalhada"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"dataAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicioAlocacao"}},{"kind":"Field","name":{"kind":"Name","value":"horaFimAlocacao"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicioAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaFimAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"nomePaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nomeUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nomeUnidadeSala"}},{"kind":"Field","name":{"kind":"Name","value":"pacienteRegistroVirtual"}},{"kind":"Field","name":{"kind":"Name","value":"tempoAtrasado"}},{"kind":"Field","name":{"kind":"Name","value":"tempoRestante"}},{"kind":"Field","name":{"kind":"Name","value":"tempoAlocado"}},{"kind":"Field","name":{"kind":"Name","value":"progresso"}},{"kind":"Field","name":{"kind":"Name","value":"atrasado"}},{"kind":"Field","name":{"kind":"Name","value":"siglaSala"}}]}}]}}]} as unknown as DocumentNode<ActiveAllocationDetailsQueryQuery, ActiveAllocationDetailsQueryQueryVariables>;
export const AppointmentAvailableOptionsFormQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentAvailableOptionsFormQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidadeOrigem"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horarioInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TimeSpan"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buscaHorariosEmUnidadesAlternativas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUnidadeOrigem"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidadeOrigem"}}},{"kind":"Argument","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"horarioInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horarioInicio"}}},{"kind":"Argument","name":{"kind":"Name","value":"comHorariosMenores"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unidadesProximas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horarios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"dataHoraFim"}},{"kind":"Field","name":{"kind":"Name","value":"dataHoraInicio"}},{"kind":"Field","name":{"kind":"Name","value":"distancia"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpoUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"siglaUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"tipoHorarioSugestao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalUnidadesBuscadas"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unidadesComAgendaAberta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horarios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"dataHoraFim"}},{"kind":"Field","name":{"kind":"Name","value":"dataHoraInicio"}},{"kind":"Field","name":{"kind":"Name","value":"distancia"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpoUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"siglaUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"tipoHorarioSugestao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalUnidadesBuscadas"}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentAvailableOptionsFormQueryQuery, AppointmentAvailableOptionsFormQueryQueryVariables>;
export const CancelAppointmentMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelAppointmentMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origem"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"discovery","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiAgendamentoCancela"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}},{"kind":"Argument","name":{"kind":"Name","value":"origem"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origem"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}}]} as unknown as DocumentNode<CancelAppointmentMutationMutation, CancelAppointmentMutationMutationVariables>;
export const CalendarAppointmentDetailsDrawerAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalendarAppointmentDetailsDrawerAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FinalidadesAgendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobrancaAtraso"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentDrawerPatientInfoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentDrawerPatientContactActionsFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentDrawerOnlinePaymentButtonFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDrawerPatientInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDrawerPatientContactActionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDrawerOnlinePaymentButtonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"pagar"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentosVinculados"},"name":{"kind":"Name","value":"AgendamentosVinculados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoTipoVinculo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<CalendarAppointmentDetailsDrawerAppointmentQuery, CalendarAppointmentDetailsDrawerAppointmentQueryVariables>;
export const CreateFlexiblePriceAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFlexiblePriceAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CriarAgendamentoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"criarAgendamento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"agendamentoApiOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RepeatedPatientError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateFlexiblePriceAppointmentMutation, CreateFlexiblePriceAppointmentMutationVariables>;
export const GetAvailableTimesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableTimesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"diaSemana"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GetAvailableTimes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comHorarioExtra"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"comHorariosMenores"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataHora"}},{"kind":"Field","name":{"kind":"Name","value":"dataHoraFim"}},{"kind":"Field","name":{"kind":"Name","value":"tipoHorarioSugestao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"LivanceApiFeriadosPorPeriodo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"2"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tbFechamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedDate"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"motivo"}},{"kind":"Field","name":{"kind":"Name","value":"codFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFechamento"}},{"kind":"Field","alias":{"kind":"Name","value":"Unidade"},"name":{"kind":"Name","value":"tbUnidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioCompromisso"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"tiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"diaSemana"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"diaSemana"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}}]}}]}}]} as unknown as DocumentNode<GetAvailableTimesQueryQuery, GetAvailableTimesQueryQueryVariables>;
export const SearchSpecificSlotQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchSpecificSlotQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LivanceApiBuscaHorarioLivreInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiBuscaHorarioLivre"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autorizado"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"tipoHorarioSugestao"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}},{"kind":"Field","name":{"kind":"Name","value":"podeExceder"}}]}}]}}]} as unknown as DocumentNode<SearchSpecificSlotQueryQuery, SearchSpecificSlotQueryQueryVariables>;
export const AppointmentTypeDurationSuggestionAlertQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentTypeDurationSuggestionAlertQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"sugestaoDuracao"},"name":{"kind":"Name","value":"LivanceApiBuscaUsuarioCompromissoSugestaoDuracao"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"novaDuracao"}},{"kind":"Field","name":{"kind":"Name","value":"deveSugerir"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tipoDeAtendimento"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<AppointmentTypeDurationSuggestionAlertQueryQuery, AppointmentTypeDurationSuggestionAlertQueryQueryVariables>;
export const CreateAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CriarAgendamentoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"criarAgendamento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"agendamentoApiOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RepeatedPatientError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateAppointmentMutation, CreateAppointmentMutationVariables>;
export const PatientSwapMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PatientSwapMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrocarPacienteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trocarPaciente"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"agendamentoApiOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RepeatedPatientError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PatientSwapMutationMutation, PatientSwapMutationMutationVariables>;
export const CreateAppointmentReceivingOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppointmentReceivingOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UsuarioFormaRecebimentoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiCreateUsuarioFormaRecebimento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateAppointmentReceivingOptionMutation, CreateAppointmentReceivingOptionMutationVariables>;
export const UpdateAppointmentReceivingOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAppointmentReceivingOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LivanceApiPatchUsuarioFormaRecebimentoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiPatchUsuarioFormaRecebimento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateAppointmentReceivingOptionMutation, UpdateAppointmentReceivingOptionMutationVariables>;
export const DenyDurationSuggestionMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DenyDurationSuggestionMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromissoTiposStatusSugestaoDuracao"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataUltimaAtualizacao"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_UsuariosCompromissosStatusSugestoesDuracoes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataUltimaAtualizacao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataUltimaAtualizacao"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromissoTiposStatusSugestaoDuracao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromissoTiposStatusSugestaoDuracao"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoTiposStatusSugestaoDuracao"}},{"kind":"Field","name":{"kind":"Name","value":"dataUltimaAtualizacao"}}]}}]}}]} as unknown as DocumentNode<DenyDurationSuggestionMutationMutation, DenyDurationSuggestionMutationMutationVariables>;
export const AcceptDurationSuggestionMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptDurationSuggestionMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duracao"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromissoTiposStatusSugestaoDuracao"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataUltimaAtualizacao"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"duracao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duracao"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_UsuariosCompromissosStatusSugestoesDuracoes_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataUltimaAtualizacao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataUltimaAtualizacao"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromissoTiposStatusSugestaoDuracao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromissoTiposStatusSugestaoDuracao"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"if_matched"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"match_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"codUsuarioCompromisso"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"dataUltimaAtualizacao"},{"kind":"EnumValue","value":"codUsuarioCompromissoTiposStatusSugestaoDuracao"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoTiposStatusSugestaoDuracao"}}]}}]}}]} as unknown as DocumentNode<AcceptDurationSuggestionMutationMutation, AcceptDurationSuggestionMutationMutationVariables>;
export const CreateAppointmentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAppointmentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LivanceApiCriaUsuarioCompromissoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiCriaUsuarioCompromisso"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"response"}}]}}]}}]} as unknown as DocumentNode<CreateAppointmentTypeMutation, CreateAppointmentTypeMutationVariables>;
export const EditAppointmentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EditAppointmentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LivanceApiAlteraUsuarioCompromissoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiAlteraUsuarioCompromissoPatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}}]}}]}}]} as unknown as DocumentNode<EditAppointmentTypeMutation, EditAppointmentTypeMutationVariables>;
export const EnableAutomaticAnticipationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableAutomaticAnticipationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"expensum_event_automatic_anticipation_settings_update_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_expensum_event_automatic_anticipation_settings_update_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EnableAutomaticAnticipationMutationMutation, EnableAutomaticAnticipationMutationMutationVariables>;
export const DisableAutomaticAnticipationMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableAutomaticAnticipationMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_expensum_event_automatic_anticipation_settings_update_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enabled"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DisableAutomaticAnticipationMutationMutation, DisableAutomaticAnticipationMutationMutationVariables>;
export const BankAccountUpdateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BankAccountUpdateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"expensum_event_bank_account_update_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_expensum_event_bank_account_update_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BankAccountUpdateMutationMutation, BankAccountUpdateMutationMutationVariables>;
export const BillingItemDetailsAssistDownloadQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillingItemDetailsAssistDownloadQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assistBillingBatchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"NuntiusGetAssistContactBatchDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contactBatchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assistBillingBatchId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assistContactBatchDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingDate"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"contactId"}},{"kind":"Field","name":{"kind":"Name","value":"contactReason"}},{"kind":"Field","name":{"kind":"Name","value":"contactType"}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}}]}}]}}]}}]} as unknown as DocumentNode<BillingItemDetailsAssistDownloadQueryQuery, BillingItemDetailsAssistDownloadQueryQueryVariables>;
export const BillingItemQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillingItemQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosAlocacoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duracaoEmMinutos"}}]}}]}}]} as unknown as DocumentNode<BillingItemQueryQuery, BillingItemQueryQueryVariables>;
export const BillingQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillingQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cobrancasAbertas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Billings"},"name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingListQueryFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cobrancasFechadas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Billings"},"name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingListQueryFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MovimentacaoExibicao"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCobranca"}},{"kind":"Field","name":{"kind":"Name","value":"codMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"codOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"quantidade"}},{"kind":"Field","name":{"kind":"Name","value":"tempoUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"tipoOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"valorDesconto"}},{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"valorAcrescimo"}},{"kind":"Field","name":{"kind":"Name","value":"nomeUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeTipoMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"identificacaoTipoMovimentacao"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CobrancaExibicao"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCobranca"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"dataVencimento"}},{"kind":"Field","name":{"kind":"Name","value":"movimentacoes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingListItemQueryFragment"}}]}}]}}]} as unknown as DocumentNode<BillingQueryQuery, BillingQueryQueryVariables>;
export const UnsubscribeAssistProMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnsubscribeAssistProMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"telefone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelarPacoteServicosAssistPro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"telefone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"telefone"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnsubscribeAssistProMutationMutation, UnsubscribeAssistProMutationMutationVariables>;
export const ChangeBankingInstitutionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChangeBankingInstitutionQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"expensumRecipient"},"name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeBankingInstitutionQueryQuery, ChangeBankingInstitutionQueryQueryVariables>;
export const GetOnlinePaymentInfoByGuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOnlinePaymentInfoByGuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"onlinePayment"},"name":{"kind":"Name","value":"expensum_online_payment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"guid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetOnlinePaymentInfoByGuidQuery, GetOnlinePaymentInfoByGuidQueryVariables>;
export const ChangeOnlinePaymentStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeOnlinePaymentStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlinePaymentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"expensum_online_payment_activity_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_expensum_online_payment_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlinePaymentId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_expensum_online_payment_activity_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlinePaymentId"}}]}}]}}]} as unknown as DocumentNode<ChangeOnlinePaymentStatusMutation, ChangeOnlinePaymentStatusMutationVariables>;
export const ChangeTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdiantarOuAtrasarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adiantarOuAtrasar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"agendamentoApiOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RepeatedPatientError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChangeTimeMutation, ChangeTimeMutationVariables>;
export const ChangeTimeFormQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChangeTimeFormQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horarios"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"horarios"},"name":{"kind":"Name","value":"LivanceApiBuscaHorarioLivreReagendamento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}},{"kind":"Argument","name":{"kind":"Name","value":"horarios"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horarios"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autorizado"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"motivo"}}]}}]}}]} as unknown as DocumentNode<ChangeTimeFormQueryQuery, ChangeTimeFormQueryQueryVariables>;
export const HandleFavoriteMemberMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HandleFavoriteMemberMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFollowing"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_nexus_follow_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioFollowing"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFollowing"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<HandleFavoriteMemberMutationMutation, HandleFavoriteMemberMutationMutationVariables>;
export const HandleNotFavoriteMemberMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HandleNotFavoriteMemberMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFollowing"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_nexus_follow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioFollowing"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFollowing"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<HandleNotFavoriteMemberMutationMutation, HandleNotFavoriteMemberMutationMutationVariables>;
export const CommunityListFollowersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommunityListFollowersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nomeMembro"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codEspecialidades"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidades"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarios"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"IntValue","value":"0"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"perfisComunidade"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"15"}},{"kind":"Argument","name":{"kind":"Name","value":"stringBusca"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nomeMembro"}}},{"kind":"Argument","name":{"kind":"Name","value":"codUsuarios"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarios"}}},{"kind":"Argument","name":{"kind":"Name","value":"codUnidades"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidades"}}},{"kind":"Argument","name":{"kind":"Name","value":"codEspecialidades"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codEspecialidades"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommunityListMapFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommunityListMapFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PerfisComunidadeConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"listaMembros"},"name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"site"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"ramal"}},{"kind":"Field","name":{"kind":"Name","value":"urlFoto"}},{"kind":"Field","name":{"kind":"Name","value":"follow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFollowing"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFollower"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"especialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]} as unknown as DocumentNode<CommunityListFollowersQueryQuery, CommunityListFollowersQueryQueryVariables>;
export const CommunityListSearchQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommunityListSearchQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nomeMembro"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codEspecialidades"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidades"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"perfisComunidade"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"stringBusca"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nomeMembro"}}},{"kind":"Argument","name":{"kind":"Name","value":"codEspecialidades"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codEspecialidades"}}},{"kind":"Argument","name":{"kind":"Name","value":"codUnidades"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidades"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommunityListMapFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"seguindo"},"name":{"kind":"Name","value":"nexus_follow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioFollower"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFollowing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommunityListMapFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PerfisComunidadeConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"listaMembros"},"name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"site"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"ramal"}},{"kind":"Field","name":{"kind":"Name","value":"urlFoto"}},{"kind":"Field","name":{"kind":"Name","value":"follow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFollowing"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFollower"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"especialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]} as unknown as DocumentNode<CommunityListSearchQueryQuery, CommunityListSearchQueryQueryVariables>;
export const InsertOnlinePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertOnlinePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumCreateOnlinePaymentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumCreateOnlinePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}}]}}]} as unknown as DocumentNode<InsertOnlinePaymentMutation, InsertOnlinePaymentMutationVariables>;
export const SearchPatientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchPatients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nome"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registroVirtual"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nome"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}}]}}]}}]} as unknown as DocumentNode<SearchPatientsQuery, SearchPatientsQueryVariables>;
export const LivanceApiCadastraCartaoMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LivanceApiCadastraCartaoMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardHash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiCadastraNovoCartao"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cardHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardHash"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"cardHash"}}]}}]}}]} as unknown as DocumentNode<LivanceApiCadastraCartaoMutationMutation, LivanceApiCadastraCartaoMutationMutationVariables>;
export const AppointmentDashboardShareReportQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentDashboardShareReportQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyticsMembroRelatorioIndependente"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentosMarcados"}},{"kind":"Field","name":{"kind":"Name","value":"consultasRealizadas"}},{"kind":"Field","name":{"kind":"Name","value":"consultasVirtuais"}},{"kind":"Field","name":{"kind":"Name","value":"mes"}},{"kind":"Field","name":{"kind":"Name","value":"reagendamentos"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosNovos"}},{"kind":"Field","name":{"kind":"Name","value":"consultasPresenciais"}},{"kind":"Field","name":{"kind":"Name","value":"consultasNoShow"}},{"kind":"Field","name":{"kind":"Name","value":"cancelamentosDefinitivos"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosPacienteAtrasado"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosConveniosParaOMes"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosMarcadosParaOMes"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosParticularesParaOMes"}},{"kind":"Field","name":{"kind":"Name","value":"cancelamentos"}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentDashboardShareReportQueryQuery, AppointmentDashboardShareReportQueryQueryVariables>;
export const CustomerContactDashboardShareReportQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerContactDashboardShareReportQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContactsChat"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContactsVoice"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"mainReasonsOccurrences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsChat"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsVoice"}},{"kind":"Field","name":{"kind":"Name","value":"percentCustomerContactsAppointmentsScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsAppointmentsScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsNewAppointmentMainReason"}},{"kind":"Field","name":{"kind":"Name","value":"mostFrequentNotScheduledAppointmentReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalNewCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalOldCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalDigitalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalBeforeFiltering"}},{"kind":"Field","name":{"kind":"Name","value":"totalFiltered"}},{"kind":"Field","name":{"kind":"Name","value":"removedFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}}]}}]} as unknown as DocumentNode<CustomerContactDashboardShareReportQueryQuery, CustomerContactDashboardShareReportQueryQueryVariables>;
export const DashboardFeatureStatusBadgeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardFeatureStatusBadgeQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"funcionalidadesDesativadas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFuncionalidade"}}]}}]}}]} as unknown as DocumentNode<DashboardFeatureStatusBadgeQueryQuery, DashboardFeatureStatusBadgeQueryQueryVariables>;
export const DeleteAppointmentReminderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAppointmentReminder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codLembrete"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lembretes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codLembrete"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codLembrete"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codLembrete"}}]}}]}}]} as unknown as DocumentNode<DeleteAppointmentReminderMutation, DeleteAppointmentReminderMutationVariables>;
export const CreateExtendTimeMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExtendTimeMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstenderAgendamentoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estenderAgendamento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agendamentoApiOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}}]}}]} as unknown as DocumentNode<CreateExtendTimeMutationMutation, CreateExtendTimeMutationMutationVariables>;
export const DisabledFeatureQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DisabledFeatureQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"funcionalidadesDesativadas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFuncionalidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}}]}}]}}]} as unknown as DocumentNode<DisabledFeatureQueryQuery, DisabledFeatureQueryQueryVariables>;
export const DisableFeatureMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableFeatureMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codFuncionalidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_funcionalidadesDesativadas_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codFuncionalidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codFuncionalidade"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}}]}}]}}]} as unknown as DocumentNode<DisableFeatureMutationMutation, DisableFeatureMutationMutationVariables>;
export const EnableFeatureMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableFeatureMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codFuncionalidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_funcionalidadesDesativadas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codFuncionalidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codFuncionalidade"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<EnableFeatureMutationMutation, EnableFeatureMutationMutationVariables>;
export const FeedbackDesiredTimeQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FeedbackDesiredTimeQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tipoDeAtendimento"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"tiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"unidades_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]} as unknown as DocumentNode<FeedbackDesiredTimeQueryQuery, FeedbackDesiredTimeQueryQueryVariables>;
export const FlexiblePriceDrawerQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FlexiblePriceDrawerQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PrecificacoesTiposSalas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"unidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tiposSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosTiposSalas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}]}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"TipoMovimentacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"identificacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"UtilizacaoSala","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoMovimentacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}}]}}]}}]}}]} as unknown as DocumentNode<FlexiblePriceDrawerQueryQuery, FlexiblePriceDrawerQueryQueryVariables>;
export const FollowUpAppointmentReminderInsertMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FollowUpAppointmentReminderInsertMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPaciente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataCadastro"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codTipoLembrete"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataParaEnvio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_lembretes_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codPaciente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPaciente"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoLembrete"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoLembrete"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataCadastro"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataParaEnvio"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codLembrete"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"usuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"dataParaEnvio"}},{"kind":"Field","name":{"kind":"Name","value":"paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"codTipoLembrete"}}]}}]}}]} as unknown as DocumentNode<FollowUpAppointmentReminderInsertMutationMutation, FollowUpAppointmentReminderInsertMutationMutationVariables>;
export const GetLatestTermsOfUseQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestTermsOfUseQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"termsOfUse"},"name":{"kind":"Name","value":"terms_of_use"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"release_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"release_date"}}]}}]}}]} as unknown as DocumentNode<GetLatestTermsOfUseQueryQuery, GetLatestTermsOfUseQueryQueryVariables>;
export const InsertTermsOfUseAgreementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertTermsOfUseAgreement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreedFromIp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"termsOfUseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"livanceCoreId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"insertTerms"},"name":{"kind":"Name","value":"insert_users_terms_of_use_agreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"terms_of_use_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"termsOfUseId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"livance_core_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"livanceCoreId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"agreed_from_ip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreedFromIp"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertTermsOfUseAgreementMutation, InsertTermsOfUseAgreementMutationVariables>;
export const HomeNextSchedulesSectionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeNextSchedulesSectionQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"today"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeNextSchedulesCarouselQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"pagar"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentosVinculados"},"name":{"kind":"Name","value":"AgendamentosVinculados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoTipoVinculo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"checkin"},"name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCheckin"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"atraso"},"name":{"kind":"Name","value":"notificacoesPacientesAtrasados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempoAtraso"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoTipoTag"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeNextSchedulesCarouselQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"today"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"2"},{"kind":"IntValue","value":"4"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentoPreAlocacao"},"name":{"kind":"Name","value":"AgendamentoPreAlocacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentoAlocacaoAtiva"},"name":{"kind":"Name","value":"AgendamentosAlocacoesAtivas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UsuariosCompromissosTiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemFragment"}}]}}]}}]} as unknown as DocumentNode<HomeNextSchedulesSectionQueryQuery, HomeNextSchedulesSectionQueryQueryVariables>;
export const HomeSectionLivanceAssistQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeSectionLivanceAssistQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromStr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toStr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDateTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDateTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeSectionLivanceAssistCardGroupQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeSectionLivanceAssistCardGroupQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"customerContactData"},"name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromStr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toStr"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","alias":{"kind":"Name","value":"convertedAppointmentsPercent"},"name":{"kind":"Name","value":"percentCustomerContactsAppointmentsScheduled"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rescueAppointmentsData"},"name":{"kind":"Name","value":"analyticsMembroTotalDeAgendamentosResgatadosPorFluxo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromStr"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toStr"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointments"},"name":{"kind":"Name","value":"agendamentosRecuperados"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lembretes"},"name":{"kind":"Name","value":"lembretes_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDateTime"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDateTime"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataEnviado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lembretesEnviados"},"name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"total"},"name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<HomeSectionLivanceAssistQueryQuery, HomeSectionLivanceAssistQueryQueryVariables>;
export const HomeSectionLivancePayQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeSectionLivancePayQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateStartAction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateEndAction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateStartCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateEndCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeSectionLivancePayCardGroupFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"expensumRecipient"},"name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagarmeId"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeSectionLivancePayCardGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"pagosOnline"},"name":{"kind":"Name","value":"expensum_online_payment_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStartCount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEndCount"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"paid","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pendentesOnline"},"name":{"kind":"Name","value":"expensum_online_payment_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStartCount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEndCount"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"pending","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pagosTotem"},"name":{"kind":"Name","value":"expensum_appointment_paid_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStartCount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEndCount"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pendentesTotem"},"name":{"kind":"Name","value":"expensum_event_totem_payment_sent_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStartCount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEndCount"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"BooleanValue","value":true}}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetPaymentsChartsInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"intervalEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateEndAction"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"intervalStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateStartAction"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"periodicity"},"value":{"kind":"StringValue","value":"monthly","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervalEnd"}},{"kind":"Field","name":{"kind":"Name","value":"intervalStart"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totemPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"expensumRecipient"},"name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagarmeId"}}]}}]}}]}}]} as unknown as DocumentNode<HomeSectionLivancePayQueryQuery, HomeSectionLivancePayQueryQueryVariables>;
export const HomeSectionOneLivQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeSectionOneLivQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_membro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locus_conselho_profissional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeSectionOneLivActiveFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeSectionOneLivActiveFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LocusGetProfileCompletionPercentage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"porcentagemPerfil"}},{"kind":"Field","name":{"kind":"Name","value":"pendente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"experiencias"}},{"kind":"Field","name":{"kind":"Name","value":"faqs"}},{"kind":"Field","name":{"kind":"Name","value":"focosTratamentos"}},{"kind":"Field","name":{"kind":"Name","value":"membroFormacoes"}},{"kind":"Field","name":{"kind":"Name","value":"sobre"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<HomeSectionOneLivQueryQuery, HomeSectionOneLivQueryQueryVariables>;
export const LinkDestinationSelectInputQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LinkDestinationSelectInputQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linksDestinos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codLinkDestino"}}]}}]}}]} as unknown as DocumentNode<LinkDestinationSelectInputQueryQuery, LinkDestinationSelectInputQueryQueryVariables>;
export const UpdateMemberAdditionalInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMemberAdditionalInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setObject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateMember"},"name":{"kind":"Name","value":"update_locus_membro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setObject"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateMemberAdditionalInfoMutation, UpdateMemberAdditionalInfoMutationVariables>;
export const ActivateMemberProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateMemberProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateMember"},"name":{"kind":"Name","value":"update_locus_membro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<ActivateMemberProfileMutationMutation, ActivateMemberProfileMutationMutationVariables>;
export const UpsertBasicProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertBasicProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocusUpsertBasicProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LocusUpsertBasicProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertBasicProfileMutation, UpsertBasicProfileMutationVariables>;
export const DisableMemberProfileMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableMemberProfileMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setObject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateMember"},"name":{"kind":"Name","value":"update_locus_membro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setObject"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DisableMemberProfileMutationMutation, DisableMemberProfileMutationMutationVariables>;
export const InsertAndUpdateMembroFormacoesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertAndUpdateMembroFormacoes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro_formacao_updates"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inserts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro_formacao_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro_formacao_bool_exp"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_locus_membro_formacao_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_locus_membro_formacao"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inserts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_locus_membro_formacao"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletes"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertAndUpdateMembroFormacoesMutation, InsertAndUpdateMembroFormacoesMutationVariables>;
export const UpdateMemberExperiencesMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMemberExperiencesMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_experiencia_membro_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_locus_experiencia_membro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"experiencia_membro_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"experiencia"},{"kind":"EnumValue","value":"deletado"}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateMemberExperiencesMutationMutation, UpdateMemberExperiencesMutationMutationVariables>;
export const UpdateMemberFaqMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMemberFAQMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_faq_membro_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_locus_faq_membro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"faq_membro_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"pergunta"},{"kind":"EnumValue","value":"resposta"},{"kind":"EnumValue","value":"deletado"}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateMemberFaqMutationMutation, UpdateMemberFaqMutationMutationVariables>;
export const InsertAndUpdateMembroInstituicoesMedicasMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertAndUpdateMembroInstituicoesMedicasMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro_instituicao_medica_updates"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inserts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro_instituicao_medica_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deletes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro_instituicao_medica_bool_exp"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_locus_membro_instituicao_medica_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_locus_membro_instituicao_medica"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inserts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_locus_membro_instituicao_medica"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deletes"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertAndUpdateMembroInstituicoesMedicasMutationMutation, InsertAndUpdateMembroInstituicoesMedicasMutationMutationVariables>;
export const UpdateMemberSocialMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMemberSocialMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocusUpdateMemberSocialMediaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LocusUpdateMemberSocialMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateMemberSocialMediaMutation, UpdateMemberSocialMediaMutationVariables>;
export const UpdateMemberTreatmentFocusMMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMemberTreatmentFocusMMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"locus_foco_tratamento_membro_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_locus_foco_tratamento_membro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"foco_tratamento_membro_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"focoTratamento"},{"kind":"EnumValue","value":"deletado"}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateMemberTreatmentFocusMMutationMutation, UpdateMemberTreatmentFocusMMutationMutationVariables>;
export const PatientPhotoQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientPhotoQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPaciente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"patient"},"name":{"kind":"Name","value":"pacientes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPaciente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPaciente"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foto"}}]}}]}}]} as unknown as DocumentNode<PatientPhotoQueryQuery, PatientPhotoQueryQueryVariables>;
export const MyMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MyMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PacienteGraphQLInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alterarPaciente"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"paciente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientData"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pacienteGraphQL"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"cpfProprio"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"receberWhatsAppConfirmacao"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneProprio"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}}]}}]}}]}}]} as unknown as DocumentNode<MyMutationMutation, MyMutationMutationVariables>;
export const CancelTotemPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelTotemPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumCancelTotemPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}}]} as unknown as DocumentNode<CancelTotemPaymentMutation, CancelTotemPaymentMutationVariables>;
export const ReceiveRoomNowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReceiveRoomNow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReceberSalaAgoraInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receberSalaAgora"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"agendamentoApiOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RepeatedPatientError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReceiveRoomNowMutation, ReceiveRoomNowMutationVariables>;
export const RecipientEmptyStateWrapperQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecipientEmptyStateWrapperQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"expensumRecipient"},"name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagarmeId"}}]}}]}}]}}]} as unknown as DocumentNode<RecipientEmptyStateWrapperQueryQuery, RecipientEmptyStateWrapperQueryQueryVariables>;
export const RecipientInvalidAlertWrapperQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecipientInvalidAlertWrapperQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"expensumRecipient"},"name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<RecipientInvalidAlertWrapperQueryQuery, RecipientInvalidAlertWrapperQueryQueryVariables>;
export const IndicateMemberForPatientMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IndicateMemberForPatientMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IndicarProfissionalInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indicarProfissional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sucesso"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IndicateMemberForPatientMutationMutation, IndicateMemberForPatientMutationMutationVariables>;
export const RecommendationMembersForPatientQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecommendationMembersForPatientQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nomeMembro"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"perfisPublicos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"nomeMembro"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nomeMembro"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MembersListFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MembersListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PerfisPublicosConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"listaMembros"},"name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"especialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]} as unknown as DocumentNode<RecommendationMembersForPatientQueryQuery, RecommendationMembersForPatientQueryQueryVariables>;
export const RecommendationPatientsForMemberQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecommendationPatientsForMemberQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registroVirtual"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListItemFragment"}}]}}]}}]} as unknown as DocumentNode<RecommendationPatientsForMemberQueryQuery, RecommendationPatientsForMemberQueryQueryVariables>;
export const PatientPaymentRefundMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PatientPaymentRefundMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"acquirerTransactionKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumChargeCancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"acquirerTransactionKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"acquirerTransactionKey"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<PatientPaymentRefundMutationMutation, PatientPaymentRefundMutationMutationVariables>;
export const RemoveUnavailableSlotMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUnavailableSlotMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codFechamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiDeleteFechamento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codFechamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codFechamento"}}}]}]}}]} as unknown as DocumentNode<RemoveUnavailableSlotMutationMutation, RemoveUnavailableSlotMutationMutationVariables>;
export const RescheduleAppointmentApiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RescheduleAppointmentApi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemarcarAgendamentoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remarcarAgendamento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"agendamentoApiOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RepeatedPatientError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RescheduleAppointmentApiMutation, RescheduleAppointmentApiMutationVariables>;
export const CreateReservedScheduleMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReservedScheduleMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horaFim"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"margemInicial"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrenteFrequencia"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiCriaPeriodoGarantidoRecorrente"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"periodoGarantidoRecorrente"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"horaFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaFim"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"margemInicial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"margemInicial"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrenteFrequencia"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrenteFrequencia"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateReservedScheduleMutationMutation, CreateReservedScheduleMutationMutationVariables>;
export const ReturnRoomMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReturnRoomMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizaAlocacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sucesso"}}]}}]}}]} as unknown as DocumentNode<ReturnRoomMutationMutation, ReturnRoomMutationMutationVariables>;
export const CreateScheduleMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScheduleMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LivanceApiCreateUsuarioAgendaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiCreateUsuarioAgenda"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateScheduleMutationMutation, CreateScheduleMutationMutationVariables>;
export const UpdateScheduleMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateScheduleMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LivanceApiPatchUsuarioAgendaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiPatchUsuarioAgenda"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateScheduleMutationMutation, UpdateScheduleMutationMutationVariables>;
export const UpsertSecretaryDetailsAppointmentInfosMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSecretaryDetailsAppointmentInfosMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_usuariosProfissionaisOrientacoesSecretarias_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if_matched"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"match_columns"},"value":{"kind":"EnumValue","value":"codUsuario"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"informacoesSobreAgendamento"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"informacoesSobreAgendamento"}}]}}]}}]} as unknown as DocumentNode<UpsertSecretaryDetailsAppointmentInfosMutationMutation, UpsertSecretaryDetailsAppointmentInfosMutationMutationVariables>;
export const UpsertSecretaryDetailsFaqMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSecretaryDetailsFaqMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_usuariosProfissionaisOrientacoesSecretarias_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if_matched"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"match_columns"},"value":{"kind":"EnumValue","value":"codUsuario"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"informacoesDuvidasFrequentes"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"informacoesDuvidasFrequentes"}}]}}]}}]} as unknown as DocumentNode<UpsertSecretaryDetailsFaqMutationMutation, UpsertSecretaryDetailsFaqMutationMutationVariables>;
export const UpsertSecretaryDetailsProfessionalInfosMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSecretaryDetailsProfessionalInfosMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_usuariosProfissionaisOrientacoesSecretarias_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if_matched"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"match_columns"},"value":{"kind":"EnumValue","value":"codUsuario"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"informacoesSobreProfissional"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"informacoesSobreProfissional"}}]}}]}}]} as unknown as DocumentNode<UpsertSecretaryDetailsProfessionalInfosMutationMutation, UpsertSecretaryDetailsProfessionalInfosMutationMutationVariables>;
export const UpsertSecretaryDetailsRestrictionsMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSecretaryDetailsRestrictionsMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_usuariosProfissionaisOrientacoesSecretarias_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if_matched"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"match_columns"},"value":{"kind":"EnumValue","value":"codUsuario"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"EnumValue","value":"informacoesSobreRestricoes"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"informacoesSobreRestricoes"}}]}}]}}]} as unknown as DocumentNode<UpsertSecretaryDetailsRestrictionsMutationMutation, UpsertSecretaryDetailsRestrictionsMutationMutationVariables>;
export const SendPaymentMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPaymentMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"expensum_event_totem_payment_sent_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentSent"},"name":{"kind":"Name","value":"insert_expensum_event_totem_payment_sent_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SendPaymentMutationMutation, SendPaymentMutationMutationVariables>;
export const AcceptLivanceAssistMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptLivanceAssistMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contratarPacoteServicos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codPacoteServico"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contratarPacoteServicosOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPacoteServico"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AcceptLivanceAssistMutationMutation, AcceptLivanceAssistMutationMutationVariables>;
export const UnavailableSlotCreateMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnavailableSlotCreateMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CriarMultiplosFechamentosInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"criarMultiplosFechamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"data"},"name":{"kind":"Name","value":"fechamentoApiOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFechamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UnavailableSlotCreateMutationMutation, UnavailableSlotCreateMutationMutationVariables>;
export const UpsertPublicPhoneMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertPublicPhoneMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"telefone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atualizarTelefonePublico"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"telefone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"telefone"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"boolean"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertPublicPhoneMutationMutation, UpsertPublicPhoneMutationMutationVariables>;
export const UserTrackableLinkReportDetailListItemQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserTrackableLinkReportDetailListItemQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codLinkRastreamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataCadastro"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userTrackableLinkReportDetails"},"name":{"kind":"Name","value":"analyticsMembroDadosDeUsuarioLinkRastreamento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codLinkRastreamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codLinkRastreamento"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataAcesso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataCadastro"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAcesso"}},{"kind":"Field","name":{"kind":"Name","value":"totalAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"totalUso"}},{"kind":"Field","name":{"kind":"Name","value":"totalRecebido"}},{"kind":"Field","name":{"kind":"Name","value":"totalBuscasRealizadas"}}]}}]}}]}}]} as unknown as DocumentNode<UserTrackableLinkReportDetailListItemQueryQuery, UserTrackableLinkReportDetailListItemQueryQueryVariables>;
export const CreateTrackableLinkMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTrackableLinkMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CriarUsuarioLinkRastreamentoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"criarUsuarioLinkRastreamento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"criarUsuarioLinkRastreamentoOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioLinkRastreamento"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTrackableLinkMutationMutation, CreateTrackableLinkMutationMutationVariables>;
export const CriaTagAgendamentoAtendidoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"criaTagAgendamentoAtendido"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentoAtendido"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sucesso"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CriaTagAgendamentoAtendidoMutation, CriaTagAgendamentoAtendidoMutationVariables>;
export const RemoveTagAgendamentoAtendidoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeTagAgendamentoAtendido"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentoNaoAtendido"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sucesso"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RemoveTagAgendamentoAtendidoMutation, RemoveTagAgendamentoAtendidoMutationVariables>;
export const EnsureRecipientHasAcceptedTermsOfUseQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EnsureRecipientHasAcceptedTermsOfUseQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"recipientTermsOfUseAgreed"},"name":{"kind":"Name","value":"expensum_recipient_terms_of_use_agreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"termsOfUse"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<EnsureRecipientHasAcceptedTermsOfUseQueryQuery, EnsureRecipientHasAcceptedTermsOfUseQueryQueryVariables>;
export const UserQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuarios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"apelido"}},{"kind":"Field","name":{"kind":"Name","value":"codPerfil"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sobrenome"}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioProfissional"},"name":{"kind":"Name","value":"UsuariosProfissionai"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codConselhoClasse"}},{"kind":"Field","name":{"kind":"Name","value":"bloqueado"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicioDivida"}},{"kind":"Field","name":{"kind":"Name","value":"dataValidacao"}},{"kind":"Field","name":{"kind":"Name","value":"usuarioTelefone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ramalTroncoNormalizado"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"userTermsOfUse"},"name":{"kind":"Name","value":"UserTermsOfUse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agreed_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"termsOfUseId"},"name":{"kind":"Name","value":"terms_of_use_id"}},{"kind":"Field","alias":{"kind":"Name","value":"agreedAt"},"name":{"kind":"Name","value":"agreed_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"especialidades"},"name":{"kind":"Name","value":"UsuariosEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"clinicas"},"name":{"kind":"Name","value":"tbClinicas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codClinica"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"integracoes"},"name":{"kind":"Name","value":"tbUsuariosIntegracoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codParceiro"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codParceiro"}}]}},{"kind":"Field","name":{"kind":"Name","value":"membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altaTaxaCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"funcionalidadesContratadas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFuncionalidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"contratada"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pacotesServicos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicos"}},{"kind":"Field","name":{"kind":"Name","value":"dataDesativacao"}},{"kind":"Field","name":{"kind":"Name","value":"dataContratacao"}},{"kind":"Field","name":{"kind":"Name","value":"dataFimTrial"}},{"kind":"Field","name":{"kind":"Name","value":"trialAtivo"}},{"kind":"Field","name":{"kind":"Name","value":"trialFinalizado"}},{"kind":"Field","name":{"kind":"Name","value":"grupoUpgrade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioPacoteServicos"}},{"kind":"Field","name":{"kind":"Name","value":"pacoteServicoPreco"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioVariavel"}},{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioFixo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"possivelDataFimTrialAssistPro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataFimTrialAssistPro"}},{"kind":"Field","name":{"kind":"Name","value":"temTrialDisponivel"}}]}}]}}]}}]} as unknown as DocumentNode<UserQueryQuery, UserQueryQueryVariables>;
export const RescheduleAppointmentFlexiblePricingPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RescheduleAppointmentFlexiblePricingPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RescheduleAppointmentFlexiblePriceFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescheduleAppointmentFlexiblePriceFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioWhatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpfProprio"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidadesPrecosFlexiveis"},"name":{"kind":"Name","value":"UnidadesPrecosFlexiveis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxaDesconto"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"periodosGarantidos"},"name":{"kind":"Name","value":"tbPeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"horaFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UsuariosCompromissosTiposSalas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}}]}}]}}]} as unknown as DocumentNode<RescheduleAppointmentFlexiblePricingPageQueryQuery, RescheduleAppointmentFlexiblePricingPageQueryQueryVariables>;
export const PatientSwapSearchPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientSwapSearchPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointment"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientSwapPatientListFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentPatientListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registroVirtual"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientSwapPatientListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentPatientListFragment"}}]}}]} as unknown as DocumentNode<PatientSwapSearchPageQueryQuery, PatientSwapSearchPageQueryQueryVariables>;
export const PatientSwapPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientSwapPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentPatientSwapFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentPatientSwapFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneProprio"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioWhatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"UsuariosCompromissosTiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PatientSwapPageQueryQuery, PatientSwapPageQueryQueryVariables>;
export const RescheduleAppointmentPatientPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RescheduleAppointmentPatientPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RescheduleAppointmentPatientFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescheduleAppointmentPatientFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneProprio"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioWhatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receberWhatsAppConfirmacao"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"cpfProprio"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"newAppointmentType"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}},{"kind":"Field","name":{"kind":"Name","value":"tiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unidadesPrecosFlexiveis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadesPrecosFlexiveisParceirosIntegracoes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"newUnit"},"name":{"kind":"Name","value":"unidades_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]} as unknown as DocumentNode<RescheduleAppointmentPatientPageQueryQuery, RescheduleAppointmentPatientPageQueryQueryVariables>;
export const ReschedulePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReschedulePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentFormFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockedActionsListAlertFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosFormasRecebimentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasCompromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"3"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuarioCompromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosCompromissosFormasRecebimentos"},"name":{"kind":"Name","value":"tbUsuariosCompromissosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethodsListToSelectQueryFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioAgenda"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Unidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasDiasSemanas"},"name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosFormasRecebimentosAggregate"},"name":{"kind":"Name","value":"usuariosFormasRecebimentos_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalidadesAgendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"3"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobrancaAtraso"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockedActionsListAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listaAcoesBloqueadas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAcao"}}]}}]}}]} as unknown as DocumentNode<ReschedulePageQueryQuery, ReschedulePageQueryQueryVariables>;
export const AppointmentFlexiblePricePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentFlexiblePricePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"time"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentFlexiblePriceFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentFlexiblePriceFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"unidadesPrecosFlexiveis"},"name":{"kind":"Name","value":"UnidadesPrecosFlexiveis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxaDesconto"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"unidades_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"periodosGarantidos"},"name":{"kind":"Name","value":"tbPeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"horaFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"UsuariosCompromissosTiposSalas"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}}]}}]}}]} as unknown as DocumentNode<AppointmentFlexiblePricePageQueryQuery, AppointmentFlexiblePricePageQueryQueryVariables>;
export const AppointmentPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPaciente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentFormFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockedActionsListAlertFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"pacientes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPaciente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPaciente"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"receberWhatsAppConfirmacao"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosFormasRecebimentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasCompromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"3"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuarioCompromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosCompromissosFormasRecebimentos"},"name":{"kind":"Name","value":"tbUsuariosCompromissosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethodsListToSelectQueryFragment"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioAgenda"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"Unidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasDiasSemanas"},"name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosFormasRecebimentosAggregate"},"name":{"kind":"Name","value":"usuariosFormasRecebimentos_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalidadesAgendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"3"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobrancaAtraso"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockedActionsListAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listaAcoesBloqueadas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAcao"}}]}}]}}]} as unknown as DocumentNode<AppointmentPageQueryQuery, AppointmentPageQueryQueryVariables>;
export const AppointmentPatientPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentPatientPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentFormPatientFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentFormPatientFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentType"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}},{"kind":"Field","name":{"kind":"Name","value":"tiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unidadesPrecosFlexiveis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadesPrecosFlexiveisParceirosIntegracoes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unit"},"name":{"kind":"Name","value":"unidades_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]} as unknown as DocumentNode<AppointmentPatientPageQueryQuery, AppointmentPatientPageQueryQueryVariables>;
export const AppointmentPatientSearchPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentPatientSearchPageQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreateAppointmentPatientListFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentPatientListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registroVirtual"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreateAppointmentPatientListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentPatientListFragment"}}]}}]} as unknown as DocumentNode<AppointmentPatientSearchPageQueryQuery, AppointmentPatientSearchPageQueryQueryVariables>;
export const UnavailableSlotPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnavailableSlotPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codFechamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tbFechamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFechamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codFechamento"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoFechamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoFechamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"3"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoFechamento"}}]}}]}}]} as unknown as DocumentNode<UnavailableSlotPageQuery, UnavailableSlotPageQueryVariables>;
export const CalendarPageScheduleQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalendarPageScheduleQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Unidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsBySchedulesQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockedActionsListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimePoliciesQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleSlotsFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockedActionsListAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listaAcoesBloqueadas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAcao"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimePoliciesHomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unidadesPoliticasDeHorarios"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"politica"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidadePoliticaDeHorario"}},{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeSchedulesSlotsHomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiUsuarioAgendaAtivosPorUsuario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"dataFim"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendasUnidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendasDiasSemanas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsBySchedulesQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Unidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockedActionsListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockedActionsListAlertFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimePoliciesQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimePoliciesHomeCalendarDayEventFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleSlotsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeSchedulesSlotsHomeCalendarDayEventFragment"}}]}}]} as unknown as DocumentNode<CalendarPageScheduleQueryQuery, CalendarPageScheduleQueryQueryVariables>;
export const CalendarPageAppointmentsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalendarPageAppointmentsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataInicioToString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataFimToString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availableAppointmentsPurpose"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentsQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HolidaysQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomePageCalendarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FinalidadesAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableAppointmentsPurpose"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FinalidadesAgendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobrancaAtraso"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tbFechamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"motivo"}},{"kind":"Field","name":{"kind":"Name","value":"codFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"tbUnidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FinalidadesAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableAppointmentsPurpose"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FinalidadesAgendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobrancaAtraso"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tbFechamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"motivo"}},{"kind":"Field","name":{"kind":"Name","value":"codFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFechamento"}},{"kind":"Field","name":{"kind":"Name","value":"tbUnidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HolidaysHomeCalendarDayEventFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiFeriadosPorPeriodo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicioToString"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFimToString"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codFeriado"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"dia"}},{"kind":"Field","name":{"kind":"Name","value":"mes"}},{"kind":"Field","name":{"kind":"Name","value":"ano"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomePageCalendarFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeCalendarDayEventFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HolidaysQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HolidaysHomeCalendarDayEventFragment"}}]}}]} as unknown as DocumentNode<CalendarPageAppointmentsQueryQuery, CalendarPageAppointmentsQueryQueryVariables>;
export const CalendarPageFreeSlotsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CalendarPageFreeSlotsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeScheduleSlotsFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeSchedulesSlotsHomePageCalendarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiBuscaSelecionaFaixasLivresAgenda"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataFim"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}},{"kind":"Field","name":{"kind":"Name","value":"podeExceder"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"autorizado"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FreeScheduleSlotsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FreeSchedulesSlotsHomePageCalendarFragment"}}]}}]} as unknown as DocumentNode<CalendarPageFreeSlotsQueryQuery, CalendarPageFreeSlotsQueryQueryVariables>;
export const UnavailableSlotsPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UnavailableSlotsPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnavailableSlotFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnavailableSlotFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Unidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"}}]}}]}}]}}]} as unknown as DocumentNode<UnavailableSlotsPageQueryQuery, UnavailableSlotsPageQueryQueryVariables>;
export const ExtendTimePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExtendTimePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExtendTimeFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExtendTimeFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiBuscaHorariosParaEstender"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataHora"}},{"kind":"Field","name":{"kind":"Name","value":"dataHoraFim"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"tipoHorarioSugestao"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"activeAllocation"},"name":{"kind":"Name","value":"AgendamentosAlocacoesAtivas_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"Agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duracao"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExtendTimePageQueryQuery, ExtendTimePageQueryQueryVariables>;
export const HomePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeProfileHeaderFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeProfileHeaderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"profilePictureFile"},"name":{"kind":"Name","value":"LivanceApiSelecionaFotoDePerfil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arquivo"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]} as unknown as DocumentNode<HomePageQuery, HomePageQueryVariables>;
export const GetOneLivUserAdditionalInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneLivUserAdditionalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivAdditionalInfoFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivAdditionalInfoFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"sobre"}},{"kind":"Field","name":{"kind":"Name","value":"maisInformacoes"}}]}}]} as unknown as DocumentNode<GetOneLivUserAdditionalInfoQuery, GetOneLivUserAdditionalInfoQueryVariables>;
export const GetOneLivUserBasicInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneLivUserBasicInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivBasicInfoFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSpecialtySelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_especialidade"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSubspecialtySelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_especialidade"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialidadeSubespecialidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subespecialidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"especialista"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subespecialidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSpecialtiesInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"specialties"},"name":{"kind":"Name","value":"locus_especialidade"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"especialista"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codEspecialidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"especialista"}},{"kind":"Field","name":{"kind":"Name","value":"conselhoProfissionalEspecialidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"conselhoProfissional"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idConselhoProfissional"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivSpecialtySelectInputFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivSubspecialtySelectInputFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"professionalCouncil"},"name":{"kind":"Name","value":"locus_conselho_profissional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sigla"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"CRM","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivProfessionalCouncilSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"professionalCouncils"},"name":{"kind":"Name","value":"locus_conselho_profissional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivBasicInfoFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"apelido"}},{"kind":"Field","name":{"kind":"Name","value":"pronome"}},{"kind":"Field","name":{"kind":"Name","value":"ufConselhoClasse"}},{"kind":"Field","name":{"kind":"Name","value":"numeroConselhoClasse"}},{"kind":"Field","name":{"kind":"Name","value":"duracaoInicialConsulta"}},{"kind":"Field","name":{"kind":"Name","value":"valorInicialConsulta"}},{"kind":"Field","name":{"kind":"Name","value":"formasPagamento"}},{"kind":"Field","name":{"kind":"Name","value":"resumo"}},{"kind":"Field","name":{"kind":"Name","value":"fotoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idConselhoProfissional"}},{"kind":"Field","name":{"kind":"Name","value":"membroEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rqe"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}},{"kind":"Field","name":{"kind":"Name","value":"idEspecialidade"}},{"kind":"Field","name":{"kind":"Name","value":"membroEspecialidadeSubespecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSubespecialidade"}},{"kind":"Field","name":{"kind":"Name","value":"rqe"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivSpecialtiesInputFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivProfessionalCouncilSelectInputFragment"}}]}}]} as unknown as DocumentNode<GetOneLivUserBasicInfoQuery, GetOneLivUserBasicInfoQueryVariables>;
export const GetOneLivUserEducationalBackgroundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneLivUserEducationalBackground"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivEducationalBackgroundFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivCoursesSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_curso_formacao"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivEducationalInstitutionSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_instituicao_ensino"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivEducationalBackgroundFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"membro"},"name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"membroFormacao"},"name":{"kind":"Name","value":"locus_membro_formacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conclusao"}},{"kind":"Field","name":{"kind":"Name","value":"idCurso"}},{"kind":"Field","name":{"kind":"Name","value":"idInstituicaoEnsino"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cursos"},"name":{"kind":"Name","value":"locus_curso_formacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivCoursesSelectInputFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"instituicoesEnsino"},"name":{"kind":"Name","value":"locus_instituicao_ensino"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivEducationalInstitutionSelectInputFragment"}}]}}]}}]} as unknown as DocumentNode<GetOneLivUserEducationalBackgroundQuery, GetOneLivUserEducationalBackgroundQueryVariables>;
export const GetOneLivUserExperiencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneLivUserExperiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivExperiencesFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivExperiencesFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"experiencias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"experiencia"}}]}}]}}]} as unknown as DocumentNode<GetOneLivUserExperiencesQuery, GetOneLivUserExperiencesQueryVariables>;
export const GetOneLivUserFaqDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneLivUserFAQ"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivFAQFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivFAQFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"faqs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pergunta"}},{"kind":"Field","name":{"kind":"Name","value":"resposta"}}]}}]}}]} as unknown as DocumentNode<GetOneLivUserFaqQuery, GetOneLivUserFaqQueryVariables>;
export const GetOneLivUserMedicalInstitutionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneLivUserMedicalInstitutions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivMedicalInstitutionsFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivMedicalInstitutionsSelectInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_instituicao_medica"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivMedicalInstitutionsFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"membro"},"name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"membroInstituicoesMedicas"},"name":{"kind":"Name","value":"locus_membro_instituicao_medica"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idInstituicaoMedica"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"instituicoesMedicas"},"name":{"kind":"Name","value":"locus_instituicao_medica"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivMedicalInstitutionsSelectInputFragment"}}]}}]}}]} as unknown as DocumentNode<GetOneLivUserMedicalInstitutionsQuery, GetOneLivUserMedicalInstitutionsQueryVariables>;
export const GetOneLivUserSocialMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneLivUserSocialMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivSocialMediaFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivSocialMediaFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_rede_social_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redeSocial"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetOneLivUserSocialMediaQuery, GetOneLivUserSocialMediaQueryVariables>;
export const GetOneLivUserTreatmentFocusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneLivUserTreatmentFocus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivTreatmentFocusFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivTreatmentFocusFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"locus_membro"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"focosTratamentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"focoTratamento"}}]}}]}}]} as unknown as DocumentNode<GetOneLivUserTreatmentFocusQuery, GetOneLivUserTreatmentFocusQueryVariables>;
export const GetOneLivUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOneLivUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetOneLivUserQuery, GetOneLivUserQueryVariables>;
export const PatientDetailPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientDetailPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"today"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"patient"},"name":{"kind":"Name","value":"pacientes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPaciente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientDetailActionListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientDetailPropertyListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientHistoryListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientDetailHeaderFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientDetailHeaderActionsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientDetailLastAppointmentFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientDetailTabsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailPropertyListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"receberWhatsAppConfirmacao"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientHistoryListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"},{"kind":"IntValue","value":"3"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoOrigem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentoAlocacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailActionListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailHeaderFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailHeaderActionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailLastAppointmentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lastAppointment"},"name":{"kind":"Name","value":"Agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"},{"kind":"IntValue","value":"3"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoOrigem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"reminders"},"name":{"kind":"Name","value":"lembretes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataEnviado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"today"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientDetailTabsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientDetailPropertyListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientHistoryListFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}}]}}]} as unknown as DocumentNode<PatientDetailPageQueryQuery, PatientDetailPageQueryQueryVariables>;
export const PatientUpdatePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientUpdatePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"patient"},"name":{"kind":"Name","value":"pacientes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPaciente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientUpdateFormQuery"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientUpdateFormQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"cpfProprio"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"receberWhatsAppConfirmacao"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneProprio"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}}]}}]} as unknown as DocumentNode<PatientUpdatePageQueryQuery, PatientUpdatePageQueryQueryVariables>;
export const PatientPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientPageQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registroVirtual"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListItemFragment"}}]}}]}}]} as unknown as DocumentNode<PatientPageQueryQuery, PatientPageQueryQueryVariables>;
export const RecommendationMemberForPatientConfirmationPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RecommendationMemberForPatientConfirmationPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPaciente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codMembro"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RecommendationMembersForPatientFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecommendationMembersForPatientFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"pacientes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPaciente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPaciente"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fotoPerfilMembro"},"name":{"kind":"Name","value":"LivanceApiSelecionaFotoDePerfil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codMembro"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arquivo"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]} as unknown as DocumentNode<RecommendationMemberForPatientConfirmationPageQueryQuery, RecommendationMemberForPatientConfirmationPageQueryQueryVariables>;
export const AceitarPacoteServicosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AceitarPacoteServicos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AceitarPacoteServicosInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aceitarPacoteServicos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aceitarPacoteServicosOutput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicos"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AceitarPacoteServicosMutation, AceitarPacoteServicosMutationVariables>;
export const AssistProAcceptanceCostPredictionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssistProAcceptanceCostPredictionQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServicos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssistProAcceptanceCostPredictionCardFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssistProAcceptanceCostPredictionCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"servicePackage"},"name":{"kind":"Name","value":"pacotesServicos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPacoteServicos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServicos"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPreco"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioFixo"}},{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalDigitalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContacts"}}]}}]}}]} as unknown as DocumentNode<AssistProAcceptanceCostPredictionQueryQuery, AssistProAcceptanceCostPredictionQueryQueryVariables>;
export const CustomerAppointmentOverviewPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerAppointmentOverviewPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyticsMembroRelatorioIndependente"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentDashboardTotalCancelledSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentDashboardCompletedAppointmentsSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentDashboardNoShowSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentDashboardLatePatientsSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentDashboardTotalSchedulesPerAppointmentReceivingOptionsQueryFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDashboardTotalCancelledSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelamentos"}},{"kind":"Field","name":{"kind":"Name","value":"cancelamentosDefinitivos"}},{"kind":"Field","name":{"kind":"Name","value":"mes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDashboardCompletedAppointmentsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mes"}},{"kind":"Field","name":{"kind":"Name","value":"consultasRealizadas"}},{"kind":"Field","name":{"kind":"Name","value":"consultasPresenciais"}},{"kind":"Field","name":{"kind":"Name","value":"consultasVirtuais"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDashboardNoShowSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mes"}},{"kind":"Field","name":{"kind":"Name","value":"consultasNoShow"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDashboardLatePatientsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mes"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosPacienteAtrasado"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDashboardTotalSchedulesPerAppointmentReceivingOptionsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataItemRelatorioIndependente"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentosMarcadosParaOMes"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosParticularesParaOMes"}},{"kind":"Field","name":{"kind":"Name","value":"agendamentosConveniosParaOMes"}},{"kind":"Field","name":{"kind":"Name","value":"mes"}}]}}]} as unknown as DocumentNode<CustomerAppointmentOverviewPageQueryQuery, CustomerAppointmentOverviewPageQueryQueryVariables>;
export const CustomerContactOverviewPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerContactOverviewPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerContactDashboardTotalContactsSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerContactDashboardContactsDistributionSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerContactDashboardSchedulingConversionRateSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerContactDashboardReasonsForNotSchedulingSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerContactDashboardHumanContactsSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerContactDashboardContactReasonSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerContactDashboardContactByTypeSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerContactDashboardContactSummarySectionQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardTotalContactsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsVoice"}},{"kind":"Field","name":{"kind":"Name","value":"percentCustomerContactsVoice"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsChat"}},{"kind":"Field","name":{"kind":"Name","value":"percentCustomerContactsChat"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"percentGrowthTotalCustomerContacts"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardContactsDistributionSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalOldCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"percentOldCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalNewCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"percentNewCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"percentGrowthTotalCustomerContacts"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardSchedulingConversionRateSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"percentCustomerContactsAppointmentsScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsNewAppointmentMainReason"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsAppointmentsScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardReasonsForNotSchedulingSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"mostFrequentNotScheduledAppointmentReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"percent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardHumanContactsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContactsChat"}},{"kind":"Field","name":{"kind":"Name","value":"percentHumanCustomerContactsChat"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContactsVoice"}},{"kind":"Field","name":{"kind":"Name","value":"percentHumanCustomerContactsVoice"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"percentGrowthTotalHumanCustomerContacts"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardContactReasonSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"percentGrowthTotalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"mainReasonsOccurrences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardContactByTypeSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"percentDigitalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"percentHumanCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalDigitalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"percentGrowthTotalCustomerContacts"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerContactDashboardContactSummarySectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NuntiusGetCustomerContactManyPeriodSummaryOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalBeforeFiltering"}},{"kind":"Field","name":{"kind":"Name","value":"totalFiltered"}},{"kind":"Field","name":{"kind":"Name","value":"percentTotalFilteredCustomerContacts"}}]}}]} as unknown as DocumentNode<CustomerContactOverviewPageQueryQuery, CustomerContactOverviewPageQueryQueryVariables>;
export const NuntiusGetCustomerContactPeriodSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NuntiusGetCustomerContactPeriodSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"NuntiusGetCustomerContactPeriodSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContacts"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"totalOldCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"percentOldCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"totalNewCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"percentNewCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"mostFrequentMainReasonId"}},{"kind":"Field","name":{"kind":"Name","value":"totalMostFrequentMainReason"}},{"kind":"Field","name":{"kind":"Name","value":"percentMostFrequentMainReason"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsNewAppointmentMainReason"}},{"kind":"Field","name":{"kind":"Name","value":"totalCustomerContactsAppointmentsScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"percentCustomerContactsAppointmentsScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"mostFrequentNotScheduledAppointmentReasonsIds"}},{"kind":"Field","name":{"kind":"Name","value":"totalAllocatedRooms"}},{"kind":"Field","name":{"kind":"Name","value":"totalAllocatedRoomsOnPeriod"}}]}}]}}]} as unknown as DocumentNode<NuntiusGetCustomerContactPeriodSummaryQuery, NuntiusGetCustomerContactPeriodSummaryQueryVariables>;
export const FollowUpAppointmentReminderPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FollowUpAppointmentReminderPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codTipoLembreteRetorno"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hoje"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FollowUpAppointmentReminderListQuery"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderListItemQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lembretes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codLembrete"}},{"kind":"Field","name":{"kind":"Name","value":"paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataParaEnvio"}},{"kind":"Field","alias":{"kind":"Name","value":"tipoDeAtendimento"},"name":{"kind":"Name","value":"usuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderListQuery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lembretes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoLembrete"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoLembreteRetorno"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataEnviado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hoje"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codLembrete"}},{"kind":"Field","name":{"kind":"Name","value":"paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FollowUpAppointmentReminderListItemQuery"}}]}}]}}]} as unknown as DocumentNode<FollowUpAppointmentReminderPageQueryQuery, FollowUpAppointmentReminderPageQueryQueryVariables>;
export const FollowUpAppointmentReminderPatientsPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FollowUpAppointmentReminderPatientsPageQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneInternacionalNormalizado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"cpf"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"registroVirtual"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientListItemFragment"}}]}}]}}]} as unknown as DocumentNode<FollowUpAppointmentReminderPatientsPageQueryQuery, FollowUpAppointmentReminderPatientsPageQueryQueryVariables>;
export const RescuedAppointmentOverviewPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RescuedAppointmentOverviewPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointments"},"name":{"kind":"Name","value":"analyticsMembroTotalDeAgendamentosResgatadosPorFluxo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RescuedAppointmentsSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RescuedAppointmentDashboardTotalRescuedSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RescuedAppointmentDashboardUnscheduledAppointmentsSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RescuedAppointmentDashboardCancelledAppointmentsSectionQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RescuedAppointmentDashboardNoShowAppointmentsSectionQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescuedAppointmentsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"mes"}},{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointmentType"},"name":{"kind":"Name","value":"fluxo"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentsRescuedSum"},"name":{"kind":"Name","value":"agendamentosRecuperados"}},{"kind":"Field","alias":{"kind":"Name","value":"sentMessagesSum"},"name":{"kind":"Name","value":"totalMensagens"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescuedAppointmentDashboardTotalRescuedSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"mes"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentsRescuedSum"},"name":{"kind":"Name","value":"agendamentosRecuperados"}},{"kind":"Field","alias":{"kind":"Name","value":"sentMessagesSum"},"name":{"kind":"Name","value":"totalMensagens"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescuedAppointmentDashboardUnscheduledAppointmentsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"mes"}},{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointmentType"},"name":{"kind":"Name","value":"fluxo"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentsRescuedSum"},"name":{"kind":"Name","value":"agendamentosRecuperados"}},{"kind":"Field","alias":{"kind":"Name","value":"sentMessagesSum"},"name":{"kind":"Name","value":"totalMensagens"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescuedAppointmentDashboardCancelledAppointmentsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"mes"}},{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointmentType"},"name":{"kind":"Name","value":"fluxo"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentsRescuedSum"},"name":{"kind":"Name","value":"agendamentosRecuperados"}},{"kind":"Field","alias":{"kind":"Name","value":"sentMessagesSum"},"name":{"kind":"Name","value":"totalMensagens"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RescuedAppointmentDashboardNoShowAppointmentsSectionQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AnalyticsMembroTotalDeAgendamentosResgatadosPorFluxo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"month"},"name":{"kind":"Name","value":"mes"}},{"kind":"Field","alias":{"kind":"Name","value":"rescuedAppointmentType"},"name":{"kind":"Name","value":"fluxo"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentsRescuedSum"},"name":{"kind":"Name","value":"agendamentosRecuperados"}},{"kind":"Field","alias":{"kind":"Name","value":"sentMessagesSum"},"name":{"kind":"Name","value":"totalMensagens"}}]}}]}}]} as unknown as DocumentNode<RescuedAppointmentOverviewPageQueryQuery, RescuedAppointmentOverviewPageQueryQueryVariables>;
export const GetSecretaryAppointmentInfosQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSecretaryAppointmentInfosQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentInfosFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentInfosFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personalizeAppointment"},"name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentInfos"},"name":{"kind":"Name","value":"informacoesSobreAgendamento"}}]}}]}}]} as unknown as DocumentNode<GetSecretaryAppointmentInfosQueryQuery, GetSecretaryAppointmentInfosQueryQueryVariables>;
export const GetSecretaryDetailsFaqQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSecretaryDetailsFaqQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecretaryDetailsFaqFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecretaryDetailsFaqFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personalizeAppointment"},"name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Faq"},"name":{"kind":"Name","value":"informacoesDuvidasFrequentes"}}]}}]}}]} as unknown as DocumentNode<GetSecretaryDetailsFaqQueryQuery, GetSecretaryDetailsFaqQueryQueryVariables>;
export const GetSecretaryDetailsPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSecretaryDetailsPageQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonalizeAppointmentFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonalizeAppointmentFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personalizeAppointment"},"name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"professionalInfos"},"name":{"kind":"Name","value":"informacoesSobreProfissional"}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentInfos"},"name":{"kind":"Name","value":"informacoesSobreAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"restrictions"},"name":{"kind":"Name","value":"informacoesSobreRestricoes"}},{"kind":"Field","alias":{"kind":"Name","value":"faq"},"name":{"kind":"Name","value":"informacoesDuvidasFrequentes"}}]}}]}}]} as unknown as DocumentNode<GetSecretaryDetailsPageQueryQuery, GetSecretaryDetailsPageQueryQueryVariables>;
export const GetSecretaryProfessionalInfosQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSecretaryProfessionalInfosQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecretaryDetailsProfessionalInfosFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecretaryDetailsProfessionalInfosFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personalizeAppointment"},"name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"professionalInfos"},"name":{"kind":"Name","value":"informacoesSobreProfissional"}}]}}]}}]} as unknown as DocumentNode<GetSecretaryProfessionalInfosQueryQuery, GetSecretaryProfessionalInfosQueryQueryVariables>;
export const GetSecretaryRestrictionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSecretaryRestrictionsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SecretaryDetailsRestrictionsFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SecretaryDetailsRestrictionsFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"personalizeAppointment"},"name":{"kind":"Name","value":"usuariosProfissionaisOrientacoesSecretarias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"restrictions"},"name":{"kind":"Name","value":"informacoesSobreRestricoes"}}]}}]}}]} as unknown as DocumentNode<GetSecretaryRestrictionsQueryQuery, GetSecretaryRestrictionsQueryQueryVariables>;
export const ServicePackagesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ServicePackagesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServico"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServicePackagesFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServicePackagesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"servicePackage"},"name":{"kind":"Name","value":"pacotesServicos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPacoteServicos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServico"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPreco"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioFixo"}},{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ServicePackagesQueryQuery, ServicePackagesQueryQueryVariables>;
export const SubscribeAssistProConfirmPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubscribeAssistProConfirmPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServico"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscribeAssistProSubscriptionConfirmCardFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscribeAssistProSubscriptionConfirmCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"servicePackage"},"name":{"kind":"Name","value":"pacotesServicos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPacoteServicos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServico"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPreco"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioFixo"}},{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubscribeAssistProConfirmPageQueryQuery, SubscribeAssistProConfirmPageQueryQueryVariables>;
export const SubscribedAssistProQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubscribedAssistProQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServicos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"servicePackage"},"name":{"kind":"Name","value":"pacotesServicos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPacoteServicos"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPacoteServicos"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPreco"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscribedAssistFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscribedAssistProPriceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacoteServicoPreco"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitarioFixo"}},{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubscribedAssistFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacoteServicoPreco"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubscribedAssistProPriceFragment"}}]}}]} as unknown as DocumentNode<SubscribedAssistProQueryQuery, SubscribedAssistProQueryQueryVariables>;
export const UpsertPhonePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UpsertPhonePageQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UpsertPublicPhoneFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UpsertPublicPhoneFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionais"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefonePublico"}}]}}]}}]} as unknown as DocumentNode<UpsertPhonePageQueryQuery, UpsertPhonePageQueryQueryVariables>;
export const UserTrackableLinksDetailsPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserTrackableLinksDetailsPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userTrackableLinkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userTrackableLink"},"name":{"kind":"Name","value":"usuariosLinksRastreamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioLinkRastreamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userTrackableLinkId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserTrackableLinksDetailsDescriptionFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserTrackableLinksDetailsLinkInputFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserTrackableLinksDetailsActionsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinksDetailsDescriptionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinksDetailsLinkInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinksDetailsActionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]} as unknown as DocumentNode<UserTrackableLinksDetailsPageQueryQuery, UserTrackableLinksDetailsPageQueryQueryVariables>;
export const UserTrackableLinkReportPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserTrackableLinkReportPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userTrackableLinkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userTrackableLink"},"name":{"kind":"Name","value":"usuariosLinksRastreamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioLinkRastreamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userTrackableLinkId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codLinkRastreamento"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserTrackableLinkReportDetailSummaryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinkReportDetailSummaryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}}]}}]} as unknown as DocumentNode<UserTrackableLinkReportPageQueryQuery, UserTrackableLinkReportPageQueryQueryVariables>;
export const UserTrackableLinksQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserTrackableLinksQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserTrackableLinksQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinkListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosLinksRastreamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioLinkRastreamento"}},{"kind":"Field","name":{"kind":"Name","value":"sistema"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserTrackableLinksQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosLinksRastreamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioLinkRastreamento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserTrackableLinkListItemQueryFragment"}}]}}]}}]} as unknown as DocumentNode<UserTrackableLinksQueryQuery, UserTrackableLinksQueryQueryVariables>;
export const BillingDetailsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillingDetailsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billingItem"},"name":{"kind":"Name","value":"movimentacaoDetalhada"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codMovimentacao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingItemId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BillingItemDetailsQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BillingItemDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MovimentacaoExibicao"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cobrado"}},{"kind":"Field","name":{"kind":"Name","value":"codCobranca"}},{"kind":"Field","name":{"kind":"Name","value":"codModalidadeFiscal"}},{"kind":"Field","name":{"kind":"Name","value":"codMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"codOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"dataVencimento"}},{"kind":"Field","name":{"kind":"Name","value":"identificacaoTipoMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"valorDesconto"}},{"kind":"Field","name":{"kind":"Name","value":"valorAcrescimo"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"tipoOrigem"}},{"kind":"Field","name":{"kind":"Name","value":"tempoUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"quantidade"}},{"kind":"Field","name":{"kind":"Name","value":"possuiExtensao"}},{"kind":"Field","name":{"kind":"Name","value":"nomeTipoMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"nomeUnidade"}}]}}]} as unknown as DocumentNode<BillingDetailsQueryQuery, BillingDetailsQueryQueryVariables>;
export const AllocationDetailsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllocationDetailsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allocation"},"name":{"kind":"Name","value":"alocacaoDetalhada"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AllocationDetailsQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllocationDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AlocacaoDetalhada"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaFimCobrado"}},{"kind":"Field","name":{"kind":"Name","value":"horaFimDevolvido"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"partes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"taxaCobranca"}},{"kind":"Field","name":{"kind":"Name","value":"tipoAlocacao"}}]}}]}}]} as unknown as DocumentNode<AllocationDetailsQueryQuery, AllocationDetailsQueryQueryVariables>;
export const AppointmentDetailsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentDetailsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointment"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentDetailsQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}}]} as unknown as DocumentNode<AppointmentDetailsQueryQuery, AppointmentDetailsQueryQueryVariables>;
export const AssistBillingBatchQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssistBillingBatchQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"assistBillingBatch"},"name":{"kind":"Name","value":"nuntius_lote_contatos_cobranca"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingItemId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssistBillingBatchQueryFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"servicePackagePrices"},"name":{"kind":"Name","value":"pacoteServicoPreco"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssistBillingBatchVariablePricesFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssistBillingBatchQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"nuntius_lote_contatos_cobranca"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contatosPorDia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCobravel"}},{"kind":"Field","name":{"kind":"Name","value":"totalDigitalCobravel"}},{"kind":"Field","name":{"kind":"Name","value":"totalHumanoCobravel"}},{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssistBillingBatchVariablePricesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacoteServicoPreco"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pacotesServicosPrecosVariaveis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"codPacoteServicosPrecoVariavel"}}]}}]}}]} as unknown as DocumentNode<AssistBillingBatchQueryQuery, AssistBillingBatchQueryQueryVariables>;
export const CommunityPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommunityPageQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CommunityFilterDrawerQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CommunityFilterDrawerQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"unidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"},{"kind":"IntValue","value":"6"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"specialties"},"name":{"kind":"Name","value":"especialidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}}]}}]}}]} as unknown as DocumentNode<CommunityPageQueryQuery, CommunityPageQueryQueryVariables>;
export const BankAccountPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BankAccountPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagarmeId"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BankAccountDetailsQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutomaticAnticipationToggleQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetAutomaticAnticipationSettingsByRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"automaticAnticipationSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BankAccountDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branchNumber"}},{"kind":"Field","name":{"kind":"Name","value":"branchCheckDigit"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountCheckDigit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutomaticAnticipationToggleQueryFragment"}}]}}]} as unknown as DocumentNode<BankAccountPageQueryQuery, BankAccountPageQueryQueryVariables>;
export const BankAccountUpdatePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BankAccountUpdatePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagarmeId"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BankAccountFormQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BanksListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GetAllBanksOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BankAccountFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"accountCheckDigit"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"banks"},"name":{"kind":"Name","value":"GetAllBanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BanksListToSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<BankAccountUpdatePageQueryQuery, BankAccountUpdatePageQueryQueryVariables>;
export const CreatePaymentPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreatePaymentPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreatePaymentFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OnlinePaymentTypesCheckboxGroupFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"expensum_payment_type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreatePaymentFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"pacientes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPaciente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"formasDePagamento"},"name":{"kind":"Name","value":"expensum_payment_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OnlinePaymentTypesCheckboxGroupFragment"}}]}}]}}]} as unknown as DocumentNode<CreatePaymentPageQueryQuery, CreatePaymentPageQueryQueryVariables>;
export const EvolutionChartsPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EvolutionChartsPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentsInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPaymentsChartsInfoInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payablesInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPayablesChartsInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetPaymentsChartsInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentsStatusChartFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentsOriginChartFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetPayablesChartsInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payablesInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PayablesStatusChartFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentsStatusChartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPaymentsChartsInfoOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervalEnd"}},{"kind":"Field","name":{"kind":"Name","value":"intervalStart"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totemPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentsOriginChartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPaymentsChartsInfoOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervalEnd"}},{"kind":"Field","name":{"kind":"Name","value":"intervalStart"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totemPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PayablesStatusChartFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPayablesChartsInfoOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervalEnd"}},{"kind":"Field","name":{"kind":"Name","value":"intervalStart"}},{"kind":"Field","name":{"kind":"Name","value":"waitingFunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}}]}}]} as unknown as DocumentNode<EvolutionChartsPageQueryQuery, EvolutionChartsPageQueryQueryVariables>;
export const GetOnlinePaymentByGuidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOnlinePaymentByGuid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"onlinePayment"},"name":{"kind":"Name","value":"expensum_online_payment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"guid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guid"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}}]}}]} as unknown as DocumentNode<GetOnlinePaymentByGuidQuery, GetOnlinePaymentByGuidQueryVariables>;
export const PatientPaymentDetailsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientPaymentDetailsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlinePaymentGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumPaymentDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onlinePaymentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlinePaymentGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentDetailsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentDetailsAppointmentSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"startHour"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsDetailsPaymentSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acquirerTransactionKey"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"refundedAt"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePaymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsDetailsPayableSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"payablesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"grossValue"}},{"kind":"Field","name":{"kind":"Name","value":"netValue"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"installment"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"anticipationFee"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentDetailsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumPaymentDetailsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onlinePaymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentDetailsAppointmentSectionFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsDetailsPaymentSectionFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsDetailsPayableSectionFragment"}}]}}]} as unknown as DocumentNode<PatientPaymentDetailsPageQuery, PatientPaymentDetailsPageQueryVariables>;
export const PatientsPaymentsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientsPaymentsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intervalStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intervalEnd"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origins"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethods"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"patientPayments"},"name":{"kind":"Name","value":"ExpensumGetPayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"intervalStart"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalStart"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"intervalEnd"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intervalEnd"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"origin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origins"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"paymentMethod"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethods"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsListFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPaymentInfo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"meioPagamentoSelecionado"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"criadoEm"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"nomeDoPagador"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parcelas"}},{"kind":"Field","name":{"kind":"Name","value":"hasAutomaticAnticipation"}},{"kind":"Field","name":{"kind":"Name","value":"payableInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"installment"}},{"kind":"Field","name":{"kind":"Name","value":"nextPaymentDate"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPaymentsOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsListItemFragment"}}]}}]}}]} as unknown as DocumentNode<PatientsPaymentsQueryQuery, PatientsPaymentsQueryQueryVariables>;
export const RefundReceiptPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefundReceiptPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlinePaymentGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRefundReceipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"onlinePaymentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlinePaymentGuid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RefundReceiptDetailsQueryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsRefundDetailsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetRefundReceiptOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"authorizationId"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"paidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAt"}},{"kind":"Field","name":{"kind":"Name","value":"canceledAmount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientPaymentsRefundPayeeSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetRefundReceiptOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receipt"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"lastFourDigits"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefundReceiptDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetRefundReceiptOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsRefundDetailsSectionFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientPaymentsRefundPayeeSectionFragment"}}]}}]} as unknown as DocumentNode<RefundReceiptPageQueryQuery, RefundReceiptPageQueryQueryVariables>;
export const PatientPaymentRefundPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientPaymentRefundPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"onlinePaymentGuid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumPaymentDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onlinePaymentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlinePaymentGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RefundDetailsQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefundDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumPaymentDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onlinePaymentGuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"onlinePaymentGuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acquirerTransactionKey"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"origin"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"payablesInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pagarmeId"}}]}}]}}]}}]} as unknown as DocumentNode<PatientPaymentRefundPageQuery, PatientPaymentRefundPageQueryVariables>;
export const ExpensumPayablesV2QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExpensumPayablesV2Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExpensumGetPayablesV2Input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetPayablesV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"payables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accrualAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"installment"}},{"kind":"Field","name":{"kind":"Name","value":"gatewayId"}},{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"installments"}},{"kind":"Field","name":{"kind":"Name","value":"originPaymentType"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentStart"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCreatedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExpensumPayablesV2QueryQuery, ExpensumPayablesV2QueryQueryVariables>;
export const TermsOfServiceQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TermsOfServiceQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expensum_terms_of_use"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urlTerms"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ExpensumGetRecipient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codClinica"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codClinica"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TermsOfServiceQueryQuery, TermsOfServiceQueryQueryVariables>;
export const InsertRecipientTermsOfUseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertRecipientTermsOfUse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"expensum_recipient_terms_of_use_agreed_insert_input"}}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_expensum_recipient_terms_of_use_agreed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertRecipientTermsOfUseMutation, InsertRecipientTermsOfUseMutationVariables>;
export const CardManagementPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CardManagementPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CardDetailsQueryFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"usuariosProfissionais"},"name":{"kind":"Name","value":"usuariosProfissionais_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formaDePagamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosCartoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CardDetailsQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuarioProfissional"},"name":{"kind":"Name","value":"usuariosProfissionais_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formaDePagamento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosCartoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"bandeira"}},{"kind":"Field","name":{"kind":"Name","value":"numero"}},{"kind":"Field","name":{"kind":"Name","value":"validade"}}]}}]}}]} as unknown as DocumentNode<CardManagementPageQueryQuery, CardManagementPageQueryQueryVariables>;
export const ChangePlanPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChangePlanPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentPlanCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangePlanAlertFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlano"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPlano"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoMovimentacao"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"temFidelidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"tipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"duracaoFidelidadeEmMeses"}},{"kind":"Field","name":{"kind":"Name","value":"carenciaEmMeses"}},{"kind":"Field","name":{"kind":"Name","value":"migravel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlanoMovimentacoesRecorrentes"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tipoMovimentacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosMovimentacoesRecorrentes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioMovimentacaoRecorrente"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlanoFuturo"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"migravel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPlano"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"temFidelidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"tipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"duracaoFidelidadeEmMeses"}},{"kind":"Field","name":{"kind":"Name","value":"carenciaEmMeses"}},{"kind":"Field","name":{"kind":"Name","value":"migravel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionais"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataValidacao"}},{"kind":"Field","name":{"kind":"Name","value":"diaVencimento"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planosMigracoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPlanoDestino"}},{"kind":"Field","name":{"kind":"Name","value":"codPlanoOrigem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentPlanCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tiposMovimentacoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"identificacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"Mensalidade","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"plano"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tipoMovimentacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosMovimentacoesRecorrentes"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tipoMovimentacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"usuariosMovimentacoesRecorrentes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlano"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"temFidelidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"tipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"duracaoFidelidadeEmMeses"}},{"kind":"Field","name":{"kind":"Name","value":"carenciaEmMeses"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangePlanAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlano"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"temFidelidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}},{"kind":"Field","name":{"kind":"Name","value":"observacao"}},{"kind":"Field","name":{"kind":"Name","value":"duracaoFidelidadeEmMeses"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}}]}}]}}]} as unknown as DocumentNode<ChangePlanPageQueryQuery, ChangePlanPageQueryQueryVariables>;
export const LivanceApiUsuarioPlanoMigracaoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LivanceApiUsuarioPlanoMigracao"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LivanceApiUsuarioPlanoMigracaoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiUsuarioPlanoMigracao"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPlano"}}]}}]}}]} as unknown as DocumentNode<LivanceApiUsuarioPlanoMigracaoMutation, LivanceApiUsuarioPlanoMigracaoMutationVariables>;
export const GetMovimentacoesByMovimentacaoRecorrenteQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMovimentacoesByMovimentacaoRecorrenteQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codMovimentacaoRecorrente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tbMovimentacoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tipoOrigem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"recorrente","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codOrigem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codMovimentacaoRecorrente"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codMovimentacao"}}]}}]}}]} as unknown as DocumentNode<GetMovimentacoesByMovimentacaoRecorrenteQueryQuery, GetMovimentacoesByMovimentacaoRecorrenteQueryQueryVariables>;
export const MyProfilePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyProfilePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MyProfileDetailsSectionFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CardInfoQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CurrentPlanInfoFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OneLivProfileCardFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PublicPhoneNumberFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilePictureFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"profilePictureFile"},"name":{"kind":"Name","value":"LivanceApiSelecionaFotoDePerfil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arquivo"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilePictureAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"profilePictureFile"},"name":{"kind":"Name","value":"LivanceApiSelecionaFotoDePerfil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arquivo"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfessionalUserPreferredNameFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionais"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Usuario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sobrenome"}},{"kind":"Field","name":{"kind":"Name","value":"apelido"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MyProfileDetailsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfilePictureFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfilePictureAlertFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfessionalUserPreferredNameFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CardInfoQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosCartoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bandeira"}},{"kind":"Field","name":{"kind":"Name","value":"numero"}},{"kind":"Field","name":{"kind":"Name","value":"validade"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentPlanInfoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tiposMovimentacoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"identificacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"Mensalidade","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"plano"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tipoMovimentacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosMovimentacoesRecorrentes"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tipoMovimentacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valorUnitario"}},{"kind":"Field","name":{"kind":"Name","value":"usuariosMovimentacoesRecorrentes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantidade"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlano"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"temFidelidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}},{"kind":"Field","name":{"kind":"Name","value":"tipoPlano"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"usuarioPlanoFuturo"},"name":{"kind":"Name","value":"usuariosProfissionaisPlanos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeExibicao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionais"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaVencimento"}},{"kind":"Field","name":{"kind":"Name","value":"dataValidacao"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OneLivProfileCardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locus_membro"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locus_conselho_profissional"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sigla"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PublicPhoneNumberFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosProfissionais"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"telefonePublico"}}]}}]}}]} as unknown as DocumentNode<MyProfilePageQueryQuery, MyProfilePageQueryQueryVariables>;
export const ReservedScheduleIndividualCancelPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReservedScheduleIndividualCancelPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantido"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"periodoGarantidoRecorrente"},"name":{"kind":"Name","value":"tbPeriodosGarantidosRecorrentes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"diaDaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"periodoGarantido"},"name":{"kind":"Name","value":"tbPeriodosGarantidos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPeriodoGarantido"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantido"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"Agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}}]}}]} as unknown as DocumentNode<ReservedScheduleIndividualCancelPageQueryQuery, ReservedScheduleIndividualCancelPageQueryQueryVariables>;
export const ReservedScheduleIndividualCancelSimulationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReservedScheduleIndividualCancelSimulationQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantido"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiSimulaCobrancaDeCancelamento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codPeriodoGarantido"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantido"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataReferencia"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxa"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}}]}}]}}]} as unknown as DocumentNode<ReservedScheduleIndividualCancelSimulationQueryQuery, ReservedScheduleIndividualCancelSimulationQueryQueryVariables>;
export const CancelIndividualReservedScheduleMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelIndividualReservedScheduleMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantido"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiCancelaPeriodoGarantido"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codPeriodoGarantido"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantido"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CancelIndividualReservedScheduleMutationMutation, CancelIndividualReservedScheduleMutationMutationVariables>;
export const ReservedScheduleCancelPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReservedScheduleCancelPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"time"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"periodoGarantidoRecorrente"},"name":{"kind":"Name","value":"tbPeriodosGarantidosRecorrentes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"diaDaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}}]}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"Agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReservedScheduleCancelPageQueryQuery, ReservedScheduleCancelPageQueryQueryVariables>;
export const ReservedScheduleCancelSimulationQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReservedScheduleCancelSimulationQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantido"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiSimulaCobrancaDeCancelamento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codPeriodoGarantido"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantido"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataReferencia"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taxa"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}}]}}]}}]} as unknown as DocumentNode<ReservedScheduleCancelSimulationQueryQuery, ReservedScheduleCancelSimulationQueryQueryVariables>;
export const CancelReservedScheduleMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelReservedScheduleMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiCancelaPeriodoGarantidoRecorrente"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"periodoGarantidoRecorrente"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CancelReservedScheduleMutationMutation, CancelReservedScheduleMutationMutationVariables>;
export const ReservedSchedulesDetailsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReservedSchedulesDetailsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"time"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"periodoGarantidoRecorrente"},"name":{"kind":"Name","value":"tbPeriodosGarantidosRecorrentes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"diaDaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidosRecorrentesFrequencia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"descricao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReservedSchedulesNextSchedulesFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservedSchedulesNextSchedulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tbPeriodosGarantidosRecorrentes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}}]}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},{"kind":"Field","name":{"kind":"Name","value":"Agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReservedSchedulesDetailsQueryQuery, ReservedSchedulesDetailsQueryQueryVariables>;
export const GetReservedSchedulePriceQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReservedSchedulePriceQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duracao"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetReservedSchedulePriceFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetReservedSchedulePriceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ReservedSchedulePrice"},"name":{"kind":"Name","value":"LivanceApiSimulaCobrancaPeriodoGarantido"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"params"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"duracao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duracao"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"price"},"name":{"kind":"Name","value":"valor"}}]}}]}}]} as unknown as DocumentNode<GetReservedSchedulePriceQueryQuery, GetReservedSchedulePriceQueryQueryVariables>;
export const HasUserAcceptedTermsOfUseQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasUserAcceptedTermsOfUseQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codTipoTermoDeUso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tbUsuariosTermosDeUso"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoTermoDeUso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoTermoDeUso"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTermosDeUso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoTermoDeUso"}},{"kind":"Field","name":{"kind":"Name","value":"dataUltimaAtualizacao"}}]}}]}}]} as unknown as DocumentNode<HasUserAcceptedTermsOfUseQueryQuery, HasUserAcceptedTermsOfUseQueryQueryVariables>;
export const GetLocationsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetLocationsFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetLocationsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"locations"},"name":{"kind":"Name","value":"unidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"desligarAlocacao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"preAlocacaoAtiva"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","alias":{"kind":"Name","value":"rooms"},"name":{"kind":"Name","value":"tbUnidades_tbUnidadesSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"alocavel"}},{"kind":"Field","alias":{"kind":"Name","value":"roomType"},"name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"alocavel"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToSelectQueryFragment"}}]}}]}}]} as unknown as DocumentNode<GetLocationsQueryQuery, GetLocationsQueryQueryVariables>;
export const GetReservedSchedulesSlotsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReservedSchedulesSlotsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duracao"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"diaDaSemana"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrenteFrequencia"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReservedSchedulesSlotsFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservedSchedulesSlotsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Slots"},"name":{"kind":"Name","value":"LivanceApiBuscaHorariosDisponiveisDiaDaSemana"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"duracao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duracao"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"diaDaSemana"},"value":{"kind":"Variable","name":{"kind":"Name","value":"diaDaSemana"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUnidade"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUnidade"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoSala"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codModalidadePeriodoGarantido"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrenteFrequencia"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrenteFrequencia"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sugestoesHorarios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}}]}}]}}]}}]} as unknown as DocumentNode<GetReservedSchedulesSlotsQueryQuery, GetReservedSchedulesSlotsQueryQueryVariables>;
export const GetPeriodosGarantidosRecorrentesDoUsuarioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPeriodosGarantidosRecorrentesDoUsuario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"time"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReservedScheduleListQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservedScheduleListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tbPeriodosGarantidosRecorrentes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},{"kind":"Field","name":{"kind":"Name","value":"diaDaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}}]}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoFinalidadePeriodoGarantido"}},{"kind":"Field","name":{"kind":"Name","value":"Agendamento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"meioPagamento"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidosRecorrentesFrequencia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"descricao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReservedScheduleListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"periodosGarantidosRecorrentes"},"name":{"kind":"Name","value":"tbPeriodosGarantidosRecorrentes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrente"}},{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantidoRecorrenteFrequencia"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReservedScheduleListItemQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"PeriodosGarantidos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"Agendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataAgendamento"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horaInicio"}}}]}}]}]}}]}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPeriodoGarantido"}}]}}]}}]}}]} as unknown as DocumentNode<GetPeriodosGarantidosRecorrentesDoUsuarioQuery, GetPeriodosGarantidosRecorrentesDoUsuarioQueryVariables>;
export const UpsertTermsOfUseMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertTermsOfUseMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"IP"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codTipoTermoDeUso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataUltimaAtualizacao"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ativo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_tbUsuariosTermosDeUso_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"IP"},"value":{"kind":"Variable","name":{"kind":"Name","value":"IP"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ativo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoTermoDeUso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codTipoTermoDeUso"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataUltimaAtualizacao"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataUltimaAtualizacao"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataUltimaAtualizacao"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"if_matched"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"match_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"codUsuario"},{"kind":"EnumValue","value":"codTipoTermoDeUso"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"dataUltimaAtualizacao"},{"kind":"EnumValue","value":"ativo"},{"kind":"EnumValue","value":"IP"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTermosDeUso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoTermoDeUso"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"dataUltimaAtualizacao"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}}]}}]}}]} as unknown as DocumentNode<UpsertTermsOfUseMutationMutation, UpsertTermsOfUseMutationMutationVariables>;
export const AppointmentReceivingOptionPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentReceivingOptionPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"formaRecebimento"},"name":{"kind":"Name","value":"usuariosFormasRecebimentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"sistema"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentReceivingOptionsFormQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposConvenios"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancePlansListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposPlanos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentReceivingOptionsFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"formaRecebimento"},"name":{"kind":"Name","value":"usuariosFormasRecebimentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"sistema"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposConvenios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HealthInsurancesListToSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposPlanos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HealthInsurancePlansListToSelectQueryFragment"}}]}}]}}]} as unknown as DocumentNode<AppointmentReceivingOptionPageQueryQuery, AppointmentReceivingOptionPageQueryQueryVariables>;
export const DeleteAppointmentReceivingOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAppointmentReceivingOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiDeleteUsuarioFormaRecebimento"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteAppointmentReceivingOptionMutation, DeleteAppointmentReceivingOptionMutationVariables>;
export const AppointmentReceivingOptionsCreatePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentReceivingOptionsCreatePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentReceivingOptionsFormQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposConvenios"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HealthInsurancePlansListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposPlanos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentReceivingOptionsFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"formaRecebimento"},"name":{"kind":"Name","value":"usuariosFormasRecebimentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoPlano"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"sistema"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposConvenios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HealthInsurancesListToSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposPlanos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HealthInsurancePlansListToSelectQueryFragment"}}]}}]}}]} as unknown as DocumentNode<AppointmentReceivingOptionsCreatePageQueryQuery, AppointmentReceivingOptionsCreatePageQueryQueryVariables>;
export const AppointmentReceivingOptionsPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentReceivingOptionsPageQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentReceivingOptionsListQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentReceivingOptionsListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tipoPlano"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentReceivingOptionsPageQueryQuery, AppointmentReceivingOptionsPageQueryQueryVariables>;
export const GetAppointmentTypeEditPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppointmentTypeEditPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentType"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sistema"}},{"kind":"Field","name":{"kind":"Name","value":"ativo"}},{"kind":"Field","alias":{"kind":"Name","value":"category"},"name":{"kind":"Name","value":"usuariosCompromissosCategoria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoCategoria"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetAppointmentTypeFormQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosFormasRecebimentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentChannelsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"canaisAgendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCanalAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeModalitiesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissosModalidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomTypesListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposSalas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetAppointmentTypeFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentType"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"informacoesPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"sistema"}},{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}},{"kind":"Field","alias":{"kind":"Name","value":"modality"},"name":{"kind":"Name","value":"usuariosCompromissosModalidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentChannels"},"name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCanalAgendamento"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"roomTypes"},"name":{"kind":"Name","value":"tiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"paymentReceiptMethods"},"name":{"kind":"Name","value":"tbUsuariosCompromissosFormasRecebimentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"category"},"name":{"kind":"Name","value":"usuariosCompromissosCategoria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoCategoria"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethodsListToMultiSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canaisAgendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentChannelsListToMultiSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissosModalidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypeModalitiesListToSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposSalas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"alocavel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"IntValue","value":"4"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomTypesListQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}},{"kind":"Field","name":{"kind":"Name","value":"Especialidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppointmentTypeEditPageQueryQuery, GetAppointmentTypeEditPageQueryQueryVariables>;
export const DeleteAppointmentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAppointmentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LivanceApiDeleteUsuarioCompromissoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiDeleteUsuarioCompromisso"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteAppointmentTypeMutation, DeleteAppointmentTypeMutationVariables>;
export const GetAppointmentTypeCreatePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppointmentTypeCreatePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GetAppointmentTypeFormQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethodsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosFormasRecebimentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"TipoConvenio"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentChannelsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"canaisAgendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCanalAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeModalitiesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissosModalidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoomTypesListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposSalas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GetAppointmentTypeFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"appointmentType"},"name":{"kind":"Name","value":"usuariosCompromissos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioCompromisso"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioCompromisso"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"informacoesPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"descricao"}},{"kind":"Field","name":{"kind":"Name","value":"sistema"}},{"kind":"Field","name":{"kind":"Name","value":"codParceiroIntegracao"}},{"kind":"Field","alias":{"kind":"Name","value":"modality"},"name":{"kind":"Name","value":"usuariosCompromissosModalidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appointmentChannels"},"name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codCanalAgendamento"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"roomTypes"},"name":{"kind":"Name","value":"tiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"paymentReceiptMethods"},"name":{"kind":"Name","value":"tbUsuariosCompromissosFormasRecebimentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"category"},"name":{"kind":"Name","value":"usuariosCompromissosCategoria"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoCategoria"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethodsListToMultiSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canaisAgendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentChannelsListToMultiSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissosModalidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypeModalitiesListToSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposSalas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"alocavel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoSala"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"IntValue","value":"4"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoomTypesListQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosEspecialidades"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codEspecialidade"}},{"kind":"Field","name":{"kind":"Name","value":"Especialidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}}]} as unknown as DocumentNode<GetAppointmentTypeCreatePageQueryQuery, GetAppointmentTypeCreatePageQueryQueryVariables>;
export const AppointmentTypesPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppointmentTypesPageQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypeListQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeListItemQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"tbUsuariosCompromissosFormasRecebimentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UsuarioFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoFormaRecebimento"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypeListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"3"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypeListItemQueryFragment"}}]}}]}}]} as unknown as DocumentNode<AppointmentTypesPageQueryQuery, AppointmentTypesPageQueryQueryVariables>;
export const EditSchedulePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditSchedulePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioAgenda"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleFormQueryFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"schedules"},"name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioAgenda"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioAgenda"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleFrequenciesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposAgendasRepeticoes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"3"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToMultiSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposAgendasRepeticoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoAgendaRepeticao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"30"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleFrequenciesListToSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"unidadeHorariosFuncionamentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"abertura"}},{"kind":"Field","name":{"kind":"Name","value":"fechamento"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"schedule"},"name":{"kind":"Name","value":"usuariosAgendas_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioAgenda"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioAgenda"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"dataFim"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","alias":{"kind":"Name","value":"compromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"diasSemana"},"name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}}]}}]}}]} as unknown as DocumentNode<EditSchedulePageQueryQuery, EditSchedulePageQueryQueryVariables>;
export const DeleteScheduleMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteScheduleMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LivanceApiDeleteUsuarioAgendaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"LivanceApiDeleteUsuarioAgenda"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"arg1"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteScheduleMutationMutation, DeleteScheduleMutationMutationVariables>;
export const CreateSchedulePageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateSchedulePageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioAgenda"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleFormQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleFrequenciesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tiposAgendasRepeticoes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unidades"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleFormQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuario"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuario"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"3"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToMultiSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tiposAgendasRepeticoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codTipoAgendaRepeticao"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"30"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleFrequenciesListToSelectQueryFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nome"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitsListToMultiSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}},{"kind":"Field","name":{"kind":"Name","value":"unidadeHorariosFuncionamentos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}},{"kind":"Field","name":{"kind":"Name","value":"abertura"}},{"kind":"Field","name":{"kind":"Name","value":"fechamento"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"schedule"},"name":{"kind":"Name","value":"usuariosAgendas_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codUsuarioAgenda"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codUsuarioAgenda"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","name":{"kind":"Name","value":"dataFim"}},{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","alias":{"kind":"Name","value":"compromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"diasSemana"},"name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSchedulePageQueryQuery, CreateSchedulePageQueryQueryVariables>;
export const SchedulesPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SchedulesPageQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchedulesListQueryFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardFrequencyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardAppointmentTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasCompromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardHeadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inicio"}},{"kind":"Field","name":{"kind":"Name","value":"fim"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardUnitFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasUnidades"},"name":{"kind":"Name","value":"tbUsuariosAgendasUnidades"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sigla"}},{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleDaysOfWeekListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendasDiasSemanas"},"name":{"kind":"Name","value":"tbUsuariosAgendasDiasSemanas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diaSemana"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemCardStartDateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"dataInicio"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ScheduleListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosAgendas"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"dataInicio"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardFrequencyFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardAppointmentTypeFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardHeadFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardUnitFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleDaysOfWeekListFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemCardStartDateFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchedulesListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codUsuarioAgenda"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","alias":{"kind":"Name","value":"startDate"},"name":{"kind":"Name","value":"dataInicio"}},{"kind":"Field","alias":{"kind":"Name","value":"tipoRepeticao"},"name":{"kind":"Name","value":"codTipoAgendaRepeticao"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ScheduleListItemFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usuariosCompromissos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"IntValue","value":"3"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}}]}}]}}]} as unknown as DocumentNode<SchedulesPageQueryQuery, SchedulesPageQueryQueryVariables>;
export const ChangeTimeConfirmPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChangeTimeConfirmPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeTimeConfirmFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeTimeConfirmFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioFormaRecebimento"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioAgenda"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"nomeConvenio"}},{"kind":"Field","name":{"kind":"Name","value":"nomePlano"}},{"kind":"Field","name":{"kind":"Name","value":"numeroCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"dataNascimento"}},{"kind":"Field","name":{"kind":"Name","value":"confirmado"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"telefone"}},{"kind":"Field","name":{"kind":"Name","value":"telefoneProprio"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"validadeCarteirinha"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ignorarEnvioWhatsApp"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpfProprio"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}}]}}]} as unknown as DocumentNode<ChangeTimeConfirmPageQueryQuery, ChangeTimeConfirmPageQueryQueryVariables>;
export const ChangeTimeMinutesPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChangeTimeMinutesPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"cancelado"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeTimeMinutesFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeTimeMinutesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}}]} as unknown as DocumentNode<ChangeTimeMinutesPageQueryQuery, ChangeTimeMinutesPageQueryQueryVariables>;
export const WaitingRoomAppointmentMenuQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WaitingRoomAppointmentMenuQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentMenuFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentMenuFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"cobraCancelamento"}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUnidade"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromissoModalidade"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"atraso"},"name":{"kind":"Name","value":"notificacoesPacientesAtrasados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempoAtraso"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoTipoTag"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"followUpAppointment"},"name":{"kind":"Name","value":"lembretes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codLembrete"}}]}}]}}]} as unknown as DocumentNode<WaitingRoomAppointmentMenuQueryQuery, WaitingRoomAppointmentMenuQueryQueryVariables>;
export const ReceiveRoomNowQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReceiveRoomNowQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReceiveRoomNowFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReceiveRoomNowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nomeLimpo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}}]}}]} as unknown as DocumentNode<ReceiveRoomNowQueryQuery, ReceiveRoomNowQueryQueryVariables>;
export const SendPaymentPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SendPaymentPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agendamento"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SendPaymentFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SendPaymentFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"AgendamentosVinculados"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoPrincipal"}}]}}]}}]} as unknown as DocumentNode<SendPaymentPageQueryQuery, SendPaymentPageQueryQueryVariables>;
export const FollowUpAppointmentReminderPageCreateQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FollowUpAppointmentReminderPageCreateQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canalAgendamentoPaciente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoriaPeriodoGarantido"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FollowUpAppointmentReminderFormFragment"}},{"kind":"Field","alias":{"kind":"Name","value":"appointment"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FollowUpAppointmentReminderMessageDrawerFragment"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"Usuario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apelido"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sobrenome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canalAgendamentoPaciente"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoriaPeriodoGarantido"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasCompromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuariosCompromissos"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appointment"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderMessageDrawerFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"Usuario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apelido"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sobrenome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<FollowUpAppointmentReminderPageCreateQueryQuery, FollowUpAppointmentReminderPageCreateQueryQueryVariables>;
export const FollowUpAppointmentReminderPatientAppointmentQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FollowUpAppointmentReminderPatientAppointmentQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"today"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"datetime2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"patientAppointments"},"name":{"kind":"Name","value":"pacientes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codPaciente"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codFinalidadeAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"IntValue","value":"1"},{"kind":"IntValue","value":"3"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoOrigem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FollowUpAppointmentReminderMessageDrawerFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"Usuario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apelido"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sobrenome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reminders"},"name":{"kind":"Name","value":"lembretes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataEnviado"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"today"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataParaEnvio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderMessageDrawerFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"Usuario"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apelido"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"sobrenome"}}]}},{"kind":"Field","name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}}]}}]} as unknown as DocumentNode<FollowUpAppointmentReminderPatientAppointmentQueryQuery, FollowUpAppointmentReminderPatientAppointmentQueryQueryVariables>;
export const FollowUpAppointmentReminderPatientQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FollowUpAppointmentReminderPatientQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canalAgendamentoPaciente"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categoriaPeriodoGarantido"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FollowUpAppointmentReminderFormFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"usuariosCompromissos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FollowUpAppointmentReminderFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usuariosAgendas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ativo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"UsuarioCompromisso"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"usuariosCompromissosCanaisAgendamentos"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codCanalAgendamento"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canalAgendamentoPaciente"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"categoria"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categoriaPeriodoGarantido"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataInicio"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataFim"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuariosAgendasCompromissos"},"name":{"kind":"Name","value":"tbUsuariosAgendasCompromissos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuariosCompromissos"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppointmentTypesListToSelectQueryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"duracao"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"appointment"},"name":{"kind":"Name","value":"agendamentos_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"codAgendamento"},"value":{"kind":"Variable","name":{"kind":"Name","value":"codAgendamento"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuario"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}}]} as unknown as DocumentNode<FollowUpAppointmentReminderPatientQueryQuery, FollowUpAppointmentReminderPatientQueryQueryVariables>;
export const WaitingRoomPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WaitingRoomPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"whereBuild"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentListQueryFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomFilterButtonFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PatientAvatarFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pacientes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"pago"}},{"kind":"Field","name":{"kind":"Name","value":"pagar"}},{"kind":"Field","name":{"kind":"Name","value":"valor"}},{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentosVinculados"},"name":{"kind":"Name","value":"AgendamentosVinculados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"codAgendamentoTipoVinculo"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"2"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onlinePayments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"canceled","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"agendamentos"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaInicio"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","name":{"kind":"Name","value":"codFinalidadeAgendamento"}},{"kind":"Field","alias":{"kind":"Name","value":"paciente"},"name":{"kind":"Name","value":"Paciente"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codPaciente"}},{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PatientAvatarFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"unidade"},"name":{"kind":"Name","value":"Unidade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"checkin"},"name":{"kind":"Name","value":"AgendamentosCheckin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCheckin"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"atraso"},"name":{"kind":"Name","value":"notificacoesPacientesAtrasados"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataCadastro"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tempoAtraso"}},{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataCadastro"}},{"kind":"Field","name":{"kind":"Name","value":"codAgendamentoTipoTag"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemPaymentFragment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomAppointmentListQueryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereBuild"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}},{"kind":"Field","name":{"kind":"Name","value":"horaFim"}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentoPreAlocacao"},"name":{"kind":"Name","value":"AgendamentoPreAlocacao"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"agendamentoAlocacaoAtiva"},"name":{"kind":"Name","value":"AgendamentosAlocacoesAtivas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UnidadeSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"TipoSala"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nome"}},{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"compromisso"},"name":{"kind":"Name","value":"UsuarioCompromisso"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"UsuariosCompromissosTiposSalas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codTipoSala"}},{"kind":"Field","name":{"kind":"Name","value":"codUsuarioCompromisso"}},{"kind":"Field","name":{"kind":"Name","value":"prioridade"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"WaitingRoomAppointmentListItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WaitingRoomFilterButtonFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"query_root"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agendamentos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"whereBuild"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"horaInicio"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"codAgendamento"}}]}}]}}]} as unknown as DocumentNode<WaitingRoomPageQueryQuery, WaitingRoomPageQueryQueryVariables>;